/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 155);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var support = __webpack_require__(8);
var base64 = __webpack_require__(43);
var nodejsUtils = __webpack_require__(22);
var setImmediate = __webpack_require__(70);
var external = __webpack_require__(16);


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
      result = new Uint8Array(str.length);
    } else {
      result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {Array[String|ArrayBuffer]} parts the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(parts, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob(parts, {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            for (var i = 0; i < parts.length; i++) {
                builder.append(parts[i]);
            }
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static informations and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.newBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.newBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        // copy the uint8array: DO NOT propagate the original ArrayBuffer, it
        // can be way larger (the whole zip file for example).
        var copy = new Uint8Array(input.length);
        if (input.length) {
            copy.set(input, 0);
        }
        return copy.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {
        
        
        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("The data of '" + name + "' is in an unsupported format !")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var cls = __webpack_require__(23);
var defaultSettings = __webpack_require__(120);
var dom = __webpack_require__(11);
var EventManager = __webpack_require__(117);
var guid = __webpack_require__(118);

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = _.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = dom.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps-focus');
  }

  function blur() {
    cls.remove(element, 'ps-focus');
  }

  i.scrollbarXRail = dom.appendTo(dom.e('div', 'ps-scrollbar-x-rail'), element);
  i.scrollbarX = dom.appendTo(dom.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  dom.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = dom.appendTo(dom.e('div', 'ps-scrollbar-y-rail'), element);
  i.scrollbarY = dom.appendTo(dom.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
  dom.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Storage = __webpack_require__(64);

var gamefsBlob = {};

var gameDefaults = {
    // === configurable options ===
    mute: true,     // Mute all sounds
    preload: true,  // Preload all images while game is starting
    autosave_on_click: false,   // Autosave after each click
    log: false,     // Enable logging
    fading: false,  // Enable fade between scenes
    // === end of configurable options ===
    id: null,
    stead: 2,
    name: 'Default Game',
    details: {
        author: '',
        version: '',
        info: ''
    },
    gJournal: [], // game event log
    autosaveID: 9,
    importID: 10,
    saveSlots: 5,
    inventory_mode: 'vertical',
    scroll_mode: 'none',
    ways_mode: 'top',
    path: './game/',
    themePath: './themes/',
    ownTheme: false,
    clickSound: null,
    isAct: false, // 'act' mode flag
    actObj: null  // ref to act object
};

var Game = {
    mainLua: function mainLua() {
        var fullpath = this.path + (this.stead === 2 ? 'main.lua' : 'main3.lua');
        if (gamefsBlob.hasOwnProperty(fullpath)) {
            return gamefsBlob[fullpath];
        }
        return fullpath;
    },
    reset: function reset() {
        Object.keys(gameDefaults).forEach(function resetConfig(key) {
            Game[key] = gameDefaults[key];
        });
        gamefsBlob = {};
    },
    getSaveName: function getSaveName(i) {
        var id = i ? i : 0;
        return this.id + '-save-' + id;
    },
    getPrefsName: function getPrefsName() {
        return this.id + '-prefs';
    },
    saveExists: function saveExists(id) {
        if (typeof id === 'undefined') {
            return false;
        }
        return Storage.exists(this.getSaveName(id));
    },
    loadConfig: function loadConfig(cfg) {
        Object.keys(cfg).forEach(function applyConfig(key) {
            Game[key] = cfg[key];
        });
    },
    load: function load(slotId) {
        return Storage.load(Game.getSaveName(slotId));
    },
    save: function save(slotId, content) {
        var slot = this.getSaveName(slotId);
        Storage.save(slot, content);
    },
    importSave: function importSave(content) {
        this.save(this.importID, content);
    },
    allSaves: function allSaves() {
        return Storage.get(this.id);
    },
    addFile: function addFile(path, url) {
        gamefsBlob[path] = url;
    },
    fileURL: function fileURL(filename) {
        var fullpath = filename;
        Game.journal('[file: ' + filename + ']');
        // direct self-reference here, since fileURL is used as callback
        if (filename.indexOf(Game.path) === -1) {
            fullpath = Game.path + filename;
        }
        fullpath = fullpath.trim()
            .replace(/\\/g, '\/')
            .replace(/\/+/g, '\/'); // fix multiple slashes
        if (gamefsBlob.hasOwnProperty(fullpath)) {
            return gamefsBlob[fullpath];
        }
        return fullpath;
    },
    journal: function gameJournal(message) {
        Game.gJournal.push(message);
    }
};

Game.reset(); // run once to initialize

module.exports = Game;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        'data':[],
        'end':[],
        'error':[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on('data', function (chunk) {
            self.processChunk(chunk);
        });
        previous.on('end', function () {
            self.end();
        });
        previous.on('error', function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!this.extraStreamInfo.hasOwnProperty(key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(69)
var ieee754 = __webpack_require__(86)
var isArray = __webpack_require__(42)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cls = __webpack_require__(23);
var dom = __webpack_require__(11);

var toInt = exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

var clone = exports.clone = function (obj) {
  if (!obj) {
    return null;
  } else if (obj.constructor === Array) {
    return obj.map(clone);
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = clone(original);
  for (var key in source) {
    result[key] = clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return dom.matches(el, "input,[contenteditable]") ||
         dom.matches(el, "select,[contenteditable]") ||
         dom.matches(el, "textarea,[contenteditable]") ||
         dom.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return toInt(dom.css(element, 'width')) +
         toInt(dom.css(element, 'paddingLeft')) +
         toInt(dom.css(element, 'paddingRight')) +
         toInt(dom.css(element, 'borderLeftWidth')) +
         toInt(dom.css(element, 'borderRightWidth'));
};

exports.startScrolling = function (element, axis) {
  cls.add(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.add(element, 'ps-' + axis);
  } else {
    cls.add(element, 'ps-x');
    cls.add(element, 'ps-y');
  }
};

exports.stopScrolling = function (element, axis) {
  cls.remove(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.remove(element, 'ps-' + axis);
  } else {
    cls.remove(element, 'ps-x');
    cls.remove(element, 'ps-y');
  }
};

exports.env = {
  isWebKit: 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: window.navigator.msMaxTouchPoints !== null
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var cls = __webpack_require__(23);
var dom = __webpack_require__(11);
var instances = __webpack_require__(1);
var updateScroll = __webpack_require__(10);

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  dom.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  dom.css(i.scrollbarYRail, yRailOffset);

  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps-active-x');
  } else {
    cls.remove(element, 'ps-active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps-active-y');
  } else {
    cls.remove(element, 'ps-active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!__webpack_require__(46).Readable;
} catch(e) {
    exports.nodestream = false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);

var lastTop;
var lastLeft;

var createDOMEvent = function (name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return event;
};

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    // don't allow scroll past container
    value = i.contentHeight - i.containerHeight;
    if (value - element.scrollTop <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollTop;
    } else {
      element.scrollTop = value;
    }
    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    // don't allow scroll past container
    value = i.contentWidth - i.containerWidth;
    if (value - element.scrollLeft <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollLeft;
    } else {
      element.scrollLeft = value;
    }
    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
  }

  if (!lastTop) {
    lastTop = element.scrollTop;
  }

  if (!lastLeft) {
    lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
  }

  if (axis === 'top' && value > lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
  }

  if (axis === 'left' && value < lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
  }

  if (axis === 'left' && value > lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
  }

  if (axis === 'top') {
    element.scrollTop = lastTop = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
  }

  if (axis === 'left') {
    element.scrollLeft = lastLeft = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
  }

};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(32);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(15);
util.inherits = __webpack_require__(13);
/*</replacement>*/

var Readable = __webpack_require__(63);
var Writable = __webpack_require__(34);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var support = __webpack_require__(8);
var nodejsUtils = __webpack_require__(22);
var GenericWorker = __webpack_require__(3);

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global Promise */


// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = __webpack_require__(102);
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var Game = __webpack_require__(2);

var Logger = {
    log: function saveLog() {
        var message = Array.prototype.join.call(arguments, ', ');
        Game.journal(message);
    },
    show: function showLog() {
        var logContent = '';
        Game.gJournal.forEach(function handleMsg(item) {
            var message = item;
            var style = '';
            if (message.indexOf('>') === 0) {
                style = 'class="command"';
            }
            if (message.indexOf('[') === 0) {
                style = 'class="event"';
            }
            if (message.indexOf('{') === 0) {
                style = 'class="error"';
            }
            message = message.replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/:(title|ways|text|inv|picture):/g, '<span class="block">$1</span>');
            logContent += '<span ' + style + '>' + message + '<br/></span>';
        });
        var el = $('#instead--log');
        el.html(logContent);
        el.scrollTop(function h() { return this.scrollHeight; });
        return;
    }
};

module.exports = Logger;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBuffer : function(data, encoding){
        return new Buffer(data, encoding);
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(21).EventEmitter;
var inherits = __webpack_require__(13);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(135);
Stream.Writable = __webpack_require__(137);
Stream.Duplex = __webpack_require__(133);
Stream.Transform = __webpack_require__(136);
Stream.PassThrough = __webpack_require__(134);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var i18n = {
    dict: {
        loading: 'Loading...',
        preload: 'Preloading images',
        empty: 'empty',
        menu_back: 'Return to game',
        menu_save: 'Save',
        menu_load: 'Load',
        menu_reset: 'Reset',
        menu_mute: 'Mute',
        menu_unmute: 'Unmute',
        menu_savegame: 'Save game',
        menu_loadgame: 'Load game',
        menu_import: 'Import',
        menu_export: 'Export saved game',
        menu_export_log: 'Export game log',
        menu_autosave: 'Autosave',
        menu_cancel: 'Cancel',
        zip: 'Play game from ZIP file',
        zip_incorrect: 'This is not an INSTEAD game zip file, choose another.'
    },
    load: function init(d) {
        this.dict = d;
    },
    t: function translate(phrase) {
        if (phrase in this.dict) {
            return this.dict[phrase];
        }
        return phrase;
    }
};

module.exports = i18n;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);

var appHTML = __webpack_require__(132);

var Game = __webpack_require__(2);
var Theme = __webpack_require__(148);
var Logger = __webpack_require__(19);

var parseImg = __webpack_require__(150);
var Sprite = __webpack_require__(65);

function normalizeContent(input, field) {
    var output = input;
    if (!output) {
        // do not process empty outputs
        return '';
    }
    var delim = '#';
    if (Game.stead !== 2) {
        delim = '';
    }
    output = output.replace(
        /<x:([^>]+)>([^<$]+)/g,
        function parseTxttab(fullString, param, text) {
            var s = param.split(',');
            var margin = s[0] + 'px';
            if (margin.search('%') !== -1) {
                margin = s[0];
            }
            var align = s[1] || 'left';
            return '<div style="padding-left:' + margin + '; text-align: ' + align + '">' + text + '</div>';
        }
    ).replace(
        /<a:#>/g,
        '<a name="instead--scroll-anchor"> </a>'
    ).replace(
        /<a(:)([^>]+)>(<i>|)((&#160;)+)/g,
        '$4<a href="" data-ref="' + delim + '$2" data-type="' + field + '">$3'
    ).replace(
        /<a(:)([^>]+)/g,
        '<a href="" data-ref="' + delim + '$2", data-type="' + field + '"'
    ).replace(
        /<w:([^>]+)>/g,
        '<span class="nowrap">$1</span>'
    ).replace(
        /<y:([^>]+)>/g,
        function parseTxty(fullString, tab) {
            var margin = tab + 'px';
            if (tab.search('%') !== -1) {
                margin = tab;
            }
            return '<div style="margin-top: ' + margin + '" />';
        }
    ).replace(
        /<g:([^>]+)>/g,
        parseImg
    );

    return output;
}

function setContent(element, content, field) {
    element.html('<pre>' + normalizeContent(content, field) + '</pre>');
}

var currentUI = {
    title: null,
    ways: null,
    text: null,
    inventory: null,
    picture: null,
    winContent: null,
    updatedTextContent: true
};

function isUnchangedUI(type, content) {
    if (type === 'text') {
        if (content.indexOf(currentUI[type]) !== -1) {
            currentUI.updatedTextContent = true;
        } else {
            currentUI.updatedTextContent = false;
        }
    }
    if (currentUI[type] === content) {
        return true;
    }
    currentUI[type] = content;
    return false;
}

function isUnchangedWin() {
    var winContent = currentUI.title + currentUI.ways + currentUI.text + currentUI.picture;
    if (currentUI.winContent === winContent) {
        return true;
    }
    currentUI.winContent = winContent;
    return false;
}

var UI = {
    init: function init(rootElement, steadHandler) {
        var self = this;
        $(rootElement).html(appHTML);
        // initialize JQuery selectors
        this.element = {
            $container: $('#stead-container'),
            $title: $('#title'),
            $ways: $('#ways-top'),
            $text: $('#instead--text'),
            $picture: $('#picture'),
            $win: $('#win'),
            $stead: $('#stead'),
            $inventory: $('#inventory'),
            $menuButton: $('#menu_button'),
            $menuImage: $('#menu_image'),
            $menu: $('#instead--menu'),
            $menu_saveload: $('#instead--menu-saveload'),
            $menu_content: $('#instead--menu-content'),
            $toolbar_mute: $('#toolbar-mute'),
            $toolbar_log: $('#toolbar-log'),
            $toolbar_menu: $('#toolbar-menu'),
            $menu_mute: $('#instead--menu-mute'),
            $gameDetails: $('#instead--game-details')
        };

        this.element.$stead.on('click', 'a', function handler(e) {
            var obj = $(this);
            self.clickHandlerLink(steadHandler.click, e, obj);
        });
        this.element.$picture.on('click', function handler(e) {
            var obj = $(this);
            self.clickHandler(steadHandler.click, e, obj);
        });
        this.element.$stead.on('click', function handler(e) {
            self.clickHandler(steadHandler.click, e);
        });

        this.element.$win.perfectScrollbar({wheelSpeed: 1});
        this.element.$inventory.perfectScrollbar({wheelSpeed: 1});
    },

    show: function show() {
        this.element.$stead.show();
    },

    hide: function hide() {
        this.element.$stead.hide();
    },

    loadTheme: function loadTheme() {
        Theme.load(this.element, Game.themePath);
        if (Game.ways_mode === 'bottom') {
            this.element.$ways = $('#ways-bottom');
        }
    },

    setAct: function setAct(act, obj) {
        Game.isAct = act;
        Game.actObj = obj;
        Theme.setCursor(Game.isAct);
    },

    setTitle: function setTitle(content) {
        if (isUnchangedUI('title', content)) {
            return;
        }
        Logger.log(':title: ' + content);
        var title = (!content || content === true) ? '' : content;
        setContent(
            this.element.$title,
            '<a href="" data-ref="#look" data-type="Title">' + title + '</a>',
            'Title'
        );
    },

    setWays: function setWays(content) {
        if (isUnchangedUI('ways', content)) {
            return;
        }
        Logger.log(':ways: ' + content);
        setContent(this.element.$ways, content, 'Ways');
    },

    setText: function setText(content) {
        if (isUnchangedUI('text', content)) {
            return;
        }
        Logger.log(':text: ' + content);
        setContent(this.element.$text, content, 'Text');
    },

    setInventory: function setInventory(content) {
        if (isUnchangedUI('inventory', content)) {
            return;
        }
        Logger.log(':inv: ' + content);
        setContent(this.element.$inventory, content, 'Inv');
        this.element.$inventory.perfectScrollbar('update');
    },

    setPicture: function setPicture(content) {
        if (isUnchangedUI('picture', content)) {
            return;
        }
        Logger.log(':picture: ' + content);
        if (content === null) {
            this.element.$picture.html('');
        } else if (Sprite.is(content)) {
            this.element.$picture.html('');
            Sprite.initCanvas(this.element.$picture, content);
        } else {
            this.element.$picture.html(parseImg(null, content));
        }
    },

    refresh: function refresh() {
        if (isUnchangedWin()) {
            return;
        }
        var scrollTarget = 0;
        if (Game.scroll_mode === 'bottom' ||
           (Game.scroll_mode === 'change' && currentUI.updatedTextContent)
           ) {
            scrollTarget = function h() { return this.scrollHeight; };
        }

        this.element.$win.scrollTop(scrollTarget);
        this.element.$win.perfectScrollbar('update');
    },

    fadeOut: function fadeOut(callback) {
        this.element.$stead.fadeOut('fast', callback);
    },

    fadeIn: function fadeIn() {
        this.element.$stead.fadeIn('fast');
    },

    clickHandlerLink: function clickHandlerLink(clickCallback, e, obj) {
        e.preventDefault();
        e.stopPropagation();
        var ref = obj.attr('data-ref');
        var type = obj.attr('data-type');
        Logger.log('[click] ' + obj.attr('data-ref') + ':' + obj.attr('data-type') + ' "' + obj.text() + '"');
        clickCallback(ref, type);
    },

    clickHandler: function clickHandler(clickCallback, e, obj) {
        e.preventDefault();
        if (Game.isAct) {
            Logger.log('[click] reset onAct');
            clickCallback(null, null, true);
        }
        if (obj) {
            clickCallback({x: e.offsetX, y: e.offsetY}); // clicked on picture
        }
    }
};

module.exports = UI;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(41)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var external = __webpack_require__(16);
var DataWorker = __webpack_require__(54);
var DataLengthProbe = __webpack_require__(53);
var Crc32Probe = __webpack_require__(52);
var DataLengthProbe = __webpack_require__(53);

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker : function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
        .pipe(this.compression.uncompressWorker())
        .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker : function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
        .withStreamInfo("compressedSize", this.compressedSize)
        .withStreamInfo("uncompressedSize", this.uncompressedSize)
        .withStreamInfo("crc32", this.crc32)
        .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compresion.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
    .pipe(new Crc32Probe())
    .pipe(new DataLengthProbe("uncompressedSize"))
    .pipe(compression.compressWorker(compressionOptions))
    .pipe(new DataLengthProbe("compressedSize"))
    .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};
// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(12);

/*<replacement>*/
var util = __webpack_require__(15);
util.inherits = __webpack_require__(13);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(32);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(5).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(15);
util.inherits = __webpack_require__(13);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(143)
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(24);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(21).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(5).Buffer;

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

var Duplex;
function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(12);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // create the two objects needed to store the corked requests
  // they are not a linked list, as no new elements are inserted in there
  this.corkedRequestsFree = new CorkedRequest(this);
  this.corkedRequestsFree.next = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

var Duplex;
function Writable(options) {
  Duplex = Duplex || __webpack_require__(12);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;

  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    state.corkedRequestsFree = holder.next;
    holder.next = null;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(142).setImmediate))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var interpreter = __webpack_require__(37);
var UI = __webpack_require__(26);
var Game = __webpack_require__(2);
var HTMLAudio = __webpack_require__(145);
var Keyboard = __webpack_require__(149);

var Logger = __webpack_require__(19);

var Instead = {
    init: function init() {
        this.handlers = {
            click: this.click.bind(this),
            reset: this.resetGame.bind(this),
            save: this.saveGame.bind(this),
            load: this.loadGame.bind(this),
            mute: this.soundMute.bind(this)
        };
        document.body.addEventListener('keydown', kbdEvent);
        document.body.addEventListener('keyup', kbdEvent);

        // preloader
        interpreter.init();
        // interpreter.load('instead_js.lua');
    },

    initGame: function initGame(gameData) {
        // Allowed properties: path, id, name, details, ownTheme, stead
        for (var property in gameData) {
            if (gameData.hasOwnProperty(property)) {
                Game[property] = gameData[property];
            }
        }
    },

    startGame: function startGame(savedGameID) {
        // load corresponding STEAD lua files
        interpreter.loadStead(Game.stead);
        // initialize INSTEAD
        interpreter.load('instead_init.lua');
        setTimer(0);            // reset game timers
        UI.loadTheme();         // load theme
        this.clickSound(true);  // preload click sound

        // init game
        interpreter.call('js_instead_gamepath("' + Game.path + '")');
        interpreter.load(Game.mainLua());
        interpreter.call('game:ini()');
        // load game, if required
        if (Game.saveExists(savedGameID)) {
            this.ifaceCmd('load ' + Game.getSaveName(savedGameID), true, true);
        } else {
            // start game
            this.ifaceCmd('look', true, true);
        }
    },

    resetGame: function resetGame() {
        var self = this;
        HTMLAudio.stopMusic();
        interpreter.clear();
        setTimeout(function t() {
            self.startGame();
        }, 100);
    },

    saveGame: function saveGame(id) {
        this.ifaceCmd('save ' + Game.getSaveName(id));
    },

    loadGame: function loadGame(id) {
        var self = this;
        if (Game.saveExists(id)) {
            HTMLAudio.stopMusic();
            interpreter.clear();
            setTimeout(function t() {
                self.startGame(id);
            }, 100);
        }
    },

    click: function click(uiref, field, onStead) {
        var ref = uiref;
        var refID;

        if (uiref !== null && typeof ref === 'object') {
            var text = interpreter.call('instead_click(' + ref.x + ', ' + ref.y + ')');
            if (text !== null) {
                this.clickSound();
                this.refreshInterface(text);
            }
            return;
        }

        if (!onStead && (Game.isAct || field === 'Inv')) {
            refID = ref.match(/([\d]+)/)[0];
            if (ref.search('act') === 0 || ref.search('act') === 1 ) {
                this.clickSound();
                this.ifaceCmd('use ' + refID, true);
                this.autoSave();
                return;
            }
            if (Game.isAct) {
                if (field !== 'Ways' && field !== 'Title') {
                    this.clickSound();
                    if (refID === Game.actObj) {
                        this.ifaceCmd('use ' + refID, true);
                    } else {
                        this.ifaceCmd('use ' + Game.actObj + ',' + refID, true);
                    }
                    UI.setAct(false, '');
                    this.autoSave();
                }
            } else {
                UI.setAct(true, refID);
            }
        } else {
            if (Game.isAct) {
                UI.setAct(false, '');
            }
            if (ref) {
                this.clickSound();
                this.ifaceCmd(ref, true);
                this.autoSave();
            }
        }
    },

    kbd: function keyboardHandler(ev) {
        if (ev) {
            var kbdHandler = interpreter.call('iface:input("kbd", ' + ev.down +  ', "' + ev.key + '")');
            if (kbdHandler && kbdHandler !== 'nil') {
                this.ifaceCmd(kbdHandler, true);
            }
            if (ev.text) {
                var textHandler = interpreter.call('iface:input("text", "' + ev.text + '")');
                if (textHandler && textHandler !== 'nil') {
                    this.ifaceCmd(textHandler, true);
                }
            }
        }
    },

    // do not use fade effect, if the game just started
    refreshInterface: function refreshInterface(text, isStart) {
        var isFading = interpreter.call('instead.get_fading()');
        if (isFading && Game.fading && !isStart) {
            UI.fadeOut(function fadeCallback() {
                Instead.updateUI(text);
                UI.fadeIn();
            });
        } else {
            this.updateUI(text);
        }
        // check if restart required
        var isRestart = interpreter.call('instead.get_restart()');
        if (isRestart) {
            this.resetGame();
        }
    },

    updateUI: function updateUI(text) {
        var inventory;
        var horizontalInventory;
        var musicPath;
        var soundPath;
        // sound
        soundPath = interpreter.call('instead.get_sound()');
        if (soundPath !== null) {
            soundPath.split(';').forEach(function parseSound(item) {
                var soundFile = (item.split('@'))[0];
                if (soundFile !== '') {
                    HTMLAudio.playSound(Game.fileURL(soundFile));
                }
            });
        }
        // music
        musicPath = interpreter.call('instead.get_music()');
        if (musicPath === null) {
            HTMLAudio.stopMusic();
        } else {
            HTMLAudio.playMusic(Game.fileURL(musicPath), 0, function cbOnEnd() {
                // call when music is finished
                interpreter.call('instead.finish_music()');
            });
        }
        // title
        UI.setTitle(interpreter.call('instead.get_title()'));
        // ways
        UI.setWays(interpreter.call('instead.get_ways()'));
        // inventory
        horizontalInventory = (Game.inventory_mode === 'horizontal');
        inventory = interpreter.call('instead.get_inv(' + horizontalInventory + ')');
        if (inventory === null) {
            UI.setInventory('');
        } else {
            UI.setInventory(inventory);
        }
        // picture
        UI.setPicture(interpreter.call('instead.get_picture()'));
        // text
        if (text) {
            UI.setText(text);
        }
        // refresh
        UI.refresh();
    },

    ifaceCmd: function ifaceCmd(ifacecmd, refreshUI, isStart) {
        var ifaceOutput = null;
        // remove part of command before slash
        var command = ifacecmd;
        if (command[0] !== '#') {
            command = ifacecmd.replace(/^([^\/]+\/)/, '');
        }
        var cmd = 'iface:cmd("' + command + '")';
        var text = interpreter.call(cmd);
        if (command !== 'user_timer') {
            Logger.log('> ' + command);
        }
        if (text !== null && command.indexOf('save') !== 0) {
            ifaceOutput = text;
        }
        if (refreshUI) {
            this.refreshInterface(ifaceOutput, isStart);
        }
    },

    timerCmd: function timerCmd() {
        var timerHandler = interpreter.call('stead.timer()');
        if (timerHandler && timerHandler !== 'nil') {
            Instead.ifaceCmd(timerHandler, true); // use direct reference, since context is lost
        }
    },

    soundMute: function soundMute(value) {
        Game.mute = value;
        HTMLAudio.mute(value);
    },

    autoSave: function autoSave(force) {
        if (Game.autosave_on_click || force) {
            interpreter.call('instead.autosave(' + Game.autosaveID + ')'); // enable autosave
            this.saveGame(Game.autosaveID); // autosave
        }
    },

    clickSound: function clickSound(isCache) {
        if (Game.clickSound) {
            HTMLAudio.playSound(Game.clickSound, null, isCache);
        }
    }
};

function kbdEvent(event) {
    if (!Game.id) {
        // do not handle keyboard events
        // if game is not loaded yet
        return;
    }
    Instead.kbd(Keyboard.handler(event));
}


var LuaTimer; // eslint-disable-line no-unused-vars

function setTimer(t) {
    window.clearInterval(LuaTimer); // clear previous timer
    var time = parseInt(t, 10);
    if (time > 0) {
        LuaTimer = window.setInterval(
            Instead.timerCmd,
            time
        );
    }
}

window.instead_settimer = setTimer;

window.onbeforeunload = function autoSaveOnClose() {
    if (Game.id) {
        Instead.autoSave(true); // force autosave
    }
};

document.onblur = function onBlur() {
    // reset Alt modifier
    Instead.kbd({key: 'alt', down: 'false'});
};

module.exports = Instead;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// virtual file system
var stead = __webpack_require__(68);
var ajaxGetSync = __webpack_require__(144);

var vfsData = {};

var vfs = {
    readfile: function readfile(path) {
        if (stead.hasOwnProperty(path)) {
            return stead[path];
        }
        if (vfsData.hasOwnProperty(path)) {
            return vfsData[path];
        }
        if (path.indexOf('blob') === 0) {
            // normal query when load from ZIP file
            return ajaxGetSync(path);
        }
        var avoidCache = Math.random().toString(36).substring(7);
        return ajaxGetSync(path + '?' + avoidCache);  // avoid cached response
    },
    save: function save(path, content) {
        vfsData[path] = content;
    },
    isStead: function isStead(path) {
        // module is a part of INSTEAD core engine
        return stead.hasOwnProperty(path);
    },
    updateStead: function updateStead(steadJson) {
        Object.keys(steadJson).forEach(function upd(filename) {
            stead[filename] = steadJson[filename];
        });
    },
    dump: function dump() {
        return JSON.stringify(vfsData);
    },
    exportFile: function exportFile(filename, content) {
        var data = new Blob([content], {type: 'octet/stream'});
        var dataUrl = window.URL.createObjectURL(data);
        var ref = document.createElement('a');
        document.body.appendChild(ref);
        ref.style = 'display: none';
        ref.href = dataUrl;
        ref.download = filename;
        ref.click();
        window.URL.revokeObjectURL(dataUrl);
        ref.remove();
    }
};

module.exports = vfs;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* global Lua */
__webpack_require__(140);
var Game = __webpack_require__(2);
var vfs = __webpack_require__(36);
var Storage = __webpack_require__(64);
var Logger = __webpack_require__(19);

// synchronous ajax to get file, so code executed before function returns
function runLuaFromPath(path) {
    try {
        var luacode = vfs.readfile(path);
        // check if download worked
        if ((typeof luacode) !== 'string') {
            throw String('RunLuaFromPath failed "' + path + '" :' +
                         ' type=' + (typeof luacode) +
                         ' val=' + String(luacode));
        }

        Lua.cache.items = {}; // Clear cache;
        return Lua.exec(luacode, path);
    } catch (e) {
        console.error('Error: file ' + path + ' : ' + String(e) + ' :\n', e); // eslint-disable-line no-console
    }
    return null;
}

function requireContent(filepath) {
    var path = filepath;
    // path transformations
    if (path.substr(-4) === '.lua') {
        path = path.slice(0, -4); // require automatically appends .lua to the filepath later, remove it here
    }
    path = path.replace(/\./g, '/');
    if (!vfs.isStead(path + '.lua')) {
        // require unknown core module, assume loading from game files
        path = Game.fileURL(path + '.lua');
    } else {
        path = path + '.lua';
    }
    return vfs.readfile(path);
}

function luaDofile(filepath) {
    return runLuaFromPath(Game.fileURL(filepath));
}


function saveFile(path) {
    var filepath = path;
    if (path.search(/prefs\.tmp/) !== -1) {
        filepath = Game.getPrefsName();
    }
    var data = Lua.eval('instead_file_get_content("' + path + '")');
    Storage.save(filepath, data[1]);
}

function loadFile(path) {
    var filepath = path;
    if (path.search(/prefs/) !== -1) {
        filepath = Game.getPrefsName();
    }
    return Storage.load(filepath);
}

function openFile(path) {
    var filepath = Game.fileURL(path);
    return vfs.readfile(filepath);
}

function gameInfo() {
    return {
        id: Game.id,
        name: Game.name,
        stead: Game.stead
    };
}

var Interpreter = {
    init: function interpreterInit() {
        Lua.initialize();
        Lua.requires = {};
        Lua.inject(luaDofile, 'dofile');
        Lua.requireContent = requireContent
        Lua.saveFile = saveFile;
        Lua.loadFile = loadFile;
        Lua.openFile = openFile;
        Lua.gameinfo = gameInfo; // to be used by external handlers
        Lua.logWarning = function logWarning(msg) {
            Logger.log('{warning} ' + msg);
        };
        Lua.set_error_callback(function errCb(errorMsg) {
            Logger.log('{error} ' + errorMsg);
        });
    },
    loadStead: function loadStead(version) {
        var path = (version === 3) ? './stead3.json' : './stead2.json';
        var stead = JSON.parse(vfs.readfile(path));
        vfs.updateStead(stead);
    },
    call: function interpreterCall(command) {
        var result = Lua.eval(command);
        if (result) {
            return result[0];
        }
        return null;
    },
    load: function interpreterLoad(path) {
        return runLuaFromPath(path);
    },
    clear: function interpreterClear() {
        Lua.destroy();
        this.init();
    }
};

module.exports = Interpreter;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(71);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28)
  , document = __webpack_require__(20).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(0);
var support = __webpack_require__(8);
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(3);

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = __webpack_require__(88);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = __webpack_require__(24);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(48);
var utils = __webpack_require__(0);

function ArrayReader(data) {
    DataReader.call(this, data);
	for(var i = 0; i < this.data.length; i++) {
		data[i] = data[i] & 0xFF;
	}
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(0);

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayReader = __webpack_require__(47);
var utils = __webpack_require__(0);

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var support = __webpack_require__(8);
var ArrayReader = __webpack_require__(47);
var StringReader = __webpack_require__(97);
var NodeBufferReader = __webpack_require__(96);
var Uint8ArrayReader = __webpack_require__(49);

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(3);
var crc32 = __webpack_require__(30);
var utils = __webpack_require__(0);

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;



/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
            case "string":
                data = this.data.substring(this.index, nextIndex);
            break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
            break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(0);
var ConvertWorker = __webpack_require__(98);
var GenericWorker = __webpack_require__(3);
var base64 = __webpack_require__(43);
var support = __webpack_require__(8);
var external = __webpack_require__(16);

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = __webpack_require__(94);
    } catch(e) {}
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} resultType the name of the final type
 * @param {String} chunkType the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(resultType, chunkType, dataArray, mimeType) {
    var content = null;
    switch(resultType) {
        case "blob" :
            return utils.newBlob(dataArray, mimeType);
        case "base64" :
            content = concat(chunkType, dataArray);
            return base64.encode(content);
        default :
            content = concat(chunkType, dataArray);
            return utils.transformTo(resultType, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
        case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++) {
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
        .on('data', function (data, meta) {
            dataArray.push(data);
            if(updateCallback) {
                updateCallback(meta);
            }
        })
        .on('error', function(err) {
            dataArray = [];
            reject(err);
        })
        .on('end', function (){
            try {
                var result = transformZipOutput(resultType, chunkType, dataArray, mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        })
        .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
        case "blob":
            internalType = "arraybuffer";
        break;
        case "arraybuffer":
            internalType = "uint8array";
        break;
        case "base64":
            internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(138).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// String encode/decode helpers



var utils = __webpack_require__(9);


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(33);

/*<replacement>*/
var util = __webpack_require__(15);
util.inherits = __webpack_require__(13);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(32);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(42);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(5).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = __webpack_require__(21);

/*<replacement>*/
var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(24);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(21).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(5).Buffer;

/*<replacement>*/
var util = __webpack_require__(15);
util.inherits = __webpack_require__(13);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(154);
var debug = undefined;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

var Duplex;
function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(12);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(56).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

var Duplex;
function Readable(options) {
  Duplex = Duplex || __webpack_require__(12);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(56).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended) return 0;

  if (state.objectMode) return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
  }

  if (n <= 0) return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else {
      return state.length;
    }
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended) state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && !this._readableState.endEmitted) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0) return null;

  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode) ret = '';else ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 64 */
/***/ (function(module, exports) {

var mfs = window.localStorage;

var Storage = {
    get: function getSaves(key) {
        var n = mfs.length;
        var saves = [];
        var k;
        var item;
        for (var i = 0; i < n; i++) {
            k = mfs.key(i);
            try {
                item = JSON.parse(mfs.getItem(k));
            } catch (e) {
                item = {timestamp: null};
            }
            item.id = k;
            if (key) {
                if (k.indexOf(key + '-save-') === 0) {
                    saves.push(item);
                }
            } else {
                saves.push(item);
            }
        }
        return saves;
    },
    save: function save(name, value) {
        mfs.setItem(name, JSON.stringify({
            timestamp: Date.now(),
            data: value
        }));
    },
    load: function load(name) {
        var content = JSON.parse(mfs.getItem(name));
        if (content) {
            return content.data;
        }
        return '';
    },
    exists: function exists(name) {
        if (!name) {
            return false;
        }
        return !!mfs.getItem(name);
    },
    clear: function clear() {
        mfs.clear();
    }
};

module.exports = Storage;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var interpreter = __webpack_require__(37);
var Game = __webpack_require__(2);
var Theme = __webpack_require__(66);

var sprites = {};
var spriteCounter = 0;
var spriteUniqueID = 0;
var fonts = {};
var fontNames = {};
var fontCounter = 0;
var nextCopy = {
    clear: false,
    x: null,
    y: null,
    width: null,
    height: null
};

function getFontSize(font, text) {
    var o = $('<div>' + text + '</div>')
            .css({
                position: 'absolute', float: 'left', 'white-space': 'nowrap',
                visibility: 'hidden', font: font
            })
            .appendTo($('body'));
    var w = o.width();
    var h = o.height();
    o.remove();
    return {width: w, height: h};
}


function luaToNumber(val) {
    if (typeof val === 'undefined' || val === 'nil') {
        return 0;
    }
    return +val;
}

function makeBlankCanvas(sprite) {
    var parsed = sprite.name.match(/(box|blank):(.+)/);
    sprite.replaceCopy = true;
    var d = parsed[2].split(',');
    var imgSize = d[0].match(/(\d+)x(\d+)/);

    var ctx = sprite.ctx;
    sprite.canvas.width = imgSize[1];
    sprite.canvas.height = imgSize[2];
    if (d[2]) {
        ctx.globalAlpha = d[2];
    }
    if (d[1]) {
        ctx.fillStyle = d[1];
        ctx.fillRect(0, 0, imgSize[1], imgSize[2]);
    }
    if (d[2]) {
        ctx.globalAlpha = 1;
    }
}

function copySprite(srcID, fx, fy, fw, fh, dstID, x, y, alpha, mode) {
    var srcSprite = sprites[srcID];
    var dstSprite = sprites[dstID];
    srcSprite.waitOp = true;
    dstSprite.waitOp = true;
    if (srcSprite.unavailable || dstSprite.unavailable) {
        setTimeout(function deferredCopy() {
            copySprite(srcID, fx, fy, fw, fh, dstID, x, y, alpha, mode);
        }, 100);
        return;
    }
    var width = luaToNumber(fw);
    var height = luaToNumber(fh);
    var srcX = luaToNumber(fx);
    var srcY = luaToNumber(fy);
    var trgX = luaToNumber(x);
    var trgY = luaToNumber(y);

    if (width < 0) {
        width = srcSprite.canvas.width;
    }
    if (height < 0) {
        height = srcSprite.canvas.height;
    }
    var ctx = dstSprite.ctx;
    if (mode === 'copy' && srcSprite.replaceCopy) {
        // cut out target canvas area on next copy operation
        nextCopy = {
            clear: true,
            x: trgX,
            y: trgY,
            width: width,
            height: height,
            dstID: dstID
        };
    } else {
        if (nextCopy.clear && nextCopy.dstID === dstID) {
            nextCopy.clear = false;
            ctx.clearRect(nextCopy.x, nextCopy.y, nextCopy.width, nextCopy.height);
        }
        if (alpha && alpha !== 'nil') {
            ctx.globalAlpha = +alpha;
        }
        ctx.drawImage(srcSprite.canvas, srcX, srcY, width, height,
                      trgX, trgY, width, height);
        if (alpha && alpha !== 'nil') {
            ctx.globalAlpha = 1;
        }
    }
    srcSprite.waitOp = false;
    dstSprite.waitOp = false;
}


var Sprite = {
    id: function id(n) {
        return '_INSTEAD_sprite' + n;
    },
    is: function is(name) {
        return name.indexOf('_INSTEAD_sprite') === 0;
    },
    initCanvas: function initCanvas(parentElement, spriteID) {
        parentElement.append(sprites[spriteID].canvas);
    },
    asImage: function spriteAsImage(spriteID) {
        spriteUniqueID++;
        var sprite = spriteID + '__' + spriteUniqueID;
        setTimeout(function populateSprite() {
            var sp = sprites[spriteID].canvas;
            var sc = document.getElementById(sprite);
            sc.width = sp.width;
            sc.height = sp.height;
            var ctx = sc.getContext('2d');
            ctx.drawImage(sp, 0, 0, sp.width, sp.height, 0, 0, sp.width, sp.height);
        }, 50);
        return '<canvas id="' + sprite + '"></canvas>';
    },
    load: function spriteLoad(fileName) {
        spriteCounter++;
        var spriteID = this.id(spriteCounter);
        var sprite = {
            id: spriteID,
            name: fileName,
            canvas: document.createElement('canvas'),
            unavailable: true,
            waitOp: true
        };
        sprite.ctx = sprite.canvas.getContext('2d');

        sprites[spriteID] = sprite;
        interpreter.call('js_instead_sprite_load("' + fileName + '", "' + spriteID + '")');

        if (sprite.name.indexOf('box') === 0 || sprite.name.indexOf('blank') === 0) {
            makeBlankCanvas(sprite);
            sprite.unavailable = false;
        } else {
            var img = new Image();
            img.addEventListener('load', function loadImage() {
                sprite.canvas.width = img.width;
                sprite.canvas.height = img.height;
                sprite.canvas.getContext('2d').drawImage(img, 0, 0);
                sprite.unavailable = false;
            }, false);
            img.src = Game.fileURL(sprite.name);
        }
    },
    copy: function spriteCopy() {
        var args = Array.prototype.slice.call(arguments);
        args[9] = 'copy';
        return copySprite.apply(this, args);
    },
    compose: function spriteCompose() {
        var args = Array.prototype.slice.call(arguments);
        args[9] = 'compose';
        return copySprite.apply(this, args);
    },
    draw: function spriteDraw() {
        var args = Array.prototype.slice.call(arguments);
        args[9] = 'draw';
        return copySprite.apply(this, args);
    },
    free: function spriteFree(spriteID) {
        if (typeof sprites[spriteID] === 'object' && sprites[spriteID].waitOp) {
            setTimeout(function deferredFree() {
                Sprite.free(spriteID);
            }, 511);
            return;
        }
        setTimeout(function delayedFree() {
            delete sprites[spriteID];
        }, 300);
    },
    pixel: function spritePixel(spriteID, x, y, color, alpha) {
        sprites[spriteID].waitOp = true;
        var ctx = sprites[spriteID].ctx;
        if (alpha && alpha !== 'nil') {
            ctx.globalAlpha = alpha;
        }
        ctx.fillStyle = color;
        ctx.fillRect(x, y, 1, 1);
        if (alpha && alpha !== 'nil') {
            ctx.globalAlpha = 1;
        }
        sprites[spriteID].waitOp = false;
    },
    fill: function spriteFill(spriteID, x, y, width, height, color) {
        var sprite = sprites[spriteID];
        sprite.waitOp = true;
        var w = width;
        var h = height;
        if (width < 0) {
            w = sprite.canvas.width;
        }
        if (height < 0) {
            h = sprite.canvas.height;
        }
        sprite.ctx.fillStyle = color;
        sprite.ctx.fillRect(x, y, w, h);
        sprite.waitOp = false;
    },
    font: function spriteFont(fileName, size) {
        fontCounter++;
        var fontID = 'sprite_font_' + fontCounter;
        var font = {
            id: fontID,
            name: fileName,
            size: +size
        };

        fonts[fontID] = font;
        if (!fontNames.hasOwnProperty(fileName)) {
            Theme.applyParamStyle('SPRITE.FNT', fontID, fileName, Game.fileURL);
        }
        fontNames[fileName] = true;
        interpreter.call('js_instead_font_load("' + fileName + size + '", "' + fontID + '")');
    },
    text: function spriteText(fontID, text, color) {
        spriteCounter++;
        var spriteID = this.id(spriteCounter);
        interpreter.call('js_instead_sprite_text("' + fontID + '", "' + spriteID + '")');

        var sprite = {
            id: spriteID,
            canvas: document.createElement('canvas'),
            unavailable: true,
            waitOp: true
        };
        sprite.ctx = sprite.canvas.getContext('2d');
        sprites[spriteID] = sprite;

        var fontName = fonts[fontID].size + 'px ' + fontID;
        var fontSize = getFontSize(fontName, text);
        sprite.canvas.width = fontSize.width;
        sprite.canvas.height = fontSize.height;
        sprite.ctx.font = fontName;
        sprite.ctx.textBaseline = 'top';
        if (color && color !== 'nil') {
            sprite.ctx.fillStyle = color;
        } else {
            sprite.ctx.fillStyle = '#FFFFFF'; // white font by default
        }
        sprite.ctx.fillText(text, 0, 0);
        sprite.unavailable = false;
    }
};

window.Sprite = Sprite;
module.exports = Sprite;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var Game = __webpack_require__(2);

var dynamicStyles = {};
var scrollerWidth = 15;

var updateCSS = true;

function setCSS() {
    if (!updateCSS) {
        return;
    }
    var css = '';
    for (var property in dynamicStyles) {
        if (dynamicStyles.hasOwnProperty(property)) {
            css = css + dynamicStyles[property];
        }
    }
    $('#theme_css').text(css);
}

function setFontCSS(selector, fontName, v, getURL) {
    var fntCSS = '';

    function setFont(name, file, type) {
        var fnt = '@font-face{font-family:"' + name + '";src:url("' + file + '") format("truetype");';
        switch (type) {
        case 'b':
            fnt += 'font-weight:bold;';
            break;
        case 'i':
            fnt += 'font-style:italic;';
            break;
        case 'bi':
            fnt += 'font-weight:bold;font-style:italic;';
            break;
        default:
            // unknown style/weight, do nothing
        }
        fnt += '}';
        return fnt;
    }

    var fonts = v.match(/(.*?){(.*?)(?:,(.*?)(?:,(.*?)(?:,(.*?))?)?)?}(\.\w+)/);
    if (fonts) {
        if (fonts[2]) {
            fntCSS += setFont(fontName, getURL(fonts[1] + fonts[2] + fonts[6]));
        }
        if (fonts[3]) {
            fntCSS += setFont(fontName, getURL(fonts[1] + fonts[3] + fonts[6]), 'b');
        }
        if (fonts[4]) {
            fntCSS += setFont(fontName, getURL(fonts[1] + fonts[4] + fonts[6]), 'i');
        }
        if (fonts[5]) {
            fntCSS += setFont(fontName, getURL(fonts[1] + fonts[5] + fonts[6]), 'bi');
        }
    }
    fonts = v.match(/(.*?){([\d\w]+)}(\.\w+)/);
    if (fntCSS === '' && fonts && fonts[2]) {
        fntCSS += setFont(fontName, getURL(fonts[1] + fonts[2] + fonts[3]));
    }
    if (fntCSS === '' && v) {
        fntCSS += setFont(fontName, getURL(v)); // one font for all types
    }
    if (selector) {
        fntCSS += selector + ' * {font-family:' + fontName + ',Arial,Helvetica,sans-serif;}';
    }
    return fntCSS;
}

var applyStyle = {
    'scr.gfx.bg': function s(e, v, getURL) {
        e.$stead.css('backgroundImage', 'url("' + getURL(v) + '")');
    },
    'scr.col.bg': function s(e, v) {
        e.$stead.css('background-color', v);
    },
    'scr.w': function s(e, v) {
        e.$stead.css('width', v + 'px');
        e.$container.css('width', v + 'px'); // change width of the INSTEAD container with toolbar
    },
    'scr.h': function s(e, v) { e.$stead.css('height', v + 'px'); },

    'scr.gfx.w': function s(e, v) {
        if (v > 0) {
            dynamicStyles['scr.gfx.w'] = '#picture img {max-width:' + v + 'px}\n#picture {width:' + v + 'px}';
            setCSS();
        }
    },
    'scr.gfx.h': function s(e, v) {
        if (v > 0) {
            dynamicStyles['scr.gfx.h'] = '#picture img {max-height:' + v + 'px}\n#picture {height:' + v + 'px}';
            setCSS();
        }
    },
    'scr.gfx.x': function s(e, v) { e.$picture.css('left', v + 'px'); },
    'scr.gfx.y': function s(e, v) { e.$picture.css('top', v + 'px'); },
    'scr.gfx.mode': function s(e, v) {
        if (v.search('float') !== -1) {
            e.$picture.appendTo('#stead').css('position', 'absolute');
        }
    },

    'win.gfx.w': function s() { this['scr.gfx.w'](arguments); },
    'win.gfx.h': function s() { this['scr.gfx.h'](arguments); },
    'win.gfx.x': function s() { this['scr.gfx.x'](arguments); },
    'win.gfx.y': function s() { this['scr.gfx.w'](arguments); },

    'win.w': function s(e, v) {
        e.$win.css('width', v + 'px');
        e.$win.css('padding-right', scrollerWidth + 'px');
    },
    'win.h': function s(e, v) { e.$win.css('height', v + 'px'); },
    'win.x': function s(e, v) { e.$win.css('left', v + 'px'); },
    'win.y': function s(e, v) { e.$win.css('top', v + 'px'); },
    'win.col.fg': function s(e, v) { e.$win.css('color', v); },
    'win.align': function s(e, v) { e.$win.css('text-align', v); },
    'win.scroll.mode': function s(e, v) {
        if (+v === 3) {
            Game.scroll_mode = 'bottom';
        } else if (+v > 0) {
            Game.scroll_mode = 'change';
        } else {
            Game.scroll_mode = 'top';
        }
    },
    'win.ways.mode': function s(e, v) {
        Game.ways_mode = v;
    },
    'win.fnt.name': function s(e, v, getURL) {
        dynamicStyles['win.fnt.name'] = setFontCSS('#win', 'insteadWin', v, getURL);
        setCSS();
    },
    'win.fnt.size': function s(e, v) {
        e.$win.css('font-size', v + 'px');
    },
    'win.fnt.height': function s(e, v) {
        // default line height for browsers: 1.2
        e.$win.css('line-height', +v * 1.2);
    },

    'inv.w': function s(e, v) {
        e.$inventory.css('width', v + 'px');
        e.$inventory.css('padding-right', scrollerWidth + 'px');
    },
    'inv.h': function s(e, v) { e.$inventory.css('height', v + 'px'); },
    'inv.x': function s(e, v) { e.$inventory.css('left', v + 'px'); },
    'inv.y': function s(e, v) { e.$inventory.css('top', v + 'px'); },
    'inv.col.fg': function s(e, v) { e.$inventory.css('color', v); },
    'inv.mode': function s(e, v) {
        if (v === 'disabled') {
            e.$inventory.hide();
        } else {
            var p = v.split('-');
            Game.inventory_mode = p[0];
            if (p[0] === 'horizontal') {
                // default text align for 'horizontal' mode
                e.$inventory.css('text-align', 'center');
            }
            if (p[1]) {
                e.$inventory.css('text-align', p[1]);
            }
        }
    },
    'inv.fnt.name': function s(e, v, getURL) {
        dynamicStyles['inv.fnt.name'] = setFontCSS('#inventory', 'insteadInv', v, getURL);
        setCSS();
    },
    'inv.fnt.size': function s(e, v) {
        e.$inventory.css('font-size', v + 'px');
    },
    'inv.fnt.height': function s(e, v) {
        // default line height for browsers: 1.2
        e.$inventory.css('line-height', +v * 1.2);
    },

    'menu.col.bg': function s(e, v) { e.$menu.css('background-color', v); },
    'menu.col.fg': function s(e, v) { e.$menu.css('color', v); },
    'menu.col.link': function s(e, v) {
        dynamicStyles['menu.col.link'] = '#instead--menu a {color:' + v + '}';
        setCSS();
    },
    'menu.col.alink': function s(e, v) {
        dynamicStyles['menu.col.alink'] = '#instead--menu a:hover {color:' + v + '}';
        setCSS();
    },
    'menu.col.alpha': function s(e, v) { e.$menu.css('opacity', (v / 255)); },
    'menu.col.border': function s(e, v) { e.$menu.css('border', v + 'px'); },
    'menu.bw': function s(e, v) { e.$menu.css('border-width', v + 'px'); },

    'menu.button.x': function s(e, v) { e.$menuButton.css('left', v + 'px'); },
    'menu.button.y': function s(e, v) { e.$menuButton.css('top', v + 'px'); },

    'menu.gfx.button': function s(e, v, getURL) {
        e.$menuImage.attr('src', getURL(v));
    },
    'win.col.link': function s(e, v) {
        dynamicStyles['win.col.link'] = '#win a {color:' + v + '}';
        setCSS();
    },
    'win.col.alink': function s(e, v) {
        dynamicStyles['win.col.alink'] = '#win a:hover {color:' + v + '}';
        setCSS();
    },
    'inv.col.link': function s(e, v) {
        dynamicStyles['inv.col.link'] = '#inventory a {color:' + v + '}';
        setCSS();
    },
    'inv.col.alink': function s(e, v) {
        dynamicStyles['inv.col.alink'] = '#inventory a:hover {color:' + v + '}';
        setCSS();
    },

    'SPRITE.FNT': function s(fontID, v, getURL) {
        dynamicStyles[fontID] = setFontCSS(null, fontID, v, getURL);
        setCSS();
    },

    'CURSOR': function s(e, v, getURL) {
        e.$stead.css('cursor', 'url(' + getURL(v) + '), auto');
    }
};

var controller = {
    resetStyles: function resetStyles() {
        dynamicStyles = {};
        this.update();
    },
    update: function update() {
        setCSS();
    },
    immediate: function immediate(v) {
        updateCSS = v;
    },
    applyParamStyle: function applyParamStyle(key, elements, value, urlGetter) {
        if (key in applyStyle && value !== 'nil') {
            applyStyle[key](elements, value, urlGetter);
        }
    }
};

module.exports = controller;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// load styles
__webpack_require__(84);
__webpack_require__(85);

var $ = __webpack_require__(4);
__webpack_require__(115)($);

var Manager = __webpack_require__(146);
var ZipLoader = __webpack_require__(152);

var i18n = __webpack_require__(25);
var Game = __webpack_require__(2);
var Instead = __webpack_require__(35);
var UI = __webpack_require__(26);
var Menu = __webpack_require__(147);

document.addEventListener(
    'DOMContentLoaded',
    function onLoad() {
        if ('INSTEADjs' in window) {
            Game.loadConfig(window['INSTEADjs']); // eslint-disable-line dot-notation
            if (window['INSTEADjs']['translation']) { // eslint-disable-line dot-notation
                i18n.load(window['INSTEADjs']['translation']); // eslint-disable-line dot-notation
            }
        }
        Manager.init();
        ZipLoader.init();
        // initialization of INSTEAD components
        Instead.init();
        UI.init('#instead', Instead.handlers);
        Menu.init(UI.element, Instead.handlers);
    }
);


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var stead={};stead["instead_js.lua"]="DEBUG = false\nSTANDALONE = true\nPLATFORM = 'web'\nlocal INSTEAD_THEME_NAME = ''\n\nINSTEAD_PLACEHOLDER = function()\n    return\nend\n\nINSTEAD_EMPTYSTR = function()\n  return ''\nend\n\nINSTEAD_NOTIMPLEMENTED = function(fn)\n  js.run('Lua.logWarning(\"' .. fn .. ' : not implemented in instead.js\");')\nend\n\n-- call JS function with given parameters\ninsteadjs_call = function(jsfn, arg)\n    local arguments = ''\n    for i,v in ipairs(arg) do\n        arguments = arguments .. '\"' .. tostring(v) .. '\",'\n    end\n    arguments = arguments:sub(1, -2)\n    js.run(jsfn .. '(' .. arguments .. ')')\nend\n\ntable_get_maxn = function(tbl)\n\tlocal c=0\n\tfor k in pairs(tbl) do\n\t\tif type(k)=='number' and (c == nil or k > c) then\n\t\t\tc=k\n\t\tend\n\tend\n\treturn c\nend\n\nlocal INSTEAD_GAMEPATH = ''\n\njs_instead_gamepath = function(path)\n  INSTEAD_GAMEPATH=path\nend\n\ninstead_gamepath=function()\n  return INSTEAD_GAMEPATH\nend\n\ninstead_realpath = INSTEAD_EMPTYSTR\ninstead_savepath = INSTEAD_EMPTYSTR\ninstead_exepath = INSTEAD_EMPTYSTR\n\n-- theme\nfunction instead_theme_var(name, value)\n    if (value) then\n        js.run('insteadThemeSet(\"' .. tostring(name) .. '\",\"' .. tostring(value) .. '\")')\n    else\n        return js.run_string('insteadThemeGet(\"' .. tostring(name) .. '\")')\n    end\nend\n\nfunction js_instead_theme_name(theme)\n  INSTEAD_THEME_NAME=theme\nend\n\nfunction instead_theme_name()\n    return INSTEAD_THEME_NAME\nend\n\n-- timer\ninstead_timer = function(t)\n    js.run('instead_settimer(\"' .. tostring(t) .. '\")')\nend\n\n-- sound\ninstead_sound = INSTEAD_PLACEHOLDER\ninstead_sound_load = INSTEAD_PLACEHOLDER\ninstead_sound_free = INSTEAD_PLACEHOLDER\ninstead_sounds_free = INSTEAD_PLACEHOLDER\ninstead_sound_channel = function()\n    INSTEAD_NOTIMPLEMENTED('sound_channel')\nend\ninstead_sound_volume = function()\n    INSTEAD_NOTIMPLEMENTED('sound_volume')\nend\ninstead_sound_panning = function()\n    INSTEAD_NOTIMPLEMENTED('sound_panning')\nend\ninstead_sound_load_mem = function()\n    INSTEAD_NOTIMPLEMENTED('sound_load_mem')\nend -- stead 3\ninstead_music_callback = function()\n    INSTEAD_NOTIMPLEMENTED('music_callback')\nend -- stead 3\n\n-- sprites are not supported (yet?)\nsprite_descriptors = {}\nfont_descriptors = {}\n\ninstead_font_load = function(filename, size)\n    js.run('Sprite.font(\"' .. tostring(filename) .. '\",\"' .. tostring(size) .. '\")')\n    return font_descriptors[filename .. size]\nend\njs_instead_font_load = function(font, id)\n    font_descriptors[font] = id\nend\ninstead_font_free = function()\n    -- fonts are not taking much memory, no need to 'free' them\n    return\nend\ninstead_font_scaled_size = function(size)\n    -- TODO: return size as-is\n    return size\nend\ninstead_sprite_alpha = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.sprite_alpha')\nend\ninstead_sprite_dup = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.dup')\nend\ninstead_sprite_scale = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.scale')\nend\ninstead_sprite_rotate = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.rotate')\nend\ninstead_sprite_text = function(font, text, col, style)\n    local arguments = ''\n    arguments = arguments .. '\"' .. tostring(font) .. '\",'\n    arguments = arguments .. '\"' .. tostring(text) .. '\",'\n    arguments = arguments .. '\"' .. tostring(col) .. '\",'\n    arguments = arguments .. '\"' .. tostring(style) .. '\"'\n    js.run('Sprite.text(' .. arguments .. ')')\n    return sprite_descriptors[font]\nend\njs_instead_sprite_text = function(font, id)\n    sprite_descriptors[font] = id\nend\ninstead_sprite_text_size = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.text_size')\n    return 16 -- default font size\nend\ninstead_sprite_draw = function(...)\n    insteadjs_call('Sprite.draw', {...})\nend\ninstead_sprite_copy = function(...)\n    insteadjs_call('Sprite.copy', {...})\nend\ninstead_sprite_compose = function(...)\n    insteadjs_call('Sprite.compose', {...})\nend\ninstead_sprite_fill = function(...)\n    insteadjs_call('Sprite.fill', {...})\nend\ninstead_sprite_pixel = function(...)\n    insteadjs_call('Sprite.pixel', {...})\nend\ninstead_sprite_load = function(filename)\n    js.run('Sprite.load(\"' .. tostring(filename) .. '\")')\n    return sprite_descriptors[filename]\nend\njs_instead_sprite_load = function(filename, id)\n    sprite_descriptors[filename] = id\nend\ninstead_sprite_free = function(descriptor)\n    js.run('Sprite.free(\"' .. tostring(descriptor) .. '\")')\nend\ninstead_sprite_size = function()\n    INSTEAD_NOTIMPLEMENTED('sprite.size')\nend\ninstead_sprites_free = INSTEAD_PLACEHOLDER\ninstead_sprite_colorkey = INSTEAD_PLACEHOLDER\ninstead_ticks = function()\n    return js.run_string('Date.now()')\nend\ninstead_mouse_pos = INSTEAD_PLACEHOLDER\ninstead_mouse_show = INSTEAD_PLACEHOLDER\ninstead_finger_pos = INSTEAD_PLACEHOLDER\nfunction instead_mouse_filter(...)\n  insteadjs_call('console.log', {...})\nend\ninstead_busy = INSTEAD_PLACEHOLDER\n\n-- click\ninstead_click = function(x,y)\n    local cmd = iface:input('mouse', true, 1, x, y, x, y)\n    if (cmd) then\n       return iface:cmd(cmd)\n    end\nend\n\n-- scene helper\njs_instead_getscene = function(invmode)\n    local scene = {}\n    scene['sound'] = instead.get_sound()\n    scene['music'] = instead.get_music()\n    scene['title'] = instead.get_title()\n    scene['ways'] = instead.get_ways()\n    scene['inv'] = instead.get_inv(invmode)\n    scene['pic'] = instead.get_picture()\n    return scene\nend\n\nfunction instead_readdir(d) -- TODO\n\treturn function()\n\t\tprint (\"Readdir for: \", d)\n\tend\nend\n\nfunction instead_text_input()\n    return true\nend\n";stead["instead_fs.lua"]="-- io.open proxy\nlocal files = {\n}\n\nio.open = function (filename, mode)\n\tlocal o = {\n\t\tmode = mode or \"r\",\n\t\tname = filename,\n\t\tnew = function(s)\n\t\t\tif not s._lines and s.mode:find(\"r\") then -- for read\n\t\t\t\tinstead_file_set_content(\n\t\t\t\t\ts,\n\t\t\t\t\tjs.run_string('Lua.openFile(\"' .. tostring(s.name) .. '\")')\n\t\t\t\t)\n\t\t\tend\n\t\tend;\n\t\tlines = function (s)\n\t\t\ts:new()\n\t\t\treturn function()\n\t\t\t\treturn s:read('*line')\n\t\t\tend\n\t\tend,\n\t\tsetvbuf = function ()\n\t\t\treturn\n\t\tend,\n\t\tread = function(s, m) -- line by line\n\t\t\ts:new()\n\t\t\tif m == '*line' then\n\t\t\t\tlocal i = s.line_nr + 1\n\t\t\t\ts.line_nr = i;\n\t\t\t\tlocal n = #s._lines\n\t\t\t\tif i >= n then\n\t\t\t\t\treturn\n\t\t\t\tend\n\t\t\t\treturn s._lines[i]\n\t\t\tend\n\t\t\treturn s.content\n\t\tend;\n\t\twrite = function(s, ...)\n\t\t\tlocal a = { ... }\n\t\t\tfor i, v in ipairs(a) do\n\t\t\t\ts.content = (s.content or '').. tostring(v)\n\t\t\tend\n\t\tend,\n\t\tflush = INSTEAD_PLACEHOLDER,\n\t\tclose = function(s)\n\t\t\tif s.content ~= '' then\n\t\t\t\tjs.run('Lua.saveFile(\"' .. s.name .. '\")')\n\t\t\tend\n\t\tend\n\t}\n\tfiles[filename] = o\n\treturn o\nend\n\nos.remove = INSTEAD_PLACEHOLDER\nos.rename = INSTEAD_PLACEHOLDER\n\ninstead_file_get_content = function(file)\n\treturn files[file] and files[file].content\nend\n\ninstead_file_set_content = function(s, content)\n\ts.content = content\n\tlocal t = {}\n\tlocal function helper(line)\n\t\ttable.insert(t, line)\n\t\treturn \"\"\n\tend\n\thelper((content:gsub(\"(.-)\\r?\\n\", helper)))\n\ts._lines = t\n\ts.line_nr = 0\nend\n\n-- loadfile proxy\nloadfile = function(file)\n\tlocal content = js.run_string('Lua.loadFile(\"' .. file .. '\")')\n\tif content ~= '' then\n\t\treturn assert(loadstring(content))\n\tend\nend\n\n-- stead3\nif std then\n\tstd.loadfile = loadfile;\nend\n\n";stead["instead_init.lua"]="local requires = {}\n\nfunction require(fn)\n\tif requires[fn] then return requires[fn] end\n\tlocal code = js.run_string('Lua.requireContent(\"' .. tostring(fn) .. '\")')\n\trequires[fn] = loadstring(code)() or true\n\treturn requires[fn]\nend\n\nrequire 'instead_js'\nrequire 'stead'\nrequire 'ext/gui'\nrequire 'ext/paths'\nrequire 'ext/sound'\nrequire 'ext/sprites'\nrequire 'ext/timer'\n\nstead:init()\n\nrequire 'instead_fs'\n";module.exports=stead;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83);
module.exports = __webpack_require__(38).setImmediate;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(20)
  , core      = __webpack_require__(38)
  , ctx       = __webpack_require__(39)
  , hide      = __webpack_require__(75)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(79)
  , createDesc = __webpack_require__(80);
module.exports = __webpack_require__(27) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20).document && document.documentElement;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(27) && !__webpack_require__(41)(function(){
  return Object.defineProperty(__webpack_require__(40)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(72)
  , IE8_DOM_DEFINE = __webpack_require__(77)
  , toPrimitive    = __webpack_require__(82)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(39)
  , invoke             = __webpack_require__(78)
  , html               = __webpack_require__(76)
  , cel                = __webpack_require__(40)
  , global             = __webpack_require__(20)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(73)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(74)
  , $task   = __webpack_require__(81);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = __webpack_require__(106);
var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = new pako[action]({
        raw:true,
        level : options.level || -1 // default compression
    });
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};

    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);
var utf8 = __webpack_require__(14);
var crc32 = __webpack_require__(30);
var signature = __webpack_require__(51);

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions, isDir) {

    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with informations about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo['file'],
    compression = streamInfo['compression'],
    useCustomEncoding = encodeFileName !== utf8.utf8encode,
    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
    comment = file.comment,
    encodedComment = utils.transformTo("string", encodeFileName(comment)),
    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
    useUTF8ForComment = utfEncodedComment.length !== comment.length,
    dosTime,
    dosDate,
    extraFields = "",
    unicodePathExtraField = "",
    unicodeCommentExtraField = "",
    dir = file.dir,
    date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo['crc32'];
        dataInfo.compressedSize = streamInfo['compressedSize'];
        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing informations
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo['crc32'], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo['compressedSize'], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo['uncompressedSize'], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emited metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo['file'].name;

    var streamedContent = this.streamFiles && !streamInfo['file'].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on('data', function (chunk) {
        self.processChunk(chunk);
    });
    previous.on('end', function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on('error', function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compressions = __webpack_require__(44);
var ZipFileWorker = __webpack_require__(89);

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
            .withStreamInfo("file", {
                name : relativePath,
                dir : dir,
                date : date,
                comment : file.comment || "",
                unixPermissions : file.unixPermissions,
                dosPermissions : file.dosPermissions
            })
            .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = __webpack_require__(95);
JSZip.prototype.loadAsync = __webpack_require__(92);
JSZip.support = __webpack_require__(8);
JSZip.defaults = __webpack_require__(45);

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.1.3";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = __webpack_require__(16);
module.exports = JSZip;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(0);
var external = __webpack_require__(16);
var utf8 = __webpack_require__(14);
var utils = __webpack_require__(0);
var ZipEntries = __webpack_require__(99);
var Crc32Probe = __webpack_require__(52);
var nodejsUtils = __webpack_require__(22);

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
        .on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
                resolve();
            }
        })
        .resume();
    });
}

module.exports = function(data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
    .then(function(data) {
        var zipEntries = new ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [external.Promise.resolve(zipEntries)];
        var files = zipEntries.files;
        if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
                promises.push(checkEntryCRC32(files[i]));
            }
        }
        return external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for (var i = 0; i < files.length; i++) {
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions : input.unixPermissions,
                dosPermissions : input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
        }

        return zip;
    });
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
    .on("data", function (chunk) {
        self.push({
            data: chunk,
            meta : {
                percent : 0
            }
        });
    })
    .on("error", function (e) {
        if(self.isPaused) {
            this.generatedError = e;
        } else {
            self.error(e);
        }
    })
    .on("end", function () {
        if(self.isPaused) {
            self._upstreamEnded = true;
        } else {
            self.end();
        }
    });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Readable = __webpack_require__(46).Readable;

var util = __webpack_require__(105);
util.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
    .on("error", function(e) {
        self.emit('error', e);
    })
    .on("end", function () {
        self.push(null);
    });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utf8 = __webpack_require__(14);
var utils = __webpack_require__(0);
var GenericWorker = __webpack_require__(3);
var StreamHelper = __webpack_require__(55);
var defaults = __webpack_require__(45);
var CompressedObject = __webpack_require__(29);
var ZipObject = __webpack_require__(101);
var generate = __webpack_require__(90);
var nodejsUtils = __webpack_require__(22);
var NodejsStreamInputAdapter = __webpack_require__(93);


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
      var worker, opts = {};
      try {
          opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions : null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: 'application/zip',
              encodeFileName: utf8.utf8encode
          });

          opts.type = opts.type.toLowerCase();
          opts.compression = opts.compression.toUpperCase();

          // "binarystring" is prefered but the internals use "string".
          if(opts.type === "binarystring") {
            opts.type = "string";
          }

          if (!opts.type) {
            throw new Error("No output type specified.");
          }

          utils.checkSupport(opts.type);

          // accept nodejs `process.platform`
          if(
              opts.platform === 'darwin' ||
              opts.platform === 'freebsd' ||
              opts.platform === 'linux' ||
              opts.platform === 'sunos'
          ) {
              opts.platform = "UNIX";
          }
          if (opts.platform === 'win32') {
              opts.platform = "DOS";
          }

          var comment = opts.comment || this.comment || "";
          worker = generate.generateWorker(this, opts, comment);
      } catch (e) {
        worker = new GenericWorker("error");
        worker.error(e);
      }
      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Uint8ArrayReader = __webpack_require__(49);
var utils = __webpack_require__(0);

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(48);
var utils = __webpack_require__(0);

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(3);
var utils = __webpack_require__(0);

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(50);
var utils = __webpack_require__(0);
var sig = __webpack_require__(51);
var ZipEntry = __webpack_require__(100);
var utf8 = __webpack_require__(14);
var support = __webpack_require__(8);
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip : can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(50);
var utils = __webpack_require__(0);
var CompressedObject = __webpack_require__(29);
var crc32fn = __webpack_require__(30);
var utf8 = __webpack_require__(14);
var compressions = __webpack_require__(44);
var support = __webpack_require__(8);

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StreamHelper = __webpack_require__(55);
var DataWorker = __webpack_require__(54);
var utf8 = __webpack_require__(14);
var CompressedObject = __webpack_require__(29);
var GenericWorker = __webpack_require__(3);

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var outputType = type.toLowerCase();
        var askUnicodeString = outputType === "string" || outputType === "text";
        if (outputType === "binarystring" || outputType === "text") {
            outputType = "string";
        }
        var result = this._decompressWorker();

        var isUnicodeString = !this._dataBinary;

        if (isUnicodeString && !askUnicodeString) {
            result = result.pipe(new utf8.Utf8EncodeWorker());
        }
        if (!isUnicodeString && askUnicodeString) {
            result = result.pipe(new utf8.Utf8DecodeWorker());
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var immediate = __webpack_require__(87);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(104);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(103);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Top level file is just a mixin of submodules & constants


var assign    = __webpack_require__(9).assign;

var deflate   = __webpack_require__(107);
var inflate   = __webpack_require__(108);
var constants = __webpack_require__(59);

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_deflate = __webpack_require__(109);
var utils        = __webpack_require__(9);
var strings      = __webpack_require__(57);
var msg          = __webpack_require__(31);
var ZStream      = __webpack_require__(61);

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_inflate = __webpack_require__(112);
var utils        = __webpack_require__(9);
var strings      = __webpack_require__(57);
var c            = __webpack_require__(59);
var msg          = __webpack_require__(31);
var ZStream      = __webpack_require__(61);
var GZheader     = __webpack_require__(110);

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__(9);
var trees   = __webpack_require__(114);
var adler32 = __webpack_require__(58);
var crc32   = __webpack_require__(60);
var msg     = __webpack_require__(31);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__(9);
var adler32       = __webpack_require__(58);
var crc32         = __webpack_require__(60);
var inflate_fast  = __webpack_require__(111);
var inflate_table = __webpack_require__(113);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(9);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = __webpack_require__(9);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(116);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var ps = __webpack_require__(119);
var psInstances = __webpack_require__(1);

function mountJQuery(jQuery) {
  jQuery.fn.perfectScrollbar = function (settingOrCommand) {
    return this.each(function () {
      if (typeof settingOrCommand === 'object' ||
          typeof settingOrCommand === 'undefined') {
        // If it's an object or none, initialize.
        var settings = settingOrCommand;

        if (!psInstances.get(this)) {
          ps.initialize(this, settings);
        }
      } else {
        // Unless, it may be a command.
        var command = settingOrCommand;

        if (command === 'update') {
          ps.update(this);
        } else if (command === 'destroy') {
          ps.destroy(this);
        }
      }
    });
  };
}

if (true) {
  // AMD. Register as an anonymous module.
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mountJQuery),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  var jq = window.jQuery ? window.jQuery : window.$;
  if (typeof jq !== 'undefined') {
    mountJQuery(jq);
  }
}

module.exports = mountJQuery;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var destroy = __webpack_require__(121);
var initialize = __webpack_require__(129);
var update = __webpack_require__(130);

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var dom = __webpack_require__(11);
var instances = __webpack_require__(1);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  dom.remove(i.scrollbarX);
  dom.remove(i.scrollbarY);
  dom.remove(i.scrollbarXRail);
  dom.remove(i.scrollbarYRail);
  _.removePsClasses(element);

  instances.remove(element);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = function (e) { e.stopPropagation(); };

  i.event.bind(i.scrollbarY, 'click', stopPropagation);
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
    updateGeometry(element);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'click', stopPropagation);
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var dom = __webpack_require__(11);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
    _.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
    _.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var dom = __webpack_require__(11);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
      return;
    }

    var focused = dom.matches(i.scrollbarX, ':focus') ||
                  dom.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (_.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      if (e.metaKey) {
        deltaX = -i.contentWidth;
      } else if (e.altKey) {
        deltaX = -i.containerWidth;
      } else {
        deltaX = -30;
      }
      break;
    case 38: // up
      if (e.metaKey) {
        deltaY = i.contentHeight;
      } else if (e.altKey) {
        deltaY = i.containerHeight;
      } else {
        deltaY = 30;
      }
      break;
    case 39: // right
      if (e.metaKey) {
        deltaX = i.contentWidth;
      } else if (e.altKey) {
        deltaX = i.containerWidth;
      } else {
        deltaX = 30;
      }
      break;
    case 40: // down
      if (e.metaKey) {
        deltaY = -i.contentHeight;
      } else if (e.altKey) {
        deltaY = -i.containerHeight;
      } else {
        deltaY = -30;
      }
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(deltaX, deltaY) {
    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
    if (child) {
      if (!window.getComputedStyle(child).overflow.match(/(scroll|auto)/)) {
        // if not scrollable
        return false;
      }

      var maxScrollTop = child.scrollHeight - child.clientHeight;
      if (maxScrollTop > 0) {
        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = child.scrollLeft - child.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByChild(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    _.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'keyup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        _.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        _.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        _.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        _.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inLocalTouch && i.settings.swipePropagation) {
      touchStart(e);
    }
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      clearInterval(easingLoop);
      easingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element) {
  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
    return;
  }

  var i = instances.get(element);
  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var cls = __webpack_require__(23);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);

// Handlers
var handlers = {
  'click-rail': __webpack_require__(122),
  'drag-scrollbar': __webpack_require__(123),
  'keyboard': __webpack_require__(124),
  'wheel': __webpack_require__(125),
  'touch': __webpack_require__(128),
  'selection': __webpack_require__(127)
};
var nativeScrollHandler = __webpack_require__(126);

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = _.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  nativeScrollHandler(element);

  updateGeometry(element);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(6);
var dom = __webpack_require__(11);
var instances = __webpack_require__(1);
var updateGeometry = __webpack_require__(7);
var updateScroll = __webpack_require__(10);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  dom.css(i.scrollbarXRail, 'display', 'none');
  dom.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  dom.css(i.scrollbarXRail, 'display', '');
  dom.css(i.scrollbarYRail, 'display', '');
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = "(function(){var Module = typeof Module !== \"undefined\" ? Module : {};\n\nvar moduleOverrides = {};\n\nvar key;\n\nfor (key in Module) {\n if (Module.hasOwnProperty(key)) {\n  moduleOverrides[key] = Module[key];\n }\n}\n\nModule[\"arguments\"] = [];\n\nModule[\"thisProgram\"] = \"./this.program\";\n\nModule[\"quit\"] = function(status, toThrow) {\n throw toThrow;\n};\n\nModule[\"preRun\"] = [];\n\nModule[\"postRun\"] = [];\n\nvar ENVIRONMENT_IS_WEB = true;\n\nvar ENVIRONMENT_IS_WORKER = false;\n\nvar ENVIRONMENT_IS_NODE = false;\n\nvar ENVIRONMENT_IS_SHELL = false;\n\nvar scriptDirectory = \"\";\n\nfunction locateFile(path) {\n if (Module[\"locateFile\"]) {\n  return Module[\"locateFile\"](path, scriptDirectory);\n } else {\n  return scriptDirectory + path;\n }\n}\n\nif (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {\n if (ENVIRONMENT_IS_WORKER) {\n  scriptDirectory = self.location.href;\n } else if (document.currentScript) {\n  scriptDirectory = document.currentScript.src;\n }\n if (scriptDirectory.indexOf(\"blob:\") !== 0) {\n  scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf(\"/\") + 1);\n } else {\n  scriptDirectory = \"\";\n }\n Module[\"read\"] = function shell_read(url) {\n  try {\n   var xhr = new XMLHttpRequest();\n   xhr.open(\"GET\", url, false);\n   xhr.send(null);\n   return xhr.responseText;\n  } catch (err) {\n   var data = tryParseAsDataURI(url);\n   if (data) {\n    return intArrayToString(data);\n   }\n   throw err;\n  }\n };\n if (ENVIRONMENT_IS_WORKER) {\n  Module[\"readBinary\"] = function readBinary(url) {\n   try {\n    var xhr = new XMLHttpRequest();\n    xhr.open(\"GET\", url, false);\n    xhr.responseType = \"arraybuffer\";\n    xhr.send(null);\n    return new Uint8Array(xhr.response);\n   } catch (err) {\n    var data = tryParseAsDataURI(url);\n    if (data) {\n     return data;\n    }\n    throw err;\n   }\n  };\n }\n Module[\"readAsync\"] = function readAsync(url, onload, onerror) {\n  var xhr = new XMLHttpRequest();\n  xhr.open(\"GET\", url, true);\n  xhr.responseType = \"arraybuffer\";\n  xhr.onload = function xhr_onload() {\n   if (xhr.status == 200 || xhr.status == 0 && xhr.response) {\n    onload(xhr.response);\n    return;\n   }\n   var data = tryParseAsDataURI(url);\n   if (data) {\n    onload(data.buffer);\n    return;\n   }\n   onerror();\n  };\n  xhr.onerror = onerror;\n  xhr.send(null);\n };\n Module[\"setWindowTitle\"] = function(title) {\n  document.title = title;\n };\n} else {}\n\nvar out = Module[\"print\"] || (typeof console !== \"undefined\" ? console.log.bind(console) : typeof print !== \"undefined\" ? print : null);\n\nvar err = Module[\"printErr\"] || (typeof printErr !== \"undefined\" ? printErr : typeof console !== \"undefined\" && console.warn.bind(console) || out);\n\nfor (key in moduleOverrides) {\n if (moduleOverrides.hasOwnProperty(key)) {\n  Module[key] = moduleOverrides[key];\n }\n}\n\nmoduleOverrides = undefined;\n\nvar STACK_ALIGN = 16;\n\nfunction dynamicAlloc(size) {\n var ret = HEAP32[DYNAMICTOP_PTR >> 2];\n var end = ret + size + 15 & -16;\n if (end <= _emscripten_get_heap_size()) {\n  HEAP32[DYNAMICTOP_PTR >> 2] = end;\n } else {\n  var success = _emscripten_resize_heap(end);\n  if (!success) return 0;\n }\n return ret;\n}\n\nfunction getNativeTypeSize(type) {\n switch (type) {\n case \"i1\":\n case \"i8\":\n  return 1;\n\n case \"i16\":\n  return 2;\n\n case \"i32\":\n  return 4;\n\n case \"i64\":\n  return 8;\n\n case \"float\":\n  return 4;\n\n case \"double\":\n  return 8;\n\n default:\n  {\n   if (type[type.length - 1] === \"*\") {\n    return 4;\n   } else if (type[0] === \"i\") {\n    var bits = parseInt(type.substr(1));\n    assert(bits % 8 === 0, \"getNativeTypeSize invalid bits \" + bits + \", type \" + type);\n    return bits / 8;\n   } else {\n    return 0;\n   }\n  }\n }\n}\n\nfunction warnOnce(text) {\n if (!warnOnce.shown) warnOnce.shown = {};\n if (!warnOnce.shown[text]) {\n  warnOnce.shown[text] = 1;\n  err(text);\n }\n}\n\nvar jsCallStartIndex = 1;\n\nvar functionPointers = new Array(128);\n\nfunction addFunction(func, sig) {\n var base = 0;\n for (var i = base; i < base + 128; i++) {\n  if (!functionPointers[i]) {\n   functionPointers[i] = func;\n   return jsCallStartIndex + i;\n  }\n }\n throw \"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.\";\n}\n\nvar funcWrappers = {};\n\nfunction dynCall(sig, ptr, args) {\n if (args && args.length) {\n  return Module[\"dynCall_\" + sig].apply(null, [ ptr ].concat(args));\n } else {\n  return Module[\"dynCall_\" + sig].call(null, ptr);\n }\n}\n\nvar tempRet0 = 0;\n\nvar setTempRet0 = function(value) {\n tempRet0 = value;\n};\n\nvar getTempRet0 = function() {\n return tempRet0;\n};\n\nvar GLOBAL_BASE = 8;\n\nvar ABORT = false;\n\nvar EXITSTATUS = 0;\n\nfunction assert(condition, text) {\n if (!condition) {\n  abort(\"Assertion failed: \" + text);\n }\n}\n\nfunction getCFunc(ident) {\n var func = Module[\"_\" + ident];\n assert(func, \"Cannot call unknown function \" + ident + \", make sure it is exported\");\n return func;\n}\n\nfunction ccall(ident, returnType, argTypes, args, opts) {\n var toC = {\n  \"string\": function(str) {\n   var ret = 0;\n   if (str !== null && str !== undefined && str !== 0) {\n    var len = (str.length << 2) + 1;\n    ret = stackAlloc(len);\n    stringToUTF8(str, ret, len);\n   }\n   return ret;\n  },\n  \"array\": function(arr) {\n   var ret = stackAlloc(arr.length);\n   writeArrayToMemory(arr, ret);\n   return ret;\n  }\n };\n function convertReturnValue(ret) {\n  if (returnType === \"string\") return UTF8ToString(ret);\n  if (returnType === \"boolean\") return Boolean(ret);\n  return ret;\n }\n var func = getCFunc(ident);\n var cArgs = [];\n var stack = 0;\n if (args) {\n  for (var i = 0; i < args.length; i++) {\n   var converter = toC[argTypes[i]];\n   if (converter) {\n    if (stack === 0) stack = stackSave();\n    cArgs[i] = converter(args[i]);\n   } else {\n    cArgs[i] = args[i];\n   }\n  }\n }\n var ret = func.apply(null, cArgs);\n ret = convertReturnValue(ret);\n if (stack !== 0) stackRestore(stack);\n return ret;\n}\n\nfunction setValue(ptr, value, type, noSafe) {\n type = type || \"i8\";\n if (type.charAt(type.length - 1) === \"*\") type = \"i32\";\n switch (type) {\n case \"i1\":\n  HEAP8[ptr >> 0] = value;\n  break;\n\n case \"i8\":\n  HEAP8[ptr >> 0] = value;\n  break;\n\n case \"i16\":\n  HEAP16[ptr >> 1] = value;\n  break;\n\n case \"i32\":\n  HEAP32[ptr >> 2] = value;\n  break;\n\n case \"i64\":\n  tempI64 = [ value >>> 0, (tempDouble = value, +Math_abs(tempDouble) >= +1 ? tempDouble > +0 ? (Math_min(+Math_floor(tempDouble / +4294967296), +4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / +4294967296) >>> 0 : 0) ], \n  HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];\n  break;\n\n case \"float\":\n  HEAPF32[ptr >> 2] = value;\n  break;\n\n case \"double\":\n  HEAPF64[ptr >> 3] = value;\n  break;\n\n default:\n  abort(\"invalid type for setValue: \" + type);\n }\n}\n\nvar ALLOC_NORMAL = 0;\n\nvar ALLOC_NONE = 3;\n\nfunction allocate(slab, types, allocator, ptr) {\n var zeroinit, size;\n if (typeof slab === \"number\") {\n  zeroinit = true;\n  size = slab;\n } else {\n  zeroinit = false;\n  size = slab.length;\n }\n var singleType = typeof types === \"string\" ? types : null;\n var ret;\n if (allocator == ALLOC_NONE) {\n  ret = ptr;\n } else {\n  ret = [ _malloc, stackAlloc, dynamicAlloc ][allocator](Math.max(size, singleType ? 1 : types.length));\n }\n if (zeroinit) {\n  var stop;\n  ptr = ret;\n  assert((ret & 3) == 0);\n  stop = ret + (size & ~3);\n  for (;ptr < stop; ptr += 4) {\n   HEAP32[ptr >> 2] = 0;\n  }\n  stop = ret + size;\n  while (ptr < stop) {\n   HEAP8[ptr++ >> 0] = 0;\n  }\n  return ret;\n }\n if (singleType === \"i8\") {\n  if (slab.subarray || slab.slice) {\n   HEAPU8.set(slab, ret);\n  } else {\n   HEAPU8.set(new Uint8Array(slab), ret);\n  }\n  return ret;\n }\n var i = 0, type, typeSize, previousType;\n while (i < size) {\n  var curr = slab[i];\n  type = singleType || types[i];\n  if (type === 0) {\n   i++;\n   continue;\n  }\n  if (type == \"i64\") type = \"i32\";\n  setValue(ret + i, curr, type);\n  if (previousType !== type) {\n   typeSize = getNativeTypeSize(type);\n   previousType = type;\n  }\n  i += typeSize;\n }\n return ret;\n}\n\nfunction getMemory(size) {\n if (!runtimeInitialized) return dynamicAlloc(size);\n return _malloc(size);\n}\n\nfunction Pointer_stringify(ptr, length) {\n abort(\"this function has been removed - you should use UTF8ToString(ptr, maxBytesToRead) instead!\");\n}\n\nvar UTF8Decoder = typeof TextDecoder !== \"undefined\" ? new TextDecoder(\"utf8\") : undefined;\n\nfunction UTF8ArrayToString(u8Array, idx, maxBytesToRead) {\n var endIdx = idx + maxBytesToRead;\n var endPtr = idx;\n while (u8Array[endPtr] && !(endPtr >= endIdx)) ++endPtr;\n if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) {\n  return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));\n } else {\n  var str = \"\";\n  while (idx < endPtr) {\n   var u0 = u8Array[idx++];\n   if (!(u0 & 128)) {\n    str += String.fromCharCode(u0);\n    continue;\n   }\n   var u1 = u8Array[idx++] & 63;\n   if ((u0 & 224) == 192) {\n    str += String.fromCharCode((u0 & 31) << 6 | u1);\n    continue;\n   }\n   var u2 = u8Array[idx++] & 63;\n   if ((u0 & 240) == 224) {\n    u0 = (u0 & 15) << 12 | u1 << 6 | u2;\n   } else {\n    u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u8Array[idx++] & 63;\n   }\n   if (u0 < 65536) {\n    str += String.fromCharCode(u0);\n   } else {\n    var ch = u0 - 65536;\n    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);\n   }\n  }\n }\n return str;\n}\n\nfunction UTF8ToString(ptr, maxBytesToRead) {\n return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : \"\";\n}\n\nfunction stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {\n if (!(maxBytesToWrite > 0)) return 0;\n var startIdx = outIdx;\n var endIdx = outIdx + maxBytesToWrite - 1;\n for (var i = 0; i < str.length; ++i) {\n  var u = str.charCodeAt(i);\n  if (u >= 55296 && u <= 57343) {\n   var u1 = str.charCodeAt(++i);\n   u = 65536 + ((u & 1023) << 10) | u1 & 1023;\n  }\n  if (u <= 127) {\n   if (outIdx >= endIdx) break;\n   outU8Array[outIdx++] = u;\n  } else if (u <= 2047) {\n   if (outIdx + 1 >= endIdx) break;\n   outU8Array[outIdx++] = 192 | u >> 6;\n   outU8Array[outIdx++] = 128 | u & 63;\n  } else if (u <= 65535) {\n   if (outIdx + 2 >= endIdx) break;\n   outU8Array[outIdx++] = 224 | u >> 12;\n   outU8Array[outIdx++] = 128 | u >> 6 & 63;\n   outU8Array[outIdx++] = 128 | u & 63;\n  } else {\n   if (outIdx + 3 >= endIdx) break;\n   outU8Array[outIdx++] = 240 | u >> 18;\n   outU8Array[outIdx++] = 128 | u >> 12 & 63;\n   outU8Array[outIdx++] = 128 | u >> 6 & 63;\n   outU8Array[outIdx++] = 128 | u & 63;\n  }\n }\n outU8Array[outIdx] = 0;\n return outIdx - startIdx;\n}\n\nfunction stringToUTF8(str, outPtr, maxBytesToWrite) {\n return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);\n}\n\nfunction lengthBytesUTF8(str) {\n var len = 0;\n for (var i = 0; i < str.length; ++i) {\n  var u = str.charCodeAt(i);\n  if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;\n  if (u <= 127) ++len; else if (u <= 2047) len += 2; else if (u <= 65535) len += 3; else len += 4;\n }\n return len;\n}\n\nvar UTF16Decoder = typeof TextDecoder !== \"undefined\" ? new TextDecoder(\"utf-16le\") : undefined;\n\nfunction allocateUTF8(str) {\n var size = lengthBytesUTF8(str) + 1;\n var ret = _malloc(size);\n if (ret) stringToUTF8Array(str, HEAP8, ret, size);\n return ret;\n}\n\nfunction writeArrayToMemory(array, buffer) {\n HEAP8.set(array, buffer);\n}\n\nfunction writeAsciiToMemory(str, buffer, dontAddNull) {\n for (var i = 0; i < str.length; ++i) {\n  HEAP8[buffer++ >> 0] = str.charCodeAt(i);\n }\n if (!dontAddNull) HEAP8[buffer >> 0] = 0;\n}\n\nfunction demangle(func) {\n return func;\n}\n\nfunction demangleAll(text) {\n var regex = /__Z[\\w\\d_]+/g;\n return text.replace(regex, function(x) {\n  var y = demangle(x);\n  return x === y ? x : y + \" [\" + x + \"]\";\n });\n}\n\nfunction jsStackTrace() {\n var err = new Error();\n if (!err.stack) {\n  try {\n   throw new Error(0);\n  } catch (e) {\n   err = e;\n  }\n  if (!err.stack) {\n   return \"(no stack trace available)\";\n  }\n }\n return err.stack.toString();\n}\n\nfunction alignUp(x, multiple) {\n if (x % multiple > 0) {\n  x += multiple - x % multiple;\n }\n return x;\n}\n\nvar buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;\n\nfunction updateGlobalBuffer(buf) {\n Module[\"buffer\"] = buffer = buf;\n}\n\nfunction updateGlobalBufferViews() {\n Module[\"HEAP8\"] = HEAP8 = new Int8Array(buffer);\n Module[\"HEAP16\"] = HEAP16 = new Int16Array(buffer);\n Module[\"HEAP32\"] = HEAP32 = new Int32Array(buffer);\n Module[\"HEAPU8\"] = HEAPU8 = new Uint8Array(buffer);\n Module[\"HEAPU16\"] = HEAPU16 = new Uint16Array(buffer);\n Module[\"HEAPU32\"] = HEAPU32 = new Uint32Array(buffer);\n Module[\"HEAPF32\"] = HEAPF32 = new Float32Array(buffer);\n Module[\"HEAPF64\"] = HEAPF64 = new Float64Array(buffer);\n}\n\nvar STACK_BASE = 16752, DYNAMIC_BASE = 5259632, DYNAMICTOP_PTR = 16496;\n\nvar TOTAL_STACK = 5242880;\n\nvar TOTAL_MEMORY = Module[\"TOTAL_MEMORY\"] || 134217728;\n\nif (TOTAL_MEMORY < TOTAL_STACK) err(\"TOTAL_MEMORY should be larger than TOTAL_STACK, was \" + TOTAL_MEMORY + \"! (TOTAL_STACK=\" + TOTAL_STACK + \")\");\n\nif (Module[\"buffer\"]) {\n buffer = Module[\"buffer\"];\n} else {\n {\n  buffer = new ArrayBuffer(TOTAL_MEMORY);\n }\n Module[\"buffer\"] = buffer;\n}\n\nupdateGlobalBufferViews();\n\nHEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;\n\nfunction callRuntimeCallbacks(callbacks) {\n while (callbacks.length > 0) {\n  var callback = callbacks.shift();\n  if (typeof callback == \"function\") {\n   callback();\n   continue;\n  }\n  var func = callback.func;\n  if (typeof func === \"number\") {\n   if (callback.arg === undefined) {\n    Module[\"dynCall_v\"](func);\n   } else {\n    Module[\"dynCall_vi\"](func, callback.arg);\n   }\n  } else {\n   func(callback.arg === undefined ? null : callback.arg);\n  }\n }\n}\n\nvar __ATPRERUN__ = [];\n\nvar __ATINIT__ = [];\n\nvar __ATMAIN__ = [];\n\nvar __ATEXIT__ = [];\n\nvar __ATPOSTRUN__ = [];\n\nvar runtimeInitialized = false;\n\nvar runtimeExited = false;\n\nfunction preRun() {\n if (Module[\"preRun\"]) {\n  if (typeof Module[\"preRun\"] == \"function\") Module[\"preRun\"] = [ Module[\"preRun\"] ];\n  while (Module[\"preRun\"].length) {\n   addOnPreRun(Module[\"preRun\"].shift());\n  }\n }\n callRuntimeCallbacks(__ATPRERUN__);\n}\n\nfunction ensureInitRuntime() {\n if (runtimeInitialized) return;\n runtimeInitialized = true;\n callRuntimeCallbacks(__ATINIT__);\n}\n\nfunction preMain() {\n callRuntimeCallbacks(__ATMAIN__);\n}\n\nfunction exitRuntime() {\n callRuntimeCallbacks(__ATEXIT__);\n runtimeExited = true;\n}\n\nfunction postRun() {\n if (Module[\"postRun\"]) {\n  if (typeof Module[\"postRun\"] == \"function\") Module[\"postRun\"] = [ Module[\"postRun\"] ];\n  while (Module[\"postRun\"].length) {\n   addOnPostRun(Module[\"postRun\"].shift());\n  }\n }\n callRuntimeCallbacks(__ATPOSTRUN__);\n}\n\nfunction addOnPreRun(cb) {\n __ATPRERUN__.unshift(cb);\n}\n\nfunction addOnPostRun(cb) {\n __ATPOSTRUN__.unshift(cb);\n}\n\nvar Math_abs = Math.abs;\n\nvar Math_ceil = Math.ceil;\n\nvar Math_floor = Math.floor;\n\nvar Math_min = Math.min;\n\nvar runDependencies = 0;\n\nvar runDependencyWatcher = null;\n\nvar dependenciesFulfilled = null;\n\nfunction addRunDependency(id) {\n runDependencies++;\n if (Module[\"monitorRunDependencies\"]) {\n  Module[\"monitorRunDependencies\"](runDependencies);\n }\n}\n\nfunction removeRunDependency(id) {\n runDependencies--;\n if (Module[\"monitorRunDependencies\"]) {\n  Module[\"monitorRunDependencies\"](runDependencies);\n }\n if (runDependencies == 0) {\n  if (runDependencyWatcher !== null) {\n   clearInterval(runDependencyWatcher);\n   runDependencyWatcher = null;\n  }\n  if (dependenciesFulfilled) {\n   var callback = dependenciesFulfilled;\n   dependenciesFulfilled = null;\n   callback();\n  }\n }\n}\n\nModule[\"preloadedImages\"] = {};\n\nModule[\"preloadedAudios\"] = {};\n\nvar memoryInitializer = null;\n\nvar dataURIPrefix = \"data:application/octet-stream;base64,\";\n\nfunction isDataURI(filename) {\n return String.prototype.startsWith ? filename.startsWith(dataURIPrefix) : filename.indexOf(dataURIPrefix) === 0;\n}\n\n__ATINIT__.push({\n func: function() {\n  ___emscripten_environ_constructor();\n }\n});\n\nmemoryInitializer = \"data:application/octet-stream;base64,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\";\n\nvar tempDoublePtr = 16736;\n\nvar ENV = {};\n\nfunction ___buildEnvironment(environ) {\n var MAX_ENV_VALUES = 64;\n var TOTAL_ENV_SIZE = 1024;\n var poolPtr;\n var envPtr;\n if (!___buildEnvironment.called) {\n  ___buildEnvironment.called = true;\n  ENV[\"USER\"] = ENV[\"LOGNAME\"] = \"web_user\";\n  ENV[\"PATH\"] = \"/\";\n  ENV[\"PWD\"] = \"/\";\n  ENV[\"HOME\"] = \"/home/web_user\";\n  ENV[\"LANG\"] = \"C.UTF-8\";\n  ENV[\"_\"] = Module[\"thisProgram\"];\n  poolPtr = getMemory(TOTAL_ENV_SIZE);\n  envPtr = getMemory(MAX_ENV_VALUES * 4);\n  HEAP32[envPtr >> 2] = poolPtr;\n  HEAP32[environ >> 2] = envPtr;\n } else {\n  envPtr = HEAP32[environ >> 2];\n  poolPtr = HEAP32[envPtr >> 2];\n }\n var strings = [];\n var totalSize = 0;\n for (var key in ENV) {\n  if (typeof ENV[key] === \"string\") {\n   var line = key + \"=\" + ENV[key];\n   strings.push(line);\n   totalSize += line.length;\n  }\n }\n if (totalSize > TOTAL_ENV_SIZE) {\n  throw new Error(\"Environment size exceeded TOTAL_ENV_SIZE!\");\n }\n var ptrSize = 4;\n for (var i = 0; i < strings.length; i++) {\n  var line = strings[i];\n  writeAsciiToMemory(line, poolPtr);\n  HEAP32[envPtr + i * ptrSize >> 2] = poolPtr;\n  poolPtr += line.length + 1;\n }\n HEAP32[envPtr + strings.length * ptrSize >> 2] = 0;\n}\n\nfunction _emscripten_get_now() {\n abort();\n}\n\nfunction _emscripten_get_now_is_monotonic() {\n return ENVIRONMENT_IS_NODE || typeof dateNow !== \"undefined\" || (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) && self[\"performance\"] && self[\"performance\"][\"now\"];\n}\n\nfunction ___setErrNo(value) {\n if (Module[\"___errno_location\"]) HEAP32[Module[\"___errno_location\"]() >> 2] = value;\n return value;\n}\n\nfunction _clock_gettime(clk_id, tp) {\n var now;\n if (clk_id === 0) {\n  now = Date.now();\n } else if (clk_id === 1 && _emscripten_get_now_is_monotonic()) {\n  now = _emscripten_get_now();\n } else {\n  ___setErrNo(22);\n  return -1;\n }\n HEAP32[tp >> 2] = now / 1e3 | 0;\n HEAP32[tp + 4 >> 2] = now % 1e3 * 1e3 * 1e3 | 0;\n return 0;\n}\n\nfunction ___clock_gettime(a0, a1) {\n return _clock_gettime(a0, a1);\n}\n\nfunction ___lock() {}\n\nfunction ___map_file(pathname, size) {\n ___setErrNo(1);\n return -1;\n}\n\nvar SYSCALLS = {\n buffers: [ null, [], [] ],\n printChar: function(stream, curr) {\n  var buffer = SYSCALLS.buffers[stream];\n  if (curr === 0 || curr === 10) {\n   (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));\n   buffer.length = 0;\n  } else {\n   buffer.push(curr);\n  }\n },\n varargs: 0,\n get: function(varargs) {\n  SYSCALLS.varargs += 4;\n  var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];\n  return ret;\n },\n getStr: function() {\n  var ret = UTF8ToString(SYSCALLS.get());\n  return ret;\n },\n get64: function() {\n  var low = SYSCALLS.get(), high = SYSCALLS.get();\n  return low;\n },\n getZero: function() {\n  SYSCALLS.get();\n }\n};\n\nfunction ___syscall10(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var path = SYSCALLS.getStr();\n  FS.unlink(path);\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall140(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var stream = SYSCALLS.getStreamFromFD(), offset_high = SYSCALLS.get(), offset_low = SYSCALLS.get(), result = SYSCALLS.get(), whence = SYSCALLS.get();\n  var offset = offset_low;\n  FS.llseek(stream, offset, whence);\n  HEAP32[result >> 2] = stream.position;\n  if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall145(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var stream = SYSCALLS.getStreamFromFD(), iov = SYSCALLS.get(), iovcnt = SYSCALLS.get();\n  return SYSCALLS.doReadv(stream, iov, iovcnt);\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction flush_NO_FILESYSTEM() {\n var fflush = Module[\"_fflush\"];\n if (fflush) fflush(0);\n var buffers = SYSCALLS.buffers;\n if (buffers[1].length) SYSCALLS.printChar(1, 10);\n if (buffers[2].length) SYSCALLS.printChar(2, 10);\n}\n\nfunction ___syscall146(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var stream = SYSCALLS.get(), iov = SYSCALLS.get(), iovcnt = SYSCALLS.get();\n  var ret = 0;\n  for (var i = 0; i < iovcnt; i++) {\n   var ptr = HEAP32[iov + i * 8 >> 2];\n   var len = HEAP32[iov + (i * 8 + 4) >> 2];\n   for (var j = 0; j < len; j++) {\n    SYSCALLS.printChar(stream, HEAPU8[ptr + j]);\n   }\n   ret += len;\n  }\n  return ret;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall196(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var path = SYSCALLS.getStr(), buf = SYSCALLS.get();\n  return SYSCALLS.doStat(FS.lstat, path, buf);\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall221(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall330(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var old = SYSCALLS.getStreamFromFD(), suggestFD = SYSCALLS.get(), flags = SYSCALLS.get();\n  if (old.fd === suggestFD) return -ERRNO_CODES.EINVAL;\n  return SYSCALLS.doDup(old.path, old.flags, suggestFD);\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall38(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var old_path = SYSCALLS.getStr(), new_path = SYSCALLS.getStr();\n  FS.rename(old_path, new_path);\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall40(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var path = SYSCALLS.getStr();\n  FS.rmdir(path);\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall5(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var pathname = SYSCALLS.getStr(), flags = SYSCALLS.get(), mode = SYSCALLS.get();\n  var stream = FS.open(pathname, flags, mode);\n  return stream.fd;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall54(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall6(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var stream = SYSCALLS.getStreamFromFD();\n  FS.close(stream);\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall63(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var old = SYSCALLS.getStreamFromFD(), suggestFD = SYSCALLS.get();\n  if (old.fd === suggestFD) return suggestFD;\n  return SYSCALLS.doDup(old.path, old.flags, suggestFD);\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___syscall91(which, varargs) {\n SYSCALLS.varargs = varargs;\n try {\n  var addr = SYSCALLS.get(), len = SYSCALLS.get();\n  var info = SYSCALLS.mappings[addr];\n  if (!info) return 0;\n  if (len === info.len) {\n   var stream = FS.getStream(info.fd);\n   SYSCALLS.doMsync(addr, stream, len, info.flags);\n   FS.munmap(stream);\n   SYSCALLS.mappings[addr] = null;\n   if (info.allocated) {\n    _free(info.malloc);\n   }\n  }\n  return 0;\n } catch (e) {\n  if (typeof FS === \"undefined\" || !(e instanceof FS.ErrnoError)) abort(e);\n  return -e.errno;\n }\n}\n\nfunction ___unlock() {}\n\nfunction _abort() {\n Module[\"abort\"]();\n}\n\nfunction _clock() {\n if (_clock.start === undefined) _clock.start = Date.now();\n return (Date.now() - _clock.start) * (1e6 / 1e3) | 0;\n}\n\nfunction _difftime(time1, time0) {\n return time1 - time0;\n}\n\nfunction _emscripten_get_heap_size() {\n return TOTAL_MEMORY;\n}\n\nfunction abortOnCannotGrowMemory(requestedSize) {\n abort(\"Cannot enlarge memory arrays to size \" + requestedSize + \" bytes. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value \" + TOTAL_MEMORY + \", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or (4) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 \");\n}\n\nfunction emscripten_realloc_buffer(size) {\n try {\n  var newBuffer = new ArrayBuffer(size);\n  if (newBuffer.byteLength != size) return false;\n  new Int8Array(newBuffer).set(HEAP8);\n } catch (e) {\n  return false;\n }\n Module[\"_emscripten_replace_memory\"](newBuffer);\n HEAP8 = new Int8Array(newBuffer);\n HEAP16 = new Int16Array(newBuffer);\n HEAP32 = new Int32Array(newBuffer);\n HEAPU8 = new Uint8Array(newBuffer);\n HEAPU16 = new Uint16Array(newBuffer);\n HEAPU32 = new Uint32Array(newBuffer);\n HEAPF32 = new Float32Array(newBuffer);\n HEAPF64 = new Float64Array(newBuffer);\n buffer = newBuffer;\n return newBuffer;\n}\n\nfunction _emscripten_resize_heap(requestedSize) {\n var oldSize = _emscripten_get_heap_size();\n var PAGE_MULTIPLE = 16777216;\n var LIMIT = 2147483648 - PAGE_MULTIPLE;\n if (requestedSize > LIMIT) {\n  return false;\n }\n var MIN_TOTAL_MEMORY = 16777216;\n var newSize = Math.max(oldSize, MIN_TOTAL_MEMORY);\n while (newSize < requestedSize) {\n  if (newSize <= 536870912) {\n   newSize = alignUp(2 * newSize, PAGE_MULTIPLE);\n  } else {\n   newSize = Math.min(alignUp((3 * newSize + 2147483648) / 4, PAGE_MULTIPLE), LIMIT);\n  }\n }\n var replacement = emscripten_realloc_buffer(newSize);\n if (!replacement || replacement.byteLength != newSize) {\n  return false;\n }\n updateGlobalBuffer(replacement);\n updateGlobalBufferViews();\n TOTAL_MEMORY = newSize;\n HEAPU32[DYNAMICTOP_PTR >> 2] = requestedSize;\n return true;\n}\n\nfunction _emscripten_run_script_int(ptr) {\n return eval(UTF8ToString(ptr)) | 0;\n}\n\nfunction _emscripten_run_script_string(ptr) {\n var s = eval(UTF8ToString(ptr)) + \"\";\n var me = _emscripten_run_script_string;\n var len = lengthBytesUTF8(s);\n if (!me.bufferSize || me.bufferSize < len + 1) {\n  if (me.bufferSize) _free(me.buffer);\n  me.bufferSize = len + 1;\n  me.buffer = _malloc(me.bufferSize);\n }\n stringToUTF8(s, me.buffer, me.bufferSize);\n return me.buffer;\n}\n\nfunction _exit(status) {\n exit(status);\n}\n\nfunction _getenv(name) {\n if (name === 0) return 0;\n name = UTF8ToString(name);\n if (!ENV.hasOwnProperty(name)) return 0;\n if (_getenv.ret) _free(_getenv.ret);\n _getenv.ret = allocateUTF8(ENV[name]);\n return _getenv.ret;\n}\n\nvar ___tm_current = 16592;\n\nvar ___tm_timezone = (stringToUTF8(\"GMT\", 16640, 4), 16640);\n\nfunction _gmtime_r(time, tmPtr) {\n var date = new Date(HEAP32[time >> 2] * 1e3);\n HEAP32[tmPtr >> 2] = date.getUTCSeconds();\n HEAP32[tmPtr + 4 >> 2] = date.getUTCMinutes();\n HEAP32[tmPtr + 8 >> 2] = date.getUTCHours();\n HEAP32[tmPtr + 12 >> 2] = date.getUTCDate();\n HEAP32[tmPtr + 16 >> 2] = date.getUTCMonth();\n HEAP32[tmPtr + 20 >> 2] = date.getUTCFullYear() - 1900;\n HEAP32[tmPtr + 24 >> 2] = date.getUTCDay();\n HEAP32[tmPtr + 36 >> 2] = 0;\n HEAP32[tmPtr + 32 >> 2] = 0;\n var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);\n var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;\n HEAP32[tmPtr + 28 >> 2] = yday;\n HEAP32[tmPtr + 40 >> 2] = ___tm_timezone;\n return tmPtr;\n}\n\nfunction _gmtime(time) {\n return _gmtime_r(time, ___tm_current);\n}\n\nfunction _llvm_log10_f32(x) {\n return Math.log(x) / Math.LN10;\n}\n\nfunction _llvm_log10_f64(a0) {\n return _llvm_log10_f32(a0);\n}\n\nfunction _tzset() {\n if (_tzset.called) return;\n _tzset.called = true;\n HEAP32[__get_timezone() >> 2] = new Date().getTimezoneOffset() * 60;\n var winter = new Date(2e3, 0, 1);\n var summer = new Date(2e3, 6, 1);\n HEAP32[__get_daylight() >> 2] = Number(winter.getTimezoneOffset() != summer.getTimezoneOffset());\n function extractZone(date) {\n  var match = date.toTimeString().match(/\\(([A-Za-z ]+)\\)$/);\n  return match ? match[1] : \"GMT\";\n }\n var winterName = extractZone(winter);\n var summerName = extractZone(summer);\n var winterNamePtr = allocate(intArrayFromString(winterName), \"i8\", ALLOC_NORMAL);\n var summerNamePtr = allocate(intArrayFromString(summerName), \"i8\", ALLOC_NORMAL);\n if (summer.getTimezoneOffset() < winter.getTimezoneOffset()) {\n  HEAP32[__get_tzname() >> 2] = winterNamePtr;\n  HEAP32[__get_tzname() + 4 >> 2] = summerNamePtr;\n } else {\n  HEAP32[__get_tzname() >> 2] = summerNamePtr;\n  HEAP32[__get_tzname() + 4 >> 2] = winterNamePtr;\n }\n}\n\nfunction _localtime_r(time, tmPtr) {\n _tzset();\n var date = new Date(HEAP32[time >> 2] * 1e3);\n HEAP32[tmPtr >> 2] = date.getSeconds();\n HEAP32[tmPtr + 4 >> 2] = date.getMinutes();\n HEAP32[tmPtr + 8 >> 2] = date.getHours();\n HEAP32[tmPtr + 12 >> 2] = date.getDate();\n HEAP32[tmPtr + 16 >> 2] = date.getMonth();\n HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;\n HEAP32[tmPtr + 24 >> 2] = date.getDay();\n var start = new Date(date.getFullYear(), 0, 1);\n var yday = (date.getTime() - start.getTime()) / (1e3 * 60 * 60 * 24) | 0;\n HEAP32[tmPtr + 28 >> 2] = yday;\n HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);\n var summerOffset = new Date(2e3, 6, 1).getTimezoneOffset();\n var winterOffset = start.getTimezoneOffset();\n var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;\n HEAP32[tmPtr + 32 >> 2] = dst;\n var zonePtr = HEAP32[__get_tzname() + (dst ? 4 : 0) >> 2];\n HEAP32[tmPtr + 40 >> 2] = zonePtr;\n return tmPtr;\n}\n\nfunction _localtime(time) {\n return _localtime_r(time, ___tm_current);\n}\n\nfunction _longjmp(env, value) {\n _setThrew(env, value || 1);\n throw \"longjmp\";\n}\n\nfunction _emscripten_memcpy_big(dest, src, num) {\n HEAPU8.set(HEAPU8.subarray(src, src + num), dest);\n}\n\nfunction _mktime(tmPtr) {\n _tzset();\n var date = new Date(HEAP32[tmPtr + 20 >> 2] + 1900, HEAP32[tmPtr + 16 >> 2], HEAP32[tmPtr + 12 >> 2], HEAP32[tmPtr + 8 >> 2], HEAP32[tmPtr + 4 >> 2], HEAP32[tmPtr >> 2], 0);\n var dst = HEAP32[tmPtr + 32 >> 2];\n var guessedOffset = date.getTimezoneOffset();\n var start = new Date(date.getFullYear(), 0, 1);\n var summerOffset = new Date(2e3, 6, 1).getTimezoneOffset();\n var winterOffset = start.getTimezoneOffset();\n var dstOffset = Math.min(winterOffset, summerOffset);\n if (dst < 0) {\n  HEAP32[tmPtr + 32 >> 2] = Number(summerOffset != winterOffset && dstOffset == guessedOffset);\n } else if (dst > 0 != (dstOffset == guessedOffset)) {\n  var nonDstOffset = Math.max(winterOffset, summerOffset);\n  var trueOffset = dst > 0 ? dstOffset : nonDstOffset;\n  date.setTime(date.getTime() + (trueOffset - guessedOffset) * 6e4);\n }\n HEAP32[tmPtr + 24 >> 2] = date.getDay();\n var yday = (date.getTime() - start.getTime()) / (1e3 * 60 * 60 * 24) | 0;\n HEAP32[tmPtr + 28 >> 2] = yday;\n return date.getTime() / 1e3 | 0;\n}\n\nfunction __isLeapYear(year) {\n return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);\n}\n\nfunction __arraySum(array, index) {\n var sum = 0;\n for (var i = 0; i <= index; sum += array[i++]) ;\n return sum;\n}\n\nvar __MONTH_DAYS_LEAP = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];\n\nvar __MONTH_DAYS_REGULAR = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];\n\nfunction __addDays(date, days) {\n var newDate = new Date(date.getTime());\n while (days > 0) {\n  var leap = __isLeapYear(newDate.getFullYear());\n  var currentMonth = newDate.getMonth();\n  var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];\n  if (days > daysInCurrentMonth - newDate.getDate()) {\n   days -= daysInCurrentMonth - newDate.getDate() + 1;\n   newDate.setDate(1);\n   if (currentMonth < 11) {\n    newDate.setMonth(currentMonth + 1);\n   } else {\n    newDate.setMonth(0);\n    newDate.setFullYear(newDate.getFullYear() + 1);\n   }\n  } else {\n   newDate.setDate(newDate.getDate() + days);\n   return newDate;\n  }\n }\n return newDate;\n}\n\nfunction _strftime(s, maxsize, format, tm) {\n var tm_zone = HEAP32[tm + 40 >> 2];\n var date = {\n  tm_sec: HEAP32[tm >> 2],\n  tm_min: HEAP32[tm + 4 >> 2],\n  tm_hour: HEAP32[tm + 8 >> 2],\n  tm_mday: HEAP32[tm + 12 >> 2],\n  tm_mon: HEAP32[tm + 16 >> 2],\n  tm_year: HEAP32[tm + 20 >> 2],\n  tm_wday: HEAP32[tm + 24 >> 2],\n  tm_yday: HEAP32[tm + 28 >> 2],\n  tm_isdst: HEAP32[tm + 32 >> 2],\n  tm_gmtoff: HEAP32[tm + 36 >> 2],\n  tm_zone: tm_zone ? UTF8ToString(tm_zone) : \"\"\n };\n var pattern = UTF8ToString(format);\n var EXPANSION_RULES_1 = {\n  \"%c\": \"%a %b %d %H:%M:%S %Y\",\n  \"%D\": \"%m/%d/%y\",\n  \"%F\": \"%Y-%m-%d\",\n  \"%h\": \"%b\",\n  \"%r\": \"%I:%M:%S %p\",\n  \"%R\": \"%H:%M\",\n  \"%T\": \"%H:%M:%S\",\n  \"%x\": \"%m/%d/%y\",\n  \"%X\": \"%H:%M:%S\"\n };\n for (var rule in EXPANSION_RULES_1) {\n  pattern = pattern.replace(new RegExp(rule, \"g\"), EXPANSION_RULES_1[rule]);\n }\n var WEEKDAYS = [ \"Sunday\", \"Monday\", \"Tuesday\", \"Wednesday\", \"Thursday\", \"Friday\", \"Saturday\" ];\n var MONTHS = [ \"January\", \"February\", \"March\", \"April\", \"May\", \"June\", \"July\", \"August\", \"September\", \"October\", \"November\", \"December\" ];\n function leadingSomething(value, digits, character) {\n  var str = typeof value === \"number\" ? value.toString() : value || \"\";\n  while (str.length < digits) {\n   str = character[0] + str;\n  }\n  return str;\n }\n function leadingNulls(value, digits) {\n  return leadingSomething(value, digits, \"0\");\n }\n function compareByDay(date1, date2) {\n  function sgn(value) {\n   return value < 0 ? -1 : value > 0 ? 1 : 0;\n  }\n  var compare;\n  if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {\n   if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {\n    compare = sgn(date1.getDate() - date2.getDate());\n   }\n  }\n  return compare;\n }\n function getFirstWeekStartDate(janFourth) {\n  switch (janFourth.getDay()) {\n  case 0:\n   return new Date(janFourth.getFullYear() - 1, 11, 29);\n\n  case 1:\n   return janFourth;\n\n  case 2:\n   return new Date(janFourth.getFullYear(), 0, 3);\n\n  case 3:\n   return new Date(janFourth.getFullYear(), 0, 2);\n\n  case 4:\n   return new Date(janFourth.getFullYear(), 0, 1);\n\n  case 5:\n   return new Date(janFourth.getFullYear() - 1, 11, 31);\n\n  case 6:\n   return new Date(janFourth.getFullYear() - 1, 11, 30);\n  }\n }\n function getWeekBasedYear(date) {\n  var thisDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);\n  var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);\n  var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);\n  var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);\n  var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);\n  if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {\n   if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {\n    return thisDate.getFullYear() + 1;\n   } else {\n    return thisDate.getFullYear();\n   }\n  } else {\n   return thisDate.getFullYear() - 1;\n  }\n }\n var EXPANSION_RULES_2 = {\n  \"%a\": function(date) {\n   return WEEKDAYS[date.tm_wday].substring(0, 3);\n  },\n  \"%A\": function(date) {\n   return WEEKDAYS[date.tm_wday];\n  },\n  \"%b\": function(date) {\n   return MONTHS[date.tm_mon].substring(0, 3);\n  },\n  \"%B\": function(date) {\n   return MONTHS[date.tm_mon];\n  },\n  \"%C\": function(date) {\n   var year = date.tm_year + 1900;\n   return leadingNulls(year / 100 | 0, 2);\n  },\n  \"%d\": function(date) {\n   return leadingNulls(date.tm_mday, 2);\n  },\n  \"%e\": function(date) {\n   return leadingSomething(date.tm_mday, 2, \" \");\n  },\n  \"%g\": function(date) {\n   return getWeekBasedYear(date).toString().substring(2);\n  },\n  \"%G\": function(date) {\n   return getWeekBasedYear(date);\n  },\n  \"%H\": function(date) {\n   return leadingNulls(date.tm_hour, 2);\n  },\n  \"%I\": function(date) {\n   var twelveHour = date.tm_hour;\n   if (twelveHour == 0) twelveHour = 12; else if (twelveHour > 12) twelveHour -= 12;\n   return leadingNulls(twelveHour, 2);\n  },\n  \"%j\": function(date) {\n   return leadingNulls(date.tm_mday + __arraySum(__isLeapYear(date.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);\n  },\n  \"%m\": function(date) {\n   return leadingNulls(date.tm_mon + 1, 2);\n  },\n  \"%M\": function(date) {\n   return leadingNulls(date.tm_min, 2);\n  },\n  \"%n\": function() {\n   return \"\\n\";\n  },\n  \"%p\": function(date) {\n   if (date.tm_hour >= 0 && date.tm_hour < 12) {\n    return \"AM\";\n   } else {\n    return \"PM\";\n   }\n  },\n  \"%S\": function(date) {\n   return leadingNulls(date.tm_sec, 2);\n  },\n  \"%t\": function() {\n   return \"\\t\";\n  },\n  \"%u\": function(date) {\n   var day = new Date(date.tm_year + 1900, date.tm_mon + 1, date.tm_mday, 0, 0, 0, 0);\n   return day.getDay() || 7;\n  },\n  \"%U\": function(date) {\n   var janFirst = new Date(date.tm_year + 1900, 0, 1);\n   var firstSunday = janFirst.getDay() === 0 ? janFirst : __addDays(janFirst, 7 - janFirst.getDay());\n   var endDate = new Date(date.tm_year + 1900, date.tm_mon, date.tm_mday);\n   if (compareByDay(firstSunday, endDate) < 0) {\n    var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth() - 1) - 31;\n    var firstSundayUntilEndJanuary = 31 - firstSunday.getDate();\n    var days = firstSundayUntilEndJanuary + februaryFirstUntilEndMonth + endDate.getDate();\n    return leadingNulls(Math.ceil(days / 7), 2);\n   }\n   return compareByDay(firstSunday, janFirst) === 0 ? \"01\" : \"00\";\n  },\n  \"%V\": function(date) {\n   var janFourthThisYear = new Date(date.tm_year + 1900, 0, 4);\n   var janFourthNextYear = new Date(date.tm_year + 1901, 0, 4);\n   var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);\n   var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);\n   var endDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);\n   if (compareByDay(endDate, firstWeekStartThisYear) < 0) {\n    return \"53\";\n   }\n   if (compareByDay(firstWeekStartNextYear, endDate) <= 0) {\n    return \"01\";\n   }\n   var daysDifference;\n   if (firstWeekStartThisYear.getFullYear() < date.tm_year + 1900) {\n    daysDifference = date.tm_yday + 32 - firstWeekStartThisYear.getDate();\n   } else {\n    daysDifference = date.tm_yday + 1 - firstWeekStartThisYear.getDate();\n   }\n   return leadingNulls(Math.ceil(daysDifference / 7), 2);\n  },\n  \"%w\": function(date) {\n   var day = new Date(date.tm_year + 1900, date.tm_mon + 1, date.tm_mday, 0, 0, 0, 0);\n   return day.getDay();\n  },\n  \"%W\": function(date) {\n   var janFirst = new Date(date.tm_year, 0, 1);\n   var firstMonday = janFirst.getDay() === 1 ? janFirst : __addDays(janFirst, janFirst.getDay() === 0 ? 1 : 7 - janFirst.getDay() + 1);\n   var endDate = new Date(date.tm_year + 1900, date.tm_mon, date.tm_mday);\n   if (compareByDay(firstMonday, endDate) < 0) {\n    var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth() - 1) - 31;\n    var firstMondayUntilEndJanuary = 31 - firstMonday.getDate();\n    var days = firstMondayUntilEndJanuary + februaryFirstUntilEndMonth + endDate.getDate();\n    return leadingNulls(Math.ceil(days / 7), 2);\n   }\n   return compareByDay(firstMonday, janFirst) === 0 ? \"01\" : \"00\";\n  },\n  \"%y\": function(date) {\n   return (date.tm_year + 1900).toString().substring(2);\n  },\n  \"%Y\": function(date) {\n   return date.tm_year + 1900;\n  },\n  \"%z\": function(date) {\n   var off = date.tm_gmtoff;\n   var ahead = off >= 0;\n   off = Math.abs(off) / 60;\n   off = off / 60 * 100 + off % 60;\n   return (ahead ? \"+\" : \"-\") + String(\"0000\" + off).slice(-4);\n  },\n  \"%Z\": function(date) {\n   return date.tm_zone;\n  },\n  \"%%\": function() {\n   return \"%\";\n  }\n };\n for (var rule in EXPANSION_RULES_2) {\n  if (pattern.indexOf(rule) >= 0) {\n   pattern = pattern.replace(new RegExp(rule, \"g\"), EXPANSION_RULES_2[rule](date));\n  }\n }\n var bytes = intArrayFromString(pattern, false);\n if (bytes.length > maxsize) {\n  return 0;\n }\n writeArrayToMemory(bytes, s);\n return bytes.length - 1;\n}\n\nfunction _system(command) {\n ___setErrNo(11);\n return -1;\n}\n\nfunction _time(ptr) {\n var ret = Date.now() / 1e3 | 0;\n if (ptr) {\n  HEAP32[ptr >> 2] = ret;\n }\n return ret;\n}\n\nif (typeof dateNow !== \"undefined\") {\n _emscripten_get_now = dateNow;\n} else if (typeof self === \"object\" && self[\"performance\"] && typeof self[\"performance\"][\"now\"] === \"function\") {\n _emscripten_get_now = function() {\n  return self[\"performance\"][\"now\"]();\n };\n} else if (typeof performance === \"object\" && typeof performance[\"now\"] === \"function\") {\n _emscripten_get_now = function() {\n  return performance[\"now\"]();\n };\n} else {\n _emscripten_get_now = Date.now;\n}\n\nvar ASSERTIONS = false;\n\nfunction intArrayFromString(stringy, dontAddNull, length) {\n var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;\n var u8array = new Array(len);\n var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);\n if (dontAddNull) u8array.length = numBytesWritten;\n return u8array;\n}\n\nfunction intArrayToString(array) {\n var ret = [];\n for (var i = 0; i < array.length; i++) {\n  var chr = array[i];\n  if (chr > 255) {\n   if (ASSERTIONS) {\n    assert(false, \"Character code \" + chr + \" (\" + String.fromCharCode(chr) + \")  at offset \" + i + \" not in 0x00-0xFF.\");\n   }\n   chr &= 255;\n  }\n  ret.push(String.fromCharCode(chr));\n }\n return ret.join(\"\");\n}\n\nvar decodeBase64 = typeof atob === \"function\" ? atob : function(input) {\n var keyStr = \"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\";\n var output = \"\";\n var chr1, chr2, chr3;\n var enc1, enc2, enc3, enc4;\n var i = 0;\n input = input.replace(/[^A-Za-z0-9\\+\\/\\=]/g, \"\");\n do {\n  enc1 = keyStr.indexOf(input.charAt(i++));\n  enc2 = keyStr.indexOf(input.charAt(i++));\n  enc3 = keyStr.indexOf(input.charAt(i++));\n  enc4 = keyStr.indexOf(input.charAt(i++));\n  chr1 = enc1 << 2 | enc2 >> 4;\n  chr2 = (enc2 & 15) << 4 | enc3 >> 2;\n  chr3 = (enc3 & 3) << 6 | enc4;\n  output = output + String.fromCharCode(chr1);\n  if (enc3 !== 64) {\n   output = output + String.fromCharCode(chr2);\n  }\n  if (enc4 !== 64) {\n   output = output + String.fromCharCode(chr3);\n  }\n } while (i < input.length);\n return output;\n};\n\nfunction intArrayFromBase64(s) {\n try {\n  var decoded = decodeBase64(s);\n  var bytes = new Uint8Array(decoded.length);\n  for (var i = 0; i < decoded.length; ++i) {\n   bytes[i] = decoded.charCodeAt(i);\n  }\n  return bytes;\n } catch (_) {\n  throw new Error(\"Converting base64 string to bytes failed.\");\n }\n}\n\nfunction tryParseAsDataURI(filename) {\n if (!isDataURI(filename)) {\n  return;\n }\n return intArrayFromBase64(filename.slice(dataURIPrefix.length));\n}\n\nfunction invoke_vii(index, a1, a2) {\n var sp = stackSave();\n try {\n  dynCall_vii(index, a1, a2);\n } catch (e) {\n  stackRestore(sp);\n  if (e !== e + 0 && e !== \"longjmp\") throw e;\n  _setThrew(1, 0);\n }\n}\n\nfunction jsCall_ii(index, a1) {\n return functionPointers[index](a1);\n}\n\nfunction jsCall_iii(index, a1, a2) {\n return functionPointers[index](a1, a2);\n}\n\nfunction jsCall_iiii(index, a1, a2, a3) {\n return functionPointers[index](a1, a2, a3);\n}\n\nfunction jsCall_iiiii(index, a1, a2, a3, a4) {\n return functionPointers[index](a1, a2, a3, a4);\n}\n\nfunction jsCall_vii(index, a1, a2) {\n functionPointers[index](a1, a2);\n}\n\nvar asmGlobalArg = {\n \"Math\": Math,\n \"Int8Array\": Int8Array,\n \"Int16Array\": Int16Array,\n \"Int32Array\": Int32Array,\n \"Uint8Array\": Uint8Array,\n \"Uint16Array\": Uint16Array,\n \"Float32Array\": Float32Array,\n \"Float64Array\": Float64Array,\n \"NaN\": NaN,\n Infinity: Infinity\n};\n\nvar asmLibraryArg = {\n \"a\": abort,\n \"b\": setTempRet0,\n \"c\": getTempRet0,\n \"d\": invoke_vii,\n \"e\": jsCall_ii,\n \"f\": jsCall_iii,\n \"g\": jsCall_iiii,\n \"h\": jsCall_iiiii,\n \"i\": jsCall_vii,\n \"j\": ___buildEnvironment,\n \"k\": ___clock_gettime,\n \"l\": ___lock,\n \"m\": ___map_file,\n \"n\": ___setErrNo,\n \"o\": ___syscall10,\n \"p\": ___syscall140,\n \"q\": ___syscall145,\n \"r\": ___syscall146,\n \"s\": ___syscall196,\n \"t\": ___syscall221,\n \"u\": ___syscall330,\n \"v\": ___syscall38,\n \"w\": ___syscall40,\n \"x\": ___syscall5,\n \"y\": ___syscall54,\n \"z\": ___syscall6,\n \"A\": ___syscall63,\n \"B\": ___syscall91,\n \"C\": ___unlock,\n \"D\": __addDays,\n \"E\": __arraySum,\n \"F\": __isLeapYear,\n \"G\": _abort,\n \"H\": _clock,\n \"I\": _clock_gettime,\n \"J\": _difftime,\n \"K\": _emscripten_get_heap_size,\n \"L\": _emscripten_get_now,\n \"M\": _emscripten_get_now_is_monotonic,\n \"N\": _emscripten_memcpy_big,\n \"O\": _emscripten_resize_heap,\n \"P\": _emscripten_run_script_int,\n \"Q\": _emscripten_run_script_string,\n \"R\": _exit,\n \"S\": _getenv,\n \"T\": _gmtime,\n \"U\": _gmtime_r,\n \"V\": _llvm_log10_f32,\n \"W\": _llvm_log10_f64,\n \"X\": _localtime,\n \"Y\": _localtime_r,\n \"Z\": _longjmp,\n \"_\": _mktime,\n \"$\": _strftime,\n \"aa\": _system,\n \"ab\": _time,\n \"ac\": _tzset,\n \"ad\": abortOnCannotGrowMemory,\n \"ae\": emscripten_realloc_buffer,\n \"af\": flush_NO_FILESYSTEM,\n \"ag\": tempDoublePtr,\n \"ah\": DYNAMICTOP_PTR\n};\n\n// EMSCRIPTEN_START_ASM\n\n\nvar asm = (/** @suppress {uselessCode} */ function(global,env,buffer) {\n\"almost asm\";var a=new global.Int8Array(buffer),b=new global.Int16Array(buffer),c=new global.Int32Array(buffer),d=new global.Uint8Array(buffer),e=new global.Uint16Array(buffer),f=new global.Float32Array(buffer),g=new global.Float64Array(buffer),h=env.ag|0,i=env.ah|0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0.0,r=global.NaN,s=global.Infinity,t=global.Math.floor,u=global.Math.abs,v=global.Math.sqrt,w=global.Math.pow,x=global.Math.cos,y=global.Math.sin,z=global.Math.tan,A=global.Math.acos,B=global.Math.asin,C=global.Math.atan,D=global.Math.atan2,E=global.Math.exp,F=global.Math.log,G=global.Math.ceil,H=global.Math.imul,I=global.Math.clz32,J=env.a,K=env.b,L=env.c,M=env.d,N=env.e,O=env.f,P=env.g,Q=env.h,R=env.i,S=env.j,T=env.k,U=env.l,V=env.m,W=env.n,X=env.o,Y=env.p,Z=env.q,_=env.r,$=env.s,aa=env.t,ba=env.u,ca=env.v,da=env.w,ea=env.x,fa=env.y,ga=env.z,ha=env.A,ia=env.B,ja=env.C,ka=env.D,la=env.E,ma=env.F,na=env.G,oa=env.H,pa=env.I,qa=env.J,ra=env.K,sa=env.L,ta=env.M,ua=env.N,va=env.O,wa=env.P,xa=env.Q,ya=env.R,za=env.S,Aa=env.T,Ba=env.U,Ca=env.V,Da=env.W,Ea=env.X,Fa=env.Y,Ga=env.Z,Ha=env._,Ia=env.$,Ja=env.aa,Ka=env.ab,La=env.ac,Ma=env.ad,Na=env.ae,Oa=env.af,Pa=16752,Qa=5259632,Ra=0.0;function Sa(newBuffer){a=new Int8Array(newBuffer);d=new Uint8Array(newBuffer);b=new Int16Array(newBuffer);e=new Uint16Array(newBuffer);c=new Int32Array(newBuffer);f=new Float32Array(newBuffer);g=new Float64Array(newBuffer);buffer=newBuffer;return true}\n// EMSCRIPTEN_START_FUNCS\nfunction Ee(b,e){b=b|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0;f=Pa;Pa=Pa+16|0;h=f;switch(c[e+8>>2]&63){case 3:{g[h>>3]=+g[e>>3]+1.0;i=(c[h+4>>2]|0)+(c[h>>2]|0)|0;h=0-i|0;j=(c[b+16>>2]|0)+(((((i|0)<0?((i|0)==(h|0)?0:h):i)|0)%((1<<d[b+7>>0])+-1|1|0)|0)<<5)|0;Pa=f;return j|0}case 20:{i=c[e>>2]|0;h=i+6|0;if(!(a[h>>0]|0)){k=i+8|0;l=ye(i+16|0,c[i+12>>2]|0,c[k>>2]|0)|0;c[k>>2]=l;a[h>>0]=1;m=c[e>>2]|0}else m=i;j=(c[b+16>>2]|0)+(((1<<d[b+7>>0])+-1&c[m+8>>2])<<5)|0;Pa=f;return j|0}case 4:{j=(c[b+16>>2]|0)+(((1<<d[b+7>>0])+-1&c[(c[e>>2]|0)+8>>2])<<5)|0;Pa=f;return j|0}case 1:{j=(c[b+16>>2]|0)+(((1<<d[b+7>>0])+-1&c[e>>2])<<5)|0;Pa=f;return j|0}case 2:{j=(c[b+16>>2]|0)+((((c[e>>2]|0)>>>0)%(((1<<d[b+7>>0])+-1|1)>>>0)|0)<<5)|0;Pa=f;return j|0}case 22:{j=(c[b+16>>2]|0)+((((c[e>>2]|0)>>>0)%(((1<<d[b+7>>0])+-1|1)>>>0)|0)<<5)|0;Pa=f;return j|0}default:{j=(c[b+16>>2]|0)+((((c[e>>2]|0)>>>0)%(((1<<d[b+7>>0])+-1|1)>>>0)|0)<<5)|0;Pa=f;return j|0}}return 0}function Fe(b,e,f,h){b=b|0;e=e|0;f=f|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0.0,C=0,D=0,E=0.0,F=0,G=0,H=0;i=Pa;Pa=Pa+32|0;j=i+16|0;k=i;l=e+28|0;m=c[l>>2]|0;n=e+7|0;o=a[n>>0]|0;p=o&255;q=e+16|0;r=c[q>>2]|0;if((m|0)<(f|0)){if((f+1|0)>>>0>268435455)Gd(b);s=e+12|0;t=Hd(b,c[s>>2]|0,m<<4,f<<4)|0;c[s>>2]=t;s=c[l>>2]|0;if((s|0)<(f|0)){u=s;do{c[t+(u<<4)+8>>2]=0;u=u+1|0}while((u|0)!=(f|0))}c[l>>2]=f}if(!h){c[q>>2]=15808;v=0;w=0;x=15808}else{u=Kd(h)|0;if((u|0)>30)Dc(b,7598,j);j=1<<u;if((j+1|0)>>>0>134217727)Gd(b);h=Hd(b,0,0,j<<5)|0;c[q>>2]=h;t=0;s=h;do{c[s+(t<<5)+28>>2]=0;c[s+(t<<5)+24>>2]=0;c[s+(t<<5)+8>>2]=0;t=t+1|0;s=c[q>>2]|0}while((t|0)<(j|0));v=j;w=u&255;x=s}a[n>>0]=w;c[e+20>>2]=x+(v<<5);do if((m|0)>(f|0)){c[l>>2]=f;v=e+12|0;x=k+8|0;w=k+4|0;s=f;while(1){u=c[v>>2]|0;j=u+(s<<4)+8|0;if(!(c[j>>2]|0))y=s+1|0;else{t=u+(s<<4)|0;u=s+1|0;a:do if(s>>>0<(c[l>>2]|0)>>>0){z=t;A=27}else{B=+(u|0);g[k>>3]=B+1.0;h=(c[w>>2]|0)+(c[k>>2]|0)|0;C=0-h|0;D=(c[q>>2]|0)+(((((h|0)<0?((h|0)==(C|0)?0:C):h)|0)%((1<<(d[n>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[D+24>>2]|0)==3?+g[D+16>>3]==B:0)break;h=c[D+28>>2]|0;if(!h){E=B;A=29;break a}else D=h}z=D;A=27}while(0);if((A|0)==27){A=0;if((z|0)==15792){E=+(u|0);A=29}else F=z}if((A|0)==29){A=0;g[k>>3]=E;c[x>>2]=3;F=Ge(b,e,k)|0}h=t;C=c[h+4>>2]|0;G=F;c[G>>2]=c[h>>2];c[G+4>>2]=C;c[F+8>>2]=c[j>>2];y=u}if((y|0)==(m|0))break;else s=y}if((f+1|0)>>>0>268435455)Gd(b);else{s=Hd(b,c[v>>2]|0,m<<4,f<<4)|0;c[v>>2]=s;break}}while(0);f=1<<p;if(o<<24>>24!=31){o=f;do{p=o;o=o+-1|0;m=r+(o<<5)+8|0;if(c[m>>2]|0){y=r+(o<<5)+16|0;F=He(e,y)|0;if((F|0)==15792)H=Ge(b,e,y)|0;else H=F;F=r+(o<<5)|0;y=c[F+4>>2]|0;k=H;c[k>>2]=c[F>>2];c[k+4>>2]=y;c[H+8>>2]=c[m>>2]}}while((p|0)>1)}if((r|0)==15808){Pa=i;return}Hd(b,r,f<<5,0)|0;Pa=i;return}function Ge(b,e,f){b=b|0;e=e|0;f=f|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0.0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0;h=Pa;Pa=Pa+160|0;i=h+144|0;j=h+128|0;k=h;l=f+8|0;switch(c[l>>2]|0){case 0:{Dc(b,7613,h+136|0);break}case 3:{m=3;break}default:{}}if((m|0)==3?(n=+g[f>>3],!(n==n&0.0==0.0)):0)Dc(b,7632,i);i=Ee(e,f)|0;m=i+8|0;a:do if((i|0)==15808|(c[m>>2]|0)!=0){o=e+20|0;p=c[o>>2]|0;q=e+16|0;r=c[q>>2]|0;b:do if(p>>>0>r>>>0){s=p;while(1){t=s+-32|0;c[o>>2]=t;if(!(c[s+-8>>2]|0))break;if(t>>>0>r>>>0)s=t;else break b}u=Ee(e,i+16|0)|0;if((u|0)==(i|0)){v=i+28|0;c[s+-4>>2]=c[v>>2];c[v>>2]=t;w=t;break a}v=u;while(1){u=c[v+28>>2]|0;if((u|0)==(i|0))break;else v=u}c[v+28>>2]=t;c[t>>2]=c[i>>2];c[t+4>>2]=c[i+4>>2];c[t+8>>2]=c[i+8>>2];c[t+12>>2]=c[i+12>>2];c[t+16>>2]=c[i+16>>2];c[t+20>>2]=c[i+20>>2];c[t+24>>2]=c[i+24>>2];c[t+28>>2]=c[i+28>>2];c[i+28>>2]=0;c[m>>2]=0;w=i;break a}while(0);o=k;p=o+124|0;do{c[o>>2]=0;o=o+4|0}while((o|0)<(p|0));o=e+12|0;p=c[e+28>>2]|0;s=1;u=0;x=1;y=0;while(1){if((x|0)>(p|0))if((s|0)>(p|0)){z=u;break}else A=p;else A=x;if((s|0)>(A|0)){B=0;C=s}else{D=c[o>>2]|0;E=0;F=s;while(1){G=E+((c[D+(F+-1<<4)+8>>2]|0)!=0&1)|0;H=F+1|0;if((F|0)<(A|0)){E=G;F=H}else{B=G;C=H;break}}}F=k+(y<<2)|0;c[F>>2]=(c[F>>2]|0)+B;F=B+u|0;y=y+1|0;if(y>>>0>=31){z=F;break}else{s=C;u=F;x=x<<1}}x=0;u=0;s=1<<(d[e+7>>0]|0);y=r;while(1){o=s+-1|0;if(!(c[y+(o<<5)+8>>2]|0)){I=u;J=x}else{if((c[y+(o<<5)+24>>2]|0)==3?(n=+g[y+(o<<5)+16>>3],g[j>>3]=n+6755399441055744.0,p=c[j>>2]|0,n==+(p|0)&(p+-1|0)>>>0<1073741824):0){F=k+((Kd(p)|0)<<2)|0;c[F>>2]=(c[F>>2]|0)+1;K=1}else K=0;I=u+1|0;J=K+x|0}if(!o)break;x=J;u=I;s=o;y=c[q>>2]|0}q=J+z|0;if((c[l>>2]|0)==3?(n=+g[f>>3],g[j>>3]=n+6755399441055744.0,y=c[j>>2]|0,n==+(y|0)&(y+-1|0)>>>0<1073741824):0){s=k+((Kd(y)|0)<<2)|0;c[s>>2]=(c[s>>2]|0)+1;L=1}else L=0;s=q+L|0;c:do if((s|0)>0){q=0;y=0;u=1;x=0;r=0;o=0;while(1){F=c[k+(x<<2)>>2]|0;p=(F|0)>0;E=F+y|0;y=p?E:y;F=p&(E|0)>(o|0);p=F?E:q;E=F?u:r;if((y|0)==(s|0)){M=E;N=p;break c}o=u&2147483647;if((o|0)>=(s|0)){M=E;N=p;break}else{q=p;u=u<<1;x=x+1|0;r=E}}}else{M=0;N=0}while(0);Fe(b,e,M,z+1+I-N|0);s=He(e,f)|0;if((s|0)!=15792){O=s;Pa=h;return O|0}O=Ge(b,e,f)|0;Pa=h;return O|0}else w=i;while(0);i=f;N=c[i+4>>2]|0;I=w+16|0;c[I>>2]=c[i>>2];c[I+4>>2]=N;c[w+24>>2]=c[l>>2];if((c[l>>2]&64|0?a[(c[f>>2]|0)+5>>0]&3:0)?a[e+5>>0]&4:0)ld(b,e);O=w;Pa=h;return O|0}function He(a,b){a=a|0;b=b|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0.0,o=0.0;e=Pa;Pa=Pa+16|0;f=e;h=b+8|0;switch(c[h>>2]&63){case 4:{i=c[b>>2]|0;j=(c[a+16>>2]|0)+(((1<<(d[a+7>>0]|0))+-1&c[i+8>>2])<<5)|0;while(1){if((c[j+24>>2]|0)==68?(c[j+16>>2]|0)==(i|0):0)break;k=c[j+28>>2]|0;if(!k){l=15792;m=20;break}else j=k}if((m|0)==20){Pa=e;return l|0}l=j;Pa=e;return l|0}case 3:{n=+g[b>>3];g[f>>3]=n+6755399441055744.0;j=c[f>>2]|0;o=+(j|0);if(n==o){i=j+-1|0;if(i>>>0<(c[a+28>>2]|0)>>>0){l=(c[a+12>>2]|0)+(i<<4)|0;Pa=e;return l|0}g[f>>3]=o+1.0;i=(c[f+4>>2]|0)+(c[f>>2]|0)|0;f=0-i|0;j=(c[a+16>>2]|0)+(((((i|0)<0?((i|0)==(f|0)?0:f):i)|0)%((1<<(d[a+7>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[j+24>>2]|0)==3?+g[j+16>>3]==o:0)break;i=c[j+28>>2]|0;if(!i){l=15792;m=20;break}else j=i}if((m|0)==20){Pa=e;return l|0}l=j;Pa=e;return l|0}break}case 0:{l=15792;Pa=e;return l|0}default:{}}j=Ee(a,b)|0;while(1){if((c[j+24>>2]|0)==(c[h>>2]|0)?cf(0,j+16|0,b)|0:0)break;a=c[j+28>>2]|0;if(!a){l=15792;m=20;break}else j=a}if((m|0)==20){Pa=e;return l|0}l=j;Pa=e;return l|0}function Ie(a,b,e,f){a=a|0;b=b|0;e=e|0;f=f|0;var h=0,i=0,j=0,k=0,l=0,m=0.0,n=0,o=0,p=0,q=0.0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;h=Pa;Pa=Pa+16|0;i=h;j=e+-1|0;a:do if(j>>>0<(c[b+28>>2]|0)>>>0){k=(c[b+12>>2]|0)+(j<<4)|0;l=8}else{m=+(e|0);g[i>>3]=m+1.0;n=(c[i+4>>2]|0)+(c[i>>2]|0)|0;o=0-n|0;p=(c[b+16>>2]|0)+(((((n|0)<0?((n|0)==(o|0)?0:o):n)|0)%((1<<(d[b+7>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[p+24>>2]|0)==3?+g[p+16>>3]==m:0)break;n=c[p+28>>2]|0;if(!n){q=m;break a}else p=n}k=p;l=8}while(0);do if((l|0)==8)if((k|0)==15792){q=+(e|0);break}else{r=k;s=f;t=s;u=c[t>>2]|0;v=s+4|0;w=v;x=c[w>>2]|0;y=r;z=y;c[z>>2]=u;A=y+4|0;B=A;c[B>>2]=x;C=f+8|0;D=c[C>>2]|0;E=r+8|0;c[E>>2]=D;Pa=h;return}while(0);g[i>>3]=q;c[i+8>>2]=3;r=Ge(a,b,i)|0;s=f;t=s;u=c[t>>2]|0;v=s+4|0;w=v;x=c[w>>2]|0;y=r;z=y;c[z>>2]=u;A=y+4|0;B=A;c[B>>2]=x;C=f+8|0;D=c[C>>2]|0;E=r+8|0;c[E>>2]=D;Pa=h;return}function Je(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=He(b,c)|0;if((d|0)!=15792){e=d;return e|0}e=Ge(a,b,c)|0;return e|0}function Ke(a,b,e){a=a|0;b=b|0;e=e|0;var f=0;if((c[b+16>>2]|0)==15808)f=0;else f=1<<(d[b+7>>0]|0);Fe(a,b,e,f);return}function Le(b){b=b|0;var d=0;d=od(b,5,32,0,0)|0;c[d+8>>2]=0;a[d+6>>0]=-1;c[d+12>>2]=0;c[d+28>>2]=0;c[d+16>>2]=15808;a[d+7>>0]=0;c[d+20>>2]=15808;return d|0}function Me(a,b){a=a|0;b=b|0;var e=0;e=c[b+16>>2]|0;if((e|0)!=15808)Hd(a,e,32<<(d[b+7>>0]|0),0)|0;Hd(a,c[b+12>>2]|0,c[b+28>>2]<<4,0)|0;Hd(a,b,32,0)|0;return}function Ne(a,b){a=a|0;b=b|0;var e=0,f=0,h=0,i=0,j=0.0,k=0;e=Pa;Pa=Pa+16|0;f=e;h=b+-1|0;if(h>>>0<(c[a+28>>2]|0)>>>0){i=(c[a+12>>2]|0)+(h<<4)|0;Pa=e;return i|0}j=+(b|0);g[f>>3]=j+1.0;b=(c[f+4>>2]|0)+(c[f>>2]|0)|0;f=0-b|0;h=(c[a+16>>2]|0)+(((((b|0)<0?((b|0)==(f|0)?0:f):b)|0)%((1<<(d[a+7>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[h+24>>2]|0)==3?+g[h+16>>3]==j:0)break;a=c[h+28>>2]|0;if(!a){i=15792;k=8;break}else h=a}if((k|0)==8){Pa=e;return i|0}i=h;Pa=e;return i|0}function Oe(a,b){a=a|0;b=b|0;var e=0,f=0,g=0;e=(c[a+16>>2]|0)+(((1<<(d[a+7>>0]|0))+-1&c[b+8>>2])<<5)|0;while(1){if((c[e+24>>2]|0)==68?(c[e+16>>2]|0)==(b|0):0)break;a=c[e+28>>2]|0;if(!a){f=15792;g=6;break}else e=a}if((g|0)==6)return f|0;f=e;return f|0}function Pe(a){a=a|0;var b=0,e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0.0,q=0,r=0,s=0,t=0,u=0,v=0;b=Pa;Pa=Pa+16|0;e=b;f=c[a+28>>2]|0;if(f|0?(h=c[a+12>>2]|0,(c[h+(f+-1<<4)+8>>2]|0)==0):0){if(f>>>0<=1){i=0;Pa=b;return i|0}j=0;k=f;while(1){l=(j+k|0)>>>1;m=(c[h+(l+-1<<4)+8>>2]|0)==0;k=m?l:k;n=m?j:l;if((k-n|0)>>>0<=1){i=n;break}else j=n}Pa=b;return i|0}j=c[a+16>>2]|0;if((j|0)==15808){i=f;Pa=b;return i|0}k=a+12|0;h=a+7|0;a=e+4|0;n=f;l=f+1|0;while(1){m=l+-1|0;a:do if(m>>>0<f>>>0)o=(c[k>>2]|0)+(m<<4)|0;else{p=+(l|0);g[e>>3]=p+1.0;q=(c[a>>2]|0)+(c[e>>2]|0)|0;r=0-q|0;s=j+(((((q|0)<0?((q|0)==(r|0)?0:r):q)|0)%((1<<(d[h>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[s+24>>2]|0)==3?+g[s+16>>3]==p:0)break;q=c[s+28>>2]|0;if(!q){o=15792;break a}else s=q}o=s}while(0);if(!(c[o+8>>2]|0))break;m=l<<1;if(m>>>0>2147483645){t=17;break}else{q=l;l=m;n=q}}if((t|0)==17){t=e+4|0;o=1;while(1){a=o+-1|0;b:do if(a>>>0<f>>>0)u=(c[k>>2]|0)+(a<<4)|0;else{p=+(o|0);g[e>>3]=p+1.0;q=(c[t>>2]|0)+(c[e>>2]|0)|0;m=0-q|0;r=j+(((((q|0)<0?((q|0)==(m|0)?0:m):q)|0)%((1<<(d[h>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[r+24>>2]|0)==3?+g[r+16>>3]==p:0)break;q=c[r+28>>2]|0;if(!q){u=15792;break b}else r=q}u=r}while(0);if(!(c[u+8>>2]|0)){i=a;break}else o=o+1|0}Pa=b;return i|0}if((l-n|0)>>>0<=1){i=n;Pa=b;return i|0}o=e+4|0;u=l;l=n;while(1){n=(u+l|0)>>>1;t=n+-1|0;c:do if(t>>>0<f>>>0)v=(c[k>>2]|0)+(t<<4)|0;else{p=+(n|0);g[e>>3]=p+1.0;s=(c[o>>2]|0)+(c[e>>2]|0)|0;q=0-s|0;m=j+(((((s|0)<0?((s|0)==(q|0)?0:q):s)|0)%((1<<(d[h>>0]|0))+-1|1|0)|0)<<5)|0;while(1){if((c[m+24>>2]|0)==3?+g[m+16>>3]==p:0)break;s=c[m+28>>2]|0;if(!s){v=15792;break c}else m=s}v=m}while(0);t=(c[v+8>>2]|0)==0;u=t?n:u;a=t?l:n;if((u-a|0)>>>0<=1){i=a;break}else l=a}Pa=b;return i|0}function Qe(b){b=b|0;var d=0,e=0;d=b+12|0;e=Be(b,13431)|0;c[(c[d>>2]|0)+184>>2]=e;e=(c[(c[d>>2]|0)+184>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7694)|0;c[(c[d>>2]|0)+188>>2]=e;e=(c[(c[d>>2]|0)+188>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,12681)|0;c[(c[d>>2]|0)+192>>2]=e;e=(c[(c[d>>2]|0)+192>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,10376)|0;c[(c[d>>2]|0)+196>>2]=e;e=(c[(c[d>>2]|0)+196>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7705)|0;c[(c[d>>2]|0)+200>>2]=e;e=(c[(c[d>>2]|0)+200>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7711)|0;c[(c[d>>2]|0)+204>>2]=e;e=(c[(c[d>>2]|0)+204>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7716)|0;c[(c[d>>2]|0)+208>>2]=e;e=(c[(c[d>>2]|0)+208>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7722)|0;c[(c[d>>2]|0)+212>>2]=e;e=(c[(c[d>>2]|0)+212>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7728)|0;c[(c[d>>2]|0)+216>>2]=e;e=(c[(c[d>>2]|0)+216>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7734)|0;c[(c[d>>2]|0)+220>>2]=e;e=(c[(c[d>>2]|0)+220>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7740)|0;c[(c[d>>2]|0)+224>>2]=e;e=(c[(c[d>>2]|0)+224>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7746)|0;c[(c[d>>2]|0)+228>>2]=e;e=(c[(c[d>>2]|0)+228>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7752)|0;c[(c[d>>2]|0)+232>>2]=e;e=(c[(c[d>>2]|0)+232>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7758)|0;c[(c[d>>2]|0)+236>>2]=e;e=(c[(c[d>>2]|0)+236>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7763)|0;c[(c[d>>2]|0)+240>>2]=e;e=(c[(c[d>>2]|0)+240>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7768)|0;c[(c[d>>2]|0)+244>>2]=e;e=(c[(c[d>>2]|0)+244>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;e=Be(b,7777)|0;c[(c[d>>2]|0)+248>>2]=e;e=(c[(c[d>>2]|0)+248>>2]|0)+5|0;a[e>>0]=a[e>>0]|32;return}function Re(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0;g=Oe(b,f)|0;if(c[g+8>>2]|0){h=g;return h|0}g=b+6|0;a[g>>0]=1<<e|(d[g>>0]|0);h=0;return h|0}function Se(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=c[b+8>>2]|0;switch(e&15){case 5:{f=(c[b>>2]|0)+8|0;break}case 7:{f=(c[b>>2]|0)+8|0;break}default:f=(c[a+12>>2]|0)+252+((e&15)<<2)|0}e=c[f>>2]|0;if(!e){g=15792;return g|0}g=Oe(e,c[(c[a+12>>2]|0)+184+(d<<2)>>2]|0)|0;return g|0}function Te(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0;g=Pa;Pa=Pa+80|0;h=g+32|0;i=g;j=g+56|0;switch(a[f>>0]|0){case 61:case 64:{k=f+1|0;break}case 27:{k=7784;break}default:k=f}c[j+12>>2]=k;c[j>>2]=b;c[j+4>>2]=d;c[j+8>>2]=e;c[h>>2]=1635077147;a[h+4>>0]=82;a[h+5>>0]=0;a[h+6>>0]=1;a[h+7>>0]=4;a[h+8>>0]=4;a[h+9>>0]=4;a[h+10>>0]=8;e=h+12|0;a[h+11>>0]=0;a[e>>0]=a[7798]|0;a[e+1>>0]=a[7799]|0;a[e+2>>0]=a[7800]|0;a[e+3>>0]=a[7801]|0;a[e+4>>0]=a[7802]|0;a[e+5>>0]=a[7803]|0;a[i>>0]=27;if(lf(d,i+1|0,17)|0)Ue(j,7805);if(!(Mm(h,i,18)|0)){d=bd(b,1)|0;e=b+8|0;k=c[e>>2]|0;c[k>>2]=d;c[k+8>>2]=70;k=(c[e>>2]|0)+16|0;c[e>>2]=k;if(((c[b+24>>2]|0)-k|0)<16)Mc(b,0);k=gd(b)|0;f=d+12|0;c[f>>2]=k;Ve(j,k);k=c[f>>2]|0;f=c[k+40>>2]|0;if((f|0)==1){l=d;Pa=g;return l|0}d=bd(b,f)|0;c[d+12>>2]=k;k=c[e>>2]|0;c[k+-16>>2]=d;c[k+-8>>2]=70;l=d;Pa=g;return l|0}if((c[i>>2]|0)!=1635077147)Ue(j,7815);if(Mm(h,i,6)|0)Ue(j,7821);if(!(Mm(h,i,12)|0))Ue(j,7854);else Ue(j,7841);return 0}function Ue(a,b){a=a|0;b=b|0;var d=0,e=0;d=Pa;Pa=Pa+16|0;e=d;d=c[a>>2]|0;c[e>>2]=c[a+12>>2];c[e+4>>2]=b;Pd(d,7864,e)|0;Jc(c[a>>2]|0,3)}function Ve(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;e=Pa;Pa=Pa+16|0;f=e;h=b+4|0;if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);i=c[f>>2]|0;if((i|0)<0)Ue(b,7854);c[d+64>>2]=i;if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);i=c[f>>2]|0;if((i|0)<0)Ue(b,7854);c[d+68>>2]=i;if(lf(c[h>>2]|0,f,1)|0)Ue(b,7805);a[d+76>>0]=a[f>>0]|0;if(lf(c[h>>2]|0,f,1)|0)Ue(b,7805);a[d+77>>0]=a[f>>0]|0;if(lf(c[h>>2]|0,f,1)|0)Ue(b,7805);a[d+78>>0]=a[f>>0]|0;if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);i=c[f>>2]|0;if((i|0)<0)Ue(b,7854);j=c[b>>2]|0;if((i+1|0)>>>0>1073741823)Gd(j);k=i<<2;l=Hd(j,0,0,k)|0;c[d+12>>2]=l;c[d+48>>2]=i;if(lf(c[h>>2]|0,l,k)|0)Ue(b,7805);if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);k=c[f>>2]|0;if((k|0)<0)Ue(b,7854);l=c[b>>2]|0;if((k+1|0)>>>0>268435455)Gd(l);i=Hd(l,0,0,k<<4)|0;l=d+8|0;c[l>>2]=i;c[d+44>>2]=k;j=(k|0)>0;a:do if(j){m=0;do{c[i+(m<<4)+8>>2]=0;m=m+1|0}while((m|0)!=(k|0));if(j){if(lf(c[h>>2]|0,f,1)|0)Ue(b,7805);m=0;n=i;o=i;b:while(1){p=a[f>>0]|0;switch(p|0){case 0:{q=p;r=44;break}case 1:{if(lf(c[h>>2]|0,f,1)|0){r=38;break b}c[n>>2]=a[f>>0];q=1;r=44;break}case 3:{if(lf(c[h>>2]|0,f,8)|0){r=41;break b}g[n>>3]=+g[f>>3];q=3;r=44;break}case 4:{p=We(b)|0;c[n>>2]=p;q=(a[p+4>>0]|64)&255;r=44;break}default:{}}if((r|0)==44){r=0;c[o+(m<<4)+8>>2]=q}p=m+1|0;if((p|0)>=(k|0))break a;s=c[l>>2]|0;if(!(lf(c[h>>2]|0,f,1)|0)){m=p;n=s+(p<<4)|0;o=s}else{r=35;break}}if((r|0)==35)Ue(b,7805);else if((r|0)==38)Ue(b,7805);else if((r|0)==41)Ue(b,7805)}}while(0);if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);l=c[f>>2]|0;if((l|0)<0)Ue(b,7854);k=c[b>>2]|0;if((l+1|0)>>>0>1073741823)Gd(k);q=Hd(k,0,0,l<<2)|0;k=d+16|0;c[k>>2]=q;c[d+56>>2]=l;i=(l|0)>0;do if(i){c[q>>2]=0;if((l|0)!=1){j=1;do{c[(c[k>>2]|0)+(j<<2)>>2]=0;j=j+1|0}while((j|0)!=(l|0))}if(!i)break;j=0;do{o=gd(c[b>>2]|0)|0;c[(c[k>>2]|0)+(j<<2)>>2]=o;Ve(b,c[(c[k>>2]|0)+(j<<2)>>2]|0);j=j+1|0}while((j|0)!=(l|0))}while(0);if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);l=c[f>>2]|0;if((l|0)<0)Ue(b,7854);k=c[b>>2]|0;if((l+1|0)>>>0>536870911)Gd(k);i=Hd(k,0,0,l<<3)|0;k=d+28|0;c[k>>2]=i;c[d+40>>2]=l;c:do if((l|0)>0){q=0;do{c[i+(q<<3)>>2]=0;q=q+1|0}while((q|0)!=(l|0));q=0;while(1){if(lf(c[h>>2]|0,f,1)|0){r=71;break}a[(c[k>>2]|0)+(q<<3)+4>>0]=a[f>>0]|0;if(lf(c[h>>2]|0,f,1)|0){r=73;break}a[(c[k>>2]|0)+(q<<3)+5>>0]=a[f>>0]|0;q=q+1|0;if((q|0)>=(l|0))break c}if((r|0)==71)Ue(b,7805);else if((r|0)==73)Ue(b,7805)}while(0);l=We(b)|0;c[d+36>>2]=l;if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);l=c[f>>2]|0;if((l|0)<0)Ue(b,7854);i=c[b>>2]|0;if((l+1|0)>>>0>1073741823)Gd(i);q=l<<2;j=Hd(i,0,0,q)|0;c[d+20>>2]=j;c[d+52>>2]=l;if(lf(c[h>>2]|0,j,q)|0)Ue(b,7805);if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);q=c[f>>2]|0;if((q|0)<0)Ue(b,7854);j=c[b>>2]|0;if((q+1|0)>>>0>357913941)Gd(j);l=Hd(j,0,0,q*12|0)|0;j=d+24|0;c[j>>2]=l;c[d+60>>2]=q;d:do if((q|0)>0){d=0;do{c[l+(d*12|0)>>2]=0;d=d+1|0}while((d|0)!=(q|0));d=0;while(1){i=We(b)|0;c[(c[j>>2]|0)+(d*12|0)>>2]=i;if(lf(c[h>>2]|0,f,4)|0){r=94;break}i=c[f>>2]|0;if((i|0)<0){r=96;break}c[(c[j>>2]|0)+(d*12|0)+4>>2]=i;if(lf(c[h>>2]|0,f,4)|0){r=98;break}i=c[f>>2]|0;if((i|0)<0){r=100;break}c[(c[j>>2]|0)+(d*12|0)+8>>2]=i;d=d+1|0;if((d|0)>=(q|0))break d}if((r|0)==94)Ue(b,7805);else if((r|0)==96)Ue(b,7854);else if((r|0)==98)Ue(b,7805);else if((r|0)==100)Ue(b,7854)}while(0);if(lf(c[h>>2]|0,f,4)|0)Ue(b,7805);h=c[f>>2]|0;if((h|0)<0)Ue(b,7854);if(!h){Pa=e;return}f=0;do{r=We(b)|0;c[(c[k>>2]|0)+(f<<3)>>2]=r;f=f+1|0}while((f|0)<(h|0));Pa=e;return}function We(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+16|0;d=b;e=a+4|0;if(lf(c[e>>2]|0,d,4)|0)Ue(a,7805);f=c[d>>2]|0;if(!f){g=0;Pa=b;return g|0}h=mf(c[a>>2]|0,c[a+8>>2]|0,f)|0;if(lf(c[e>>2]|0,h,c[d>>2]|0)|0)Ue(a,7805);g=Ae(c[a>>2]|0,h,(c[d>>2]|0)+-1|0)|0;Pa=b;return g|0}function Xe(b){b=b|0;var c=0;a[b>>0]=27;a[b+1>>0]=76;a[b+2>>0]=117;a[b+3>>0]=97;a[b+4>>0]=82;a[b+5>>0]=0;a[b+6>>0]=1;a[b+7>>0]=4;a[b+8>>0]=4;a[b+9>>0]=4;a[b+10>>0]=8;c=b+12|0;a[b+11>>0]=0;a[c>>0]=a[7798]|0;a[c+1>>0]=a[7799]|0;a[c+2>>0]=a[7800]|0;a[c+3>>0]=a[7801]|0;a[c+4>>0]=a[7802]|0;a[c+5>>0]=a[7803]|0;return}function Ye(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,h=0;d=Pa;Pa=Pa+16|0;e=d;f=c[a+8>>2]|0;if((f|0)!=3)if((f&15|0)==4?(f=c[a>>2]|0,(Nd(f+16|0,c[f+12>>2]|0,e)|0)!=0):0){g[b>>3]=+g[e>>3];c[b+8>>2]=3;h=b}else h=0;else h=a;Pa=d;return h|0}function Ze(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+48|0;f=e+32|0;h=e;i=d+8|0;if((c[i>>2]|0)!=3){j=0;Pa=e;return j|0}g[f>>3]=+g[d>>3];k=Ae(b,h,Gm(h,10898,f)|0)|0;c[d>>2]=k;c[i>>2]=(a[k+4>>0]|64)&255;j=1;Pa=e;return j|0}function _e(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;g=Pa;Pa=Pa+16|0;h=g;i=b+12|0;j=d;k=0;l=c[d+8>>2]|0;while(1){if((l|0)!=69){d=Se(b,j,0)|0;m=d+8|0;n=c[m>>2]|0;if(!n){o=11;break}else{p=d;q=m;r=n}}else{n=c[j>>2]|0;s=He(n,e)|0;if(c[s+8>>2]|0){o=9;break}m=c[n+8>>2]|0;if(!m){o=9;break}if(a[m+6>>0]&1){o=9;break}n=Re(m,0,c[(c[i>>2]|0)+184>>2]|0)|0;if(!n){o=9;break}m=n+8|0;p=n;q=m;r=c[m>>2]|0}k=k+1|0;if((r&15|0)==6){o=13;break}if(k>>>0>=100){o=14;break}else{j=p;l=r}}if((o|0)==9){r=s;l=c[r+4>>2]|0;k=f;c[k>>2]=c[r>>2];c[k+4>>2]=l;c[f+8>>2]=c[s+8>>2];Pa=g;return}else if((o|0)==11)Cc(b,j,7889);else if((o|0)==13){s=b+28|0;l=c[s>>2]|0;k=b+8|0;r=c[k>>2]|0;c[k>>2]=r+16;i=p;p=c[i+4>>2]|0;m=r;c[m>>2]=c[i>>2];c[m+4>>2]=p;c[r+8>>2]=c[q>>2];q=c[k>>2]|0;c[k>>2]=q+16;r=j;p=c[r+4>>2]|0;m=q;c[m>>2]=c[r>>2];c[m+4>>2]=p;c[q+8>>2]=c[j+8>>2];j=c[k>>2]|0;c[k>>2]=j+16;q=e;p=c[q+4>>2]|0;m=j;c[m>>2]=c[q>>2];c[m+4>>2]=p;c[j+8>>2]=c[e+8>>2];Rc(b,(c[k>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);e=(c[s>>2]|0)+(f-l)|0;l=c[k>>2]|0;f=l+-16|0;c[k>>2]=f;k=f;f=c[k+4>>2]|0;s=e;c[s>>2]=c[k>>2];c[s+4>>2]=f;c[e+8>>2]=c[l+-8>>2];Pa=g;return}else if((o|0)==14)Dc(b,7895,h)}function $e(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;g=Pa;Pa=Pa+16|0;h=g;i=b+12|0;j=d;k=0;l=c[d+8>>2]|0;while(1){if((l|0)!=69){d=Se(b,j,1)|0;m=d+8|0;n=c[m>>2]|0;if(!n){o=16;break}else{p=d;q=m;r=n}}else{s=c[j>>2]|0;t=He(s,e)|0;if(c[t+8>>2]|0){u=t;break}n=c[s+8>>2]|0;if(!n){o=9;break}if(a[n+6>>0]&2){o=9;break}m=Re(n,1,c[(c[i>>2]|0)+188>>2]|0)|0;if(!m){o=9;break}n=m+8|0;p=m;q=n;r=c[n>>2]|0}k=k+1|0;if((r&15|0)==6){o=18;break}if(k>>>0>=100){o=19;break}else{j=p;l=r}}if((o|0)==9)if((t|0)==15792)u=Ge(b,s,e)|0;else u=t;else if((o|0)==16)Cc(b,j,7889);else if((o|0)==18){t=b+8|0;r=c[t>>2]|0;c[t>>2]=r+16;l=p;p=c[l+4>>2]|0;k=r;c[k>>2]=c[l>>2];c[k+4>>2]=p;c[r+8>>2]=c[q>>2];q=c[t>>2]|0;c[t>>2]=q+16;r=j;p=c[r+4>>2]|0;k=q;c[k>>2]=c[r>>2];c[k+4>>2]=p;c[q+8>>2]=c[j+8>>2];j=c[t>>2]|0;c[t>>2]=j+16;q=e;p=c[q+4>>2]|0;k=j;c[k>>2]=c[q>>2];c[k+4>>2]=p;c[j+8>>2]=c[e+8>>2];e=c[t>>2]|0;c[t>>2]=e+16;j=f;p=c[j+4>>2]|0;k=e;c[k>>2]=c[j>>2];c[k+4>>2]=p;c[e+8>>2]=c[f+8>>2];Rc(b,(c[t>>2]|0)+-64|0,0,a[(c[b+16>>2]|0)+18>>0]&1);Pa=g;return}else if((o|0)==19)Dc(b,7912,h);h=f;o=c[h+4>>2]|0;t=u;c[t>>2]=c[h>>2];c[t+4>>2]=o;o=f+8|0;c[u+8>>2]=c[o>>2];a[s+6>>0]=0;if(!(c[o>>2]&64)){Pa=g;return}if(!(a[(c[f>>2]|0)+5>>0]&3)){Pa=g;return}if(!(a[s+5>>0]&4)){Pa=g;return}ld(b,s);Pa=g;return}function af(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;f=d+8|0;h=c[f>>2]|0;if((h|0)==3){if((c[e+8>>2]|0)==3){i=+g[d>>3]<+g[e>>3]&1;return i|0}}else if((h&15|0)==4?(c[e+8>>2]&15|0)==4:0){h=c[d>>2]|0;j=c[e>>2]|0;k=h+16|0;l=j+16|0;m=vn(k,l)|0;a:do if(!m){n=c[j+12>>2]|0;o=l;p=c[h+12>>2]|0;q=k;while(1){r=_l(q)|0;if((r|0)==(n|0)){s=0;break a}t=r+1|0;if((r|0)==(p|0)){s=-1;break a}o=o+t|0;q=q+t|0;r=vn(q,o)|0;if(r|0){s=r;break}else{n=n-t|0;p=p-t|0}}}else s=m;while(0);i=s>>>31;return i|0}s=b+8|0;m=c[s>>2]|0;k=Se(b,d,13)|0;h=k+8|0;if(!(c[h>>2]|0)){l=Se(b,e,13)|0;j=l+8|0;if(!(c[j>>2]|0))Ic(b,d,e);else{u=l;v=j}}else{u=k;v=h}h=b+28|0;k=c[h>>2]|0;j=c[s>>2]|0;c[s>>2]=j+16;l=u;u=c[l+4>>2]|0;p=j;c[p>>2]=c[l>>2];c[p+4>>2]=u;c[j+8>>2]=c[v>>2];v=c[s>>2]|0;c[s>>2]=v+16;j=d;d=c[j+4>>2]|0;u=v;c[u>>2]=c[j>>2];c[u+4>>2]=d;c[v+8>>2]=c[f>>2];f=c[s>>2]|0;c[s>>2]=f+16;v=e;d=c[v+4>>2]|0;u=f;c[u>>2]=c[v>>2];c[u+4>>2]=d;c[f+8>>2]=c[e+8>>2];Rc(b,(c[s>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);b=(c[h>>2]|0)+(m-k)|0;k=c[s>>2]|0;m=k+-16|0;c[s>>2]=m;h=m;m=c[h+4>>2]|0;e=b;c[e>>2]=c[h>>2];c[e+4>>2]=m;c[b+8>>2]=c[k+-8>>2];k=c[s>>2]|0;s=c[k+8>>2]|0;switch(s|0){case 1:{i=(c[k>>2]|0)!=0&1;return i|0}case 0:{i=s;return i|0}default:{i=1;return i|0}}return 0}function bf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;f=d+8|0;h=c[f>>2]|0;if((h|0)==3){if((c[e+8>>2]|0)==3){i=+g[d>>3]<=+g[e>>3];j=i&1;return j|0}}else if((h&15|0)==4?(c[e+8>>2]&15|0)==4:0){h=c[d>>2]|0;k=c[e>>2]|0;l=h+16|0;m=k+16|0;n=vn(l,m)|0;a:do if(!n){o=c[k+12>>2]|0;p=m;q=c[h+12>>2]|0;r=l;while(1){s=_l(r)|0;t=(s|0)==(q|0);if((s|0)==(o|0))break;u=s+1|0;if(t){v=-1;break a}p=p+u|0;r=r+u|0;s=vn(r,p)|0;if(s|0){v=s;break a}else{o=o-u|0;q=q-u|0}}v=(t^1)&1}else v=n;while(0);i=(v|0)<1;j=i&1;return j|0}v=b+8|0;n=c[v>>2]|0;t=Se(b,d,14)|0;l=t+8|0;if(!(c[l>>2]|0)){h=Se(b,e,14)|0;m=h+8|0;if(!(c[m>>2]|0)){k=c[v>>2]|0;q=Se(b,e,13)|0;o=q+8|0;if(!(c[o>>2]|0)){p=Se(b,d,13)|0;r=p+8|0;if(!(c[r>>2]|0))Ic(b,d,e);else{w=p;x=r}}else{w=q;x=o}o=b+28|0;q=c[o>>2]|0;r=c[v>>2]|0;c[v>>2]=r+16;p=w;w=c[p+4>>2]|0;u=r;c[u>>2]=c[p>>2];c[u+4>>2]=w;c[r+8>>2]=c[x>>2];x=c[v>>2]|0;c[v>>2]=x+16;r=e;w=c[r+4>>2]|0;u=x;c[u>>2]=c[r>>2];c[u+4>>2]=w;c[x+8>>2]=c[e+8>>2];x=c[v>>2]|0;c[v>>2]=x+16;w=d;u=c[w+4>>2]|0;r=x;c[r>>2]=c[w>>2];c[r+4>>2]=u;c[x+8>>2]=c[f>>2];Rc(b,(c[v>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);x=(c[o>>2]|0)+(k-q)|0;q=c[v>>2]|0;k=q+-16|0;c[v>>2]=k;o=k;k=c[o+4>>2]|0;u=x;c[u>>2]=c[o>>2];c[u+4>>2]=k;c[x+8>>2]=c[q+-8>>2];q=c[v>>2]|0;switch(c[q+8>>2]|0){case 1:{i=(c[q>>2]|0)==0;j=i&1;return j|0}case 0:{i=1;j=i&1;return j|0}default:{i=0;j=i&1;return j|0}}}else{y=h;z=m}}else{y=t;z=l}l=b+28|0;t=c[l>>2]|0;m=c[v>>2]|0;c[v>>2]=m+16;h=y;y=c[h+4>>2]|0;q=m;c[q>>2]=c[h>>2];c[q+4>>2]=y;c[m+8>>2]=c[z>>2];z=c[v>>2]|0;c[v>>2]=z+16;m=d;d=c[m+4>>2]|0;y=z;c[y>>2]=c[m>>2];c[y+4>>2]=d;c[z+8>>2]=c[f>>2];f=c[v>>2]|0;c[v>>2]=f+16;z=e;d=c[z+4>>2]|0;y=f;c[y>>2]=c[z>>2];c[y+4>>2]=d;c[f+8>>2]=c[e+8>>2];Rc(b,(c[v>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);b=(c[l>>2]|0)+(n-t)|0;t=c[v>>2]|0;n=t+-16|0;c[v>>2]=n;l=n;n=c[l+4>>2]|0;e=b;c[e>>2]=c[l>>2];c[e+4>>2]=n;c[b+8>>2]=c[t+-8>>2];t=c[v>>2]|0;switch(c[t+8>>2]|0){case 1:{i=(c[t>>2]|0)!=0;j=i&1;return j|0}case 0:{i=0;j=i&1;return j|0}default:{i=1;j=i&1;return j|0}}return 0}function cf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;f=d+8|0;do switch(c[f>>2]&63){case 3:{h=+g[d>>3]==+g[e>>3]&1;return h|0}case 1:{h=(c[d>>2]|0)==(c[e>>2]|0)&1;return h|0}case 2:{h=(c[d>>2]|0)==(c[e>>2]|0)&1;return h|0}case 22:{h=(c[d>>2]|0)==(c[e>>2]|0)&1;return h|0}case 4:{h=(c[d>>2]|0)==(c[e>>2]|0)&1;return h|0}case 20:{h=we(c[d>>2]|0,c[e>>2]|0)|0;return h|0}case 7:{i=c[d>>2]|0;j=c[e>>2]|0;if((i|0)==(j|0)){h=1;return h|0}if(!b){h=0;return h|0}k=c[i+8>>2]|0;i=c[j+8>>2]|0;if(!k){h=0;return h|0}if(a[k+6>>0]&32){h=0;return h|0}j=b+12|0;l=Re(k,5,c[(c[j>>2]|0)+204>>2]|0)|0;if(!l){h=0;return h|0}if((k|0)!=(i|0)){if(!i){h=0;return h|0}if(a[i+6>>0]&32){h=0;return h|0}k=Re(i,5,c[(c[j>>2]|0)+204>>2]|0)|0;if(!k){h=0;return h|0}if((c[l+8>>2]|0)!=(c[k+8>>2]|0)){h=0;return h|0}if(!(cf(0,l,k)|0)){h=0;return h|0}else m=l}else m=l;break}case 5:{l=c[d>>2]|0;k=c[e>>2]|0;if((l|0)==(k|0)){h=1;return h|0}if(!b){h=0;return h|0}j=c[l+8>>2]|0;l=c[k+8>>2]|0;if(!j){h=0;return h|0}if(a[j+6>>0]&32){h=0;return h|0}k=b+12|0;i=Re(j,5,c[(c[k>>2]|0)+204>>2]|0)|0;if(!i){h=0;return h|0}if((j|0)!=(l|0)){if(!l){h=0;return h|0}if(a[l+6>>0]&32){h=0;return h|0}j=Re(l,5,c[(c[k>>2]|0)+204>>2]|0)|0;if(!j){h=0;return h|0}if((c[i+8>>2]|0)!=(c[j+8>>2]|0)){h=0;return h|0}if(!(cf(0,i,j)|0)){h=0;return h|0}else m=i}else m=i;break}case 0:{h=1;return h|0}default:{h=(c[d>>2]|0)==(c[e>>2]|0)&1;return h|0}}while(0);i=b+8|0;j=c[i>>2]|0;k=b+28|0;l=c[k>>2]|0;c[i>>2]=j+16;n=m;o=c[n+4>>2]|0;p=j;c[p>>2]=c[n>>2];c[p+4>>2]=o;c[j+8>>2]=c[m+8>>2];m=c[i>>2]|0;c[i>>2]=m+16;o=d;d=c[o+4>>2]|0;p=m;c[p>>2]=c[o>>2];c[p+4>>2]=d;c[m+8>>2]=c[f>>2];f=c[i>>2]|0;c[i>>2]=f+16;m=e;d=c[m+4>>2]|0;p=f;c[p>>2]=c[m>>2];c[p+4>>2]=d;c[f+8>>2]=c[e+8>>2];Rc(b,(c[i>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);b=(c[k>>2]|0)+(j-l)|0;l=c[i>>2]|0;j=l+-16|0;c[i>>2]=j;k=j;j=c[k+4>>2]|0;e=b;c[e>>2]=c[k>>2];c[e+4>>2]=j;c[b+8>>2]=c[l+-8>>2];l=c[i>>2]|0;i=c[l+8>>2]|0;switch(i|0){case 1:{h=(c[l>>2]|0)!=0&1;return h|0}case 0:{h=i;return h|0}default:{h=1;return h|0}}return 0}function df(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;e=Pa;Pa=Pa+64|0;f=e+56|0;h=e+48|0;i=e+40|0;j=e+32|0;k=e;l=b+8|0;m=b+28|0;n=b+16|0;o=b+12|0;p=d;d=c[l>>2]|0;a:while(1){q=d+-32|0;r=d+-24|0;s=c[r>>2]|0;t=d+-16|0;do if((s|0)==3|(s&15|0)==4){u=d+-8|0;v=c[u>>2]|0;if((v&15|0)==4)w=s;else{if((v|0)!=3){x=6;break}g[j>>3]=+g[t>>3];v=Ae(b,k,Gm(k,10898,j)|0)|0;c[t>>2]=v;c[u>>2]=(a[v+4>>0]|64)&255;w=c[r>>2]|0}v=c[(c[t>>2]|0)+12>>2]|0;y=(w&15|0)==4;if(!v){if(!((w|0)==3&(y^1))){z=2;break}g[i>>3]=+g[q>>3];A=Ae(b,k,Gm(k,10898,i)|0)|0;c[q>>2]=A;c[r>>2]=(a[A+4>>0]|64)&255;z=2;break}if(y?(c[(c[q>>2]|0)+12>>2]|0)==0:0){y=t;A=c[y+4>>2]|0;B=q;c[B>>2]=c[y>>2];c[B+4>>2]=A;c[r>>2]=c[u>>2];z=2;break}b:do if((p|0)>1){u=v;A=1;while(1){B=d+(0-A<<4)+-16|0;y=B+8|0;C=c[y>>2]|0;if((C&15|0)!=4){if((C|0)!=3){D=u;E=A;break b}g[h>>3]=+g[B>>3];C=Ae(b,k,Gm(k,10898,h)|0)|0;c[B>>2]=C;c[y>>2]=(a[C+4>>0]|64)&255}C=c[(c[B>>2]|0)+12>>2]|0;if(C>>>0>=(-3-u|0)>>>0){x=22;break a}B=C+u|0;C=A+1|0;if((C|0)<(p|0)){u=B;A=C}else{D=B;E=C;break}}}else{D=v;E=1}while(0);v=mf(b,(c[o>>2]|0)+144|0,D)|0;A=0;u=E;while(1){C=c[d+(0-u<<4)>>2]|0;B=c[C+12>>2]|0;Un(v+A|0,C+16|0,B|0)|0;A=B+A|0;if((u|0)<=1)break;else u=u+-1|0}u=0-E|0;B=Ae(b,v,A)|0;c[d+(u<<4)>>2]=B;c[d+(u<<4)+8>>2]=(a[B+4>>0]|64)&255;z=E}else x=6;while(0);if((x|0)==6){x=0;s=Se(b,q,15)|0;B=s+8|0;if(!(c[B>>2]|0)){u=Se(b,t,15)|0;C=u+8|0;if(!(c[C>>2]|0)){x=9;break}else{F=u;G=C}}else{F=s;G=B}B=c[m>>2]|0;s=c[l>>2]|0;c[l>>2]=s+16;C=F;u=c[C+4>>2]|0;y=s;c[y>>2]=c[C>>2];c[y+4>>2]=u;c[s+8>>2]=c[G>>2];s=c[l>>2]|0;c[l>>2]=s+16;u=q;y=c[u+4>>2]|0;C=s;c[C>>2]=c[u>>2];c[C+4>>2]=y;c[s+8>>2]=c[r>>2];s=c[l>>2]|0;c[l>>2]=s+16;y=t;C=c[y+4>>2]|0;u=s;c[u>>2]=c[y>>2];c[u+4>>2]=C;c[s+8>>2]=c[d+-8>>2];Rc(b,(c[l>>2]|0)+-48|0,1,a[(c[n>>2]|0)+18>>0]&1);s=(c[m>>2]|0)+(q-B)|0;B=c[l>>2]|0;C=B+-16|0;c[l>>2]=C;u=C;C=c[u+4>>2]|0;y=s;c[y>>2]=c[u>>2];c[y+4>>2]=C;c[s+8>>2]=c[B+-8>>2];z=2}p=p+1-z|0;d=(c[l>>2]|0)+(1-z<<4)|0;c[l>>2]=d;if((p|0)<=1){x=28;break}}if((x|0)==9)Gc(b,q,t);else if((x|0)==22)Dc(b,7929,f);else if((x|0)==28){Pa=e;return}}function ef(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0.0,n=0,o=0,p=0;f=e+8|0;a:do switch(c[f>>2]&15){case 5:{h=c[e>>2]|0;i=c[h+8>>2]|0;if((i|0?(a[i+6>>0]&16)==0:0)?(j=Re(i,4,c[(c[b+12>>2]|0)+200>>2]|0)|0,j|0):0){k=j;l=j+8|0;break a}m=+(Pe(h)|0);g[d>>3]=m;c[d+8>>2]=3;return}case 4:{g[d>>3]=+((c[(c[e>>2]|0)+12>>2]|0)>>>0);c[d+8>>2]=3;return}default:{h=Se(b,e,4)|0;j=h+8|0;if(!(c[j>>2]|0))Cc(b,e,7952);else{k=h;l=j}}}while(0);j=b+28|0;h=c[j>>2]|0;i=b+8|0;n=c[i>>2]|0;c[i>>2]=n+16;o=k;k=c[o+4>>2]|0;p=n;c[p>>2]=c[o>>2];c[p+4>>2]=k;c[n+8>>2]=c[l>>2];l=c[i>>2]|0;c[i>>2]=l+16;n=e;k=c[n+4>>2]|0;p=l;c[p>>2]=c[n>>2];c[p+4>>2]=k;c[l+8>>2]=c[f>>2];l=c[i>>2]|0;c[i>>2]=l+16;k=e;e=c[k+4>>2]|0;p=l;c[p>>2]=c[k>>2];c[p+4>>2]=e;c[l+8>>2]=c[f>>2];Rc(b,(c[i>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);b=(c[j>>2]|0)+(d-h)|0;h=c[i>>2]|0;d=h+-16|0;c[i>>2]=d;i=d;d=c[i+4>>2]|0;j=b;c[j>>2]=c[i>>2];c[j+4>>2]=d;c[b+8>>2]=c[h+-8>>2];return}function ff(b,d,e,f,h){b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0.0,s=0,t=0;i=Pa;Pa=Pa+32|0;j=i+16|0;k=i;l=e+8|0;m=c[l>>2]|0;do if((m|0)!=3){if((m&15|0)==4?(n=c[e>>2]|0,Nd(n+16|0,c[n+12>>2]|0,j)|0):0){g[k>>3]=+g[j>>3];c[k+8>>2]=3;o=k;p=6;break}}else{o=e;p=6}while(0);a:do if((p|0)==6){k=c[f+8>>2]|0;do if((k|0)==3)q=f;else{if((k&15|0)==4?(m=c[f>>2]|0,Nd(m+16|0,c[m+12>>2]|0,j)|0):0){q=j;break}break a}while(0);r=+Ld(h+-6|0,+g[o>>3],+g[q>>3]);g[d>>3]=r;c[d+8>>2]=3;Pa=i;return}while(0);q=Se(b,e,h)|0;o=q+8|0;if(!(c[o>>2]|0)){j=Se(b,f,h)|0;h=j+8|0;if(!(c[h>>2]|0))Hc(b,e,f);else{s=j;t=h}}else{s=q;t=o}o=b+28|0;q=c[o>>2]|0;h=b+8|0;j=c[h>>2]|0;c[h>>2]=j+16;p=s;s=c[p+4>>2]|0;k=j;c[k>>2]=c[p>>2];c[k+4>>2]=s;c[j+8>>2]=c[t>>2];t=c[h>>2]|0;c[h>>2]=t+16;j=e;e=c[j+4>>2]|0;s=t;c[s>>2]=c[j>>2];c[s+4>>2]=e;c[t+8>>2]=c[l>>2];l=c[h>>2]|0;c[h>>2]=l+16;t=f;e=c[t+4>>2]|0;s=l;c[s>>2]=c[t>>2];c[s+4>>2]=e;c[l+8>>2]=c[f+8>>2];Rc(b,(c[h>>2]|0)+-48|0,1,a[(c[b+16>>2]|0)+18>>0]&1);b=(c[o>>2]|0)+(d-q)|0;q=c[h>>2]|0;d=q+-16|0;c[h>>2]=d;h=d;d=c[h+4>>2]|0;o=b;c[o>>2]=c[h>>2];c[o+4>>2]=d;c[b+8>>2]=c[q+-8>>2];Pa=i;return}function gf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;b=c[a+16>>2]|0;d=b+24|0;e=c[d>>2]|0;f=b+28|0;g=c[(c[f>>2]|0)+-4>>2]|0;h=g&63;switch(g&63){case 12:case 7:case 6:case 21:case 19:case 18:case 17:case 16:case 15:case 14:case 13:{i=a+8|0;j=c[i>>2]|0;k=j+-16|0;c[i>>2]=k;i=g>>>6&255;l=k;k=c[l+4>>2]|0;m=e+(i<<4)|0;c[m>>2]=c[l>>2];c[m+4>>2]=k;c[e+(i<<4)+8>>2]=c[j+-8>>2];return}case 24:case 25:case 26:{j=a+8|0;i=c[j>>2]|0;switch(c[i+-8>>2]|0){case 0:{n=1;break}case 1:{n=(c[i+-16>>2]|0)==0;break}default:n=0}k=(n^1)&1;c[j>>2]=i+-16;if((h|0)==26){h=(Se(a,e+(g>>>23<<4)|0,14)|0)+8|0;o=(c[h>>2]|0)==0?n&1:k}else o=k;if((o|0)==(g>>>6&255|0))return;c[f>>2]=(c[f>>2]|0)+4;return}case 22:{f=a+8|0;o=c[f>>2]|0;k=o+-32|0;n=k-(e+(g>>>23<<4))|0;e=o+-16|0;h=c[e+4>>2]|0;i=o+-48|0;c[i>>2]=c[e>>2];c[i+4>>2]=h;c[o+-40>>2]=c[o+-8>>2];if((n|0)>16){c[f>>2]=k;df(a,n>>>4)}n=c[f>>2]|0;k=c[d>>2]|0;d=g>>>6&255;o=n+-16|0;h=c[o+4>>2]|0;i=k+(d<<4)|0;c[i>>2]=c[o>>2];c[i+4>>2]=h;c[k+(d<<4)+8>>2]=c[n+-8>>2];c[f>>2]=c[b+4>>2];return}case 34:{c[a+8>>2]=c[b+4>>2];return}case 29:{if(!(g&8372224))return;c[a+8>>2]=c[b+4>>2];return}default:return}}function hf(b){b=b|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,u=0,v=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0.0,ca=0.0,da=0.0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0;e=Pa;Pa=Pa+32|0;f=e+24|0;h=e+16|0;i=e+8|0;j=e;k=b+16|0;l=b+40|0;m=b+48|0;n=b+8|0;o=b+12|0;p=b+24|0;q=b+44|0;r=b+20|0;s=b+6|0;u=c[k>>2]|0;a:while(1){v=c[c[u>>2]>>2]|0;x=v+12|0;y=c[(c[x>>2]|0)+8>>2]|0;z=u+24|0;A=u+28|0;B=u+4|0;C=u+4|0;D=u+4|0;E=u+4|0;F=u+4|0;G=u+4|0;H=u+4|0;I=c[u+24>>2]|0;b:while(1){J=c[A>>2]|0;c[A>>2]=J+4;K=c[J>>2]|0;J=a[l>>0]|0;if((J&12)!=0?(L=(c[m>>2]|0)+-1|0,c[m>>2]=L,M=(L|0)!=0,!((J&4)==0&M)):0){N=c[k>>2]|0;L=J&255;if((L&8|0)==0|M)O=0;else{c[m>>2]=c[q>>2];O=1}P=N+18|0;M=d[P>>0]|0;if(!(M&128)){if(O)Oc(b,3,-1);do if(!(L&4)){J=N+28|0;Q=J;R=J}else{J=c[(c[c[N>>2]>>2]|0)+12>>2]|0;S=N+28|0;T=c[S>>2]|0;U=c[J+12>>2]|0;V=(T-U>>2)+-1|0;W=c[J+20>>2]|0;J=(W|0)==0;if(J)X=0;else X=c[W+(V<<2)>>2]|0;if(V|0?(V=c[r>>2]|0,V>>>0<T>>>0):0){if(J)Y=0;else Y=c[W+((V-U>>2)+-1<<2)>>2]|0;if((X|0)==(Y|0)){Q=S;R=S;break}}Oc(b,2,X);Q=S;R=S}while(0);c[r>>2]=c[R>>2];if((a[s>>0]|0)==1){Z=22;break a}}else a[P>>0]=M&127;_=c[z>>2]|0}else _=I;L=K>>>6&255;$=_+(L<<4)|0;c:do switch(K&63){case 31:{Z=149;break b;break}case 0:{S=K>>>23;U=_+(S<<4)|0;V=c[U+4>>2]|0;W=$;c[W>>2]=c[U>>2];c[W+4>>2]=V;c[_+(L<<4)+8>>2]=c[_+(S<<4)+8>>2];aa=_;break}case 1:{S=K>>>14;V=y+(S<<4)|0;W=c[V+4>>2]|0;U=$;c[U>>2]=c[V>>2];c[U+4>>2]=W;c[_+(L<<4)+8>>2]=c[y+(S<<4)+8>>2];aa=_;break}case 2:{S=c[A>>2]|0;c[A>>2]=S+4;W=(c[S>>2]|0)>>>6;S=y+(W<<4)|0;U=c[S+4>>2]|0;V=$;c[V>>2]=c[S>>2];c[V+4>>2]=U;c[_+(L<<4)+8>>2]=c[y+(W<<4)+8>>2];aa=_;break}case 3:{c[$>>2]=K>>>23;c[_+(L<<4)+8>>2]=1;if(!(K&8372224))aa=_;else{c[A>>2]=(c[A>>2]|0)+4;aa=_}break}case 4:{W=$;U=K>>>23;while(1){c[W+8>>2]=0;if(!U){aa=_;break}else{W=W+16|0;U=U+-1|0}}break}case 5:{U=c[(c[v+16+(K>>>23<<2)>>2]|0)+8>>2]|0;W=U;V=c[W+4>>2]|0;S=$;c[S>>2]=c[W>>2];c[S+4>>2]=V;c[_+(L<<4)+8>>2]=c[U+8>>2];aa=_;break}case 6:{U=K>>>14;_e(b,c[(c[v+16+(K>>>23<<2)>>2]|0)+8>>2]|0,(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0,$);aa=c[z>>2]|0;break}case 7:{U=K>>>14;_e(b,_+(K>>>23<<4)|0,(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0,$);aa=c[z>>2]|0;break}case 8:{U=K>>>23;V=K>>>14;$e(b,c[(c[v+16+(L<<2)>>2]|0)+8>>2]|0,(K|0)<0?y+((U&255)<<4)|0:_+(U<<4)|0,(K&4194304|0)==0?_+((V&511)<<4)|0:y+((V&255)<<4)|0);aa=c[z>>2]|0;break}case 9:{V=c[v+16+(K>>>23<<2)>>2]|0;U=c[V+8>>2]|0;S=$;W=c[S+4>>2]|0;J=U;c[J>>2]=c[S>>2];c[J+4>>2]=W;W=_+(L<<4)+8|0;c[U+8>>2]=c[W>>2];if(((c[W>>2]&64|0)!=0?(W=c[$>>2]|0,(a[W+5>>0]&3)!=0):0)?(a[V+5>>0]&4)!=0:0){jd(b,V,W);aa=_}else aa=_;break}case 10:{W=K>>>23;V=K>>>14;$e(b,$,(K|0)<0?y+((W&255)<<4)|0:_+(W<<4)|0,(K&4194304|0)==0?_+((V&511)<<4)|0:y+((V&255)<<4)|0);aa=c[z>>2]|0;break}case 11:{V=K>>>23;W=K>>>14&511;U=Le(b)|0;c[$>>2]=U;c[_+(L<<4)+8>>2]=69;if(W|V|0){J=Jd(V)|0;Fe(b,U,J,Jd(W)|0)}if((c[(c[o>>2]|0)+12>>2]|0)>0){c[n>>2]=$+16;Ed(b);c[n>>2]=c[E>>2]}aa=c[z>>2]|0;break}case 12:{W=K>>>23;J=_+(W<<4)|0;U=$+16|0;V=J;S=c[V+4>>2]|0;T=U;c[T>>2]=c[V>>2];c[T+4>>2]=S;c[U+8>>2]=c[_+(W<<4)+8>>2];W=K>>>14;_e(b,J,(K&4194304|0)==0?_+((W&511)<<4)|0:y+((W&255)<<4)|0,$);aa=c[z>>2]|0;break}case 13:{W=K>>>23;J=(K|0)<0?y+((W&255)<<4)|0:_+(W<<4)|0;W=K>>>14;U=(K&4194304|0)==0?_+((W&511)<<4)|0:y+((W&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[U+8>>2]|0)==3:0){g[$>>3]=+g[J>>3]+ +g[U>>3];c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,U,6);aa=c[z>>2]|0;break}case 14:{U=K>>>23;J=(K|0)<0?y+((U&255)<<4)|0:_+(U<<4)|0;U=K>>>14;W=(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[W+8>>2]|0)==3:0){g[$>>3]=+g[J>>3]-+g[W>>3];c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,W,7);aa=c[z>>2]|0;break}case 15:{W=K>>>23;J=(K|0)<0?y+((W&255)<<4)|0:_+(W<<4)|0;W=K>>>14;U=(K&4194304|0)==0?_+((W&511)<<4)|0:y+((W&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[U+8>>2]|0)==3:0){g[$>>3]=+g[J>>3]*+g[U>>3];c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,U,8);aa=c[z>>2]|0;break}case 16:{U=K>>>23;J=(K|0)<0?y+((U&255)<<4)|0:_+(U<<4)|0;U=K>>>14;W=(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[W+8>>2]|0)==3:0){g[$>>3]=+g[J>>3]/+g[W>>3];c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,W,9);aa=c[z>>2]|0;break}case 17:{W=K>>>23;J=(K|0)<0?y+((W&255)<<4)|0:_+(W<<4)|0;W=K>>>14;U=(K&4194304|0)==0?_+((W&511)<<4)|0:y+((W&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[U+8>>2]|0)==3:0){ba=+g[J>>3];ca=+g[U>>3];da=ba-ca*+t(+(ba/ca));g[$>>3]=da;c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,U,10);aa=c[z>>2]|0;break}case 18:{U=K>>>23;J=(K|0)<0?y+((U&255)<<4)|0:_+(U<<4)|0;U=K>>>14;W=(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0;if((c[J+8>>2]|0)==3?(c[W+8>>2]|0)==3:0){da=+w(+(+g[J>>3]),+(+g[W>>3]));g[$>>3]=da;c[_+(L<<4)+8>>2]=3;aa=_;break c}ff(b,$,J,W,11);aa=c[z>>2]|0;break}case 19:{W=K>>>23;J=_+(W<<4)|0;if((c[_+(W<<4)+8>>2]|0)==3){g[$>>3]=-+g[J>>3];c[_+(L<<4)+8>>2]=3;aa=_;break c}else{ff(b,$,J,J,12);aa=c[z>>2]|0;break c}break}case 20:{J=K>>>23;switch(c[_+(J<<4)+8>>2]|0){case 0:{ea=1;break}case 1:{ea=(c[_+(J<<4)>>2]|0)==0;break}default:ea=0}c[$>>2]=ea&1;c[_+(L<<4)+8>>2]=1;aa=_;break}case 21:{ef(b,$,_+(K>>>23<<4)|0);aa=c[z>>2]|0;break}case 22:{J=K>>>23;W=K>>>14&511;c[n>>2]=_+(W<<4)+16;df(b,1-J+W|0);W=c[z>>2]|0;U=W+(L<<4)|0;S=W+(J<<4)|0;T=S;V=c[T+4>>2]|0;fa=U;c[fa>>2]=c[T>>2];c[fa+4>>2]=V;c[W+(L<<4)+8>>2]=c[W+(J<<4)+8>>2];if((c[(c[o>>2]|0)+12>>2]|0)>0){c[n>>2]=L>>>0<J>>>0?S:U+16|0;Ed(b);U=c[C>>2]|0;c[n>>2]=U;ga=U}else ga=c[D>>2]|0;U=c[z>>2]|0;c[n>>2]=ga;aa=U;break}case 23:{if(L|0)fd(b,(c[z>>2]|0)+(L<<4)+-16|0);c[A>>2]=(c[A>>2]|0)+((K>>>14)+-131071<<2);aa=_;break}case 24:{U=K>>>23;S=(K|0)<0?y+((U&255)<<4)|0:_+(U<<4)|0;U=K>>>14;J=(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0;if((c[S+8>>2]|0)==(c[J+8>>2]|0))ha=(cf(b,S,J)|0)!=0;else ha=0;J=c[A>>2]|0;if((L|0)==(ha&1|0)){S=c[J>>2]|0;U=S>>>6&255;if(!U)ia=J;else{fd(b,(c[z>>2]|0)+(U<<4)+-16|0);ia=c[A>>2]|0}ja=ia+((S>>>14)+-131070<<2)|0}else ja=J+4|0;c[A>>2]=ja;aa=c[z>>2]|0;break}case 25:{J=K>>>23;S=K>>>14;U=(af(b,(K|0)<0?y+((J&255)<<4)|0:_+(J<<4)|0,(K&4194304|0)==0?_+((S&511)<<4)|0:y+((S&255)<<4)|0)|0)==(L|0);S=c[A>>2]|0;if(U){U=c[S>>2]|0;J=U>>>6&255;if(!J)ka=S;else{fd(b,(c[z>>2]|0)+(J<<4)+-16|0);ka=c[A>>2]|0}la=ka+((U>>>14)+-131070<<2)|0}else la=S+4|0;c[A>>2]=la;aa=c[z>>2]|0;break}case 26:{S=K>>>23;U=K>>>14;J=(bf(b,(K|0)<0?y+((S&255)<<4)|0:_+(S<<4)|0,(K&4194304|0)==0?_+((U&511)<<4)|0:y+((U&255)<<4)|0)|0)==(L|0);U=c[A>>2]|0;if(J){J=c[U>>2]|0;S=J>>>6&255;if(!S)ma=U;else{fd(b,(c[z>>2]|0)+(S<<4)+-16|0);ma=c[A>>2]|0}na=ma+((J>>>14)+-131070<<2)|0}else na=U+4|0;c[A>>2]=na;aa=c[z>>2]|0;break}case 27:{U=c[_+(L<<4)+8>>2]|0;J=(U|0)==0;if(!(K&8372224)){if(!J)if(!((U|0)==1?!(c[$>>2]|0):0))Z=115}else if(!J){if((U|0)==1?(c[$>>2]|0)==0:0)Z=115}else Z=115;if((Z|0)==115){Z=0;c[A>>2]=(c[A>>2]|0)+4;aa=_;break c}U=c[A>>2]|0;J=c[U>>2]|0;S=J>>>6&255;if(!S)oa=U;else{fd(b,(c[z>>2]|0)+(S<<4)+-16|0);oa=c[A>>2]|0}c[A>>2]=oa+((J>>>14)+-131070<<2);aa=_;break}case 28:{J=K>>>23;S=_+(J<<4)|0;U=c[_+(J<<4)+8>>2]|0;J=(U|0)==0;if(!(K&8372224))if(!J)if((U|0)==1?(c[S>>2]|0)==0:0)Z=127;else Z=126;else Z=127;else if(!J)if((U|0)==1?(c[S>>2]|0)==0:0)Z=126;else Z=127;else Z=126;if((Z|0)==126){Z=0;pa=(c[A>>2]|0)+4|0}else if((Z|0)==127){Z=0;J=S;S=c[J+4>>2]|0;W=$;c[W>>2]=c[J>>2];c[W+4>>2]=S;c[_+(L<<4)+8>>2]=U;U=c[A>>2]|0;S=c[U>>2]|0;W=S>>>6&255;if(!W)qa=U;else{fd(b,(c[z>>2]|0)+(W<<4)+-16|0);qa=c[A>>2]|0}pa=qa+((S>>>14)+-131070<<2)|0}c[A>>2]=pa;aa=_;break}case 29:{S=K>>>23;W=K>>>14&511;if(S|0)c[n>>2]=$+(S<<4);if(!(Pc(b,$,W+-1|0)|0)){Z=137;break b}if(W|0)c[n>>2]=c[G>>2];aa=c[z>>2]|0;break}case 30:{W=K>>>23;if(W|0)c[n>>2]=$+(W<<4);if(!(Pc(b,$,-1)|0)){Z=142;break b}aa=c[z>>2]|0;break}case 32:{da=+g[$+32>>3];ca=da+ +g[$>>3];ba=+g[$+16>>3];if(da>0.0){if(!(ca<=ba)){aa=_;break c}}else if(!(ba<=ca)){aa=_;break c}c[A>>2]=(c[A>>2]|0)+((K>>>14)+-131071<<2);g[$>>3]=ca;c[_+(L<<4)+8>>2]=3;W=$+48|0;g[W>>3]=ca;c[W+8>>2]=3;aa=_;break}case 33:{W=$+16|0;S=$+32|0;U=_+(L<<4)+8|0;J=c[U>>2]|0;if((J|0)!=3){if((J&15|0)!=4){Z=164;break a}J=c[$>>2]|0;if(!(Nd(J+16|0,c[J+12>>2]|0,j)|0)){Z=164;break a}g[$>>3]=+g[j>>3];c[U>>2]=3}J=W+8|0;V=c[J>>2]|0;if((V|0)!=3){if((V&15|0)!=4){Z=169;break a}V=c[W>>2]|0;if(!(Nd(V+16|0,c[V+12>>2]|0,j)|0)){Z=169;break a}g[W>>3]=+g[j>>3];c[J>>2]=3}J=S+8|0;W=c[J>>2]|0;if((W|0)==3)ra=S;else{if((W&15|0)!=4){Z=175;break a}W=c[S>>2]|0;if(!(Nd(W+16|0,c[W+12>>2]|0,j)|0)){Z=175;break a}g[S>>3]=+g[j>>3];c[J>>2]=3;ra=S}g[$>>3]=+g[$>>3]-+g[ra>>3];c[U>>2]=3;c[A>>2]=(c[A>>2]|0)+((K>>>14)+-131071<<2);aa=_;break}case 34:{U=$+48|0;S=$+32|0;J=U+32|0;W=S;V=c[W+4>>2]|0;fa=J;c[fa>>2]=c[W>>2];c[fa+4>>2]=V;c[J+8>>2]=c[S+8>>2];S=$+16|0;J=U+16|0;V=S;fa=c[V+4>>2]|0;W=J;c[W>>2]=c[V>>2];c[W+4>>2]=fa;c[J+8>>2]=c[S+8>>2];S=$;J=c[S+4>>2]|0;fa=U;c[fa>>2]=c[S>>2];c[fa+4>>2]=J;c[U+8>>2]=c[_+(L<<4)+8>>2];c[n>>2]=U+48;Rc(b,U,K>>>14&511,1);U=c[z>>2]|0;c[n>>2]=c[B>>2];J=c[A>>2]|0;c[A>>2]=J+4;fa=c[J>>2]|0;sa=fa;ta=U;ua=U+((fa>>>6&255)<<4)|0;Z=178;break}case 35:{sa=K;ta=_;ua=$;Z=178;break}case 36:{fa=K>>>23;U=K>>>14&511;if(!fa)va=((c[n>>2]|0)-$>>4)+-1|0;else va=fa;if(!U){fa=c[A>>2]|0;c[A>>2]=fa+4;wa=(c[fa>>2]|0)>>>6}else wa=U;U=c[$>>2]|0;fa=va+-50+(wa*50|0)|0;if((fa|0)>(c[U+28>>2]|0))Ke(b,U,fa);if((va|0)>0){J=U+5|0;S=fa;fa=va;while(1){W=$+(fa<<4)|0;Ie(b,U,S,W);S=S+-1|0;if((c[W+8>>2]&64|0?a[(c[W>>2]|0)+5>>0]&3:0)?a[J>>0]&4:0)ld(b,U);if((fa|0)<=1)break;else fa=fa+-1|0}}c[n>>2]=c[H>>2];aa=_;break}case 37:{fa=c[(c[(c[x>>2]|0)+16>>2]|0)+(K>>>14<<2)>>2]|0;U=fa+32|0;J=c[U>>2]|0;S=c[fa+40>>2]|0;W=c[fa+28>>2]|0;d:do if(!J)Z=202;else{if((S|0)>0){V=J+16|0;T=0;do{xa=d[W+(T<<3)+5>>0]|0;if(!(a[W+(T<<3)+4>>0]|0))ya=c[(c[v+16+(xa<<2)>>2]|0)+8>>2]|0;else ya=_+(xa<<4)|0;if((c[(c[V+(T<<2)>>2]|0)+8>>2]|0)!=(ya|0)){Z=202;break d}T=T+1|0}while((T|0)<(S|0))}c[$>>2]=J;c[_+(L<<4)+8>>2]=70}while(0);if((Z|0)==202){Z=0;J=bd(b,S)|0;c[J+12>>2]=fa;c[$>>2]=J;c[_+(L<<4)+8>>2]=70;if((S|0)>0){T=J+16|0;V=0;do{xa=d[W+(V<<3)+5>>0]|0;if(!(a[W+(V<<3)+4>>0]|0))c[T+(V<<2)>>2]=c[v+16+(xa<<2)>>2];else{za=dd(b,_+(xa<<4)|0)|0;c[T+(V<<2)>>2]=za}V=V+1|0}while((V|0)!=(S|0))}if(a[fa+5>>0]&4)md(b,fa,J);c[U>>2]=J}if((c[(c[o>>2]|0)+12>>2]|0)>0){c[n>>2]=$+16;Ed(b);c[n>>2]=c[F>>2]}aa=c[z>>2]|0;break}case 38:{S=K>>>23;V=S+-1|0;T=(_-(c[u>>2]|0)>>4)-(d[(c[x>>2]|0)+76>>0]|0)|0;W=T+-1|0;if(!S){if(((c[p>>2]|0)-(c[n>>2]|0)>>4|0)<(T|0))Mc(b,W);S=c[z>>2]|0;za=S+(L<<4)|0;c[n>>2]=za+(W<<4);Aa=W;Ba=S;Ca=za}else{Aa=V;Ba=_;Ca=$}if((Aa|0)>0){V=Ba+(1-T<<4)|0;T=0;do{if((T|0)<(W|0)){za=V+(T<<4)|0;S=za;xa=c[S+4>>2]|0;Da=Ca+(T<<4)|0;c[Da>>2]=c[S>>2];c[Da+4>>2]=xa;Ea=c[za+8>>2]|0}else Ea=0;c[Ca+(T<<4)+8>>2]=Ea;T=T+1|0}while((T|0)!=(Aa|0));aa=Ba}else aa=Ba;break}default:aa=_}while(0);if((Z|0)==178){Z=0;L=c[ua+24>>2]|0;if(!L)aa=ta;else{M=ua+16|0;T=c[M+4>>2]|0;V=ua;c[V>>2]=c[M>>2];c[V+4>>2]=T;c[ua+8>>2]=L;c[A>>2]=(c[A>>2]|0)+((sa>>>14)+-131071<<2);aa=ta}}I=aa}if((Z|0)==137){Z=0;I=c[k>>2]|0;A=I+18|0;a[A>>0]=a[A>>0]|4;Fa=I}else if((Z|0)==142){Z=0;I=c[k>>2]|0;A=c[I+8>>2]|0;z=c[I>>2]|0;F=c[A>>2]|0;v=I+24|0;H=(c[v>>2]|0)+(d[(c[(c[z>>2]|0)+12>>2]|0)+76>>0]<<4)|0;if((c[(c[x>>2]|0)+56>>2]|0)>0)fd(b,c[A+24>>2]|0);if(z>>>0<H>>>0){B=0;G=z;do{y=G;D=c[y+4>>2]|0;C=F+(B<<4)|0;c[C>>2]=c[y>>2];c[C+4>>2]=D;c[F+(B<<4)+8>>2]=c[z+(B<<4)+8>>2];B=B+1|0;G=z+(B<<4)|0}while(G>>>0<H>>>0)}H=z;c[A+24>>2]=F+((c[v>>2]|0)-H>>4<<4);G=F+((c[n>>2]|0)-H>>4<<4)|0;c[n>>2]=G;c[A+4>>2]=G;c[A+28>>2]=c[I+28>>2];G=A+18|0;a[G>>0]=a[G>>0]|64;c[k>>2]=A;Fa=A}else if((Z|0)==149){Z=0;G=K>>>23;if(G|0)c[n>>2]=$+(G<<4)+-16;if((c[(c[x>>2]|0)+56>>2]|0)>0)fd(b,_);G=Qc(b,$)|0;if(!(a[u+18>>0]&4)){Z=225;break}H=c[k>>2]|0;if(!G)Fa=H;else{c[n>>2]=c[H+4>>2];Fa=H}}u=Fa}if((Z|0)==22){if(!O){Ga=c[Q>>2]|0;Ha=Ga+-4|0;c[Q>>2]=Ha;Ia=a[P>>0]|0;Ja=Ia|-128;a[P>>0]=Ja;Ka=c[n>>2]|0;La=Ka+-16|0;c[N>>2]=La;Jc(b,1)}c[m>>2]=1;Ga=c[Q>>2]|0;Ha=Ga+-4|0;c[Q>>2]=Ha;Ia=a[P>>0]|0;Ja=Ia|-128;a[P>>0]=Ja;Ka=c[n>>2]|0;La=Ka+-16|0;c[N>>2]=La;Jc(b,1)}else if((Z|0)==164)Dc(b,7966,i);else if((Z|0)==169)Dc(b,8003,h);else if((Z|0)==175)Dc(b,8032,f);else if((Z|0)==225){Pa=e;return}}function jf(a){a=a|0;var b=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+16|0;e=b;f=Va[c[a+8>>2]&255](c[a+16>>2]|0,c[a+12>>2]|0,e)|0;g=c[e>>2]|0;if((f|0)==0|(g|0)==0){h=-1;Pa=b;return h|0}c[a>>2]=g+-1;c[a+4>>2]=f+1;h=d[f>>0]|0;Pa=b;return h|0}function kf(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;c[b+16>>2]=a;c[b+8>>2]=d;c[b+12>>2]=e;c[b>>2]=0;c[b+4>>2]=0;return}function lf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;e=Pa;Pa=Pa+16|0;f=e;if(!d){g=0;Pa=e;return g|0}h=a+16|0;i=a+8|0;j=a+12|0;k=a+4|0;l=d;d=b;b=c[a>>2]|0;while(1){if(!b){m=Va[c[i>>2]&255](c[h>>2]|0,c[j>>2]|0,f)|0;n=c[f>>2]|0;if((m|0)==0|(n|0)==0){g=l;o=8;break}c[a>>2]=n;c[k>>2]=m;p=n;q=m}else{p=b;q=c[k>>2]|0}m=l>>>0>p>>>0?p:l;Un(d|0,q|0,m|0)|0;b=(c[a>>2]|0)-m|0;c[a>>2]=b;c[k>>2]=(c[k>>2]|0)+m;l=l-m|0;if(!l){g=0;o=8;break}else d=d+m|0}if((o|0)==8){Pa=e;return g|0}return 0}function mf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=b+8|0;f=c[e>>2]|0;if(f>>>0>=d>>>0){g=c[b>>2]|0;return g|0}h=d>>>0>32?d:32;if((h+1|0)>>>0>4294967293)Gd(a);d=Hd(a,c[b>>2]|0,f,h)|0;c[b>>2]=d;c[e>>2]=h;g=d;return g|0}function nf(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;g=Pa;Pa=Pa+256|0;h=g+40|0;i=g+32|0;j=g+24|0;k=g+16|0;l=g+8|0;m=g;n=g+148|0;o=g+48|0;p=gb(b)|0;q=1;r=1;while(1)if(!(xc(d,r,n)|0))break;else{s=r;r=r<<1;q=s}if((q|0)<(r|0)){s=r;t=q;while(1){q=(s+t|0)/2|0;u=(xc(d,q,n)|0)==0;v=u?q:s;t=u?t:q+1|0;if((t|0)>=(v|0)){w=v;break}else s=v}}else w=r;r=(w|0)>23?12:0;if(e|0){c[m>>2]=e;Kb(b,10714,m)|0}Hb(b,8060,16)|0;if(!(xc(d,f,o)|0)){x=gb(b)|0;y=x-p|0;mc(b,y);Pa=g;return}m=w+-11|0;w=o+36|0;e=o+20|0;s=o+8|0;t=o+12|0;n=o+35|0;v=o+4|0;q=o+24|0;u=f;while(1){f=u+1|0;if((f|0)==(r|0)){Hb(b,8077,5)|0;z=m}else{Ac(d,8083,o)|0;c[l>>2]=w;Kb(b,8088,l)|0;A=c[e>>2]|0;if((A|0)>0){c[k>>2]=A;Kb(b,8094,k)|0}Hb(b,8098,4)|0;a:do if(!(a[c[s>>2]>>0]|0))switch(a[c[t>>2]>>0]|0){case 109:{Hb(b,8117,10)|0;break a;break}case 67:{if(!(of(b,o)|0)){Hb(b,13353,1)|0;break a}else{A=yb(b,-1,0)|0;c[i>>2]=A;Kb(b,8103,i)|0;ib(b,-2);break a}break}default:{A=c[q>>2]|0;c[h>>2]=w;c[h+4>>2]=A;Kb(b,8128,h)|0;break a}}else{c[j>>2]=c[v>>2];Kb(b,8103,j)|0}while(0);if(a[n>>0]|0)Hb(b,8145,20)|0;mc(b,(gb(b)|0)-p|0);z=f}if(!(xc(d,z,o)|0))break;else u=z}x=gb(b)|0;y=x-p|0;mc(b,y);Pa=g;return}function of(a,b){a=a|0;b=b|0;var c=0,d=0;c=gb(a)|0;Ac(a,13112,b)|0;Tb(a,-1001e3,2);b=c+1|0;if(!(pf(a,b,2)|0)){hb(a,c);d=0;return d|0}else{lb(a,-1,b);hb(a,-3);d=1;return d|0}return 0}function pf(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0;if(!c){d=0;return d|0}if((nb(a,-1)|0)!=5){d=0;return d|0}Db(a);if(!(lc(a,-2)|0)){d=0;return d|0}e=c+-1|0;while(1){if((nb(a,-2)|0)==4){if(sb(a,b,-1)|0){f=7;break}if(pf(a,b,e)|0){f=9;break}}hb(a,-2);if(!(lc(a,-2)|0)){d=0;f=11;break}}if((f|0)==7){hb(a,-2);d=1;return d|0}else if((f|0)==9){ib(a,-2);Hb(a,13528,1)|0;jb(a,-2);mc(a,3);d=1;return d|0}else if((f|0)==11)return d|0;return 0}function qf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=Pa;Pa=Pa+128|0;f=e+16|0;g=e+8|0;h=e;i=e+28|0;if(!(xc(a,0,i)|0)){c[h>>2]=b;c[h+4>>2]=d;j=rf(a,8166,h)|0;Pa=e;return j|0}Ac(a,12581,i)|0;if(!(Cl(c[i+8>>2]|0,8188)|0)){h=b+-1|0;if(!h){c[g>>2]=c[i+4>>2];c[g+4>>2]=d;j=rf(a,8195,g)|0;Pa=e;return j|0}else k=h}else k=b;b=i+4|0;h=c[b>>2]|0;if(!h){if(!(of(a,i)|0))l=13353;else l=yb(a,-1,0)|0;c[b>>2]=l;m=l}else m=h;c[f>>2]=k;c[f+4>>2]=m;c[f+8>>2]=d;j=rf(a,8225,f)|0;Pa=e;return j|0}function rf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Pa;Pa=Pa+128|0;f=e+16|0;g=e+24|0;h=e;c[h>>2]=d;if(xc(a,1,g)|0?(Ac(a,8255,g)|0,d=c[g+20>>2]|0,(d|0)>0):0){c[f>>2]=g+36;c[f+4>>2]=d;Kb(a,8258,f)|0;Jb(a,b,h)|0;mc(a,2);kc(a)|0}Hb(a,16476,0)|0;Jb(a,b,h)|0;mc(a,2);kc(a)|0;return 0}function sf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=Pa;Pa=Pa+112|0;e=d;f=d+8|0;if(xc(a,b,f)|0?(Ac(a,8255,f)|0,b=c[f+20>>2]|0,(b|0)>0):0){c[e>>2]=f+36;c[e+4>>2]=b;Kb(a,8258,e)|0;Pa=d;return}Hb(a,16476,0)|0;Pa=d;return}function tf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;e=Pa;Pa=Pa+16|0;f=e;g=Qk()|0;h=c[g>>2]|0;if(b|0){Mb(a,1);i=1;Pa=e;return i|0}Db(a);b=bl(h)|0;if(!d)Ib(a,b)|0;else{c[f>>2]=d;c[f+4>>2]=b;Kb(a,8266,f)|0}Fb(a,h);i=3;Pa=e;return i|0}function uf(a,b){a=a|0;b=b|0;var d=0,e=0;switch(b|0){case -1:{d=Qk()|0;e=c[d>>2]|0;Db(a);Ib(a,bl(e)|0)|0;Fb(a,e);return 3}case 0:{Mb(a,1);break}default:Db(a)}Ib(a,11419)|0;Fb(a,b);return 3}function vf(a,b){a=a|0;b=b|0;var c=0;Rb(a,-1001e3,b);if(nb(a,-1)|0){c=0;return c|0}hb(a,-2);Ub(a,0,0);mb(a,-1);Zb(a,-1001e3,b);c=1;return c|0}function wf(a,b){a=a|0;b=b|0;Rb(a,-1001e3,b);ac(a,-2)|0;return}function xf(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=Ab(a,b)|0;if(!d){e=0;return e|0}if(!(Vb(a,b)|0)){e=0;return e|0}Rb(a,-1001e3,c);c=(sb(a,-1,-2)|0)==0;hb(a,-3);e=c?0:d;return e|0}function yf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;e=Pa;Pa=Pa+16|0;f=e;g=Ab(a,b)|0;if((g|0?Vb(a,b)|0:0)?(Rb(a,-1001e3,d),h=(sb(a,-1,-2)|0)==0,hb(a,-3),!h):0){i=g;Pa=e;return i|0}g=ob(a,nb(a,b)|0)|0;c[f>>2]=d;c[f+4>>2]=g;qf(a,b,Kb(a,8273,f)|0)|0;i=0;Pa=e;return i|0}function zf(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;f=Pa;Pa=Pa+16|0;g=f+8|0;h=f;if(!d){i=yb(a,b,0)|0;if(!i){j=ob(a,4)|0;k=ob(a,nb(a,b)|0)|0;c[h>>2]=j;c[h+4>>2]=k;qf(a,b,Kb(a,8273,h)|0)|0;l=0}else l=i}else l=Af(a,b,d,0)|0;d=c[e>>2]|0;a:do if(d|0){i=0;h=d;while(1){if(!(Cl(h,l)|0)){m=i;break}i=i+1|0;h=c[e+(i<<2)>>2]|0;if(!h)break a}Pa=f;return m|0}while(0);c[g>>2]=l;m=qf(a,b,Kb(a,8293,g)|0)|0;Pa=f;return m|0}function Af(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;f=Pa;Pa=Pa+16|0;g=f;if((nb(a,b)|0)>=1){h=yb(a,b,e)|0;if(h|0){i=h;Pa=f;return i|0}h=ob(a,4)|0;j=ob(a,nb(a,b)|0)|0;c[g>>2]=h;c[g+4>>2]=j;qf(a,b,Kb(a,8273,g)|0)|0;i=0;Pa=f;return i|0}if(!e){i=d;Pa=f;return i|0}if(!d)k=0;else k=_l(d)|0;c[e>>2]=k;i=d;Pa=f;return i|0}function Bf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Pa;Pa=Pa+16|0;f=e;g=yb(a,b,d)|0;if(g|0){Pa=e;return g|0}d=ob(a,4)|0;h=ob(a,nb(a,b)|0)|0;c[f>>2]=d;c[f+4>>2]=h;qf(a,b,Kb(a,8273,f)|0)|0;Pa=e;return g|0}function Cf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;if(ab(a,b+20|0)|0){Pa=e;return}if(!d){rf(a,9456,e+8|0)|0;Pa=e;return}else{c[f>>2]=d;rf(a,8313,f)|0;Pa=e;return}}function Df(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=Pa;Pa=Pa+16|0;f=e;if((nb(a,b)|0)==(d|0)){Pa=e;return}g=ob(a,d)|0;d=ob(a,nb(a,b)|0)|0;c[f>>2]=g;c[f+4>>2]=d;qf(a,b,Kb(a,8273,f)|0)|0;Pa=e;return}function Ef(a,b){a=a|0;b=b|0;if((nb(a,b)|0)!=-1)return;qf(a,b,9441)|0;return}function Ff(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0.0,h=0;d=Pa;Pa=Pa+16|0;e=d;f=d+8|0;g=+ub(a,b,f);if(c[f>>2]|0){Pa=d;return +g}f=ob(a,3)|0;h=ob(a,nb(a,b)|0)|0;c[e>>2]=f;c[e+4>>2]=h;qf(a,b,Kb(a,8273,e)|0)|0;Pa=d;return +g}function Gf(a,b,d){a=a|0;b=b|0;d=+d;var e=0,f=0,g=0,h=0.0,i=0;e=Pa;Pa=Pa+16|0;f=e;g=e+8|0;if((nb(a,b)|0)<1){h=d;Pa=e;return +h}d=+ub(a,b,g);if(!(c[g>>2]|0)){g=ob(a,3)|0;i=ob(a,nb(a,b)|0)|0;c[f>>2]=g;c[f+4>>2]=i;qf(a,b,Kb(a,8273,f)|0)|0}h=d;Pa=e;return +h}function Hf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;d=Pa;Pa=Pa+16|0;e=d;f=d+8|0;g=vb(a,b,f)|0;if(c[f>>2]|0){Pa=d;return g|0}f=ob(a,3)|0;h=ob(a,nb(a,b)|0)|0;c[e>>2]=f;c[e+4>>2]=h;qf(a,b,Kb(a,8273,e)|0)|0;Pa=d;return g|0}function If(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;d=Pa;Pa=Pa+16|0;e=d;f=d+8|0;g=wb(a,b,f)|0;if(c[f>>2]|0){Pa=d;return g|0}f=ob(a,3)|0;h=ob(a,nb(a,b)|0)|0;c[e>>2]=f;c[e+4>>2]=h;qf(a,b,Kb(a,8273,e)|0)|0;Pa=d;return g|0}function Jf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;e=Pa;Pa=Pa+16|0;f=e;g=e+8|0;if((nb(a,b)|0)<1){h=d;Pa=e;return h|0}d=vb(a,b,g)|0;if(!(c[g>>2]|0)){g=ob(a,3)|0;i=ob(a,nb(a,b)|0)|0;c[f>>2]=g;c[f+4>>2]=i;qf(a,b,Kb(a,8273,f)|0)|0}h=d;Pa=e;return h|0}function Kf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;d=Pa;Pa=Pa+16|0;e=c[a+12>>2]|0;f=a+4|0;g=c[f>>2]|0;h=a+8|0;i=c[h>>2]|0;if((g-i|0)>>>0>=b>>>0){j=c[a>>2]|0;k=i;l=j+k|0;Pa=d;return l|0}m=g<<1;g=(m-i|0)>>>0<b>>>0?i+b|0:m;if(g>>>0<i>>>0|(g-i|0)>>>0<b>>>0)rf(e,8333,d)|0;b=oc(e,g)|0;Un(b|0,c[a>>2]|0,c[h>>2]|0)|0;if((c[a>>2]|0)!=(a+16|0))ib(e,-2);c[a>>2]=b;c[f>>2]=g;j=b;k=c[h>>2]|0;l=j+k|0;Pa=d;return l|0}function Lf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;e=Pa;Pa=Pa+16|0;f=c[a+12>>2]|0;g=a+4|0;h=c[g>>2]|0;i=a+8|0;j=c[i>>2]|0;if((h-j|0)>>>0>=d>>>0){k=c[a>>2]|0;l=j;m=k+l|0;Un(m|0,b|0,d|0)|0;n=c[i>>2]|0;o=n+d|0;c[i>>2]=o;Pa=e;return}p=h<<1;h=(p-j|0)>>>0<d>>>0?j+d|0:p;if(h>>>0<j>>>0|(h-j|0)>>>0<d>>>0)rf(f,8333,e)|0;j=oc(f,h)|0;Un(j|0,c[a>>2]|0,c[i>>2]|0)|0;if((c[a>>2]|0)!=(a+16|0))ib(f,-2);c[a>>2]=j;c[g>>2]=h;k=j;l=c[i>>2]|0;m=k+l|0;Un(m|0,b|0,d|0)|0;n=c[i>>2]|0;o=n+d|0;c[i>>2]=o;Pa=e;return}function Mf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;d=Pa;Pa=Pa+16|0;e=_l(b)|0;f=c[a+12>>2]|0;g=a+4|0;h=c[g>>2]|0;i=a+8|0;j=c[i>>2]|0;if((h-j|0)>>>0>=e>>>0){k=c[a>>2]|0;l=j;m=k+l|0;Un(m|0,b|0,e|0)|0;n=c[i>>2]|0;o=n+e|0;c[i>>2]=o;Pa=d;return}p=h<<1;h=(p-j|0)>>>0<e>>>0?j+e|0:p;if(h>>>0<j>>>0|(h-j|0)>>>0<e>>>0)rf(f,8333,d)|0;j=oc(f,h)|0;Un(j|0,c[a>>2]|0,c[i>>2]|0)|0;if((c[a>>2]|0)!=(a+16|0))ib(f,-2);c[a>>2]=j;c[g>>2]=h;k=j;l=c[i>>2]|0;m=k+l|0;Un(m|0,b|0,e|0)|0;n=c[i>>2]|0;o=n+e|0;c[i>>2]=o;Pa=d;return}function Nf(a){a=a|0;var b=0;b=c[a+12>>2]|0;Hb(b,c[a>>2]|0,c[a+8>>2]|0)|0;if((c[a>>2]|0)==(a+16|0))return;ib(b,-2);return}function Of(a,b){a=a|0;b=b|0;var d=0,e=0;d=a+8|0;e=(c[d>>2]|0)+b|0;c[d>>2]=e;d=c[a+12>>2]|0;Hb(d,c[a>>2]|0,e)|0;if((c[a>>2]|0)==(a+16|0))return;ib(d,-2);return}function Pf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;b=Pa;Pa=Pa+16|0;d=b+4|0;e=a+12|0;f=c[e>>2]|0;g=yb(f,-1,d)|0;h=a+16|0;if((c[a>>2]|0)!=(h|0))jb(f,-2);i=c[d>>2]|0;d=c[e>>2]|0;e=a+4|0;j=c[e>>2]|0;k=a+8|0;l=c[k>>2]|0;if((j-l|0)>>>0>=i>>>0){m=c[a>>2]|0;n=l;o=m+n|0;Un(o|0,g|0,i|0)|0;p=c[k>>2]|0;q=p+i|0;c[k>>2]=q;r=c[a>>2]|0;s=(r|0)==(h|0);t=s?-1:-2;ib(f,t);Pa=b;return}u=j<<1;j=(u-l|0)>>>0<i>>>0?l+i|0:u;if(j>>>0<l>>>0|(j-l|0)>>>0<i>>>0)rf(d,8333,b)|0;l=oc(d,j)|0;Un(l|0,c[a>>2]|0,c[k>>2]|0)|0;if((c[a>>2]|0)!=(h|0))ib(d,-2);c[a>>2]=l;c[e>>2]=j;m=l;n=c[k>>2]|0;o=m+n|0;Un(o|0,g|0,i|0)|0;p=c[k>>2]|0;q=p+i|0;c[k>>2]=q;r=c[a>>2]|0;s=(r|0)==(h|0);t=s?-1:-2;ib(f,t);Pa=b;return}function Qf(a,b){a=a|0;b=b|0;c[b+12>>2]=a;c[b>>2]=b+16;c[b+8>>2]=0;c[b+4>>2]=1024;return}function Rf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;c[b+12>>2]=a;e=b+16|0;c[b>>2]=e;f=b+8|0;c[f>>2]=0;g=b+4|0;c[g>>2]=1024;if(d>>>0<=1024){h=e;i=0;j=h+i|0;return j|0}k=d>>>0>2048?d:2048;d=oc(a,k)|0;Un(d|0,c[b>>2]|0,c[f>>2]|0)|0;if((c[b>>2]|0)!=(e|0))ib(a,-2);c[b>>2]=d;c[g>>2]=k;h=d;i=c[f>>2]|0;j=h+i|0;return j|0}function Sf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;f=Pa;Pa=Pa+1088|0;g=f+40|0;h=f+24|0;i=f+8|0;j=f;k=f+56|0;l=f+52|0;m=(gb(b)|0)+1|0;if(d){c[j>>2]=d;Kb(b,8357,j)|0;j=qm(d,13355)|0;c[k+4>>2]=j;if(!j){j=Qk()|0;n=bl(c[j>>2]|0)|0;j=(yb(b,m,0)|0)+1|0;c[i>>2]=11062;c[i+4>>2]=j;c[i+8>>2]=n;Kb(b,8361,i)|0;ib(b,m);o=7;Pa=f;return o|0}}else{Hb(b,8350,6)|0;c[k+4>>2]=c[1401]}if(Tf(k,l)|0){i=c[k>>2]|0;c[k>>2]=i+1;a[k+8+i>>0]=10}i=c[l>>2]|0;n=(d|0)!=0;do if(n&(i|0)==27){j=k+4|0;p=xm(d,8378,c[j>>2]|0)|0;c[j>>2]=p;if(p|0){Tf(k,l)|0;q=c[l>>2]|0;break}p=Qk()|0;j=bl(c[p>>2]|0)|0;p=(yb(b,m,0)|0)+1|0;c[h>>2]=8381;c[h+4>>2]=p;c[h+8>>2]=j;Kb(b,8361,h)|0;ib(b,m);o=7;Pa=f;return o|0}else q=i;while(0);if((q|0)!=-1){i=c[k>>2]|0;c[k>>2]=i+1;a[k+8+i>>0]=q}q=gc(b,134,k,yb(b,-1,0)|0,e)|0;e=c[k+4>>2]|0;k=mm(e)|0;if(n)bm(e)|0;if(!k){ib(b,m);o=q;Pa=f;return o|0}else{hb(b,m);q=Qk()|0;k=bl(c[q>>2]|0)|0;q=(yb(b,m,0)|0)+1|0;c[g>>2]=10810;c[g+4>>2]=q;c[g+8>>2]=k;Kb(b,8361,g)|0;ib(b,m);o=7;Pa=f;return o|0}return 0}function Tf(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;c[b>>2]=0;e=b+4|0;f=Am(c[e>>2]|0)|0;a:do switch(f|0){case -1:{g=0;h=f;break}case 239:{i=c[b>>2]|0;c[b>>2]=i+1;a[b+8+i>>0]=-17;i=Am(c[e>>2]|0)|0;switch(i|0){case -1:{g=0;h=i;break a;break}case 187:break;default:{j=i;k=5;break a}}i=c[b>>2]|0;c[b>>2]=i+1;a[b+8+i>>0]=-69;i=Am(c[e>>2]|0)|0;switch(i|0){case -1:{g=0;h=i;break a;break}case 191:break;default:{j=i;k=5;break a}}a[(c[b>>2]|0)+(b+8)>>0]=-65;c[b>>2]=0;j=Am(c[e>>2]|0)|0;k=5;break}default:{j=f;k=5}}while(0);if((k|0)==5){c[d>>2]=j;if((j|0)!=35){l=0;return l|0}b:while(1)switch(Am(c[e>>2]|0)|0){case 10:case -1:{break b;break}default:{}}g=1;h=Am(c[e>>2]|0)|0}c[d>>2]=h;l=g;return l|0}function Uf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;a=c[b>>2]|0;if((a|0)>0){c[d>>2]=a;c[b>>2]=0;e=b+8|0;return e|0}a=b+4|0;if(Im(c[a>>2]|0)|0){e=0;return e|0}f=b+8|0;b=Lm(f,1,1024,c[a>>2]|0)|0;c[d>>2]=b;e=f;return e|0}function Vf(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;g=Pa;Pa=Pa+16|0;h=g;c[h>>2]=b;c[h+4>>2]=d;d=gc(a,135,h,e,f)|0;Pa=g;return d|0}function Wf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;a=b+4|0;e=c[a>>2]|0;if(!e){f=0;return f|0}c[d>>2]=e;c[a>>2]=0;f=c[b>>2]|0;return f|0}function Xf(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;if(!(Vb(a,b)|0)){d=0;return d|0}Ib(a,c)|0;Sb(a,-2);if(!(nb(a,-1)|0)){hb(a,-3);d=0;return d|0}else{ib(a,-2);d=1;return d|0}return 0}function Yf(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=fb(a,b)|0;if(!(Vb(a,d)|0)){e=0;return e|0}Ib(a,c)|0;Sb(a,-2);if(!(nb(a,-1)|0)){hb(a,-3);e=0;return e|0}else{ib(a,-2);mb(a,d);dc(a,1,1,0,0);e=1;return e|0}return 0}function Zf(a,b){a=a|0;b=b|0;var d=0,e=0;d=Pa;Pa=Pa+16|0;e=d+4|0;nc(a,b);b=vb(a,-1,e)|0;if(!(c[e>>2]|0))rf(a,8388,d)|0;hb(a,-2);Pa=d;return b|0}function _f(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Pa;Pa=Pa+16|0;f=e;a:do if(!(Yf(a,b,10834)|0))switch(nb(a,b)|0){case 4:case 3:{mb(a,b);break a;break}case 1:{g=(xb(a,b)|0)==0;Ib(a,g?8845:8904)|0;break a;break}case 0:{Hb(a,8881,3)|0;break a;break}default:{g=ob(a,nb(a,b)|0)|0;h=Cb(a,b)|0;c[f>>2]=g;c[f+4>>2]=h;Kb(a,8418,f)|0;break a}}while(0);f=yb(a,-1,d)|0;Pa=e;return f|0}function $f(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;ag(a,-1001e3,12986,1)|0;Rb(a,-1,b);if((nb(a,-1)|0)==5){ib(a,-2);Pa=e;return}hb(a,-2);Tb(a,-1001e3,2);if(ag(a,0,b,d)|0){c[f>>2]=b;rf(a,8425,f)|0}mb(a,-1);Zb(a,-3,b);ib(a,-2);Pa=e;return}function ag(b,c,d,e){b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0;if(c|0)mb(b,c);c=d;while(1){d=rm(c,46)|0;if(!d)f=c+(_l(c)|0)|0;else f=d;d=f-c|0;Hb(b,c,d)|0;Sb(b,-2);if(nb(b,-1)|0){if((nb(b,-1)|0)!=5)break}else{hb(b,-2);Ub(b,0,(a[f>>0]|0)==46?1:e);Hb(b,c,d)|0;mb(b,-2);Yb(b,-4)}ib(b,-2);if((a[f>>0]|0)==46)c=f+1|0;else{g=0;h=11;break}}if((h|0)==11)return g|0;hb(b,-3);g=c;return g|0}function bg(a,b){a=a|0;b=+b;var c=0,d=0,e=0,f=0,h=0,i=0.0;c=Pa;Pa=Pa+32|0;d=c+24|0;e=c+8|0;f=c;h=eb(a)|0;if((h|0)==(eb(0)|0)){i=+g[h>>3];if(i!=b){g[e>>3]=b;g[e+8>>3]=i;rf(a,8499,e)|0}}else rf(a,8473,f)|0;Eb(a,-4660.0);if((vb(a,-1,0)|0)==-4660?(wb(a,-1,0)|0)==-4660:0){hb(a,-2);Pa=c;return}rf(a,8553,d)|0;hb(a,-2);Pa=c;return}function cg(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;e=Pa;Pa=Pa+16|0;f=e;bg(a,502.0);if(!(ab(a,d+20|0)|0)){c[f>>2]=8455;rf(a,8313,f)|0}if(!(c[b>>2]|0)){g=~d;hb(a,g);Pa=e;return}f=-2-d|0;h=0-d|0;if((d|0)<=0){i=b;do{Lb(a,c[i+4>>2]|0,d);Zb(a,f,c[i>>2]|0);i=i+8|0}while((c[i>>2]|0)!=0);g=~d;hb(a,g);Pa=e;return}i=b;do{b=0;do{mb(a,h);b=b+1|0}while((b|0)!=(d|0));Lb(a,c[i+4>>2]|0,d);Zb(a,f,c[i>>2]|0);i=i+8|0}while((c[i>>2]|0)!=0);g=~d;hb(a,g);Pa=e;return}function dg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;Rb(a,b,c);if((nb(a,-1)|0)==5){d=1;return d|0}hb(a,-2);e=fb(a,b)|0;Ub(a,0,0);mb(a,-1);Zb(a,e,c);d=0;return d|0}function eg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;Lb(a,c,0);Ib(a,b)|0;dc(a,1,1,0,0);dg(a,-1001e3,12986)|0;mb(a,-2);Zb(a,-2,b);hb(a,-2);if(!d)return;mb(a,-1);Xb(a,b);return}function fg(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;f=Pa;Pa=Pa+1072|0;g=f+16|0;h=f+8|0;i=f;j=f+24|0;k=_l(d)|0;l=j+12|0;c[l>>2]=a;m=j+16|0;c[j>>2]=m;n=j+8|0;c[n>>2]=0;o=j+4|0;c[o>>2]=1024;p=Um(b,d)|0;if(!p){q=b;r=0;s=1024;t=a}else{u=b;b=p;p=0;v=1024;w=a;while(1){x=b-u|0;if((v-p|0)>>>0<x>>>0){y=v<<1;z=(y-p|0)>>>0<x>>>0?p+x|0:y;if(z>>>0<p>>>0|(z-p|0)>>>0<x>>>0)rf(w,8333,i)|0;y=oc(w,z)|0;Un(y|0,c[j>>2]|0,c[n>>2]|0)|0;if((c[j>>2]|0)!=(m|0))ib(w,-2);c[j>>2]=y;c[o>>2]=z;A=y;B=c[n>>2]|0}else{A=c[j>>2]|0;B=p}Un(A+B|0,u|0,x|0)|0;y=(c[n>>2]|0)+x|0;c[n>>2]=y;x=_l(e)|0;z=c[l>>2]|0;C=c[o>>2]|0;if((C-y|0)>>>0<x>>>0){D=C<<1;C=(D-y|0)>>>0<x>>>0?x+y|0:D;if(C>>>0<y>>>0|(C-y|0)>>>0<x>>>0)rf(z,8333,h)|0;D=oc(z,C)|0;Un(D|0,c[j>>2]|0,c[n>>2]|0)|0;if((c[j>>2]|0)!=(m|0))ib(z,-2);c[j>>2]=D;c[o>>2]=C;E=D;F=c[n>>2]|0}else{E=c[j>>2]|0;F=y}Un(E+F|0,e|0,x|0)|0;y=(c[n>>2]|0)+x|0;c[n>>2]=y;x=b+k|0;b=Um(x,d)|0;D=c[l>>2]|0;C=c[o>>2]|0;if(!b){q=x;r=y;s=C;t=D;break}else{u=x;p=y;v=C;w=D}}}w=_l(q)|0;if((s-r|0)>>>0<w>>>0){v=s<<1;s=(v-r|0)>>>0<w>>>0?r+w|0:v;if(s>>>0<r>>>0|(s-r|0)>>>0<w>>>0)rf(t,8333,g)|0;g=oc(t,s)|0;Un(g|0,c[j>>2]|0,c[n>>2]|0)|0;if((c[j>>2]|0)!=(m|0))ib(t,-2);c[j>>2]=g;c[o>>2]=s;G=g;H=c[n>>2]|0}else{G=c[j>>2]|0;H=r}Un(G+H|0,q|0,w|0)|0;q=(c[n>>2]|0)+w|0;c[n>>2]=q;n=c[l>>2]|0;Hb(n,c[j>>2]|0,q)|0;if((c[j>>2]|0)==(m|0)){I=yb(a,-1,0)|0;Pa=f;return I|0}ib(n,-2);I=yb(a,-1,0)|0;Pa=f;return I|0}function gg(){var a=0;a=se(129,0)|0;if(!a)return a|0;db(a,272)|0;return a|0}function hg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;if(!d){Ik(b);e=0}else e=Jk(b,d)|0;return e|0}function ig(a){a=a|0;var b=0,d=0,e=0,f=0;b=Pa;Pa=Pa+16|0;d=b;e=c[1433]|0;f=yb(a,-1,0)|0;c[d>>2]=f;al(e,8621,d)|0;fm(e)|0;Pa=b;return 0}function jg(a){a=a|0;eg(a,9269,273,1);hb(a,-2);eg(a,8671,274,1);hb(a,-2);eg(a,8679,275,1);hb(a,-2);eg(a,8689,276,1);hb(a,-2);eg(a,8695,277,1);hb(a,-2);eg(a,8698,278,1);hb(a,-2);eg(a,8701,279,1);hb(a,-2);eg(a,8708,280,1);hb(a,-2);eg(a,8714,281,1);hb(a,-2);eg(a,10161,282,1);hb(a,-2);eg(a,8719,283,1);hb(a,-2);dg(a,-1001e3,13001)|0;hb(a,-2);return}function kg(a){a=a|0;Ub(a,0,2);cg(a,400,0);return 1}function lg(a){a=a|0;Eb(a,+(wa(Af(a,1,8737,0)|0)|0));return 1}function mg(a){a=a|0;Ib(a,xa(Af(a,1,8737,0)|0)|0)|0;return 1}function ng(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=d+b|0;f=e+511|0;g=c[a+20>>2]|0;do if((g|0)>(c[a+24>>2]|0)?(h=(c[(c[a>>2]|0)+12>>2]|0)+(g+-1<<2)|0,i=c[h>>2]|0,(i&63|0)==4):0){j=i>>>6&255;k=j+(i>>>23)|0;if((j|0)>(b|0)|(k+1|0)<(b|0)?(j|0)<(b|0)|(j|0)>(e|0):0)break;l=(j|0)<(b|0)?j:b;c[h>>2]=l<<6&16320|i&8372287|((k|0)<(e|0)?f:k)-l<<23;return}while(0);og(a,b<<6|(d<<23)+-8388608|4)|0;return}function og(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;e=c[b>>2]|0;f=b+28|0;g=c[f>>2]|0;h=b+20|0;i=c[h>>2]|0;do if((g|0)!=-1){j=c[e+12>>2]|0;k=g;while(1){l=j+(k<<2)|0;m=c[l>>2]|0;n=(m>>>14)+-131071|0;o=k;k=(n|0)==-1?-1:k+1+n|0;if((o|0)>0?(n=l+-4|0,p=c[n>>2]|0,(a[272+(p&63)>>0]|0)<0):0){q=n;r=p}else{q=l;r=m}if((r&63|0)==28){c[q>>2]=r&8372224|r>>>23<<6|27;p=i+~o|0;if((((p|0)>-1?p:0-p|0)|0)>131071){s=8;break}t=c[l>>2]&16383;u=(p<<14)+2147467264|0}else{p=i+~o|0;if((((p|0)>-1?p:0-p|0)|0)>131071){s=11;break}t=(p<<14)+2147467264|0;u=m&16383}c[l>>2]=t|u;if((k|0)==-1){s=14;break}}if((s|0)==8)ah(c[b+12>>2]|0,8740);else if((s|0)==11)ah(c[b+12>>2]|0,8740);else if((s|0)==14){v=c[h>>2]|0;break}}else v=i;while(0);c[f>>2]=-1;f=e+48|0;if((v|0)<(c[f>>2]|0)){w=c[e+12>>2]|0;x=v}else{v=e+12|0;i=Fd(c[(c[b+12>>2]|0)+52>>2]|0,c[v>>2]|0,f,4,2147483645,8767)|0;c[v>>2]=i;w=i;x=c[h>>2]|0}c[w+(x<<2)>>2]=d;d=c[h>>2]|0;x=e+52|0;w=b+12|0;if((d|0)<(c[x>>2]|0)){y=e+20|0;z=d;A=c[w>>2]|0;B=A+8|0;C=c[B>>2]|0;D=c[y>>2]|0;E=D+(z<<2)|0;c[E>>2]=C;F=c[h>>2]|0;G=F+1|0;c[h>>2]=G;return F|0}else{d=e+20|0;e=Fd(c[(c[w>>2]|0)+52>>2]|0,c[d>>2]|0,x,4,2147483645,8767)|0;c[d>>2]=e;y=d;z=c[h>>2]|0;A=c[w>>2]|0;B=A+8|0;C=c[B>>2]|0;D=c[y>>2]|0;E=D+(z<<2)|0;c[E>>2]=C;F=c[h>>2]|0;G=F+1|0;c[h>>2]=G;return F|0}return 0}function pg(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return og(a,c<<6|b|d<<23|e<<14)|0}function qg(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;b=a+28|0;d=c[b>>2]|0;c[b>>2]=-1;b=og(a,2147450903)|0;if((d|0)==-1){e=b;return e|0}if((b|0)==-1){e=d;return e|0}f=c[(c[a>>2]|0)+12>>2]|0;g=b;while(1){h=f+(g<<2)|0;i=c[h>>2]|0;j=(i>>>14)+-131071|0;k=(j|0)==-1?-1:g+1+j|0;if((k|0)==-1)break;else g=k}f=d+~g|0;if((((f|0)>-1?f:0-f|0)|0)>131071)ah(c[a+12>>2]|0,8740);c[h>>2]=(f<<14)+2147467264|i&16383;e=b;return e|0}function rg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return og(a,c<<6|b|d<<14)|0}function sg(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;if((d|0)==-1)return;e=c[b>>2]|0;if((e|0)==-1){c[b>>2]=d;return}b=c[(c[a>>2]|0)+12>>2]|0;f=e;while(1){g=b+(f<<2)|0;h=c[g>>2]|0;e=(h>>>14)+-131071|0;i=(e|0)==-1?-1:f+1+e|0;if((i|0)==-1)break;else f=i}b=~f+d|0;if((((b|0)>-1?b:0-b|0)|0)>131071)ah(c[a+12>>2]|0,8740);c[g>>2]=h&16383|(b<<14)+2147467264;return}function tg(a,b,c){a=a|0;b=b|0;c=c|0;og(a,b<<6|(c<<23)+8388608|31)|0;return}function ug(a){a=a|0;var b=0;b=c[a+20>>2]|0;c[a+24>>2]=b;return b|0}function vg(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;if((c[b+20>>2]|0)==(e|0)){c[b+24>>2]=e;f=b+28|0;if((d|0)==-1)return;g=c[f>>2]|0;if((g|0)==-1){c[f>>2]=d;return}f=c[(c[b>>2]|0)+12>>2]|0;h=g;while(1){i=f+(h<<2)|0;j=c[i>>2]|0;g=(j>>>14)+-131071|0;k=(g|0)==-1?-1:h+1+g|0;if((k|0)==-1)break;else h=k}f=~h+d|0;if((((f|0)>-1?f:0-f|0)|0)>131071)ah(c[b+12>>2]|0,8740);c[i>>2]=(f<<14)+2147467264|j&16383;return}if((d|0)==-1)return;j=c[(c[b>>2]|0)+12>>2]|0;f=d;while(1){d=j+(f<<2)|0;i=c[d>>2]|0;h=(i>>>14)+-131071|0;k=f;f=(h|0)==-1?-1:f+1+h|0;if((k|0)>0?(h=d+-4|0,g=c[h>>2]|0,(a[272+(g&63)>>0]|0)<0):0){l=h;m=g}else{l=d;m=i}if((m&63|0)!=28){g=~k+e|0;if((((g|0)>-1?g:0-g|0)|0)>131071){n=20;break}else{o=g;p=i}}else{c[l>>2]=m&8372224|m>>>23<<6|27;i=~k+e|0;if((((i|0)>-1?i:0-i|0)|0)>131071){n=17;break}o=i;p=c[d>>2]|0}c[d>>2]=p&16383|(o<<14)+2147467264;if((f|0)==-1){n=22;break}}if((n|0)==17)ah(c[b+12>>2]|0,8740);else if((n|0)==20)ah(c[b+12>>2]|0,8740);else if((n|0)==22)return}function wg(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0;c[a+24>>2]=c[a+20>>2];d=a+28|0;if((b|0)==-1)return;e=c[d>>2]|0;if((e|0)==-1){c[d>>2]=b;return}d=c[(c[a>>2]|0)+12>>2]|0;f=e;while(1){g=d+(f<<2)|0;h=c[g>>2]|0;e=(h>>>14)+-131071|0;i=(e|0)==-1?-1:f+1+e|0;if((i|0)==-1)break;else f=i}d=~f+b|0;if((((d|0)>-1?d:0-d|0)|0)>131071)ah(c[a+12>>2]|0,8740);c[g>>2]=(d<<14)+2147467264|h&16383;return}function xg(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;if((b|0)==-1)return;e=c[(c[a>>2]|0)+12>>2]|0;a=(d<<6)+64&16320;d=b;do{b=e+(d<<2)|0;f=c[b>>2]|0;g=(f>>>14)+-131071|0;c[b>>2]=f&-16321|a;d=(g|0)==-1?-1:d+1+g|0}while((d|0)!=-1);return}function yg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=b<<6;if((c|0)<262144){e=og(a,d|c<<14|1)|0;return e|0}else{b=og(a,d|2)|0;og(a,c<<6|39)|0;e=b;return e|0}return 0}function zg(b,e){b=b|0;e=e|0;var f=0;f=(d[b+48>>0]|0)+e|0;e=(c[b>>2]|0)+78|0;if((f|0)<=(d[e>>0]|0|0))return;if((f|0)>249)ah(c[b+12>>2]|0,8775);a[e>>0]=f;return}function Ag(b,e){b=b|0;e=e|0;var f=0,g=0,h=0;f=b+48|0;g=(d[f>>0]|0)+e|0;e=(c[b>>2]|0)+78|0;if((g|0)<=(d[e>>0]|0|0)){h=g&255;a[f>>0]=h;return}if((g|0)>249)ah(c[b+12>>2]|0,8775);b=g&255;a[e>>0]=b;h=b;a[f>>0]=h;return}function Bg(b,d){b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;c[f+8>>2]=(a[d+4>>0]|64)&255;d=Cg(b,f,f)|0;Pa=e;return d|0}function Cg(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;f=Pa;Pa=Pa+16|0;h=f;i=c[(c[b+12>>2]|0)+52>>2]|0;j=Je(i,c[b+4>>2]|0,d)|0;d=c[b>>2]|0;k=j+8|0;if(((c[k>>2]|0)==3?(g[h>>3]=+g[j>>3]+6755399441055744.0,l=c[h>>2]|0,h=c[d+8>>2]|0,(c[h+(l<<4)+8>>2]|0)==(c[e+8>>2]|0)):0)?cf(0,h+(l<<4)|0,e)|0:0){m=l;Pa=f;return m|0}l=d+44|0;h=c[l>>2]|0;n=b+32|0;b=c[n>>2]|0;g[j>>3]=+(b|0);c[k>>2]=3;k=c[l>>2]|0;j=d+8|0;if((b|0)<(k|0)){o=k;p=c[j>>2]|0}else{k=Fd(i,c[j>>2]|0,l,16,67108863,8810)|0;c[j>>2]=k;o=c[l>>2]|0;p=k}if((h|0)<(o|0)?(k=h+1|0,c[p+(h<<4)+8>>2]=0,(k|0)<(o|0)):0){h=k;do{c[p+(h<<4)+8>>2]=0;h=h+1|0}while((h|0)<(o|0))}o=e;h=c[o+4>>2]|0;k=p+(b<<4)|0;c[k>>2]=c[o>>2];c[k+4>>2]=h;h=e+8|0;c[p+(b<<4)+8>>2]=c[h>>2];c[n>>2]=(c[n>>2]|0)+1;if(!(c[h>>2]&64)){m=b;Pa=f;return m|0}h=c[e>>2]|0;if(!(a[h+5>>0]&3)){m=b;Pa=f;return m|0}if(!(a[d+5>>0]&4)){m=b;Pa=f;return m|0}jd(i,d,h);m=b;Pa=f;return m|0}function Dg(b,d){b=b|0;d=+d;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0;e=Pa;Pa=Pa+32|0;f=e;h=e+8|0;g[f>>3]=d;i=c[(c[b+12>>2]|0)+52>>2]|0;g[h>>3]=d;c[h+8>>2]=3;if(d!=d|0.0!=0.0|d==0.0){j=i+8|0;k=c[j>>2]|0;c[j>>2]=k+16;l=Ae(i,f,8)|0;c[k>>2]=l;c[k+8>>2]=(a[l+4>>0]|64)&255;l=Cg(b,(c[j>>2]|0)+-16|0,h)|0;c[j>>2]=(c[j>>2]|0)+-16;m=l;Pa=e;return m|0}else{m=Cg(b,h,h)|0;Pa=e;return m|0}return 0}function Eg(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0;switch(c[e>>2]|0){case 12:{g=(c[(c[b>>2]|0)+12>>2]|0)+(c[e+8>>2]<<2)|0;c[g>>2]=c[g>>2]&-8372225|(f<<14)+16384&8372224;return}case 13:{g=c[b>>2]|0;h=c[g+12>>2]|0;i=e+8|0;e=h+(c[i>>2]<<2)|0;c[e>>2]=c[e>>2]&8388607|(f<<23)+8388608;f=h+(c[i>>2]<<2)|0;i=b+48|0;h=a[i>>0]|0;e=h&255;c[f>>2]=e<<6|c[f>>2]&-16321;f=e+1|0;e=g+78|0;do if((h&255)>=(d[e>>0]|0))if((h&255)>248)ah(c[b+12>>2]|0,8775);else{g=f&255;a[e>>0]=g;j=g;break}else j=f&255;while(0);a[i>>0]=j;return}default:return}}function Fg(a,b){a=a|0;b=b|0;var d=0;switch(c[b>>2]|0){case 12:{c[b>>2]=6;d=b+8|0;c[d>>2]=(c[(c[(c[a>>2]|0)+12>>2]|0)+(c[d>>2]<<2)>>2]|0)>>>6&255;return}case 13:{d=(c[(c[a>>2]|0)+12>>2]|0)+(c[b+8>>2]<<2)|0;c[d>>2]=c[d>>2]&8388607|16777216;c[b>>2]=11;return}default:return}}function Gg(e,f){e=e|0;f=f|0;var g=0,h=0,i=0,j=0;switch(c[f>>2]|0){case 7:{c[f>>2]=6;return}case 8:{g=f+8|0;h=og(e,c[g>>2]<<23|5)|0;c[g>>2]=h;c[f>>2]=11;return}case 9:{h=f+8|0;g=b[h>>1]|0;if((g&256|0)==0?(d[e+46>>0]|0)<=(g|0):0){g=e+48|0;a[g>>0]=(a[g>>0]|0)+-1<<24>>24}g=h+2|0;if((a[h+3>>0]|0)==7)if((d[e+46>>0]|0)>(d[g>>0]|0))i=7;else{j=e+48|0;a[j>>0]=(a[j>>0]|0)+-1<<24>>24;i=7}else i=6;j=og(e,d[g>>0]<<23|i|b[h>>1]<<14)|0;c[h>>2]=j;c[f>>2]=11;return}case 12:{c[f>>2]=6;j=f+8|0;c[j>>2]=(c[(c[(c[e>>2]|0)+12>>2]|0)+(c[j>>2]<<2)>>2]|0)>>>6&255;return}case 13:{j=(c[(c[e>>2]|0)+12>>2]|0)+(c[f+8>>2]<<2)|0;c[j>>2]=c[j>>2]&8388607|16777216;c[f>>2]=11;return}default:return}}function Hg(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;Gg(b,e);if(((c[e>>2]|0)==6?(f=c[e+8>>2]|0,(f&256|0)==0):0)?(f|0)>=(d[b+46>>0]|0|0):0){f=b+48|0;a[f>>0]=(a[f>>0]|0)+-1<<24>>24}f=b+48|0;g=a[f>>0]|0;h=(g&255)+1|0;i=(c[b>>2]|0)+78|0;if((g&255)<(d[i>>0]|0)){j=h&255;a[f>>0]=j;k=j&255;l=k+-1|0;Ig(b,e,l);return}if((g&255)>248)ah(c[b+12>>2]|0,8775);g=h&255;a[i>>0]=g;j=g;a[f>>0]=j;k=j&255;l=k+-1|0;Ig(b,e,l);return}function Ig(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0;Jg(b,d,e);f=(c[d>>2]|0)==10;g=d+16|0;do if(f?(h=c[d+8>>2]|0,(h|0)!=-1):0){i=c[g>>2]|0;if((i|0)==-1){c[g>>2]=h;j=h;break}k=c[(c[b>>2]|0)+12>>2]|0;l=i;while(1){m=k+(l<<2)|0;n=c[m>>2]|0;i=(n>>>14)+-131071|0;o=(i|0)==-1?-1:l+1+i|0;if((o|0)==-1)break;else l=o}k=h+~l|0;if((((k|0)>-1?k:0-k|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[m>>2]=(k<<14)+2147467264|n&16383;p=10;break}}else p=10;while(0);if((p|0)==10)j=c[g>>2]|0;n=d+20|0;m=c[n>>2]|0;if((j|0)==(m|0)){c[g>>2]=-1;c[n>>2]=-1;q=d+8|0;c[q>>2]=e;c[d>>2]=6;return}a:do if((j|0)==-1)p=19;else{k=c[(c[b>>2]|0)+12>>2]|0;o=j;while(1){i=k+(o<<2)|0;if((o|0)>0?(r=c[i+-4>>2]|0,(a[272+(r&63)>>0]|0)<0):0)s=r;else s=c[i>>2]|0;if((s&63|0)!=28){p=26;break a}r=((c[i>>2]|0)>>>14)+-131071|0;o=(r|0)==-1?-1:o+1+r|0;if((o|0)==-1){p=19;break}}}while(0);b:do if((p|0)==19)if((m|0)==-1){t=-1;u=-1}else{s=c[(c[b>>2]|0)+12>>2]|0;j=m;while(1){o=s+(j<<2)|0;if((j|0)>0?(k=c[o+-4>>2]|0,(a[272+(k&63)>>0]|0)<0):0)v=k;else v=c[o>>2]|0;if((v&63|0)!=28){p=26;break b}k=((c[o>>2]|0)>>>14)+-131071|0;j=(k|0)==-1?-1:j+1+k|0;if((j|0)==-1){t=-1;u=-1;break}}}while(0);do if((p|0)==26){v=b+28|0;do if(!f){m=c[v>>2]|0;c[v>>2]=-1;j=og(b,2147450903)|0;if((m|0)!=-1)if((j|0)!=-1){s=c[(c[b>>2]|0)+12>>2]|0;k=j;while(1){w=s+(k<<2)|0;x=c[w>>2]|0;o=(x>>>14)+-131071|0;l=(o|0)==-1?-1:k+1+o|0;if((l|0)==-1)break;else k=l}s=m+~k|0;if((((s|0)>-1?s:0-s|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[w>>2]=(s<<14)+2147467264|x&16383;y=j;break}}else y=m;else y=j}else y=-1;while(0);s=b+20|0;l=b+24|0;c[l>>2]=c[s>>2];o=e<<6;h=og(b,o|16387)|0;c[l>>2]=c[s>>2];r=og(b,o|8388611)|0;c[l>>2]=c[s>>2];if((y|0)!=-1){s=c[v>>2]|0;if((s|0)==-1){c[v>>2]=y;t=h;u=r;break}l=c[(c[b>>2]|0)+12>>2]|0;o=s;while(1){z=l+(o<<2)|0;A=c[z>>2]|0;s=(A>>>14)+-131071|0;i=(s|0)==-1?-1:o+1+s|0;if((i|0)==-1)break;else o=i}l=y+~o|0;if((((l|0)>-1?l:0-l|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[z>>2]=(l<<14)+2147467264|A&16383;t=h;u=r;break}}else{t=h;u=r}}while(0);A=c[b+20>>2]|0;c[b+24>>2]=A;z=c[n>>2]|0;c:do if((z|0)!=-1){y=e<<6;x=y&16320;w=c[(c[b>>2]|0)+12>>2]|0;if((e|0)==255){f=z;while(1){l=w+(f<<2)|0;v=c[l>>2]|0;i=(v>>>14)+-131071|0;s=f;f=(i|0)==-1?-1:f+1+i|0;if((s|0)>0?(i=l+-4|0,B=c[i>>2]|0,(a[272+(B&63)>>0]|0)<0):0){C=i;D=B}else{C=l;D=v}if((D&63|0)!=28){B=t+~s|0;if((((B|0)>-1?B:0-B|0)|0)>131071){p=65;break}else{E=B;F=v}}else{c[C>>2]=D&8372224|D>>>23<<6|27;v=A+~s|0;if((((v|0)>-1?v:0-v|0)|0)>131071){p=62;break}E=v;F=c[l>>2]|0}c[l>>2]=F&16383|(E<<14)+2147467264;if((f|0)==-1)break c}if((p|0)==62){G=b+12|0;H=c[G>>2]|0;ah(H,8740)}else if((p|0)==65){I=b+12|0;J=c[I>>2]|0;ah(J,8740)}}f=z;while(1){r=w+(f<<2)|0;h=c[r>>2]|0;o=(h>>>14)+-131071|0;l=f;f=(o|0)==-1?-1:f+1+o|0;if((l|0)>0?(o=r+-4|0,v=c[o>>2]|0,(a[272+(v&63)>>0]|0)<0):0){K=o;L=v}else{K=r;L=h}if((L&63|0)!=28){v=t+~l|0;if((((v|0)>-1?v:0-v|0)|0)>131071){p=65;break}else{M=v;N=h}}else{if((L>>>23|0)==(e|0))O=L&8372224|y|27;else O=L&-16321|x;c[K>>2]=O;h=A+~l|0;if((((h|0)>-1?h:0-h|0)|0)>131071){p=62;break}M=h;N=c[r>>2]|0}c[r>>2]=N&16383|(M<<14)+2147467264;if((f|0)==-1)break c}if((p|0)==62){G=b+12|0;H=c[G>>2]|0;ah(H,8740)}else if((p|0)==65){I=b+12|0;J=c[I>>2]|0;ah(J,8740)}}while(0);J=c[g>>2]|0;if((J|0)==-1){c[g>>2]=-1;c[n>>2]=-1;q=d+8|0;c[q>>2]=e;c[d>>2]=6;return}I=e<<6;H=I&16320;G=c[(c[b>>2]|0)+12>>2]|0;if((e|0)==255){M=J;while(1){N=G+(M<<2)|0;O=c[N>>2]|0;K=(O>>>14)+-131071|0;L=M;M=(K|0)==-1?-1:M+1+K|0;if((L|0)>0?(K=N+-4|0,t=c[K>>2]|0,(a[272+(t&63)>>0]|0)<0):0){P=K;Q=t}else{P=N;Q=O}if((Q&63|0)!=28){t=u+~L|0;if((((t|0)>-1?t:0-t|0)|0)>131071){p=90;break}else{R=t;S=O}}else{c[P>>2]=Q&8372224|Q>>>23<<6|27;O=A+~L|0;if((((O|0)>-1?O:0-O|0)|0)>131071){p=87;break}R=O;S=c[N>>2]|0}c[N>>2]=S&16383|(R<<14)+2147467264;if((M|0)==-1){p=92;break}}if((p|0)==87){T=b+12|0;U=c[T>>2]|0;ah(U,8740)}else if((p|0)==90){V=b+12|0;W=c[V>>2]|0;ah(W,8740)}else if((p|0)==92){c[g>>2]=-1;c[n>>2]=-1;q=d+8|0;c[q>>2]=e;c[d>>2]=6;return}}M=J;while(1){J=G+(M<<2)|0;R=c[J>>2]|0;S=(R>>>14)+-131071|0;Q=M;M=(S|0)==-1?-1:M+1+S|0;if((Q|0)>0?(S=J+-4|0,P=c[S>>2]|0,(a[272+(P&63)>>0]|0)<0):0){X=S;Y=P}else{X=J;Y=R}if((Y&63|0)!=28){P=u+~Q|0;if((((P|0)>-1?P:0-P|0)|0)>131071){p=90;break}else{Z=P;_=R}}else{if((Y>>>23|0)==(e|0))$=Y&8372224|I|27;else $=Y&-16321|H;c[X>>2]=$;R=A+~Q|0;if((((R|0)>-1?R:0-R|0)|0)>131071){p=87;break}Z=R;_=c[J>>2]|0}c[J>>2]=_&16383|(Z<<14)+2147467264;if((M|0)==-1){p=92;break}}if((p|0)==87){T=b+12|0;U=c[T>>2]|0;ah(U,8740)}else if((p|0)==90){V=b+12|0;W=c[V>>2]|0;ah(W,8740)}else if((p|0)==92){c[g>>2]=-1;c[n>>2]=-1;q=d+8|0;c[q>>2]=e;c[d>>2]=6;return}}function Jg(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0.0,s=0;f=Pa;Pa=Pa+32|0;h=f+16|0;i=f;Gg(b,d);j=c[d>>2]|0;a:do switch(j|0){case 1:{k=e+1|0;l=c[b+20>>2]|0;do if((l|0)>(c[b+24>>2]|0)?(m=(c[(c[b>>2]|0)+12>>2]|0)+(l+-1<<2)|0,n=c[m>>2]|0,(n&63|0)==4):0){o=n>>>6&255;p=o+(n>>>23)|0;if((o|0)>(e|0)|(p+1|0)<(e|0)?(o|0)<(e|0)|(o|0)>(k|0):0)break;q=(o|0)<(e|0)?o:e;c[m>>2]=q<<6&16320|n&8372287|((p|0)>(e|0)?p:e)-q<<23;break a}while(0);og(b,e<<6|4)|0;break}case 2:case 3:{og(b,e<<6|((j|0)==2&1)<<23|3)|0;break}case 4:{k=c[d+8>>2]|0;l=e<<6;if((k|0)<262144){og(b,l|k<<14|1)|0;break a}else{og(b,l|2)|0;og(b,k<<6|39)|0;break a}break}case 5:{r=+g[d+8>>3];g[h>>3]=r;k=c[(c[b+12>>2]|0)+52>>2]|0;g[i>>3]=r;c[i+8>>2]=3;if(r!=r|0.0!=0.0|r==0.0){l=k+8|0;q=c[l>>2]|0;c[l>>2]=q+16;p=Ae(k,h,8)|0;c[q>>2]=p;c[q+8>>2]=(a[p+4>>0]|64)&255;p=Cg(b,(c[l>>2]|0)+-16|0,i)|0;c[l>>2]=(c[l>>2]|0)+-16;s=p}else s=Cg(b,i,i)|0;p=e<<6;if((s|0)<262144){og(b,p|s<<14|1)|0;break a}else{og(b,p|2)|0;og(b,s<<6|39)|0;break a}break}case 11:{p=(c[(c[b>>2]|0)+12>>2]|0)+(c[d+8>>2]<<2)|0;c[p>>2]=c[p>>2]&-16321|e<<6&16320;break}case 6:{p=c[d+8>>2]|0;if((p|0)!=(e|0))og(b,p<<23|e<<6)|0;break}default:{Pa=f;return}}while(0);c[d+8>>2]=e;c[d>>2]=6;Pa=f;return}function Kg(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;Gg(b,e);if((c[e>>2]|0)==6){f=e+8|0;g=c[f>>2]|0;if((c[e+16>>2]|0)==(c[e+20>>2]|0)){h=g;return h|0}if((g|0)>=(d[b+46>>0]|0|0)){Ig(b,e,g);i=f}else j=5}else j=5;if((j|0)==5){Gg(b,e);if(((c[e>>2]|0)==6?(j=c[e+8>>2]|0,(j&256|0)==0):0)?(j|0)>=(d[b+46>>0]|0|0):0){j=b+48|0;a[j>>0]=(a[j>>0]|0)+-1<<24>>24}j=b+48|0;f=a[j>>0]|0;g=(f&255)+1|0;k=(c[b>>2]|0)+78|0;do if((f&255)>=(d[k>>0]|0))if((f&255)>248)ah(c[b+12>>2]|0,8775);else{l=g&255;a[k>>0]=l;m=l;break}else m=g&255;while(0);a[j>>0]=m;Ig(b,e,(m&255)+-1|0);i=e+8|0}h=c[i>>2]|0;return h|0}function Lg(a,b){a=a|0;b=b|0;if((c[b>>2]|0)==8?(c[b+16>>2]|0)==(c[b+20>>2]|0):0)return;Kg(a,b)|0;return}function Mg(a,b){a=a|0;b=b|0;if((c[b+16>>2]|0)==(c[b+20>>2]|0)){Gg(a,b);return}else{Kg(a,b)|0;return}}function Ng(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0.0,m=0,n=0,o=0,p=0,q=0,r=0;e=Pa;Pa=Pa+32|0;f=e+16|0;h=e;if((c[d+16>>2]|0)==(c[d+20>>2]|0))Gg(b,d);else Kg(b,d)|0;i=c[d>>2]|0;switch(i|0){case 1:case 3:case 2:{if((c[b+32>>2]|0)<256){if((i|0)==1){c[h+8>>2]=0;c[f>>2]=c[b+4>>2];c[f+8>>2]=69;j=Cg(b,f,h)|0}else{c[f>>2]=(i|0)==2&1;c[f+8>>2]=1;j=Cg(b,f,f)|0}c[d+8>>2]=j;c[d>>2]=4;k=j|256;Pa=e;return k|0}break}case 5:{j=d+8|0;l=+g[j>>3];g[f>>3]=l;i=c[(c[b+12>>2]|0)+52>>2]|0;g[h>>3]=l;c[h+8>>2]=3;if(l!=l|0.0!=0.0|l==0.0){m=i+8|0;n=c[m>>2]|0;c[m>>2]=n+16;o=Ae(i,f,8)|0;c[n>>2]=o;c[n+8>>2]=(a[o+4>>0]|64)&255;o=Cg(b,(c[m>>2]|0)+-16|0,h)|0;c[m>>2]=(c[m>>2]|0)+-16;p=o}else p=Cg(b,h,h)|0;c[j>>2]=p;c[d>>2]=4;q=p;r=15;break}case 4:{q=c[d+8>>2]|0;r=15;break}default:{}}if((r|0)==15?(q|0)<256:0){k=q|256;Pa=e;return k|0}k=Kg(b,d)|0;Pa=e;return k|0}function Og(b,f,g){b=b|0;f=f|0;g=g|0;var h=0;switch(c[f>>2]|0){case 7:{if(((c[g>>2]|0)==6?(h=c[g+8>>2]|0,(h&256|0)==0):0)?(h|0)>=(d[b+46>>0]|0):0){h=b+48|0;a[h>>0]=(a[h>>0]|0)+-1<<24>>24}Ig(b,g,c[f+8>>2]|0);return}case 8:{og(b,(Kg(b,g)|0)<<6|c[f+8>>2]<<23|9)|0;break}case 9:{h=f+8|0;f=(a[h+3>>0]|0)==7?10:8;og(b,(Ng(b,g)|0)<<14|f|d[h+2>>0]<<6|e[h>>1]<<23)|0;break}default:{}}if((c[g>>2]|0)!=6)return;h=c[g+8>>2]|0;if(h&256|0)return;if((h|0)<(d[b+46>>0]|0))return;h=b+48|0;a[h>>0]=(a[h>>0]|0)+-1<<24>>24;return}function Pg(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0;Kg(b,e)|0;g=e+8|0;h=c[g>>2]|0;if((c[e>>2]|0)==6&(h&256|0)==0?(h|0)>=(d[b+46>>0]|0|0):0){i=b+48|0;a[i>>0]=(a[i>>0]|0)+-1<<24>>24}i=b+48|0;c[g>>2]=d[i>>0];c[e>>2]=6;e=(d[i>>0]|0)+2|0;j=(c[b>>2]|0)+78|0;do if(e>>>0>(d[j>>0]|0)>>>0)if(e>>>0>249)ah(c[b+12>>2]|0,8775);else{k=e&255;a[j>>0]=k;l=k;break}else l=e&255;while(0);a[i>>0]=l;l=c[g>>2]|0;og(b,h<<23|l<<6|(Ng(b,f)|0)<<14|12)|0;if((c[f>>2]|0)!=6)return;l=c[f+8>>2]|0;if(l&256|0)return;if((l|0)<(d[b+46>>0]|0|0))return;a[i>>0]=(a[i>>0]|0)+-1<<24>>24;return}function Qg(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;Gg(b,e);f=c[e>>2]|0;a:do switch(f|0){case 10:{g=e+8|0;h=c[g>>2]|0;i=(c[(c[b>>2]|0)+12>>2]|0)+(h<<2)|0;if((h|0)>0?(h=i+-4|0,j=c[h>>2]|0,(a[272+(j&63)>>0]|0)<0):0){k=h;l=j}else{k=i;l=c[i>>2]|0}c[k>>2]=((l&16320|0)==0&1)<<6|l&-16321;m=c[g>>2]|0;n=32;break}case 2:case 5:case 4:break;case 11:{g=c[b>>2]|0;i=e+8|0;j=c[(c[g+12>>2]|0)+(c[i>>2]<<2)>>2]|0;h=b+20|0;if((j&63|0)==20){c[h>>2]=(c[h>>2]|0)+-1;og(b,j>>>23<<6|16411)|0;j=b+28|0;h=c[j>>2]|0;c[j>>2]=-1;j=og(b,2147450903)|0;if((h|0)!=-1)if((j|0)!=-1){o=c[(c[b>>2]|0)+12>>2]|0;p=j;while(1){q=o+(p<<2)|0;r=c[q>>2]|0;s=(r>>>14)+-131071|0;t=(s|0)==-1?-1:p+1+s|0;if((t|0)==-1)break;else p=t}o=h+~p|0;if((((o|0)>-1?o:0-o|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[q>>2]=(o<<14)+2147467264|r&16383;m=j;n=32;break a}}else{u=h;n=33}else{m=j;n=32}}else{v=i;w=g;n=16}break}default:{o=e+8|0;if((f|0)==6){x=o;n=22}else{v=o;w=c[b>>2]|0;n=16}}}while(0);if((n|0)==16){f=b+48|0;r=a[f>>0]|0;q=(r&255)+1|0;l=w+78|0;do if((r&255)>=(d[l>>0]|0))if((r&255)>248)ah(c[b+12>>2]|0,8775);else{w=q&255;a[l>>0]=w;y=w;break}else y=q&255;while(0);a[f>>0]=y;Jg(b,e,(y&255)+-1|0);if((c[e>>2]|0)==6){x=v;n=22}else{z=v;n=25}}if((n|0)==22){v=c[e+8>>2]|0;if((v&256|0)==0?(v|0)>=(d[b+46>>0]|0):0){v=b+48|0;a[v>>0]=(a[v>>0]|0)+-1<<24>>24;z=x;n=25}else{z=x;n=25}}do if((n|0)==25){og(b,c[z>>2]<<23|16348)|0;x=b+28|0;v=c[x>>2]|0;c[x>>2]=-1;x=og(b,2147450903)|0;if((v|0)!=-1)if((x|0)!=-1){y=c[(c[b>>2]|0)+12>>2]|0;f=x;while(1){A=y+(f<<2)|0;B=c[A>>2]|0;q=(B>>>14)+-131071|0;l=(q|0)==-1?-1:f+1+q|0;if((l|0)==-1)break;else f=l}y=v+~f|0;if((((y|0)>-1?y:0-y|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[A>>2]=(y<<14)+2147467264|B&16383;m=x;n=32;break}}else{u=v;n=33}else{m=x;n=32}}while(0);if((n|0)==32?(m|0)!=-1:0){u=m;n=33}do if((n|0)==33){m=e+20|0;B=c[m>>2]|0;if((B|0)==-1){c[m>>2]=u;break}m=c[(c[b>>2]|0)+12>>2]|0;A=B;while(1){C=m+(A<<2)|0;D=c[C>>2]|0;B=(D>>>14)+-131071|0;z=(B|0)==-1?-1:A+1+B|0;if((z|0)==-1)break;else A=z}m=u+~A|0;if((((m|0)>-1?m:0-m|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[C>>2]=(m<<14)+2147467264|D&16383;break}}while(0);D=e+16|0;e=c[D>>2]|0;c[b+24>>2]=c[b+20>>2];C=b+28|0;if((e|0)==-1){c[D>>2]=-1;return}u=c[C>>2]|0;if((u|0)==-1){c[C>>2]=e;c[D>>2]=-1;return}C=c[(c[b>>2]|0)+12>>2]|0;n=u;while(1){E=C+(n<<2)|0;F=c[E>>2]|0;u=(F>>>14)+-131071|0;m=(u|0)==-1?-1:n+1+u|0;if((m|0)==-1)break;else n=m}C=e+~n|0;if((((C|0)>-1?C:0-C|0)|0)>131071)ah(c[b+12>>2]|0,8740);c[E>>2]=(C<<14)+2147467264|F&16383;c[D>>2]=-1;return}function Rg(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;Gg(b,e);f=c[e>>2]|0;a:do switch(f|0){case 10:{g=c[e+8>>2]|0;h=29;break}case 3:case 1:break;case 11:{i=c[b>>2]|0;j=e+8|0;k=c[(c[i+12>>2]|0)+(c[j>>2]<<2)>>2]|0;l=b+20|0;if((k&63|0)==20){c[l>>2]=(c[l>>2]|0)+-1;og(b,k>>>23<<6|27)|0;k=b+28|0;l=c[k>>2]|0;c[k>>2]=-1;k=og(b,2147450903)|0;if((l|0)!=-1)if((k|0)!=-1){m=c[(c[b>>2]|0)+12>>2]|0;n=k;while(1){o=m+(n<<2)|0;p=c[o>>2]|0;q=(p>>>14)+-131071|0;r=(q|0)==-1?-1:n+1+q|0;if((r|0)==-1)break;else n=r}m=l+~n|0;if((((m|0)>-1?m:0-m|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[o>>2]=(m<<14)+2147467264|p&16383;g=k;h=29;break a}}else{s=l;h=30}else{g=k;h=29}}else{t=j;u=i;h=13}break}default:{m=e+8|0;if((f|0)==6){v=m;h=19}else{t=m;u=c[b>>2]|0;h=13}}}while(0);if((h|0)==13){f=b+48|0;p=a[f>>0]|0;o=(p&255)+1|0;m=u+78|0;do if((p&255)>=(d[m>>0]|0))if((p&255)>248)ah(c[b+12>>2]|0,8775);else{u=o&255;a[m>>0]=u;w=u;break}else w=o&255;while(0);a[f>>0]=w;Jg(b,e,(w&255)+-1|0);if((c[e>>2]|0)==6){v=t;h=19}else{x=t;h=22}}if((h|0)==19){t=c[e+8>>2]|0;if((t&256|0)==0?(t|0)>=(d[b+46>>0]|0|0):0){t=b+48|0;a[t>>0]=(a[t>>0]|0)+-1<<24>>24;x=v;h=22}else{x=v;h=22}}do if((h|0)==22){og(b,c[x>>2]<<23|32732)|0;v=b+28|0;t=c[v>>2]|0;c[v>>2]=-1;v=og(b,2147450903)|0;if((t|0)!=-1)if((v|0)!=-1){w=c[(c[b>>2]|0)+12>>2]|0;f=v;while(1){y=w+(f<<2)|0;z=c[y>>2]|0;o=(z>>>14)+-131071|0;m=(o|0)==-1?-1:f+1+o|0;if((m|0)==-1)break;else f=m}w=t+~f|0;if((((w|0)>-1?w:0-w|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[y>>2]=(w<<14)+2147467264|z&16383;g=v;h=29;break}}else{s=t;h=30}else{g=v;h=29}}while(0);if((h|0)==29?(g|0)!=-1:0){s=g;h=30}do if((h|0)==30){g=e+16|0;z=c[g>>2]|0;if((z|0)==-1){c[g>>2]=s;break}g=c[(c[b>>2]|0)+12>>2]|0;y=z;while(1){A=g+(y<<2)|0;B=c[A>>2]|0;z=(B>>>14)+-131071|0;x=(z|0)==-1?-1:y+1+z|0;if((x|0)==-1)break;else y=x}g=s+~y|0;if((((g|0)>-1?g:0-g|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[A>>2]=(g<<14)+2147467264|B&16383;break}}while(0);B=e+20|0;e=c[B>>2]|0;c[b+24>>2]=c[b+20>>2];A=b+28|0;if((e|0)==-1){c[B>>2]=-1;return}s=c[A>>2]|0;if((s|0)==-1){c[A>>2]=e;c[B>>2]=-1;return}A=c[(c[b>>2]|0)+12>>2]|0;h=s;while(1){C=A+(h<<2)|0;D=c[C>>2]|0;s=(D>>>14)+-131071|0;g=(s|0)==-1?-1:h+1+s|0;if((g|0)==-1)break;else h=g}A=e+~h|0;if((((A|0)>-1?A:0-A|0)|0)>131071)ah(c[b+12>>2]|0,8740);c[C>>2]=(A<<14)+2147467264|D&16383;c[B>>2]=-1;return}function Sg(d,e,f){d=d|0;e=e|0;f=f|0;var g=0,h=0;g=e+8|0;a[g+2>>0]=c[g>>2];h=(Ng(d,f)|0)&65535;b[g>>1]=h;a[g+3>>0]=(c[e>>2]|0)==8?8:7;c[e>>2]=9;return}function Tg(b,e,f,h){b=b|0;e=e|0;f=f|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;i=Pa;Pa=Pa+32|0;j=i;c[j+20>>2]=-1;c[j+16>>2]=-1;c[j>>2]=5;g[j+8>>3]=0.0;switch(e|0){case 0:{if(((c[f>>2]|0)==5?(c[f+16>>2]|0)==-1:0)?(c[f+20>>2]|0)==-1:0){e=f+8|0;g[e>>3]=-+g[e>>3];Pa=i;return}Kg(b,f)|0;Ug(b,19,f,j,h);Pa=i;return}case 1:{Gg(b,f);switch(c[f>>2]|0){case 3:case 1:{c[f>>2]=2;break}case 2:case 5:case 4:{c[f>>2]=3;break}case 10:{e=c[f+8>>2]|0;k=(c[(c[b>>2]|0)+12>>2]|0)+(e<<2)|0;if((e|0)>0?(e=k+-4|0,l=c[e>>2]|0,(a[272+(l&63)>>0]|0)<0):0){m=e;n=l}else{m=k;n=c[k>>2]|0}c[m>>2]=((n&16320|0)==0&1)<<6|n&-16321;break}case 6:{o=21;break}case 11:{n=b+48|0;m=a[n>>0]|0;k=(m&255)+1|0;l=(c[b>>2]|0)+78|0;do if((m&255)>=(d[l>>0]|0))if((m&255)>248)ah(c[b+12>>2]|0,8775);else{e=k&255;a[l>>0]=e;p=e;break}else p=k&255;while(0);a[n>>0]=p;Jg(b,f,(p&255)+-1|0);if((c[f>>2]|0)==6)o=21;else{q=f+8|0;o=24}break}default:{}}if((o|0)==21){p=f+8|0;n=c[p>>2]|0;if((n&256|0)==0?(n|0)>=(d[b+46>>0]|0):0){n=b+48|0;a[n>>0]=(a[n>>0]|0)+-1<<24>>24;q=p;o=24}else{q=p;o=24}}if((o|0)==24){o=og(b,c[q>>2]<<23|20)|0;c[q>>2]=o;c[f>>2]=11}o=f+20|0;q=c[o>>2]|0;p=f+16|0;n=c[p>>2]|0;c[o>>2]=n;c[p>>2]=q;if((n|0)==-1)r=q;else{q=c[(c[b>>2]|0)+12>>2]|0;o=n;do{n=q+(o<<2)|0;if((o|0)>0?(k=n+-4|0,l=c[k>>2]|0,(a[272+(l&63)>>0]|0)<0):0){s=k;t=l}else{s=n;t=c[n>>2]|0}if((t&63|0)==28)c[s>>2]=t&8372224|t>>>23<<6|27;l=((c[n>>2]|0)>>>14)+-131071|0;o=(l|0)==-1?-1:o+1+l|0}while((o|0)!=-1);r=c[p>>2]|0}if((r|0)==-1){Pa=i;return}p=c[(c[b>>2]|0)+12>>2]|0;o=r;do{r=p+(o<<2)|0;if((o|0)>0?(t=r+-4|0,s=c[t>>2]|0,(a[272+(s&63)>>0]|0)<0):0){u=t;v=s}else{u=r;v=c[r>>2]|0}if((v&63|0)==28)c[u>>2]=v&8372224|v>>>23<<6|27;s=((c[r>>2]|0)>>>14)+-131071|0;o=(s|0)==-1?-1:o+1+s|0}while((o|0)!=-1);Pa=i;return}case 2:{Kg(b,f)|0;Ug(b,21,f,j,h);Pa=i;return}default:{Pa=i;return}}}function Ug(b,e,f,h,i){b=b|0;e=e|0;f=f|0;h=h|0;i=i|0;var j=0.0,k=0,l=0.0,m=0,n=0;if(((((((c[f>>2]|0)==5?(c[f+16>>2]|0)==-1:0)?(c[f+20>>2]|0)==-1:0)?(c[h>>2]|0)==5:0)?(c[h+16>>2]|0)==-1:0)?(c[h+20>>2]|0)==-1:0)?(j=+g[h+8>>3],k=f+8|0,!((e|1|0)==17&j==0.0)):0){l=+Ld(e+-13|0,+g[k>>3],j);g[k>>3]=l;return}switch(e|0){case 19:case 21:{m=0;break}default:m=Ng(b,h)|0}k=Ng(b,f)|0;if((k|0)>(m|0)){if(((c[f>>2]|0)==6?(n=c[f+8>>2]|0,(n&256|0)==0):0)?(n|0)>=(d[b+46>>0]|0|0):0){n=b+48|0;a[n>>0]=(a[n>>0]|0)+-1<<24>>24}if(((c[h>>2]|0)==6?(n=c[h+8>>2]|0,(n&256|0)==0):0)?(n|0)>=(d[b+46>>0]|0|0):0){n=b+48|0;a[n>>0]=(a[n>>0]|0)+-1<<24>>24}}else{if(((c[h>>2]|0)==6?(n=c[h+8>>2]|0,(n&256|0)==0):0)?(n|0)>=(d[b+46>>0]|0|0):0){n=b+48|0;a[n>>0]=(a[n>>0]|0)+-1<<24>>24}if(((c[f>>2]|0)==6?(n=c[f+8>>2]|0,(n&256|0)==0):0)?(n|0)>=(d[b+46>>0]|0|0):0){n=b+48|0;a[n>>0]=(a[n>>0]|0)+-1<<24>>24}}n=og(b,m<<14|e|k<<23)|0;c[f+8>>2]=n;c[f>>2]=11;c[(c[(c[b>>2]|0)+20>>2]|0)+((c[b+20>>2]|0)+-1<<2)>>2]=i;return}function Vg(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;switch(e|0){case 13:{Qg(b,f);return}case 14:{Rg(b,f);return}case 6:{Gg(b,f);if(((c[f>>2]|0)==6?(e=c[f+8>>2]|0,(e&256|0)==0):0)?(e|0)>=(d[b+46>>0]|0|0):0){e=b+48|0;a[e>>0]=(a[e>>0]|0)+-1<<24>>24}e=b+48|0;g=a[e>>0]|0;h=(g&255)+1|0;i=(c[b>>2]|0)+78|0;do if((g&255)>=(d[i>>0]|0))if((g&255)>248)ah(c[b+12>>2]|0,8775);else{j=h&255;a[i>>0]=j;k=j;break}else k=h&255;while(0);a[e>>0]=k;Ig(b,f,(k&255)+-1|0);return}case 5:case 4:case 3:case 2:case 1:case 0:{if(((c[f>>2]|0)==5?(c[f+16>>2]|0)==-1:0)?(c[f+20>>2]|0)==-1:0)return;Ng(b,f)|0;return}default:{Ng(b,f)|0;return}}}function Wg(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;switch(e|0){case 13:{Gg(b,g);i=g+20|0;j=c[f+20>>2]|0;do if((j|0)!=-1){k=c[i>>2]|0;if((k|0)==-1){c[i>>2]=j;break}l=c[(c[b>>2]|0)+12>>2]|0;m=k;while(1){n=l+(m<<2)|0;o=c[n>>2]|0;k=(o>>>14)+-131071|0;p=(k|0)==-1?-1:m+1+k|0;if((p|0)==-1)break;else m=p}l=j+~m|0;if((((l|0)>-1?l:0-l|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[n>>2]=(l<<14)+2147467264|o&16383;break}}while(0);c[f>>2]=c[g>>2];c[f+4>>2]=c[g+4>>2];c[f+8>>2]=c[g+8>>2];c[f+12>>2]=c[g+12>>2];c[f+16>>2]=c[g+16>>2];c[f+20>>2]=c[g+20>>2];return}case 14:{Gg(b,g);o=g+16|0;n=c[f+16>>2]|0;do if((n|0)!=-1){j=c[o>>2]|0;if((j|0)==-1){c[o>>2]=n;break}i=c[(c[b>>2]|0)+12>>2]|0;l=j;while(1){q=i+(l<<2)|0;r=c[q>>2]|0;j=(r>>>14)+-131071|0;p=(j|0)==-1?-1:l+1+j|0;if((p|0)==-1)break;else l=p}i=n+~l|0;if((((i|0)>-1?i:0-i|0)|0)>131071)ah(c[b+12>>2]|0,8740);else{c[q>>2]=(i<<14)+2147467264|r&16383;break}}while(0);c[f>>2]=c[g>>2];c[f+4>>2]=c[g+4>>2];c[f+8>>2]=c[g+8>>2];c[f+12>>2]=c[g+12>>2];c[f+16>>2]=c[g+16>>2];c[f+20>>2]=c[g+20>>2];return}case 6:{if((c[g+16>>2]|0)==(c[g+20>>2]|0))Gg(b,g);else Kg(b,g)|0;if((c[g>>2]|0)==11?(r=c[(c[b>>2]|0)+12>>2]|0,q=g+8|0,n=r+(c[q>>2]<<2)|0,o=c[n>>2]|0,(o&63|0)==22):0){i=f+8|0;if(((c[f>>2]|0)==6?(m=c[i>>2]|0,(m&256|0)==0):0)?(m|0)>=(d[b+46>>0]|0|0):0){m=b+48|0;a[m>>0]=(a[m>>0]|0)+-1<<24>>24;m=r+(c[q>>2]<<2)|0;s=m;t=c[m>>2]|0}else{s=n;t=o}c[s>>2]=c[i>>2]<<23|t&8388607;c[f>>2]=11;c[i>>2]=c[q>>2];return}Gg(b,g);if(((c[g>>2]|0)==6?(q=c[g+8>>2]|0,(q&256|0)==0):0)?(q|0)>=(d[b+46>>0]|0|0):0){q=b+48|0;a[q>>0]=(a[q>>0]|0)+-1<<24>>24}q=b+48|0;i=a[q>>0]|0;t=(i&255)+1|0;s=(c[b>>2]|0)+78|0;do if((i&255)>=(d[s>>0]|0))if((i&255)>248)ah(c[b+12>>2]|0,8775);else{o=t&255;a[s>>0]=o;u=o;break}else u=t&255;while(0);a[q>>0]=u;Ig(b,g,(u&255)+-1|0);Ug(b,22,f,g,h);return}case 5:case 4:case 3:case 2:case 1:case 0:{Ug(b,e+13|0,f,g,h);return}case 9:case 8:case 7:{Xg(b,e+17|0,1,f,g);return}case 12:case 11:case 10:{Xg(b,e+14|0,0,f,g);return}default:return}}function Xg(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0;i=Ng(b,g)|0;j=Ng(b,h)|0;if(((c[h>>2]|0)==6?(k=c[h+8>>2]|0,(k&256|0)==0):0)?(k|0)>=(d[b+46>>0]|0|0):0){k=b+48|0;a[k>>0]=(a[k>>0]|0)+-1<<24>>24}if(((c[g>>2]|0)==6?(k=c[g+8>>2]|0,(k&256|0)==0):0)?(k|0)>=(d[b+46>>0]|0|0):0){k=b+48|0;a[k>>0]=(a[k>>0]|0)+-1<<24>>24}k=(e|0)!=24&(f|0)==0;og(b,(k?64:f<<6)|e|(k?j:i)<<23|(k?i:j)<<14)|0;j=b+28|0;i=c[j>>2]|0;c[j>>2]=-1;j=og(b,2147450903)|0;if((i|0)==-1){l=j;m=g+8|0;c[m>>2]=l;c[g>>2]=10;return}if((j|0)==-1){l=i;m=g+8|0;c[m>>2]=l;c[g>>2]=10;return}k=c[(c[b>>2]|0)+12>>2]|0;e=j;while(1){n=k+(e<<2)|0;o=c[n>>2]|0;f=(o>>>14)+-131071|0;h=(f|0)==-1?-1:e+1+f|0;if((h|0)==-1)break;else e=h}k=i+~e|0;if((((k|0)>-1?k:0-k|0)|0)>131071)ah(c[b+12>>2]|0,8740);c[n>>2]=(k<<14)+2147467264|o&16383;l=j;m=g+8|0;c[m>>2]=l;c[g>>2]=10;return}function Yg(a,b){a=a|0;b=b|0;c[(c[(c[a>>2]|0)+20>>2]|0)+((c[a+20>>2]|0)+-1<<2)>>2]=b;return}function Zg(b,c,d,e){b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0;f=((d+-1|0)/50|0)+1|0;g=c<<6|((e|0)==-1?0:e<<23)|36;if((d|0)<25551)og(b,g|f<<14)|0;else{og(b,g)|0;og(b,f<<6|39)|0}a[b+48>>0]=c+1;return}function _g(b){b=b|0;var c=0,d=0;c=Be(b,8820)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=1;c=Be(b,8824)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=2;c=Be(b,8830)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=3;c=Be(b,8833)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=4;c=Be(b,8838)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=5;c=Be(b,10956)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=6;c=Be(b,8845)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=7;c=Be(b,8851)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=8;c=Be(b,8855)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=9;c=Be(b,8864)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=10;c=Be(b,8869)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=11;c=Be(b,8872)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=12;c=Be(b,8875)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=13;c=Be(b,8881)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=14;c=Be(b,8885)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=15;c=Be(b,8889)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=16;c=Be(b,8892)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=17;c=Be(b,10388)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=18;c=Be(b,8899)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=19;c=Be(b,8904)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=20;c=Be(b,8909)|0;d=c+5|0;a[d>>0]=a[d>>0]|32;a[c+6>>0]=21;c=Be(b,8915)|0;b=c+5|0;a[b>>0]=a[b>>0]|32;a[c+6>>0]=22;return}function $g(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+32|0;f=e+16|0;g=e+8|0;h=e;if((d|0)>=257){i=c[704+(d+-257<<2)>>2]|0;if((d|0)>=286){j=i;Pa=e;return j|0}k=c[b+52>>2]|0;c[f>>2]=i;j=Pd(k,8935,f)|0;Pa=e;return j|0}f=c[b+52>>2]|0;if(!(a[432+(d+1)>>0]&4)){c[g>>2]=d;j=Pd(f,8926,g)|0;Pa=e;return j|0}else{c[h>>2]=d;j=Pd(f,8921,h)|0;Pa=e;return j|0}return 0}function ah(a,b){a=a|0;b=b|0;bh(a,b,c[a+16>>2]|0)}function bh(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;f=Pa;Pa=Pa+128|0;g=f+112|0;h=f+104|0;i=f+96|0;j=f+88|0;k=f+80|0;l=f+64|0;m=f;Qd(m,(c[b+68>>2]|0)+16|0,60);f=b+52|0;n=c[f>>2]|0;o=c[b+4>>2]|0;c[l>>2]=m;c[l+4>>2]=o;c[l+8>>2]=d;d=Pd(n,8993,l)|0;if(!e){p=c[f>>2]|0;Jc(p,3)}l=c[f>>2]|0;do if((e+-287|0)>>>0>=3){if((e|0)>=257){n=c[704+(e+-257<<2)>>2]|0;if((e|0)>=286){q=n;break}c[h>>2]=n;q=Pd(l,8935,h)|0;break}if(!(a[432+(e+1)>>0]&4)){c[i>>2]=e;q=Pd(l,8926,i)|0;break}else{c[j>>2]=e;q=Pd(l,8921,j)|0;break}}else{n=b+60|0;o=c[n>>2]|0;m=o+4|0;r=c[m>>2]|0;s=r+1|0;t=o+8|0;u=c[t>>2]|0;do if(s>>>0>u>>>0){if(u>>>0>2147483645)bh(b,9003,0);v=u<<1;if((v|0)==-2)Gd(l);else{w=Hd(l,c[o>>2]|0,u,v)|0;c[o>>2]=w;c[t>>2]=v;v=c[m>>2]|0;x=v+1|0;y=w;z=v;break}}else{x=s;y=c[o>>2]|0;z=r}while(0);c[m>>2]=x;a[y+z>>0]=0;r=c[f>>2]|0;c[k>>2]=c[c[n>>2]>>2];q=Pd(r,8935,k)|0}while(0);c[g>>2]=d;c[g+4>>2]=q;Pd(l,9028,g)|0;p=c[f>>2]|0;Jc(p,3)}function ch(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;f=c[b+52>>2]|0;g=Ae(f,d,e)|0;e=f+8|0;d=c[e>>2]|0;c[e>>2]=d+16;c[d>>2]=g;c[d+8>>2]=(a[g+4>>0]|64)&255;d=Je(f,c[(c[b+48>>2]|0)+4>>2]|0,(c[e>>2]|0)+-16|0)|0;b=d+8|0;if((c[b>>2]|0)==0?(c[d>>2]=1,c[b>>2]=1,(c[(c[f+12>>2]|0)+12>>2]|0)>0):0)Ed(f);c[e>>2]=(c[e>>2]|0)+-16;return g|0}function dh(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0;a[d+76>>0]=46;h=d+52|0;c[h>>2]=b;c[d>>2]=g;c[d+32>>2]=286;c[d+56>>2]=e;c[d+48>>2]=0;c[d+4>>2]=1;c[d+8>>2]=1;c[d+68>>2]=f;f=Be(b,9039)|0;c[d+72>>2]=f;b=f+5|0;a[b>>0]=a[b>>0]|32;b=d+60|0;d=c[b>>2]|0;f=Hd(c[h>>2]|0,c[d>>2]|0,c[d+8>>2]|0,32)|0;d=c[b>>2]|0;c[d>>2]=f;c[d+8>>2]=32;return}function eh(a){a=a|0;var b=0,d=0;c[a+8>>2]=c[a+4>>2];b=a+32|0;if((c[b>>2]|0)==286){d=fh(a,a+24|0)|0;c[a+16>>2]=d;return}else{d=a+16|0;c[d>>2]=c[b>>2];c[d+4>>2]=c[b+4>>2];c[d+8>>2]=c[b+8>>2];c[d+12>>2]=c[b+12>>2];c[b>>2]=286;return}}function fh(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0,Ma=0,Na=0,Oa=0,Qa=0,Ra=0,Sa=0,Ta=0,Ua=0,Va=0,Wa=0,Xa=0,Ya=0,Za=0,_a=0,$a=0,ab=0,bb=0,cb=0,db=0,eb=0,fb=0,gb=0,hb=0,ib=0,jb=0,kb=0,lb=0,mb=0,nb=0,ob=0,pb=0,qb=0,rb=0,sb=0,tb=0,ub=0,vb=0,wb=0;f=Pa;Pa=Pa+16|0;g=f;h=b+60|0;c[(c[h>>2]|0)+4>>2]=0;i=b+56|0;j=b+4|0;a:while(1){k=c[b>>2]|0;b:do switch(k|0){case 91:{l=36;break a;break}case 61:{l=40;break a;break}case 60:{l=48;break a;break}case 62:{l=56;break a;break}case 126:{l=64;break a;break}case 58:{l=72;break a;break}case 39:case 34:{l=80;break a;break}case 46:{l=204;break a;break}case 57:case 56:case 55:case 54:case 53:case 52:case 51:case 50:case 49:case 48:{m=k;break a;break}case -1:{n=286;l=350;break a;break}case 13:case 10:{o=c[i>>2]|0;p=c[o>>2]|0;c[o>>2]=p+-1;if(!p)q=jf(o)|0;else{p=o+4|0;o=c[p>>2]|0;c[p>>2]=o+1;q=d[o>>0]|0}c[b>>2]=q;switch(q|0){case 13:case 10:{if((q|0)!=(k|0)){o=c[i>>2]|0;p=c[o>>2]|0;c[o>>2]=p+-1;if(!p)r=jf(o)|0;else{p=o+4|0;o=c[p>>2]|0;c[p>>2]=o+1;r=d[o>>0]|0}c[b>>2]=r}break}default:{}}o=c[j>>2]|0;c[j>>2]=o+1;if((o|0)>2147483643){l=14;break a}break}case 11:case 9:case 12:case 32:{o=c[i>>2]|0;p=c[o>>2]|0;c[o>>2]=p+-1;if(!p)s=jf(o)|0;else{p=o+4|0;o=c[p>>2]|0;c[p>>2]=o+1;s=d[o>>0]|0}c[b>>2]=s;break}case 45:{o=c[i>>2]|0;p=c[o>>2]|0;c[o>>2]=p+-1;if(!p)t=jf(o)|0;else{p=o+4|0;o=c[p>>2]|0;c[p>>2]=o+1;t=d[o>>0]|0}c[b>>2]=t;if((t|0)!=45){n=45;l=350;break a}o=c[i>>2]|0;p=c[o>>2]|0;c[o>>2]=p+-1;if(!p)u=jf(o)|0;else{p=o+4|0;o=c[p>>2]|0;c[p>>2]=o+1;u=d[o>>0]|0}c[b>>2]=u;do if((u|0)==91){o=gh(b)|0;c[(c[h>>2]|0)+4>>2]=0;if((o|0)>-1){hh(b,0,o);c[(c[h>>2]|0)+4>>2]=0;break b}else{v=c[b>>2]|0;break}}else v=u;while(0);o=v;while(1){switch(o|0){case -1:case 13:case 10:{break b;break}default:{}}p=c[i>>2]|0;w=c[p>>2]|0;c[p>>2]=w+-1;if(!w)x=jf(p)|0;else{w=p+4|0;p=c[w>>2]|0;c[w>>2]=p+1;x=d[p>>0]|0}c[b>>2]=x;o=x}break}default:{l=328;break a}}while(0)}switch(l|0){case 14:{ah(b,9044);break}case 36:{x=gh(b)|0;if((x|0)>-1){hh(b,e,x);n=289;Pa=f;return n|0}if((x|0)==-1){n=91;Pa=f;return n|0}else bh(b,9069,289);break}case 40:{x=c[i>>2]|0;v=c[x>>2]|0;c[x>>2]=v+-1;if(!v)y=jf(x)|0;else{v=x+4|0;x=c[v>>2]|0;c[v>>2]=x+1;y=d[x>>0]|0}c[b>>2]=y;if((y|0)!=61){n=61;Pa=f;return n|0}y=c[i>>2]|0;x=c[y>>2]|0;c[y>>2]=x+-1;if(!x)z=jf(y)|0;else{x=y+4|0;y=c[x>>2]|0;c[x>>2]=y+1;z=d[y>>0]|0}c[b>>2]=z;n=281;Pa=f;return n|0}case 48:{z=c[i>>2]|0;y=c[z>>2]|0;c[z>>2]=y+-1;if(!y)A=jf(z)|0;else{y=z+4|0;z=c[y>>2]|0;c[y>>2]=z+1;A=d[z>>0]|0}c[b>>2]=A;if((A|0)!=61){n=60;Pa=f;return n|0}A=c[i>>2]|0;z=c[A>>2]|0;c[A>>2]=z+-1;if(!z)B=jf(A)|0;else{z=A+4|0;A=c[z>>2]|0;c[z>>2]=A+1;B=d[A>>0]|0}c[b>>2]=B;n=283;Pa=f;return n|0}case 56:{B=c[i>>2]|0;A=c[B>>2]|0;c[B>>2]=A+-1;if(!A)C=jf(B)|0;else{A=B+4|0;B=c[A>>2]|0;c[A>>2]=B+1;C=d[B>>0]|0}c[b>>2]=C;if((C|0)!=61){n=62;Pa=f;return n|0}C=c[i>>2]|0;B=c[C>>2]|0;c[C>>2]=B+-1;if(!B)D=jf(C)|0;else{B=C+4|0;C=c[B>>2]|0;c[B>>2]=C+1;D=d[C>>0]|0}c[b>>2]=D;n=282;Pa=f;return n|0}case 64:{D=c[i>>2]|0;C=c[D>>2]|0;c[D>>2]=C+-1;if(!C)E=jf(D)|0;else{C=D+4|0;D=c[C>>2]|0;c[C>>2]=D+1;E=d[D>>0]|0}c[b>>2]=E;if((E|0)!=61){n=126;Pa=f;return n|0}E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)F=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;F=d[E>>0]|0}c[b>>2]=F;n=284;Pa=f;return n|0}case 72:{F=c[i>>2]|0;E=c[F>>2]|0;c[F>>2]=E+-1;if(!E)G=jf(F)|0;else{E=F+4|0;F=c[E>>2]|0;c[E>>2]=F+1;G=d[F>>0]|0}c[b>>2]=G;if((G|0)!=58){n=58;Pa=f;return n|0}G=c[i>>2]|0;F=c[G>>2]|0;c[G>>2]=F+-1;if(!F)H=jf(G)|0;else{F=G+4|0;G=c[F>>2]|0;c[F>>2]=G+1;H=d[G>>0]|0}c[b>>2]=H;n=285;Pa=f;return n|0}case 80:{H=c[h>>2]|0;G=H+4|0;F=c[G>>2]|0;E=F+1|0;D=H+8|0;C=c[D>>2]|0;do if(E>>>0>C>>>0){if(C>>>0>2147483645)bh(b,9003,0);B=C<<1;A=c[b+52>>2]|0;if((B|0)==-2)Gd(A);else{z=Hd(A,c[H>>2]|0,C,B)|0;c[H>>2]=z;c[D>>2]=B;B=c[G>>2]|0;I=B+1|0;J=z;K=B;break}}else{I=E;J=c[H>>2]|0;K=F}while(0);F=k&255;c[G>>2]=I;a[J+K>>0]=F;K=c[i>>2]|0;J=c[K>>2]|0;c[K>>2]=J+-1;if(!J)L=jf(K)|0;else{J=K+4|0;K=c[J>>2]|0;c[J>>2]=K+1;L=d[K>>0]|0}c[b>>2]=L;c:do if((L|0)!=(k|0)){K=b+52|0;J=g+4|0;I=g+8|0;G=L;d:while(1){e:do switch(G|0){case -1:{l=93;break d;break}case 13:case 10:{l=94;break d;break}case 92:{H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)M=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;M=d[H>>0]|0}c[b>>2]=M;do switch(M|0){case -1:{N=M;break e;break}case 97:{O=7;l=166;break}case 98:{O=8;l=166;break}case 102:{O=12;l=166;break}case 110:{O=10;l=166;break}case 114:{O=13;l=166;break}case 116:{O=9;l=166;break}case 118:{O=11;l=166;break}case 120:{c[g>>2]=120;H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)P=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;P=d[H>>0]|0}c[b>>2]=P;c[J>>2]=P;if(!(a[432+(P+1)>>0]&16)){Q=2;l=109;break d}H=Md(P)|0;E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)R=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;R=d[E>>0]|0}c[b>>2]=R;c[I>>2]=R;if(!(a[432+(R+1)>>0]&16)){Q=3;l=109;break d}O=(Md(R)|0)+(H<<4)|0;l=166;break}case 13:case 10:{H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)S=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;S=d[H>>0]|0}c[b>>2]=S;switch(S|0){case 13:case 10:{if((S|0)!=(M|0)){H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)T=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;T=d[H>>0]|0}c[b>>2]=T}break}default:{}}H=c[j>>2]|0;c[j>>2]=H+1;if((H|0)>2147483643){l=125;break d}else U=10;break}case 39:case 34:case 92:{O=M;l=166;break}case 122:{H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)V=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;V=d[H>>0]|0}c[b>>2]=V;if(!(a[432+(V+1)>>0]&8)){N=V;break e}H=V;while(1){switch(H|0){case 13:case 10:{E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)W=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;W=d[E>>0]|0}c[b>>2]=W;switch(W|0){case 13:case 10:{if((W|0)==(H|0))X=H;else{E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)Y=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;Y=d[E>>0]|0}c[b>>2]=Y;X=Y}break}default:X=W}E=c[j>>2]|0;c[j>>2]=E+1;if((E|0)>2147483643){l=143;break d}else Z=X;break}default:{E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)_=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;_=d[E>>0]|0}c[b>>2]=_;Z=_}}if(!(a[432+(Z+1)>>0]&8)){N=Z;break e}else H=Z}break}default:{if(!(a[432+(M+1)>>0]&2)){l=150;break d}c[g>>2]=M;H=M+-48|0;E=c[i>>2]|0;D=c[E>>2]|0;c[E>>2]=D+-1;if(!D)$=jf(E)|0;else{D=E+4|0;E=c[D>>2]|0;c[D>>2]=E+1;$=d[E>>0]|0}c[b>>2]=$;if(a[432+($+1)>>0]&2){c[J>>2]=$;E=(H*10|0)+-48+$|0;D=c[i>>2]|0;C=c[D>>2]|0;c[D>>2]=C+-1;if(!C)aa=jf(D)|0;else{C=D+4|0;D=c[C>>2]|0;c[C>>2]=D+1;aa=d[D>>0]|0}c[b>>2]=aa;if(!(a[432+(aa+1)>>0]&2)){ba=E;ca=2}else{c[I>>2]=aa;D=c[i>>2]|0;C=c[D>>2]|0;c[D>>2]=C+-1;if(!C)da=jf(D)|0;else{C=D+4|0;D=c[C>>2]|0;c[C>>2]=D+1;da=d[D>>0]|0}c[b>>2]=da;ba=(E*10|0)+-48+aa|0;ca=3}}else{ba=H;ca=1}if((ba|0)>255){l=156;break d}U=ba}}while(0);if((l|0)==166){l=0;H=c[i>>2]|0;E=c[H>>2]|0;c[H>>2]=E+-1;if(!E)ea=jf(H)|0;else{E=H+4|0;H=c[E>>2]|0;c[E>>2]=H+1;ea=d[H>>0]|0}c[b>>2]=ea;U=O}H=c[h>>2]|0;E=H+4|0;D=c[E>>2]|0;C=D+1|0;B=H+8|0;z=c[B>>2]|0;if(C>>>0>z>>>0){if(z>>>0>2147483645){l=173;break d}A=z<<1;fa=c[K>>2]|0;if((A|0)==-2){l=175;break d}y=Hd(fa,c[H>>2]|0,z,A)|0;c[H>>2]=y;c[B>>2]=A;A=c[E>>2]|0;ga=A+1|0;ha=y;ia=A}else{ga=C;ha=c[H>>2]|0;ia=D}c[E>>2]=ga;a[ha+ia>>0]=U;N=c[b>>2]|0;break}default:{E=c[h>>2]|0;D=E+4|0;H=c[D>>2]|0;C=H+1|0;A=E+8|0;y=c[A>>2]|0;if(C>>>0>y>>>0){if(y>>>0>2147483645){l=181;break d}B=y<<1;ja=c[K>>2]|0;if((B|0)==-2){l=183;break d}z=Hd(ja,c[E>>2]|0,y,B)|0;c[E>>2]=z;c[A>>2]=B;B=c[D>>2]|0;ka=B+1|0;la=z;ma=B}else{ka=C;la=c[E>>2]|0;ma=H}c[D>>2]=ka;a[la+ma>>0]=G;D=c[i>>2]|0;H=c[D>>2]|0;c[D>>2]=H+-1;if(!H)na=jf(D)|0;else{H=D+4|0;D=c[H>>2]|0;c[H>>2]=D+1;na=d[D>>0]|0}c[b>>2]=na;N=na}}while(0);if((N|0)==(k|0))break c;else G=N}switch(l|0){case 93:{bh(b,9099,286);break}case 94:{bh(b,9099,289);break}case 109:{ih(b,g,Q,9117);break}case 125:{ah(b,9044);break}case 143:{ah(b,9044);break}case 150:{ih(b,b,1,9144);break}case 156:{ih(b,g,ca,9168);break}case 173:{bh(b,9003,0);break}case 175:{Gd(fa);break}case 181:{bh(b,9003,0);break}case 183:{Gd(ja);break}}}while(0);ja=c[h>>2]|0;fa=ja+4|0;ca=c[fa>>2]|0;g=ca+1|0;Q=ja+8|0;N=c[Q>>2]|0;do if(g>>>0>N>>>0){if(N>>>0>2147483645)bh(b,9003,0);na=N<<1;ma=c[b+52>>2]|0;if((na|0)==-2)Gd(ma);else{la=Hd(ma,c[ja>>2]|0,N,na)|0;c[ja>>2]=la;c[Q>>2]=na;na=c[fa>>2]|0;oa=na+1|0;pa=la;qa=na;break}}else{oa=g;pa=c[ja>>2]|0;qa=ca}while(0);c[fa>>2]=oa;a[pa+qa>>0]=F;F=c[i>>2]|0;qa=c[F>>2]|0;c[F>>2]=qa+-1;if(!qa)ra=jf(F)|0;else{qa=F+4|0;F=c[qa>>2]|0;c[qa>>2]=F+1;ra=d[F>>0]|0}c[b>>2]=ra;ra=c[h>>2]|0;F=c[b+52>>2]|0;qa=Ae(F,(c[ra>>2]|0)+1|0,(c[ra+4>>2]|0)+-2|0)|0;ra=F+8|0;pa=c[ra>>2]|0;c[ra>>2]=pa+16;c[pa>>2]=qa;c[pa+8>>2]=(a[qa+4>>0]|64)&255;pa=Je(F,c[(c[b+48>>2]|0)+4>>2]|0,(c[ra>>2]|0)+-16|0)|0;oa=pa+8|0;if((c[oa>>2]|0)==0?(c[pa>>2]=1,c[oa>>2]=1,(c[(c[F+12>>2]|0)+12>>2]|0)>0):0)Ed(F);c[ra>>2]=(c[ra>>2]|0)+-16;c[e>>2]=qa;n=289;Pa=f;return n|0}case 204:{qa=c[h>>2]|0;ra=qa+4|0;F=c[ra>>2]|0;oa=F+1|0;pa=qa+8|0;fa=c[pa>>2]|0;do if(oa>>>0>fa>>>0){if(fa>>>0>2147483645)bh(b,9003,0);ca=fa<<1;ja=c[b+52>>2]|0;if((ca|0)==-2)Gd(ja);else{g=Hd(ja,c[qa>>2]|0,fa,ca)|0;c[qa>>2]=g;c[pa>>2]=ca;ca=c[ra>>2]|0;sa=ca+1|0;ta=g;ua=ca;break}}else{sa=oa;ta=c[qa>>2]|0;ua=F}while(0);c[ra>>2]=sa;a[ta+ua>>0]=46;ua=c[i>>2]|0;ta=c[ua>>2]|0;c[ua>>2]=ta+-1;if(!ta)va=jf(ua)|0;else{ta=ua+4|0;ua=c[ta>>2]|0;c[ta>>2]=ua+1;va=d[ua>>0]|0}c[b>>2]=va;if(va|0?Xk(13528,va,2)|0:0){ua=c[h>>2]|0;ta=ua+4|0;sa=c[ta>>2]|0;ra=sa+1|0;F=ua+8|0;qa=c[F>>2]|0;do if(ra>>>0>qa>>>0){if(qa>>>0>2147483645)bh(b,9003,0);oa=qa<<1;pa=c[b+52>>2]|0;if((oa|0)==-2)Gd(pa);else{fa=Hd(pa,c[ua>>2]|0,qa,oa)|0;c[ua>>2]=fa;c[F>>2]=oa;oa=c[ta>>2]|0;wa=oa+1|0;xa=fa;ya=oa;break}}else{wa=ra;xa=c[ua>>2]|0;ya=sa}while(0);c[ta>>2]=wa;a[xa+ya>>0]=va;ya=c[i>>2]|0;xa=c[ya>>2]|0;c[ya>>2]=xa+-1;if(!xa)za=jf(ya)|0;else{xa=ya+4|0;ya=c[xa>>2]|0;c[xa>>2]=ya+1;za=d[ya>>0]|0}c[b>>2]=za;if(!za){n=279;Pa=f;return n|0}if(!(Xk(13528,za,2)|0)){n=279;Pa=f;return n|0}ya=c[h>>2]|0;xa=ya+4|0;wa=c[xa>>2]|0;ta=wa+1|0;sa=ya+8|0;ua=c[sa>>2]|0;do if(ta>>>0>ua>>>0){if(ua>>>0>2147483645)bh(b,9003,0);ra=ua<<1;F=c[b+52>>2]|0;if((ra|0)==-2)Gd(F);else{qa=Hd(F,c[ya>>2]|0,ua,ra)|0;c[ya>>2]=qa;c[sa>>2]=ra;ra=c[xa>>2]|0;Aa=ra+1|0;Ba=qa;Ca=ra;break}}else{Aa=ta;Ba=c[ya>>2]|0;Ca=wa}while(0);c[xa>>2]=Aa;a[Ba+Ca>>0]=za;za=c[i>>2]|0;Ca=c[za>>2]|0;c[za>>2]=Ca+-1;if(!Ca)Da=jf(za)|0;else{Ca=za+4|0;za=c[Ca>>2]|0;c[Ca>>2]=za+1;Da=d[za>>0]|0}c[b>>2]=Da;n=280;Pa=f;return n|0}if(!(a[432+(va+1)>>0]&2)){n=46;Pa=f;return n|0}else m=va;break}case 328:{if(!(a[432+(k+1)>>0]&1)){va=c[i>>2]|0;Da=c[va>>2]|0;c[va>>2]=Da+-1;if(!Da)Ea=jf(va)|0;else{Da=va+4|0;va=c[Da>>2]|0;c[Da>>2]=va+1;Ea=d[va>>0]|0}c[b>>2]=Ea;n=k;Pa=f;return n|0}Ea=b+52|0;va=k;while(1){k=c[h>>2]|0;Da=k+4|0;za=c[Da>>2]|0;Ca=za+1|0;Ba=k+8|0;Aa=c[Ba>>2]|0;if(Ca>>>0>Aa>>>0){if(Aa>>>0>2147483645){l=333;break}xa=Aa<<1;Fa=c[Ea>>2]|0;if((xa|0)==-2){l=335;break}wa=Hd(Fa,c[k>>2]|0,Aa,xa)|0;c[k>>2]=wa;c[Ba>>2]=xa;xa=c[Da>>2]|0;Ga=xa+1|0;Ha=wa;Ia=xa}else{Ga=Ca;Ha=c[k>>2]|0;Ia=za}c[Da>>2]=Ga;a[Ha+Ia>>0]=va;Da=c[i>>2]|0;za=c[Da>>2]|0;c[Da>>2]=za+-1;if(!za)Ja=jf(Da)|0;else{za=Da+4|0;Da=c[za>>2]|0;c[za>>2]=Da+1;Ja=d[Da>>0]|0}c[b>>2]=Ja;if(!(a[432+(Ja+1)>>0]&3)){l=341;break}else va=Ja}if((l|0)==333)bh(b,9003,0);else if((l|0)==335)Gd(Fa);else if((l|0)==341){Fa=c[h>>2]|0;Ja=c[Ea>>2]|0;Ea=Ae(Ja,c[Fa>>2]|0,c[Fa+4>>2]|0)|0;Fa=Ja+8|0;va=c[Fa>>2]|0;c[Fa>>2]=va+16;c[va>>2]=Ea;Ia=Ea+4|0;c[va+8>>2]=(a[Ia>>0]|64)&255;va=Je(Ja,c[(c[b+48>>2]|0)+4>>2]|0,(c[Fa>>2]|0)+-16|0)|0;Ha=va+8|0;if((c[Ha>>2]|0)==0?(c[va>>2]=1,c[Ha>>2]=1,(c[(c[Ja+12>>2]|0)+12>>2]|0)>0):0)Ed(Ja);c[Fa>>2]=(c[Fa>>2]|0)+-16;c[e>>2]=Ea;if((a[Ia>>0]|0)==4){Ia=a[Ea+6>>0]|0;Pa=f;return (Ia<<24>>24==0?288:Ia&255|256)|0}else{n=288;Pa=f;return n|0}}break}case 350:{Pa=f;return n|0}}Ia=c[h>>2]|0;Ea=Ia+4|0;Fa=c[Ea>>2]|0;Ja=Fa+1|0;Ha=Ia+8|0;va=c[Ha>>2]|0;do if(Ja>>>0>va>>>0){if(va>>>0>2147483645)bh(b,9003,0);Ga=va<<1;Da=c[b+52>>2]|0;if((Ga|0)==-2)Gd(Da);else{za=Hd(Da,c[Ia>>2]|0,va,Ga)|0;c[Ia>>2]=za;c[Ha>>2]=Ga;Ga=c[Ea>>2]|0;Ka=Ga+1|0;La=za;Ma=Ga;break}}else{Ka=Ja;La=c[Ia>>2]|0;Ma=Fa}while(0);c[Ea>>2]=Ka;a[La+Ma>>0]=m;Ma=c[i>>2]|0;La=c[Ma>>2]|0;c[Ma>>2]=La+-1;if(!La)Na=jf(Ma)|0;else{La=Ma+4|0;Ma=c[La>>2]|0;c[La>>2]=Ma+1;Na=d[Ma>>0]|0}c[b>>2]=Na;if(!((m|0)!=48|(Na|0)==0)?(Xk(9193,Na,3)|0)!=0:0){m=c[h>>2]|0;Ma=m+4|0;La=c[Ma>>2]|0;Ka=La+1|0;Ea=m+8|0;Fa=c[Ea>>2]|0;do if(Ka>>>0>Fa>>>0){if(Fa>>>0>2147483645)bh(b,9003,0);Ia=Fa<<1;Ja=c[b+52>>2]|0;if((Ia|0)==-2)Gd(Ja);else{Ha=Hd(Ja,c[m>>2]|0,Fa,Ia)|0;c[m>>2]=Ha;c[Ea>>2]=Ia;Ia=c[Ma>>2]|0;Oa=Ia+1|0;Qa=Ha;Ra=Ia;break}}else{Oa=Ka;Qa=c[m>>2]|0;Ra=La}while(0);c[Ma>>2]=Oa;a[Qa+Ra>>0]=Na;Ra=c[i>>2]|0;Qa=c[Ra>>2]|0;c[Ra>>2]=Qa+-1;if(!Qa)Sa=jf(Ra)|0;else{Qa=Ra+4|0;Ra=c[Qa>>2]|0;c[Qa>>2]=Ra+1;Sa=d[Ra>>0]|0}c[b>>2]=Sa;Ta=9199;Ua=Sa}else{Ta=9196;Ua=Na}Na=b+52|0;Sa=Ua;while(1){if(Sa)if(Xk(Ta,Sa,3)|0){Ua=c[h>>2]|0;Ra=Ua+4|0;Qa=c[Ra>>2]|0;Oa=Qa+1|0;Ma=Ua+8|0;La=c[Ma>>2]|0;if(Oa>>>0>La>>>0){if(La>>>0>2147483645){l=269;break}m=La<<1;Va=c[Na>>2]|0;if((m|0)==-2){l=271;break}Ka=Hd(Va,c[Ua>>2]|0,La,m)|0;c[Ua>>2]=Ka;c[Ma>>2]=m;m=c[Ra>>2]|0;Wa=m+1|0;Xa=Ka;Ya=m}else{Wa=Oa;Xa=c[Ua>>2]|0;Ya=Qa}c[Ra>>2]=Wa;a[Xa+Ya>>0]=Sa;Ra=c[i>>2]|0;Qa=c[Ra>>2]|0;c[Ra>>2]=Qa+-1;if(!Qa)Za=jf(Ra)|0;else{Qa=Ra+4|0;Ra=c[Qa>>2]|0;c[Qa>>2]=Ra+1;Za=d[Ra>>0]|0}c[b>>2]=Za;if(Za)if(!(Xk(9202,Za,3)|0))_a=Za;else{Ra=c[h>>2]|0;Qa=Ra+4|0;Ua=c[Qa>>2]|0;Oa=Ua+1|0;m=Ra+8|0;Ka=c[m>>2]|0;if(Oa>>>0>Ka>>>0){if(Ka>>>0>2147483645){l=281;break}Ma=Ka<<1;$a=c[Na>>2]|0;if((Ma|0)==-2){l=283;break}La=Hd($a,c[Ra>>2]|0,Ka,Ma)|0;c[Ra>>2]=La;c[m>>2]=Ma;Ma=c[Qa>>2]|0;ab=Ma+1|0;bb=La;cb=Ma}else{ab=Oa;bb=c[Ra>>2]|0;cb=Ua}c[Qa>>2]=ab;a[bb+cb>>0]=Za;Qa=c[i>>2]|0;Ua=c[Qa>>2]|0;c[Qa>>2]=Ua+-1;if(!Ua)db=jf(Qa)|0;else{Ua=Qa+4|0;Qa=c[Ua>>2]|0;c[Ua>>2]=Qa+1;db=d[Qa>>0]|0}c[b>>2]=db;_a=db}else _a=0}else _a=Sa;else _a=0;eb=c[h>>2]|0;fb=eb+4|0;gb=c[fb>>2]|0;hb=gb+1|0;ib=eb+8|0;jb=c[ib>>2]|0;kb=hb>>>0>jb>>>0;if(!((_a|0)==46?1:(a[432+(_a+1)>>0]&16)!=0)){l=301;break}if(kb){if(jb>>>0>2147483645){l=293;break}Qa=jb<<1;lb=c[Na>>2]|0;if((Qa|0)==-2){l=295;break}Ua=Hd(lb,c[eb>>2]|0,jb,Qa)|0;c[eb>>2]=Ua;c[ib>>2]=Qa;Qa=c[fb>>2]|0;mb=Qa+1|0;nb=Ua;ob=Qa}else{mb=hb;nb=c[eb>>2]|0;ob=gb}c[fb>>2]=mb;a[nb+ob>>0]=_a;Qa=c[i>>2]|0;Ua=c[Qa>>2]|0;c[Qa>>2]=Ua+-1;if(!Ua)pb=jf(Qa)|0;else{Ua=Qa+4|0;Qa=c[Ua>>2]|0;c[Ua>>2]=Qa+1;pb=d[Qa>>0]|0}c[b>>2]=pb;Sa=pb}if((l|0)==269)bh(b,9003,0);else if((l|0)==271)Gd(Va);else if((l|0)==281)bh(b,9003,0);else if((l|0)==283)Gd($a);else if((l|0)==293)bh(b,9003,0);else if((l|0)==295)Gd(lb);else if((l|0)==301){do if(kb){if(jb>>>0>2147483645)bh(b,9003,0);l=jb<<1;lb=c[Na>>2]|0;if((l|0)==-2)Gd(lb);else{$a=Hd(lb,c[eb>>2]|0,jb,l)|0;c[eb>>2]=$a;c[ib>>2]=l;l=c[fb>>2]|0;qb=l+1|0;rb=$a;sb=l;break}}else{qb=hb;rb=c[eb>>2]|0;sb=gb}while(0);c[fb>>2]=qb;a[rb+sb>>0]=0;sb=b+76|0;rb=a[sb>>0]|0;qb=c[h>>2]|0;fb=c[qb>>2]|0;gb=c[qb+4>>2]|0;if(!gb){tb=fb;ub=-1}else{qb=gb;do{qb=qb+-1|0;gb=fb+qb|0;if((a[gb>>0]|0)==46)a[gb>>0]=rb}while((qb|0)!=0);qb=c[h>>2]|0;tb=c[qb>>2]|0;ub=(c[qb+4>>2]|0)+-1|0}if(Nd(tb,ub,e)|0){n=287;Pa=f;return n|0}ub=a[sb>>0]|0;tb=qn()|0;qb=a[c[tb>>2]>>0]|0;a[sb>>0]=qb;tb=c[h>>2]|0;rb=c[tb>>2]|0;fb=c[tb+4>>2]|0;if(!fb){vb=rb;wb=-1}else{tb=fb;do{tb=tb+-1|0;fb=rb+tb|0;if((a[fb>>0]|0)==ub<<24>>24)a[fb>>0]=qb}while((tb|0)!=0);tb=c[h>>2]|0;vb=c[tb>>2]|0;wb=(c[tb+4>>2]|0)+-1|0}if(Nd(vb,wb,e)|0){n=287;Pa=f;return n|0}n=a[sb>>0]|0;sb=c[h>>2]|0;h=c[sb>>2]|0;f=c[sb+4>>2]|0;if(!f)bh(b,9205,287);sb=f;do{sb=sb+-1|0;f=h+sb|0;if((a[f>>0]|0)==n<<24>>24)a[f>>0]=46}while((sb|0)!=0);bh(b,9205,287)}return 0}function gh(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;e=c[b>>2]|0;f=b+60|0;g=c[f>>2]|0;h=g+4|0;i=c[h>>2]|0;j=i+1|0;k=g+8|0;l=c[k>>2]|0;do if(j>>>0>l>>>0){if(l>>>0>2147483645)bh(b,9003,0);m=l<<1;n=c[b+52>>2]|0;if((m|0)==-2)Gd(n);else{o=Hd(n,c[g>>2]|0,l,m)|0;c[g>>2]=o;c[k>>2]=m;m=c[h>>2]|0;p=m+1|0;q=o;r=m;break}}else{p=j;q=c[g>>2]|0;r=i}while(0);c[h>>2]=p;a[q+r>>0]=e;r=b+56|0;q=c[r>>2]|0;p=c[q>>2]|0;c[q>>2]=p+-1;if(!p)s=jf(q)|0;else{p=q+4|0;q=c[p>>2]|0;c[p>>2]=q+1;s=d[q>>0]|0}c[b>>2]=s;if((s|0)!=61){t=0;u=s;v=(u|0)!=(e|0);w=v<<31>>31;x=t^w;return x|0}s=b+52|0;q=0;while(1){p=c[f>>2]|0;h=p+4|0;i=c[h>>2]|0;g=i+1|0;j=p+8|0;k=c[j>>2]|0;if(g>>>0>k>>>0){if(k>>>0>2147483645){y=16;break}l=k<<1;z=c[s>>2]|0;if((l|0)==-2){y=18;break}m=Hd(z,c[p>>2]|0,k,l)|0;c[p>>2]=m;c[j>>2]=l;l=c[h>>2]|0;A=l+1|0;B=m;C=l}else{A=g;B=c[p>>2]|0;C=i}c[h>>2]=A;a[B+C>>0]=61;h=c[r>>2]|0;i=c[h>>2]|0;c[h>>2]=i+-1;if(!i)D=jf(h)|0;else{i=h+4|0;h=c[i>>2]|0;c[i>>2]=h+1;D=d[h>>0]|0}c[b>>2]=D;h=q+1|0;if((D|0)==61)q=h;else{t=h;u=D;y=24;break}}if((y|0)==16)bh(b,9003,0);else if((y|0)==18)Gd(z);else if((y|0)==24){v=(u|0)!=(e|0);w=v<<31>>31;x=t^w;return x|0}return 0}function hh(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0;g=c[b>>2]|0;h=b+60|0;i=c[h>>2]|0;j=i+4|0;k=c[j>>2]|0;l=k+1|0;m=i+8|0;n=c[m>>2]|0;do if(l>>>0>n>>>0){if(n>>>0>2147483645)bh(b,9003,0);o=n<<1;p=c[b+52>>2]|0;if((o|0)==-2)Gd(p);else{q=Hd(p,c[i>>2]|0,n,o)|0;c[i>>2]=q;c[m>>2]=o;o=c[j>>2]|0;r=o+1|0;s=q;t=o;break}}else{r=l;s=c[i>>2]|0;t=k}while(0);c[j>>2]=r;a[s+t>>0]=g;g=b+56|0;t=c[g>>2]|0;s=c[t>>2]|0;c[t>>2]=s+-1;if(!s)u=jf(t)|0;else{s=t+4|0;t=c[s>>2]|0;c[s>>2]=t+1;u=d[t>>0]|0}c[b>>2]=u;switch(u|0){case 13:case 10:{t=c[g>>2]|0;s=c[t>>2]|0;c[t>>2]=s+-1;if(!s)v=jf(t)|0;else{s=t+4|0;t=c[s>>2]|0;c[s>>2]=t+1;v=d[t>>0]|0}c[b>>2]=v;switch(v|0){case 13:case 10:{if((v|0)==(u|0))w=u;else{t=c[g>>2]|0;s=c[t>>2]|0;c[t>>2]=s+-1;if(!s)x=jf(t)|0;else{s=t+4|0;t=c[s>>2]|0;c[s>>2]=t+1;x=d[t>>0]|0}c[b>>2]=x;w=x}break}default:w=v}v=b+4|0;x=c[v>>2]|0;c[v>>2]=x+1;if((x|0)>2147483643)ah(b,9044);else{y=v;z=w}break}default:{y=b+4|0;z=u}}u=(e|0)==0;w=b+52|0;v=z;a:while(1){b:do switch(v|0){case -1:{A=26;break a;break}case 93:{z=(gh(b)|0)==(f|0);B=c[b>>2]|0;if(z){A=29;break a}else C=B;break}case 13:case 10:{z=c[h>>2]|0;x=z+4|0;t=c[x>>2]|0;s=t+1|0;r=z+8|0;j=c[r>>2]|0;if(s>>>0>j>>>0){if(j>>>0>2147483645){A=43;break a}k=j<<1;D=c[w>>2]|0;if((k|0)==-2){A=45;break a}i=Hd(D,c[z>>2]|0,j,k)|0;c[z>>2]=i;c[r>>2]=k;k=c[x>>2]|0;E=k+1|0;F=i;G=k}else{E=s;F=c[z>>2]|0;G=t}c[x>>2]=E;a[F+G>>0]=10;x=c[b>>2]|0;t=c[g>>2]|0;z=c[t>>2]|0;c[t>>2]=z+-1;if(!z)H=jf(t)|0;else{z=t+4|0;t=c[z>>2]|0;c[z>>2]=t+1;H=d[t>>0]|0}c[b>>2]=H;switch(H|0){case 13:case 10:{if((H|0)==(x|0))I=x;else{x=c[g>>2]|0;t=c[x>>2]|0;c[x>>2]=t+-1;if(!t)J=jf(x)|0;else{t=x+4|0;x=c[t>>2]|0;c[t>>2]=x+1;J=d[x>>0]|0}c[b>>2]=J;I=J}break}default:I=H}x=c[y>>2]|0;c[y>>2]=x+1;if((x|0)>2147483643){A=57;break a}if(u){c[(c[h>>2]|0)+4>>2]=0;C=I}else C=I;break}default:{if(u){x=c[g>>2]|0;t=c[x>>2]|0;c[x>>2]=t+-1;if(!t)K=jf(x)|0;else{t=x+4|0;x=c[t>>2]|0;c[t>>2]=x+1;K=d[x>>0]|0}c[b>>2]=K;C=K;break b}x=c[h>>2]|0;t=x+4|0;z=c[t>>2]|0;s=z+1|0;k=x+8|0;i=c[k>>2]|0;if(s>>>0>i>>>0){if(i>>>0>2147483645){A=64;break a}r=i<<1;L=c[w>>2]|0;if((r|0)==-2){A=66;break a}j=Hd(L,c[x>>2]|0,i,r)|0;c[x>>2]=j;c[k>>2]=r;r=c[t>>2]|0;M=r+1|0;N=j;O=r}else{M=s;N=c[x>>2]|0;O=z}c[t>>2]=M;a[N+O>>0]=v;t=c[g>>2]|0;z=c[t>>2]|0;c[t>>2]=z+-1;if(!z)P=jf(t)|0;else{z=t+4|0;t=c[z>>2]|0;c[z>>2]=t+1;P=d[t>>0]|0}c[b>>2]=P;C=P}}while(0);v=C}if((A|0)==26)bh(b,u?9222:9246,286);else if((A|0)==29){C=c[h>>2]|0;v=C+4|0;P=c[v>>2]|0;O=P+1|0;N=C+8|0;M=c[N>>2]|0;do if(O>>>0>M>>>0){if(M>>>0>2147483645)bh(b,9003,0);K=M<<1;I=c[w>>2]|0;if((K|0)==-2)Gd(I);else{y=Hd(I,c[C>>2]|0,M,K)|0;c[C>>2]=y;c[N>>2]=K;K=c[v>>2]|0;Q=K+1|0;R=y;S=K;break}}else{Q=O;R=c[C>>2]|0;S=P}while(0);c[v>>2]=Q;a[R+S>>0]=B;B=c[g>>2]|0;g=c[B>>2]|0;c[B>>2]=g+-1;if(!g)T=jf(B)|0;else{g=B+4|0;B=c[g>>2]|0;c[g>>2]=B+1;T=d[B>>0]|0}c[b>>2]=T;if(u)return;u=c[h>>2]|0;h=f+2|0;f=c[w>>2]|0;w=Ae(f,(c[u>>2]|0)+h|0,(c[u+4>>2]|0)-(h<<1)|0)|0;h=f+8|0;u=c[h>>2]|0;c[h>>2]=u+16;c[u>>2]=w;c[u+8>>2]=(a[w+4>>0]|64)&255;u=Je(f,c[(c[b+48>>2]|0)+4>>2]|0,(c[h>>2]|0)+-16|0)|0;T=u+8|0;if((c[T>>2]|0)==0?(c[u>>2]=1,c[T>>2]=1,(c[(c[f+12>>2]|0)+12>>2]|0)>0):0)Ed(f);c[h>>2]=(c[h>>2]|0)+-16;c[e>>2]=w;return}else if((A|0)==43)bh(b,9003,0);else if((A|0)==45)Gd(D);else if((A|0)==57)ah(b,9044);else if((A|0)==64)bh(b,9003,0);else if((A|0)==66)Gd(L)}function ih(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;c[(c[a+60>>2]|0)+4>>2]=0;jh(a,92);a:do if((d|0)>0){f=0;do{g=c[b+(f<<2)>>2]|0;if((g|0)==-1)break a;jh(a,g);f=f+1|0}while((f|0)<(d|0))}while(0);bh(a,e,289)}function jh(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;e=c[b+60>>2]|0;f=e+4|0;g=c[f>>2]|0;h=g+1|0;i=e+8|0;j=c[i>>2]|0;if(h>>>0<=j>>>0){k=h;l=c[e>>2]|0;m=g;n=d&255;c[f>>2]=k;o=l+m|0;a[o>>0]=n;return}if(j>>>0>2147483645)bh(b,9003,0);g=j<<1;h=c[b+52>>2]|0;if((g|0)==-2)Gd(h);b=Hd(h,c[e>>2]|0,j,g)|0;c[e>>2]=b;c[i>>2]=g;g=c[f>>2]|0;k=g+1|0;l=b;m=g;n=d&255;c[f>>2]=k;o=l+m|0;a[o>>0]=n;return}function kh(a){a=a|0;var b=0;b=fh(a,a+40|0)|0;c[a+32>>2]=b;return b|0}function lh(a){a=a|0;Tb(a,-1001e3,2);Tb(a,-1001e3,2);Zb(a,-2,9269);cg(a,848,0);Hb(a,9272,7)|0;Zb(a,-2,9280);return 1}function mh(a){a=a|0;var b=0,d=0,e=0,f=0;b=Pa;Pa=Pa+16|0;d=b;if(!(xb(a,1)|0)){e=Af(a,2,9815,0)|0;c[d>>2]=e;f=rf(a,11053,d)|0;Pa=b;return f|0}else{f=gb(a)|0;Pa=b;return f|0}return 0}function nh(a){a=a|0;var b=0,d=0,e=0;b=1088+((zf(a,1,9722,1040)|0)<<2)|0;d=c[b>>2]|0;b=jc(a,d,Jf(a,2,0)|0)|0;switch(d|0){case 3:{d=jc(a,4,0)|0;Eb(a,+(d|0)*.0009765625+ +(b|0));Fb(a,d);e=2;return e|0}case 9:case 5:{Mb(a,b);e=1;return e|0}default:{Fb(a,b);e=1;return e|0}}return 0}function oh(a){a=a|0;var b=0;b=Af(a,1,0,0)|0;hb(a,1);if(!(Sf(a,b,0)|0)){dc(a,0,-1,0,284);return (gb(a)|0)+-1|0}else kc(a)|0;return 0}function ph(a){a=a|0;var b=0;b=Jf(a,2,1)|0;hb(a,1);if(!((b|0)>0&(rb(a,1)|0)!=0))kc(a)|0;sf(a,b);mb(a,1);mc(a,2);kc(a)|0;return 0}function qh(a){a=a|0;Ef(a,1);if(!(Vb(a,1)|0)){Db(a);return 1}else{Xf(a,1,9496)|0;return 1}return 0}function rh(a){a=a|0;Jh(a,9713,1,285);return 3}function sh(a){a=a|0;var b=0,c=0,d=0,e=0;b=Af(a,1,0,0)|0;c=Af(a,2,0,0)|0;d=(nb(a,3)|0)==-1;if(Sf(a,b,c)|0){Db(a);jb(a,-2);e=2;return e|0}if(d){e=1;return e|0}mb(a,d?0:3);if(qc(a,-2,1)|0){e=1;return e|0}hb(a,-2);e=1;return e|0}function th(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0;b=Pa;Pa=Pa+16|0;d=b;e=yb(a,1,d)|0;f=Af(a,3,9639,0)|0;g=(nb(a,4)|0)==-1;if(!e){h=Af(a,2,9642,0)|0;Df(a,1,6);hb(a,5);i=gc(a,136,0,h,f)|0}else{h=Af(a,2,e,0)|0;i=Vf(a,e,c[d>>2]|0,h,f)|0}if(i|0){Db(a);jb(a,-2);j=2;Pa=b;return j|0}if(g){j=1;Pa=b;return j|0}mb(a,g?0:4);if(qc(a,-2,1)|0){j=1;Pa=b;return j|0}hb(a,-2);j=1;Pa=b;return j|0}function uh(a){a=a|0;var b=0;Df(a,1,5);hb(a,2);if(lc(a,1)|0){b=2;return b|0}Db(a);b=1;return b|0}function vh(a){a=a|0;Jh(a,9631,0,139);return 3}function wh(a){a=a|0;var b=0,c=0;Ef(a,1);Db(a);jb(a,1);b=ec(a,(gb(a)|0)+-2|0,-1,0,0,286)|0;if(!(ab(a,1)|0)){hb(a,0);Mb(a,0);Ib(a,9456)|0;c=2;return c|0}else{Mb(a,(b|0)==0&1);kb(a,1);c=gb(a)|0;return c|0}return 0}function xh(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;b=Pa;Pa=Pa+16|0;d=b;e=b+4|0;f=gb(a)|0;Pb(a,9425);a:do if((f|0)<1)g=c[1368]|0;else{h=c[1368]|0;i=1;while(1){mb(a,-1);mb(a,i);dc(a,1,1,0,0);j=yb(a,-1,e)|0;if(!j)break;if(i>>>0>1)$l(9,h)|0;zm(j,1,c[e>>2]|0,h)|0;hb(a,-2);if((i|0)<(f|0))i=i+1|0;else{g=h;break a}}k=rf(a,9588,d)|0;Pa=b;return k|0}while(0);$l(10,g)|0;fm(g)|0;k=0;Pa=b;return k|0}function yh(a){a=a|0;Ef(a,1);Ef(a,2);Mb(a,sb(a,1,2)|0);return 1}function zh(a){a=a|0;if((nb(a,1)|0|1|0)!=5)qf(a,1,9563)|0;Fb(a,zb(a,1)|0);return 1}function Ah(a){a=a|0;Df(a,1,5);Ef(a,2);hb(a,2);Sb(a,1);return 1}function Bh(a){a=a|0;Df(a,1,5);Ef(a,2);Ef(a,3);hb(a,3);_b(a,1);return 1}function Ch(b){b=b|0;var c=0,d=0,e=0,f=0;c=gb(b)|0;if((nb(b,1)|0)==4?(d=yb(b,1,0)|0,(a[d>>0]|0)==35):0){Fb(b,c+-1|0);e=1;return e|0}d=Hf(b,1)|0;f=(d|0)<0?d+c|0:(d|0)>(c|0)?c:d;if((f|0)<=0)qf(b,1,9544)|0;e=c-f|0;return e|0}function Dh(a){a=a|0;var b=0,c=0,d=0,e=0;b=Pa;Pa=Pa+16|0;c=b;d=nb(a,2)|0;Df(a,1,5);switch(d|0){case 0:case 5:break;default:qf(a,2,10327)|0}if(!(Xf(a,1,9496)|0)){hb(a,2);ac(a,1)|0;e=1;Pa=b;return e|0}else{e=rf(a,9508,c)|0;Pa=b;return e|0}return 0}function Eh(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0.0,m=0.0,n=0,o=0,p=0.0,q=0.0,r=0;d=Pa;Pa=Pa+16|0;e=d;do if((nb(b,2)|0)>=1){f=Bf(b,1,e)|0;g=f+(c[e>>2]|0)|0;h=Hf(b,2)|0;if((h+-2|0)>>>0>=35)qf(b,2,9471)|0;i=f+(Rm(f,9489)|0)|0;switch(a[i>>0]|0){case 45:{j=1;k=i+1|0;break}case 43:{j=0;k=i+1|0;break}default:{j=0;k=i}}i=a[k>>0]|0;if(cn(i&255)|0){l=+(h|0);m=0.0;f=k;n=i;while(1){i=n&255;if((i+-48|0)>>>0<10)o=(n<<24>>24)+-48|0;else o=($m(i)|0)+-55|0;p=m*l+ +(o|0);i=f+1|0;if((o|0)>=(h|0)){q=m;r=f;break}n=a[i>>0]|0;if(!(cn(n&255)|0)){q=p;r=i;break}else{m=p;f=i}}if((r+(Rm(r,9489)|0)|0)==(g|0)){Eb(b,(j|0)==0?q:-q);Pa=d;return 1}}}else{m=+ub(b,1,e);if(!(c[e>>2]|0)){Ef(b,1);break}Eb(b,m);Pa=d;return 1}while(0);Db(b);Pa=d;return 1}function Fh(a){a=a|0;Ef(a,1);_f(a,1,0)|0;return 1}function Gh(a){a=a|0;Ef(a,1);Ib(a,ob(a,nb(a,1)|0)|0)|0;return 1}function Hh(a){a=a|0;var b=0,c=0,d=0;b=gb(a)|0;if((b|0)<=1)qf(a,2,9441)|0;mb(a,1);lb(a,2,1);kb(a,2);c=ec(a,b+-2|0,-1,1,0,286)|0;if(!(ab(a,1)|0)){hb(a,0);Mb(a,0);Ib(a,9456)|0;d=2;return d|0}else{Mb(a,(c|0)==0&1);kb(a,1);d=gb(a)|0;return d|0}return 0}function Ih(a){a=a|0;var b=0,c=0;b=cc(a,0)|0;if(!(ab(a,1)|0)){hb(a,0);Mb(a,0);Ib(a,9456)|0;c=2;return c|0}else{Mb(a,(b|0)==1&1);kb(a,1);c=gb(a)|0;return c|0}return 0}function Jh(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;if(Xf(a,1,b)|0){mb(a,1);dc(a,1,3,0,0);return}Df(a,1,5);Lb(a,d,0);mb(a,1);if(!c){Db(a);return}else{Fb(a,0);return}}function Kh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;b=Pa;Pa=Pa+16|0;Cf(a,2,9650);mb(a,1);dc(a,0,1,0,0);if(!(nb(a,-1)|0)){hb(a,-2);c[d>>2]=0;e=0;Pa=b;return e|0}if(!(rb(a,-1)|0))rf(a,9676,b)|0;kb(a,5);e=yb(a,5,d)|0;Pa=b;return e|0}function Lh(a){a=a|0;var b=0,c=0;b=Hf(a,2)|0;Df(a,1,5);c=b+1|0;Fb(a,c);Tb(a,1,c);c=(nb(a,-1)|0)==0;return (c?1:2)|0}function Mh(a){a=a|0;return (gb(a)|0)+-1|0}function Nh(a){a=a|0;Ub(a,0,12);cg(a,1136,0);return 1}function Oh(a){a=a|0;var b=0,c=0,d=0;b=If(a,1)|0;c=Hf(a,2)|0;if((b|0)<0&(c|0)>-1){Gb(a,(c|0)>31?-1:b>>>c|~(-1>>>c));return 1}if((c|0)>0)d=(c|0)>31?0:b>>>c;else d=(c|0)<-31?0:b<<0-c;Gb(a,d);return 1}function Ph(a){a=a|0;var b=0,c=0,d=0,e=0,f=0;b=gb(a)|0;if((b|0)<1)c=-1;else{d=1;e=-1;while(1){f=(If(a,d)|0)&e;if((d|0)==(b|0)){c=f;break}else{d=d+1|0;e=f}}}Gb(a,c);return 1}function Qh(a){a=a|0;Gb(a,~(If(a,1)|0));return 1}function Rh(a){a=a|0;var b=0,c=0,d=0,e=0,f=0;b=gb(a)|0;if((b|0)<1)c=0;else{d=1;e=0;while(1){f=If(a,d)|0|e;if((d|0)==(b|0)){c=f;break}else{d=d+1|0;e=f}}}Gb(a,c);return 1}function Sh(a){a=a|0;var b=0,c=0,d=0,e=0,f=0;b=gb(a)|0;if((b|0)<1)c=0;else{d=1;e=0;while(1){f=(If(a,d)|0)^e;if((d|0)==(b|0)){c=f;break}else{d=d+1|0;e=f}}}Gb(a,c);return 1}function Th(a){a=a|0;var b=0,c=0,d=0,e=0;b=gb(a)|0;if((b|0)<1){c=1;Mb(a,c);return 1}d=1;e=-1;while(1){e=(If(a,d)|0)&e;if((d|0)==(b|0))break;else d=d+1|0}c=(e|0)!=0&1;Mb(a,c);return 1}function Uh(a){a=a|0;var b=0,c=0,d=0,e=0;b=Pa;Pa=Pa+16|0;c=If(a,1)|0;d=Hf(a,2)|0;e=Jf(a,3,1)|0;if((d|0)<=-1)qf(a,2,9912)|0;if((e|0)<=0)qf(a,3,9937)|0;if((e+d|0)>32)rf(a,9960,b)|0;Gb(a,c>>>d&~(-2<<e+-1));Pa=b;return 1}function Vh(a){a=a|0;var b=0,c=0,d=0;b=Hf(a,2)|0;c=If(a,1)|0;d=b&31;Gb(a,c>>>(32-d|0)|c<<d);return 1}function Wh(a){a=a|0;var b=0,c=0,d=0;b=If(a,1)|0;c=Hf(a,2)|0;if((c|0)<0){d=(c|0)<-31?0:b>>>(0-c|0);Gb(a,d);return 1}else{d=(c|0)>31?0:b<<c;Gb(a,d);return 1}return 0}function Xh(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+16|0;c=If(a,1)|0;d=If(a,2)|0;e=Hf(a,3)|0;f=Jf(a,4,1)|0;if((e|0)<=-1)qf(a,3,9912)|0;if((f|0)<=0)qf(a,4,9937)|0;if((f+e|0)>32)rf(a,9960,b)|0;g=~(-2<<f+-1);Gb(a,c&~(g<<e)|(d&g)<<e);Pa=b;return 1}function Yh(a){a=a|0;var b=0,c=0,d=0;b=0-(Hf(a,2)|0)|0;c=If(a,1)|0;d=b&31;Gb(a,c>>>(32-d|0)|c<<d);return 1}function Zh(a){a=a|0;var b=0,c=0,d=0;b=If(a,1)|0;c=Hf(a,2)|0;if((c|0)>0){d=(c|0)>31?0:b>>>c;Gb(a,d);return 1}else{d=(c|0)<-31?0:b<<0-c;Gb(a,d);return 1}return 0}function _h(a){a=a|0;Ub(a,0,6);cg(a,1248,0);return 1}function $h(a){a=a|0;var b=0;Df(a,1,6);b=qe(a)|0;mb(a,1);cb(a,b,1);return 1}function ai(a){a=a|0;var b=0,c=0,d=0;b=Bb(a,1)|0;if(!b)qf(a,1,10120)|0;c=gi(a,b,(gb(a)|0)+-1|0)|0;if((c|0)<0){Mb(a,0);jb(a,-2);d=2;return d|0}else{Mb(a,1);jb(a,~c);d=c+1|0;return d|0}return 0}function bi(a){a=a|0;Mb(a,Ob(a)|0);return 2}function ci(a){a=a|0;var b=0,c=0;b=Pa;Pa=Pa+112|0;c=Bb(a,1)|0;if(!c)qf(a,1,10120)|0;if((c|0)==(a|0)){Hb(a,10009,7)|0;Pa=b;return 1}switch(ic(c)|0){case 1:{Hb(a,10139,9)|0;Pa=b;return 1}case 0:{do if((xc(c,0,b)|0)<=0)if(!(gb(c)|0)){Hb(a,10156,4)|0;break}else{Hb(a,10139,9)|0;break}else Hb(a,10149,6)|0;while(0);Pa=b;return 1}default:{Hb(a,10156,4)|0;Pa=b;return 1}}return 0}function di(a){a=a|0;var b=0;Df(a,1,6);b=qe(a)|0;mb(a,1);cb(a,b,1);Lb(a,287,1);return 1}function ei(a){a=a|0;return Wc(a,gb(a)|0,0,0)|0}function fi(a){a=a|0;var b=0,c=0;b=Bb(a,-1001001)|0;c=gi(a,b,gb(a)|0)|0;if((c|0)>=0)return c|0;if(!(rb(a,-1)|0))kc(a)|0;sf(a,1);jb(a,-2);mc(a,2);kc(a)|0;return 0}function gi(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;if(!(ab(b,c)|0)){Hb(a,10035,28)|0;d=-1;return d|0}if((ic(b)|0)==0?(gb(b)|0)==0:0){Hb(a,10064,28)|0;d=-1;return d|0}cb(a,b,c);if((Sc(b,a,c)|0)>>>0>=2){cb(b,a,1);d=-1;return d|0}c=gb(b)|0;if(!(ab(a,c+1|0)|0)){hb(b,~c);Hb(a,10093,26)|0;d=-1;return d|0}else{cb(b,a,c);d=c;return d|0}return 0}function hi(a){a=a|0;Ub(a,0,16);cg(a,1312,0);return 1}function ii(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;b=Pa;Pa=Pa+272|0;d=b+256|0;e=b;f=c[1433]|0;zm(10679,11,1,f)|0;fm(f)|0;g=c[1401]|0;if(!(Zl(e,250,g)|0)){Pa=b;return 0}while(1){if(!(Cl(e,10691)|0)){h=8;break}if(!((Vf(a,e,_l(e)|0,10697,0)|0)==0?!(ec(a,0,0,0,0,0)|0):0)){i=yb(a,-1,0)|0;c[d>>2]=i;al(f,10714,d)|0;fm(f)|0}hb(a,0);zm(10679,11,1,f)|0;fm(f)|0;if(!(Zl(e,250,g)|0)){h=8;break}}if((h|0)==8){Pa=b;return 0}return 0}function ji(a){a=a|0;if((nb(a,1)|0)==7){Wb(a,1);return 1}else{Db(a);return 1}return 0}function ki(b){b=b|0;var c=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;c=Pa;Pa=Pa+16|0;d=c;if((nb(b,1)|0)==8)e=Bb(b,1)|0;else e=b;f=vc(e)|0;g=uc(e)|0;if((g|0)!=0&(g|0)!=136)Hb(b,10665,13)|0;else{dg(b,-1001e3,10368)|0;Ob(e)|0;cb(e,b,1);Sb(b,-2);ib(b,-2)}if(!(f&1))h=0;else{a[d>>0]=99;h=1}if(!(f&2))i=h;else{a[d+h>>0]=114;i=h+1|0}if(!(f&4)){j=i;k=d+j|0;a[k>>0]=0;Ib(b,d)|0;l=wc(e)|0;Fb(b,l);Pa=c;return 3}a[d+i>>0]=108;j=i+1|0;k=d+j|0;a[k>>0]=0;Ib(b,d)|0;l=wc(e)|0;Fb(b,l);Pa=c;return 3}function li(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;e=Pa;Pa=Pa+112|0;f=e;g=e+4|0;if((nb(b,1)|0)==8){h=Bb(b,1)|0;i=1}else{h=b;i=0}j=i|2;k=Af(b,j,10501,0)|0;l=i+1|0;do if(qb(b,l)|0)if(!(xc(h,vb(b,l,0)|0,g)|0)){Db(b);m=1;Pa=e;return m|0}else n=k;else{if((nb(b,l)|0)==6){c[f>>2]=k;Kb(b,10508,f)|0;i=yb(b,-1,0)|0;mb(b,l);cb(b,h,1);n=i;break}m=qf(b,l,10512)|0;Pa=e;return m|0}while(0);if(!(Ac(h,n,g)|0)){m=qf(b,j,10979)|0;Pa=e;return m|0}Ub(b,0,2);if(rm(n,83)|0){Ib(b,c[g+16>>2]|0)|0;Zb(b,-2,10539);Ib(b,g+36|0)|0;Zb(b,-2,10546);Fb(b,c[g+24>>2]|0);Zb(b,-2,10556);Fb(b,c[g+28>>2]|0);Zb(b,-2,10568);Ib(b,c[g+12>>2]|0)|0;Zb(b,-2,10584)}if(rm(n,108)|0){Fb(b,c[g+20>>2]|0);Zb(b,-2,10589)}if(rm(n,117)|0){Fb(b,d[g+32>>0]|0);Zb(b,-2,10601);Fb(b,d[g+33>>0]|0);Zb(b,-2,10606);Mb(b,a[g+34>>0]|0);Zb(b,-2,10614)}if(rm(n,110)|0){Ib(b,c[g+4>>2]|0)|0;Zb(b,-2,10623);Ib(b,c[g+8>>2]|0)|0;Zb(b,-2,10628)}if(rm(n,116)|0){Mb(b,a[g+35>>0]|0);Zb(b,-2,10637)}if(rm(n,76)|0){if((h|0)==(b|0)){mb(b,-2);ib(b,-3)}else cb(h,b,1);Zb(b,-2,10648)}if(!(rm(n,102)|0)){m=1;Pa=e;return m|0}if((h|0)==(b|0)){mb(b,-2);ib(b,-3)}else cb(h,b,1);Zb(b,-2,10660);m=1;Pa=e;return m|0}function mi(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+112|0;c=b;if((nb(a,1)|0)==8){d=Bb(a,1)|0;e=1}else{d=a;e=0}f=Hf(a,e|2)|0;g=e+1|0;if((nb(a,g)|0)==6){mb(a,g);Ib(a,yc(a,0,f)|0)|0;h=1;Pa=b;return h|0}if(!(xc(d,Hf(a,g)|0,c)|0)){h=qf(a,g,10349)|0;Pa=b;return h|0}g=yc(d,c,f)|0;if(!g){Db(a);h=1;Pa=b;return h|0}else{cb(d,a,1);Ib(a,g)|0;mb(a,-2);h=2;Pa=b;return h|0}return 0}function ni(a){a=a|0;mb(a,-1001e3);return 1}function oi(a){a=a|0;Ef(a,1);if(Vb(a,1)|0)return 1;Db(a);return 1}function pi(a){a=a|0;var b=0,c=0,d=0;b=Hf(a,2)|0;Df(a,1,6);c=pc(a,1,b)|0;if(!c){d=0;return d|0}Ib(a,c)|0;jb(a,-2);d=2;return d|0}function qi(a){a=a|0;var b=0,c=0,e=0,f=0;b=Pa;Pa=Pa+112|0;c=b;e=Hf(a,2)|0;Df(a,1,6);mb(a,1);Ac(a,10454,c)|0;if(!((e|0)>0?(e|0)<=(d[c+32>>0]|0|0):0))qf(a,2,10457)|0;f=Hf(a,4)|0;Df(a,3,6);mb(a,3);Ac(a,10454,c)|0;if(!((f|0)>0?(f|0)<=(d[c+32>>0]|0|0):0))qf(a,4,10457)|0;if(pb(a,1)|0)qf(a,1,10479)|0;if(!(pb(a,3)|0)){sc(a,1,e,3,f);Pa=b;return 0}qf(a,3,10479)|0;sc(a,1,e,3,f);Pa=b;return 0}function ri(a){a=a|0;var b=0,c=0,e=0;b=Pa;Pa=Pa+112|0;c=b;e=Hf(a,2)|0;Df(a,1,6);mb(a,1);Ac(a,10454,c)|0;if(!((e|0)>0?(e|0)<=(d[c+32>>0]|0|0):0))qf(a,2,10457)|0;Nb(a,rc(a,1,e)|0);Pa=b;return 1}function si(a){a=a|0;if((nb(a,1)|0)==2)qf(a,1,10411)|0;Df(a,1,7);if((nb(a,2)|0)>=1)Df(a,2,5);hb(a,2);bc(a,1);return 1}function ti(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;if((nb(a,1)|0)==8){b=Bb(a,1)|0;c=1}else{b=a;c=0}d=c+1|0;if((nb(a,d)|0)<1){hb(a,d);e=0;f=0;g=0}else{h=Bf(a,c|2,0)|0;Df(a,d,6);i=Jf(a,c+3|0,0)|0;c=(rm(h,99)|0)!=0&1;j=(rm(h,114)|0)==0;k=j?c:c|2;c=(rm(h,108)|0)==0;h=c?k:k|4;e=(i|0)>0?h|8:h;f=i;g=136}if(dg(a,-1001e3,10368)|0){Ob(b)|0;cb(b,a,1);mb(a,d);_b(a,-3);tc(b,g,e,f)|0;return 0}Ib(a,10374)|0;Zb(a,-2,10376);mb(a,-1);ac(a,-2)|0;Ob(b)|0;cb(b,a,1);mb(a,d);_b(a,-3);tc(b,g,e,f)|0;return 0}function ui(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+112|0;c=b;if((nb(a,1)|0)==8){d=Bb(a,1)|0;e=1}else{d=a;e=0}f=e+1|0;if(!(xc(d,Hf(a,f)|0,c)|0)){g=qf(a,f,10349)|0;Pa=b;return g|0}else{f=e+3|0;Ef(a,f);hb(a,f);cb(a,d,1);Ib(a,zc(d,c,Hf(a,e|2)|0)|0)|0;g=1;Pa=b;return g|0}return 0}function vi(a){a=a|0;switch(nb(a,2)|0){case 0:case 5:break;default:qf(a,2,10327)|0}hb(a,2);ac(a,1)|0;return 1}function wi(a){a=a|0;var b=0,c=0,d=0;Ef(a,3);b=Hf(a,2)|0;Df(a,1,6);c=qc(a,1,b)|0;if(!c){d=0;return d|0}Ib(a,c)|0;jb(a,-1);d=1;return d|0}function xi(a){a=a|0;var b=0,c=0,d=0,e=0;if((nb(a,1)|0)==8){b=1;c=Bb(a,1)|0}else{b=0;c=a}d=b+1|0;e=yb(a,d,0)|0;if((e|0)==0?(nb(a,d)|0)>=1:0){mb(a,d);return 1}nf(a,c,e,Jf(a,b|2,(c|0)==(a|0)&1)|0);return 1}function yi(a,b){a=a|0;b=b|0;var d=0;dg(a,-1001e3,10368)|0;Ob(a)|0;Sb(a,-2);if((nb(a,-1)|0)!=6)return;Ib(a,c[1456+(c[b>>2]<<2)>>2]|0)|0;d=c[b+20>>2]|0;if((d|0)>-1)Fb(a,d);else Db(a);dc(a,2,0,0,0);return}function zi(a){a=a|0;var b=0,d=0,e=0;Ub(a,0,11);cg(a,1488,0);vf(a,10718)|0;mb(a,-1);Zb(a,-2,13431);cg(a,1584,0);hb(a,-2);b=c[1401]|0;d=oc(a,8)|0;e=d+4|0;c[e>>2]=0;wf(a,10718);c[d>>2]=b;c[e>>2]=288;mb(a,-1);Zb(a,-1001e3,10724);Zb(a,-2,10734);e=c[1368]|0;b=oc(a,8)|0;d=b+4|0;c[d>>2]=0;wf(a,10718);c[b>>2]=e;c[d>>2]=288;mb(a,-1);Zb(a,-1001e3,10740);Zb(a,-2,10751);d=c[1433]|0;e=oc(a,8)|0;b=e+4|0;c[b>>2]=0;wf(a,10718);c[e>>2]=d;c[b>>2]=288;Zb(a,-2,10758);return 1}function Ai(a){a=a|0;var b=0;b=(yf(a,1,10718)|0)+4|0;c[b>>2]=288;Db(a);Hb(a,10765,26)|0;return 2}function Bi(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;if((nb(a,1)|0)==-1)Rb(a,-1001e3,10740);d=(yf(a,1,10718)|0)+4|0;if(!(c[d>>2]|0))rf(a,10869,b)|0;d=(yf(a,1,10718)|0)+4|0;e=c[d>>2]|0;c[d>>2]=0;d=Ta[e&511](a)|0;Pa=b;return d|0}function Ci(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=yf(a,1,10718)|0;if(!(c[d+4>>2]|0))rf(a,10869,b)|0;e=tf(a,(fm(c[d>>2]|0)|0)==0&1,0)|0;Pa=b;return e|0}function Di(a){a=a|0;var b=0,d=0;b=Pa;Pa=Pa+16|0;d=(yf(a,1,10718)|0)+4|0;if(!(c[d>>2]|0))rf(a,10869,b)|0;Ni(a,0);Pa=b;return 1}function Ei(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=yf(a,1,10718)|0;if(!(c[d+4>>2]|0))rf(a,10869,b)|0;e=Li(a,c[d>>2]|0,2)|0;Pa=b;return e|0}function Fi(a){a=a|0;var b=0,d=0,e=0,f=0.0,g=0,h=0;b=Pa;Pa=Pa+16|0;d=yf(a,1,10718)|0;if(!(c[d+4>>2]|0))rf(a,10869,b)|0;e=c[d>>2]|0;d=zf(a,2,10917,1680)|0;f=+Gf(a,3,0.0);g=~~f;if(!(f==+(g|0)))qf(a,3,10921)|0;if(!(om(e,g,c[5460+(d<<2)>>2]|0)|0)){Eb(a,+(km(e)|0));h=1;Pa=b;return h|0}else{h=tf(a,0,0)|0;Pa=b;return h|0}return 0}function Gi(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+16|0;d=yf(a,1,10718)|0;if(!(c[d+4>>2]|0))rf(a,10869,b)|0;e=c[d>>2]|0;d=zf(a,2,0,1664)|0;f=Jf(a,3,1024)|0;g=tf(a,(am(e,0,c[5448+(d<<2)>>2]|0,f)|0)==0&1,0)|0;Pa=b;return g|0}function Hi(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=yf(a,1,10718)|0;if(!(c[d+4>>2]|0))rf(a,10869,b)|0;e=c[d>>2]|0;mb(a,1);d=Ki(a,e,2)|0;Pa=b;return d|0}function Ii(a){a=a|0;var b=0,d=0;b=yf(a,1,10718)|0;if(!(c[b+4>>2]|0))return 0;if(!(c[b>>2]|0))return 0;b=(yf(a,1,10718)|0)+4|0;d=c[b>>2]|0;c[b>>2]=0;Ta[d&511](a)|0;return 0}function Ji(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;e=yf(a,1,10718)|0;if(!(c[e+4>>2]|0)){Hb(a,10845,13)|0;Pa=b;return 1}else{c[d>>2]=c[e>>2];Kb(a,10859,d)|0;Pa=b;return 1}return 0}function Ki(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0.0,o=0,p=0;e=Pa;Pa=Pa+16|0;f=e;h=e+8|0;i=(gb(a)|0)-d|0;if(!i){j=1;Pa=e;return j|0}k=1;l=d;d=i;while(1){d=d+-1|0;if((nb(a,l)|0)==3)if(!k)m=0;else{n=+ub(a,l,0);g[f>>3]=n;m=(al(b,10898,f)|0)>0}else{i=Bf(a,l,h)|0;if(!k)o=0;else{p=zm(i,1,c[h>>2]|0,b)|0;o=(p|0)==(c[h>>2]|0)}m=o}if(!d)break;else{k=m&1;l=l+1|0}}if(m){j=1;Pa=e;return j|0}j=tf(a,0,0)|0;Pa=e;return j|0}\nfunction Ya(a){a=a|0;var b=0;b=Pa;Pa=Pa+a|0;Pa=Pa+15&-16;return b|0}function Za(){return Pa|0}function _a(a){a=a|0;Pa=a}function $a(a,b){a=a|0;b=b|0;Pa=a;Qa=b}function ab(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;d=Pa;Pa=Pa+16|0;e=d;c[e>>2]=b;f=c[a+16>>2]|0;g=a+8|0;h=c[g>>2]|0;do if(((c[a+24>>2]|0)-h>>4|0)<=(b|0)){if(((h-(c[a+28>>2]|0)>>4)+5|0)>(1e6-b|0)){i=0;Pa=d;return i|0}if(!(Kc(a,129,e)|0)){j=c[g>>2]|0;k=c[e>>2]|0;break}else{i=0;Pa=d;return i|0}}else{j=h;k=b}while(0);b=f+4|0;f=j+(k<<4)|0;if((c[b>>2]|0)>>>0>=f>>>0){i=1;Pa=d;return i|0}c[b>>2]=f;i=1;Pa=d;return i|0}function bb(a,b){a=a|0;b=b|0;Mc(a,c[b>>2]|0);return}function cb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;if((a|0)==(b|0))return;e=a+8|0;a=c[e>>2]|0;f=0-d|0;g=a+(f<<4)|0;c[e>>2]=g;if((d|0)<=0)return;h=b+8|0;b=c[h>>2]|0;c[h>>2]=b+16;i=g;g=c[i+4>>2]|0;j=b;c[j>>2]=c[i>>2];c[j+4>>2]=g;c[b+8>>2]=c[a+(f<<4)+8>>2];if((d|0)==1)return;f=1;do{a=c[e>>2]|0;b=c[h>>2]|0;c[h>>2]=b+16;g=a+(f<<4)|0;j=c[g+4>>2]|0;i=b;c[i>>2]=c[g>>2];c[i+4>>2]=j;c[b+8>>2]=c[a+(f<<4)+8>>2];f=f+1|0}while((f|0)!=(d|0));return}function db(a,b){a=a|0;b=b|0;var d=0;d=(c[a+12>>2]|0)+168|0;a=c[d>>2]|0;c[d>>2]=b;return a|0}function eb(a){a=a|0;var b=0;if(!a){b=5440;return b|0}b=c[(c[a+12>>2]|0)+176>>2]|0;return b|0}function fb(a,b){a=a|0;b=b|0;var d=0;if((b+1000999|0)>>>0>1000999){d=b;return d|0}d=((c[a+8>>2]|0)-(c[c[a+16>>2]>>2]|0)>>4)+b|0;return d|0}function gb(a){a=a|0;return (c[a+8>>2]|0)-((c[c[a+16>>2]>>2]|0)+16)>>4|0}function hb(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;if((b|0)<=-1){d=a+8|0;c[d>>2]=(c[d>>2]|0)+(b+1<<4);return}d=c[c[a+16>>2]>>2]|0;e=a+8|0;a=c[e>>2]|0;f=d+16+(b<<4)|0;if(a>>>0<f>>>0){g=((d+(b<<4)+8+4+(3-a)|0)>>>4)+1|0;b=a;do{c[b+8>>2]=0;b=b+16|0}while(b>>>0<f>>>0);c[e>>2]=a+(g<<4)}c[e>>2]=f;return}function ib(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=f+16|0;e=a+8|0;a=c[e>>2]|0;if(b>>>0>=a>>>0){j=a;k=j+-16|0;c[e>>2]=k;return}a=f;f=b;while(1){b=f;g=c[b+4>>2]|0;i=a;c[i>>2]=c[b>>2];c[i+4>>2]=g;c[a+8>>2]=c[a+24>>2];g=f+16|0;i=c[e>>2]|0;if(g>>>0<i>>>0){b=f;f=g;a=b}else{j=i;break}}k=j+-16|0;c[e>>2]=k;return}function jb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;a=c[b>>2]|0;if(a>>>0>f>>>0){e=a;do{g=e;e=e+-16|0;i=e;h=c[i+4>>2]|0;j=g;c[j>>2]=c[i>>2];c[j+4>>2]=h;c[g+8>>2]=c[g+-8>>2]}while(e>>>0>f>>>0);k=c[b>>2]|0}else k=a;a=k;b=c[a+4>>2]|0;e=f;c[e>>2]=c[a>>2];c[e+4>>2]=b;c[f+8>>2]=c[k+8>>2];return}function kb(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;f=b+8|0;g=c[f>>2]|0;h=g+-16|0;i=b+16|0;j=c[i>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){k=g+(e<<4)|0;break}if((e|0)==-1001e3){k=(c[b+12>>2]|0)+40|0;break}l=-1001e3-e|0;m=c[j>>2]|0;if((c[m+8>>2]|0)==22)k=15792;else{n=c[m>>2]|0;k=(l|0)>(d[n+6>>0]|0|0)?15792:n+16+(l+-1<<4)|0}}else{l=(c[j>>2]|0)+(e<<4)|0;k=l>>>0<g>>>0?l:15792}while(0);j=h;l=c[j+4>>2]|0;n=k;c[n>>2]=c[j>>2];c[n+4>>2]=l;l=g+-8|0;c[k+8>>2]=c[l>>2];if((((e|0)<-1001e3?c[l>>2]&64|0:0)?(l=c[h>>2]|0,a[l+5>>0]&3):0)?(h=c[c[c[i>>2]>>2]>>2]|0,a[h+5>>0]&4):0)jd(b,h,l);c[f>>2]=(c[f>>2]|0)+-16;return}function lb(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0;g=b+16|0;h=c[g>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){i=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){i=(c[b+12>>2]|0)+40|0;break}j=-1001e3-e|0;k=c[h>>2]|0;if((c[k+8>>2]|0)==22)i=15792;else{l=c[k>>2]|0;i=(j|0)>(d[l+6>>0]|0|0)?15792:l+16+(j+-1<<4)|0}}else{j=(c[h>>2]|0)+(e<<4)|0;i=j>>>0<(c[b+8>>2]|0)>>>0?j:15792}while(0);do if((f|0)<=0){if((f|0)>=-1000999){m=(c[b+8>>2]|0)+(f<<4)|0;break}if((f|0)==-1001e3){m=(c[b+12>>2]|0)+40|0;break}e=-1001e3-f|0;j=c[h>>2]|0;if((c[j+8>>2]|0)==22)m=15792;else{l=c[j>>2]|0;m=(e|0)>(d[l+6>>0]|0|0)?15792:l+16+(e+-1<<4)|0}}else{e=(c[h>>2]|0)+(f<<4)|0;m=e>>>0<(c[b+8>>2]|0)>>>0?e:15792}while(0);h=i;e=c[h+4>>2]|0;l=m;c[l>>2]=c[h>>2];c[l+4>>2]=e;e=i+8|0;c[m+8>>2]=c[e>>2];if((f|0)>=-1001e3)return;if(!(c[e>>2]&64))return;e=c[i>>2]|0;if(!(a[e+5>>0]&3))return;i=c[c[c[g>>2]>>2]>>2]|0;if(!(a[i+5>>0]&4))return;jd(b,i,e);return}function mb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;a=c[b>>2]|0;e=f;g=c[e+4>>2]|0;i=a;c[i>>2]=c[e>>2];c[i+4>>2]=g;c[a+8>>2]=c[f+8>>2];c[b>>2]=(c[b>>2]|0)+16;return}function nb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)>0){f=(c[e>>2]|0)+(b<<4)|0;if(f>>>0<(c[a+8>>2]|0)>>>0)g=f;else{h=-1;return h|0}}else{if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}f=-1001e3-b|0;i=c[e>>2]|0;if((c[i+8>>2]|0)==22){h=-1;return h|0}j=c[i>>2]|0;if((f|0)>(d[j+6>>0]|0|0)){h=-1;return h|0}else g=j+16+(f+-1<<4)|0}while(0);if((g|0)==15792){h=-1;return h|0}h=c[g+8>>2]&15;return h|0}function ob(a,b){a=a|0;b=b|0;return c[352+(b+1<<2)>>2]|0}function pb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);a=c[f+8>>2]|0;return ((a|0)==22|(a|0)==102)&1|0}function qb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=Pa;Pa=Pa+16|0;f=e;g=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){h=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){h=(c[a+12>>2]|0)+40|0;break}i=-1001e3-b|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(b<<4)|0;h=i>>>0<(c[a+8>>2]|0)>>>0?i:15792}while(0);if((c[h+8>>2]|0)==3){l=1;Pa=e;return l|0}l=(Ye(h,f)|0)!=0&1;Pa=e;return l|0}function rb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)>0){f=(c[e>>2]|0)+(b<<4)|0;if(f>>>0<(c[a+8>>2]|0)>>>0)g=f;else{h=0;return h|0}}else{if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}f=-1001e3-b|0;i=c[e>>2]|0;if((c[i+8>>2]|0)==22){h=0;return h|0}j=c[i>>2]|0;if((f|0)>(d[j+6>>0]|0|0)){h=0;return h|0}else g=j+16+(f+-1<<4)|0}while(0);if((g|0)==15792){h=0;return h|0}h=((c[g+8>>2]&15)+-3|0)>>>0<2&1;return h|0}function sb(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;f=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}h=-1001e3-b|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(b<<4)|0;g=h>>>0<(c[a+8>>2]|0)>>>0?h:15792}while(0);do if((e|0)<=0){if((e|0)>=-1000999){k=(c[a+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){k=(c[a+12>>2]|0)+40|0;break}b=-1001e3-e|0;h=c[f>>2]|0;if((c[h+8>>2]|0)==22){l=0;return l|0}else{j=c[h>>2]|0;k=(b|0)>(d[j+6>>0]|0|0)?15792:j+16+(b+-1<<4)|0;break}}else{b=(c[f>>2]|0)+(e<<4)|0;k=b>>>0<(c[a+8>>2]|0)>>>0?b:15792}while(0);if(!((g|0)!=15792&(k|0)!=15792)){l=0;return l|0}if((c[g+8>>2]|0)!=(c[k+8>>2]|0)){l=0;return l|0}l=(cf(0,g,k)|0)!=0&1;return l|0}function tb(a,b,e,f){a=a|0;b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0;g=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){h=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){h=(c[a+12>>2]|0)+40|0;break}i=-1001e3-b|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(b<<4)|0;h=i>>>0<(c[a+8>>2]|0)>>>0?i:15792}while(0);do if((e|0)<=0){if((e|0)>=-1000999){l=(c[a+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){l=(c[a+12>>2]|0)+40|0;break}b=-1001e3-e|0;i=c[g>>2]|0;if((c[i+8>>2]|0)==22){m=0;return m|0}else{k=c[i>>2]|0;l=(b|0)>(d[k+6>>0]|0|0)?15792:k+16+(b+-1<<4)|0;break}}else{b=(c[g>>2]|0)+(e<<4)|0;l=b>>>0<(c[a+8>>2]|0)>>>0?b:15792}while(0);if(!((h|0)!=15792&(l|0)!=15792)){m=0;return m|0}switch(f|0){case 0:{if((c[h+8>>2]|0)!=(c[l+8>>2]|0)){m=0;return m|0}m=(cf(a,h,l)|0)!=0&1;return m|0}case 1:{m=af(a,h,l)|0;return m|0}case 2:{m=bf(a,h,l)|0;return m|0}default:{m=0;return m|0}}return 0}function ub(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0.0,o=0;f=Pa;Pa=Pa+16|0;h=f;i=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){j=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){j=(c[a+12>>2]|0)+40|0;break}k=-1001e3-b|0;l=c[i>>2]|0;if((c[l+8>>2]|0)==22)j=15792;else{m=c[l>>2]|0;j=(k|0)>(d[m+6>>0]|0|0)?15792:m+16+(k+-1<<4)|0}}else{k=(c[i>>2]|0)+(b<<4)|0;j=k>>>0<(c[a+8>>2]|0)>>>0?k:15792}while(0);if((c[j+8>>2]|0)!=3){a=Ye(j,h)|0;if(!a){if(!e){n=0.0;Pa=f;return +n}c[e>>2]=0;n=0.0;Pa=f;return +n}else o=a}else o=j;if(e|0)c[e>>2]=1;n=+g[o>>3];Pa=f;return +n}function vb(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;f=Pa;Pa=Pa+16|0;h=f;i=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){j=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){j=(c[a+12>>2]|0)+40|0;break}k=-1001e3-b|0;l=c[i>>2]|0;if((c[l+8>>2]|0)==22)j=15792;else{m=c[l>>2]|0;j=(k|0)>(d[m+6>>0]|0|0)?15792:m+16+(k+-1<<4)|0}}else{k=(c[i>>2]|0)+(b<<4)|0;j=k>>>0<(c[a+8>>2]|0)>>>0?k:15792}while(0);if((c[j+8>>2]|0)!=3){a=Ye(j,h)|0;if(!a){if(!e){n=0;Pa=f;return n|0}c[e>>2]=0;n=0;Pa=f;return n|0}else o=a}else o=j;j=~~+g[o>>3];if(!e){n=j;Pa=f;return n|0}c[e>>2]=1;n=j;Pa=f;return n|0}function wb(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;f=Pa;Pa=Pa+32|0;h=f+8|0;i=f;j=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){k=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){k=(c[a+12>>2]|0)+40|0;break}l=-1001e3-b|0;m=c[j>>2]|0;if((c[m+8>>2]|0)==22)k=15792;else{n=c[m>>2]|0;k=(l|0)>(d[n+6>>0]|0|0)?15792:n+16+(l+-1<<4)|0}}else{l=(c[j>>2]|0)+(b<<4)|0;k=l>>>0<(c[a+8>>2]|0)>>>0?l:15792}while(0);if((c[k+8>>2]|0)!=3){a=Ye(k,h)|0;if(!a){if(!e){o=0;Pa=f;return o|0}c[e>>2]=0;o=0;Pa=f;return o|0}else p=a}else p=k;g[i>>3]=+g[p>>3]+6755399441055744.0;p=c[i>>2]|0;if(!e){o=p;Pa=f;return o|0}c[e>>2]=1;o=p;Pa=f;return o|0}function xb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);a=c[f+8>>2]|0;switch(a|0){case 1:{j=(c[f>>2]|0)!=0&1;return j|0}case 0:{j=a;return j|0}default:{j=1;return j|0}}return 0}function yb(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;f=a+16|0;g=c[f>>2]|0;h=(b|0)>0;do if(!h){if((b|0)>=-1000999){i=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){i=(c[a+12>>2]|0)+40|0;break}j=-1001e3-b|0;k=c[g>>2]|0;if((c[k+8>>2]|0)==22)i=15792;else{l=c[k>>2]|0;i=(j|0)>(d[l+6>>0]|0|0)?15792:l+16+(j+-1<<4)|0}}else{j=(c[g>>2]|0)+(b<<4)|0;i=j>>>0<(c[a+8>>2]|0)>>>0?j:15792}while(0);do if((c[i+8>>2]&15|0)!=4){if(!(Ze(a,i)|0)){if(!e){m=0;return m|0}c[e>>2]=0;m=0;return m|0}g=a+12|0;if((c[(c[g>>2]|0)+12>>2]|0)>0)Ed(a);j=c[f>>2]|0;if(h){l=(c[j>>2]|0)+(b<<4)|0;n=l>>>0<(c[a+8>>2]|0)>>>0?l:15792;break}if((b|0)>=-1000999){n=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){n=(c[g>>2]|0)+40|0;break}g=-1001e3-b|0;l=c[j>>2]|0;if((c[l+8>>2]|0)==22)n=15792;else{j=c[l>>2]|0;n=(g|0)>(d[j+6>>0]|0|0)?15792:j+16+(g+-1<<4)|0}}else n=i;while(0);if(e|0)c[e>>2]=c[(c[n>>2]|0)+12>>2];m=(c[n>>2]|0)+16|0;return m|0}function zb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);switch(c[f+8>>2]&15){case 4:{j=c[(c[f>>2]|0)+12>>2]|0;return j|0}case 7:{j=c[(c[f>>2]|0)+16>>2]|0;return j|0}case 5:{j=Pe(c[f>>2]|0)|0;return j|0}default:{j=0;return j|0}}return 0}function Ab(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);switch(c[f+8>>2]&15){case 7:{j=(c[f>>2]|0)+24|0;return j|0}case 2:{j=c[f>>2]|0;return j|0}default:{j=0;return j|0}}return 0}function Bb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);if((c[f+8>>2]|0)!=72){j=0;return j|0}j=c[f>>2]|0;return j|0}function Cb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=c[a+16>>2]|0;f=(b|0)>0;do if(!f){if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}h=-1001e3-b|0;i=c[e>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[e>>2]|0)+(b<<4)|0;g=h>>>0<(c[a+8>>2]|0)>>>0?h:15792}while(0);switch(c[g+8>>2]&63){case 5:{k=c[g>>2]|0;return k|0}case 6:{k=c[g>>2]|0;return k|0}case 38:{k=c[g>>2]|0;return k|0}case 22:{k=c[g>>2]|0;return k|0}case 8:{k=c[g>>2]|0;return k|0}case 2:case 7:{do if(!f){if((b|0)>=-1000999){l=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){l=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)l=15792;else{j=c[h>>2]|0;l=(g|0)>(d[j+6>>0]|0|0)?15792:j+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;l=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);switch(c[l+8>>2]&15){case 7:{k=(c[l>>2]|0)+24|0;return k|0}case 2:{k=c[l>>2]|0;return k|0}default:{k=0;return k|0}}break}default:{k=0;return k|0}}return 0}function Db(a){a=a|0;var b=0;b=a+8|0;a=c[b>>2]|0;c[a+8>>2]=0;c[b>>2]=a+16;return}function Eb(a,b){a=a|0;b=+b;var d=0;d=a+8|0;a=c[d>>2]|0;g[a>>3]=b;c[a+8>>2]=3;c[d>>2]=(c[d>>2]|0)+16;return}function Fb(a,b){a=a|0;b=b|0;var d=0;d=a+8|0;a=c[d>>2]|0;g[a>>3]=+(b|0);c[a+8>>2]=3;c[d>>2]=(c[d>>2]|0)+16;return}function Gb(a,b){a=a|0;b=b|0;var d=0;d=a+8|0;a=c[d>>2]|0;g[a>>3]=(b|0)>-1?+(b|0):+(b>>>0);c[a+8>>2]=3;c[d>>2]=(c[d>>2]|0)+16;return}function Hb(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;if((c[(c[b+12>>2]|0)+12>>2]|0)>0)Ed(b);f=Ae(b,d,e)|0;e=b+8|0;b=c[e>>2]|0;c[b>>2]=f;c[b+8>>2]=(a[f+4>>0]|64)&255;c[e>>2]=(c[e>>2]|0)+16;return f+16|0}function Ib(b,d){b=b|0;d=d|0;var e=0,f=0,g=0;if(!d){e=b+8|0;f=c[e>>2]|0;c[f+8>>2]=0;c[e>>2]=f+16;g=0;return g|0}if((c[(c[b+12>>2]|0)+12>>2]|0)>0)Ed(b);f=Be(b,d)|0;d=b+8|0;b=c[d>>2]|0;c[b>>2]=f;c[b+8>>2]=(a[f+4>>0]|64)&255;c[d>>2]=(c[d>>2]|0)+16;g=f+16|0;return g|0}function Jb(a,b,d){a=a|0;b=b|0;d=d|0;if((c[(c[a+12>>2]|0)+12>>2]|0)>0)Ed(a);return Od(a,b,d)|0}function Kb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;if((c[(c[a+12>>2]|0)+12>>2]|0)>0)Ed(a);c[f>>2]=d;d=Od(a,b,f)|0;Pa=e;return d|0}function Lb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;if(!d){e=a+8|0;f=c[e>>2]|0;c[f>>2]=b;g=e;h=22;i=f;j=i+8|0;c[j>>2]=h;k=c[g>>2]|0;l=k+16|0;c[g>>2]=l;return}if((c[(c[a+12>>2]|0)+12>>2]|0)>0)Ed(a);f=ad(a,d)|0;c[f+12>>2]=b;b=a+8|0;a=(c[b>>2]|0)+(0-d<<4)|0;c[b>>2]=a;e=d;d=a;do{e=e+-1|0;a=d+(e<<4)|0;m=c[a+4>>2]|0;n=f+16+(e<<4)|0;c[n>>2]=c[a>>2];c[n+4>>2]=m;c[f+16+(e<<4)+8>>2]=c[d+(e<<4)+8>>2];d=c[b>>2]|0}while((e|0)!=0);c[d>>2]=f;g=b;h=102;i=d;j=i+8|0;c[j>>2]=h;k=c[g>>2]|0;l=k+16|0;c[g>>2]=l;return}function Mb(a,b){a=a|0;b=b|0;var d=0;d=a+8|0;a=c[d>>2]|0;c[a>>2]=(b|0)!=0&1;c[a+8>>2]=1;c[d>>2]=(c[d>>2]|0)+16;return}function Nb(a,b){a=a|0;b=b|0;var d=0;d=a+8|0;a=c[d>>2]|0;c[a>>2]=b;c[a+8>>2]=2;c[d>>2]=(c[d>>2]|0)+16;return}function Ob(a){a=a|0;var b=0,d=0;b=a+8|0;d=c[b>>2]|0;c[d>>2]=a;c[d+8>>2]=72;c[b>>2]=(c[b>>2]|0)+16;return (c[(c[a+12>>2]|0)+172>>2]|0)==(a|0)|0}function Pb(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Ne(c[(c[b+12>>2]|0)+40>>2]|0,2)|0;f=b+8|0;g=c[f>>2]|0;c[f>>2]=g+16;h=Be(b,d)|0;c[g>>2]=h;c[g+8>>2]=(a[h+4>>0]|64)&255;h=(c[f>>2]|0)+-16|0;_e(b,e,h,h);return}function Qb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=(c[a+8>>2]|0)+-16|0;_e(a,f,b,b);return}function Rb(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;g=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){h=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){h=(c[b+12>>2]|0)+40|0;break}i=-1001e3-e|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(e<<4)|0;h=i>>>0<(c[b+8>>2]|0)>>>0?i:15792}while(0);e=b+8|0;g=c[e>>2]|0;i=Be(b,f)|0;c[g>>2]=i;c[g+8>>2]=(a[i+4>>0]|64)&255;i=c[e>>2]|0;c[e>>2]=i+16;_e(b,h,i,i);return}function Sb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;a=He(c[f>>2]|0,(c[b>>2]|0)+-16|0)|0;f=c[b>>2]|0;b=a;e=c[b+4>>2]|0;g=f+-16|0;c[g>>2]=c[b>>2];c[g+4>>2]=e;c[f+-8>>2]=c[a+8>>2];return}function Tb(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;f=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}h=-1001e3-b|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(b<<4)|0;g=h>>>0<(c[a+8>>2]|0)>>>0?h:15792}while(0);b=Ne(c[g>>2]|0,e)|0;e=a+8|0;a=c[e>>2]|0;g=b;f=c[g+4>>2]|0;h=a;c[h>>2]=c[g>>2];c[h+4>>2]=f;c[a+8>>2]=c[b+8>>2];c[e>>2]=(c[e>>2]|0)+16;return}function Ub(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;if((c[(c[a+12>>2]|0)+12>>2]|0)>0)Ed(a);e=Le(a)|0;f=a+8|0;g=c[f>>2]|0;c[g>>2]=e;c[g+8>>2]=69;c[f>>2]=(c[f>>2]|0)+16;if(!((b|0)>0|(d|0)>0))return;Fe(a,e,b,d);return}function Vb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=c[f+8>>2]|0;switch(b&15){case 5:{j=(c[f>>2]|0)+8|0;break}case 7:{j=(c[f>>2]|0)+8|0;break}default:j=(c[a+12>>2]|0)+252+((b&15)<<2)|0}b=c[j>>2]|0;if(!b){k=0;return k|0}j=a+8|0;a=c[j>>2]|0;c[a>>2]=b;c[a+8>>2]=69;c[j>>2]=(c[j>>2]|0)+16;k=1;return k|0}function Wb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=c[(c[f>>2]|0)+12>>2]|0;f=a+8|0;a=c[f>>2]|0;if(!b){j=0;k=a+8|0;c[k>>2]=j;l=c[f>>2]|0;m=l+16|0;c[f>>2]=m;return}c[a>>2]=b;j=69;k=a+8|0;c[k>>2]=j;l=c[f>>2]|0;m=l+16|0;c[f>>2]=m;return}function Xb(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Ne(c[(c[b+12>>2]|0)+40>>2]|0,2)|0;f=b+8|0;g=c[f>>2]|0;c[f>>2]=g+16;h=Be(b,d)|0;c[g>>2]=h;c[g+8>>2]=(a[h+4>>0]|64)&255;h=c[f>>2]|0;$e(b,e,h+-16|0,h+-32|0);c[f>>2]=(c[f>>2]|0)+-32;return}function Yb(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;e=c[b>>2]|0;$e(a,f,e+-32|0,e+-16|0);c[b>>2]=(c[b>>2]|0)+-32;return}function Zb(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;g=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){h=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){h=(c[b+12>>2]|0)+40|0;break}i=-1001e3-e|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(e<<4)|0;h=i>>>0<(c[b+8>>2]|0)>>>0?i:15792}while(0);e=b+8|0;g=c[e>>2]|0;c[e>>2]=g+16;i=Be(b,f)|0;c[g>>2]=i;c[g+8>>2]=(a[i+4>>0]|64)&255;i=c[e>>2]|0;$e(b,h,i+-16|0,i+-32|0);c[e>>2]=(c[e>>2]|0)+-32;return}function _b(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;f=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){g=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){g=(c[b+12>>2]|0)+40|0;break}h=-1001e3-e|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(e<<4)|0;g=h>>>0<(c[b+8>>2]|0)>>>0?h:15792}while(0);e=b+8|0;f=c[e>>2]|0;h=Je(b,c[g>>2]|0,f+-32|0)|0;j=f+-16|0;i=c[j+4>>2]|0;k=h;c[k>>2]=c[j>>2];c[k+4>>2]=i;c[h+8>>2]=c[f+-8>>2];a[(c[g>>2]|0)+6>>0]=0;f=c[e>>2]|0;if(!(c[f+-8>>2]&64)){l=f;m=l+-32|0;c[e>>2]=m;return}if(!(a[(c[f+-16>>2]|0)+5>>0]&3)){l=f;m=l+-32|0;c[e>>2]=m;return}h=c[g>>2]|0;if(!(a[h+5>>0]&4)){l=f;m=l+-32|0;c[e>>2]=m;return}ld(b,h);l=c[e>>2]|0;m=l+-32|0;c[e>>2]=m;return}function $b(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0;g=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){h=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){h=(c[b+12>>2]|0)+40|0;break}i=-1001e3-e|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(e<<4)|0;h=i>>>0<(c[b+8>>2]|0)>>>0?i:15792}while(0);e=b+8|0;Ie(b,c[h>>2]|0,f,(c[e>>2]|0)+-16|0);f=c[e>>2]|0;if(!(c[f+-8>>2]&64)){l=f;m=l+-16|0;c[e>>2]=m;return}if(!(a[(c[f+-16>>2]|0)+5>>0]&3)){l=f;m=l+-16|0;c[e>>2]=m;return}g=c[h>>2]|0;if(!(a[g+5>>0]&4)){l=f;m=l+-16|0;c[e>>2]=m;return}ld(b,g);l=c[e>>2]|0;m=l+-16|0;c[e>>2]=m;return}function ac(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;f=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){g=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){g=(c[b+12>>2]|0)+40|0;break}h=-1001e3-e|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(e<<4)|0;g=h>>>0<(c[b+8>>2]|0)>>>0?h:15792}while(0);e=b+8|0;f=c[e>>2]|0;if(!(c[f+-8>>2]|0)){k=0;l=0}else{h=c[f+-16>>2]|0;k=h;l=h}h=c[g+8>>2]|0;switch(h&15){case 5:{c[(c[g>>2]|0)+8>>2]=l;if(!k){m=c[e>>2]|0;n=m+-16|0;c[e>>2]=n;return 1}if(a[k+5>>0]&3?(f=c[g>>2]|0,a[f+5>>0]&4):0)ld(b,f);pd(b,c[g>>2]|0,k);m=c[e>>2]|0;n=m+-16|0;c[e>>2]=n;return 1}case 7:{c[(c[g>>2]|0)+8>>2]=k;if(!k){m=c[e>>2]|0;n=m+-16|0;c[e>>2]=n;return 1}if(a[l+5>>0]&3?(f=c[g>>2]|0,a[f+5>>0]&4):0)jd(b,f,l);pd(b,c[g>>2]|0,k);m=c[e>>2]|0;n=m+-16|0;c[e>>2]=n;return 1}default:{c[(c[b+12>>2]|0)+252+((h&15)<<2)>>2]=k;m=c[e>>2]|0;n=m+-16|0;c[e>>2]=n;return 1}}return 0}function bc(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;f=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){g=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){g=(c[b+12>>2]|0)+40|0;break}h=-1001e3-e|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(e<<4)|0;g=h>>>0<(c[b+8>>2]|0)>>>0?h:15792}while(0);e=b+8|0;f=c[e>>2]|0;if(!(c[f+-8>>2]|0)){c[(c[g>>2]|0)+12>>2]=0;k=c[e>>2]|0;l=k+-16|0;c[e>>2]=l;return}c[(c[g>>2]|0)+12>>2]=c[f+-16>>2];f=c[(c[e>>2]|0)+-16>>2]|0;if(!(a[f+5>>0]&3)){k=c[e>>2]|0;l=k+-16|0;c[e>>2]=l;return}h=c[g>>2]|0;if(!(a[h+5>>0]&4)){k=c[e>>2]|0;l=k+-16|0;c[e>>2]=l;return}jd(b,h,f);k=c[e>>2]|0;l=k+-16|0;c[e>>2]=l;return}function cc(b,e){b=b|0;e=e|0;var f=0,g=0;f=c[b+16>>2]|0;if(!(a[f+18>>0]&8)){g=0;return g|0}if(e|0)c[e>>2]=c[f+24>>2];g=d[f+37>>0]|0;return g|0}function dc(a,d,e,f,g){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0;h=a+8|0;i=(c[h>>2]|0)+(~d<<4)|0;if((g|0)!=0?(b[a+36>>1]|0)==0:0){d=a+16|0;c[(c[d>>2]|0)+28>>2]=g;c[(c[d>>2]|0)+24>>2]=f;Rc(a,i,e,1)}else Rc(a,i,e,0);if((e|0)!=-1)return;e=(c[a+16>>2]|0)+4|0;a=c[h>>2]|0;if((c[e>>2]|0)>>>0>=a>>>0)return;c[e>>2]=a;return}function ec(e,f,g,h,i,j){e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;k=Pa;Pa=Pa+16|0;l=k;if(!h)m=0;else{n=c[e+16>>2]|0;do if((h|0)<=0){if((h|0)>=-1000999){o=(c[e+8>>2]|0)+(h<<4)|0;break}if((h|0)==-1001e3){o=(c[e+12>>2]|0)+40|0;break}p=-1001e3-h|0;q=c[n>>2]|0;if((c[q+8>>2]|0)==22)o=15792;else{r=c[q>>2]|0;o=(p|0)>(d[r+6>>0]|0)?15792:r+16+(p+-1<<4)|0}}else{p=(c[n>>2]|0)+(h<<4)|0;o=p>>>0<(c[e+8>>2]|0)>>>0?p:15792}while(0);m=o-(c[e+28>>2]|0)|0}o=e+8|0;h=(c[o>>2]|0)+(~f<<4)|0;c[l>>2]=h;f=h;if((j|0)!=0?(b[e+36>>1]|0)==0:0){n=c[e+16>>2]|0;c[n+28>>2]=j;c[n+24>>2]=i;c[n+20>>2]=f-(c[e+28>>2]|0);a[n+36>>0]=a[e+41>>0]|0;i=e+68|0;j=n+32|0;c[j>>2]=c[i>>2];c[i>>2]=m;p=n+18|0;a[p>>0]=a[p>>0]|16;Rc(e,h,g,1);a[p>>0]=a[p>>0]&-17;c[i>>2]=c[j>>2];s=0}else{c[l+4>>2]=g;s=Xc(e,130,l,f-(c[e+28>>2]|0)|0,m)|0}if((g|0)!=-1){Pa=k;return s|0}g=(c[e+16>>2]|0)+4|0;e=c[o>>2]|0;if((c[g>>2]|0)>>>0>=e>>>0){Pa=k;return s|0}c[g>>2]=e;Pa=k;return s|0}function fc(a,b){a=a|0;b=b|0;Rc(a,c[b>>2]|0,c[b+4>>2]|0,0);return}function gc(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0;h=Pa;Pa=Pa+32|0;i=h;kf(b,i,d,e);e=Yc(b,i,(f|0)==0?13353:f,g)|0;if(e|0){Pa=h;return e|0}g=c[(c[b+8>>2]|0)+-16>>2]|0;if((a[g+6>>0]|0)!=1){Pa=h;return e|0}f=Ne(c[(c[b+12>>2]|0)+40>>2]|0,2)|0;i=g+16|0;g=c[(c[i>>2]|0)+8>>2]|0;d=f;j=c[d+4>>2]|0;k=g;c[k>>2]=c[d>>2];c[k+4>>2]=j;j=f+8|0;c[g+8>>2]=c[j>>2];if(!(c[j>>2]&64)){Pa=h;return e|0}j=c[f>>2]|0;if(!(a[j+5>>0]&3)){Pa=h;return e|0}f=c[i>>2]|0;if(!(a[f+5>>0]&4)){Pa=h;return e|0}jd(b,f,j);Pa=h;return e|0}function hc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=c[a+8>>2]|0;if((c[e+-8>>2]|0)!=70){f=1;return f|0}f=_c(a,c[(c[e+-16>>2]|0)+12>>2]|0,b,d,0)|0;return f|0}function ic(a){a=a|0;return d[a+6>>0]|0|0}function jc(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;g=c[b+12>>2]|0;do switch(e|0){case 0:{a[g+63>>0]=0;h=0;return h|0}case 1:{ne(g,0);a[g+63>>0]=1;h=0;return h|0}case 2:{Dd(b,0);h=0;return h|0}case 3:{h=((c[g+12>>2]|0)+(c[g+8>>2]|0)|0)>>>10;return h|0}case 4:{h=(c[g+12>>2]|0)+(c[g+8>>2]|0)&1023;return h|0}case 5:{if((a[g+62>>0]|0)==2){i=(c[g+20>>2]|0)==0&1;Cd(b);h=i;return h|0}i=(f<<10)+-1600|0;if(!(a[g+63>>0]|0))j=i;else j=(c[g+12>>2]|0)+i|0;ne(g,j);Cd(b);h=(a[g+61>>0]|0)==5&1;return h|0}case 6:{i=g+156|0;k=c[i>>2]|0;c[i>>2]=f;h=k;return h|0}case 8:{k=g+160|0;i=c[k>>2]|0;c[k>>2]=f;h=i;return h|0}case 7:{i=g+164|0;k=c[i>>2]|0;c[i>>2]=f;h=k;return h|0}case 9:{h=d[g+63>>0]|0;return h|0}case 10:{rd(b,2);h=0;return h|0}case 11:{rd(b,0);h=0;return h|0}default:{h=-1;return h|0}}while(0);return 0}function kc(a){a=a|0;Fc(a);return 0}function lc(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;e=De(a,c[f>>2]|0,(c[b>>2]|0)+-16|0)|0;f=c[b>>2]|0;c[b>>2]=(e|0)==0?f+-16|0:f+16|0;return e|0}function mc(b,d){b=b|0;d=d|0;var e=0,f=0;if((d|0)>1){if((c[(c[b+12>>2]|0)+12>>2]|0)>0)Ed(b);df(b,d);return}else{if(d|0)return;d=b+8|0;e=c[d>>2]|0;f=Ae(b,16476,0)|0;c[e>>2]=f;c[e+8>>2]=(a[f+4>>0]|64)&255;c[d>>2]=(c[d>>2]|0)+16;return}}function nc(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0;e=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){f=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){f=(c[a+12>>2]|0)+40|0;break}g=-1001e3-b|0;h=c[e>>2]|0;if((c[h+8>>2]|0)==22)f=15792;else{i=c[h>>2]|0;f=(g|0)>(d[i+6>>0]|0|0)?15792:i+16+(g+-1<<4)|0}}else{g=(c[e>>2]|0)+(b<<4)|0;f=g>>>0<(c[a+8>>2]|0)>>>0?g:15792}while(0);b=a+8|0;ef(a,c[b>>2]|0,f);c[b>>2]=(c[b>>2]|0)+16;return}function oc(a,b){a=a|0;b=b|0;var d=0;if((c[(c[a+12>>2]|0)+12>>2]|0)>0)Ed(a);d=Ce(a,b,0)|0;b=a+8|0;a=c[b>>2]|0;c[a>>2]=d;c[a+8>>2]=71;c[b>>2]=(c[b>>2]|0)+16;return d+24|0}function pc(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;f=c[a+16>>2]|0;do if((b|0)<=0){if((b|0)>=-1000999){g=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){g=(c[a+12>>2]|0)+40|0;break}h=-1001e3-b|0;i=c[f>>2]|0;if((c[i+8>>2]|0)==22)g=15792;else{j=c[i>>2]|0;g=(h|0)>(d[j+6>>0]|0|0)?15792:j+16+(h+-1<<4)|0}}else{h=(c[f>>2]|0)+(b<<4)|0;g=h>>>0<(c[a+8>>2]|0)>>>0?h:15792}while(0);a:do switch(c[g+8>>2]&63){case 38:{b=c[g>>2]|0;if((e|0)<=0){k=0;return k|0}if((d[b+6>>0]|0|0)<(e|0)){k=0;return k|0}else{l=16476;m=b+16+(e+-1<<4)|0}break}case 6:{b=c[g>>2]|0;f=c[b+12>>2]|0;if((e|0)<=0){k=0;return k|0}if((c[f+40>>2]|0)<(e|0)){k=0;return k|0}else{h=e+-1|0;j=c[(c[f+28>>2]|0)+(h<<3)>>2]|0;l=(j|0)==0?16476:j+16|0;m=c[(c[b+16+(h<<2)>>2]|0)+8>>2]|0;break a}break}default:{k=0;return k|0}}while(0);e=a+8|0;a=c[e>>2]|0;g=m;h=c[g+4>>2]|0;b=a;c[b>>2]=c[g>>2];c[b+4>>2]=h;c[a+8>>2]=c[m+8>>2];c[e>>2]=(c[e>>2]|0)+16;k=l;return k|0}function qc(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;g=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){h=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){h=(c[b+12>>2]|0)+40|0;break}i=-1001e3-e|0;j=c[g>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[g>>2]|0)+(e<<4)|0;h=i>>>0<(c[b+8>>2]|0)>>>0?i:15792}while(0);a:do switch(c[h+8>>2]&63){case 38:{e=c[h>>2]|0;if((f|0)<=0){l=0;return l|0}if((d[e+6>>0]|0|0)<(f|0)){l=0;return l|0}else{m=16476;n=e;o=e+16+(f+-1<<4)|0}break}case 6:{e=c[h>>2]|0;g=c[e+12>>2]|0;if((f|0)<=0){l=0;return l|0}if((c[g+40>>2]|0)<(f|0)){l=0;return l|0}else{i=f+-1|0;k=c[e+16+(i<<2)>>2]|0;e=c[(c[g+28>>2]|0)+(i<<3)>>2]|0;m=(e|0)==0?16476:e+16|0;n=k;o=c[k+8>>2]|0;break a}break}default:{l=0;return l|0}}while(0);f=b+8|0;h=c[f>>2]|0;k=h+-16|0;c[f>>2]=k;e=k;k=c[e+4>>2]|0;i=o;c[i>>2]=c[e>>2];c[i+4>>2]=k;c[o+8>>2]=c[h+-8>>2];h=c[f>>2]|0;if(!(c[h+8>>2]&64)){l=m;return l|0}f=c[h>>2]|0;if(!(a[f+5>>0]&3)){l=m;return l|0}h=n;if(!(a[h+5>>0]&4)){l=m;return l|0}jd(b,h,f);l=m;return l|0}function rc(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;f=c[a+16>>2]|0;g=(b|0)>0;do if(!g){if((b|0)>=-1000999){h=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){h=(c[a+12>>2]|0)+40|0;break}i=-1001e3-b|0;j=c[f>>2]|0;if((c[j+8>>2]|0)==22)h=15792;else{k=c[j>>2]|0;h=(i|0)>(d[k+6>>0]|0|0)?15792:k+16+(i+-1<<4)|0}}else{i=(c[f>>2]|0)+(b<<4)|0;h=i>>>0<(c[a+8>>2]|0)>>>0?i:15792}while(0);switch(c[h+8>>2]&63){case 6:{do if(!g){if((b|0)>=-1000999){l=(c[a+8>>2]|0)+(b<<4)|0;break}if((b|0)==-1001e3){l=(c[a+12>>2]|0)+40|0;break}i=-1001e3-b|0;k=c[f>>2]|0;if((c[k+8>>2]|0)==22)l=15792;else{j=c[k>>2]|0;l=(i|0)>(d[j+6>>0]|0|0)?15792:j+16+(i+-1<<4)|0}}else{i=(c[f>>2]|0)+(b<<4)|0;l=i>>>0<(c[a+8>>2]|0)>>>0?i:15792}while(0);m=c[(c[l>>2]|0)+16+(e+-1<<2)>>2]|0;return m|0}case 38:{m=(c[h>>2]|0)+16+(e+-1<<4)|0;return m|0}default:{m=0;return m|0}}return 0}function sc(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0;i=c[b+16>>2]|0;do if((e|0)<=0){if((e|0)>=-1000999){j=(c[b+8>>2]|0)+(e<<4)|0;break}if((e|0)==-1001e3){j=(c[b+12>>2]|0)+40|0;break}k=-1001e3-e|0;l=c[i>>2]|0;if((c[l+8>>2]|0)==22)j=15792;else{m=c[l>>2]|0;j=(k|0)>(d[m+6>>0]|0|0)?15792:m+16+(k+-1<<4)|0}}else{k=(c[i>>2]|0)+(e<<4)|0;j=k>>>0<(c[b+8>>2]|0)>>>0?k:15792}while(0);e=c[j>>2]|0;j=e+16+(f+-1<<2)|0;do if((g|0)<=0){if((g|0)>=-1000999){n=(c[b+8>>2]|0)+(g<<4)|0;break}if((g|0)==-1001e3){n=(c[b+12>>2]|0)+40|0;break}f=-1001e3-g|0;k=c[i>>2]|0;if((c[k+8>>2]|0)==22)n=15792;else{m=c[k>>2]|0;n=(f|0)>(d[m+6>>0]|0|0)?15792:m+16+(f+-1<<4)|0}}else{f=(c[i>>2]|0)+(g<<4)|0;n=f>>>0<(c[b+8>>2]|0)>>>0?f:15792}while(0);g=(c[n>>2]|0)+16+(h+-1<<2)|0;c[j>>2]=c[g>>2];j=c[g>>2]|0;if(!(a[j+5>>0]&3))return;if(!(a[e+5>>0]&4))return;jd(b,e,j);return}function tc(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;g=(d|0)==0|(e|0)==0;h=c[b+16>>2]|0;if(a[h+18>>0]&1)c[b+20>>2]=c[h+28>>2];c[b+52>>2]=g?0:d;c[b+44>>2]=f;c[b+48>>2]=f;a[b+40>>0]=g?0:e&255;return 1}function uc(a){a=a|0;return c[a+52>>2]|0}function vc(a){a=a|0;return d[a+40>>0]|0|0}function wc(a){a=a|0;return c[a+44>>2]|0}function xc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;if((b|0)<0){e=0;return e|0}f=c[a+16>>2]|0;g=a+72|0;if((b|0)!=0&(f|0)!=(g|0)){a=b;h=f;while(1){i=a+-1|0;j=c[h+8>>2]|0;if((a|0)>1&(j|0)!=(g|0)){a=i;h=j}else{k=j;l=i;break}}}else{k=f;l=b}if((l|0)!=0|(k|0)==(g|0)){e=0;return e|0}c[d+96>>2]=k;e=1;return e|0}function yc(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;if(!e){g=c[b+8>>2]|0;if((c[g+-8>>2]|0)!=70){h=0;return h|0}h=id(c[(c[g+-16>>2]|0)+12>>2]|0,f,0)|0;return h|0}g=c[e+96>>2]|0;do if(a[g+18>>0]&1){if((f|0)>=0){e=c[g+24>>2]|0;i=c[(c[c[g>>2]>>2]|0)+12>>2]|0;j=id(i,f,((c[g+28>>2]|0)-(c[i+12>>2]|0)>>2)+-1|0)|0;if(!j){k=e;l=9;break}else{m=e;n=j;l=13;break}}j=0-f|0;e=c[g>>2]|0;i=d[(c[(c[e>>2]|0)+12>>2]|0)+76>>0]|0;if((((c[g+24>>2]|0)-e>>4)-i|0)>(j|0)){o=e+(i<<4)+(j<<4)|0;p=6333}else{h=0;return h|0}}else{k=(c[g>>2]|0)+16|0;l=9}while(0);if((l|0)==9){if((c[b+16>>2]|0)==(g|0))q=b+8|0;else q=c[g+12>>2]|0;if((f|0)>0?((c[q>>2]|0)-k>>4|0)>=(f|0):0){m=k;n=6320;l=13}else{h=0;return h|0}}if((l|0)==13){o=m+(f+-1<<4)|0;p=n}n=b+8|0;b=c[n>>2]|0;f=o;m=c[f+4>>2]|0;l=b;c[l>>2]=c[f>>2];c[l+4>>2]=m;c[b+8>>2]=c[o+8>>2];c[n>>2]=(c[n>>2]|0)+16;h=p;return h|0}function zc(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;g=c[e+96>>2]|0;do if(a[g+18>>0]&1){if((f|0)>=0){e=c[g+24>>2]|0;h=c[(c[c[g>>2]>>2]|0)+12>>2]|0;i=id(h,f,((c[g+28>>2]|0)-(c[h+12>>2]|0)>>2)+-1|0)|0;if(!i){j=e;k=6;break}else{l=e;m=i;k=10;break}}i=0-f|0;e=c[g>>2]|0;h=d[(c[(c[e>>2]|0)+12>>2]|0)+76>>0]|0;if((((c[g+24>>2]|0)-e>>4)-h|0)>(i|0)){n=e+(h<<4)+(i<<4)|0;o=6333}else{p=0;q=b+8|0;r=c[q>>2]|0;s=r+-16|0;c[q>>2]=s;return p|0}}else{j=(c[g>>2]|0)+16|0;k=6}while(0);if((k|0)==6){if((c[b+16>>2]|0)==(g|0))t=b+8|0;else t=c[g+12>>2]|0;if((f|0)>0?((c[t>>2]|0)-j>>4|0)>=(f|0):0){l=j;m=6320;k=10}else{p=0;q=b+8|0;r=c[q>>2]|0;s=r+-16|0;c[q>>2]=s;return p|0}}if((k|0)==10){n=l+(f+-1<<4)|0;o=m}m=c[b+8>>2]|0;f=m+-16|0;l=c[f+4>>2]|0;k=n;c[k>>2]=c[f>>2];c[k+4>>2]=l;c[n+8>>2]=c[m+-8>>2];p=o;q=b+8|0;r=c[q>>2]|0;s=r+-16|0;c[q>>2]=s;return p|0}function Ac(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0;f=Pa;Pa=Pa+16|0;g=f;if((a[d>>0]|0)==62){h=b+8|0;i=(c[h>>2]|0)+-16|0;c[h>>2]=i;j=d+1|0;k=0;l=i}else{i=c[e+96>>2]|0;j=d;k=i;l=c[i>>2]|0}i=l+8|0;if((c[i>>2]&31|0)==6)m=c[l>>2]|0;else m=0;d=a[j>>0]|0;a:do if(!(d<<24>>24))n=1;else{h=(m|0)==0;o=(k|0)==0;p=e+16|0;q=e+24|0;r=e+28|0;s=e+12|0;t=e+36|0;u=m+4|0;v=e+20|0;w=k+18|0;x=e+32|0;y=e+34|0;z=e+33|0;A=m+6|0;B=e+35|0;C=e+8|0;D=m+12|0;E=e+4|0;F=k+8|0;G=k+28|0;H=b+12|0;I=j;J=1;K=d;while(1){b:do switch(K<<24>>24|0){case 83:{if(!h?(a[u>>0]|0)!=38:0){L=c[D>>2]|0;M=c[L+36>>2]|0;N=(M|0)==0?6348:M+16|0;c[p>>2]=N;M=c[L+64>>2]|0;c[q>>2]=M;c[r>>2]=c[L+68>>2];O=N;P=(M|0)==0?6351:6356}else{c[p>>2]=6343;c[q>>2]=-1;c[r>>2]=-1;O=6343;P=13569}c[s>>2]=P;Qd(t,O,60);Q=J;break}case 108:{if(!o?(a[w>>0]&1)!=0:0){M=c[(c[c[k>>2]>>2]|0)+12>>2]|0;N=c[M+20>>2]|0;if(!N)R=0;else R=c[N+(((c[G>>2]|0)-(c[M+12>>2]|0)>>2)+-1<<2)>>2]|0}else R=-1;c[v>>2]=R;Q=J;break}case 117:{if(!h){a[x>>0]=a[A>>0]|0;if((a[u>>0]|0)!=38){a[y>>0]=a[(c[D>>2]|0)+77>>0]|0;a[z>>0]=a[(c[D>>2]|0)+76>>0]|0;Q=J;break b}}else a[x>>0]=0;a[y>>0]=1;a[z>>0]=0;Q=J;break}case 116:{if(o)S=0;else S=a[w>>0]&64;a[B>>0]=S;Q=J;break}case 110:{c:do if((!o?(a[w>>0]&64)==0:0)?(M=c[F>>2]|0,(a[M+18>>0]&1)!=0):0){N=c[(c[c[M>>2]>>2]|0)+12>>2]|0;L=c[N+12>>2]|0;T=((c[M+28>>2]|0)-L>>2)+-1|0;M=c[L+(T<<2)>>2]|0;do switch(M&63){case 30:case 29:{L=Bc(N,T,M>>>6&255,E)|0;c[C>>2]=L;if(!L)break c;else{Q=J;break b}break}case 34:{c[E>>2]=6360;U=6360;break}case 7:case 6:case 12:{V=0;W=45;break}case 10:case 8:{V=1;W=45;break}case 24:{V=5;W=45;break}case 13:{V=6;W=45;break}case 14:{V=7;W=45;break}case 15:{V=8;W=45;break}case 16:{V=9;W=45;break}case 17:{V=10;W=45;break}case 18:{V=11;W=45;break}case 19:{V=12;W=45;break}case 21:{V=4;W=45;break}case 25:{V=13;W=45;break}case 26:{V=14;W=45;break}case 22:{V=15;W=45;break}default:{W=46;break c}}while(0);if((W|0)==45){W=0;c[E>>2]=(c[(c[H>>2]|0)+184+(V<<2)>>2]|0)+16;U=6373}c[C>>2]=U;Q=J;break b}else W=46;while(0);if((W|0)==46){W=0;c[C>>2]=0}c[C>>2]=16476;c[E>>2]=0;Q=J;break}case 102:case 76:{Q=J;break}default:Q=0}while(0);I=I+1|0;K=a[I>>0]|0;if(!(K<<24>>24)){n=Q;break a}else J=Q}}while(0);if(rm(j,102)|0){Q=b+8|0;W=c[Q>>2]|0;U=l;l=c[U+4>>2]|0;V=W;c[V>>2]=c[U>>2];c[V+4>>2]=l;c[W+8>>2]=c[i>>2];c[Q>>2]=(c[Q>>2]|0)+16}if(!(rm(j,76)|0)){Pa=f;return n|0}if(m|0?(a[m+4>>0]|0)!=38:0){j=m+12|0;m=c[(c[j>>2]|0)+20>>2]|0;Q=Le(b)|0;i=b+8|0;W=c[i>>2]|0;c[W>>2]=Q;c[W+8>>2]=69;c[i>>2]=(c[i>>2]|0)+16;c[g>>2]=1;c[g+8>>2]=1;if((c[(c[j>>2]|0)+52>>2]|0)>0){i=0;do{Ie(b,Q,c[m+(i<<2)>>2]|0,g);i=i+1|0}while((i|0)<(c[(c[j>>2]|0)+52>>2]|0))}Pa=f;return n|0}j=b+8|0;b=c[j>>2]|0;c[b+8>>2]=0;c[j>>2]=b+16;Pa=f;return n|0}function Bc(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;g=id(b,e+1|0,d)|0;c[f>>2]=g;if(g|0){h=8875;return h|0}g=b+12|0;i=d;d=e;a:while(1){if((i|0)<=0){h=0;j=40;break}k=c[g>>2]|0;e=-1;l=0;while(1){m=c[k+(l<<2)>>2]|0;n=m>>>6&255;switch(m&63){case 4:{o=l;p=(n|0)>(d|0)|(n+(m>>>23)|0)<(d|0)?e:l;break}case 34:{o=l;p=(n+2|0)>(d|0)?e:l;break}case 30:case 29:{o=l;p=(n|0)>(d|0)?e:l;break}case 23:{q=(m>>>14)+-131071|0;r=l+1+q|0;o=((l|0)>=(r|0)|(r|0)>(i|0)?0:q)+l|0;p=e;break}case 27:{o=l;p=(n|0)==(d|0)?l:e;break}default:{o=l;p=((n|0)==(d|0)?(a[272+(m&63)>>0]&64)!=0:0)?l:e}}l=o+1|0;if((l|0)>=(i|0))break;else e=p}if((p|0)==-1){h=0;j=40;break}s=c[k+(p<<2)>>2]|0;switch(s&63){case 7:case 6:{j=17;break a;break}case 5:{j=28;break a;break}case 2:case 1:{j=29;break a;break}case 12:{j=34;break a;break}case 0:break;default:{h=0;j=40;break a}}d=s>>>23;if(d>>>0>=(s>>>6&255)>>>0){h=0;j=40;break}e=id(b,d+1|0,p)|0;c[f>>2]=e;if(e|0){h=8875;j=40;break}else i=p}if((j|0)==17){i=s>>>14;d=s>>>23;if((s&63|0)==7)t=id(b,d+1|0,p)|0;else{o=c[(c[b+28>>2]|0)+(d<<3)>>2]|0;t=(o|0)==0?13353:o+16|0}if(!(s&4194304)){o=Bc(b,p,i&511,f)|0;if(!((o|0)!=0?(a[o>>0]|0)==99:0))j=25}else{o=c[b+8>>2]|0;d=i&255;if((c[o+(d<<4)+8>>2]&15|0)==4)c[f>>2]=(c[o+(d<<4)>>2]|0)+16;else j=25}if((j|0)==25)c[f>>2]=13353;if(!t){h=6391;return h|0}d=(Cl(t,9039)|0)==0;h=d?6384:6391;return h|0}else if((j|0)==28){d=c[(c[b+28>>2]|0)+(s>>>23<<3)>>2]|0;c[f>>2]=(d|0)==0?13353:d+16|0;h=6406;return h|0}else if((j|0)==29){if((s&63|0)==1)u=s>>>14;else u=(c[k+(p+1<<2)>>2]|0)>>>6;k=c[b+8>>2]|0;if((c[k+(u<<4)+8>>2]&15|0)!=4){h=0;return h|0}c[f>>2]=(c[k+(u<<4)>>2]|0)+16;h=6397;return h|0}else if((j|0)==34){u=s>>>14;if(!(s&4194304)){s=Bc(b,p,u&511,f)|0;if(s|0?(a[s>>0]|0)==99:0){h=8188;return h|0}}else{s=c[b+8>>2]|0;b=u&255;if((c[s+(b<<4)+8>>2]&15|0)==4){c[f>>2]=(c[s+(b<<4)>>2]|0)+16;h=8188;return h|0}}c[f>>2]=13353;h=8188;return h|0}else if((j|0)==40)return h|0;return 0}function Cc(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;f=Pa;Pa=Pa+32|0;g=f+16|0;h=f;i=f+24|0;f=c[b+16>>2]|0;c[i>>2]=0;j=c[352+((c[d+8>>2]&15)+1<<2)>>2]|0;a:do if(a[f+18>>0]&1){k=c[c[f>>2]>>2]|0;l=a[k+6>>0]|0;b:do if(l<<24>>24){m=l&255;n=0;while(1){if((c[(c[k+16+(n<<2)>>2]|0)+8>>2]|0)==(d|0))break;o=n+1|0;if(o>>>0<m>>>0)n=o;else break b}m=c[(c[(c[k+12>>2]|0)+28>>2]|0)+(n<<3)>>2]|0;o=(m|0)==0?13353:m+16|0;c[i>>2]=o;p=6406;q=o;c[h>>2]=e;r=h+4|0;c[r>>2]=p;s=h+8|0;c[s>>2]=q;t=h+12|0;c[t>>2]=j;Dc(b,6414,h)}while(0);l=c[f+24>>2]|0;o=c[f+4>>2]|0;m=l;if(l>>>0<o>>>0){u=l;while(1){if((u|0)==(d|0))break;u=u+16|0;if(u>>>0>=o>>>0)break a}o=c[k+12>>2]|0;u=Bc(o,((c[f+28>>2]|0)-(c[o+12>>2]|0)>>2)+-1|0,d-m>>4,i)|0;if(u|0){p=u;q=c[i>>2]|0;c[h>>2]=e;r=h+4|0;c[r>>2]=p;s=h+8|0;c[s>>2]=q;t=h+12|0;c[t>>2]=j;Dc(b,6414,h)}}}while(0);c[g>>2]=e;c[g+4>>2]=j;Dc(b,6449,g)}function Dc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;Ec(a,Od(a,b,f)|0);Fc(a)}function Ec(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+80|0;f=e+64|0;g=e;h=c[b+16>>2]|0;if(!(a[h+18>>0]&1)){Pa=e;return}i=c[(c[c[h>>2]>>2]|0)+12>>2]|0;j=c[i+20>>2]|0;if(!j)k=0;else k=c[j+(((c[h+28>>2]|0)-(c[i+12>>2]|0)>>2)+-1<<2)>>2]|0;h=c[i+36>>2]|0;if(!h){a[g>>0]=63;a[g+1>>0]=0}else Qd(g,h+16|0,60);c[f>>2]=g;c[f+4>>2]=k;c[f+8>>2]=d;Pd(b,8993,f)|0;Pa=e;return}function Fc(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;b=c[a+68>>2]|0;if(!b)Jc(a,2);d=(c[a+28>>2]|0)+b|0;b=d+8|0;if((c[b>>2]&15|0)!=6)Jc(a,6);e=a+8|0;f=c[e>>2]|0;g=f+-16|0;h=c[g+4>>2]|0;i=f;c[i>>2]=c[g>>2];c[i+4>>2]=h;c[f+8>>2]=c[f+-8>>2];f=c[e>>2]|0;h=d;d=c[h+4>>2]|0;i=f+-16|0;c[i>>2]=c[h>>2];c[i+4>>2]=d;c[f+-8>>2]=c[b>>2];b=c[e>>2]|0;c[e>>2]=b+16;Rc(a,b+-16|0,1,0);Jc(a,2)}function Gc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=c[b+8>>2]|0;Cc(a,(e|0)==3|(e&15|0)==4?d:b,6474)}function Hc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=Pa;Pa=Pa+16|0;e=(Ye(b,d)|0)==0;Cc(a,e?b:c,6486)}function Ic(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=Pa;Pa=Pa+16|0;f=e+8|0;g=e;e=c[352+((c[b+8>>2]&15)+1<<2)>>2]|0;b=c[352+((c[d+8>>2]&15)+1<<2)>>2]|0;if((e|0)==(b|0)){c[g>>2]=e;Dc(a,6508,g)}else{c[f>>2]=e;c[f+4>>2]=b;Dc(a,6541,f)}}function Jc(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=c[b+64>>2]|0;if(e|0){c[e+160>>2]=d;Ga(e+4|0,1)}a[b+6>>0]=d;e=b+12|0;f=c[e>>2]|0;g=c[f+172>>2]|0;if(c[g+64>>2]|0){h=c[b+8>>2]|0;i=g+8|0;g=c[i>>2]|0;c[i>>2]=g+16;i=h+-16|0;j=c[i+4>>2]|0;k=g;c[k>>2]=c[i>>2];c[k+4>>2]=j;c[g+8>>2]=c[h+-8>>2];Jc(c[(c[e>>2]|0)+172>>2]|0,d)}d=c[f+168>>2]|0;if(!d)na();Ta[d&511](b)|0;na()}function Kc(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;f=Pa;Pa=Pa+176|0;g=4;h=Hk(40)|0;c[h>>2]=0;i=f;l=a+38|0;m=b[l>>1]|0;n=i+160|0;c[n>>2]=0;o=a+64|0;c[i>>2]=c[o>>2];c[o>>2]=i;h=Rn(i+4|0,1,h|0,g|0)|0;g=L()|0;j=0;p=j;j=0;if((p|0)!=0&(k|0)!=0){q=Sn(c[p>>2]|0,h|0,g|0)|0;if(!q)Ga(p|0,k|0);K(k|0)}else q=-1;p=L()|0;if((q|0)==1)r=p;else r=0;do{if(r|0){s=6;break}j=0;M(d|0,a|0,e|0);p=j;j=0;if((p|0)!=0&(k|0)!=0){t=Sn(c[p>>2]|0,h|0,g|0)|0;if(!t)Ga(p|0,k|0);K(k|0)}else t=-1;r=L()|0}while((t|0)==1);if((s|0)==6){u=c[i>>2]|0;c[o>>2]=u;b[l>>1]=m;v=c[n>>2]|0;Ik(h|0);Pa=f;return v|0}u=c[i>>2]|0;c[o>>2]=u;b[l>>1]=m;v=c[n>>2]|0;Ik(h|0);Pa=f;return v|0}function Lc(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=b+28|0;f=c[e>>2]|0;g=b+32|0;h=c[g>>2]|0;if((d+1|0)>>>0>268435455)Gd(b);i=Hd(b,f,h<<4,d<<4)|0;c[e>>2]=i;if((h|0)<(d|0)){j=h;do{c[i+(j<<4)+8>>2]=0;j=j+1|0}while((j|0)!=(d|0))}c[g>>2]=d;c[b+24>>2]=i+(d<<4)+-80;d=b+8|0;g=f;c[d>>2]=i+((c[d>>2]|0)-g>>4<<4);d=c[b+56>>2]|0;if(d|0?(f=d+8|0,c[f>>2]=i+((c[f>>2]|0)-g>>4<<4),f=c[d>>2]|0,f|0):0){d=f;do{f=d+8|0;c[f>>2]=(c[e>>2]|0)+((c[f>>2]|0)-g>>4<<4);d=c[d>>2]|0}while((d|0)!=0)}d=c[b+16>>2]|0;if(!d)return;b=d;do{d=b+4|0;f=c[e>>2]|0;c[d>>2]=f+((c[d>>2]|0)-g>>4<<4);c[b>>2]=f+((c[b>>2]|0)-g>>4<<4);if(a[b+18>>0]&1){d=b+24|0;c[d>>2]=f+((c[d>>2]|0)-g>>4<<4)}b=c[b+8>>2]|0}while((b|0)!=0);return}function Mc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=Pa;Pa=Pa+16|0;e=c[a+32>>2]|0;if((e|0)>1e6)Jc(a,6);f=b+5+((c[a+8>>2]|0)-(c[a+28>>2]|0)>>4)|0;b=e<<1;e=(b|0)<1e6?b:1e6;b=(e|0)<(f|0)?f:e;if((b|0)>1e6){Lc(a,1000200);Dc(a,9456,d)}else{Lc(a,b);Pa=d;return}}function Nc(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=c[a+8>>2]|0;d=c[a+16>>2]|0;if(!d)e=b;else{f=d;d=b;while(1){b=c[f+4>>2]|0;g=d>>>0<b>>>0?b:d;f=c[f+8>>2]|0;if(!f){e=g;break}else d=g}}d=e-(c[a+28>>2]|0)|0;e=d>>4;f=e+11+((e+1|0)/8|0)|0;e=(f|0)<1e6?f:1e6;if((d|0)>15999984)return;if((e|0)>=(c[a+32>>2]|0))return;Lc(a,e);return}function Oc(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;f=Pa;Pa=Pa+112|0;g=f;h=f+4|0;i=c[b+52>>2]|0;if(!i){Pa=f;return}j=b+41|0;if(!(a[j>>0]|0)){Pa=f;return}k=c[b+16>>2]|0;l=b+8|0;m=c[l>>2]|0;n=b+28|0;o=c[n>>2]|0;p=m-o|0;q=k+4|0;r=(c[q>>2]|0)-o|0;c[h>>2]=d;c[h+20>>2]=e;c[h+96>>2]=k;e=m;do if(((c[b+24>>2]|0)-m|0)<336){d=c[b+32>>2]|0;if((d|0)>1e6)Jc(b,6);o=(p>>4)+25|0;s=d<<1;d=(s|0)<1e6?s:1e6;s=(d|0)<(o|0)?o:d;if((s|0)>1e6){Lc(b,1000200);Dc(b,9456,g)}else{Lc(b,s);t=c[l>>2]|0;break}}else t=e;while(0);c[q>>2]=t+320;a[j>>0]=0;t=k+18|0;a[t>>0]=a[t>>0]|2;Xa[i&255](b,h);a[j>>0]=1;j=c[n>>2]|0;c[q>>2]=j+r;c[l>>2]=j+p;a[t>>0]=a[t>>0]&-3;Pa=f;return}function Pc(e,f,g){e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0;h=Pa;Pa=Pa+32|0;i=h+16|0;j=h+8|0;k=h;l=e+28|0;m=e+8|0;n=e+24|0;o=e+32|0;p=f;a:while(1){q=c[l>>2]|0;switch(c[p+8>>2]&63){case 22:{r=3;break a;break}case 38:{r=4;break a;break}case 6:{r=30;break a;break}default:{}}f=Se(e,p,16)|0;s=p-(c[l>>2]|0)|0;t=f+8|0;if((c[t>>2]&15|0)!=6){r=56;break}u=c[m>>2]|0;if(u>>>0>p>>>0){v=u;do{w=v;v=v+-16|0;x=v;y=c[x+4>>2]|0;z=w;c[z>>2]=c[x>>2];c[z+4>>2]=y;c[w+8>>2]=c[w+-8>>2]}while(v>>>0>p>>>0);A=c[m>>2]|0}else A=u;v=A+16|0;c[m>>2]=v;w=v;if(((c[n>>2]|0)-w|0)<16){v=c[o>>2]|0;if((v|0)>1e6){r=63;break}y=(w-(c[l>>2]|0)>>4)+5|0;w=v<<1;v=(w|0)<1e6?w:1e6;w=(v|0)<(y|0)?y:v;if((w|0)>1e6){r=65;break}Lc(e,w)}w=(c[l>>2]|0)+s|0;v=f;y=c[v+4>>2]|0;z=w;c[z>>2]=c[v>>2];c[z+4>>2]=y;c[w+8>>2]=c[t>>2];p=w}if((r|0)==3)B=p;else if((r|0)==4)B=(c[p>>2]|0)+12|0;else if((r|0)==30){A=p-q|0;w=c[(c[p>>2]|0)+12>>2]|0;y=c[m>>2]|0;z=w+78|0;v=d[z>>0]|0;do if(((c[n>>2]|0)-y>>4|0)<=(v|0)){x=c[o>>2]|0;if((x|0)>1e6)Jc(e,6);C=v+5+(y-q>>4)|0;D=x<<1;x=(D|0)<1e6?D:1e6;D=(x|0)<(C|0)?C:x;if((D|0)>1e6){Lc(e,1000200);Dc(e,9456,j)}else{Lc(e,D);E=c[m>>2]|0;F=c[l>>2]|0;break}}else{E=y;F=q}while(0);y=E;j=F+A|0;A=E-j>>4;E=A+-1|0;F=a[w+76>>0]|0;v=F&255;if((A|0)>(v|0)){G=E;H=y}else{A=E;E=y;do{y=E;E=E+16|0;c[y+8>>2]=0;A=A+1|0}while((A|0)<(v|0));c[m>>2]=E;G=A;H=E}if(a[w+77>>0]|0){E=0-G|0;G=H+(E<<4)|0;if(F<<24>>24!=0?(c[m>>2]=H+16,A=G,y=c[A+4>>2]|0,D=H,c[D>>2]=c[A>>2],c[D+4>>2]=y,y=H+(E<<4)+8|0,c[H+8>>2]=c[y>>2],c[y>>2]=0,F<<24>>24!=1):0){F=1;do{y=c[m>>2]|0;E=G+(F<<4)|0;c[m>>2]=y+16;D=E;A=c[D+4>>2]|0;x=y;c[x>>2]=c[D>>2];c[x+4>>2]=A;A=E+8|0;c[y+8>>2]=c[A>>2];c[A>>2]=0;F=F+1|0}while((F|0)!=(v|0));I=H}else I=H}else I=j+16|0;H=e+16|0;v=c[(c[H>>2]|0)+12>>2]|0;if(!v)J=oe(e)|0;else J=v;c[H>>2]=J;b[J+16>>1]=g;c[J>>2]=j;c[J+24>>2]=I;j=I+(d[z>>0]<<4)|0;c[J+4>>2]=j;z=J+28|0;c[z>>2]=c[w+12>>2];w=J+18|0;a[w>>0]=1;c[m>>2]=j;if((c[(c[e+12>>2]|0)+12>>2]|0)>0)Ed(e);if(!(a[e+40>>0]&1)){K=0;Pa=h;return K|0}c[z>>2]=(c[z>>2]|0)+4;j=c[J+8>>2]|0;if((a[j+18>>0]&1)!=0?(c[(c[j+28>>2]|0)+-4>>2]&63|0)==30:0){a[w>>0]=a[w>>0]|64;L=4}else L=0;Oc(e,L,-1);c[z>>2]=(c[z>>2]|0)+-4;K=0;Pa=h;return K|0}else if((r|0)==56)Cc(e,p,10383);else if((r|0)==63)Jc(e,6);else if((r|0)==65){Lc(e,1000200);Dc(e,9456,i)}i=p-q|0;p=c[B>>2]|0;B=c[m>>2]|0;do if(((c[n>>2]|0)-B|0)<336){r=c[o>>2]|0;if((r|0)>1e6)Jc(e,6);z=(B-q>>4)+25|0;L=r<<1;r=(L|0)<1e6?L:1e6;L=(r|0)<(z|0)?z:r;if((L|0)>1e6){Lc(e,1000200);Dc(e,9456,k)}else{Lc(e,L);break}}while(0);k=e+16|0;q=c[(c[k>>2]|0)+12>>2]|0;if(!q)M=oe(e)|0;else M=q;c[k>>2]=M;b[M+16>>1]=g;c[M>>2]=(c[l>>2]|0)+i;c[M+4>>2]=(c[m>>2]|0)+320;a[M+18>>0]=0;if((c[(c[e+12>>2]|0)+12>>2]|0)>0)Ed(e);M=e+40|0;if(a[M>>0]&1)Oc(e,0,-1);i=Ta[p&511](e)|0;p=(c[m>>2]|0)+(0-i<<4)|0;i=c[k>>2]|0;g=d[M>>0]|0;if(!(g&6)){N=p;O=c[i+8>>2]|0}else{if(!(g&2))P=p;else{g=p-(c[l>>2]|0)|0;Oc(e,1,-1);P=(c[l>>2]|0)+g|0}g=c[i+8>>2]|0;c[e+20>>2]=c[g+28>>2];N=P;O=g}g=c[i>>2]|0;P=b[i+16>>1]|0;c[k>>2]=O;b:do if(P<<16>>16){O=g;k=P<<16>>16;i=N;while(1){if(i>>>0>=(c[m>>2]|0)>>>0)break;e=O+16|0;l=i;p=c[l+4>>2]|0;M=O;c[M>>2]=c[l>>2];c[M+4>>2]=p;c[O+8>>2]=c[i+8>>2];p=k+-1|0;if(!p){Q=e;break b}else{O=e;k=p;i=i+16|0}}if((k|0)>0){i=O;t=k;while(1){f=i+16|0;c[i+8>>2]=0;if((t|0)>1){i=f;t=t+-1|0}else{Q=f;break}}}else Q=O}else Q=g;while(0);c[m>>2]=Q;K=1;Pa=h;return K|0}function Qc(a,e){a=a|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;f=a+16|0;g=c[f>>2]|0;h=d[a+40>>0]|0;if(!(h&6)){i=e;j=c[g+8>>2]|0}else{if(!(h&2))k=e;else{h=a+28|0;l=e-(c[h>>2]|0)|0;Oc(a,1,-1);k=(c[h>>2]|0)+l|0}l=c[g+8>>2]|0;c[a+20>>2]=c[l+28>>2];i=k;j=l}l=c[g>>2]|0;k=b[g+16>>1]|0;g=k<<16>>16;c[f>>2]=j;j=a+8|0;if(!(k<<16>>16)){m=l;c[j>>2]=m;n=g+1|0;return n|0}k=l;l=g;a=i;while(1){if(a>>>0>=(c[j>>2]|0)>>>0)break;i=k+16|0;f=a;h=c[f+4>>2]|0;e=k;c[e>>2]=c[f>>2];c[e+4>>2]=h;c[k+8>>2]=c[a+8>>2];h=l+-1|0;if(!h){m=i;o=13;break}else{k=i;l=h;a=a+16|0}}if((o|0)==13){c[j>>2]=m;n=g+1|0;return n|0}if((l|0)<=0){m=k;c[j>>2]=m;n=g+1|0;return n|0}o=k;k=l;while(1){l=o+16|0;c[o+8>>2]=0;if((k|0)>1){o=l;k=k+-1|0}else{m=l;break}}c[j>>2]=m;n=g+1|0;return n|0}function Rc(a,c,d,e){a=a|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;f=Pa;Pa=Pa+16|0;g=f;h=a+38|0;i=(b[h>>1]|0)+1<<16>>16;b[h>>1]=i;if((i&65535)>199){if(i<<16>>16==200)Dc(a,6571,g);if((i&65535)>224)Jc(a,6)}i=(e|0)!=0;if(!i){e=a+36|0;b[e>>1]=(b[e>>1]|0)+1<<16>>16}if(!(Pc(a,c,d)|0))hf(a);if(i){j=b[h>>1]|0;k=j+-1<<16>>16;b[h>>1]=k;Pa=f;return}i=a+36|0;b[i>>1]=(b[i>>1]|0)+-1<<16>>16;j=b[h>>1]|0;k=j+-1<<16>>16;b[h>>1]=k;Pa=f;return}function Sc(d,f,g){d=d|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;if(!f)h=1;else h=(e[f+38>>1]|0)+1&65535;f=d+38|0;b[f>>1]=h;h=d+36|0;b[h>>1]=0;i=d+8|0;j=Kc(d,131,(c[i>>2]|0)+(0-g<<4)|0)|0;if((j|0)==-1){k=2;b[h>>1]=1;l=b[f>>1]|0;m=l+-1<<16>>16;b[f>>1]=m;return k|0}if(j>>>0<=1){k=j;b[h>>1]=1;l=b[f>>1]|0;m=l+-1<<16>>16;b[f>>1]=m;return k|0}g=d+16|0;n=d+28|0;o=d+41|0;p=d+12|0;q=d+68|0;r=d+32|0;s=j;a:while(1){j=c[g>>2]|0;if(!j)break;t=j;while(1){if(a[t+18>>0]&16)break;j=c[t+8>>2]|0;if(!j)break a;else t=j}j=t+18|0;u=(c[n>>2]|0)+(c[t+20>>2]|0)|0;fd(d,u);switch(s|0){case 4:{v=c[(c[p>>2]|0)+180>>2]|0;c[u>>2]=v;w=(a[v+4>>0]|64)&255;break}case 6:{v=Ae(d,6588,23)|0;c[u>>2]=v;w=(a[v+4>>0]|64)&255;break}default:{v=c[i>>2]|0;x=v+-16|0;y=c[x+4>>2]|0;z=u;c[z>>2]=c[x>>2];c[z+4>>2]=y;w=c[v+-8>>2]|0}}c[u+8>>2]=w;v=u+16|0;c[i>>2]=v;c[g>>2]=t;a[o>>0]=a[t+36>>0]|0;b[h>>1]=0;u=t;y=v;do{v=c[u+4>>2]|0;y=y>>>0<v>>>0?v:y;u=c[u+8>>2]|0}while((u|0)!=0);u=y-(c[n>>2]|0)|0;v=u>>4;z=v+11+((v+1|0)/8|0)|0;v=(z|0)<1e6?z:1e6;if((u|0)<=15999984?(v|0)<(c[r>>2]|0):0)Lc(d,v);c[q>>2]=c[t+32>>2];a[j>>0]=a[j>>0]|32;a[t+37>>0]=s;v=Kc(d,132,0)|0;if(v>>>0>1)s=v;else{k=v;A=25;break}}if((A|0)==25){b[h>>1]=1;l=b[f>>1]|0;m=l+-1<<16>>16;b[f>>1]=m;return k|0}a[d+6>>0]=s;A=c[i>>2]|0;switch(s|0){case 4:{q=c[(c[p>>2]|0)+180>>2]|0;c[A>>2]=q;B=(a[q+4>>0]|64)&255;break}case 6:{q=Ae(d,6588,23)|0;c[A>>2]=q;B=(a[q+4>>0]|64)&255;break}default:{q=A+-16|0;d=c[q+4>>2]|0;p=A;c[p>>2]=c[q>>2];c[p+4>>2]=d;B=c[A+-8>>2]|0}}c[A+8>>2]=B;B=A+16|0;c[i>>2]=B;c[(c[g>>2]|0)+4>>2]=B;k=s;b[h>>1]=1;l=b[f>>1]|0;m=l+-1<<16>>16;b[f>>1]=m;return k|0}function Tc(f,g){f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;h=f+16|0;i=c[h>>2]|0;if((e[f+38>>1]|0)>199)Vc(f,6571,g);j=f+6|0;switch(a[j>>0]|0){case 0:{if((i|0)!=(f+72|0))Vc(f,6612,g);if(Pc(f,g+-16|0,-1)|0)return;hf(f);return}case 1:{a[j>>0]=0;j=f+28|0;c[i>>2]=(c[j>>2]|0)+(c[i+20>>2]|0);k=i+18|0;l=a[k>>0]|0;if(!(l&1)){m=c[i+28>>2]|0;if(!m){n=g;o=i}else{a[i+37>>0]=1;a[k>>0]=l|8;l=Ta[m&511](f)|0;n=(c[f+8>>2]|0)+(0-l<<4)|0;o=c[h>>2]|0}l=d[f+40>>0]|0;if(!(l&6)){p=n;q=c[o+8>>2]|0}else{if(!(l&2))r=n;else{l=n-(c[j>>2]|0)|0;Oc(f,1,-1);r=(c[j>>2]|0)+l|0}l=c[o+8>>2]|0;c[f+20>>2]=c[l+28>>2];p=r;q=l}l=c[o>>2]|0;r=b[o+16>>1]|0;c[h>>2]=q;q=f+8|0;a:do if(r<<16>>16){h=l;o=r<<16>>16;j=p;while(1){if(j>>>0>=(c[q>>2]|0)>>>0)break;n=h+16|0;m=j;k=c[m+4>>2]|0;i=h;c[i>>2]=c[m>>2];c[i+4>>2]=k;c[h+8>>2]=c[j+8>>2];k=o+-1|0;if(!k){s=n;break a}else{h=n;o=k;j=j+16|0}}if((o|0)>0){j=h;k=o;while(1){n=j+16|0;c[j+8>>2]=0;if((k|0)>1){j=n;k=k+-1|0}else{s=n;break}}}else s=h}else s=l;while(0);c[q>>2]=s}else hf(f);Uc(f,0);return}default:Vc(f,10064,g)}}function Uc(e,f){e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;f=e+16|0;g=c[f>>2]|0;h=e+72|0;if((g|0)==(h|0))return;i=e+68|0;j=e+8|0;k=e+40|0;l=e+20|0;m=e+28|0;n=g;do{g=n+18|0;o=a[g>>0]|0;if(!(o&1)){p=o&255;if(!(p&16))q=o;else{o=p&239;a[g>>0]=o;c[i>>2]=c[n+32>>2];q=o}if((b[n+16>>1]|0)==-1?(o=n+4|0,p=c[j>>2]|0,(c[o>>2]|0)>>>0<p>>>0):0)c[o>>2]=p;if(!(q&32))a[n+37>>0]=1;a[g>>0]=q&-57|8;g=Ta[c[n+28>>2]&511](e)|0;p=(c[j>>2]|0)+(0-g<<4)|0;g=c[f>>2]|0;o=d[k>>0]|0;if(!(o&6)){r=p;s=c[g+8>>2]|0}else{if(!(o&2))t=p;else{o=p-(c[m>>2]|0)|0;Oc(e,1,-1);t=(c[m>>2]|0)+o|0}o=c[g+8>>2]|0;c[l>>2]=c[o+28>>2];r=t;s=o}o=c[g>>2]|0;p=b[g+16>>1]|0;c[f>>2]=s;a:do if(p<<16>>16){g=o;u=p<<16>>16;v=r;while(1){if(v>>>0>=(c[j>>2]|0)>>>0)break;w=g+16|0;x=v;y=c[x+4>>2]|0;z=g;c[z>>2]=c[x>>2];c[z+4>>2]=y;c[g+8>>2]=c[v+8>>2];y=u+-1|0;if(!y){A=w;break a}else{g=w;u=y;v=v+16|0}}if((u|0)>0){v=g;y=u;while(1){w=v+16|0;c[v+8>>2]=0;if((y|0)>1){v=w;y=y+-1|0}else{A=w;break}}}else A=g}else A=o;while(0);c[j>>2]=A}else{gf(e);hf(e)}n=c[f>>2]|0}while((n|0)!=(h|0));return}function Vc(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;f=b+8|0;c[f>>2]=e;g=Be(b,d)|0;c[e>>2]=g;c[e+8>>2]=(a[g+4>>0]|64)&255;c[f>>2]=(c[f>>2]|0)+16;Jc(b,-1)}function Wc(d,e,f,g){d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;h=Pa;Pa=Pa+16|0;i=h+8|0;j=h;k=c[d+16>>2]|0;if(b[d+36>>1]|0)if((c[(c[d+12>>2]|0)+172>>2]|0)==(d|0))Dc(d,6692,i);else Dc(d,6650,j);a[d+6>>0]=1;c[k+20>>2]=(c[k>>2]|0)-(c[d+28>>2]|0);if(a[k+18>>0]&1){Pa=h;return 0}c[k+28>>2]=g;if(!g){l=d+8|0;m=c[l>>2]|0;n=0-e|0;o=m+(n<<4)|0;p=o+-16|0;c[k>>2]=p;Jc(d,1)}c[k+24>>2]=f;l=d+8|0;m=c[l>>2]|0;n=0-e|0;o=m+(n<<4)|0;p=o+-16|0;c[k>>2]=p;Jc(d,1);return 0}function Xc(d,e,f,g,h){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;i=d+16|0;j=c[i>>2]|0;k=d+41|0;l=a[k>>0]|0;m=d+36|0;n=b[m>>1]|0;o=d+68|0;p=c[o>>2]|0;c[o>>2]=h;h=Kc(d,e,f)|0;if(!h){c[o>>2]=p;return h|0}f=d+28|0;e=(c[f>>2]|0)+g|0;fd(d,e);switch(h|0){case 4:{g=c[(c[d+12>>2]|0)+180>>2]|0;c[e>>2]=g;q=(a[g+4>>0]|64)&255;break}case 6:{g=Ae(d,6588,23)|0;c[e>>2]=g;q=(a[g+4>>0]|64)&255;break}default:{g=c[d+8>>2]|0;r=g+-16|0;s=c[r+4>>2]|0;t=e;c[t>>2]=c[r>>2];c[t+4>>2]=s;q=c[g+-8>>2]|0}}c[e+8>>2]=q;q=e+16|0;c[d+8>>2]=q;c[i>>2]=j;a[k>>0]=l;b[m>>1]=n;if(!j)u=q;else{n=j;j=q;while(1){q=c[n+4>>2]|0;m=j>>>0<q>>>0?q:j;n=c[n+8>>2]|0;if(!n){u=m;break}else j=m}}j=u-(c[f>>2]|0)|0;f=j>>4;u=f+11+((f+1|0)/8|0)|0;f=(u|0)<1e6?u:1e6;if((j|0)>15999984){c[o>>2]=p;return h|0}if((f|0)>=(c[d+32>>2]|0)){c[o>>2]=p;return h|0}Lc(d,f);c[o>>2]=p;return h|0}function Yc(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;g=Pa;Pa=Pa+64|0;h=g;i=a+36|0;b[i>>1]=(b[i>>1]|0)+1<<16>>16;c[h>>2]=d;c[h+56>>2]=e;c[h+52>>2]=f;f=h+16|0;c[f>>2]=0;e=h+24|0;c[e>>2]=0;d=h+28|0;c[d>>2]=0;j=h+36|0;c[j>>2]=0;k=h+40|0;c[k>>2]=0;l=h+48|0;c[l>>2]=0;m=h+4|0;c[m>>2]=0;n=h+12|0;c[n>>2]=0;o=Xc(a,133,h,(c[a+8>>2]|0)-(c[a+28>>2]|0)|0,c[a+68>>2]|0)|0;h=Hd(a,c[m>>2]|0,c[n>>2]|0,0)|0;c[m>>2]=h;c[n>>2]=0;Hd(a,c[f>>2]|0,c[e>>2]<<1,0)|0;Hd(a,c[d>>2]|0,c[j>>2]<<4,0)|0;Hd(a,c[k>>2]|0,c[l>>2]<<4,0)|0;b[i>>1]=(b[i>>1]|0)+-1<<16>>16;Pa=g;return o|0}function Zc(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;f=Pa;Pa=Pa+16|0;g=f+8|0;h=f;i=c[e>>2]|0;j=c[i>>2]|0;c[i>>2]=j+-1;if(!j)k=jf(i)|0;else{j=i+4|0;i=c[j>>2]|0;c[j>>2]=i+1;k=d[i>>0]|0}i=c[e+52>>2]|0;j=(i|0)==0;if((k|0)==27){if(!j?(rm(i,98)|0)==0:0){c[h>>2]=6776;c[h+4>>2]=i;Pd(b,6734,h)|0;Jc(b,3)}l=Te(b,c[e>>2]|0,e+4|0,c[e+56>>2]|0)|0}else{if(!j?(rm(i,116)|0)==0:0){c[g>>2]=6783;c[g+4>>2]=i;Pd(b,6734,g)|0;Jc(b,3)}l=Rd(b,c[e>>2]|0,e+4|0,e+16|0,c[e+56>>2]|0,k)|0}k=l+6|0;if(!(a[k>>0]|0)){Pa=f;return}e=l+16|0;g=l+5|0;i=0;do{j=cd(b)|0;c[e+(i<<2)>>2]=j;if(a[j+5>>0]&3?a[g>>0]&4:0)jd(b,l,j);i=i+1|0}while(i>>>0<(d[k>>0]|0)>>>0);Pa=f;return}function _c(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0;g=Pa;Pa=Pa+48|0;h=g;i=g+20|0;c[i>>2]=a;c[i+4>>2]=d;c[i+8>>2]=e;c[i+12>>2]=f;f=i+16|0;Xe(h);j=Wa[d&255](a,h,18,e)|0;c[f>>2]=j;$c(b,i);Pa=g;return c[f>>2]|0}function $c(b,d){b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=c[b+64>>2];h=d+16|0;i=c[h>>2]|0;if(!i){j=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=j;k=j}else k=i;c[f>>2]=c[b+68>>2];if(!k){i=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=i;l=i}else l=k;a[f>>0]=a[b+76>>0]|0;if(!l){k=Wa[c[d+4>>2]&255](c[d>>2]|0,f,1,c[d+8>>2]|0)|0;c[h>>2]=k;m=k}else m=l;a[f>>0]=a[b+77>>0]|0;if(!m){l=Wa[c[d+4>>2]&255](c[d>>2]|0,f,1,c[d+8>>2]|0)|0;c[h>>2]=l;n=l}else n=m;a[f>>0]=a[b+78>>0]|0;if(!n){m=Wa[c[d+4>>2]&255](c[d>>2]|0,f,1,c[d+8>>2]|0)|0;c[h>>2]=m;o=m}else o=n;n=c[b+12>>2]|0;m=c[b+48>>2]|0;c[f>>2]=m;if(!o){l=d+4|0;k=d+8|0;i=Wa[c[l>>2]&255](c[d>>2]|0,f,4,c[k>>2]|0)|0;c[h>>2]=i;if(!i){j=Wa[c[l>>2]&255](c[d>>2]|0,n,m<<2,c[k>>2]|0)|0;c[h>>2]=j;m=c[b+44>>2]|0;c[f>>2]=m;if(!j){n=Wa[c[l>>2]&255](c[d>>2]|0,f,4,c[k>>2]|0)|0;c[h>>2]=n;p=n;q=f;r=m}else{p=j;q=f;r=m}}else{s=i;t=14}}else{s=o;t=14}if((t|0)==14){t=c[b+44>>2]|0;c[f>>2]=t;p=s;q=f;r=t}a:do if((r|0)>0){t=b+8|0;q=d+4|0;s=d+8|0;o=0;i=p;while(1){m=c[t>>2]|0;j=m+(o<<4)|0;n=m+(o<<4)+8|0;m=c[n>>2]|0;a[f>>0]=m&15;if(!i){k=Wa[c[q>>2]&255](c[d>>2]|0,f,1,c[s>>2]|0)|0;c[h>>2]=k;u=c[n>>2]|0;v=k}else{u=m;v=i}b:do switch(u&15){case 4:{m=c[j>>2]|0;if(!m){c[f>>2]=0;if(!v){k=Wa[c[q>>2]&255](c[d>>2]|0,f,4,c[s>>2]|0)|0;c[h>>2]=k;w=k}else w=v;x=w;break b}c[f>>2]=(c[m+12>>2]|0)+1;if(!v){k=Wa[c[q>>2]&255](c[d>>2]|0,f,4,c[s>>2]|0)|0;c[h>>2]=k;if(!k){n=Wa[c[q>>2]&255](c[d>>2]|0,m+16|0,c[f>>2]|0,c[s>>2]|0)|0;c[h>>2]=n;y=n}else y=k}else y=v;x=y;break}case 1:{a[f>>0]=c[j>>2];if(!v){k=Wa[c[q>>2]&255](c[d>>2]|0,f,1,c[s>>2]|0)|0;c[h>>2]=k;z=k}else z=v;x=z;break}case 3:{g[f>>3]=+g[j>>3];if(!v){k=Wa[c[q>>2]&255](c[d>>2]|0,f,8,c[s>>2]|0)|0;c[h>>2]=k;A=k}else A=v;x=A;break}default:x=v}while(0);o=o+1|0;if((o|0)==(r|0)){B=x;break a}else i=x}}else B=p;while(0);p=c[b+56>>2]|0;c[f>>2]=p;if(!B){x=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=x;C=x}else C=B;if((p|0)>0){B=b+16|0;x=0;do{$c(c[(c[B>>2]|0)+(x<<2)>>2]|0,d);x=x+1|0}while((x|0)!=(p|0));D=c[h>>2]|0}else D=C;C=b+40|0;p=c[C>>2]|0;c[f>>2]=p;if(!D){x=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=x;E=x}else E=D;if((p|0)>0){D=b+28|0;x=d+4|0;B=d+8|0;r=0;v=E;while(1){A=c[D>>2]|0;a[f>>0]=a[A+(r<<3)+4>>0]|0;if(!v){z=Wa[c[x>>2]&255](c[d>>2]|0,f,1,c[B>>2]|0)|0;c[h>>2]=z;F=c[D>>2]|0;G=z}else{F=A;G=v}a[f>>0]=a[F+(r<<3)+5>>0]|0;if(!G){A=Wa[c[x>>2]&255](c[d>>2]|0,f,1,c[B>>2]|0)|0;c[h>>2]=A;H=A}else H=G;r=r+1|0;if((r|0)==(p|0)){I=H;break}else v=H}}else I=E;E=d+12|0;if((c[E>>2]|0)==0?(H=c[b+36>>2]|0,(H|0)!=0):0){c[f>>2]=(c[H+12>>2]|0)+1;if(!I){v=d+4|0;p=d+8|0;r=Wa[c[v>>2]&255](c[d>>2]|0,f,4,c[p>>2]|0)|0;c[h>>2]=r;if(!r){G=Wa[c[v>>2]&255](c[d>>2]|0,H+16|0,c[f>>2]|0,c[p>>2]|0)|0;c[h>>2]=G;J=G}else J=r}else J=I;K=J}else{c[f>>2]=0;if(!I){J=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=J;L=J}else L=I;K=L}if(!(c[E>>2]|0))M=c[b+52>>2]|0;else M=0;L=c[b+20>>2]|0;c[f>>2]=M;if(!K){I=d+4|0;J=d+8|0;r=Wa[c[I>>2]&255](c[d>>2]|0,f,4,c[J>>2]|0)|0;c[h>>2]=r;if(!r){G=Wa[c[I>>2]&255](c[d>>2]|0,L,M<<2,c[J>>2]|0)|0;c[h>>2]=G;N=G}else N=r}else N=K;if(!(c[E>>2]|0))O=c[b+60>>2]|0;else O=0;c[f>>2]=O;if(!N){K=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=K;P=K}else P=N;if((O|0)>0){N=b+24|0;K=d+4|0;r=d+8|0;G=0;J=P;while(1){M=c[(c[N>>2]|0)+(G*12|0)>>2]|0;if(!M){c[f>>2]=0;if(!J){L=Wa[c[K>>2]&255](c[d>>2]|0,f,4,c[r>>2]|0)|0;c[h>>2]=L;Q=L}else Q=J;R=Q}else{c[f>>2]=(c[M+12>>2]|0)+1;do if(!J){L=Wa[c[K>>2]&255](c[d>>2]|0,f,4,c[r>>2]|0)|0;c[h>>2]=L;if(L|0){S=L;break}L=Wa[c[K>>2]&255](c[d>>2]|0,M+16|0,c[f>>2]|0,c[r>>2]|0)|0;c[h>>2]=L;S=L}else S=J;while(0);R=S}M=c[N>>2]|0;c[f>>2]=c[M+(G*12|0)+4>>2];if(!R){L=Wa[c[K>>2]&255](c[d>>2]|0,f,4,c[r>>2]|0)|0;c[h>>2]=L;T=c[N>>2]|0;U=L}else{T=M;U=R}c[f>>2]=c[T+(G*12|0)+8>>2];if(!U){M=Wa[c[K>>2]&255](c[d>>2]|0,f,4,c[r>>2]|0)|0;c[h>>2]=M;V=M}else V=U;G=G+1|0;if((G|0)==(O|0)){W=V;break}else J=V}}else W=P;if(!(c[E>>2]|0))X=c[C>>2]|0;else X=0;c[f>>2]=X;if(!W){C=Wa[c[d+4>>2]&255](c[d>>2]|0,f,4,c[d+8>>2]|0)|0;c[h>>2]=C;Y=C}else Y=W;if((X|0)<=0){Pa=e;return}W=b+28|0;b=d+4|0;C=d+8|0;E=0;P=Y;while(1){Y=c[(c[W>>2]|0)+(E<<3)>>2]|0;if(!Y){c[f>>2]=0;if(!P){V=Wa[c[b>>2]&255](c[d>>2]|0,f,4,c[C>>2]|0)|0;c[h>>2]=V;Z=V}else Z=P;_=Z}else{c[f>>2]=(c[Y+12>>2]|0)+1;do if(!P){V=Wa[c[b>>2]&255](c[d>>2]|0,f,4,c[C>>2]|0)|0;c[h>>2]=V;if(V|0){$=V;break}V=Wa[c[b>>2]&255](c[d>>2]|0,Y+16|0,c[f>>2]|0,c[C>>2]|0)|0;c[h>>2]=V;$=V}else $=P;while(0);_=$}E=E+1|0;if((E|0)==(X|0))break;else P=_}Pa=e;return}function ad(b,c){b=b|0;c=c|0;var d=0;d=od(b,38,(c<<4)+16|0,0,0)|0;a[d+6>>0]=c;return d|0}function bd(b,d){b=b|0;d=d|0;var e=0,f=0;e=d<<2;f=od(b,6,e+16|0,0,0)|0;c[f+12>>2]=0;a[f+6>>0]=d;if(!d)return f|0;Vn(f+16|0,0,e|0)|0;return f|0}function cd(a){a=a|0;var b=0;b=od(a,10,32,0,0)|0;c[b+8>>2]=b+16;c[b+24>>2]=0;return b|0}function dd(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=c[b+12>>2]|0;f=b+56|0;g=c[f>>2]|0;a:do if(!g)h=f;else{i=f;j=g;while(1){k=c[j+8>>2]|0;if(k>>>0<d>>>0){h=i;break a}if((k|0)==(d|0))break;k=c[j>>2]|0;if(!k){h=j;break a}else{l=j;j=k;i=l}}i=j+5|0;l=a[i>>0]^3;if(((a[e+60>>0]^3)&l)<<24>>24){m=j;return m|0}a[i>>0]=l;m=j;return m|0}while(0);g=od(b,10,32,h,0)|0;c[g+8>>2]=d;d=g+16|0;c[d>>2]=e+112;h=e+128+4|0;e=c[h>>2]|0;c[d+4>>2]=e;c[e+16>>2]=g;c[h>>2]=g;m=g;return m|0}function ed(a,b){a=a|0;b=b|0;var d=0,e=0;if((c[b+8>>2]|0)==(b+16|0)){Hd(a,b,32,0)|0;return}d=b+16|0;e=d+4|0;c[(c[e>>2]|0)+16>>2]=c[d>>2];c[(c[d>>2]|0)+16+4>>2]=c[e>>2];Hd(a,b,32,0)|0;return}function fd(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;e=c[b+12>>2]|0;f=b+56|0;g=c[f>>2]|0;if(!g)return;h=e+60|0;i=e+68|0;j=g;while(1){g=j+8|0;k=c[g>>2]|0;if(k>>>0<d>>>0){l=10;break}c[f>>2]=c[j>>2];if(!(((a[h>>0]^3)&(a[j+5>>0]^3))<<24>>24)){if((k|0)!=(j+16|0)){k=j+16|0;m=k+4|0;c[(c[m>>2]|0)+16>>2]=c[k>>2];c[(c[k>>2]|0)+16+4>>2]=c[m>>2]}Hd(b,j,32,0)|0}else{m=j+16|0;k=m+4|0;c[(c[k>>2]|0)+16>>2]=c[m>>2];c[(c[m>>2]|0)+16+4>>2]=c[k>>2];k=c[g>>2]|0;m=j+16|0;n=k;o=c[n+4>>2]|0;p=m;c[p>>2]=c[n>>2];c[p+4>>2]=o;c[j+24>>2]=c[k+8>>2];c[g>>2]=m;c[j>>2]=c[i>>2];c[i>>2]=j;nd(e,j)}j=c[f>>2]|0;if(!j){l=10;break}}if((l|0)==10)return}function gd(b){b=b|0;var d=0;d=od(b,9,80,0,0)|0;c[d+8>>2]=0;c[d+44>>2]=0;c[d+16>>2]=0;c[d+56>>2]=0;c[d+12>>2]=0;c[d+32>>2]=0;c[d+48>>2]=0;c[d+20>>2]=0;c[d+52>>2]=0;c[d+28>>2]=0;c[d+40>>2]=0;a[d+76>>0]=0;a[d+77>>0]=0;a[d+78>>0]=0;c[d+24>>2]=0;c[d+60>>2]=0;c[d+64>>2]=0;c[d+68>>2]=0;c[d+36>>2]=0;return d|0}function hd(a,b){a=a|0;b=b|0;Hd(a,c[b+12>>2]|0,c[b+48>>2]<<2,0)|0;Hd(a,c[b+16>>2]|0,c[b+56>>2]<<2,0)|0;Hd(a,c[b+8>>2]|0,c[b+44>>2]<<4,0)|0;Hd(a,c[b+20>>2]|0,c[b+52>>2]<<2,0)|0;Hd(a,c[b+24>>2]|0,(c[b+60>>2]|0)*12|0,0)|0;Hd(a,c[b+28>>2]|0,c[b+40>>2]<<3,0)|0;Hd(a,b,80,0)|0;return}function id(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=c[a+60>>2]|0;if((e|0)<=0){f=0;return f|0}g=c[a+24>>2]|0;a=b;b=0;while(1){if((c[g+(b*12|0)+4>>2]|0)>(d|0)){f=0;h=8;break}if((c[g+(b*12|0)+8>>2]|0)>(d|0)){i=a+-1|0;if(!i){h=6;break}else j=i}else j=a;i=b+1|0;if((i|0)<(e|0)){a=j;b=i}else{f=0;h=8;break}}if((h|0)==6){f=(c[g+(b*12|0)>>2]|0)+16|0;return f|0}else if((h|0)==8)return f|0;return 0}function jd(b,e,f){b=b|0;e=e|0;f=f|0;var g=0;g=c[b+12>>2]|0;if((d[g+61>>0]|0)<2){kd(g,f);return}else{f=e+5|0;a[f>>0]=a[g+60>>0]&3|a[f>>0]&-72;return}}function kd(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=d+5|0;a[e>>0]=a[e>>0]&-4;switch(a[d+4>>0]|0){case 20:case 4:{f=(c[d+12>>2]|0)+17|0;break}case 7:{g=c[d+8>>2]|0;if(g|0?a[g+5>>0]&3:0)kd(b,g);g=c[d+12>>2]|0;if(g|0?a[g+5>>0]&3:0)kd(b,g);f=(c[d+16>>2]|0)+24|0;break}case 10:{g=d+8|0;h=c[g>>2]|0;if((c[h+8>>2]&64|0)!=0?(i=c[h>>2]|0,(a[i+5>>0]&3)!=0):0){kd(b,i);j=c[g>>2]|0}else j=h;if((j|0)==(d+16|0))f=32;else return;break}case 6:{j=b+84|0;c[d+8>>2]=c[j>>2];c[j>>2]=d;return}case 38:{j=b+84|0;c[d+8>>2]=c[j>>2];c[j>>2]=d;return}case 5:{j=b+84|0;c[d+24>>2]=c[j>>2];c[j>>2]=d;return}case 8:{j=b+84|0;c[d+60>>2]=c[j>>2];c[j>>2]=d;return}case 9:{j=b+84|0;c[d+72>>2]=c[j>>2];c[j>>2]=d;return}default:return}a[e>>0]=a[e>>0]|4;e=b+16|0;c[e>>2]=(c[e>>2]|0)+f;return}function ld(b,d){b=b|0;d=d|0;var e=0;e=c[b+12>>2]|0;b=d+5|0;a[b>>0]=a[b>>0]&-5;b=e+88|0;c[d+24>>2]=c[b>>2];c[b>>2]=d;return}function md(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0;if(c[e+32>>2]|0){g=c[b+12>>2]|0;h=e+5|0;a[h>>0]=a[h>>0]&-5;h=g+88|0;c[e+72>>2]=c[h>>2];c[h>>2]=e;return}if(!(a[f+5>>0]&3))return;h=e+5|0;e=a[h>>0]|0;if(!(e&4))return;g=c[b+12>>2]|0;if((d[g+61>>0]|0)<2){kd(g,f);return}else{a[h>>0]=a[g+60>>0]&3|e&-72;return}}function nd(b,e){b=b|0;e=e|0;var f=0,g=0,h=0;f=e+5|0;g=a[f>>0]|0;h=g&255;if(h&7|0)return;if((a[b+62>>0]|0)!=2?(d[b+61>>0]|0)>=2:0){a[f>>0]=h&184|a[b+60>>0]&3;return}a[f>>0]=g&-69|4;g=c[e+8>>2]|0;if(!(c[g+8>>2]&64))return;e=c[g>>2]|0;if(!(a[e+5>>0]&3))return;kd(b,e);return}function od(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0;h=c[b+12>>2]|0;i=(Hd(b,0,d&15,e)|0)+g|0;g=(f|0)==0?h+68|0:f;a[i+5>>0]=a[h+60>>0]&3;a[i+4>>0]=d;c[i>>2]=c[g>>2];c[g>>2]=i;return i|0}function pd(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0;g=c[b+12>>2]|0;h=e+5|0;if((f|0)==0|(a[h>>0]&24)!=0)return;if(a[f+6>>0]&4)return;if(!(Re(f,2,c[g+192>>2]|0)|0))return;f=g+76|0;i=c[f>>2]|0;if((i|0)==(e|0)){do j=qd(b,i,1)|0;while((j|0)==(i|0));c[f>>2]=j}j=g+68|0;while(1){f=c[j>>2]|0;if((f|0)==(e|0))break;else j=f}c[j>>2]=c[e>>2];j=g+72|0;c[e>>2]=c[j>>2];c[j>>2]=e;e=a[h>>0]|16;a[h>>0]=e;j=e&255;if((d[g+61>>0]|0)<2)k=j&191;else k=j&184|a[g+60>>0]&3;a[h>>0]=k;return}function qd(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;g=b+12|0;h=c[g>>2]|0;i=d[h+60>>0]|0;j=i^3;k=(a[h+62>>0]|0)==2;h=k?255:184;l=k?64:i&3;i=k?64:0;k=c[e>>2]|0;if(!k){m=0;return m|0}n=e;e=f;f=k;a:while(1){if(!e){m=n;o=23;break}e=e+-1|0;k=f+5|0;p=d[k>>0]|0;b:do if(!((p^3)&j)){q=c[f>>2]|0;c[n>>2]=q;switch(a[f+4>>0]|0){case 9:{hd(b,f);r=n;o=21;break b;break}case 6:{Hd(b,f,(d[f+6>>0]<<2)+16|0,0)|0;r=n;o=21;break b;break}case 38:{Hd(b,f,(d[f+6>>0]<<4)+16|0,0)|0;r=n;o=21;break b;break}case 10:{ed(b,f);r=n;o=21;break b;break}case 5:{Me(b,f);r=n;o=21;break b;break}case 8:{re(b,f);r=n;o=21;break b;break}case 7:{Hd(b,f,(c[f+16>>2]|0)+24|0,0)|0;r=n;o=21;break b;break}case 4:{s=(c[g>>2]|0)+28|0;c[s>>2]=(c[s>>2]|0)+-1;break}case 20:break;default:{t=n;u=q;break b}}Hd(b,f,(c[f+12>>2]|0)+17|0,0)|0;r=n;o=21}else{if(i&p|0){m=0;o=23;break a}if(((a[f+4>>0]|0)==8?c[f+28>>2]|0:0)?(qd(b,f+56|0,-3)|0,pe(f),(a[(c[g>>2]|0)+62>>0]|0)!=1):0)Nc(f);a[k>>0]=h&p|l;r=f;o=21}while(0);if((o|0)==21){o=0;t=r;u=c[r>>2]|0}if(!u){m=0;o=23;break}else{n=t;f=u}}if((o|0)==23)return m|0;return 0}function rd(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;f=b+12|0;g=c[f>>2]|0;h=g+62|0;if((d[h>>0]|0)==(e|0))return;if((e|0)==2){e=g+61|0;if(a[e>>0]|0)do sd(b)|0;while((a[e>>0]|0)!=0);c[g+20>>2]=(c[g+12>>2]|0)+(c[g+8>>2]|0);a[h>>0]=2;return}a[h>>0]=0;a[g+61>>0]=2;c[g+64>>2]=0;h=g+72|0;do i=qd(b,h,1)|0;while((i|0)==(h|0));c[g+80>>2]=i;i=g+68|0;do j=qd(b,i,1)|0;while((j|0)==(i|0));c[g+76>>2]=j;j=(c[f>>2]|0)+61|0;if(1<<d[j>>0]&-29|0)return;do sd(b)|0;while(!(1<<d[j>>0]&-29|0));return}function sd(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;e=Pa;Pa=Pa+16|0;f=e;g=b+12|0;h=c[g>>2]|0;i=h+61|0;switch(a[i>>0]|0){case 5:{j=h+16|0;c[j>>2]=c[h+32>>2]<<2;k=h+84|0;c[k>>2]=0;c[k+4>>2]=0;c[k+8>>2]=0;c[k+12>>2]=0;c[k+16>>2]=0;k=c[h+172>>2]|0;if(k|0?a[k+5>>0]&3:0)kd(h,k);if(c[h+48>>2]&64|0?(k=c[h+40>>2]|0,a[k+5>>0]&3):0)kd(h,k);td(h);k=c[h+104>>2]|0;if(k|0){l=h+60|0;m=k;do{k=m+5|0;a[k>>0]=a[l>>0]&3|a[k>>0]&-72;kd(h,m);m=c[m>>2]|0}while((m|0)!=0)}a[i>>0]=0;n=c[j>>2]|0;Pa=e;return n|0}case 0:{j=h+84|0;if(c[j>>2]|0){m=h+16|0;l=c[m>>2]|0;ud(h);n=(c[m>>2]|0)-l|0;Pa=e;return n|0}a[i>>0]=1;l=h+16|0;m=c[l>>2]|0;k=h+20|0;c[k>>2]=m;if(a[b+5>>0]&3)kd(h,b);if(c[h+48>>2]&64|0?(o=c[h+40>>2]|0,a[o+5>>0]&3):0)kd(h,o);td(h);o=h+112|0;p=c[h+128+4>>2]|0;if((p|0)!=(o|0)){q=p;do{if(((a[q+5>>0]&7)==0?(p=c[q+8>>2]|0,c[p+8>>2]&64|0):0)?(r=c[p>>2]|0,a[r+5>>0]&3):0)kd(h,r);q=c[q+16+4>>2]|0}while((q|0)!=(o|0))}if(c[j>>2]|0)do ud(h);while((c[j>>2]|0)!=0);o=(c[l>>2]|0)-m|0;m=h+92|0;q=c[m>>2]|0;r=h+88|0;p=c[r>>2]|0;s=h+96|0;t=c[s>>2]|0;c[s>>2]=0;c[r>>2]=0;c[m>>2]=0;c[j>>2]=p;if(p|0)do ud(h);while((c[j>>2]|0)!=0);c[j>>2]=q;if(q|0)do ud(h);while((c[j>>2]|0)!=0);c[j>>2]=t;if(t|0)do ud(h);while((c[j>>2]|0)!=0);t=o-(c[l>>2]|0)|0;do{o=c[s>>2]|0;c[s>>2]=0;if(!o)break;q=0;p=o;while(1){o=p;p=c[p+24>>2]|0;if(vd(h,o)|0)if(!(c[j>>2]|0))u=1;else{do ud(h);while((c[j>>2]|0)!=0);u=1}else u=q;if(!p)break;else q=u}}while((u|0)!=0);wd(h,c[m>>2]|0,0);u=h+100|0;wd(h,c[u>>2]|0,0);q=c[m>>2]|0;p=c[u>>2]|0;o=c[l>>2]|0;r=c[g>>2]|0;v=r+104|0;while(1){w=c[v>>2]|0;if(!w)break;else v=w}w=t+o|0;o=r+72|0;r=c[o>>2]|0;if(r|0){t=o;o=v;v=r;while(1){r=v+5|0;x=d[r>>0]|0;if(!(x&3)){y=v;z=o}else{a[r>>0]=x|8;c[t>>2]=c[v>>2];c[v>>2]=c[o>>2];c[o>>2]=v;y=t;z=v}v=c[y>>2]|0;if(!v)break;else{t=y;o=z}}}z=c[h+104>>2]|0;if(z|0){o=h+60|0;y=z;do{z=y+5|0;a[z>>0]=a[o>>0]&3|a[z>>0]&-72;kd(h,y);y=c[y>>2]|0}while((y|0)!=0)}if(c[j>>2]|0)do ud(h);while((c[j>>2]|0)!=0);y=w-(c[l>>2]|0)|0;while(1){w=c[s>>2]|0;c[s>>2]=0;if(!w)break;o=0;z=w;while(1){w=z;z=c[z+24>>2]|0;if(vd(h,w)|0)if(!(c[j>>2]|0))A=1;else{do ud(h);while((c[j>>2]|0)!=0);A=1}else A=o;if(!z)break;else o=A}if(!A){B=70;break}}if((B|0)==70?(A=c[s>>2]|0,A|0):0){s=A;do{A=c[s+16>>2]|0;j=a[s+7>>0]|0;o=A+(1<<(j&255)<<5)|0;if(j<<24>>24!=31){j=A;do{A=j+8|0;do if(c[A>>2]|0){z=j+24|0;w=c[z>>2]|0;if(!(w&64))break;t=c[j+16>>2]|0;if((w&15|0)==4){if(!t)break;if(!(a[t+5>>0]&3))break;kd(h,t);break}else{w=t+5|0;if(!(a[w>>0]&3))break;c[A>>2]=0;if(!(a[w>>0]&3))break;c[z>>2]=11;break}}while(0);j=j+32|0}while(j>>>0<o>>>0)}s=c[s+24>>2]|0}while((s|0)!=0)}s=c[u>>2]|0;if(s|0){o=s;do{s=c[o+16>>2]|0;j=a[o+7>>0]|0;A=s+(1<<(j&255)<<5)|0;if(j<<24>>24!=31){j=s;do{s=j+8|0;do if(c[s>>2]|0){z=j+24|0;w=c[z>>2]|0;if(!(w&64))break;t=c[j+16>>2]|0;if((w&15|0)==4){if(!t)break;if(!(a[t+5>>0]&3))break;kd(h,t);break}else{w=t+5|0;if(!(a[w>>0]&3))break;c[s>>2]=0;if(!(a[w>>0]&3))break;c[z>>2]=11;break}}while(0);j=j+32|0}while(j>>>0<A>>>0)}o=c[o+24>>2]|0}while((o|0)!=0)}wd(h,c[m>>2]|0,q);wd(h,c[u>>2]|0,p);p=h+60|0;a[p>>0]=a[p>>0]^3;p=y+(c[l>>2]|0)|0;c[k>>2]=(c[k>>2]|0)+p;k=c[g>>2]|0;a[k+61>>0]=2;c[k+64>>2]=0;l=k+72|0;y=0;do{y=y+1|0;C=qd(b,l,1)|0}while((C|0)==(l|0));c[k+80>>2]=C;C=k+68|0;l=0;do{l=l+1|0;D=qd(b,C,1)|0}while((D|0)==(C|0));c[k+76>>2]=D;n=((l+y|0)*5|0)+p|0;Pa=e;return n|0}case 2:{p=h+64|0;y=h+32|0;l=h+24|0;D=0;while(1){k=(c[p>>2]|0)+D|0;C=c[y>>2]|0;if((k|0)>=(C|0)){E=D;F=k;G=C;break}qd(b,(c[l>>2]|0)+(k<<2)|0,-3)|0;D=D+1|0;if(D>>>0>=80){B=108;break}}if((B|0)==108){E=80;F=(c[p>>2]|0)+D|0;G=c[y>>2]|0}c[p>>2]=F;if((F|0)>=(G|0))a[i>>0]=3;n=E*5|0;Pa=e;return n|0}case 3:{E=h+80|0;G=c[E>>2]|0;if(!G){a[i>>0]=4;n=0;Pa=e;return n|0}else{F=qd(b,G,80)|0;c[E>>2]=F;n=400;Pa=e;return n|0}break}case 4:{F=h+76|0;E=c[F>>2]|0;if(E|0){G=qd(b,E,80)|0;c[F>>2]=G;n=400;Pa=e;return n|0}c[f>>2]=c[h+172>>2];qd(b,f,1)|0;f=c[g>>2]|0;if((a[f+62>>0]|0)!=1){g=(c[f+32>>2]|0)/2|0;if((c[f+28>>2]|0)>>>0<g>>>0)ze(b,g);g=f+144|0;h=f+152|0;f=Hd(b,c[g>>2]|0,c[h>>2]|0,0)|0;c[g>>2]=f;c[h>>2]=0}a[i>>0]=5;n=5;Pa=e;return n|0}default:{n=0;Pa=e;return n|0}}return 0}function td(b){b=b|0;var d=0;d=c[b+252>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+256>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+260>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+264>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+268>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+272>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+276>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+280>>2]|0;if(d|0?a[d+5>>0]&3:0)kd(b,d);d=c[b+284>>2]|0;if(!d)return;if(!(a[d+5>>0]&3))return;kd(b,d);return}function ud(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0;e=b+84|0;f=c[e>>2]|0;g=f+5|0;a[g>>0]=a[g>>0]|4;switch(a[f+4>>0]|0){case 5:{h=f+24|0;c[e>>2]=c[h>>2];i=f+8|0;j=c[i>>2]|0;do if(j){if(!(a[j+6>>0]&8)){k=Re(j,3,c[b+196>>2]|0)|0;l=c[i>>2]|0;if(!l)m=k;else{n=k;o=l;p=5}}else{n=0;o=j;p=5}if((p|0)==5)if(!(a[o+5>>0]&3))m=n;else{kd(b,o);m=n}if(((m|0)!=0?(c[m+8>>2]&15|0)==4:0)?(l=(c[m>>2]|0)+16|0,k=rm(l,107)|0,q=(k|0)!=0,k=(rm(l,118)|0)!=0,q|k):0){a[g>>0]=a[g>>0]&-5;if(q)if(k){k=b+100|0;c[h>>2]=c[k>>2];c[k>>2]=f;break}else{vd(b,f)|0;break}k=c[f+16>>2]|0;q=a[f+7>>0]|0;l=k+(1<<(q&255)<<5)|0;r=(c[f+28>>2]|0)>0&1;if(q<<24>>24==31)s=r;else{q=k;k=r;while(1){r=q+8|0;t=q+24|0;u=(c[t>>2]&64|0)==0;a:do if(!(c[r>>2]|0))if(!u?(a[(c[q+16>>2]|0)+5>>0]&3)!=0:0){c[t>>2]=11;v=k}else v=k;else{if(!u?(w=c[q+16>>2]|0,a[w+5>>0]&3):0)kd(b,w);if(!k){w=c[r>>2]|0;do if(w&64|0){x=c[q>>2]|0;if((w&15|0)!=4)if(!(a[x+5>>0]&3))break;else{v=1;break a}if(x|0?a[x+5>>0]&3:0)kd(b,x)}while(0);v=0}else v=k}while(0);q=q+32|0;if(q>>>0>=l>>>0){s=v;break}else k=v}}if(!s){k=b+88|0;c[h>>2]=c[k>>2];c[k>>2]=f;break}else{k=b+92|0;c[h>>2]=c[k>>2];c[k>>2]=f;break}}else p=35}else p=35;while(0);if((p|0)==35){p=f+16|0;h=c[p>>2]|0;s=h+(1<<d[f+7>>0]<<5)|0;v=f+28|0;m=c[v>>2]|0;if((m|0)>0){n=f+12|0;o=0;j=m;while(1){m=c[n>>2]|0;if((c[m+(o<<4)+8>>2]&64|0)!=0?(i=c[m+(o<<4)>>2]|0,(a[i+5>>0]&3)!=0):0){kd(b,i);y=c[v>>2]|0}else y=j;o=o+1|0;if((o|0)>=(y|0))break;else j=y}z=c[p>>2]|0}else z=h;if(z>>>0<s>>>0){h=z;do{z=h+8|0;p=c[z>>2]|0;y=h+24|0;j=(c[y>>2]&64|0)==0;if(!p){if(!j?a[(c[h+16>>2]|0)+5>>0]&3:0)c[y>>2]=11}else{if(!j?(j=c[h+16>>2]|0,(a[j+5>>0]&3)!=0):0){kd(b,j);A=c[z>>2]|0}else A=p;if(A&64|0?(p=c[h>>2]|0,a[p+5>>0]&3):0)kd(b,p)}h=h+32|0}while(h>>>0<s>>>0)}}B=(c[f+28>>2]<<4)+32+(32<<d[f+7>>0])|0;break}case 6:{c[e>>2]=c[f+8>>2];s=c[f+12>>2]|0;if(s|0?a[s+5>>0]&3:0)kd(b,s);s=f+6|0;h=a[s>>0]|0;if(!(h<<24>>24))B=16;else{A=0;p=h;while(1){h=c[f+16+(A<<2)>>2]|0;if((h|0)!=0?(a[h+5>>0]&3)!=0:0){kd(b,h);C=a[s>>0]|0}else C=p;A=A+1|0;D=C&255;if(A>>>0>=D>>>0)break;else p=C}B=(D<<2)+16|0}break}case 38:{c[e>>2]=c[f+8>>2];D=f+6|0;C=a[D>>0]|0;if(!(C<<24>>24))B=16;else{p=0;A=C;while(1){if((c[f+16+(p<<4)+8>>2]&64|0)!=0?(C=c[f+16+(p<<4)>>2]|0,(a[C+5>>0]&3)!=0):0){kd(b,C);E=a[D>>0]|0}else E=A;p=p+1|0;F=E&255;if(p>>>0>=F>>>0)break;else A=E}B=(F<<4)+16|0}break}case 8:{F=f+60|0;c[e>>2]=c[F>>2];E=b+88|0;c[F>>2]=c[E>>2];c[E>>2]=f;a[g>>0]=a[g>>0]&-5;g=f+28|0;E=c[g>>2]|0;if(!E)B=1;else{F=f+8|0;A=c[F>>2]|0;if(E>>>0<A>>>0){p=E;D=A;while(1){if((c[p+8>>2]&64|0)!=0?(A=c[p>>2]|0,(a[A+5>>0]&3)!=0):0){kd(b,A);G=c[F>>2]|0}else G=D;A=p+16|0;if(A>>>0<G>>>0){p=A;D=G}else{H=A;break}}}else H=E;if((a[b+61>>0]|0)==1){E=c[f+32>>2]|0;G=(c[g>>2]|0)+(E<<4)|0;if(H>>>0<G>>>0){g=H;do{c[g+8>>2]=0;g=g+16|0}while(g>>>0<G>>>0);I=E}else I=E}else I=c[f+32>>2]|0;B=(I<<4)+112|0}break}case 9:{c[e>>2]=c[f+72>>2];e=f+32|0;I=c[e>>2]|0;if(I|0?a[I+5>>0]&3:0)c[e>>2]=0;e=c[f+36>>2]|0;if(e|0?a[e+5>>0]&3:0)kd(b,e);e=f+44|0;I=c[e>>2]|0;if((I|0)>0){E=f+8|0;G=0;g=I;while(1){I=c[E>>2]|0;if((c[I+(G<<4)+8>>2]&64|0)!=0?(H=c[I+(G<<4)>>2]|0,(a[H+5>>0]&3)!=0):0){kd(b,H);J=c[e>>2]|0}else J=g;G=G+1|0;if((G|0)>=(J|0))break;else g=J}}J=f+40|0;g=c[J>>2]|0;if((g|0)>0){G=f+28|0;E=0;H=g;while(1){g=c[(c[G>>2]|0)+(E<<3)>>2]|0;if((g|0)!=0?(a[g+5>>0]&3)!=0:0){kd(b,g);K=c[J>>2]|0}else K=H;E=E+1|0;if((E|0)>=(K|0))break;else H=K}}K=f+56|0;H=c[K>>2]|0;if((H|0)>0){E=f+16|0;G=0;g=H;while(1){I=c[(c[E>>2]|0)+(G<<2)>>2]|0;if((I|0)!=0?(a[I+5>>0]&3)!=0:0){kd(b,I);L=c[K>>2]|0}else L=g;G=G+1|0;if((G|0)>=(L|0)){M=L;break}else g=L}}else M=H;H=f+60|0;L=c[H>>2]|0;if((L|0)>0){g=f+24|0;G=0;E=L;while(1){I=c[(c[g>>2]|0)+(G*12|0)>>2]|0;if((I|0)!=0?(a[I+5>>0]&3)!=0:0){kd(b,I);N=c[H>>2]|0}else N=E;G=G+1|0;if((G|0)>=(N|0))break;else E=N}O=N;P=c[K>>2]|0}else{O=L;P=M}B=(O*12|0)+80+(c[e>>2]<<4)+(c[J>>2]<<3)+((c[f+48>>2]|0)+P+(c[f+52>>2]|0)<<2)|0;break}default:return}f=b+16|0;c[f>>2]=(c[f>>2]|0)+B;return}function vd(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;f=e+16|0;g=c[f>>2]|0;h=g+(1<<(d[e+7>>0]|0)<<5)|0;i=e+28|0;j=c[i>>2]|0;if((j|0)>0){k=e+12|0;l=0;m=0;n=j;while(1){j=c[k>>2]|0;if((c[j+(m<<4)+8>>2]&64|0)!=0?(o=c[j+(m<<4)>>2]|0,(a[o+5>>0]&3)!=0):0){kd(b,o);p=1;q=c[i>>2]|0}else{p=l;q=n}m=m+1|0;if((m|0)>=(q|0))break;else{l=p;n=q}}r=p;s=c[f>>2]|0}else{r=0;s=g}if(s>>>0<h>>>0){g=s;s=0;f=0;p=r;while(1){q=g+8|0;n=c[q>>2]|0;l=g+24|0;m=c[l>>2]|0;i=(m&64|0)==0;a:do if(!n)if(!i?(a[(c[g+16>>2]|0)+5>>0]&3)!=0:0){c[l>>2]=11;t=s;u=f;v=p}else{t=s;u=f;v=p}else{do if(i){w=n;x=19}else{k=c[g+16>>2]|0;if((m&15|0)==4){if(!k){w=n;x=19;break}if(!(a[k+5>>0]&3)){w=n;x=19;break}kd(b,k);w=c[q>>2]|0;x=19;break}o=(n&64|0)==0;if(!(a[k+5>>0]&3))if(o){t=s;u=f;v=p;break a}else break;if(o){t=s;u=1;v=p;break a}t=(a[(c[g>>2]|0)+5>>0]&3)==0?s:1;u=1;v=p;break a}while(0);if((x|0)==19?(x=0,(w&64|0)==0):0){t=s;u=f;v=p;break}o=c[g>>2]|0;if(!(a[o+5>>0]&3)){t=s;u=f;v=p}else{kd(b,o);t=s;u=f;v=1}}while(0);g=g+32|0;if(g>>>0>=h>>>0)break;else{s=t;f=u;p=v}}if(t|0){t=b+96|0;c[e+24>>2]=c[t>>2];c[t>>2]=e;y=v;return y|0}if(!u)z=v;else{u=b+100|0;c[e+24>>2]=c[u>>2];c[u>>2]=e;y=v;return y|0}}else z=r;r=b+88|0;c[e+24>>2]=c[r>>2];c[r>>2]=e;y=z;return y|0}function wd(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;if((e|0)==(f|0))return;g=e;do{e=g+16|0;h=c[e>>2]|0;i=h+(1<<(d[g+7>>0]|0)<<5)|0;j=g+28|0;if((c[j>>2]|0)>0){k=g+12|0;l=0;do{m=c[k>>2]|0;if(xd(b,m+(l<<4)|0)|0)c[m+(l<<4)+8>>2]=0;l=l+1|0}while((l|0)<(c[j>>2]|0));n=c[e>>2]|0}else n=h;if(n>>>0<i>>>0){j=n;do{l=j+8|0;if(((c[l>>2]|0?xd(b,j)|0:0)?(c[l>>2]=0,l=j+24|0,c[l>>2]&64|0):0)?a[(c[j+16>>2]|0)+5>>0]&3:0)c[l>>2]=11;j=j+32|0}while(j>>>0<i>>>0)}g=c[g+24>>2]|0}while((g|0)!=(f|0));return}function xd(b,d){b=b|0;d=d|0;var e=0,f=0,g=0;e=c[d+8>>2]|0;if(!(e&64)){f=0;return f|0}g=c[d>>2]|0;if((e&15|0)!=4){f=a[g+5>>0]&3;return f|0}if(!g){f=0;return f|0}if(!(a[g+5>>0]&3)){f=0;return f|0}kd(b,g);f=0;return f|0}function yd(a,b){a=a|0;b=b|0;var e=0;e=(c[a+12>>2]|0)+61|0;if(1<<(d[e>>0]|0)&b|0)return;do sd(a)|0;while(!(1<<(d[e>>0]|0)&b|0));return}function zd(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;d=b+12|0;e=c[d>>2]|0;f=e+104|0;g=f;while(1){h=c[g>>2]|0;if(!h)break;else g=h}h=e+72|0;i=c[h>>2]|0;if(!i)j=f;else{f=g;g=i;while(1){i=g+5|0;a[i>>0]=a[i>>0]|8;c[h>>2]=c[g>>2];c[g>>2]=c[f>>2];c[f>>2]=g;i=c[h>>2]|0;if(!i)break;else{k=g;g=i;f=k}}j=(c[d>>2]|0)+104|0}d=c[j>>2]|0;if(d|0){f=d;do{d=f+5|0;a[d>>0]=a[d>>0]&-65;Ad(b,0);f=c[j>>2]|0}while((f|0)!=0)}a[e+60>>0]=3;a[e+62>>0]=0;qd(b,h,-3)|0;qd(b,e+68|0,-3)|0;h=e+32|0;if((c[h>>2]|0)<=0)return;f=e+24|0;e=0;do{qd(b,(c[f>>2]|0)+(e<<2)|0,-3)|0;e=e+1|0}while((e|0)<(c[h>>2]|0));return}function Ad(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;f=Pa;Pa=Pa+32|0;g=f+16|0;h=f;i=c[b+12>>2]|0;j=i+104|0;k=c[j>>2]|0;c[j>>2]=c[k>>2];j=i+68|0;c[k>>2]=c[j>>2];c[j>>2]=k;j=k+5|0;l=a[j>>0]|0;a[j>>0]=l&-17;if((d[i+61>>0]|0)>=2)a[j>>0]=a[i+60>>0]&3|l&-88;c[h>>2]=k;l=h+8|0;c[l>>2]=(a[k+4>>0]|64)&255;k=Se(b,h,2)|0;if(!k){Pa=f;return}j=k+8|0;if((c[j>>2]&15|0)!=6){Pa=f;return}m=b+41|0;n=a[m>>0]|0;o=i+63|0;i=a[o>>0]|0;a[m>>0]=0;a[o>>0]=0;p=b+8|0;q=c[p>>2]|0;r=k;k=c[r+4>>2]|0;s=q;c[s>>2]=c[r>>2];c[s+4>>2]=k;c[q+8>>2]=c[j>>2];j=c[p>>2]|0;q=h;h=c[q+4>>2]|0;k=j+16|0;c[k>>2]=c[q>>2];c[k+4>>2]=h;c[j+24>>2]=c[l>>2];l=c[p>>2]|0;c[p>>2]=l+32;j=Xc(b,134,0,l-(c[b+28>>2]|0)|0,0)|0;a[m>>0]=n;a[o>>0]=i;if(!((e|0)!=0&(j|0)!=0)){Pa=f;return}if((j|0)!=2){t=j;Jc(b,t)}j=c[p>>2]|0;if((c[j+-8>>2]&15|0)==4)u=(c[j+-16>>2]|0)+16|0;else u=6788;c[g>>2]=u;Pd(b,6799,g)|0;t=5;Jc(b,t)}function Bd(a,b){a=a|0;b=b|0;Rc(a,(c[a+8>>2]|0)+-32|0,0,0);return}function Cd(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;d=c[b+12>>2]|0;do if((a[d+62>>0]|0)==2){e=d+20|0;f=c[e>>2]|0;if(!f){Dd(b,0);g=(c[d+12>>2]|0)+(c[d+8>>2]|0)|0;h=g;i=d+61|0;j=g}else{g=d+61|0;if((a[g>>0]|0)!=5)do sd(b)|0;while((a[g>>0]|0)!=5);a[g>>0]=0;k=(c[d+12>>2]|0)+(c[d+8>>2]|0)|0;l=k>>>0>(H(c[d+160>>2]|0,(f>>>0)/100|0)|0)>>>0;h=k;i=g;j=l?0:f}c[e>>2]=j;l=(h|0)/100|0;k=c[d+156>>2]|0;m=H(k,0-l|0)|0;ne(d,((k|0)<(2147483644/(l|0)|0|0)?m:-2147483644)+h|0);n=i}else{m=d+12|0;l=c[d+164>>2]|0;k=(l|0)>40?l:40;l=((c[m>>2]|0)/200|0)+1|0;o=H(k,l)|0;p=d+61|0;q=(l|0)<(2147483644/(k>>>0)|0|0)?o:2147483644;do{q=q-(sd(b)|0)|0;r=(a[p>>0]|0)==5;if((q|0)<=-1600){s=12;break}}while(!r);if((s|0)==12?!r:0){ne(d,((q|0)/(k|0)|0)*200|0);n=p;break}e=(c[d+20>>2]|0)/100|0;f=c[d+156>>2]|0;g=H(f,0-e|0)|0;ne(d,(c[m>>2]|0)+(c[d+8>>2]|0)+((f|0)<(2147483644/(e|0)|0|0)?g:-2147483644)|0);n=p}while(0);r=d+104|0;if(!(c[r>>2]|0))return;d=0;while(1){if(d>>>0>=4?(a[n>>0]|0)!=5:0){s=20;break}Ad(b,1);if(!(c[r>>2]|0)){s=20;break}else d=d+1|0}if((s|0)==20)return}function Dd(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;f=b+12|0;g=c[f>>2]|0;h=g+62|0;i=a[h>>0]|0;j=(e|0)!=0;if(!j){a[h>>0]=0;e=g+104|0;k=c[e>>2]|0;if(k){l=k;do{k=l+5|0;a[k>>0]=a[k>>0]&-65;Ad(b,1);l=c[e>>2]|0}while((l|0)!=0);if((a[h>>0]|0)==2)m=8;else m=7}else m=7}else{a[h>>0]=1;m=7}if((m|0)==7?(d[g+61>>0]|0)<2:0)m=8;if((m|0)==8){m=c[f>>2]|0;a[m+61>>0]=2;c[m+64>>2]=0;l=m+72|0;do n=qd(b,l,1)|0;while((n|0)==(l|0));c[m+80>>2]=n;n=m+68|0;do o=qd(b,n,1)|0;while((o|0)==(n|0));c[m+76>>2]=o}o=(c[f>>2]|0)+61|0;if((a[o>>0]|0)==5){p=o;q=5}else{do sd(b)|0;while((a[o>>0]|0)!=5);o=(c[f>>2]|0)+61|0;p=o;q=a[o>>0]|0}if(!(1<<(q&255)&-33)){do sd(b)|0;while(!(1<<d[p>>0]&-33|0));o=(c[f>>2]|0)+61|0;r=o;s=a[o>>0]|0}else{r=p;s=q}if(s<<24>>24!=5)do sd(b)|0;while((a[r>>0]|0)!=5);if(i<<24>>24==2?(r=(c[f>>2]|0)+61|0,a[r>>0]|0):0)do sd(b)|0;while((a[r>>0]|0)!=0);a[h>>0]=i;i=(c[g+12>>2]|0)+(c[g+8>>2]|0)|0;h=(i|0)/100|0;r=c[g+156>>2]|0;s=H(h,0-r|0)|0;ne(g,((r|0)<(2147483644/(h|0)|0|0)?s:-2147483644)+i|0);if(j)return;j=(c[f>>2]|0)+104|0;f=c[j>>2]|0;if(!f)return;i=f;do{f=i+5|0;a[f>>0]=a[f>>0]&-65;Ad(b,1);i=c[j>>2]|0}while((i|0)!=0);return}function Ed(b){b=b|0;var d=0;d=c[b+12>>2]|0;if(!(a[d+63>>0]|0)){ne(d,-1600);return}else{Cd(b);return}}function Fd(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;i=Pa;Pa=Pa+16|0;j=i;k=c[e>>2]|0;if((k|0)>=((g|0)/2|0|0))if((k|0)<(g|0))l=g;else{c[j>>2]=h;c[j+4>>2]=g;Dc(b,6829,j)}else{j=k<<1;l=(j|0)>4?j:4}if((l+1|0)>>>0>(4294967293/(f>>>0)|0)>>>0)Gd(b);j=H(k,f)|0;k=H(l,f)|0;f=c[b+12>>2]|0;g=(d|0)==0;h=f+4|0;m=Wa[c[f>>2]&255](c[h>>2]|0,d,j,k)|0;if(!((k|0)!=0&(m|0)==0)){n=m;o=f+12|0;p=c[o>>2]|0;q=0-j|0;r=g?0:q;s=k+r|0;t=s+p|0;c[o>>2]=t;c[e>>2]=l;Pa=i;return n|0}if(!(a[f+63>>0]|0))Jc(b,4);Dd(b,1);m=Wa[c[f>>2]&255](c[h>>2]|0,d,j,k)|0;if(!m)Jc(b,4);else{n=m;o=f+12|0;p=c[o>>2]|0;q=0-j|0;r=g?0:q;s=k+r|0;t=s+p|0;c[o>>2]=t;c[e>>2]=l;Pa=i;return n|0}return 0}function Gd(a){a=a|0;var b=0;b=Pa;Pa=Pa+16|0;Dc(a,6855,b)}function Hd(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0;g=c[b+12>>2]|0;h=(d|0)==0;i=g+4|0;j=Wa[c[g>>2]&255](c[i>>2]|0,d,e,f)|0;if((f|0)!=0&(j|0)==0){if(!(a[g+63>>0]|0))Jc(b,4);Dd(b,1);k=Wa[c[g>>2]&255](c[i>>2]|0,d,e,f)|0;if(!k)Jc(b,4);else l=k}else l=j;j=g+12|0;c[j>>2]=(h?0:0-e|0)+f+(c[j>>2]|0);return l|0}function Id(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;if(a>>>0<8){b=a;return b|0}if(a>>>0>15){c=1;d=a;do{e=d+1|0;d=e>>>1;c=c+1|0}while(e>>>0>31);f=c<<3;g=d}else{f=8;g=a}b=f|g+-8;return b|0}function Jd(a){a=a|0;var b=0;b=a>>>3&31;return ((b|0)==0?a:(a&7|8)<<b+-1)|0}function Kd(a){a=a|0;var b=0,c=0,e=0,f=0,g=0,h=0;b=a+-1|0;if(b>>>0>255){a=b;c=0;while(1){e=c+8|0;f=a>>>8;if(a>>>0>65535){a=f;c=e}else{g=e;h=f;break}}}else{g=0;h=b}return g+(d[16+h>>0]|0)|0}function Ld(a,b,c){a=a|0;b=+b;c=+c;var d=0.0;switch(a|0){case 0:{d=b+c;break}case 1:{d=b-c;break}case 2:{d=b*c;break}case 3:{d=b/c;break}case 4:{d=b-+t(+(b/c))*c;break}case 5:{d=+w(+b,+c);break}case 6:{d=-b;break}default:d=0.0}return +d}function Md(b){b=b|0;return ((a[432+(b+1)>>0]&2)==0?(b|32)+-87|0:b+-48|0)|0}function Nd(b,e,f){b=b|0;e=e|0;f=f|0;var h=0,i=0,j=0,k=0.0,l=0,m=0.0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0.0,x=0,y=0,z=0,A=0,B=0.0,C=0,D=0,E=0.0,F=0,G=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0;h=Pa;Pa=Pa+16|0;i=h;if(Pm(b,6894)|0){j=0;Pa=h;return j|0}a:do if(!(Pm(b,6897)|0)){k=+xn(b,i);l=c[i>>2]|0;m=k}else{c[i>>2]=b;n=b;while(1){o=a[n>>0]|0;p=n+1|0;if(!(a[432+((o&255)+1)>>0]&8))break;else n=p}switch(o<<24>>24){case 45:{q=1;r=p;break}case 43:{q=0;r=p;break}default:{q=0;r=n}}b:do if((a[r>>0]|0)==48){switch(a[r+1>>0]|0){case 88:case 120:break;default:break b}s=r+2|0;t=a[s>>0]|0;u=t&255;v=a[432+(u+1)>>0]|0;if(!(v&16)){w=0.0;x=0;y=s;z=t}else{k=0.0;t=v;v=u;u=0;A=s;while(1){B=k*16.0+ +(((t&2)==0?(v|32)+-87|0:v+-48|0)|0);s=u+1|0;C=A+1|0;D=a[C>>0]|0;v=D&255;t=a[432+(v+1)>>0]|0;if(!(t&16)){w=B;x=s;y=C;z=D;break}else{k=B;u=s;A=C}}}if(z<<24>>24==46){A=y+1|0;u=d[A>>0]|0;t=a[432+(u+1)>>0]|0;if(!(t&16)){E=w;F=0;G=A}else{k=w;v=t;t=u;u=0;C=A;while(1){B=k*16.0+ +(((v&2)==0?(t|32)+-87|0:t+-48|0)|0);A=u+1|0;s=C+1|0;t=d[s>>0]|0;v=a[432+(t+1)>>0]|0;if(!(v&16)){E=B;F=A;G=s;break}else{k=B;u=A;C=s}}}}else{E=w;F=0;G=y}C=G;if(F|x|0){u=H(F,-4)|0;c[i>>2]=C;switch(a[G>>0]|0){case 80:case 112:{v=G+1|0;switch(a[v>>0]|0){case 45:{I=1;J=G+2|0;break}case 43:{I=0;J=G+2|0;break}default:{I=0;J=v}}v=a[J>>0]|0;if(!(a[432+((v&255)+1)>>0]&2)){K=u;L=G}else{t=0;s=J;A=v;do{s=s+1|0;t=(A<<24>>24)+-48+(t*10|0)|0;A=a[s>>0]|0}while((a[432+((A&255)+1)>>0]&2)!=0);M=((I|0)==0?t:0-t|0)+u|0;N=s;O=26}break}default:{M=u;N=C;O=26}}if((O|0)==26){c[i>>2]=N;K=M;L=N}l=L;m=+pn((q|0)==0?E:-E,K);break a}}while(0);g[f>>3]=0.0;j=0;Pa=h;return j|0}while(0);g[f>>3]=m;if((l|0)==(b|0)){j=0;Pa=h;return j|0}if(!(a[432+((d[l>>0]|0)+1)>>0]&8))P=l;else{f=l;do f=f+1|0;while((a[432+((d[f>>0]|0)+1)>>0]&8)!=0);c[i>>2]=f;P=f}j=(P|0)==(b+e|0)&1;Pa=h;return j|0}function Od(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0.0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;f=Pa;Pa=Pa+48|0;h=f+32|0;i=f+24|0;j=f;k=rm(d,37)|0;l=b+24|0;m=b+8|0;n=c[m>>2]|0;o=(c[l>>2]|0)-n|0;p=n;do if(k){n=0;q=d;r=o;s=p;t=k;a:while(1){if((r|0)<48){Mc(b,2);u=c[m>>2]|0}else u=s;c[m>>2]=u+16;v=Ae(b,q,t-q|0)|0;c[u>>2]=v;c[u+8>>2]=(a[v+4>>0]|64)&255;w=a[t+1>>0]|0;switch(w<<24>>24|0){case 115:{v=(c[e>>2]|0)+(4-1)&~(4-1);x=c[v>>2]|0;c[e>>2]=v+4;v=(x|0)==0?13461:x;x=_l(v)|0;y=c[m>>2]|0;c[m>>2]=y+16;z=Ae(b,v,x)|0;c[y>>2]=z;c[y+8>>2]=(a[z+4>>0]|64)&255;break}case 99:{z=(c[e>>2]|0)+(4-1)&~(4-1);y=c[z>>2]|0;c[e>>2]=z+4;a[j>>0]=y;y=c[m>>2]|0;c[m>>2]=y+16;z=Ae(b,j,1)|0;c[y>>2]=z;c[y+8>>2]=(a[z+4>>0]|64)&255;break}case 100:{z=c[m>>2]|0;c[m>>2]=z+16;y=(c[e>>2]|0)+(4-1)&~(4-1);x=c[y>>2]|0;c[e>>2]=y+4;g[z>>3]=+(x|0);c[z+8>>2]=3;break}case 102:{z=c[m>>2]|0;c[m>>2]=z+16;x=(c[e>>2]|0)+(8-1)&~(8-1);A=+g[x>>3];c[e>>2]=x+8;g[z>>3]=A;c[z+8>>2]=3;break}case 112:{z=(c[e>>2]|0)+(4-1)&~(4-1);x=c[z>>2]|0;c[e>>2]=z+4;c[i>>2]=x;x=Gm(j,6900,i)|0;z=c[m>>2]|0;c[m>>2]=z+16;y=Ae(b,j,x)|0;c[z>>2]=y;c[z+8>>2]=(a[y+4>>0]|64)&255;break}case 37:{y=c[m>>2]|0;c[m>>2]=y+16;z=Ae(b,6903,1)|0;c[y>>2]=z;c[y+8>>2]=(a[z+4>>0]|64)&255;break}default:{B=12;break a}}n=n+2|0;q=t+2|0;t=rm(q,37)|0;s=c[m>>2]|0;r=(c[l>>2]|0)-s|0;if(!t){B=14;break}}if((B|0)==12){c[h>>2]=w<<24>>24;Dc(b,6905,h)}else if((B|0)==14){C=q;D=n;E=r;F=s;break}}else{C=d;D=0;E=o;F=p}while(0);if((E|0)<32){Mc(b,1);G=c[m>>2]|0}else G=F;F=_l(C)|0;c[m>>2]=G+16;E=Ae(b,C,F)|0;c[G>>2]=E;c[G+8>>2]=(a[E+4>>0]|64)&255;if(!D){H=c[m>>2]|0;I=H+-16|0;J=c[I>>2]|0;K=J+16|0;Pa=f;return K|0}df(b,D|1);H=c[m>>2]|0;I=H+-16|0;J=c[I>>2]|0;K=J+16|0;Pa=f;return K|0}function Pd(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;d=Od(a,b,f)|0;Pa=e;return d|0}function Qd(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=_l(c)|0;switch(a[c>>0]|0){case 61:{f=c+1|0;if(e>>>0>d>>>0){g=d+-1|0;Un(b|0,f|0,g|0)|0;a[b+g>>0]=0;return}else{Un(b|0,f|0,e|0)|0;return}break}case 64:{if(e>>>0>d>>>0){a[b>>0]=a[8943]|0;a[b+1>>0]=a[8944]|0;a[b+2>>0]=a[8945]|0;Un(b+3|0,c+1+e+(3-d)|0,d+-3|0)|0;return}else{Un(b|0,c+1|0,e|0)|0;return}break}default:{f=rm(c,10)|0;g=b;h=6948;i=g+9|0;do{a[g>>0]=a[h>>0]|0;g=g+1|0;h=h+1|0}while((g|0)<(i|0));h=b+9|0;b=d+-15|0;d=(f|0)==0;if(e>>>0<b>>>0&d){Un(h|0,c|0,e|0)|0;j=h+e|0}else{g=d?e:f-c|0;f=g>>>0>b>>>0?b:g;Un(h|0,c|0,f|0)|0;c=h+f|0;a[c>>0]=a[8943]|0;a[c+1>>0]=a[8944]|0;a[c+2>>0]=a[8945]|0;j=c+3|0};a[j>>0]=a[6958]|0;a[j+1>>0]=a[6959]|0;a[j+2>>0]=a[6960]|0;return}}}function Rd(d,e,f,g,h,i){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;j=Pa;Pa=Pa+176|0;k=j+156|0;l=j+80|0;m=j;n=j+104|0;o=bd(d,1)|0;p=d+8|0;q=c[p>>2]|0;c[q>>2]=o;c[q+8>>2]=70;q=(c[p>>2]|0)+16|0;c[p>>2]=q;if(((c[d+24>>2]|0)-q|0)<16)Mc(d,0);q=gd(d)|0;c[o+12>>2]=q;c[n>>2]=q;p=Be(d,h)|0;h=q+36|0;c[h>>2]=p;c[m+60>>2]=f;f=m+64|0;c[f>>2]=g;c[g+28>>2]=0;c[g+16>>2]=0;c[g+4>>2]=0;dh(d,m,e,p,i);i=c[m+52>>2]|0;p=m+48|0;c[n+8>>2]=c[p>>2];e=n+12|0;c[e>>2]=m;c[p>>2]=n;c[n+20>>2]=0;c[n+24>>2]=0;c[n+28>>2]=-1;c[n+32>>2]=0;c[n+36>>2]=0;p=n+44|0;c[p>>2]=0;a[p+4>>0]=0;c[n+40>>2]=c[(c[f>>2]|0)+4>>2];f=n+16|0;c[f>>2]=0;c[h>>2]=c[m+68>>2];a[q+78>>0]=2;q=Le(i)|0;c[n+4>>2]=q;h=i+8|0;p=c[h>>2]|0;c[p>>2]=q;c[p+8>>2]=69;p=(c[h>>2]|0)+16|0;c[h>>2]=p;if(((c[i+24>>2]|0)-p|0)<16)Mc(i,0);a[k+10>>0]=0;a[k+8>>0]=a[n+46>>0]|0;i=c[(c[e>>2]|0)+64>>2]|0;b[k+4>>1]=c[i+28>>2];b[k+6>>1]=c[i+16>>2];a[k+9>>0]=0;c[k>>2]=c[f>>2];c[f>>2]=k;a[(c[n>>2]|0)+77>>0]=1;c[l+16>>2]=-1;c[l+20>>2]=-1;c[l>>2]=7;c[l+8>>2]=0;Sd(n,c[m+72>>2]|0,l)|0;eh(m);l=m+16|0;a:while(1){n=c[l>>2]|0;switch(n|0){case 277:case 286:case 262:case 261:case 260:{r=n;break a;break}default:{}}Td(m);if((n|0)==274){s=8;break}}if((s|0)==8)r=c[l>>2]|0;if((r|0)==286){Vd(m);Pa=j;return o|0}else Ud(m,286);return 0}function Sd(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;f=c[b>>2]|0;g=f+40|0;h=c[g>>2]|0;i=b+47|0;j=a[i>>0]|0;if(j<<24>>24==-1)$d(b,255,7549);if((h|0)>(j&255|0))k=h;else{j=f+28|0;l=Fd(c[(c[b+12>>2]|0)+52>>2]|0,c[j>>2]|0,g,8,255,7549)|0;c[j>>2]=l;k=c[g>>2]|0}g=c[f+28>>2]|0;if((h|0)<(k|0)){l=h;do{c[g+(l<<3)>>2]=0;l=l+1|0}while((l|0)<(k|0))}k=a[i>>0]|0;l=k&255;a[g+(l<<3)+4>>0]=(c[e>>2]|0)==7&1;a[g+(l<<3)+5>>0]=c[e+8>>2];c[g+(l<<3)>>2]=d;if(!(a[d+5>>0]&3)){m=l;n=k;o=n+1<<24>>24;a[i>>0]=o;return m|0}if(!(a[f+5>>0]&4)){m=l;n=k;o=n+1<<24>>24;a[i>>0]=o;return m|0}jd(c[(c[b+12>>2]|0)+52>>2]|0,f,d);d=a[i>>0]|0;m=d&255;n=d;o=n+1<<24>>24;a[i>>0]=o;return m|0}function Td(e){e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0;f=Pa;Pa=Pa+176|0;g=f+160|0;h=f+144|0;i=f+128|0;j=f+112|0;k=f+96|0;l=f+80|0;m=f+48|0;n=f+24|0;o=f;p=e+4|0;q=c[p>>2]|0;r=e+48|0;s=c[r>>2]|0;t=e+52|0;u=(c[t>>2]|0)+38|0;v=(b[u>>1]|0)+1<<16>>16;b[u>>1]=v;if((v&65535)>200)$d(s,200,7120);v=e+16|0;do switch(c[v>>2]|0){case 59:{eh(e);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 267:{c[n>>2]=-1;ae(e,n);a:while(1){u=c[v>>2]|0;switch(u|0){case 260:{E=8;break a;break}case 261:break;default:{F=u;break a}}ae(e,n)}if((E|0)==8){eh(e);u=c[r>>2]|0;a[m+10>>0]=0;a[m+8>>0]=a[u+46>>0]|0;G=c[(c[u+12>>2]|0)+64>>2]|0;b[m+4>>1]=c[G+28>>2];b[m+6>>1]=c[G+16>>2];a[m+9>>0]=0;G=u+16|0;c[m>>2]=c[G>>2];c[G>>2]=m;b:do{G=c[v>>2]|0;switch(G|0){case 277:case 286:case 262:case 261:case 260:{break b;break}default:{}}Td(e)}while((G|0)!=274);Wd(u);F=c[v>>2]|0}if((F|0)==262){eh(e);wg(s,c[n>>2]|0);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}if((c[p>>2]|0)==(q|0))Ud(e,262);else{G=c[t>>2]|0;H=$g(e,262)|0;I=$g(e,267)|0;c[l>>2]=H;c[l+4>>2]=I;c[l+8>>2]=q;ah(e,Pd(G,7129,l)|0)}break}case 278:{eh(e);G=ug(s)|0;be(e,m,0)|0;if((c[m>>2]|0)==1)c[m>>2]=3;Qg(c[r>>2]|0,m);I=c[m+20>>2]|0;a[n+10>>0]=1;a[n+8>>0]=a[s+46>>0]|0;H=c[(c[s+12>>2]|0)+64>>2]|0;b[n+4>>1]=c[H+28>>2];b[n+6>>1]=c[H+16>>2];a[n+9>>0]=0;H=s+16|0;c[n>>2]=c[H>>2];c[H>>2]=n;if((c[v>>2]|0)!=259)Ud(e,259);eh(e);H=c[r>>2]|0;a[m+10>>0]=0;a[m+8>>0]=a[H+46>>0]|0;J=c[(c[H+12>>2]|0)+64>>2]|0;b[m+4>>1]=c[J+28>>2];b[m+6>>1]=c[J+16>>2];a[m+9>>0]=0;J=H+16|0;c[m>>2]=c[J>>2];c[J>>2]=m;c:do{J=c[v>>2]|0;switch(J|0){case 277:case 286:case 262:case 261:case 260:{break c;break}default:{}}Td(e)}while((J|0)!=274);Wd(H);vg(s,qg(s)|0,G);if((c[v>>2]|0)==262){eh(e);Wd(s);wg(s,I);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}if((c[p>>2]|0)==(q|0))Ud(e,262);else{u=c[t>>2]|0;J=$g(e,262)|0;K=$g(e,278)|0;c[k>>2]=J;c[k+4>>2]=K;c[k+8>>2]=q;ah(e,Pd(u,7129,k)|0)}break}case 259:{eh(e);u=c[r>>2]|0;a[m+10>>0]=0;a[m+8>>0]=a[u+46>>0]|0;K=c[(c[u+12>>2]|0)+64>>2]|0;b[m+4>>1]=c[K+28>>2];b[m+6>>1]=c[K+16>>2];a[m+9>>0]=0;K=u+16|0;c[m>>2]=c[K>>2];c[K>>2]=m;d:do{K=c[v>>2]|0;switch(K|0){case 277:case 286:case 262:case 261:case 260:{break d;break}default:{}}Td(e)}while((K|0)!=274);Wd(u);if((c[v>>2]|0)==262){eh(e);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}if((c[p>>2]|0)==(q|0))Ud(e,262);else{I=c[t>>2]|0;G=$g(e,262)|0;H=$g(e,259)|0;c[j>>2]=G;c[j+4>>2]=H;c[j+8>>2]=q;ah(e,Pd(I,7129,j)|0)}break}case 264:{a[n+10>>0]=1;a[n+8>>0]=a[s+46>>0]|0;I=c[(c[s+12>>2]|0)+64>>2]|0;b[n+4>>1]=c[I+28>>2];b[n+6>>1]=c[I+16>>2];a[n+9>>0]=0;I=s+16|0;c[n>>2]=c[I>>2];c[I>>2]=n;eh(e);if((c[v>>2]|0)!=288)Ud(e,288);I=e+24|0;H=c[I>>2]|0;eh(e);switch(c[v>>2]|0){case 61:{G=c[r>>2]|0;K=G+48|0;J=d[K>>0]|0;ce(e,ch(e,7166,11)|0);ce(e,ch(e,7178,11)|0);ce(e,ch(e,7190,10)|0);ce(e,H);if((c[v>>2]|0)!=61)Ud(e,61);eh(e);be(e,m,0)|0;Hg(c[r>>2]|0,m);if((c[v>>2]|0)!=44)Ud(e,44);eh(e);be(e,m,0)|0;Hg(c[r>>2]|0,m);if((c[v>>2]|0)==44){eh(e);be(e,m,0)|0;Hg(c[r>>2]|0,m)}else{L=d[K>>0]|0;yg(G,L,Dg(G,1.0)|0)|0;Ag(G,1)}de(e,J,q,1,1);break}case 268:case 44:{J=c[r>>2]|0;G=d[J+48>>0]|0;ce(e,ch(e,7201,15)|0);ce(e,ch(e,7217,11)|0);ce(e,ch(e,7229,13)|0);ce(e,H);H=c[v>>2]|0;do if((H|0)==44){L=4;while(1){eh(e);if((c[v>>2]|0)!=288){E=51;break}K=c[I>>2]|0;eh(e);ce(e,K);M=c[v>>2]|0;if((M|0)==44)L=L+1|0;else{E=53;break}}if((E|0)==51)Ud(e,288);else if((E|0)==53){N=L+-2|0;O=M;break}}else{N=1;O=H}while(0);if((O|0)!=268)Ud(e,268);eh(e);H=c[p>>2]|0;be(e,m,0)|0;if((c[v>>2]|0)==44){I=1;while(1){eh(e);Hg(c[r>>2]|0,m);be(e,m,0)|0;u=I+1|0;if((c[v>>2]|0)==44)I=u;else{P=u;break}}}else P=1;ee(c[r>>2]|0,3,P,m);zg(J,3);de(e,G,H,N,0);break}default:ah(e,7243)}if((c[v>>2]|0)==262){eh(e);Wd(s);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}if((c[p>>2]|0)==(q|0))Ud(e,262);else{I=c[t>>2]|0;u=$g(e,262)|0;K=$g(e,264)|0;c[i>>2]=u;c[i+4>>2]=K;c[i+8>>2]=q;ah(e,Pd(I,7129,i)|0)}break}case 273:{I=ug(s)|0;a[n+10>>0]=1;K=a[s+46>>0]|0;a[n+8>>0]=K;u=c[(c[s+12>>2]|0)+64>>2]|0;Q=c[u+28>>2]&65535;b[n+4>>1]=Q;R=c[u+16>>2]&65535;b[n+6>>1]=R;a[n+9>>0]=0;u=s+16|0;c[n>>2]=c[u>>2];a[o+10>>0]=0;S=o+8|0;a[S>>0]=K;b[o+4>>1]=Q;b[o+6>>1]=R;R=o+9|0;a[R>>0]=0;c[o>>2]=n;c[u>>2]=o;eh(e);e:while(1){u=c[v>>2]|0;switch(u|0){case 277:case 286:case 262:case 261:case 260:{T=u;break e;break}default:{}}Td(e);if((u|0)==274){E=69;break}}if((E|0)==69)T=c[v>>2]|0;if((T|0)!=277)if((c[p>>2]|0)==(q|0))Ud(e,277);else{H=c[t>>2]|0;G=$g(e,277)|0;J=$g(e,273)|0;c[h>>2]=G;c[h+4>>2]=J;c[h+8>>2]=q;ah(e,Pd(H,7129,h)|0)}eh(e);be(e,m,0)|0;if((c[m>>2]|0)==1)c[m>>2]=3;Qg(c[r>>2]|0,m);H=c[m+20>>2]|0;if(a[R>>0]|0)xg(s,H,d[S>>0]|0);Wd(s);vg(s,H,I);Wd(s);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 265:{eh(e);if((c[v>>2]|0)!=288)Ud(e,288);H=c[e+24>>2]|0;eh(e);J=c[r>>2]|0;if(!(fe(J,H,n,1)|0)){fe(J,c[e+72>>2]|0,n,1)|0;G=Bg(c[r>>2]|0,H)|0;c[m+16>>2]=-1;c[m+20>>2]=-1;c[m>>2]=4;c[m+8>>2]=G;Sg(J,n,m)}f:while(1){switch(c[v>>2]|0){case 58:{E=86;break f;break}case 46:break;default:{U=0;break f}}ge(e,n)}if((E|0)==86){ge(e,n);U=1}he(e,o,U,q);Og(c[r>>2]|0,n,o);Yg(c[r>>2]|0,q);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 269:{eh(e);I=c[v>>2]|0;if((I|0)==265){eh(e);S=c[r>>2]|0;if((c[v>>2]|0)!=288)Ud(e,288);R=c[e+24>>2]|0;eh(e);ce(e,R);R=c[r>>2]|0;J=R+46|0;G=a[J>>0]|0;a[J>>0]=(G&255)+1;c[(c[(c[R>>2]|0)+24>>2]|0)+((b[(c[c[(c[R+12>>2]|0)+64>>2]>>2]|0)+((c[R+40>>2]|0)+(G+1&255)+-1<<1)>>1]|0)*12|0)+4>>2]=c[R+20>>2];he(e,m,0,c[p>>2]|0);c[(c[(c[S>>2]|0)+24>>2]|0)+((b[(c[c[(c[S+12>>2]|0)+64>>2]>>2]|0)+((c[S+40>>2]|0)+(c[m+8>>2]|0)<<1)>>1]|0)*12|0)+4>>2]=c[S+20>>2];w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}if((I|0)!=288)Ud(e,288);I=e+24|0;S=0;g:while(1){R=c[I>>2]|0;eh(e);ce(e,R);S=S+1|0;switch(c[v>>2]|0){case 61:{E=97;break g;break}case 44:break;default:{E=100;break g}}eh(e);if((c[v>>2]|0)!=288){E=95;break}}if((E|0)==95)Ud(e,288);else if((E|0)==97){eh(e);be(e,m,0)|0;if((c[v>>2]|0)==44){I=1;while(1){eh(e);Hg(c[r>>2]|0,m);be(e,m,0)|0;R=I+1|0;if((c[v>>2]|0)==44)I=R;else{V=R;break}}}else V=1}else if((E|0)==100){c[m>>2]=0;V=0}ee(c[r>>2]|0,S,V,m);I=c[r>>2]|0;R=I+46|0;G=S+(d[R>>0]|0)|0;a[R>>0]=G;R=c[I+20>>2]|0;J=c[(c[I>>2]|0)+24>>2]|0;H=c[c[(c[I+12>>2]|0)+64>>2]>>2]|0;u=(c[I+40>>2]|0)+(G&255)|0;G=S;do{c[J+((b[H+(u-G<<1)>>1]|0)*12|0)+4>>2]=R;G=G+-1|0}while((G|0)!=0);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 285:{eh(e);if((c[v>>2]|0)!=288)Ud(e,288);G=c[e+24>>2]|0;eh(e);R=c[r>>2]|0;u=e+64|0;H=c[u>>2]|0;J=H+24|0;S=R+16|0;I=b[(c[S>>2]|0)+4>>1]|0;Q=H+28|0;h:do if((c[Q>>2]|0)>(I|0)){K=I;while(1){if(xe(G,c[(c[J>>2]|0)+(K<<4)>>2]|0)|0)break;W=K+1|0;if((W|0)<(c[Q>>2]|0))K=W;else break h}L=R+12|0;W=c[(c[L>>2]|0)+52>>2]|0;X=c[(c[J>>2]|0)+(K<<4)+8>>2]|0;c[g>>2]=G+16;c[g+4>>2]=X;X=Pd(W,7264,g)|0;_d(c[L>>2]|0,X)}while(0);if((c[v>>2]|0)!=285)Ud(e,285);eh(e);I=c[R+20>>2]|0;X=c[Q>>2]|0;L=H+32|0;if((X|0)<(c[L>>2]|0)){Y=c[J>>2]|0;Z=X}else{W=Fd(c[t>>2]|0,c[J>>2]|0,L,16,32767,6961)|0;c[J>>2]=W;Y=W;Z=c[Q>>2]|0}c[Y+(X<<4)>>2]=G;c[Y+(X<<4)+8>>2]=q;a[Y+(X<<4)+12>>0]=a[(c[r>>2]|0)+46>>0]|0;c[Y+(X<<4)+4>>2]=I;c[Q>>2]=Z+1;i:while(1){switch(c[v>>2]|0){case 286:case 262:case 261:case 260:{E=120;break i;break}case 285:case 59:break;default:{E=119;break i}}Td(e)}if((E|0)==119)_=c[J>>2]|0;else if((E|0)==120){Q=c[J>>2]|0;a[Q+(X<<4)+12>>0]=a[(c[S>>2]|0)+8>>0]|0;_=Q}Q=_+(X<<4)|0;G=c[u>>2]|0;H=b[(c[(c[r>>2]|0)+16>>2]|0)+6>>1]|0;R=G+16|0;if((c[R>>2]|0)<=(H|0)){w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}I=G+12|0;G=H;while(1){if(!(xe(c[(c[I>>2]|0)+(G<<4)>>2]|0,c[Q>>2]|0)|0))$=G+1|0;else{Xd(e,G,Q);$=G}if(($|0)<(c[R>>2]|0))G=$;else break}w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 274:{eh(e);G=c[r>>2]|0;j:do switch(c[v>>2]|0){case 59:case 277:case 286:case 262:case 261:case 260:{aa=0;ba=0;break}default:{be(e,m,0)|0;if((c[v>>2]|0)==44){R=1;while(1){eh(e);Hg(c[r>>2]|0,m);be(e,m,0)|0;Q=R+1|0;if((c[v>>2]|0)==44)R=Q;else{ca=Q;break}}}else ca=1;if((c[m>>2]&-2|0)!=12)if((ca|0)==1){aa=1;ba=Kg(G,m)|0;break j}else{Hg(G,m);aa=ca;ba=d[G+46>>0]|0;break j}else{Eg(G,m,-1);if((ca|0)==1&(c[m>>2]|0)==12){R=(c[(c[G>>2]|0)+12>>2]|0)+(c[m+8>>2]<<2)|0;c[R>>2]=c[R>>2]&-64|30}aa=-1;ba=d[G+46>>0]|0;break j}}}while(0);tg(G,ba,aa);if((c[v>>2]|0)==59)eh(e);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}case 266:case 258:{R=qg(s)|0;K=c[p>>2]|0;Q=(c[v>>2]|0)==266;eh(e);do if(Q)if((c[v>>2]|0)==288){I=c[e+24>>2]|0;eh(e);da=I;break}else Ud(e,288);else da=Be(c[t>>2]|0,8824)|0;while(0);Q=c[e+64>>2]|0;G=Q+12|0;I=Q+16|0;u=c[I>>2]|0;X=Q+20|0;if((u|0)<(c[X>>2]|0)){ea=c[G>>2]|0;fa=u}else{Q=Fd(c[t>>2]|0,c[G>>2]|0,X,16,32767,6961)|0;c[G>>2]=Q;ea=Q;fa=c[I>>2]|0}c[ea+(u<<4)>>2]=da;c[ea+(u<<4)+8>>2]=K;a[ea+(u<<4)+12>>0]=a[(c[r>>2]|0)+46>>0]|0;c[ea+(u<<4)+4>>2]=R;c[I>>2]=fa+1;Yd(e,u)|0;w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}default:{u=m+8|0;ie(e,u);k:do switch(c[v>>2]|0){case 44:case 61:{c[m>>2]=0;je(e,m,1);break}default:if((c[u>>2]|0)==12){I=(c[(c[s>>2]|0)+12>>2]|0)+(c[m+16>>2]<<2)|0;c[I>>2]=c[I>>2]&-8372225|16384;break k}else ah(e,7302)}while(0);w=c[r>>2]|0;x=w+46|0;y=a[x>>0]|0;z=w+48|0;a[z>>0]=y;A=c[t>>2]|0;B=A+38|0;C=b[B>>1]|0;D=C+-1<<16>>16;b[B>>1]=D;Pa=f;return}}while(0)}function Ud(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=Pa;Pa=Pa+16|0;e=d;d=c[a+52>>2]|0;f=$g(a,b)|0;c[e>>2]=f;ah(a,Pd(d,7108,e)|0)}function Vd(a){a=a|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=c[a+52>>2]|0;f=a+48|0;g=c[f>>2]|0;h=c[g>>2]|0;tg(g,0,0);Wd(g);i=g+20|0;j=c[i>>2]|0;if((j+1|0)>>>0>1073741823)Gd(e);k=h+12|0;l=h+48|0;m=Hd(e,c[k>>2]|0,c[l>>2]<<2,j<<2)|0;c[k>>2]=m;m=c[i>>2]|0;c[l>>2]=m;if((m+1|0)>>>0>1073741823)Gd(e);l=h+20|0;k=h+52|0;j=Hd(e,c[l>>2]|0,c[k>>2]<<2,m<<2)|0;c[l>>2]=j;c[k>>2]=c[i>>2];i=g+32|0;k=c[i>>2]|0;if((k+1|0)>>>0>268435455)Gd(e);j=h+8|0;l=h+44|0;m=Hd(e,c[j>>2]|0,c[l>>2]<<4,k<<4)|0;c[j>>2]=m;c[l>>2]=c[i>>2];i=g+36|0;l=c[i>>2]|0;if((l+1|0)>>>0>1073741823)Gd(e);m=h+16|0;j=h+56|0;k=Hd(e,c[m>>2]|0,c[j>>2]<<2,l<<2)|0;c[m>>2]=k;c[j>>2]=c[i>>2];i=g+44|0;j=b[i>>1]|0;if((j+1|0)>>>0>357913941)Gd(e);k=h+24|0;m=h+60|0;l=Hd(e,c[k>>2]|0,(c[m>>2]|0)*12|0,j*12|0)|0;c[k>>2]=l;c[m>>2]=b[i>>1];i=g+47|0;m=h+28|0;l=h+40|0;h=Hd(e,c[m>>2]|0,c[l>>2]<<3,d[i>>0]<<3)|0;c[m>>2]=h;c[l>>2]=d[i>>0];c[f>>2]=c[g+8>>2];if((c[a+16>>2]&-2|0)==288){g=c[a+24>>2]|0;ch(a,g+16|0,c[g+12>>2]|0)|0}g=e+8|0;c[g>>2]=(c[g>>2]|0)+-16;if((c[(c[e+12>>2]|0)+12>>2]|0)<=0)return;Ed(e);return}function Wd(e){e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;f=e+16|0;g=c[f>>2]|0;h=e+12|0;i=c[h>>2]|0;if(c[g>>2]|0?a[g+9>>0]|0:0){j=qg(e)|0;xg(e,j,d[g+8>>0]|0);wg(e,j)}if(a[g+10>>0]|0){j=i+52|0;k=Be(c[j>>2]|0,8824)|0;l=i+64|0;m=c[l>>2]|0;n=m+24|0;o=i+48|0;p=c[o>>2]|0;q=c[p+20>>2]|0;r=m+28|0;s=c[r>>2]|0;t=m+32|0;if((s|0)<(c[t>>2]|0)){u=c[n>>2]|0;v=p;w=s;x=m}else{m=Fd(c[j>>2]|0,c[n>>2]|0,t,16,32767,6961)|0;c[n>>2]=m;u=m;v=c[o>>2]|0;w=c[r>>2]|0;x=c[l>>2]|0}c[u+(s<<4)>>2]=k;c[u+(s<<4)+8>>2]=0;a[u+(s<<4)+12>>0]=a[v+46>>0]|0;c[u+(s<<4)+4>>2]=q;c[r>>2]=w+1;w=(c[x+24>>2]|0)+(s<<4)|0;s=b[(c[v+16>>2]|0)+6>>1]|0;v=x+16|0;if((c[v>>2]|0)>(s|0)){r=x+12|0;x=s;while(1){if(!(xe(c[(c[r>>2]|0)+(x<<4)>>2]|0,c[w>>2]|0)|0))y=x+1|0;else{Xd(i,x,w);y=x}if((y|0)<(c[v>>2]|0))x=y;else break}}}y=c[g>>2]|0;c[f>>2]=y;f=g+8|0;x=a[f>>0]|0;v=e+46|0;w=a[v>>0]|0;r=w&255;s=c[(c[h>>2]|0)+64>>2]|0;q=s+4|0;c[q>>2]=(x&255)-r+(c[q>>2]|0);if((x&255)<(w&255)){q=c[e+20>>2]|0;u=c[e+40>>2]|0;k=c[(c[e>>2]|0)+24>>2]|0;l=c[s>>2]|0;o=r;while(1){r=(o&255)+-1<<24>>24;c[k+((b[l+(u+(r&255)<<1)>>1]|0)*12|0)+8>>2]=q;if((r&255)>(x&255))o=o+-1|0;else break}a[v>>0]=x;z=x}else z=w;a[e+48>>0]=z;z=c[i+64>>2]|0;c[z+28>>2]=b[g+4>>1];w=b[g+6>>1]|0;if(!y)if((c[z+16>>2]|0)>(w|0))Zd(i,(c[z+12>>2]|0)+(w<<4)|0);else return;z=s+16|0;if((c[z>>2]|0)<=(w|0))return;i=s+12|0;s=g+9|0;g=w;w=x;while(1){x=c[i>>2]|0;y=x+(g<<4)+12|0;v=w&255;if((d[y>>0]|0)>(w&255)){if(!(a[s>>0]|0))A=w;else{xg(e,c[x+(g<<4)+4>>2]|0,v);A=a[f>>0]|0}a[y>>0]=A}y=g+((Yd(c[h>>2]|0,g)|0)==0&1)|0;if((y|0)>=(c[z>>2]|0))break;g=y;w=a[f>>0]|0}return}function Xd(e,f,g){e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;h=Pa;Pa=Pa+16|0;i=h;j=c[e+48>>2]|0;k=c[e+64>>2]|0;l=k+12|0;m=c[l>>2]|0;n=a[m+(f<<4)+12>>0]|0;if((n&255)<(d[g+12>>0]|0)){o=c[e+52>>2]|0;p=c[m+(f<<4)+8>>2]|0;q=(c[(c[(c[j>>2]|0)+24>>2]|0)+((b[(c[c[(c[j+12>>2]|0)+64>>2]>>2]|0)+((c[j+40>>2]|0)+(n&255)<<1)>>1]|0)*12|0)>>2]|0)+16|0;c[i>>2]=(c[m+(f<<4)>>2]|0)+16;c[i+4>>2]=p;c[i+8>>2]=q;_d(e,Pd(o,7052,i)|0)}vg(j,c[m+(f<<4)+4>>2]|0,c[g+4>>2]|0);g=k+16|0;k=(c[g>>2]|0)+-1|0;if((k|0)<=(f|0)){r=k;c[g>>2]=r;Pa=h;return}k=f;do{f=c[l>>2]|0;m=f+(k<<4)|0;k=k+1|0;j=f+(k<<4)|0;c[m>>2]=c[j>>2];c[m+4>>2]=c[j+4>>2];c[m+8>>2]=c[j+8>>2];c[m+12>>2]=c[j+12>>2];j=(c[g>>2]|0)+-1|0}while((k|0)<(j|0));r=j;c[g>>2]=r;Pa=h;return}function Yd(e,f){e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;g=e+48|0;h=c[(c[g>>2]|0)+16>>2]|0;i=c[e+64>>2]|0;j=c[i+12>>2]|0;k=h+4|0;l=b[k>>1]|0;m=i+28|0;if((c[m>>2]|0)<=(l|0)){n=0;return n|0}o=i+24|0;i=j+(f<<4)|0;p=l;while(1){q=c[o>>2]|0;r=q+(p<<4)|0;if(xe(c[r>>2]|0,c[i>>2]|0)|0)break;l=p+1|0;if((l|0)<(c[m>>2]|0))p=l;else{n=0;s=10;break}}if((s|0)==10)return n|0;s=a[q+(p<<4)+12>>0]|0;do if((d[j+(f<<4)+12>>0]|0)>(s&255)){if((a[h+9>>0]|0)==0?(c[m>>2]|0)<=(b[k>>1]|0):0)break;xg(c[g>>2]|0,c[j+(f<<4)+4>>2]|0,s&255)}while(0);Xd(e,f,r);n=1;return n|0}function Zd(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;e=Pa;Pa=Pa+16|0;f=e;e=c[d>>2]|0;if((a[e+4>>0]|0)==4)g=(a[e+6>>0]|0)==0?6974:7018;else g=6974;h=c[b+52>>2]|0;i=c[d+8>>2]|0;c[f>>2]=e+16;c[f+4>>2]=i;_d(b,Pd(h,g,f)|0)}function _d(a,b){a=a|0;b=b|0;c[a+16>>2]=0;ah(a,b)}function $d(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=Pa;Pa=Pa+32|0;f=e+8|0;g=e;e=a+12|0;h=c[(c[e>>2]|0)+52>>2]|0;i=c[(c[a>>2]|0)+64>>2]|0;if(!i)j=7503;else{c[g>>2]=i;j=Pd(h,7483,g)|0}c[f>>2]=d;c[f+4>>2]=b;c[f+8>>2]=j;j=Pd(h,7517,f)|0;ah(c[e>>2]|0,j)}function ae(d,e){d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;f=Pa;Pa=Pa+48|0;g=f+24|0;h=f;i=d+48|0;j=c[i>>2]|0;eh(d);be(d,h,0)|0;k=d+16|0;if((c[k>>2]|0)!=275)Ud(d,275);eh(d);a:do switch(c[k>>2]|0){case 258:case 266:{Rg(c[i>>2]|0,h);a[g+10>>0]=0;a[g+8>>0]=a[j+46>>0]|0;l=c[(c[j+12>>2]|0)+64>>2]|0;b[g+4>>1]=c[l+28>>2];b[g+6>>1]=c[l+16>>2];a[g+9>>0]=0;l=j+16|0;c[g>>2]=c[l>>2];c[l>>2]=g;l=c[h+16>>2]|0;m=c[d+4>>2]|0;n=(c[k>>2]|0)==266;eh(d);do if(n)if((c[k>>2]|0)==288){o=c[d+24>>2]|0;eh(d);p=o;break}else Ud(d,288);else p=Be(c[d+52>>2]|0,8824)|0;while(0);n=c[d+64>>2]|0;o=n+12|0;q=n+16|0;r=c[q>>2]|0;s=n+20|0;if((r|0)<(c[s>>2]|0)){t=c[o>>2]|0;u=r}else{n=Fd(c[d+52>>2]|0,c[o>>2]|0,s,16,32767,6961)|0;c[o>>2]=n;t=n;u=c[q>>2]|0}c[t+(r<<4)>>2]=p;c[t+(r<<4)+8>>2]=m;a[t+(r<<4)+12>>0]=a[(c[i>>2]|0)+46>>0]|0;c[t+(r<<4)+4>>2]=l;c[q>>2]=u+1;Yd(d,r)|0;b:while(1){switch(c[k>>2]|0){case 286:case 262:case 261:case 260:{break b;break}case 285:case 59:break;default:{v=16;break b}}Td(d)}if((v|0)==16){w=qg(j)|0;break a}Wd(j);Pa=f;return}default:{Qg(c[i>>2]|0,h);a[g+10>>0]=0;a[g+8>>0]=a[j+46>>0]|0;l=c[(c[j+12>>2]|0)+64>>2]|0;b[g+4>>1]=c[l+28>>2];b[g+6>>1]=c[l+16>>2];a[g+9>>0]=0;l=j+16|0;c[g>>2]=c[l>>2];c[l>>2]=g;w=c[h+20>>2]|0}}while(0);c:do{h=c[k>>2]|0;switch(h|0){case 277:case 286:case 262:case 261:case 260:{break c;break}default:{}}Td(d)}while((h|0)!=274);Wd(j);if((c[k>>2]&-2|0)==260)sg(j,e,qg(j)|0);wg(j,w);Pa=f;return}function be(e,f,h){e=e|0;f=f|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;i=Pa;Pa=Pa+32|0;j=i;k=e+48|0;l=c[k>>2]|0;m=e+52|0;n=(c[m>>2]|0)+38|0;o=(b[n>>1]|0)+1<<16>>16;b[n>>1]=o;if((o&65535)>200)$d(l,200,7120);o=e+16|0;a:do switch(c[o>>2]|0){case 271:{p=1;q=6;break}case 45:{p=0;q=6;break}case 35:{p=2;q=6;break}case 287:{c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=5;c[f+8>>2]=0;g[f+8>>3]=+g[e+24>>3];q=18;break}case 289:{n=Bg(l,c[e+24>>2]|0)|0;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=4;c[f+8>>2]=n;q=18;break}case 270:{c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=1;c[f+8>>2]=0;q=18;break}case 276:{c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=2;c[f+8>>2]=0;q=18;break}case 263:{c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=3;c[f+8>>2]=0;q=18;break}case 280:{if(!(a[(c[l>>2]|0)+77>>0]|0))ah(e,7440);else{n=pg(l,38,0,1,0)|0;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=13;c[f+8>>2]=n;q=18;break a}break}case 123:{le(e,f);break}case 265:{eh(e);he(e,f,0,c[e+4>>2]|0);break}default:ie(e,f)}while(0);if((q|0)==6){l=c[e+4>>2]|0;eh(e);be(e,f,8)|0;Tg(c[k>>2]|0,p,f,l)}else if((q|0)==18)eh(e);do switch(c[o>>2]|0){case 43:{r=0;break}case 45:{r=1;break}case 42:{r=2;break}case 47:{r=3;break}case 37:{r=4;break}case 94:{r=5;break}case 279:{r=6;break}case 284:{r=10;break}case 281:{r=7;break}case 60:{r=8;break}case 283:{r=9;break}case 62:{r=11;break}case 282:{r=12;break}case 257:{r=13;break}case 272:{r=14;break}default:{s=15;t=c[m>>2]|0;u=t+38|0;v=b[u>>1]|0;w=v+-1<<16>>16;b[u>>1]=w;Pa=i;return s|0}}while(0);o=e+4|0;l=r;while(1){if((d[320+(l<<1)>>0]|0)<=(h|0)){s=l;q=37;break}r=c[o>>2]|0;eh(e);Vg(c[k>>2]|0,l,f);p=l;l=be(e,j,d[320+(l<<1)+1>>0]|0)|0;Wg(c[k>>2]|0,p,f,j,r);if((l|0)==15){s=15;q=37;break}}if((q|0)==37){t=c[m>>2]|0;u=t+38|0;v=b[u>>1]|0;w=v+-1<<16>>16;b[u>>1]=w;Pa=i;return s|0}return 0}function ce(d,e){d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;f=c[d+48>>2]|0;g=c[d+64>>2]|0;h=c[f>>2]|0;i=h+60|0;j=c[i>>2]|0;k=f+44|0;if((j|0)>(b[k>>1]|0)){l=j;m=c[h+24>>2]|0}else{n=h+24|0;o=Fd(c[d+52>>2]|0,c[n>>2]|0,i,12,32767,7424)|0;c[n>>2]=o;l=c[i>>2]|0;m=o}if((j|0)<(l|0)?(o=j+1|0,c[m+(j*12|0)>>2]=0,(o|0)<(l|0)):0){j=o;do{c[m+(j*12|0)>>2]=0;j=j+1|0}while((j|0)!=(l|0))}l=b[k>>1]|0;j=l<<16>>16;c[m+(j*12|0)>>2]=e;if((a[e+5>>0]&3)!=0?(a[h+5>>0]&4)!=0:0){jd(c[d+52>>2]|0,h,e);e=b[k>>1]|0;p=e<<16>>16;q=e}else{p=j;q=l}b[k>>1]=q+1<<16>>16;q=g+4|0;k=c[q>>2]|0;l=k+1|0;if((l-(c[f+40>>2]|0)|0)>200)$d(f,200,7424);f=g+8|0;if((k+2|0)>(c[f>>2]|0)){j=Fd(c[d+52>>2]|0,c[g>>2]|0,f,2,2147483645,7424)|0;c[g>>2]=j;f=c[q>>2]|0;r=f+1|0;s=j;t=f;u=p&65535;c[q>>2]=r;v=s+(t<<1)|0;b[v>>1]=u;return}else{r=l;s=c[g>>2]|0;t=k;u=p&65535;c[q>>2]=r;v=s+(t<<1)|0;b[v>>1]=u;return}}function de(e,f,g,h,i){e=e|0;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;j=Pa;Pa=Pa+32|0;k=j+12|0;l=j;m=e+48|0;n=c[m>>2]|0;o=n+46|0;p=a[o>>0]|0;a[o>>0]=(p&255)+3;q=c[n+20>>2]|0;r=n+12|0;s=c[(c[n>>2]|0)+24>>2]|0;t=c[c[(c[r>>2]|0)+64>>2]>>2]|0;u=(c[n+40>>2]|0)+(p+3&255)|0;c[s+((b[t+(u+-3<<1)>>1]|0)*12|0)+4>>2]=q;c[s+((b[t+(u+-2<<1)>>1]|0)*12|0)+4>>2]=q;c[s+((b[t+(u+-1<<1)>>1]|0)*12|0)+4>>2]=q;q=e+16|0;if((c[q>>2]|0)!=259)Ud(e,259);eh(e);u=(i|0)!=0;if(u)v=rg(n,33,f,131070)|0;else v=qg(n)|0;a[l+10>>0]=0;a[l+8>>0]=a[o>>0]|0;o=c[(c[r>>2]|0)+64>>2]|0;b[l+4>>1]=c[o+28>>2];b[l+6>>1]=c[o+16>>2];a[l+9>>0]=0;o=n+16|0;c[l>>2]=c[o>>2];c[o>>2]=l;l=c[m>>2]|0;o=l+46|0;r=(d[o>>0]|0)+h|0;a[o>>0]=r;if(h|0){o=c[l+20>>2]|0;i=c[(c[l>>2]|0)+24>>2]|0;t=c[c[(c[l+12>>2]|0)+64>>2]>>2]|0;s=(c[l+40>>2]|0)+(r&255)|0;r=h;do{c[i+((b[t+(s-r<<1)>>1]|0)*12|0)+4>>2]=o;r=r+-1|0}while((r|0)!=0)}Ag(n,h);r=c[m>>2]|0;a[k+10>>0]=0;a[k+8>>0]=a[r+46>>0]|0;m=c[(c[r+12>>2]|0)+64>>2]|0;b[k+4>>1]=c[m+28>>2];b[k+6>>1]=c[m+16>>2];a[k+9>>0]=0;m=r+16|0;c[k>>2]=c[m>>2];c[m>>2]=k;a:do{k=c[q>>2]|0;switch(k|0){case 277:case 286:case 262:case 261:case 260:{break a;break}default:{}}Td(e)}while((k|0)!=274);Wd(r);Wd(n);wg(n,v);if(u){w=rg(n,32,f,131070)|0;x=v+1|0;vg(n,w,x);Yg(n,g);Pa=j;return}else{pg(n,34,f,0,h)|0;Yg(n,g);w=rg(n,35,f+2|0,131070)|0;x=v+1|0;vg(n,w,x);Yg(n,g);Pa=j;return}}function ee(a,b,e,f){a=a|0;b=b|0;e=e|0;f=f|0;var g=0;g=b-e|0;switch(c[f>>2]|0){case 13:case 12:{e=g+1|0;b=(e|0)>0?e:0;Eg(a,f,b);if((b|0)<=1)return;Ag(a,b+-1|0);return}case 0:break;default:Hg(a,f)}if((g|0)<=0)return;f=d[a+48>>0]|0;Ag(a,g);ng(a,f,g);return}function fe(e,f,g,h){e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;if(!e){i=0;return i|0}j=a[e+46>>0]|0;a:do if(j<<24>>24){k=e+12|0;l=e+40|0;m=j&255;while(1){n=m+-1|0;if(xe(f,c[(c[(c[e>>2]|0)+24>>2]|0)+((b[(c[c[(c[k>>2]|0)+64>>2]>>2]|0)+((c[l>>2]|0)+n<<1)>>1]|0)*12|0)>>2]|0)|0)break;if((m|0)>1)m=n;else break a}if((m|0)>0){c[g+16>>2]=-1;c[g+20>>2]=-1;c[g>>2]=7;c[g+8>>2]=n;if(h|0){i=7;return i|0}l=e+16|0;do l=c[l>>2]|0;while((m|0)<=(d[l+8>>0]|0));a[l+9>>0]=1;i=7;return i|0}}while(0);h=c[(c[e>>2]|0)+28>>2]|0;n=e+47|0;b:do if(!(a[n>>0]|0))o=15;else{j=0;while(1){if(xe(c[h+(j<<3)>>2]|0,f)|0){p=j;break b}j=j+1|0;if(j>>>0>=(d[n>>0]|0)>>>0){o=15;break}}}while(0);do if((o|0)==15)if(!(fe(c[e+8>>2]|0,f,g,0)|0)){i=0;return i|0}else{p=Sd(e,f,g)|0;break}while(0);c[g+16>>2]=-1;c[g+20>>2]=-1;c[g>>2]=8;c[g+8>>2]=p;i=8;return i|0}function ge(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0;d=Pa;Pa=Pa+32|0;e=d;f=a+48|0;g=c[f>>2]|0;Lg(g,b);eh(a);if((c[a+16>>2]|0)==288){h=c[a+24>>2]|0;eh(a);i=Bg(c[f>>2]|0,h)|0;c[e+16>>2]=-1;c[e+20>>2]=-1;c[e>>2]=4;c[e+8>>2]=i;Sg(g,b,e);Pa=d;return}else Ud(a,288)}function he(e,f,g,h){e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;i=Pa;Pa=Pa+80|0;j=i;k=i+24|0;l=i+12|0;m=e+48|0;n=c[m>>2]|0;o=e+52|0;p=c[o>>2]|0;q=c[n>>2]|0;r=n+36|0;n=q+56|0;s=c[n>>2]|0;t=q+16|0;if(((c[r>>2]|0)>=(s|0)?(u=Fd(p,c[t>>2]|0,n,4,262143,7384)|0,c[t>>2]=u,v=c[n>>2]|0,(s|0)<(v|0)):0)?(n=s+1|0,c[u+(s<<2)>>2]=0,(n|0)<(v|0)):0){s=n;do{c[(c[t>>2]|0)+(s<<2)>>2]=0;s=s+1|0}while((s|0)!=(v|0))}v=gd(p)|0;s=c[t>>2]|0;t=c[r>>2]|0;c[r>>2]=t+1;c[s+(t<<2)>>2]=v;if(a[v+5>>0]&3?a[q+5>>0]&4:0)jd(p,q,v);c[k>>2]=v;c[v+64>>2]=h;q=c[o>>2]|0;c[k+8>>2]=c[m>>2];p=k+12|0;c[p>>2]=e;c[m>>2]=k;c[k+20>>2]=0;c[k+24>>2]=0;c[k+28>>2]=-1;c[k+32>>2]=0;c[k+36>>2]=0;t=k+44|0;c[t>>2]=0;a[t+4>>0]=0;c[k+40>>2]=c[(c[e+64>>2]|0)+4>>2];t=k+16|0;c[t>>2]=0;c[v+36>>2]=c[e+68>>2];a[v+78>>0]=2;v=Le(q)|0;c[k+4>>2]=v;s=q+8|0;r=c[s>>2]|0;c[r>>2]=v;c[r+8>>2]=69;r=(c[s>>2]|0)+16|0;c[s>>2]=r;if(((c[q+24>>2]|0)-r|0)<16)Mc(q,0);a[l+10>>0]=0;a[l+8>>0]=a[k+46>>0]|0;q=c[(c[p>>2]|0)+64>>2]|0;b[l+4>>1]=c[q+28>>2];b[l+6>>1]=c[q+16>>2];a[l+9>>0]=0;c[l>>2]=c[t>>2];c[t>>2]=l;l=e+16|0;if((c[l>>2]|0)!=40)Ud(e,40);eh(e);if(!g){g=c[m>>2]|0;w=c[g>>2]|0;x=g}else{ce(e,ch(e,7394,4)|0);g=c[m>>2]|0;t=g+46|0;q=a[t>>0]|0;a[t>>0]=(q&255)+1;t=c[g>>2]|0;c[(c[t+24>>2]|0)+((b[(c[c[(c[g+12>>2]|0)+64>>2]>>2]|0)+((c[g+40>>2]|0)+(q+1&255)+-1<<1)>>1]|0)*12|0)+4>>2]=c[g+20>>2];w=t;x=g}g=w+77|0;a[g>>0]=0;t=c[l>>2]|0;a:do if((t|0)!=41){q=e+24|0;p=0;r=t;b:while(1){switch(r|0){case 280:{y=20;break b;break}case 288:break;default:{y=21;break b}}s=c[q>>2]|0;eh(e);ce(e,s);s=p+1|0;if(a[g>>0]|0){z=s;break a}if((c[l>>2]|0)!=44){z=s;break a}eh(e);p=s;r=c[l>>2]|0}if((y|0)==20){eh(e);a[g>>0]=1;z=p;break}else if((y|0)==21)ah(e,7399)}else z=0;while(0);g=c[m>>2]|0;t=g+46|0;r=z+(d[t>>0]|0)|0;a[t>>0]=r;if(z|0){t=c[g+20>>2]|0;q=c[(c[g>>2]|0)+24>>2]|0;s=c[c[(c[g+12>>2]|0)+64>>2]>>2]|0;v=(c[g+40>>2]|0)+(r&255)|0;r=z;do{c[q+((b[s+(v-r<<1)>>1]|0)*12|0)+4>>2]=t;r=r+-1|0}while((r|0)!=0)}r=a[x+46>>0]|0;a[w+76>>0]=r;Ag(x,r&255);if((c[l>>2]|0)!=41)Ud(e,41);eh(e);c:while(1){r=c[l>>2]|0;switch(r|0){case 277:case 286:case 262:case 261:case 260:{A=r;break c;break}default:{}}Td(e);if((r|0)==274){y=32;break}}if((y|0)==32)A=c[l>>2]|0;l=c[e+4>>2]|0;c[(c[k>>2]|0)+68>>2]=l;if((A|0)==262){eh(e);A=c[(c[m>>2]|0)+8>>2]|0;m=rg(A,37,0,(c[A+36>>2]|0)+-1|0)|0;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=11;c[f+8>>2]=m;Hg(A,f);Vd(e);Pa=i;return}if((l|0)==(h|0))Ud(e,262);else{l=c[o>>2]|0;o=$g(e,262)|0;i=$g(e,265)|0;c[j>>2]=o;c[j+4>>2]=i;c[j+8>>2]=h;ah(e,Pd(l,7129,j)|0)}}function ie(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;d=Pa;Pa=Pa+48|0;e=d+24|0;f=d;g=a+48|0;h=c[g>>2]|0;i=a+4|0;j=c[i>>2]|0;k=a+16|0;a:do switch(c[k>>2]|0){case 40:{eh(a);be(a,b,0)|0;if((c[k>>2]|0)==41){eh(a);Gg(c[g>>2]|0,b);l=a+24|0;break a}if((c[i>>2]|0)==(j|0))Ud(a,41);else{m=c[a+52>>2]|0;n=$g(a,41)|0;o=$g(a,40)|0;c[e>>2]=n;c[e+4>>2]=o;c[e+8>>2]=j;ah(a,Pd(m,7129,e)|0)}break}case 288:{m=a+24|0;o=c[m>>2]|0;eh(a);n=c[g>>2]|0;if(!(fe(n,o,b,1)|0)){fe(n,c[a+72>>2]|0,b,1)|0;p=Bg(c[g>>2]|0,o)|0;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=4;c[f+8>>2]=p;Sg(n,b,f);l=m}else l=m;break}default:ah(a,7315)}while(0);e=f+16|0;i=f+20|0;m=f+8|0;b:while(1)switch(c[k>>2]|0){case 46:{ge(a,b);break}case 91:{Lg(h,b);eh(a);be(a,f,0)|0;Mg(c[g>>2]|0,f);if((c[k>>2]|0)!=93){q=14;break b}eh(a);Sg(h,b,f);break}case 58:{eh(a);if((c[k>>2]|0)!=288){q=17;break b}n=c[l>>2]|0;eh(a);p=Bg(c[g>>2]|0,n)|0;c[e>>2]=-1;c[i>>2]=-1;c[f>>2]=4;c[m>>2]=p;Pg(h,b,f);ke(a,b,j);break}case 123:case 289:case 40:{Hg(h,b);ke(a,b,j);break}default:{q=21;break b}}if((q|0)==14)Ud(a,93);else if((q|0)==17)Ud(a,288);else if((q|0)==21){Pa=d;return}}function je(f,g,h){f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;i=Pa;Pa=Pa+64|0;j=i+32|0;k=i;l=g+8|0;if(((c[l>>2]|0)+-7|0)>>>0>=3)ah(f,7302);m=f+16|0;a:do switch(c[m>>2]|0){case 44:{eh(f);c[k>>2]=g;n=k+8|0;ie(f,n);o=c[n>>2]|0;if((o|0)!=9){n=c[f+48>>2]|0;p=a[n+48>>0]|0;q=k+16|0;r=p&255;s=(o|0)==7;t=g;u=0;while(1){if((c[t+8>>2]|0)==9){v=t+16|0;w=v+3|0;if((o|0)==(d[w>>0]|0)?(x=v+2|0,(c[q>>2]|0)==(d[x>>0]|0)):0){a[w>>0]=7;a[x>>0]=p;y=1}else y=u;if(s?(c[q>>2]|0)==(b[v>>1]|0):0){b[v>>1]=r;z=1}else z=y}else z=u;t=c[t>>2]|0;if(!t)break;else u=z}if(z|0){pg(n,(o|0)==7?0:5,p&255,c[q>>2]|0,0)|0;Ag(n,1)}}if(((e[(c[f+52>>2]|0)+38>>1]|0)+h|0)>200)$d(c[f+48>>2]|0,200,7120);else{je(f,k,h+1|0);A=f+48|0;break a}break}case 61:{eh(f);be(f,j,0)|0;u=f+48|0;if((c[m>>2]|0)==44){t=1;while(1){eh(f);Hg(c[u>>2]|0,j);be(f,j,0)|0;r=t+1|0;if((c[m>>2]|0)==44)t=r;else{B=r;break}}}else B=1;t=c[u>>2]|0;if((B|0)==(h|0)){Fg(t,j);Og(c[u>>2]|0,l,j);Pa=i;return}else{ee(t,h,B,j);if((B|0)<=(h|0)){A=u;break a}t=(c[u>>2]|0)+48|0;a[t>>0]=h-B+(d[t>>0]|0);A=u;break a}break}default:Ud(f,61)}while(0);f=c[A>>2]|0;A=(d[f+48>>0]|0)+-1|0;c[j+16>>2]=-1;c[j+20>>2]=-1;c[j>>2]=6;c[j+8>>2]=A;Og(f,l,j);Pa=i;return}function ke(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;g=Pa;Pa=Pa+48|0;h=g+24|0;i=g;j=b+48|0;k=c[j>>2]|0;l=b+16|0;switch(c[l>>2]|0){case 40:{eh(b);if((c[l>>2]|0)!=41){be(b,i,0)|0;if((c[l>>2]|0)==44)do{eh(b);Hg(c[j>>2]|0,i);be(b,i,0)|0}while((c[l>>2]|0)==44);Eg(k,i,-1);if((c[l>>2]|0)!=41)if((c[b+4>>2]|0)==(f|0))Ud(b,41);else{l=c[b+52>>2]|0;j=$g(b,41)|0;m=$g(b,40)|0;c[h>>2]=j;c[h+4>>2]=m;c[h+8>>2]=f;ah(b,Pd(l,7129,h)|0)}}else c[i>>2]=0;eh(b);break}case 123:{le(b,i);break}case 289:{h=Bg(k,c[b+24>>2]|0)|0;c[i+16>>2]=-1;c[i+20>>2]=-1;c[i>>2]=4;c[i+8>>2]=h;eh(b);break}default:ah(b,7333)}b=e+8|0;h=c[b>>2]|0;switch(c[i>>2]|0){case 0:break;case 13:case 12:{n=0;o=pg(k,29,h,n,2)|0;p=e+16|0;c[p>>2]=-1;q=e+20|0;c[q>>2]=-1;c[e>>2]=12;c[b>>2]=o;Yg(k,f);r=h+1|0;s=r&255;t=k+48|0;a[t>>0]=s;Pa=g;return}default:Hg(k,i)}n=(d[k+48>>0]|0)-h|0;o=pg(k,29,h,n,2)|0;p=e+16|0;c[p>>2]=-1;q=e+20|0;c[q>>2]=-1;c[e>>2]=12;c[b>>2]=o;Yg(k,f);r=h+1|0;s=r&255;t=k+48|0;a[t>>0]=s;Pa=g;return}function le(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;d=Pa;Pa=Pa+64|0;e=d+40|0;f=d;g=a+48|0;h=c[g>>2]|0;i=a+4|0;j=c[i>>2]|0;k=pg(h,11,0,0,0)|0;l=f+36|0;c[l>>2]=0;m=f+28|0;c[m>>2]=0;n=f+32|0;c[n>>2]=0;o=f+24|0;c[o>>2]=b;c[b+16>>2]=-1;c[b+20>>2]=-1;c[b>>2]=11;c[b+8>>2]=k;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=0;c[f+8>>2]=0;Hg(c[g>>2]|0,b);b=a+16|0;if((c[b>>2]|0)!=123)Ud(a,123);eh(a);a:do if((c[b>>2]|0)!=125){p=0;b:while(1){if(p|0?(Hg(h,f),c[f>>2]=0,(c[l>>2]|0)==50):0){Zg(h,c[(c[o>>2]|0)+8>>2]|0,c[n>>2]|0,50);c[l>>2]=0}c:do switch(c[b>>2]|0){case 288:{if((kh(a)|0)==61){me(a,f);break c}be(a,f,0)|0;q=c[n>>2]|0;if((q|0)>2147483645){r=14;break b}c[n>>2]=q+1;c[l>>2]=(c[l>>2]|0)+1;break}case 91:{me(a,f);break}default:{be(a,f,0)|0;q=c[n>>2]|0;if((q|0)>2147483645){r=19;break b}c[n>>2]=q+1;c[l>>2]=(c[l>>2]|0)+1}}while(0);switch(c[b>>2]|0){case 125:{break a;break}case 44:{eh(a);break}case 59:{eh(a);break}default:{r=23;break b}}if((c[b>>2]|0)==125)break a;p=c[f>>2]|0}if((r|0)==14)$d(c[g>>2]|0,2147483645,7361);else if((r|0)==19)$d(c[g>>2]|0,2147483645,7361);else if((r|0)==23)if((c[i>>2]|0)==(j|0))Ud(a,125);else{p=c[a+52>>2]|0;q=$g(a,125)|0;s=$g(a,123)|0;c[e>>2]=q;c[e+4>>2]=s;c[e+8>>2]=j;ah(a,Pd(p,7129,e)|0)}}while(0);eh(a);a=c[l>>2]|0;d:do if(a|0){switch(c[f>>2]|0){case 13:case 12:{Eg(h,f,-1);Zg(h,c[(c[o>>2]|0)+8>>2]|0,c[n>>2]|0,-1);c[n>>2]=(c[n>>2]|0)+-1;break d;break}case 0:{t=a;break}default:{Hg(h,f);t=c[l>>2]|0}}Zg(h,c[(c[o>>2]|0)+8>>2]|0,c[n>>2]|0,t)}while(0);t=c[(c[(c[h>>2]|0)+12>>2]|0)+(k<<2)>>2]&8388607;o=(Id(c[n>>2]|0)|0)<<23|t;c[(c[(c[h>>2]|0)+12>>2]|0)+(k<<2)>>2]=o;t=(Id(c[m>>2]|0)|0)<<14&8372224|o&-8372225;c[(c[(c[h>>2]|0)+12>>2]|0)+(k<<2)>>2]=t;Pa=d;return}function me(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;e=Pa;Pa=Pa+48|0;f=e+24|0;g=e;h=b+48|0;i=c[h>>2]|0;j=i+48|0;k=a[j>>0]|0;l=b+16|0;do if((c[l>>2]|0)==288){m=d+28|0;if((c[m>>2]|0)>2147483645)$d(i,2147483645,7361);else{n=c[b+24>>2]|0;eh(b);o=Bg(c[h>>2]|0,n)|0;c[f+16>>2]=-1;c[f+20>>2]=-1;c[f>>2]=4;c[f+8>>2]=o;p=m;break}}else{eh(b);be(b,f,0)|0;Mg(c[h>>2]|0,f);if((c[l>>2]|0)==93){eh(b);p=d+28|0;break}else Ud(b,93)}while(0);c[p>>2]=(c[p>>2]|0)+1;if((c[l>>2]|0)==61){eh(b);l=Ng(i,f)|0;be(b,g,0)|0;f=c[(c[d+24>>2]|0)+8>>2]|0;pg(i,10,f,l,Ng(i,g)|0)|0;a[j>>0]=k;Pa=e;return}else Ud(b,61)}function ne(a,b){a=a|0;b=b|0;var d=0,e=0;d=a+12|0;e=a+8|0;c[e>>2]=(c[d>>2]|0)-b+(c[e>>2]|0);c[d>>2]=b;return}function oe(a){a=a|0;var b=0,d=0;b=Hd(a,0,0,40)|0;d=c[a+16>>2]|0;c[d+12>>2]=b;c[b+8>>2]=d;c[b+12>>2]=0;return b|0}function pe(a){a=a|0;var b=0,d=0;b=(c[a+16>>2]|0)+12|0;d=c[b>>2]|0;c[b>>2]=0;if(!d)return;b=d;do{d=b;b=c[b+12>>2]|0;Hd(a,d,40,0)|0}while((b|0)!=0);return}function qe(d){d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=d+12|0;if((c[(c[e>>2]|0)+12>>2]|0)>0)Ed(d);f=od(d,8,112,0,0)|0;g=d+8|0;h=c[g>>2]|0;c[h>>2]=f;c[h+8>>2]=72;c[g>>2]=(c[g>>2]|0)+16;c[f+12>>2]=c[e>>2];e=f+28|0;c[e>>2]=0;g=f+16|0;c[g>>2]=0;h=f+32|0;c[h>>2]=0;c[f+64>>2]=0;b[f+38>>1]=0;i=f+52|0;c[i>>2]=0;j=f+40|0;a[j>>0]=0;k=f+44|0;c[k>>2]=0;a[f+41>>0]=1;c[f+56>>2]=0;b[f+36>>1]=1;a[f+6>>0]=0;c[f+68>>2]=0;a[j>>0]=a[d+40>>0]|0;j=c[d+44>>2]|0;c[k>>2]=j;c[i>>2]=c[d+52>>2];c[f+48>>2]=j;j=Hd(d,0,0,640)|0;c[e>>2]=j;c[h>>2]=40;h=j+8|0;c[h>>2]=0;c[j+24>>2]=0;c[j+40>>2]=0;c[j+56>>2]=0;c[j+72>>2]=0;c[j+88>>2]=0;c[j+104>>2]=0;c[j+120>>2]=0;c[j+136>>2]=0;c[j+152>>2]=0;c[j+168>>2]=0;c[j+184>>2]=0;c[j+200>>2]=0;c[j+216>>2]=0;c[j+232>>2]=0;c[j+248>>2]=0;c[j+264>>2]=0;c[j+280>>2]=0;c[j+296>>2]=0;c[j+312>>2]=0;c[j+328>>2]=0;c[j+344>>2]=0;c[j+360>>2]=0;c[j+376>>2]=0;c[j+392>>2]=0;c[j+408>>2]=0;c[j+424>>2]=0;c[j+440>>2]=0;c[j+456>>2]=0;c[j+472>>2]=0;c[j+488>>2]=0;c[j+504>>2]=0;c[j+520>>2]=0;c[j+536>>2]=0;c[j+552>>2]=0;c[j+568>>2]=0;c[j+584>>2]=0;c[j+600>>2]=0;c[j+616>>2]=0;c[j+632>>2]=0;c[f+24>>2]=j+560;e=f+72|0;c[f+80>>2]=0;c[f+84>>2]=0;a[f+90>>0]=0;c[e>>2]=j;c[f+8>>2]=j+16;c[h>>2]=0;c[f+76>>2]=j+336;c[g>>2]=e;return f|0}function re(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;d=b+28|0;fd(b,c[d>>2]|0);e=c[d>>2]|0;if(!e){Hd(a,b,112,0)|0;return}c[b+16>>2]=b+72;f=b+84|0;g=c[f>>2]|0;c[f>>2]=0;if(!g)h=e;else{e=g;do{g=e;e=c[e+12>>2]|0;Hd(b,g,40,0)|0}while((e|0)!=0);h=c[d>>2]|0}Hd(b,h,c[b+32>>2]<<4,0)|0;Hd(a,b,112,0)|0;return}function se(d,e){d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;f=Pa;Pa=Pa+32|0;g=f;h=f+16|0;i=Wa[d&255](e,0,8,400)|0;if(!i){j=0;Pa=f;return j|0}k=i+112|0;c[i>>2]=0;a[i+4>>0]=8;a[i+172>>0]=33;a[i+5>>0]=1;a[i+174>>0]=0;c[i+12>>2]=k;c[i+28>>2]=0;c[i+16>>2]=0;c[i+32>>2]=0;c[i+64>>2]=0;b[i+38>>1]=0;c[i+52>>2]=0;a[i+40>>0]=0;c[i+44>>2]=0;a[i+41>>0]=1;c[i+48>>2]=0;c[i+56>>2]=0;b[i+36>>1]=1;a[i+6>>0]=0;c[i+68>>2]=0;c[k>>2]=d;c[i+116>>2]=e;c[i+284>>2]=i;e=Ka(0)|0;c[h>>2]=e;c[g>>2]=i;c[g+4>>2]=h;c[g+8>>2]=15792;c[g+12>>2]=129;h=ye(g,16,e)|0;c[i+168>>2]=h;h=i+224|0;c[i+240>>2]=h;c[i+244>>2]=h;a[i+175>>0]=0;h=i+132|0;c[i+160>>2]=0;c[i+256>>2]=0;c[i+264>>2]=0;c[i+280>>2]=0;c[h>>2]=0;c[h+4>>2]=0;c[h+8>>2]=0;c[h+12>>2]=0;h=eb(0)|0;c[i+288>>2]=h;a[i+173>>0]=5;h=i+120|0;e=i+180|0;g=e+40|0;do{c[e>>2]=0;e=e+4|0}while((e|0)<(g|0));c[h>>2]=400;c[i+124>>2]=0;c[i+268>>2]=200;c[i+272>>2]=200;c[i+276>>2]=200;e=i+364|0;g=e+36|0;do{c[e>>2]=0;e=e+4|0}while((e|0)<(g|0));if(!(Kc(i,135,0)|0)){j=i;Pa=f;return j|0}ue(i);j=0;Pa=f;return j|0}function te(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0;d=Pa;Pa=Pa+16|0;e=d;f=c[b+12>>2]|0;g=Hd(b,0,0,640)|0;c[b+28>>2]=g;c[b+32>>2]=40;h=g+8|0;c[h>>2]=0;c[g+24>>2]=0;c[g+40>>2]=0;c[g+56>>2]=0;c[g+72>>2]=0;c[g+88>>2]=0;c[g+104>>2]=0;c[g+120>>2]=0;c[g+136>>2]=0;c[g+152>>2]=0;c[g+168>>2]=0;c[g+184>>2]=0;c[g+200>>2]=0;c[g+216>>2]=0;c[g+232>>2]=0;c[g+248>>2]=0;c[g+264>>2]=0;c[g+280>>2]=0;c[g+296>>2]=0;c[g+312>>2]=0;c[g+328>>2]=0;c[g+344>>2]=0;c[g+360>>2]=0;c[g+376>>2]=0;c[g+392>>2]=0;c[g+408>>2]=0;c[g+424>>2]=0;c[g+440>>2]=0;c[g+456>>2]=0;c[g+472>>2]=0;c[g+488>>2]=0;c[g+504>>2]=0;c[g+520>>2]=0;c[g+536>>2]=0;c[g+552>>2]=0;c[g+568>>2]=0;c[g+584>>2]=0;c[g+600>>2]=0;c[g+616>>2]=0;c[g+632>>2]=0;c[b+24>>2]=g+560;i=b+72|0;c[b+80>>2]=0;c[b+84>>2]=0;a[b+90>>0]=0;c[i>>2]=g;c[b+8>>2]=g+16;c[h>>2]=0;c[b+76>>2]=g+336;c[b+16>>2]=i;i=Le(b)|0;c[f+40>>2]=i;c[f+48>>2]=69;Fe(b,i,2,0);c[e>>2]=b;g=e+8|0;c[g>>2]=72;Ie(b,i,1,e);h=Le(b)|0;c[e>>2]=h;c[g>>2]=69;Ie(b,i,2,e);ze(b,32);Qe(b);_g(b);e=Ae(b,7558,17)|0;c[f+180>>2]=e;b=e+5|0;a[b>>0]=a[b>>0]|32;a[f+63>>0]=1;Pa=d;return}function ue(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;b=a+12|0;d=c[b>>2]|0;e=a+28|0;fd(a,c[e>>2]|0);zd(a);f=c[b>>2]|0;Hd(a,c[f+24>>2]|0,c[f+32>>2]<<2,0)|0;f=d+144|0;b=d+152|0;g=Hd(a,c[f>>2]|0,c[b>>2]|0,0)|0;c[f>>2]=g;c[b>>2]=0;b=c[e>>2]|0;if(!b){h=c[d>>2]|0;i=d+4|0;j=c[i>>2]|0;Wa[h&255](j,a,400,0)|0;return}c[a+16>>2]=a+72;g=a+84|0;f=c[g>>2]|0;c[g>>2]=0;if(!f)k=b;else{b=f;do{f=b;b=c[b+12>>2]|0;Hd(a,f,40,0)|0}while((b|0)!=0);k=c[e>>2]|0}Hd(a,k,c[a+32>>2]<<4,0)|0;h=c[d>>2]|0;i=d+4|0;j=c[i>>2]|0;Wa[h&255](j,a,400,0)|0;return}function ve(a){a=a|0;ue(c[(c[a+12>>2]|0)+172>>2]|0);return}function we(a,b){a=a|0;b=b|0;var d=0,e=0;d=c[a+12>>2]|0;if((a|0)==(b|0)){e=1;return e|0}if((d|0)!=(c[b+12>>2]|0)){e=0;return e|0}e=(Mm(a+16|0,b+16|0,d)|0)==0&1;return e|0}function xe(b,d){b=b|0;d=d|0;var e=0,f=0,g=0;e=a[b+4>>0]|0;if(e<<24>>24!=(a[d+4>>0]|0)){f=0;return f|0}if(e<<24>>24!=4){e=c[b+12>>2]|0;if((b|0)!=(d|0))if((e|0)==(c[d+12>>2]|0))g=(Mm(b+16|0,d+16|0,e)|0)==0;else g=0;else g=1}else g=(b|0)==(d|0);f=g&1;return f|0}function ye(a,b,c){a=a|0;b=b|0;c=c|0;var e=0,f=0,g=0,h=0;e=c^b;c=b>>>5;if(c>>>0>=b>>>0){f=e;return f|0}g=~c;h=b;b=e;while(1){e=(b<<5)+(b>>>2)+(d[a+(h+-1)>>0]|0)^b;h=h+g|0;if(h>>>0<=c>>>0){f=e;break}else b=e}return f|0}function ze(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;e=c[b+12>>2]|0;f=e+24|0;yd(b,-5);g=e+32|0;e=c[g>>2]|0;if((e|0)<(d|0)){if((d+1|0)>>>0>1073741823)Gd(b);h=Hd(b,c[f>>2]|0,e<<2,d<<2)|0;c[f>>2]=h;i=c[g>>2]|0;if((i|0)<(d|0)?(c[h+(i<<2)>>2]=0,h=i+1|0,(h|0)!=(d|0)):0){j=h;do{c[(c[f>>2]|0)+(j<<2)>>2]=0;j=j+1|0}while((j|0)!=(d|0));k=i}else k=i}else k=e;if((k|0)>0){e=d+-1|0;i=0;j=k;while(1){h=(c[f>>2]|0)+(i<<2)|0;l=c[h>>2]|0;c[h>>2]=0;if(!l)m=j;else{h=l;do{l=h;h=c[h>>2]|0;n=c[l+8>>2]&e;c[l>>2]=c[(c[f>>2]|0)+(n<<2)>>2];c[(c[f>>2]|0)+(n<<2)>>2]=l;n=l+5|0;a[n>>0]=a[n>>0]&-65}while((h|0)!=0);m=c[g>>2]|0}i=i+1|0;if((i|0)>=(m|0)){o=m;break}else j=m}}else o=k;if((o|0)<=(d|0)){c[g>>2]=d;return}if((d+1|0)>>>0>1073741823)Gd(b);k=Hd(b,c[f>>2]|0,o<<2,d<<2)|0;c[f>>2]=k;c[g>>2]=d;return}function Ae(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;if(f>>>0>=41){if((f+1|0)>>>0>4294967277)Gd(b);g=c[(c[b+12>>2]|0)+56>>2]|0;h=od(b,20,f+17|0,0,0)|0;c[h+12>>2]=f;c[h+8>>2]=g;a[h+6>>0]=0;g=h+16|0;Un(g|0,e|0,f|0)|0;a[g+f>>0]=0;i=h;return i|0}h=c[b+12>>2]|0;g=c[h+56>>2]^f;j=f>>>5;if(j>>>0<f>>>0){k=~j;l=f;m=g;while(1){n=(m<<5)+(m>>>2)+(d[e+(l+-1)>>0]|0)^m;l=l+k|0;if(l>>>0<=j>>>0){o=n;break}else m=n}}else o=g;g=h+24|0;m=h+32|0;j=c[m>>2]|0;l=(c[g>>2]|0)+((j+-1&o)<<2)|0;k=c[l>>2]|0;a:do if(k|0){n=k;while(1){if(((o|0)==(c[n+8>>2]|0)?(c[n+12>>2]|0)==(f|0):0)?(Mm(e,n+16|0,f)|0)==0:0)break;p=c[n>>2]|0;if(!p)break a;else n=p}p=n+5|0;q=a[p>>0]^3;if(((a[h+60>>0]^3)&q)<<24>>24){i=n;return i|0}a[p>>0]=q;i=n;return i|0}while(0);k=h+28|0;if((j|0)<1073741823?(c[k>>2]|0)>>>0>=j>>>0:0){ze(b,j<<1);r=(c[g>>2]|0)+(((c[m>>2]|0)+-1&o)<<2)|0}else r=l;l=od(b,4,f+17|0,r,0)|0;c[l+12>>2]=f;c[l+8>>2]=o;a[l+6>>0]=0;o=l+16|0;Un(o|0,e|0,f|0)|0;a[o+f>>0]=0;c[k>>2]=(c[k>>2]|0)+1;i=l;return i|0}function Be(a,b){a=a|0;b=b|0;return Ae(a,b,_l(b)|0)|0}function Ce(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;if(b>>>0>4294967269)Gd(a);else{e=od(a,7,b+24|0,0,0)|0;c[e+16>>2]=b;c[e+8>>2]=0;c[e+12>>2]=d;return e|0}return 0}function De(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0.0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;f=Pa;Pa=Pa+16|0;h=f+8|0;i=f;j=e+8|0;switch(c[j>>2]|0){case 0:{k=-1;l=c[b+28>>2]|0;break}case 3:{m=+g[e>>3];g[i>>3]=m+6755399441055744.0;n=c[i>>2]|0;if((n|0)>0&m==+(n|0)?(i=c[b+28>>2]|0,(n|0)<=(i|0)):0){k=n+-1|0;l=i}else o=6;break}default:o=6}do if((o|0)==6){i=Ee(b,e)|0;while(1){n=i+16|0;p=i+24|0;q=c[p>>2]|0;if((q|0)==(c[j>>2]|0)){if(cf(0,n,e)|0){o=13;break}r=c[p>>2]|0}else r=q;if(((r|0)==11?c[j>>2]&64|0:0)?(c[n>>2]|0)==(c[e>>2]|0):0){o=13;break}n=c[i+28>>2]|0;if(!n){o=15;break}else i=n}if((o|0)==13){n=c[b+28>>2]|0;k=(i-(c[b+16>>2]|0)>>5)+n|0;l=n;break}else if((o|0)==15)Dc(a,7576,h)}while(0);h=k+1|0;a:do if((h|0)<(l|0)){a=b+12|0;r=c[a>>2]|0;n=k;q=h;while(1){if(c[r+(q<<4)+8>>2]|0)break;p=q+1|0;if((p|0)<(l|0)){s=q;q=p;n=s}else{t=p;break a}}g[e>>3]=+(n+2|0);c[j>>2]=3;r=c[a>>2]|0;i=r+(q<<4)|0;p=c[i+4>>2]|0;s=e+16|0;c[s>>2]=c[i>>2];c[s+4>>2]=p;c[e+24>>2]=c[r+(q<<4)+8>>2];u=1;Pa=f;return u|0}else t=h;while(0);h=t-l|0;l=1<<(d[b+7>>0]|0);if((h|0)>=(l|0)){u=0;Pa=f;return u|0}t=b+16|0;b=c[t>>2]|0;k=h;while(1){if(c[b+(k<<5)+8>>2]|0)break;h=k+1|0;if((h|0)<(l|0))k=h;else{u=0;o=26;break}}if((o|0)==26){Pa=f;return u|0}o=b+(k<<5)+16|0;l=c[o+4>>2]|0;h=e;c[h>>2]=c[o>>2];c[h+4>>2]=l;c[j>>2]=c[b+(k<<5)+24>>2];b=c[t>>2]|0;t=b+(k<<5)|0;j=c[t+4>>2]|0;l=e+16|0;c[l>>2]=c[t>>2];c[l+4>>2]=j;c[e+24>>2]=c[b+(k<<5)+8>>2];u=1;Pa=f;return u|0}\nfunction Li(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;f=Pa;Pa=Pa+1056|0;h=f+1040|0;i=f;j=gb(b)|0;Jm(d);a:do if((j|0)==1){k=e+1|0;l=Mi(b,d,1)|0}else{Cf(b,j+19|0,10960);m=i+8|0;n=i+8|0;o=e;p=j+-2|0;b:while(1){c:do if((nb(b,o)|0)==3){q=vb(b,o,0)|0;if(!q){r=Am(d)|0;Wk(r,d)|0;Hb(b,0,0)|0;s=(r|0)!=-1&1;break}else{Qf(b,i);r=Lm(Kf(i,q)|0,1,q,d)|0;c[m>>2]=(c[m>>2]|0)+r;Nf(i);s=(r|0)!=0&1;break}}else{r=yb(b,o,0)|0;if(!((r|0)!=0?(a[r>>0]|0)==42:0))qf(b,o,10979)|0;switch(a[r+1>>0]|0){case 110:{c[h>>2]=i;if((wm(d,10994,h)|0)==1){Eb(b,+g[i>>3]);t=1}else{Db(b);t=0}s=t;break c;break}case 108:{s=Mi(b,d,1)|0;break c;break}case 76:{s=Mi(b,d,0)|0;break c;break}case 97:{Qf(b,i);r=Lm(Kf(i,1024)|0,1,1024,d)|0;c[n>>2]=(c[n>>2]|0)+r;if(r>>>0>=1024){r=1024;do{r=r<<(r>>>0<1073741824&1);q=Lm(Kf(i,r)|0,1,r,d)|0;c[n>>2]=(c[n>>2]|0)+q}while(q>>>0>=r>>>0)}Nf(i);s=1;break c;break}default:break b}}while(0);r=o+1|0;if((s|0)!=0&(p|0)!=0){o=r;p=p+-1|0}else{k=r;l=s;break a}}u=qf(b,o,10998)|0;Pa=f;return u|0}while(0);if(mm(d)|0){u=tf(b,0,0)|0;Pa=f;return u|0}if(!l){hb(b,-2);Db(b)}u=k-e|0;Pa=f;return u|0}function Mi(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0;f=Pa;Pa=Pa+1040|0;g=f;Qf(b,g);h=Kf(g,1024)|0;a:do if(Zl(h,1024,d)|0){i=g+8|0;j=h;while(1){k=_l(j)|0;if(k|0?(a[j+(k+-1)>>0]|0)==10:0)break;c[i>>2]=(c[i>>2]|0)+k;j=Kf(g,1024)|0;if(!(Zl(j,1024,d)|0))break a}c[i>>2]=k-e+(c[i>>2]|0);Nf(g);l=1;Pa=f;return l|0}while(0);Nf(g);l=(zb(b,-1)|0)!=0&1;Pa=f;return l|0}function Ni(a,b){a=a|0;b=b|0;var c=0,d=0;c=gb(a)|0;if((c|0)>=19)qf(a,17,11013)|0;mb(a,1);Fb(a,c+-1|0);Mb(a,b);if((c|0)<=1){d=c+2|0;Lb(a,289,d);return}b=1;do{b=b+1|0;mb(a,b)}while((b|0)!=(c|0));d=c+2|0;Lb(a,289,d);return}function Oi(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+16|0;d=b+8|0;e=Ab(a,-1001001)|0;f=vb(a,-1001002,0)|0;if(!(c[e+4>>2]|0)){g=rf(a,11030,b)|0;Pa=b;return g|0}hb(a,1);if((f|0)>=1){h=1;while(1){mb(a,-1001003-h|0);if((h|0)==(f|0))break;else h=h+1|0}}h=Li(a,c[e>>2]|0,2)|0;if(nb(a,0-h|0)|0){g=h;Pa=b;return g|0}if((h|0)>1){e=yb(a,1-h|0,0)|0;c[d>>2]=e;g=rf(a,11053,d)|0;Pa=b;return g|0}if(!(xb(a,-1001003)|0)){g=0;Pa=b;return g|0}hb(a,0);mb(a,-1001001);d=(yf(a,1,10718)|0)+4|0;e=c[d>>2]|0;c[d>>2]=0;Ta[e&511](a)|0;g=0;Pa=b;return g|0}function Pi(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;Rb(a,-1001e3,10740);e=Ab(a,-1)|0;if(!(c[e+4>>2]|0)){c[d>>2]=10744;rf(a,11093,d)|0}d=tf(a,(fm(c[e>>2]|0)|0)==0&1,0)|0;Pa=b;return d|0}function Qi(a){a=a|0;$i(a,10724,13355);return 1}function Ri(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+16|0;d=b+8|0;e=b;if((nb(a,1)|0)==-1)Db(a);if(!(nb(a,1)|0)){Rb(a,-1001e3,10724);kb(a,1);f=(yf(a,1,10718)|0)+4|0;if(!(c[f>>2]|0))rf(a,10869,e)|0;Ni(a,0);Pa=b;return 1}else{e=Bf(a,1,0)|0;f=oc(a,8)|0;g=f+4|0;c[g>>2]=0;wf(a,10718);c[f>>2]=0;c[g>>2]=290;g=qm(e,13355)|0;c[f>>2]=g;if(!g){g=Qk()|0;f=bl(c[g>>2]|0)|0;c[d>>2]=e;c[d+4>>2]=f;rf(a,11161,d)|0}kb(a,1);Ni(a,1);Pa=b;return 1}return 0}function Si(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0;d=Bf(b,1,0)|0;e=Af(b,2,13355,0)|0;f=oc(b,8)|0;g=f+4|0;c[g>>2]=0;wf(b,10718);c[f>>2]=0;c[g>>2]=290;g=a[e>>0]|0;if(!((g<<24>>24!=0?(h=e+1|0,(Xk(13521,g<<24>>24,4)|0)!=0):0)?(g=(a[h>>0]|0)==43?e+2|0:h,!(a[((a[g>>0]|0)==98?g+1|0:g)>>0]|0)):0))qf(b,2,11188)|0;g=qm(d,e)|0;c[f>>2]=g;if(g|0){i=1;return i|0}i=tf(b,0,d)|0;return i|0}function Ti(a){a=a|0;$i(a,10740,11159);return 1}function Ui(a){a=a|0;var b=0,d=0,e=0,f=0;b=Pa;Pa=Pa+16|0;d=Bf(a,1,0)|0;Af(a,2,13355,0)|0;e=oc(a,8)|0;f=e+4|0;c[f>>2]=0;wf(a,10718);rf(a,11137,b)|0;c[e>>2]=0;c[f>>2]=291;f=tf(a,0,d)|0;Pa=b;return f|0}function Vi(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;Rb(a,-1001e3,10724);e=Ab(a,-1)|0;if(!(c[e+4>>2]|0)){c[d>>2]=10728;rf(a,11093,d)|0}d=Li(a,c[e>>2]|0,1)|0;Pa=b;return d|0}function Wi(a){a=a|0;var b=0,d=0,e=0;b=oc(a,8)|0;d=b+4|0;c[d>>2]=0;wf(a,10718);c[b>>2]=0;c[d>>2]=290;d=Fm()|0;c[b>>2]=d;if(d|0){e=1;return e|0}e=tf(a,0,0)|0;return e|0}function Xi(a){a=a|0;var b=0;Ef(a,1);b=xf(a,1,10718)|0;if(!b){Db(a);return 1}if(!(c[b+4>>2]|0)){Hb(a,11120,11)|0;return 1}else{Hb(a,11132,4)|0;return 1}return 0}function Yi(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;Rb(a,-1001e3,10740);e=Ab(a,-1)|0;if(!(c[e+4>>2]|0)){c[d>>2]=10744;rf(a,11093,d)|0}d=Ki(a,c[e>>2]|0,1)|0;Pa=b;return d|0}function Zi(a){a=a|0;var b=0;b=yf(a,1,10718)|0;return tf(a,(bm(c[b>>2]|0)|0)==0&1,0)|0}function _i(a){a=a|0;yf(a,1,10718)|0;return uf(a,-1)|0}function $i(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=Pa;Pa=Pa+16|0;f=e+8|0;g=e;if((nb(a,1)|0)<1){Rb(a,-1001e3,b);Pa=e;return}h=yb(a,1,0)|0;if(h){i=oc(a,8)|0;j=i+4|0;c[j>>2]=0;wf(a,10718);c[i>>2]=0;c[j>>2]=290;j=qm(h,d)|0;c[i>>2]=j;if(!j){j=Qk()|0;i=bl(c[j>>2]|0)|0;c[g>>2]=h;c[g+4>>2]=i;rf(a,11161,g)|0}}else{g=(yf(a,1,10718)|0)+4|0;if(!(c[g>>2]|0))rf(a,10869,f)|0;mb(a,1)}Zb(a,-1001e3,b);Rb(a,-1001e3,b);Pa=e;return}function aj(a){a=a|0;Ub(a,0,28);cg(a,1696,0);Eb(a,3.141592653589793);Zb(a,-2,11201);Eb(a,s);Zb(a,-2,11204);return 1}function bj(a){a=a|0;Eb(a,+u(+(+Ff(a,1))));return 1}function cj(a){a=a|0;Eb(a,+A(+(+Ff(a,1))));return 1}function dj(a){a=a|0;Eb(a,+B(+(+Ff(a,1))));return 1}function ej(a){a=a|0;var b=0.0;b=+Ff(a,1);Eb(a,+D(+b,+(+Ff(a,2))));return 1}function fj(a){a=a|0;Eb(a,+C(+(+Ff(a,1))));return 1}function gj(a){a=a|0;Eb(a,+G(+(+Ff(a,1))));return 1}function hj(a){a=a|0;Eb(a,+mn(+Ff(a,1)));return 1}function ij(a){a=a|0;Eb(a,+x(+(+Ff(a,1))));return 1}function jj(a){a=a|0;Eb(a,+Ff(a,1)/.017453292519943295);return 1}function kj(a){a=a|0;Eb(a,+E(+(+Ff(a,1))));return 1}function lj(a){a=a|0;Eb(a,+t(+(+Ff(a,1))));return 1}function mj(a){a=a|0;var b=0.0;b=+Ff(a,1);Eb(a,b%+Ff(a,2));return 1}function nj(a){a=a|0;var b=0,d=0;b=Pa;Pa=Pa+16|0;d=b;Eb(a,+ql(+Ff(a,1),d));Fb(a,c[d>>2]|0);Pa=b;return 2}function oj(a){a=a|0;var b=0.0;b=+Ff(a,1);Eb(a,+pn(b,Hf(a,2)|0));return 1}function pj(a){a=a|0;Eb(a,+Da(+(+Ff(a,1))));return 1}function qj(a){a=a|0;var b=0.0,c=0.0,d=0.0;b=+Ff(a,1);do if((nb(a,2)|0)>=1){c=+Ff(a,2);if(c==10.0){d=+Da(+b);break}else{d=+F(+b)/+F(+c);break}}else d=+F(+b);while(0);Eb(a,d);return 1}function rj(a){a=a|0;var b=0,c=0.0,d=0.0,e=0,f=0.0,g=0.0;b=gb(a)|0;c=+Ff(a,1);if((b|0)<2){d=c;Eb(a,d);return 1}e=2;f=c;while(1){c=+Ff(a,e);g=c>f?c:f;if((e|0)==(b|0)){d=g;break}else{e=e+1|0;f=g}}Eb(a,d);return 1}function sj(a){a=a|0;var b=0,c=0.0,d=0.0,e=0,f=0.0,g=0.0;b=gb(a)|0;c=+Ff(a,1);if((b|0)<2){d=c;Eb(a,d);return 1}e=2;f=c;while(1){c=+Ff(a,e);g=c<f?c:f;if((e|0)==(b|0)){d=g;break}else{e=e+1|0;f=g}}Eb(a,d);return 1}function tj(a){a=a|0;var b=0,c=0,d=0.0;b=Pa;Pa=Pa+16|0;c=b;d=+nn(+Ff(a,1),c);Eb(a,+g[c>>3]);Eb(a,d);Pa=b;return 2}function uj(a){a=a|0;var b=0.0;b=+Ff(a,1);Eb(a,+w(+b,+(+Ff(a,2))));return 1}function vj(a){a=a|0;Eb(a,+Ff(a,1)*.017453292519943295);return 1}function wj(a){a=a|0;var b=0,c=0.0,d=0,e=0.0,f=0.0;b=Pa;Pa=Pa+16|0;c=+((An()|0)%2147483647|0|0)/2147483647.0;switch(gb(a)|0){case 0:{Eb(a,c);d=1;Pa=b;return d|0}case 1:{e=+Ff(a,1);if(!(e>=1.0))qf(a,1,11347)|0;Eb(a,+t(+(c*e))+1.0);d=1;Pa=b;return d|0}case 2:{e=+Ff(a,1);f=+Ff(a,2);if(!(e<=f))qf(a,2,11347)|0;Eb(a,e+ +t(+(c*(f-e+1.0))));d=1;Pa=b;return d|0}default:{d=rf(a,11365,b)|0;Pa=b;return d|0}}return 0}function xj(a){a=a|0;zn(If(a,1)|0);An()|0;return 0}function yj(a){a=a|0;Eb(a,+hn(+Ff(a,1)));return 1}function zj(a){a=a|0;Eb(a,+y(+(+Ff(a,1))));return 1}function Aj(a){a=a|0;Eb(a,+v(+(+Ff(a,1))));return 1}function Bj(a){a=a|0;Eb(a,+on(+Ff(a,1)));return 1}function Cj(a){a=a|0;Eb(a,+z(+(+Ff(a,1))));return 1}function Dj(a){a=a|0;Ub(a,0,11);cg(a,1936,0);return 1}function Ej(a){a=a|0;Eb(a,+(oa()|0)/1.0e6);return 1}function Fj(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;d=Pa;Pa=Pa+1264|0;e=d+200|0;f=d+1248|0;g=d+1252|0;h=d+208|0;i=d;j=Af(b,1,11600,0)|0;if((nb(b,2)|0)<1)k=Ka(0)|0;else k=~~+Ff(b,2);c[f>>2]=k;if((a[j>>0]|0)==33){l=j+1|0;m=Aa(f|0)|0}else{l=j;m=Ea(f|0)|0}if(!m){Db(b);Pa=d;return 1}if(!(Cl(l,11603)|0)){Ub(b,0,9);Fb(b,c[m>>2]|0);Zb(b,-2,11498);Fb(b,c[m+4>>2]|0);Zb(b,-2,11502);Fb(b,c[m+8>>2]|0);Zb(b,-2,11506);Fb(b,c[m+12>>2]|0);Zb(b,-2,11511);Fb(b,(c[m+16>>2]|0)+1|0);Zb(b,-2,11548);Fb(b,(c[m+20>>2]|0)+1900|0);Zb(b,-2,11554);Fb(b,(c[m+24>>2]|0)+1|0);Zb(b,-2,11606);Fb(b,(c[m+28>>2]|0)+1|0);Zb(b,-2,11611);f=c[m+32>>2]|0;if((f|0)<0){Pa=d;return 1}Mb(b,f);Zb(b,-2,11559);Pa=d;return 1}a[g>>0]=37;Qf(b,h);f=h+8|0;j=h+4|0;k=g+1|0;n=g+2|0;o=l;a:while(1){l=a[o>>0]|0;switch(l<<24>>24){case 0:{break a;break}case 37:{p=o+1|0;q=a[p>>0]|0;if(q<<24>>24!=0?(Xk(11616,q<<24>>24,23)|0)!=0:0){a[k>>0]=q;a[n>>0]=0;r=o+2|0}else{c[e>>2]=p;qf(b,1,Kb(b,11639,e)|0)|0;r=p}Lf(h,i,Ia(i|0,200,g|0,m|0)|0);s=r;break}default:{p=c[f>>2]|0;if(p>>>0<(c[j>>2]|0)>>>0){t=p;u=l}else{Kf(h,1)|0;t=c[f>>2]|0;u=a[o>>0]|0}l=c[h>>2]|0;c[f>>2]=t+1;a[l+t>>0]=u;s=o+1|0}}o=s}Nf(h);Pa=d;return 1}function Gj(a){a=a|0;var b=0;b=~~+Ff(a,1);Eb(a,+qa(b|0,~~+Gf(a,2,0.0)|0));return 1}function Hj(a){a=a|0;var b=0,c=0,d=0;b=Af(a,1,0,0)|0;c=Ja(b|0)|0;if(!b){Mb(a,c);d=1;return d|0}else{d=uf(a,c)|0;return d|0}return 0}function Ij(a){a=a|0;var b=0;if((nb(a,1)|0)==1)b=(xb(a,1)|0)==0&1;else b=Jf(a,1,0)|0;if(xb(a,2)|0)ve(a);if(!a)return 0;else ya(b|0);return 0}function Jj(a){a=a|0;Ib(a,za(Bf(a,1,0)|0)|0)|0;return 1}function Kj(a){a=a|0;var b=0;b=Bf(a,1,0)|0;return tf(a,(Hm(b)|0)==0&1,b)|0}function Lj(a){a=a|0;var b=0;b=Bf(a,1,0)|0;return tf(a,(Km(b,Bf(a,2,0)|0)|0)==0&1,0)|0}function Mj(a){a=a|0;var b=0,d=0;b=Af(a,1,0,0)|0;d=2064+((zf(a,2,11565,2032)|0)<<2)|0;Ib(a,sn(c[d>>2]|0,b)|0)|0;return 1}function Nj(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;b=Pa;Pa=Pa+80|0;d=b+16|0;e=b+8|0;f=b;g=b+64|0;h=b+20|0;if((nb(a,1)|0)<1)i=Ka(0)|0;else{Df(a,1,5);hb(a,1);Rb(a,-1,11498);j=vb(a,-1,g)|0;k=(c[g>>2]|0)==0?0:j;hb(a,-2);c[h>>2]=k;Rb(a,-1,11502);k=vb(a,-1,g)|0;j=(c[g>>2]|0)==0?0:k;hb(a,-2);c[h+4>>2]=j;Rb(a,-1,11506);j=vb(a,-1,g)|0;k=(c[g>>2]|0)==0?12:j;hb(a,-2);c[h+8>>2]=k;Rb(a,-1,11511);k=vb(a,-1,g)|0;if(!(c[g>>2]|0)){c[f>>2]=11511;l=rf(a,11515,f)|0}else{hb(a,-2);l=k}c[h+12>>2]=l;Rb(a,-1,11548);l=vb(a,-1,g)|0;if(!(c[g>>2]|0)){c[e>>2]=11548;m=rf(a,11515,e)|0}else{hb(a,-2);m=l}c[h+16>>2]=m+-1;Rb(a,-1,11554);m=vb(a,-1,g)|0;if(!(c[g>>2]|0)){c[d>>2]=11554;n=rf(a,11515,d)|0}else{hb(a,-2);n=m}c[h+20>>2]=n+-1900;Rb(a,-1,11559);if(!(nb(a,-1)|0))o=-1;else o=xb(a,-1)|0;hb(a,-2);c[h+32>>2]=o;i=Ha(h|0)|0}if((i|0)==-1){Db(a);Pa=b;return 1}else{Eb(a,+(i|0));Pa=b;return 1}return 0}function Oj(a){a=a|0;var b=0,c=0,d=0;b=Pa;Pa=Pa+32|0;c=b;if(!(Bm(c)|0)){d=rf(a,11461,b+24|0)|0;Pa=b;return d|0}else{Ib(a,c)|0;d=1;Pa=b;return d|0}return 0}function Pj(a){a=a|0;Ub(a,0,14);cg(a,2096,0);Ub(a,0,1);Hb(a,16476,0)|0;mb(a,-2);ac(a,-2)|0;hb(a,-2);mb(a,-2);Zb(a,-2,13431);hb(a,-2);return 1}function Qj(a){a=a|0;var b=0,e=0,f=0,g=0,h=0,i=0,j=0;b=Pa;Pa=Pa+16|0;e=b+4|0;f=Bf(a,1,e)|0;g=Jf(a,2,1)|0;h=c[e>>2]|0;i=(g|0)>-1?g:h>>>0<(0-g|0)>>>0?0:g+1+h|0;h=Jf(a,3,i)|0;g=c[e>>2]|0;e=(h|0)>-1?h:g>>>0<(0-h|0)>>>0?0:h+1+g|0;h=(i|0)==0?1:i;i=e>>>0>g>>>0?g:e;if(i>>>0<h>>>0){j=0;Pa=b;return j|0}e=i-h+1|0;if((i|0)==-1){j=rf(a,12431,b)|0;Pa=b;return j|0}Cf(a,e,12431);if((e|0)<=0){j=e;Pa=b;return j|0}i=h+-1|0;h=0;do{Fb(a,d[f+(i+h)>>0]|0);h=h+1|0}while((h|0)<(e|0));j=e;Pa=b;return j|0}function Rj(b){b=b|0;var c=0,d=0,e=0,f=0,g=0,h=0;c=Pa;Pa=Pa+1040|0;d=c;e=gb(b)|0;f=Rf(b,d,e)|0;if((e|0)<1){Of(d,e);Pa=c;return 1}g=1;while(1){h=Hf(b,g)|0;if((h&255|0)!=(h|0))qf(b,g,12412)|0;a[f+(g+-1)>>0]=h;if((g|0)==(e|0))break;else g=g+1|0}Of(d,e);Pa=c;return 1}function Sj(a){a=a|0;var b=0,c=0,d=0;b=Pa;Pa=Pa+1056|0;c=b+8|0;Df(a,1,6);hb(a,1);Qf(a,c);if(!(hc(a,130,c)|0)){Nf(c);d=1;Pa=b;return d|0}else{d=rf(a,12382,b)|0;Pa=b;return d|0}return 0}function Tj(a){a=a|0;return ck(a,1)|0}function Uj(b){b=b|0;var e=0,f=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0.0,Y=0.0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0;e=Pa;Pa=Pa+1168|0;f=e+96|0;h=e+88|0;i=e+80|0;j=e+72|0;k=e+64|0;l=e+56|0;m=e+48|0;n=e+40|0;o=e+32|0;p=e+24|0;q=e+1148|0;r=e+1152|0;s=e+1144|0;t=e+104|0;u=e;v=gb(b)|0;w=Bf(b,1,s)|0;x=c[s>>2]|0;s=w+x|0;Qf(b,t);a:do if((x|0)>0){y=t+8|0;z=t+4|0;A=u+1|0;B=1;C=w;b:while(1){D=a[C>>0]|0;do if(D<<24>>24==37){E=C+1|0;if((a[E>>0]|0)==37){F=c[y>>2]|0;if(F>>>0<(c[z>>2]|0)>>>0){G=F;H=37}else{Kf(t,1)|0;G=c[y>>2]|0;H=a[E>>0]|0}F=c[t>>2]|0;c[y>>2]=G+1;a[F+G>>0]=H;I=B;J=C+2|0;break}F=Kf(t,512)|0;K=B+1|0;if((B|0)>=(v|0))qf(b,K,12175)|0;L=a[E>>0]|0;c:do if(!(L<<24>>24)){M=E;N=0}else{O=E;P=L;while(1){if(!(Xk(12184,P<<24>>24,6)|0)){M=O;N=P;break c}Q=O+1|0;P=a[Q>>0]|0;if(!(P<<24>>24)){M=Q;N=0;break}else O=Q}}while(0);L=E;if((M-L|0)>>>0>5){rf(b,12190,p)|0;R=a[M>>0]|0}else R=N;O=((R&255)+-48|0)>>>0<10?M+1|0:M;P=((d[O>>0]|0)+-48|0)>>>0<10?O+1|0:O;O=a[P>>0]|0;if(O<<24>>24==46){Q=P+1|0;S=((d[Q>>0]|0)+-48|0)>>>0<10?P+2|0:Q;Q=((d[S>>0]|0)+-48|0)>>>0<10?S+1|0:S;T=Q;U=a[Q>>0]|0}else{T=P;U=O}if(((U&255)+-48|0)>>>0<10)rf(b,12222,o)|0;a[u>>0]=37;O=T-L+1|0;Un(A|0,E|0,O|0)|0;a[A+O>>0]=0;O=T+1|0;V=a[T>>0]|0;switch(V<<24>>24|0){case 99:{L=Hf(b,K)|0;c[n>>2]=L;W=Gm(F,u,n)|0;break}case 105:case 100:{X=+Ff(b,K);L=~~X;Y=X-+(L|0);if(!(Y>-1.0&Y<1.0))qf(b,K,12267)|0;P=_l(u)|0;Q=a[u+(P+-1)>>0]|0;S=u+P|0;Z=S+-1|0;a[Z>>0]=108;a[Z+1>>0]=0;a[S>>0]=Q;a[u+(P+1)>>0]=0;c[m>>2]=L;W=Gm(F,u,m)|0;break}case 88:case 120:case 117:case 111:{Y=+Ff(b,K);L=~~Y>>>0;X=Y-+(L>>>0);if(!(X>-1.0&X<1.0))qf(b,K,12296)|0;P=_l(u)|0;Q=a[u+(P+-1)>>0]|0;S=u+P|0;Z=S+-1|0;a[Z>>0]=108;a[Z+1>>0]=0;a[S>>0]=Q;a[u+(P+1)>>0]=0;c[l>>2]=L;W=Gm(F,u,l)|0;break}case 71:case 103:case 102:case 69:case 101:{L=_l(u)|0;P=u+(L+-1)|0;Q=a[P>>0]|0;S=u+L|0;a[S+-1>>0]=0;a[P>>0]=Q;a[S>>0]=0;X=+Ff(b,K);g[k>>3]=X;W=Gm(F,u,k)|0;break}case 113:{S=Bf(b,K,q)|0;Q=c[y>>2]|0;if(Q>>>0<(c[z>>2]|0)>>>0)_=Q;else{Kf(t,1)|0;_=c[y>>2]|0}Q=c[t>>2]|0;c[y>>2]=_+1;a[Q+_>>0]=34;Q=c[q>>2]|0;c[q>>2]=Q+-1;d:do if(Q|0){P=S;while(1){L=a[P>>0]|0;switch(L<<24>>24){case 10:case 92:case 34:{Z=c[y>>2]|0;if(Z>>>0<(c[z>>2]|0)>>>0)$=Z;else{Kf(t,1)|0;$=c[y>>2]|0}Z=c[t>>2]|0;c[y>>2]=$+1;a[Z+$>>0]=92;Z=c[y>>2]|0;if(Z>>>0<(c[z>>2]|0)>>>0)aa=Z;else{Kf(t,1)|0;aa=c[y>>2]|0}Z=a[P>>0]|0;ba=c[t>>2]|0;c[y>>2]=aa+1;a[ba+aa>>0]=Z;break}case 0:{ca=0;da=43;break}default:{Z=L&255;if(!(en(Z)|0)){ba=c[y>>2]|0;if(ba>>>0<(c[z>>2]|0)>>>0){ea=ba;fa=L}else{Kf(t,1)|0;ea=c[y>>2]|0;fa=a[P>>0]|0}L=c[t>>2]|0;c[y>>2]=ea+1;a[L+ea>>0]=fa}else{ca=Z;da=43}}}if((da|0)==43){da=0;if(((d[P+1>>0]|0)+-48|0)>>>0<10){c[i>>2]=ca;Gm(r,12342,i)|0}else{c[j>>2]=ca;Gm(r,12338,j)|0}Mf(t,r)}Z=c[q>>2]|0;c[q>>2]=Z+-1;if(!Z)break d;else P=P+1|0}}while(0);S=c[y>>2]|0;if(S>>>0<(c[z>>2]|0)>>>0)ga=S;else{Kf(t,1)|0;ga=c[y>>2]|0}S=c[t>>2]|0;c[y>>2]=ga+1;a[S+ga>>0]=34;W=0;break}case 115:{S=_f(b,K,q)|0;Q=(rm(u,46)|0)==0;if(Q&(c[q>>2]|0)>>>0>99){Pf(t);ha=0}else{c[h>>2]=S;S=Gm(F,u,h)|0;hb(b,-2);ha=S}W=ha;break}default:break b}c[y>>2]=(c[y>>2]|0)+W;I=K;J=O}else{S=c[y>>2]|0;if(S>>>0<(c[z>>2]|0)>>>0){ia=S;ja=D}else{Kf(t,1)|0;ia=c[y>>2]|0;ja=a[C>>0]|0}S=c[t>>2]|0;c[y>>2]=ia+1;a[S+ia>>0]=ja;I=B;J=C+1|0}while(0);if(J>>>0<s>>>0){B=I;C=J}else break a}c[f>>2]=V<<24>>24;ka=rf(b,12348,f)|0;Pa=e;return ka|0}while(0);Nf(t);ka=1;Pa=e;return ka|0}function Vj(a){a=a|0;Bf(a,1,0)|0;Bf(a,2,0)|0;hb(a,2);Fb(a,0);Lb(a,292,3);return 1}function Wj(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0;d=Pa;Pa=Pa+1360|0;e=d+16|0;f=d+8|0;g=d;h=d+1352|0;i=d+1348|0;j=d+1344|0;k=d+1064|0;l=d+24|0;m=Bf(b,1,i)|0;n=Bf(b,2,j)|0;o=nb(b,3)|0;p=Jf(b,4,(c[i>>2]|0)+1|0)|0;q=(a[n>>0]|0)==94;if((o+-3|0)>>>0>=4)qf(b,3,12069)|0;Qf(b,l);if(q){r=(c[j>>2]|0)+-1|0;c[j>>2]=r;s=n+1|0;t=r}else{s=n;t=c[j>>2]|0}j=k+16|0;c[j>>2]=b;c[k>>2]=200;n=k+4|0;c[n>>2]=m;r=m+(c[i>>2]|0)|0;i=k+8|0;c[i>>2]=r;c[k+12>>2]=s+t;if(!p){u=0;v=m;w=r;x=v;y=w-x|0;Lf(l,v,y);Nf(l);Fb(b,u);Pa=d;return 2}r=k+20|0;t=l+8|0;z=l+4|0;A=k+28|0;B=k+24|0;C=q^1;q=m;m=0;while(1){c[r>>2]=0;D=dk(k,q,s)|0;if(D){E=m+1|0;F=c[j>>2]|0;switch(o|0){case 6:{mb(F,3);G=c[r>>2]|0;H=(q|0)!=0&(G|0)==0?1:G;Cf(c[j>>2]|0,H,11790);if((H|0)>0){G=0;do{ek(k,G,q,D);G=G+1|0}while((G|0)!=(H|0))}dc(F,H,1,0,0);I=40;break}case 5:{do if((c[r>>2]|0)>0){G=c[A>>2]|0;if((G|0)!=-1){J=c[B>>2]|0;if((G|0)==-2){Fb(F,J+1-(c[n>>2]|0)|0);break}else{K=F;L=J}}else{rf(F,11830,g)|0;K=c[j>>2]|0;L=c[B>>2]|0}Hb(K,L,G)|0}else Hb(F,q,D-q|0)|0;while(0);Qb(F,3);I=40;break}default:{H=yb(F,3,h)|0;if(c[h>>2]|0){G=D-q|0;J=0;do{M=H+J|0;N=a[M>>0]|0;do if(N<<24>>24==37){O=J+1|0;P=H+O|0;Q=a[P>>0]|0;R=Q<<24>>24;if(((Q&255)+-48|0)>>>0<10)if(Q<<24>>24==48){Lf(l,q,G);S=O;break}else{ek(k,R+-49|0,q,D);Pf(l);S=O;break}if(Q<<24>>24!=37){Q=c[j>>2]|0;c[f>>2]=37;rf(Q,12100,f)|0}Q=c[t>>2]|0;if(Q>>>0<(c[z>>2]|0)>>>0)T=Q;else{Kf(l,1)|0;T=c[t>>2]|0}Q=a[P>>0]|0;P=c[l>>2]|0;c[t>>2]=T+1;a[P+T>>0]=Q;S=O}else{O=c[t>>2]|0;if(O>>>0<(c[z>>2]|0)>>>0){U=O;V=N}else{Kf(l,1)|0;U=c[t>>2]|0;V=a[M>>0]|0}O=c[l>>2]|0;c[t>>2]=U+1;a[O+U>>0]=V;S=J}while(0);J=S+1|0}while(J>>>0<(c[h>>2]|0)>>>0)}}}if((I|0)==40){I=0;if(xb(F,-1)|0){if(!(rb(F,-1)|0)){J=ob(F,nb(F,-1)|0)|0;c[e>>2]=J;rf(F,12142,e)|0}}else{hb(F,-2);Hb(F,q,D-q|0)|0}Pf(l)}if(D>>>0>q>>>0){W=D;X=E}else{Y=E;I=46}}else{Y=m;I=46}if((I|0)==46){I=0;Z=c[i>>2]|0;if(q>>>0>=Z>>>0){I=47;break}J=c[t>>2]|0;if(J>>>0<(c[z>>2]|0)>>>0)_=J;else{Kf(l,1)|0;_=c[t>>2]|0}J=a[q>>0]|0;G=c[l>>2]|0;c[t>>2]=_+1;a[G+_>>0]=J;W=q+1|0;X=Y}if(X>>>0<p>>>0&C){q=W;m=X}else{I=52;break}}if((I|0)==47){u=Y;v=q;w=Z;x=v;y=w-x|0;Lf(l,v,y);Nf(l);Fb(b,u);Pa=d;return 2}else if((I|0)==52){u=X;v=W;w=c[i>>2]|0;x=v;y=w-x|0;Lf(l,v,y);Nf(l);Fb(b,u);Pa=d;return 2}return 0}function Xj(a){a=a|0;var b=0,d=0;b=Pa;Pa=Pa+16|0;d=b;Bf(a,1,d)|0;Fb(a,c[d>>2]|0);Pa=b;return 1}function Yj(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+1056|0;f=e+1040|0;g=e;h=Bf(b,1,f)|0;i=Rf(b,g,c[f>>2]|0)|0;if(!(c[f>>2]|0)){j=0;Of(g,j);Pa=e;return 1}b=0;do{k=(Nm(d[h+b>>0]|0)|0)&255;a[i+b>>0]=k;b=b+1|0;k=c[f>>2]|0}while(b>>>0<k>>>0);j=k;Of(g,j);Pa=e;return 1}function Zj(a){a=a|0;return ck(a,0)|0}function _j(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;b=Pa;Pa=Pa+1056|0;d=b;e=b+1052|0;f=b+1048|0;g=b+8|0;h=Bf(a,1,e)|0;i=Hf(a,2)|0;j=Af(a,3,16476,f)|0;if((i|0)<1){Hb(a,16476,0)|0;k=1;Pa=b;return k|0}l=c[e>>2]|0;m=c[f>>2]|0;n=m+l|0;if(n>>>0>=l>>>0?n>>>0<(2147483647/(i>>>0)|0)>>>0:0){n=(H(m,i+-1|0)|0)+(H(l,i)|0)|0;l=Rf(a,g,n)|0;Un(l|0,h|0,c[e>>2]|0)|0;if((i|0)>1){m=l;l=i;while(1){i=c[e>>2]|0;o=m+i|0;p=c[f>>2]|0;if(!p){q=o;r=i}else{Un(o|0,j|0,p|0)|0;q=o+(c[f>>2]|0)|0;r=c[e>>2]|0}Un(q|0,h|0,r|0)|0;if((l|0)>2){m=q;l=l+-1|0}else break}}Of(g,n);k=1;Pa=b;return k|0}k=rf(a,11752,d)|0;Pa=b;return k|0}function $j(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;d=Pa;Pa=Pa+1056|0;e=d+1040|0;f=d;g=Bf(b,1,e)|0;h=Rf(b,f,c[e>>2]|0)|0;b=c[e>>2]|0;if(!b){i=0;Of(f,i);Pa=d;return 1}j=0;k=b;while(1){a[h+j>>0]=a[g+(k+~j)>>0]|0;j=j+1|0;b=c[e>>2]|0;if(b>>>0<=j>>>0){i=b;break}else k=b}Of(f,i);Pa=d;return 1}function ak(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+16|0;d=b;e=Bf(a,1,d)|0;f=Hf(a,2)|0;g=c[d>>2]|0;h=(f|0)>-1?f:g>>>0<(0-f|0)>>>0?0:f+1+g|0;g=Jf(a,3,-1)|0;f=c[d>>2]|0;d=(g|0)>-1?g:f>>>0<(0-g|0)>>>0?0:g+1+f|0;g=(h|0)==0?1:h;h=d>>>0>f>>>0?f:d;if(h>>>0<g>>>0){Hb(a,16476,0)|0;Pa=b;return 1}else{Hb(a,e+g+-1|0,1-g+h|0)|0;Pa=b;return 1}return 0}function bk(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+1056|0;f=e+1040|0;g=e;h=Bf(b,1,f)|0;i=Rf(b,g,c[f>>2]|0)|0;if(!(c[f>>2]|0)){j=0;Of(g,j);Pa=e;return 1}b=0;do{k=($m(d[h+b>>0]|0)|0)&255;a[i+b>>0]=k;b=b+1|0;k=c[f>>2]|0}while(b>>>0<k>>>0);j=k;Of(g,j);Pa=e;return 1}function ck(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;e=Pa;Pa=Pa+288|0;f=e+284|0;g=e+280|0;h=e;i=Bf(b,1,f)|0;j=Bf(b,2,g)|0;k=Jf(b,3,1)|0;l=c[f>>2]|0;m=l+1|0;n=(k|0)>-1?k:l>>>0<(0-k|0)>>>0?0:m+k|0;if(n)if(n>>>0>m>>>0){Db(b);o=1;Pa=e;return o|0}else p=n;else p=1;n=(d|0)!=0;a:do if(n){d=(xb(b,4)|0)==0;m=c[g>>2]|0;if(d){d=0;do{k=j+d|0;if(Pm(k,11779)|0){q=17;break a}d=d+1+(_l(k)|0)|0}while(d>>>0<=m>>>0)}d=i+p+-1|0;k=(c[f>>2]|0)-p+1|0;b:do if(!m)r=d;else{if(m>>>0>k>>>0)break a;l=m+-1|0;s=k-l|0;if(!s)break a;t=a[j>>0]|0;u=j+1|0;v=s;s=d;while(1){w=Xk(s,t,v)|0;if(!w)break a;x=s;s=w+1|0;if(!(Mm(s,u,l)|0)){r=w;break b}v=v+x-s|0;if(!v)break a}}while(0);d=r-i|0;Fb(b,d+1|0);Fb(b,d+(c[g>>2]|0)|0);o=2;Pa=e;return o|0}else q=17;while(0);do if((q|0)==17){r=i+p+-1|0;d=(a[j>>0]|0)==94;if(d){k=(c[g>>2]|0)+-1|0;c[g>>2]=k;y=j+1|0;z=k}else{y=j;z=c[g>>2]|0}k=h+16|0;c[k>>2]=b;c[h>>2]=200;c[h+4>>2]=i;m=h+8|0;c[m>>2]=i+(c[f>>2]|0);c[h+12>>2]=y+z;v=h+20|0;c[v>>2]=0;c:do if(d){s=dk(h,r,y)|0;if(!s)q=34;else{A=r;B=s}}else{s=dk(h,r,y)|0;if(!s){l=r;while(1){if(l>>>0>=(c[m>>2]|0)>>>0){q=34;break c}u=l+1|0;c[v>>2]=0;t=dk(h,u,y)|0;if(!t)l=u;else{A=u;B=t;break}}}else{A=r;B=s}}while(0);if((q|0)==34)break;if(!n){r=c[v>>2]|0;m=(r|0)==0?1:r;Cf(c[k>>2]|0,m,11790);if((m|0)>0){r=0;do{ek(h,r,A,B);r=r+1|0}while((r|0)!=(m|0));C=m}else C=m}else{r=i;Fb(b,1-r+A|0);Fb(b,B-r|0);r=c[v>>2]|0;Cf(c[k>>2]|0,r,11790);if((r|0)>0){d=0;do{ek(h,d,0,0);d=d+1|0}while((d|0)!=(r|0))}C=r+2|0}o=C;Pa=e;return o|0}while(0);Db(b);o=1;Pa=e;return o|0}function dk(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0;g=Pa;Pa=Pa+96|0;h=g+80|0;i=g+72|0;j=g+64|0;k=g+56|0;l=g+48|0;m=g+40|0;n=g+32|0;o=g+24|0;p=g+16|0;q=g+8|0;r=c[b>>2]|0;c[b>>2]=r+-1;if(!r)rf(c[b+16>>2]|0,11849,g)|0;r=b+12|0;s=c[r>>2]|0;a:do if((s|0)==(f|0))t=e;else{u=b+16|0;v=b+4|0;w=b+8|0;x=b+20|0;y=e;z=f;A=s;b:while(1){B=y+-1|0;C=z;D=A;c:while(1){E=a[C>>0]|0;switch(E<<24>>24|0){case 40:{F=8;break b;break}case 41:{F=17;break b;break}case 36:{F=24;break c;break}case 37:break;default:{F=84;break c}}G=a[C+1>>0]|0;switch(G<<24>>24|0){case 98:{F=28;break c;break}case 57:case 56:case 55:case 54:case 53:case 52:case 51:case 50:case 49:case 48:{F=77;break c;break}case 102:break;default:{F=27;break c}}H=C+2|0;if((a[H>>0]|0)==91)I=91;else{rf(c[u>>2]|0,11940,m)|0;I=a[H>>0]|0}J=C+3|0;switch(I<<24>>24|0){case 37:{if((J|0)==(c[r>>2]|0))rf(c[u>>2]|0,11975,l)|0;K=C+4|0;break}case 91:{L=(a[J>>0]|0)==94?C+4|0:J;while(1){if((L|0)==(c[r>>2]|0))rf(c[u>>2]|0,12010,k)|0;M=L+1|0;if((a[L>>0]|0)==37)N=M>>>0<(c[r>>2]|0)>>>0?L+2|0:M;else N=M;if((a[N>>0]|0)==93)break;else L=N}K=N+1|0;break}default:K=J}if((y|0)==(c[v>>2]|0))O=0;else O=a[B>>0]|0;L=O&255;M=K+-1|0;P=(a[J>>0]|0)==94;Q=P?J:H;R=(P^1)&1;P=Q+1|0;S=P>>>0<M>>>0;d:do if(S){T=O&255;U=Q;V=P;while(1){W=a[V>>0]|0;X=U+2|0;Y=a[X>>0]|0;do if(W<<24>>24==37)if(!(fk(L,Y&255)|0))Z=X;else{_=R;break d}else{if(Y<<24>>24==45?($=U+3|0,$>>>0<M>>>0):0){if(L>>>0<(W&255)>>>0){Z=$;break}if(L>>>0>(d[$>>0]|0)>>>0){Z=$;break}else{_=R;break d}}if(W<<24>>24==T<<24>>24){_=R;break d}else Z=V}while(0);V=Z+1|0;if(V>>>0>=M>>>0){F=63;break}else U=Z}}else F=63;while(0);if((F|0)==63){F=0;_=R^1}if(_|0){t=0;break a}L=a[y>>0]|0;H=L&255;e:do if(S){J=Q;U=P;while(1){V=a[U>>0]|0;T=J+2|0;W=a[T>>0]|0;do if(V<<24>>24==37)if(!(fk(H,W&255)|0))aa=T;else{ba=R;break e}else{if(W<<24>>24==45?(Y=J+3|0,Y>>>0<M>>>0):0){if((V&255)>(L&255)){aa=Y;break}if((d[Y>>0]|0)<(L&255)){aa=Y;break}else{ba=R;break e}}if(V<<24>>24==L<<24>>24){ba=R;break e}else aa=U}while(0);U=aa+1|0;if(U>>>0>=M>>>0){F=75;break}else J=aa}}else F=75;while(0);if((F|0)==75){F=0;ba=R^1}if(!ba){t=0;break a}M=c[r>>2]|0;if((K|0)==(M|0)){t=y;break a}else{C=K;D=M}}if((F|0)==24){F=0;B=C+1|0;if((B|0)==(D|0)){F=25;break}else{ca=B;da=B;F=95}}else if((F|0)==27){F=0;B=C+1|0;if((B|0)==(D|0))rf(c[u>>2]|0,11975,i)|0;ca=C+2|0;da=B;F=95}else if((F|0)==28){F=0;B=C+2|0;if((D+-1|0)>>>0<=B>>>0)rf(c[u>>2]|0,11893,n)|0;M=a[y>>0]|0;if(M<<24>>24!=(a[B>>0]|0)){t=0;break a}B=a[C+3>>0]|0;L=y+1|0;H=c[w>>2]|0;if(L>>>0>=H>>>0){t=0;break a}P=1;Q=y;S=L;while(1){L=a[S>>0]|0;if(L<<24>>24==B<<24>>24){J=P+-1|0;if(!J)break;else ea=J}else ea=P+(L<<24>>24==M<<24>>24&1)|0;L=S+1|0;if(L>>>0<H>>>0){J=S;P=ea;S=L;Q=J}else{t=0;break a}}fa=Q+2|0;ga=C+4|0}else if((F|0)==77){F=0;S=G&255;P=S+-49|0;if(((G&255)>=49?(P|0)<(c[x>>2]|0):0)?(H=c[b+24+(P<<3)+4>>2]|0,(H|0)!=-1):0){ha=P;ia=H}else{H=c[u>>2]|0;c[j>>2]=S+-48;S=rf(H,12042,j)|0;ha=S;ia=c[b+24+(S<<3)+4>>2]|0}S=y+ia|0;if(((c[w>>2]|0)-y|0)>>>0<ia>>>0){t=0;break a}if((S|0)==0|(Mm(c[b+24+(ha<<3)>>2]|0,y,ia)|0)!=0){t=0;break a}fa=S;ga=C+2|0}else if((F|0)==84){F=0;S=C+1|0;if(E<<24>>24==91){H=(a[S>>0]|0)==94?C+2|0:S;P=D;while(1){if((H|0)==(P|0))rf(c[u>>2]|0,12010,h)|0;M=H+1|0;if((a[H>>0]|0)==37)ja=M>>>0<(c[r>>2]|0)>>>0?H+2|0:M;else ja=M;if((a[ja>>0]|0)==93)break;H=ja;P=c[r>>2]|0}ca=ja+1|0;da=S;F=95}else{ca=S;da=S;F=95}}f:do if((F|0)==95){F=0;ka=c[w>>2]|0;do if(ka>>>0>y>>>0){P=a[y>>0]|0;H=P&255;la=a[C>>0]|0;ma=la<<24>>24;g:do switch(ma|0){case 46:{na=a[ca>>0]|0;break}case 37:{oa=fk(H,d[da>>0]|0)|0;F=112;break}case 91:{D=ca+-1|0;Q=(a[da>>0]|0)==94;M=Q?da:C;B=(Q^1)&1;Q=M+1|0;if(Q>>>0<D>>>0){J=M;M=Q;while(1){Q=a[M>>0]|0;L=J+2|0;U=a[L>>0]|0;do if(Q<<24>>24==37)if(!(fk(H,U&255)|0))pa=L;else{oa=B;F=112;break g}else{if(U<<24>>24==45?(V=J+3|0,V>>>0<D>>>0):0){if((Q&255)>(P&255)){pa=V;break}if((d[V>>0]|0)<(P&255)){pa=V;break}else{oa=B;F=112;break g}}if(Q<<24>>24==P<<24>>24){oa=B;F=112;break g}else pa=M}while(0);M=pa+1|0;if(M>>>0>=D>>>0)break;else J=pa}}oa=B^1;F=112;break}default:{oa=la<<24>>24==P<<24>>24&1;F=112}}while(0);if((F|0)==112){F=0;P=a[ca>>0]|0;if(!oa){qa=P;break}else na=P}switch(na<<24>>24|0){case 43:{F=117;break b;break}case 42:{ra=y;break b;break}case 45:{F=144;break b;break}case 63:{P=ca+1|0;H=dk(b,y+1|0,P)|0;if(!H){fa=y;ga=P;break f}else{t=H;break a}break}default:{fa=y+1|0;ga=ca;break f}}}else qa=a[ca>>0]|0;while(0);switch(qa<<24>>24){case 45:case 63:case 42:break;default:{t=0;break a}}fa=y;ga=ca+1|0}while(0);A=c[r>>2]|0;if((ga|0)==(A|0)){t=fa;break a}else{y=fa;z=ga}}if((F|0)==8){z=C+1|0;if((a[z>>0]|0)==41){A=c[x>>2]|0;if((A|0)>31)rf(c[u>>2]|0,11790,q)|0;c[b+24+(A<<3)>>2]=y;c[b+24+(A<<3)+4>>2]=-2;c[x>>2]=A+1;A=dk(b,y,C+2|0)|0;if(A|0){t=A;break}c[x>>2]=(c[x>>2]|0)+-1;t=0;break}else{A=c[x>>2]|0;if((A|0)>31)rf(c[u>>2]|0,11790,p)|0;c[b+24+(A<<3)>>2]=y;c[b+24+(A<<3)+4>>2]=-1;c[x>>2]=A+1;A=dk(b,y,z)|0;if(A|0){t=A;break}c[x>>2]=(c[x>>2]|0)+-1;t=0;break}}else if((F|0)==17){A=C+1|0;z=c[x>>2]|0;h:do if((z|0)>0){v=z;while(1){S=v;v=v+-1|0;R=b+24+(v<<3)+4|0;if((c[R>>2]|0)==-1){sa=v;ta=R;break h}if((S|0)<=1){F=21;break}}}else F=21;while(0);if((F|0)==21){z=rf(c[u>>2]|0,11869,o)|0;sa=z;ta=b+24+(z<<3)+4|0}c[ta>>2]=y-(c[b+24+(sa<<3)>>2]|0);z=dk(b,y,A)|0;if(z|0){t=z;break}c[ta>>2]=-1;t=0;break}else if((F|0)==25){t=(y|0)==(c[w>>2]|0)?y:0;break}else if((F|0)==117)ra=y+1|0;else if((F|0)==144){z=ca+1|0;x=dk(b,y,z)|0;if(x|0){t=x;break}x=ca+-1|0;v=y;while(1){if((c[w>>2]|0)>>>0<=v>>>0){t=0;break a}S=a[v>>0]|0;R=S&255;H=a[C>>0]|0;i:do switch(H<<24>>24|0){case 46:break;case 37:{ua=fk(R,d[da>>0]|0)|0;F=161;break}case 91:{P=(a[da>>0]|0)==94;J=P?da:C;D=(P^1)&1;P=J+1|0;if(P>>>0<x>>>0){M=J;J=P;while(1){P=a[J>>0]|0;Q=M+2|0;U=a[Q>>0]|0;do if(P<<24>>24==37)if(!(fk(R,U&255)|0))va=Q;else{ua=D;F=161;break i}else{if(U<<24>>24==45?(L=M+3|0,L>>>0<x>>>0):0){if((P&255)>(S&255)){va=L;break}if((d[L>>0]|0)<(S&255)){va=L;break}else{ua=D;F=161;break i}}if(P<<24>>24==S<<24>>24){ua=D;F=161;break i}else va=J}while(0);J=va+1|0;if(J>>>0>=x>>>0)break;else M=va}}ua=D^1;F=161;break}default:{ua=H<<24>>24==S<<24>>24&1;F=161}}while(0);if((F|0)==161?(F=0,(ua|0)==0):0){t=0;break a}v=v+1|0;S=dk(b,v,z)|0;if(S|0){t=S;break a}}}if(ka>>>0>ra>>>0){z=ca+-1|0;j:do switch(ma|0){case 46:{wa=ka-ra|0;break}case 37:{v=d[da>>0]|0;x=0;w=ra;while(1){if(!(fk(d[w>>0]|0,v)|0)){wa=x;break j}y=x+1|0;w=ra+y|0;if(ka>>>0<=w>>>0){wa=y;break}else x=y}break}default:{x=0;w=ra;while(1){v=a[w>>0]|0;y=v&255;k:do switch(ma|0){case 46:break;case 91:{A=(a[da>>0]|0)==94;u=A?da:C;S=(A^1)&1;A=u+1|0;if(A>>>0<z>>>0){H=u;u=A;while(1){A=a[u>>0]|0;R=H+2|0;M=a[R>>0]|0;do if(A<<24>>24==37)if(!(fk(y,M&255)|0))xa=R;else{ya=S;F=138;break k}else{if(M<<24>>24==45?(J=H+3|0,J>>>0<z>>>0):0){if((A&255)>(v&255)){xa=J;break}if((d[J>>0]|0)<(v&255)){xa=J;break}else{ya=S;F=138;break k}}if(A<<24>>24==v<<24>>24){ya=S;F=138;break k}else xa=u}while(0);u=xa+1|0;if(u>>>0>=z>>>0)break;else H=xa}}ya=S^1;F=138;break}default:{ya=la<<24>>24==v<<24>>24&1;F=138}}while(0);if((F|0)==138?(F=0,(ya|0)==0):0){wa=x;break j}v=x+1|0;w=ra+v|0;if(ka>>>0<=w>>>0){wa=v;break j}else x=v}}}while(0);if((wa|0)>-1)za=wa;else{t=0;break}}else za=0;z=ca+1|0;x=za;while(1){w=dk(b,ra+x|0,z)|0;v=(w|0)==0;x=x+(v<<31>>31)|0;if(!v){t=w;break a}if((x|0)<=-1){t=0;break}}}while(0);c[b>>2]=(c[b>>2]|0)+1;Pa=g;return t|0}function ek(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0;f=Pa;Pa=Pa+16|0;g=f+8|0;h=f;if((c[a+20>>2]|0)<=(b|0)){i=c[a+16>>2]|0;if(!b){Hb(i,d,e-d|0)|0;Pa=f;return}else{rf(i,11808,h)|0;Pa=f;return}}h=c[a+24+(b<<3)+4>>2]|0;if((h|0)!=-1){i=c[a+16>>2]|0;d=c[a+24+(b<<3)>>2]|0;if((h|0)==-2){Fb(i,d+1-(c[a+4>>2]|0)|0);Pa=f;return}else{j=i;k=d}}else{d=a+16|0;rf(c[d>>2]|0,11830,g)|0;j=c[d>>2]|0;k=c[a+24+(b<<3)>>2]|0}Hb(j,k,h)|0;Pa=f;return}function fk(a,b){a=a|0;b=b|0;var c=0,d=0;do switch(Nm(b)|0){case 97:{c=dn(a)|0;break}case 99:{c=en(a)|0;break}case 100:{c=(a+-48|0)>>>0<10&1;break}case 103:{c=bn(a)|0;break}case 108:{c=an(a)|0;break}case 112:{c=gn(a)|0;break}case 115:{c=Fl(a)|0;break}case 117:{c=Om(a)|0;break}case 119:{c=cn(a)|0;break}case 120:{c=fn(a)|0;break}case 122:{c=(a|0)==0&1;break}default:{d=(b|0)==(a|0)&1;return d|0}}while(0);a=(an(b)|0)==0;d=a?(c|0)==0&1:c;return d|0}function gk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;b=Pa;Pa=Pa+288|0;d=b+8|0;e=b+4|0;f=b;g=yb(a,-1001001,e)|0;h=yb(a,-1001002,f)|0;i=d+16|0;c[i>>2]=a;c[d>>2]=200;c[d+4>>2]=g;j=c[e>>2]|0;e=d+8|0;c[e>>2]=g+j;c[d+12>>2]=h+(c[f>>2]|0);f=vb(a,-1001003,0)|0;if((f|0)>(j|0)){k=0;Pa=b;return k|0}j=d+20|0;l=g+f|0;while(1){c[j>>2]=0;m=dk(d,l,h)|0;if(m|0)break;f=l+1|0;if(f>>>0>(c[e>>2]|0)>>>0){k=0;n=8;break}else l=f}if((n|0)==8){Pa=b;return k|0}Fb(a,m-g+((m|0)==(l|0)&1)|0);kb(a,-1001003);a=c[j>>2]|0;j=(l|0)!=0&(a|0)==0?1:a;Cf(c[i>>2]|0,j,11790);if((j|0)<=0){k=j;Pa=b;return k|0}i=0;do{ek(d,i,l,m);i=i+1|0}while((i|0)!=(j|0));k=j;Pa=b;return k|0}function hk(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;Lf(d,b,c);return 0}function ik(a){a=a|0;Ub(a,0,7);cg(a,2224,0);Rb(a,-1,12453);Xb(a,12453);return 1}function jk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;b=Pa;Pa=Pa+1072|0;d=b+8|0;e=b;f=b+24|0;g=b+16|0;h=Af(a,2,16476,g)|0;Df(a,1,5);i=Jf(a,3,1)|0;if((nb(a,4)|0)<1)j=Zf(a,1)|0;else j=Hf(a,4)|0;Qf(a,f);if((i|0)>=(j|0)){if((i|0)!=(j|0)){Nf(f);Pa=b;return 1}}else{k=i;do{Tb(a,1,k);if(!(rb(a,-1)|0)){i=ob(a,nb(a,-1)|0)|0;c[e>>2]=i;c[e+4>>2]=k;rf(a,12621,e)|0}Pf(f);Lf(f,h,c[g>>2]|0);k=k+1|0}while((k|0)!=(j|0))}Tb(a,1,j);if(!(rb(a,-1)|0)){k=ob(a,nb(a,-1)|0)|0;c[d>>2]=k;c[d+4>>2]=j;rf(a,12621,d)|0}Pf(f);Nf(f);Pa=b;return 1}function kk(a){a=a|0;var b=0.0,c=0.0,d=0.0,e=0.0;Df(a,1,5);Db(a);if(!(lc(a,1)|0)){b=0.0;Eb(a,b);return 1}c=0.0;while(1){hb(a,-2);if((nb(a,-1)|0)==3){d=+ub(a,-1,0);e=d>c?d:c}else e=c;if(!(lc(a,1)|0)){b=e;break}else c=e}Eb(a,b);return 1}function lk(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+16|0;Df(a,1,5);c=Zf(a,1)|0;d=c+1|0;switch(gb(a)|0){case 2:{e=d;break}case 3:{f=2;break}default:{g=rf(a,12583,b)|0;Pa=b;return g|0}}if((f|0)==2){f=Hf(a,2)|0;if((f|0)<1|(f|0)>(d|0))qf(a,2,12531)|0;if((c|0)<(f|0))e=f;else{c=d;do{d=c;c=c+-1|0;Tb(a,1,c);$b(a,1,d)}while((c|0)>(f|0));e=f}}$b(a,1,e);g=0;Pa=b;return g|0}function mk(a){a=a|0;var b=0,c=0;b=gb(a)|0;Ub(a,b,1);Fb(a,b);Zb(a,-2,12581);if((b|0)<=0)return 1;mb(a,1);$b(a,-2,1);kb(a,1);if((b|0)==1)return 1;c=b;while(1){$b(a,1,c);if((c|0)>2)c=c+-1|0;else break}return 1}function nk(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+16|0;c=b;Df(a,1,5);d=Jf(a,2,1)|0;if((nb(a,3)|0)<1)e=Zf(a,1)|0;else e=Hf(a,3)|0;if((e|0)<(d|0)){f=0;Pa=b;return f|0}g=e-d|0;h=g+1|0;if((g|0)>=0?ab(a,h)|0:0){Tb(a,1,d);if((e|0)<=(d|0)){f=h;Pa=b;return f|0}g=d;do{g=g+1|0;Tb(a,1,g)}while((g|0)!=(e|0));f=h;Pa=b;return f|0}f=rf(a,12554,c)|0;Pa=b;return f|0}function ok(a){a=a|0;var b=0,c=0,d=0,e=0;Df(a,1,5);b=Zf(a,1)|0;c=Jf(a,2,b)|0;if((c|0)!=(b|0)?(c|0)<1|(c|0)>(b+1|0):0)qf(a,1,12531)|0;Tb(a,1,c);if((c|0)>=(b|0)){d=c;Db(a);$b(a,1,d);return 1}e=c;do{c=e;e=e+1|0;Tb(a,1,e);$b(a,1,c)}while((e|0)!=(b|0));d=b;Db(a);$b(a,1,d);return 1}function pk(a){a=a|0;var b=0;Df(a,1,5);b=Zf(a,1)|0;Cf(a,40,16476);if((nb(a,2)|0)>=1)Df(a,2,6);hb(a,2);qk(a,1,b);return 0}function qk(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;d=Pa;Pa=Pa+16|0;e=d+8|0;f=d;if((c|0)<=(b|0)){Pa=d;return}g=c;c=b;while(1){Tb(a,1,c);Tb(a,1,g);if(!(rk(a,-1,-2)|0))hb(a,-3);else{$b(a,1,c);$b(a,1,g)}b=g-c|0;if((b|0)==1){h=27;break}i=(g+c|0)/2|0;Tb(a,1,i);Tb(a,1,c);do if(!(rk(a,-2,-1)|0)){hb(a,-2);Tb(a,1,g);if(!(rk(a,-1,-2)|0)){hb(a,-3);break}else{$b(a,1,i);$b(a,1,g);break}}else{$b(a,1,i);$b(a,1,c)}while(0);if((b|0)==2){h=27;break}Tb(a,1,i);mb(a,-1);j=g+-1|0;Tb(a,1,j);$b(a,1,i);$b(a,1,j);k=j;l=c;while(1){m=l+1|0;Tb(a,1,m);if(!(rk(a,-1,-2)|0)){n=l;o=m}else{p=m;while(1){if((g|0)<=(p|0))rf(a,12496,f)|0;hb(a,-2);m=p+1|0;Tb(a,1,m);if(!(rk(a,-1,-2)|0)){n=p;o=m;break}else p=m}}p=k+-1|0;Tb(a,1,p);if(!(rk(a,-3,-1)|0)){q=k;r=p}else{m=p;while(1){if((m|0)<=(c|0))rf(a,12496,e)|0;hb(a,-2);p=m+-1|0;Tb(a,1,p);if(!(rk(a,-3,-1)|0)){q=m;r=p;break}else m=p}}if((q|0)<=(o|0))break;$b(a,1,o);$b(a,1,r);k=r;l=o}hb(a,-4);Tb(a,1,j);Tb(a,1,o);$b(a,1,j);$b(a,1,o);l=(o-c|0)<(g-o|0);k=n+2|0;i=c;c=l?k:c;b=g;g=l?g:n;qk(a,l?i:k,l?n:b);if((g|0)<=(c|0)){h=27;break}}if((h|0)==27){Pa=d;return}}function rk(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;if(!(nb(a,2)|0)){d=tb(a,b,c,1)|0;return d|0}else{mb(a,2);mb(a,b+-1|0);mb(a,c+-2|0);dc(a,2,1,0,0);c=xb(a,-1)|0;hb(a,-2);d=c;return d|0}return 0}function sk(a){a=a|0;dg(a,-1001e3,12674)|0;Ub(a,0,1);Lb(a,293,0);Zb(a,-2,12681);ac(a,-2)|0;Ub(a,0,3);cg(a,2288,0);Ub(a,4,0);mb(a,-2);Lb(a,294,1);$b(a,-2,1);mb(a,-2);Lb(a,295,1);$b(a,-2,2);mb(a,-2);Lb(a,296,1);$b(a,-2,3);mb(a,-2);Lb(a,297,1);$b(a,-2,4);mb(a,-1);Zb(a,-3,12686);Zb(a,-2,12694);yk(a,12704,12709,12722,12731);yk(a,12869,12875,12889,12899);Hb(a,12968,10)|0;Zb(a,-2,12979);dg(a,-1001e3,12986)|0;Zb(a,-2,12994);dg(a,-1001e3,13001)|0;Zb(a,-2,13010);Tb(a,-1001e3,2);mb(a,-2);cg(a,2320,1);hb(a,-2);return 1}function tk(a){a=a|0;var b=0,c=0;b=Zf(a,1)|0;if((b|0)<=0)return 0;c=b;while(1){Tb(a,1,c);hb(a,-2);if((c|0)>1)c=c+-1|0;else break}return 0}function uk(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;e=Bf(a,1,0)|0;Rb(a,-1001e3,13001);Rb(a,-1,e);if(nb(a,-1)|0){Pa=b;return 1}c[d>>2]=e;Kb(a,13372,d)|0;Pa=b;return 1}function vk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;b=Pa;Pa=Pa+32|0;d=b+8|0;e=b;f=Bf(a,1,0)|0;Rb(a,-1001001,12704);g=yb(a,-1,0)|0;if(!g){c[e>>2]=12704;rf(a,13173,e)|0;h=Bk(a,f,0,13528,13203)|0}else h=Bk(a,f,g,13528,13203)|0;if(!h){i=1;Pa=b;return i|0}if(!(Sf(a,h,0)|0)){Ib(a,h)|0;i=2;Pa=b;return i|0}else{g=yb(a,1,0)|0;f=yb(a,-1,0)|0;c[d>>2]=g;c[d+4>>2]=h;c[d+8>>2]=f;i=rf(a,13205,d)|0;Pa=b;return i|0}return 0}function wk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;b=Pa;Pa=Pa+32|0;d=b+8|0;e=b;f=Bf(a,1,0)|0;Rb(a,-1001001,12869);g=yb(a,-1,0)|0;if(!g){c[e>>2]=12869;rf(a,13173,e)|0;h=Bk(a,f,0,13528,13203)|0}else h=Bk(a,f,g,13528,13203)|0;if(!h){i=1;Pa=b;return i|0}if(!(Ck(a,h,f)|0)){Ib(a,h)|0;i=2;Pa=b;return i|0}else{f=yb(a,1,0)|0;g=yb(a,-1,0)|0;c[d>>2]=f;c[d+4>>2]=h;c[d+8>>2]=g;i=rf(a,13205,d)|0;Pa=b;return i|0}return 0}function xk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;b=Pa;Pa=Pa+32|0;d=b+24|0;e=b+8|0;f=b;g=Bf(a,1,0)|0;h=rm(g,46)|0;if(!h){i=0;Pa=b;return i|0}Hb(a,g,h-g|0)|0;h=yb(a,-1,0)|0;Rb(a,-1001001,12869);j=yb(a,-1,0)|0;if(!j){c[f>>2]=12869;rf(a,13173,f)|0;k=Bk(a,h,0,13528,13203)|0}else k=Bk(a,h,j,13528,13203)|0;if(!k){i=1;Pa=b;return i|0}switch(Ck(a,k,g)|0){case 0:{Ib(a,k)|0;i=2;Pa=b;return i|0}case 2:{c[d>>2]=g;c[d+4>>2]=k;Kb(a,13251,d)|0;i=1;Pa=b;return i|0}default:{d=yb(a,1,0)|0;g=yb(a,-1,0)|0;c[e>>2]=d;c[e+4>>2]=k;c[e+8>>2]=g;i=rf(a,13205,e)|0;Pa=b;return i|0}}return 0}function yk(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=za(c|0)|0;if(!f){c=za(d|0)|0;if(c|0){g=c;h=3}}else{g=f;h=3}if((h|0)==3?(Rb(a,-1001e3,13154),h=xb(a,-1)|0,hb(a,-2),(h|0)==0):0){fg(a,fg(a,g,13164,13167)|0,13171,e)|0;ib(a,-2);Zb(a,-2,b);return}Ib(a,e)|0;Zb(a,-2,b);return}function zk(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+112|0;c=b;d=b+4|0;e=Bf(a,1,0)|0;f=gb(a)|0;$f(a,e,1);Rb(a,-1,13094);g=(nb(a,-1)|0)==0;hb(a,-2);if(g){mb(a,-1);Zb(a,-2,13100);Ib(a,e)|0;Zb(a,-2,13094);g=Sm(e,46)|0;Hb(a,e,((g|0)==0?e:g+1|0)-e|0)|0;Zb(a,-2,13103)}mb(a,-1);if(!(((xc(a,1,d)|0)!=0?(Ac(a,13112,d)|0)!=0:0)?!(pb(a,-1)|0):0))rf(a,13114,c)|0;mb(a,-2);qc(a,-2,1)|0;hb(a,-2);if((f|0)<2){Pa=b;return 1}c=2;while(1){if((nb(a,c)|0)==6){mb(a,c);mb(a,-2);dc(a,1,0,0,0)}if((c|0)==(f|0))break;else c=c+1|0}Pa=b;return 1}function Ak(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;b=Pa;Pa=Pa+1056|0;d=b+8|0;e=b+16|0;f=Bf(a,1,0)|0;hb(a,1);Rb(a,-1001e3,12986);Rb(a,2,f);if(xb(a,-1)|0){Pa=b;return 1}hb(a,-2);Qf(a,e);Rb(a,-1001001,12694);if((nb(a,3)|0)!=5)rf(a,13033,b)|0;g=1;while(1){Tb(a,3,g);if(!(nb(a,-1)|0)){hb(a,-2);Nf(e);h=yb(a,-1,0)|0;c[d>>2]=f;c[d+4>>2]=h;rf(a,13069,d)|0}Ib(a,f)|0;dc(a,1,2,0,0);if((nb(a,-2)|0)==6)break;if(!(rb(a,-2)|0))hb(a,-3);else{hb(a,-2);Pf(e)}g=g+1|0}Ib(a,f)|0;jb(a,-2);dc(a,2,1,0,0);if(nb(a,-1)|0)Zb(a,2,f);Rb(a,2,f);if(nb(a,-1)|0){Pa=b;return 1}Mb(a,1);mb(a,-1);Zb(a,2,f);Pa=b;return 1}function Bk(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;h=Pa;Pa=Pa+1056|0;i=h;j=h+8|0;Qf(b,j);if(!(a[f>>0]|0))k=d;else k=fg(b,d,f,g)|0;g=e;a:while(1){switch(a[g>>0]|0){case 0:{l=13;break a;break}case 59:{m=g+1|0;break}default:{e=rm(g,59)|0;if(!e)n=g+(_l(g)|0)|0;else n=e;Hb(b,g,n-g|0)|0;if(!n){l=13;break a}o=fg(b,yb(b,-1,0)|0,13353,k)|0;ib(b,-2);p=qm(o,13355)|0;if(p|0){l=11;break a}c[i>>2]=o;Kb(b,13357,i)|0;ib(b,-2);Pf(j);m=n}}g=m}if((l|0)==11){bm(p)|0;q=o;Pa=h;return q|0}else if((l|0)==13){Nf(j);q=0;Pa=h;return q|0}return 0}function Ck(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;e=Pa;Pa=Pa+16|0;f=e+8|0;g=e;h=fg(a,d,13528,13281)|0;d=rm(h,45)|0;if(d){i=Hb(a,h,d-h|0)|0;c[g>>2]=i;i=Dk(a,b,Kb(a,13283,g)|0)|0;if((i|0)==2)j=d+1|0;else{k=i;Pa=e;return k|0}}else j=h;c[f>>2]=j;k=Dk(a,b,Kb(a,13283,f)|0)|0;Pa=e;return k|0}function Dk(b,c,d){b=b|0;c=c|0;d=d|0;var e=0;Rb(b,-1001e3,12674);Rb(b,-1,c);c=Ab(b,-1)|0;hb(b,-3);if(!c){Hb(b,13294,58)|0;e=1;return e|0}if((a[d>>0]|0)==42){Mb(b,1);e=0;return e|0}else{Hb(b,13294,58)|0;e=2;return e|0}return 0}function Ek(a){a=a|0;var b=0,c=0,d=0;b=Bf(a,1,0)|0;c=Dk(a,b,Bf(a,2,0)|0)|0;if(!c){d=1;return d|0}Db(a);jb(a,-2);Ib(a,(c|0)==1?13439:13446)|0;d=3;return d|0}function Fk(a){a=a|0;var b=0,c=0,d=0,e=0;b=Bf(a,1,0)|0;c=Bf(a,2,0)|0;d=Af(a,3,13528,0)|0;if(Bk(a,b,c,d,Af(a,4,13203,0)|0)|0){e=1;return e|0}Db(a);jb(a,-2);e=2;return e|0}function Gk(a){a=a|0;Df(a,1,5);if(!(Vb(a,1)|0)){Ub(a,0,1);mb(a,-1);ac(a,1)|0}Tb(a,-1001e3,2);Zb(a,-2,13431);return 0}function Hk(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0;b=Pa;Pa=Pa+16|0;d=b;do if(a>>>0<245){e=a>>>0<11?16:a+11&-8;f=e>>>3;g=c[3962]|0;h=g>>>f;if(h&3|0){i=(h&1^1)+f|0;j=15888+(i<<1<<2)|0;k=j+8|0;l=c[k>>2]|0;m=l+8|0;n=c[m>>2]|0;if((n|0)==(j|0))c[3962]=g&~(1<<i);else{c[n+12>>2]=j;c[k>>2]=n}n=i<<3;c[l+4>>2]=n|3;i=l+n+4|0;c[i>>2]=c[i>>2]|1;o=m;Pa=b;return o|0}m=c[3964]|0;if(e>>>0>m>>>0){if(h|0){i=2<<f;n=h<<f&(i|0-i);i=(n&0-n)+-1|0;n=i>>>12&16;f=i>>>n;i=f>>>5&8;h=f>>>i;f=h>>>2&4;l=h>>>f;h=l>>>1&2;k=l>>>h;l=k>>>1&1;j=(i|n|f|h|l)+(k>>>l)|0;l=15888+(j<<1<<2)|0;k=l+8|0;h=c[k>>2]|0;f=h+8|0;n=c[f>>2]|0;if((n|0)==(l|0)){i=g&~(1<<j);c[3962]=i;p=i}else{c[n+12>>2]=l;c[k>>2]=n;p=g}n=j<<3;j=n-e|0;c[h+4>>2]=e|3;k=h+e|0;c[k+4>>2]=j|1;c[h+n>>2]=j;if(m|0){n=c[3967]|0;h=m>>>3;l=15888+(h<<1<<2)|0;i=1<<h;if(!(p&i)){c[3962]=p|i;q=l;r=l+8|0}else{i=l+8|0;q=c[i>>2]|0;r=i}c[r>>2]=n;c[q+12>>2]=n;c[n+8>>2]=q;c[n+12>>2]=l}c[3964]=j;c[3967]=k;o=f;Pa=b;return o|0}f=c[3963]|0;if(f){k=(f&0-f)+-1|0;j=k>>>12&16;l=k>>>j;k=l>>>5&8;n=l>>>k;l=n>>>2&4;i=n>>>l;n=i>>>1&2;h=i>>>n;i=h>>>1&1;s=c[16152+((k|j|l|n|i)+(h>>>i)<<2)>>2]|0;i=s;h=s;n=(c[s+4>>2]&-8)-e|0;while(1){s=c[i+16>>2]|0;if(!s){l=c[i+20>>2]|0;if(!l)break;else t=l}else t=s;s=(c[t+4>>2]&-8)-e|0;l=s>>>0<n>>>0;i=t;h=l?t:h;n=l?s:n}i=h+e|0;if(i>>>0>h>>>0){s=c[h+24>>2]|0;l=c[h+12>>2]|0;do if((l|0)==(h|0)){j=h+20|0;k=c[j>>2]|0;if(!k){u=h+16|0;v=c[u>>2]|0;if(!v){w=0;break}else{x=v;y=u}}else{x=k;y=j}j=x;k=y;while(1){u=j+20|0;v=c[u>>2]|0;if(!v){z=j+16|0;A=c[z>>2]|0;if(!A)break;else{B=A;C=z}}else{B=v;C=u}j=B;k=C}c[k>>2]=0;w=j}else{u=c[h+8>>2]|0;c[u+12>>2]=l;c[l+8>>2]=u;w=l}while(0);do if(s|0){l=c[h+28>>2]|0;u=16152+(l<<2)|0;if((h|0)==(c[u>>2]|0)){c[u>>2]=w;if(!w){c[3963]=f&~(1<<l);break}}else{l=s+16|0;c[((c[l>>2]|0)==(h|0)?l:s+20|0)>>2]=w;if(!w)break}c[w+24>>2]=s;l=c[h+16>>2]|0;if(l|0){c[w+16>>2]=l;c[l+24>>2]=w}l=c[h+20>>2]|0;if(l|0){c[w+20>>2]=l;c[l+24>>2]=w}}while(0);if(n>>>0<16){s=n+e|0;c[h+4>>2]=s|3;f=h+s+4|0;c[f>>2]=c[f>>2]|1}else{c[h+4>>2]=e|3;c[i+4>>2]=n|1;c[i+n>>2]=n;if(m|0){f=c[3967]|0;s=m>>>3;l=15888+(s<<1<<2)|0;u=1<<s;if(!(u&g)){c[3962]=u|g;D=l;E=l+8|0}else{u=l+8|0;D=c[u>>2]|0;E=u}c[E>>2]=f;c[D+12>>2]=f;c[f+8>>2]=D;c[f+12>>2]=l}c[3964]=n;c[3967]=i}o=h+8|0;Pa=b;return o|0}else F=e}else F=e}else F=e}else if(a>>>0<=4294967231){l=a+11|0;f=l&-8;u=c[3963]|0;if(u){s=0-f|0;v=l>>>8;if(v)if(f>>>0>16777215)G=31;else{l=(v+1048320|0)>>>16&8;z=v<<l;v=(z+520192|0)>>>16&4;A=z<<v;z=(A+245760|0)>>>16&2;H=14-(v|l|z)+(A<<z>>>15)|0;G=f>>>(H+7|0)&1|H<<1}else G=0;H=c[16152+(G<<2)>>2]|0;a:do if(!H){I=0;J=0;K=s;L=61}else{z=0;A=s;l=H;v=f<<((G|0)==31?0:25-(G>>>1)|0);M=0;while(1){N=(c[l+4>>2]&-8)-f|0;if(N>>>0<A>>>0)if(!N){O=l;P=0;Q=l;L=65;break a}else{R=l;S=N}else{R=z;S=A}N=c[l+20>>2]|0;l=c[l+16+(v>>>31<<2)>>2]|0;T=(N|0)==0|(N|0)==(l|0)?M:N;if(!l){I=T;J=R;K=S;L=61;break}else{z=R;A=S;v=v<<1;M=T}}}while(0);if((L|0)==61){if((I|0)==0&(J|0)==0){H=2<<G;s=(H|0-H)&u;if(!s){F=f;break}H=(s&0-s)+-1|0;s=H>>>12&16;e=H>>>s;H=e>>>5&8;h=e>>>H;e=h>>>2&4;i=h>>>e;h=i>>>1&2;n=i>>>h;i=n>>>1&1;U=0;V=c[16152+((H|s|e|h|i)+(n>>>i)<<2)>>2]|0}else{U=J;V=I}if(!V){W=U;X=K}else{O=U;P=K;Q=V;L=65}}if((L|0)==65){i=O;n=P;h=Q;while(1){e=(c[h+4>>2]&-8)-f|0;s=e>>>0<n>>>0;H=s?e:n;e=s?h:i;s=c[h+16>>2]|0;if(!s)Y=c[h+20>>2]|0;else Y=s;if(!Y){W=e;X=H;break}else{i=e;n=H;h=Y}}}if(((W|0)!=0?X>>>0<((c[3964]|0)-f|0)>>>0:0)?(h=W+f|0,h>>>0>W>>>0):0){n=c[W+24>>2]|0;i=c[W+12>>2]|0;do if((i|0)==(W|0)){H=W+20|0;e=c[H>>2]|0;if(!e){s=W+16|0;g=c[s>>2]|0;if(!g){Z=0;break}else{_=g;$=s}}else{_=e;$=H}H=_;e=$;while(1){s=H+20|0;g=c[s>>2]|0;if(!g){m=H+16|0;M=c[m>>2]|0;if(!M)break;else{aa=M;ba=m}}else{aa=g;ba=s}H=aa;e=ba}c[e>>2]=0;Z=H}else{s=c[W+8>>2]|0;c[s+12>>2]=i;c[i+8>>2]=s;Z=i}while(0);do if(n){i=c[W+28>>2]|0;s=16152+(i<<2)|0;if((W|0)==(c[s>>2]|0)){c[s>>2]=Z;if(!Z){s=u&~(1<<i);c[3963]=s;ca=s;break}}else{s=n+16|0;c[((c[s>>2]|0)==(W|0)?s:n+20|0)>>2]=Z;if(!Z){ca=u;break}}c[Z+24>>2]=n;s=c[W+16>>2]|0;if(s|0){c[Z+16>>2]=s;c[s+24>>2]=Z}s=c[W+20>>2]|0;if(s){c[Z+20>>2]=s;c[s+24>>2]=Z;ca=u}else ca=u}else ca=u;while(0);b:do if(X>>>0<16){u=X+f|0;c[W+4>>2]=u|3;n=W+u+4|0;c[n>>2]=c[n>>2]|1}else{c[W+4>>2]=f|3;c[h+4>>2]=X|1;c[h+X>>2]=X;n=X>>>3;if(X>>>0<256){u=15888+(n<<1<<2)|0;s=c[3962]|0;i=1<<n;if(!(s&i)){c[3962]=s|i;da=u;ea=u+8|0}else{i=u+8|0;da=c[i>>2]|0;ea=i}c[ea>>2]=h;c[da+12>>2]=h;c[h+8>>2]=da;c[h+12>>2]=u;break}u=X>>>8;if(u)if(X>>>0>16777215)fa=31;else{i=(u+1048320|0)>>>16&8;s=u<<i;u=(s+520192|0)>>>16&4;n=s<<u;s=(n+245760|0)>>>16&2;g=14-(u|i|s)+(n<<s>>>15)|0;fa=X>>>(g+7|0)&1|g<<1}else fa=0;g=16152+(fa<<2)|0;c[h+28>>2]=fa;s=h+16|0;c[s+4>>2]=0;c[s>>2]=0;s=1<<fa;if(!(ca&s)){c[3963]=ca|s;c[g>>2]=h;c[h+24>>2]=g;c[h+12>>2]=h;c[h+8>>2]=h;break}s=c[g>>2]|0;c:do if((c[s+4>>2]&-8|0)==(X|0))ga=s;else{g=X<<((fa|0)==31?0:25-(fa>>>1)|0);n=s;while(1){ha=n+16+(g>>>31<<2)|0;i=c[ha>>2]|0;if(!i)break;if((c[i+4>>2]&-8|0)==(X|0)){ga=i;break c}else{g=g<<1;n=i}}c[ha>>2]=h;c[h+24>>2]=n;c[h+12>>2]=h;c[h+8>>2]=h;break b}while(0);s=ga+8|0;H=c[s>>2]|0;c[H+12>>2]=h;c[s>>2]=h;c[h+8>>2]=H;c[h+12>>2]=ga;c[h+24>>2]=0}while(0);o=W+8|0;Pa=b;return o|0}else F=f}else F=f}else F=-1;while(0);W=c[3964]|0;if(W>>>0>=F>>>0){ga=W-F|0;ha=c[3967]|0;if(ga>>>0>15){X=ha+F|0;c[3967]=X;c[3964]=ga;c[X+4>>2]=ga|1;c[ha+W>>2]=ga;c[ha+4>>2]=F|3}else{c[3964]=0;c[3967]=0;c[ha+4>>2]=W|3;ga=ha+W+4|0;c[ga>>2]=c[ga>>2]|1}o=ha+8|0;Pa=b;return o|0}ha=c[3965]|0;if(ha>>>0>F>>>0){ga=ha-F|0;c[3965]=ga;W=c[3968]|0;X=W+F|0;c[3968]=X;c[X+4>>2]=ga|1;c[W+4>>2]=F|3;o=W+8|0;Pa=b;return o|0}if(!(c[4080]|0)){c[4082]=4096;c[4081]=4096;c[4083]=-1;c[4084]=-1;c[4085]=0;c[4073]=0;c[4080]=d&-16^1431655768;ia=4096}else ia=c[4082]|0;d=F+48|0;W=F+47|0;ga=ia+W|0;X=0-ia|0;ia=ga&X;if(ia>>>0<=F>>>0){o=0;Pa=b;return o|0}fa=c[4072]|0;if(fa|0?(ca=c[4070]|0,da=ca+ia|0,da>>>0<=ca>>>0|da>>>0>fa>>>0):0){o=0;Pa=b;return o|0}d:do if(!(c[4073]&4)){fa=c[3968]|0;e:do if(fa){da=16296;while(1){ca=c[da>>2]|0;if(ca>>>0<=fa>>>0?(ca+(c[da+4>>2]|0)|0)>>>0>fa>>>0:0)break;ca=c[da+8>>2]|0;if(!ca){L=128;break e}else da=ca}ca=ga-ha&X;if(ca>>>0<2147483647){ea=Wn(ca|0)|0;if((ea|0)==((c[da>>2]|0)+(c[da+4>>2]|0)|0))if((ea|0)==(-1|0))ja=ca;else{ka=ca;la=ea;L=145;break d}else{ma=ea;na=ca;L=136}}else ja=0}else L=128;while(0);do if((L|0)==128){fa=Wn(0)|0;if((fa|0)!=(-1|0)?(f=fa,ca=c[4081]|0,ea=ca+-1|0,Z=((ea&f|0)==0?0:(ea+f&0-ca)-f|0)+ia|0,f=c[4070]|0,ca=Z+f|0,Z>>>0>F>>>0&Z>>>0<2147483647):0){ea=c[4072]|0;if(ea|0?ca>>>0<=f>>>0|ca>>>0>ea>>>0:0){ja=0;break}ea=Wn(Z|0)|0;if((ea|0)==(fa|0)){ka=Z;la=fa;L=145;break d}else{ma=ea;na=Z;L=136}}else ja=0}while(0);do if((L|0)==136){Z=0-na|0;if(!(d>>>0>na>>>0&(na>>>0<2147483647&(ma|0)!=(-1|0))))if((ma|0)==(-1|0)){ja=0;break}else{ka=na;la=ma;L=145;break d}ea=c[4082]|0;fa=W-na+ea&0-ea;if(fa>>>0>=2147483647){ka=na;la=ma;L=145;break d}if((Wn(fa|0)|0)==(-1|0)){Wn(Z|0)|0;ja=0;break}else{ka=fa+na|0;la=ma;L=145;break d}}while(0);c[4073]=c[4073]|4;oa=ja;L=143}else{oa=0;L=143}while(0);if(((L|0)==143?ia>>>0<2147483647:0)?(ja=Wn(ia|0)|0,ia=Wn(0)|0,ma=ia-ja|0,na=ma>>>0>(F+40|0)>>>0,!((ja|0)==(-1|0)|na^1|ja>>>0<ia>>>0&((ja|0)!=(-1|0)&(ia|0)!=(-1|0))^1)):0){ka=na?ma:oa;la=ja;L=145}if((L|0)==145){ja=(c[4070]|0)+ka|0;c[4070]=ja;if(ja>>>0>(c[4071]|0)>>>0)c[4071]=ja;ja=c[3968]|0;f:do if(ja){oa=16296;while(1){pa=c[oa>>2]|0;qa=c[oa+4>>2]|0;if((la|0)==(pa+qa|0)){L=154;break}ma=c[oa+8>>2]|0;if(!ma)break;else oa=ma}if(((L|0)==154?(ma=oa+4|0,(c[oa+12>>2]&8|0)==0):0)?la>>>0>ja>>>0&pa>>>0<=ja>>>0:0){c[ma>>2]=qa+ka;ma=(c[3965]|0)+ka|0;na=ja+8|0;ia=(na&7|0)==0?0:0-na&7;na=ja+ia|0;W=ma-ia|0;c[3968]=na;c[3965]=W;c[na+4>>2]=W|1;c[ja+ma+4>>2]=40;c[3969]=c[4084];break}if(la>>>0<(c[3966]|0)>>>0)c[3966]=la;ma=la+ka|0;W=16296;while(1){if((c[W>>2]|0)==(ma|0)){L=162;break}na=c[W+8>>2]|0;if(!na)break;else W=na}if((L|0)==162?(c[W+12>>2]&8|0)==0:0){c[W>>2]=la;oa=W+4|0;c[oa>>2]=(c[oa>>2]|0)+ka;oa=la+8|0;na=la+((oa&7|0)==0?0:0-oa&7)|0;oa=ma+8|0;ia=ma+((oa&7|0)==0?0:0-oa&7)|0;oa=na+F|0;d=ia-na-F|0;c[na+4>>2]=F|3;g:do if((ja|0)==(ia|0)){X=(c[3965]|0)+d|0;c[3965]=X;c[3968]=oa;c[oa+4>>2]=X|1}else{if((c[3967]|0)==(ia|0)){X=(c[3964]|0)+d|0;c[3964]=X;c[3967]=oa;c[oa+4>>2]=X|1;c[oa+X>>2]=X;break}X=c[ia+4>>2]|0;if((X&3|0)==1){ha=X&-8;ga=X>>>3;h:do if(X>>>0<256){fa=c[ia+8>>2]|0;Z=c[ia+12>>2]|0;if((Z|0)==(fa|0)){c[3962]=c[3962]&~(1<<ga);break}else{c[fa+12>>2]=Z;c[Z+8>>2]=fa;break}}else{fa=c[ia+24>>2]|0;Z=c[ia+12>>2]|0;do if((Z|0)==(ia|0)){ea=ia+16|0;ca=ea+4|0;f=c[ca>>2]|0;if(!f){ba=c[ea>>2]|0;if(!ba){ra=0;break}else{sa=ba;ta=ea}}else{sa=f;ta=ca}ca=sa;f=ta;while(1){ea=ca+20|0;ba=c[ea>>2]|0;if(!ba){aa=ca+16|0;$=c[aa>>2]|0;if(!$)break;else{ua=$;va=aa}}else{ua=ba;va=ea}ca=ua;f=va}c[f>>2]=0;ra=ca}else{ea=c[ia+8>>2]|0;c[ea+12>>2]=Z;c[Z+8>>2]=ea;ra=Z}while(0);if(!fa)break;Z=c[ia+28>>2]|0;n=16152+(Z<<2)|0;do if((c[n>>2]|0)!=(ia|0)){ea=fa+16|0;c[((c[ea>>2]|0)==(ia|0)?ea:fa+20|0)>>2]=ra;if(!ra)break h}else{c[n>>2]=ra;if(ra|0)break;c[3963]=c[3963]&~(1<<Z);break h}while(0);c[ra+24>>2]=fa;Z=ia+16|0;n=c[Z>>2]|0;if(n|0){c[ra+16>>2]=n;c[n+24>>2]=ra}n=c[Z+4>>2]|0;if(!n)break;c[ra+20>>2]=n;c[n+24>>2]=ra}while(0);wa=ia+ha|0;xa=ha+d|0}else{wa=ia;xa=d}ga=wa+4|0;c[ga>>2]=c[ga>>2]&-2;c[oa+4>>2]=xa|1;c[oa+xa>>2]=xa;ga=xa>>>3;if(xa>>>0<256){X=15888+(ga<<1<<2)|0;da=c[3962]|0;n=1<<ga;if(!(da&n)){c[3962]=da|n;ya=X;za=X+8|0}else{n=X+8|0;ya=c[n>>2]|0;za=n}c[za>>2]=oa;c[ya+12>>2]=oa;c[oa+8>>2]=ya;c[oa+12>>2]=X;break}X=xa>>>8;do if(!X)Aa=0;else{if(xa>>>0>16777215){Aa=31;break}n=(X+1048320|0)>>>16&8;da=X<<n;ga=(da+520192|0)>>>16&4;Z=da<<ga;da=(Z+245760|0)>>>16&2;ea=14-(ga|n|da)+(Z<<da>>>15)|0;Aa=xa>>>(ea+7|0)&1|ea<<1}while(0);X=16152+(Aa<<2)|0;c[oa+28>>2]=Aa;ha=oa+16|0;c[ha+4>>2]=0;c[ha>>2]=0;ha=c[3963]|0;ea=1<<Aa;if(!(ha&ea)){c[3963]=ha|ea;c[X>>2]=oa;c[oa+24>>2]=X;c[oa+12>>2]=oa;c[oa+8>>2]=oa;break}ea=c[X>>2]|0;i:do if((c[ea+4>>2]&-8|0)==(xa|0))Ba=ea;else{X=xa<<((Aa|0)==31?0:25-(Aa>>>1)|0);ha=ea;while(1){Ca=ha+16+(X>>>31<<2)|0;da=c[Ca>>2]|0;if(!da)break;if((c[da+4>>2]&-8|0)==(xa|0)){Ba=da;break i}else{X=X<<1;ha=da}}c[Ca>>2]=oa;c[oa+24>>2]=ha;c[oa+12>>2]=oa;c[oa+8>>2]=oa;break g}while(0);ea=Ba+8|0;X=c[ea>>2]|0;c[X+12>>2]=oa;c[ea>>2]=oa;c[oa+8>>2]=X;c[oa+12>>2]=Ba;c[oa+24>>2]=0}while(0);o=na+8|0;Pa=b;return o|0}oa=16296;while(1){d=c[oa>>2]|0;if(d>>>0<=ja>>>0?(Da=d+(c[oa+4>>2]|0)|0,Da>>>0>ja>>>0):0)break;oa=c[oa+8>>2]|0}oa=Da+-47|0;na=oa+8|0;d=oa+((na&7|0)==0?0:0-na&7)|0;na=ja+16|0;oa=d>>>0<na>>>0?ja:d;d=oa+8|0;ia=ka+-40|0;ma=la+8|0;W=(ma&7|0)==0?0:0-ma&7;ma=la+W|0;X=ia-W|0;c[3968]=ma;c[3965]=X;c[ma+4>>2]=X|1;c[la+ia+4>>2]=40;c[3969]=c[4084];ia=oa+4|0;c[ia>>2]=27;c[d>>2]=c[4074];c[d+4>>2]=c[4075];c[d+8>>2]=c[4076];c[d+12>>2]=c[4077];c[4074]=la;c[4075]=ka;c[4077]=0;c[4076]=d;d=oa+24|0;do{X=d;d=d+4|0;c[d>>2]=7}while((X+8|0)>>>0<Da>>>0);if((oa|0)!=(ja|0)){d=oa-ja|0;c[ia>>2]=c[ia>>2]&-2;c[ja+4>>2]=d|1;c[oa>>2]=d;X=d>>>3;if(d>>>0<256){ma=15888+(X<<1<<2)|0;W=c[3962]|0;ea=1<<X;if(!(W&ea)){c[3962]=W|ea;Ea=ma;Fa=ma+8|0}else{ea=ma+8|0;Ea=c[ea>>2]|0;Fa=ea}c[Fa>>2]=ja;c[Ea+12>>2]=ja;c[ja+8>>2]=Ea;c[ja+12>>2]=ma;break}ma=d>>>8;if(ma)if(d>>>0>16777215)Ga=31;else{ea=(ma+1048320|0)>>>16&8;W=ma<<ea;ma=(W+520192|0)>>>16&4;X=W<<ma;W=(X+245760|0)>>>16&2;fa=14-(ma|ea|W)+(X<<W>>>15)|0;Ga=d>>>(fa+7|0)&1|fa<<1}else Ga=0;fa=16152+(Ga<<2)|0;c[ja+28>>2]=Ga;c[ja+20>>2]=0;c[na>>2]=0;W=c[3963]|0;X=1<<Ga;if(!(W&X)){c[3963]=W|X;c[fa>>2]=ja;c[ja+24>>2]=fa;c[ja+12>>2]=ja;c[ja+8>>2]=ja;break}X=c[fa>>2]|0;j:do if((c[X+4>>2]&-8|0)==(d|0))Ha=X;else{fa=d<<((Ga|0)==31?0:25-(Ga>>>1)|0);W=X;while(1){Ia=W+16+(fa>>>31<<2)|0;ea=c[Ia>>2]|0;if(!ea)break;if((c[ea+4>>2]&-8|0)==(d|0)){Ha=ea;break j}else{fa=fa<<1;W=ea}}c[Ia>>2]=ja;c[ja+24>>2]=W;c[ja+12>>2]=ja;c[ja+8>>2]=ja;break f}while(0);d=Ha+8|0;X=c[d>>2]|0;c[X+12>>2]=ja;c[d>>2]=ja;c[ja+8>>2]=X;c[ja+12>>2]=Ha;c[ja+24>>2]=0}}else{X=c[3966]|0;if((X|0)==0|la>>>0<X>>>0)c[3966]=la;c[4074]=la;c[4075]=ka;c[4077]=0;c[3971]=c[4080];c[3970]=-1;c[3975]=15888;c[3974]=15888;c[3977]=15896;c[3976]=15896;c[3979]=15904;c[3978]=15904;c[3981]=15912;c[3980]=15912;c[3983]=15920;c[3982]=15920;c[3985]=15928;c[3984]=15928;c[3987]=15936;c[3986]=15936;c[3989]=15944;c[3988]=15944;c[3991]=15952;c[3990]=15952;c[3993]=15960;c[3992]=15960;c[3995]=15968;c[3994]=15968;c[3997]=15976;c[3996]=15976;c[3999]=15984;c[3998]=15984;c[4001]=15992;c[4e3]=15992;c[4003]=16e3;c[4002]=16e3;c[4005]=16008;c[4004]=16008;c[4007]=16016;c[4006]=16016;c[4009]=16024;c[4008]=16024;c[4011]=16032;c[4010]=16032;c[4013]=16040;c[4012]=16040;c[4015]=16048;c[4014]=16048;c[4017]=16056;c[4016]=16056;c[4019]=16064;c[4018]=16064;c[4021]=16072;c[4020]=16072;c[4023]=16080;c[4022]=16080;c[4025]=16088;c[4024]=16088;c[4027]=16096;c[4026]=16096;c[4029]=16104;c[4028]=16104;c[4031]=16112;c[4030]=16112;c[4033]=16120;c[4032]=16120;c[4035]=16128;c[4034]=16128;c[4037]=16136;c[4036]=16136;X=ka+-40|0;d=la+8|0;na=(d&7|0)==0?0:0-d&7;d=la+na|0;oa=X-na|0;c[3968]=d;c[3965]=oa;c[d+4>>2]=oa|1;c[la+X+4>>2]=40;c[3969]=c[4084]}while(0);la=c[3965]|0;if(la>>>0>F>>>0){ka=la-F|0;c[3965]=ka;la=c[3968]|0;ja=la+F|0;c[3968]=ja;c[ja+4>>2]=ka|1;c[la+4>>2]=F|3;o=la+8|0;Pa=b;return o|0}}la=Qk()|0;c[la>>2]=12;o=0;Pa=b;return o|0}function Ik(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;if(!a)return;b=a+-8|0;d=c[3966]|0;e=c[a+-4>>2]|0;a=e&-8;f=b+a|0;do if(!(e&1)){g=c[b>>2]|0;if(!(e&3))return;h=b+(0-g)|0;i=g+a|0;if(h>>>0<d>>>0)return;if((c[3967]|0)==(h|0)){j=f+4|0;k=c[j>>2]|0;if((k&3|0)!=3){l=h;m=i;n=h;break}c[3964]=i;c[j>>2]=k&-2;c[h+4>>2]=i|1;c[h+i>>2]=i;return}k=g>>>3;if(g>>>0<256){g=c[h+8>>2]|0;j=c[h+12>>2]|0;if((j|0)==(g|0)){c[3962]=c[3962]&~(1<<k);l=h;m=i;n=h;break}else{c[g+12>>2]=j;c[j+8>>2]=g;l=h;m=i;n=h;break}}g=c[h+24>>2]|0;j=c[h+12>>2]|0;do if((j|0)==(h|0)){k=h+16|0;o=k+4|0;p=c[o>>2]|0;if(!p){q=c[k>>2]|0;if(!q){r=0;break}else{s=q;t=k}}else{s=p;t=o}o=s;p=t;while(1){k=o+20|0;q=c[k>>2]|0;if(!q){u=o+16|0;v=c[u>>2]|0;if(!v)break;else{w=v;x=u}}else{w=q;x=k}o=w;p=x}c[p>>2]=0;r=o}else{k=c[h+8>>2]|0;c[k+12>>2]=j;c[j+8>>2]=k;r=j}while(0);if(g){j=c[h+28>>2]|0;k=16152+(j<<2)|0;if((c[k>>2]|0)==(h|0)){c[k>>2]=r;if(!r){c[3963]=c[3963]&~(1<<j);l=h;m=i;n=h;break}}else{j=g+16|0;c[((c[j>>2]|0)==(h|0)?j:g+20|0)>>2]=r;if(!r){l=h;m=i;n=h;break}}c[r+24>>2]=g;j=h+16|0;k=c[j>>2]|0;if(k|0){c[r+16>>2]=k;c[k+24>>2]=r}k=c[j+4>>2]|0;if(k){c[r+20>>2]=k;c[k+24>>2]=r;l=h;m=i;n=h}else{l=h;m=i;n=h}}else{l=h;m=i;n=h}}else{l=b;m=a;n=b}while(0);if(n>>>0>=f>>>0)return;b=f+4|0;a=c[b>>2]|0;if(!(a&1))return;if(!(a&2)){if((c[3968]|0)==(f|0)){r=(c[3965]|0)+m|0;c[3965]=r;c[3968]=l;c[l+4>>2]=r|1;if((l|0)!=(c[3967]|0))return;c[3967]=0;c[3964]=0;return}if((c[3967]|0)==(f|0)){r=(c[3964]|0)+m|0;c[3964]=r;c[3967]=n;c[l+4>>2]=r|1;c[n+r>>2]=r;return}r=(a&-8)+m|0;x=a>>>3;do if(a>>>0<256){w=c[f+8>>2]|0;t=c[f+12>>2]|0;if((t|0)==(w|0)){c[3962]=c[3962]&~(1<<x);break}else{c[w+12>>2]=t;c[t+8>>2]=w;break}}else{w=c[f+24>>2]|0;t=c[f+12>>2]|0;do if((t|0)==(f|0)){s=f+16|0;d=s+4|0;e=c[d>>2]|0;if(!e){k=c[s>>2]|0;if(!k){y=0;break}else{z=k;A=s}}else{z=e;A=d}d=z;e=A;while(1){s=d+20|0;k=c[s>>2]|0;if(!k){j=d+16|0;q=c[j>>2]|0;if(!q)break;else{B=q;C=j}}else{B=k;C=s}d=B;e=C}c[e>>2]=0;y=d}else{o=c[f+8>>2]|0;c[o+12>>2]=t;c[t+8>>2]=o;y=t}while(0);if(w|0){t=c[f+28>>2]|0;h=16152+(t<<2)|0;if((c[h>>2]|0)==(f|0)){c[h>>2]=y;if(!y){c[3963]=c[3963]&~(1<<t);break}}else{t=w+16|0;c[((c[t>>2]|0)==(f|0)?t:w+20|0)>>2]=y;if(!y)break}c[y+24>>2]=w;t=f+16|0;h=c[t>>2]|0;if(h|0){c[y+16>>2]=h;c[h+24>>2]=y}h=c[t+4>>2]|0;if(h|0){c[y+20>>2]=h;c[h+24>>2]=y}}}while(0);c[l+4>>2]=r|1;c[n+r>>2]=r;if((l|0)==(c[3967]|0)){c[3964]=r;return}else D=r}else{c[b>>2]=a&-2;c[l+4>>2]=m|1;c[n+m>>2]=m;D=m}m=D>>>3;if(D>>>0<256){n=15888+(m<<1<<2)|0;a=c[3962]|0;b=1<<m;if(!(a&b)){c[3962]=a|b;E=n;F=n+8|0}else{b=n+8|0;E=c[b>>2]|0;F=b}c[F>>2]=l;c[E+12>>2]=l;c[l+8>>2]=E;c[l+12>>2]=n;return}n=D>>>8;if(n)if(D>>>0>16777215)G=31;else{E=(n+1048320|0)>>>16&8;F=n<<E;n=(F+520192|0)>>>16&4;b=F<<n;F=(b+245760|0)>>>16&2;a=14-(n|E|F)+(b<<F>>>15)|0;G=D>>>(a+7|0)&1|a<<1}else G=0;a=16152+(G<<2)|0;c[l+28>>2]=G;c[l+20>>2]=0;c[l+16>>2]=0;F=c[3963]|0;b=1<<G;a:do if(!(F&b)){c[3963]=F|b;c[a>>2]=l;c[l+24>>2]=a;c[l+12>>2]=l;c[l+8>>2]=l}else{E=c[a>>2]|0;b:do if((c[E+4>>2]&-8|0)==(D|0))H=E;else{n=D<<((G|0)==31?0:25-(G>>>1)|0);m=E;while(1){I=m+16+(n>>>31<<2)|0;r=c[I>>2]|0;if(!r)break;if((c[r+4>>2]&-8|0)==(D|0)){H=r;break b}else{n=n<<1;m=r}}c[I>>2]=l;c[l+24>>2]=m;c[l+12>>2]=l;c[l+8>>2]=l;break a}while(0);E=H+8|0;w=c[E>>2]|0;c[w+12>>2]=l;c[E>>2]=l;c[l+8>>2]=w;c[l+12>>2]=H;c[l+24>>2]=0}while(0);l=(c[3970]|0)+-1|0;c[3970]=l;if(l|0)return;l=16304;while(1){H=c[l>>2]|0;if(!H)break;else l=H+8|0}c[3970]=-1;return}function Jk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;if(!a){d=Hk(b)|0;return d|0}if(b>>>0>4294967231){e=Qk()|0;c[e>>2]=12;d=0;return d|0}e=Kk(a+-8|0,b>>>0<11?16:b+11&-8)|0;if(e|0){d=e+8|0;return d|0}e=Hk(b)|0;if(!e){d=0;return d|0}f=c[a+-4>>2]|0;g=(f&-8)-((f&3|0)==0?8:4)|0;Un(e|0,a|0,(g>>>0<b>>>0?g:b)|0)|0;Ik(a);d=e;return d|0}function Kk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;d=a+4|0;e=c[d>>2]|0;f=e&-8;g=a+f|0;if(!(e&3)){if(b>>>0<256){h=0;return h|0}if(f>>>0>=(b+4|0)>>>0?(f-b|0)>>>0<=c[4082]<<1>>>0:0){h=a;return h|0}h=0;return h|0}if(f>>>0>=b>>>0){i=f-b|0;if(i>>>0<=15){h=a;return h|0}j=a+b|0;c[d>>2]=e&1|b|2;c[j+4>>2]=i|3;k=g+4|0;c[k>>2]=c[k>>2]|1;Lk(j,i);h=a;return h|0}if((c[3968]|0)==(g|0)){i=(c[3965]|0)+f|0;j=i-b|0;k=a+b|0;if(i>>>0<=b>>>0){h=0;return h|0}c[d>>2]=e&1|b|2;c[k+4>>2]=j|1;c[3968]=k;c[3965]=j;h=a;return h|0}if((c[3967]|0)==(g|0)){j=(c[3964]|0)+f|0;if(j>>>0<b>>>0){h=0;return h|0}k=j-b|0;if(k>>>0>15){i=a+b|0;l=a+j|0;c[d>>2]=e&1|b|2;c[i+4>>2]=k|1;c[l>>2]=k;m=l+4|0;c[m>>2]=c[m>>2]&-2;n=i;o=k}else{c[d>>2]=e&1|j|2;k=a+j+4|0;c[k>>2]=c[k>>2]|1;n=0;o=0}c[3964]=o;c[3967]=n;h=a;return h|0}n=c[g+4>>2]|0;if(n&2|0){h=0;return h|0}o=(n&-8)+f|0;if(o>>>0<b>>>0){h=0;return h|0}f=o-b|0;k=n>>>3;do if(n>>>0<256){j=c[g+8>>2]|0;i=c[g+12>>2]|0;if((i|0)==(j|0)){c[3962]=c[3962]&~(1<<k);break}else{c[j+12>>2]=i;c[i+8>>2]=j;break}}else{j=c[g+24>>2]|0;i=c[g+12>>2]|0;do if((i|0)==(g|0)){m=g+16|0;l=m+4|0;p=c[l>>2]|0;if(!p){q=c[m>>2]|0;if(!q){r=0;break}else{s=q;t=m}}else{s=p;t=l}l=s;p=t;while(1){m=l+20|0;q=c[m>>2]|0;if(!q){u=l+16|0;v=c[u>>2]|0;if(!v)break;else{w=v;x=u}}else{w=q;x=m}l=w;p=x}c[p>>2]=0;r=l}else{m=c[g+8>>2]|0;c[m+12>>2]=i;c[i+8>>2]=m;r=i}while(0);if(j|0){i=c[g+28>>2]|0;m=16152+(i<<2)|0;if((c[m>>2]|0)==(g|0)){c[m>>2]=r;if(!r){c[3963]=c[3963]&~(1<<i);break}}else{i=j+16|0;c[((c[i>>2]|0)==(g|0)?i:j+20|0)>>2]=r;if(!r)break}c[r+24>>2]=j;i=g+16|0;m=c[i>>2]|0;if(m|0){c[r+16>>2]=m;c[m+24>>2]=r}m=c[i+4>>2]|0;if(m|0){c[r+20>>2]=m;c[m+24>>2]=r}}}while(0);if(f>>>0<16){c[d>>2]=e&1|o|2;r=a+o+4|0;c[r>>2]=c[r>>2]|1;h=a;return h|0}else{r=a+b|0;c[d>>2]=e&1|b|2;c[r+4>>2]=f|3;b=a+o+4|0;c[b>>2]=c[b>>2]|1;Lk(r,f);h=a;return h|0}return 0}function Lk(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;d=a+b|0;e=c[a+4>>2]|0;do if(!(e&1)){f=c[a>>2]|0;if(!(e&3))return;g=a+(0-f)|0;h=f+b|0;if((c[3967]|0)==(g|0)){i=d+4|0;j=c[i>>2]|0;if((j&3|0)!=3){k=g;l=h;break}c[3964]=h;c[i>>2]=j&-2;c[g+4>>2]=h|1;c[d>>2]=h;return}j=f>>>3;if(f>>>0<256){f=c[g+8>>2]|0;i=c[g+12>>2]|0;if((i|0)==(f|0)){c[3962]=c[3962]&~(1<<j);k=g;l=h;break}else{c[f+12>>2]=i;c[i+8>>2]=f;k=g;l=h;break}}f=c[g+24>>2]|0;i=c[g+12>>2]|0;do if((i|0)==(g|0)){j=g+16|0;m=j+4|0;n=c[m>>2]|0;if(!n){o=c[j>>2]|0;if(!o){p=0;break}else{q=o;r=j}}else{q=n;r=m}m=q;n=r;while(1){j=m+20|0;o=c[j>>2]|0;if(!o){s=m+16|0;t=c[s>>2]|0;if(!t)break;else{u=t;v=s}}else{u=o;v=j}m=u;n=v}c[n>>2]=0;p=m}else{j=c[g+8>>2]|0;c[j+12>>2]=i;c[i+8>>2]=j;p=i}while(0);if(f){i=c[g+28>>2]|0;j=16152+(i<<2)|0;if((c[j>>2]|0)==(g|0)){c[j>>2]=p;if(!p){c[3963]=c[3963]&~(1<<i);k=g;l=h;break}}else{i=f+16|0;c[((c[i>>2]|0)==(g|0)?i:f+20|0)>>2]=p;if(!p){k=g;l=h;break}}c[p+24>>2]=f;i=g+16|0;j=c[i>>2]|0;if(j|0){c[p+16>>2]=j;c[j+24>>2]=p}j=c[i+4>>2]|0;if(j){c[p+20>>2]=j;c[j+24>>2]=p;k=g;l=h}else{k=g;l=h}}else{k=g;l=h}}else{k=a;l=b}while(0);b=d+4|0;a=c[b>>2]|0;if(!(a&2)){if((c[3968]|0)==(d|0)){p=(c[3965]|0)+l|0;c[3965]=p;c[3968]=k;c[k+4>>2]=p|1;if((k|0)!=(c[3967]|0))return;c[3967]=0;c[3964]=0;return}if((c[3967]|0)==(d|0)){p=(c[3964]|0)+l|0;c[3964]=p;c[3967]=k;c[k+4>>2]=p|1;c[k+p>>2]=p;return}p=(a&-8)+l|0;v=a>>>3;do if(a>>>0<256){u=c[d+8>>2]|0;r=c[d+12>>2]|0;if((r|0)==(u|0)){c[3962]=c[3962]&~(1<<v);break}else{c[u+12>>2]=r;c[r+8>>2]=u;break}}else{u=c[d+24>>2]|0;r=c[d+12>>2]|0;do if((r|0)==(d|0)){q=d+16|0;e=q+4|0;j=c[e>>2]|0;if(!j){i=c[q>>2]|0;if(!i){w=0;break}else{x=i;y=q}}else{x=j;y=e}e=x;j=y;while(1){q=e+20|0;i=c[q>>2]|0;if(!i){o=e+16|0;s=c[o>>2]|0;if(!s)break;else{z=s;A=o}}else{z=i;A=q}e=z;j=A}c[j>>2]=0;w=e}else{m=c[d+8>>2]|0;c[m+12>>2]=r;c[r+8>>2]=m;w=r}while(0);if(u|0){r=c[d+28>>2]|0;h=16152+(r<<2)|0;if((c[h>>2]|0)==(d|0)){c[h>>2]=w;if(!w){c[3963]=c[3963]&~(1<<r);break}}else{r=u+16|0;c[((c[r>>2]|0)==(d|0)?r:u+20|0)>>2]=w;if(!w)break}c[w+24>>2]=u;r=d+16|0;h=c[r>>2]|0;if(h|0){c[w+16>>2]=h;c[h+24>>2]=w}h=c[r+4>>2]|0;if(h|0){c[w+20>>2]=h;c[h+24>>2]=w}}}while(0);c[k+4>>2]=p|1;c[k+p>>2]=p;if((k|0)==(c[3967]|0)){c[3964]=p;return}else B=p}else{c[b>>2]=a&-2;c[k+4>>2]=l|1;c[k+l>>2]=l;B=l}l=B>>>3;if(B>>>0<256){a=15888+(l<<1<<2)|0;b=c[3962]|0;p=1<<l;if(!(b&p)){c[3962]=b|p;C=a;D=a+8|0}else{p=a+8|0;C=c[p>>2]|0;D=p}c[D>>2]=k;c[C+12>>2]=k;c[k+8>>2]=C;c[k+12>>2]=a;return}a=B>>>8;if(a)if(B>>>0>16777215)E=31;else{C=(a+1048320|0)>>>16&8;D=a<<C;a=(D+520192|0)>>>16&4;p=D<<a;D=(p+245760|0)>>>16&2;b=14-(a|C|D)+(p<<D>>>15)|0;E=B>>>(b+7|0)&1|b<<1}else E=0;b=16152+(E<<2)|0;c[k+28>>2]=E;c[k+20>>2]=0;c[k+16>>2]=0;D=c[3963]|0;p=1<<E;if(!(D&p)){c[3963]=D|p;c[b>>2]=k;c[k+24>>2]=b;c[k+12>>2]=k;c[k+8>>2]=k;return}p=c[b>>2]|0;a:do if((c[p+4>>2]&-8|0)==(B|0))F=p;else{b=B<<((E|0)==31?0:25-(E>>>1)|0);D=p;while(1){G=D+16+(b>>>31<<2)|0;C=c[G>>2]|0;if(!C)break;if((c[C+4>>2]&-8|0)==(B|0)){F=C;break a}else{b=b<<1;D=C}}c[G>>2]=k;c[k+24>>2]=D;c[k+12>>2]=k;c[k+8>>2]=k;return}while(0);G=F+8|0;B=c[G>>2]|0;c[B+12>>2]=k;c[G>>2]=k;c[k+8>>2]=B;c[k+12>>2]=F;c[k+24>>2]=0;return}function Mk(a){a=a|0;var b=0,d=0,e=0;b=Pa;Pa=Pa+16|0;d=b;e=Sk(c[a+60>>2]|0)|0;c[d>>2]=e;e=Pk(ga(6,d|0)|0)|0;Pa=b;return e|0}function Nk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0;f=Pa;Pa=Pa+32|0;g=f;c[b+36>>2]=132;if((c[b>>2]&64|0)==0?(c[g>>2]=c[b+60>>2],c[g+4>>2]=21523,c[g+8>>2]=f+16,fa(54,g|0)|0):0)a[b+75>>0]=-1;g=Rk(b,d,e)|0;Pa=f;return g|0}function Ok(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=Pa;Pa=Pa+32|0;f=e;g=e+20|0;c[f>>2]=c[a+60>>2];c[f+4>>2]=0;c[f+8>>2]=b;c[f+12>>2]=g;c[f+16>>2]=d;if((Pk(Y(140,f|0)|0)|0)<0){c[g>>2]=-1;h=-1}else h=c[g>>2]|0;Pa=e;return h|0}function Pk(a){a=a|0;var b=0,d=0;if(a>>>0>4294963200){b=Qk()|0;c[b>>2]=0-a;d=-1}else d=a;return d|0}function Qk(){return 16344}function Rk(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;e=Pa;Pa=Pa+48|0;f=e+32|0;g=e+16|0;h=e;i=a+28|0;j=c[i>>2]|0;c[h>>2]=j;k=a+20|0;l=(c[k>>2]|0)-j|0;c[h+4>>2]=l;c[h+8>>2]=b;c[h+12>>2]=d;b=l+d|0;l=a+60|0;c[g>>2]=c[l>>2];c[g+4>>2]=h;c[g+8>>2]=2;j=Pk(_(146,g|0)|0)|0;a:do if((b|0)!=(j|0)){g=2;m=b;n=h;o=j;while(1){if((o|0)<0)break;m=m-o|0;p=c[n+4>>2]|0;q=o>>>0>p>>>0;r=q?n+8|0:n;s=g+(q<<31>>31)|0;t=o-(q?p:0)|0;c[r>>2]=(c[r>>2]|0)+t;p=r+4|0;c[p>>2]=(c[p>>2]|0)-t;c[f>>2]=c[l>>2];c[f+4>>2]=r;c[f+8>>2]=s;o=Pk(_(146,f|0)|0)|0;if((m|0)==(o|0)){u=3;break a}else{g=s;n=r}}c[a+16>>2]=0;c[i>>2]=0;c[k>>2]=0;c[a>>2]=c[a>>2]|32;if((g|0)==2)v=0;else v=d-(c[n+4>>2]|0)|0}else u=3;while(0);if((u|0)==3){u=c[a+44>>2]|0;c[a+16>>2]=u+(c[a+48>>2]|0);a=u;c[i>>2]=a;c[k>>2]=a;v=d}Pa=e;return v|0}function Sk(a){a=a|0;return a|0}function Tk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;f=Pa;Pa=Pa+32|0;g=f+16|0;h=f;c[h>>2]=d;i=h+4|0;j=b+48|0;k=c[j>>2]|0;c[i>>2]=e-((k|0)!=0&1);l=b+44|0;c[h+8>>2]=c[l>>2];c[h+12>>2]=k;c[g>>2]=c[b+60>>2];c[g+4>>2]=h;c[g+8>>2]=2;h=Pk(Z(145,g|0)|0)|0;if((h|0)>=1){g=c[i>>2]|0;if(h>>>0>g>>>0){i=c[l>>2]|0;l=b+4|0;c[l>>2]=i;k=i;c[b+8>>2]=k+(h-g);if(!(c[j>>2]|0))m=e;else{c[l>>2]=k+1;a[d+(e+-1)>>0]=a[k>>0]|0;m=e}}else m=h}else{c[b>>2]=c[b>>2]|h&48^16;m=h}Pa=f;return m|0}function Uk(a){a=a|0;return 1}function Vk(a){a=a|0;var b=0,e=0,f=0;b=Pa;Pa=Pa+16|0;e=b;if((Zk(a)|0)==0?(Va[c[a+32>>2]&255](a,e,1)|0)==1:0)f=d[e>>0]|0;else f=-1;Pa=b;return f|0}function Wk(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;do if((b|0)!=-1){if((c[d+76>>2]|0)>-1)e=Uk(d)|0;else e=0;f=d+4|0;g=c[f>>2]|0;if(!g){Zk(d)|0;h=c[f>>2]|0;if(h|0){i=h;j=6}}else{i=g;j=6}if((j|0)==6?i>>>0>((c[d+44>>2]|0)+-8|0)>>>0:0){g=i+-1|0;c[f>>2]=g;a[g>>0]=b;c[d>>2]=c[d>>2]&-17;if(!e){k=b;break}Yk(d);k=b;break}if(e){Yk(d);k=-1}else k=-1}else k=-1;while(0);return k|0}function Xk(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;f=d&255;g=(e|0)!=0;a:do if(g&(b&3|0)!=0){h=d&255;i=b;j=e;while(1){if((a[i>>0]|0)==h<<24>>24){k=i;l=j;m=6;break a}n=i+1|0;o=j+-1|0;p=(o|0)!=0;if(p&(n&3|0)!=0){i=n;j=o}else{q=n;r=o;s=p;m=5;break}}}else{q=b;r=e;s=g;m=5}while(0);if((m|0)==5)if(s){k=q;l=r;m=6}else m=16;b:do if((m|0)==6){r=d&255;if((a[k>>0]|0)==r<<24>>24)if(!l){m=16;break}else{t=k;break}q=H(f,16843009)|0;c:do if(l>>>0>3){s=k;g=l;while(1){e=c[s>>2]^q;if((e&-2139062144^-2139062144)&e+-16843009|0){u=g;v=s;break c}e=s+4|0;b=g+-4|0;if(b>>>0>3){s=e;g=b}else{w=e;x=b;m=11;break}}}else{w=k;x=l;m=11}while(0);if((m|0)==11)if(!x){m=16;break}else{u=x;v=w}q=v;g=u;while(1){if((a[q>>0]|0)==r<<24>>24){t=q;break b}g=g+-1|0;if(!g){m=16;break}else q=q+1|0}}while(0);if((m|0)==16)t=0;return t|0}function Yk(a){a=a|0;return}function Zk(b){b=b|0;var d=0,e=0,f=0;d=b+74|0;e=a[d>>0]|0;a[d>>0]=e+255|e;e=b+20|0;d=b+28|0;if((c[e>>2]|0)>>>0>(c[d>>2]|0)>>>0)Va[c[b+36>>2]&255](b,0,0)|0;c[b+16>>2]=0;c[d>>2]=0;c[e>>2]=0;e=c[b>>2]|0;if(!(e&4)){d=(c[b+44>>2]|0)+(c[b+48>>2]|0)|0;c[b+8>>2]=d;c[b+4>>2]=d;f=e<<27>>31}else{c[b>>2]=e|32;f=-1}return f|0}function _k(){return 5888}function $k(a){a=a|0;return (a+-48|0)>>>0<10|0}function al(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;d=dl(a,b,f)|0;Pa=e;return d|0}function bl(a){a=a|0;var b=0;b=(wl()|0)+188|0;return xl(a,c[b>>2]|0)|0}function cl(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;g=Pa;Pa=Pa+128|0;h=g+124|0;i=g;j=i;k=6132;l=j+124|0;do{c[j>>2]=c[k>>2];j=j+4|0;k=k+4|0}while((j|0)<(l|0));if((d+-1|0)>>>0>2147483646)if(!d){m=h;n=1;o=4}else{h=Qk()|0;c[h>>2]=75;p=-1}else{m=b;n=d;o=4}if((o|0)==4){o=-2-m|0;d=n>>>0>o>>>0?o:n;c[i+48>>2]=d;n=i+20|0;c[n>>2]=m;c[i+44>>2]=m;o=m+d|0;m=i+16|0;c[m>>2]=o;c[i+28>>2]=o;o=dl(i,e,f)|0;if(!d)p=o;else{d=c[n>>2]|0;a[d+(((d|0)==(c[m>>2]|0))<<31>>31)>>0]=0;p=o}}Pa=g;return p|0}function dl(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;f=Pa;Pa=Pa+224|0;g=f+208|0;h=f+160|0;i=f+80|0;j=f;k=h;l=k+40|0;do{c[k>>2]=0;k=k+4|0}while((k|0)<(l|0));c[g>>2]=c[e>>2];if((el(0,d,g,i,h)|0)<0)m=-1;else{if((c[b+76>>2]|0)>-1)n=Uk(b)|0;else n=0;e=c[b>>2]|0;k=e&32;if((a[b+74>>0]|0)<1)c[b>>2]=e&-33;e=b+48|0;if(!(c[e>>2]|0)){l=b+44|0;o=c[l>>2]|0;c[l>>2]=j;p=b+28|0;c[p>>2]=j;q=b+20|0;c[q>>2]=j;c[e>>2]=80;r=b+16|0;c[r>>2]=j+80;j=el(b,d,g,i,h)|0;if(!o)s=j;else{Va[c[b+36>>2]&255](b,0,0)|0;t=(c[q>>2]|0)==0?-1:j;c[l>>2]=o;c[e>>2]=0;c[r>>2]=0;c[p>>2]=0;c[q>>2]=0;s=t}}else s=el(b,d,g,i,h)|0;h=c[b>>2]|0;c[b>>2]=h|k;if(n|0)Yk(b);m=(h&32|0)==0?s:-1}Pa=f;return m|0}function el(d,e,f,h,i){d=d|0;e=e|0;f=f|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0;j=Pa;Pa=Pa+64|0;k=j+56|0;l=j+40|0;m=j;n=j+48|0;o=j+60|0;c[k>>2]=e;e=(d|0)!=0;p=m+40|0;q=p;r=m+39|0;m=n+4|0;s=0;t=0;u=0;a:while(1){v=s;w=t;while(1){do if((w|0)>-1)if((v|0)>(2147483647-w|0)){x=Qk()|0;c[x>>2]=75;y=-1;break}else{y=v+w|0;break}else y=w;while(0);z=c[k>>2]|0;x=a[z>>0]|0;if(!(x<<24>>24)){A=94;break a}B=x;x=z;b:while(1){switch(B<<24>>24){case 37:{A=10;break b;break}case 0:{C=x;break b;break}default:{}}D=x+1|0;c[k>>2]=D;B=a[D>>0]|0;x=D}c:do if((A|0)==10){A=0;B=x;D=x;while(1){if((a[D+1>>0]|0)!=37){C=B;break c}E=B+1|0;D=D+2|0;c[k>>2]=D;if((a[D>>0]|0)!=37){C=E;break}else B=E}}while(0);v=C-z|0;if(e)fl(d,z,v);if(!v)break;else w=y}w=($k(a[(c[k>>2]|0)+1>>0]|0)|0)==0;v=c[k>>2]|0;if(!w?(a[v+2>>0]|0)==36:0){F=(a[v+1>>0]|0)+-48|0;G=1;H=3}else{F=-1;G=u;H=1}w=v+H|0;c[k>>2]=w;v=a[w>>0]|0;x=(v<<24>>24)+-32|0;if(x>>>0>31|(1<<x&75913|0)==0){I=0;J=v;K=w}else{v=0;B=x;x=w;while(1){w=1<<B|v;D=x+1|0;c[k>>2]=D;E=a[D>>0]|0;B=(E<<24>>24)+-32|0;if(B>>>0>31|(1<<B&75913|0)==0){I=w;J=E;K=D;break}else{v=w;x=D}}}if(J<<24>>24==42){if(($k(a[K+1>>0]|0)|0)!=0?(x=c[k>>2]|0,(a[x+2>>0]|0)==36):0){v=x+1|0;c[i+((a[v>>0]|0)+-48<<2)>>2]=10;M=c[h+((a[v>>0]|0)+-48<<3)>>2]|0;N=1;O=x+3|0}else{if(G|0){P=-1;break}if(e){x=(c[f>>2]|0)+(4-1)&~(4-1);v=c[x>>2]|0;c[f>>2]=x+4;Q=v}else Q=0;M=Q;N=0;O=(c[k>>2]|0)+1|0}c[k>>2]=O;v=(M|0)<0;R=v?0-M|0:M;S=v?I|8192:I;T=N;U=O}else{v=gl(k)|0;if((v|0)<0){P=-1;break}R=v;S=I;T=G;U=c[k>>2]|0}do if((a[U>>0]|0)==46){v=U+1|0;if((a[v>>0]|0)!=42){c[k>>2]=v;v=gl(k)|0;V=v;W=c[k>>2]|0;break}if($k(a[U+2>>0]|0)|0?(v=c[k>>2]|0,(a[v+3>>0]|0)==36):0){x=v+2|0;c[i+((a[x>>0]|0)+-48<<2)>>2]=10;B=c[h+((a[x>>0]|0)+-48<<3)>>2]|0;x=v+4|0;c[k>>2]=x;V=B;W=x;break}if(T|0){P=-1;break a}if(e){x=(c[f>>2]|0)+(4-1)&~(4-1);B=c[x>>2]|0;c[f>>2]=x+4;X=B}else X=0;B=(c[k>>2]|0)+2|0;c[k>>2]=B;V=X;W=B}else{V=-1;W=U}while(0);B=0;x=W;while(1){if(((a[x>>0]|0)+-65|0)>>>0>57){P=-1;break a}v=x;x=x+1|0;c[k>>2]=x;Y=a[(a[v>>0]|0)+-65+(2592+(B*58|0))>>0]|0;Z=Y&255;if((Z+-1|0)>>>0>=8)break;else B=Z}if(!(Y<<24>>24)){P=-1;break}v=(F|0)>-1;do if(Y<<24>>24==19)if(v){P=-1;break a}else A=54;else{if(v){c[i+(F<<2)>>2]=Z;D=h+(F<<3)|0;w=c[D+4>>2]|0;E=l;c[E>>2]=c[D>>2];c[E+4>>2]=w;A=54;break}if(!e){P=0;break a}hl(l,Z,f);_=c[k>>2]|0;A=55}while(0);if((A|0)==54){A=0;if(e){_=x;A=55}else $=0}d:do if((A|0)==55){A=0;v=a[_+-1>>0]|0;w=(B|0)!=0&(v&15|0)==3?v&-33:v;v=S&-65537;E=(S&8192|0)==0?S:v;e:do switch(w|0){case 110:{switch((B&255)<<24>>24){case 0:{c[c[l>>2]>>2]=y;$=0;break d;break}case 1:{c[c[l>>2]>>2]=y;$=0;break d;break}case 2:{D=c[l>>2]|0;c[D>>2]=y;c[D+4>>2]=((y|0)<0)<<31>>31;$=0;break d;break}case 3:{b[c[l>>2]>>1]=y;$=0;break d;break}case 4:{a[c[l>>2]>>0]=y;$=0;break d;break}case 6:{c[c[l>>2]>>2]=y;$=0;break d;break}case 7:{D=c[l>>2]|0;c[D>>2]=y;c[D+4>>2]=((y|0)<0)<<31>>31;$=0;break d;break}default:{$=0;break d}}break}case 112:{aa=120;ba=V>>>0>8?V:8;ca=E|8;A=67;break}case 88:case 120:{aa=w;ba=V;ca=E;A=67;break}case 111:{D=l;da=c[D>>2]|0;ea=c[D+4>>2]|0;D=jl(da,ea,p)|0;fa=q-D|0;ga=D;ha=0;ia=13451;ja=(E&8|0)==0|(V|0)>(fa|0)?V:fa+1|0;ka=E;la=da;ma=ea;A=73;break}case 105:case 100:{ea=l;da=c[ea>>2]|0;fa=c[ea+4>>2]|0;if((fa|0)<0){ea=Jn(0,0,da|0,fa|0)|0;D=L()|0;na=l;c[na>>2]=ea;c[na+4>>2]=D;oa=1;pa=13451;qa=ea;ra=D;A=72;break e}else{oa=(E&2049|0)!=0&1;pa=(E&2048|0)==0?((E&1|0)==0?13451:13453):13452;qa=da;ra=fa;A=72;break e}break}case 117:{fa=l;oa=0;pa=13451;qa=c[fa>>2]|0;ra=c[fa+4>>2]|0;A=72;break}case 99:{a[r>>0]=c[l>>2];sa=r;ta=0;ua=13451;va=1;wa=v;xa=q;break}case 109:{fa=Qk()|0;ya=bl(c[fa>>2]|0)|0;A=77;break}case 115:{fa=c[l>>2]|0;ya=(fa|0)==0?13461:fa;A=77;break}case 67:{c[n>>2]=c[l>>2];c[m>>2]=0;c[l>>2]=n;za=-1;A=81;break}case 83:{if(!V){ll(d,32,R,0,E);Aa=0;A=91}else{za=V;A=81}break}case 65:case 71:case 70:case 69:case 97:case 103:case 102:case 101:{$=nl(d,+g[l>>3],R,V,E,w)|0;break d;break}default:{sa=z;ta=0;ua=13451;va=V;wa=E;xa=q}}while(0);f:do if((A|0)==67){A=0;w=l;fa=c[w>>2]|0;da=c[w+4>>2]|0;w=il(fa,da,p,aa&32)|0;D=(ca&8|0)==0|(fa|0)==0&(da|0)==0;ga=w;ha=D?0:2;ia=D?13451:13451+(aa>>>4)|0;ja=ba;ka=ca;la=fa;ma=da;A=73}else if((A|0)==72){A=0;ga=kl(qa,ra,p)|0;ha=oa;ia=pa;ja=V;ka=E;la=qa;ma=ra;A=73}else if((A|0)==77){A=0;da=Xk(ya,0,V)|0;fa=(da|0)==0;sa=ya;ta=0;ua=13451;va=fa?V:da-ya|0;wa=v;xa=fa?ya+V|0:da}else if((A|0)==81){A=0;da=c[l>>2]|0;fa=0;while(1){D=c[da>>2]|0;if(!D){Ba=fa;break}w=ml(o,D)|0;Ca=(w|0)<0;if(Ca|w>>>0>(za-fa|0)>>>0){A=85;break}D=w+fa|0;if(za>>>0>D>>>0){da=da+4|0;fa=D}else{Ba=D;break}}if((A|0)==85){A=0;if(Ca){P=-1;break a}else Ba=fa}ll(d,32,R,Ba,E);if(!Ba){Aa=0;A=91}else{da=c[l>>2]|0;D=0;while(1){w=c[da>>2]|0;if(!w){Aa=Ba;A=91;break f}ea=ml(o,w)|0;D=ea+D|0;if((D|0)>(Ba|0)){Aa=Ba;A=91;break f}fl(d,o,ea);if(D>>>0>=Ba>>>0){Aa=Ba;A=91;break}else da=da+4|0}}}while(0);if((A|0)==73){A=0;v=(la|0)!=0|(ma|0)!=0;da=(ja|0)!=0|v;D=q-ga+((v^1)&1)|0;sa=da?ga:p;ta=ha;ua=ia;va=da?((ja|0)>(D|0)?ja:D):0;wa=(ja|0)>-1?ka&-65537:ka;xa=q}else if((A|0)==91){A=0;ll(d,32,R,Aa,E^8192);$=(R|0)>(Aa|0)?R:Aa;break}D=xa-sa|0;da=(va|0)<(D|0)?D:va;v=da+ta|0;fa=(R|0)<(v|0)?v:R;ll(d,32,fa,v,wa);fl(d,ua,ta);ll(d,48,fa,v,wa^65536);ll(d,48,da,D,0);fl(d,sa,D);ll(d,32,fa,v,wa^8192);$=fa}while(0);s=$;t=y;u=T}g:do if((A|0)==94)if(!d)if(!u)P=0;else{T=1;while(1){t=c[i+(T<<2)>>2]|0;if(!t)break;hl(h+(T<<3)|0,t,f);t=T+1|0;if(t>>>0<10)T=t;else{P=1;break g}}t=T;while(1){if(c[i+(t<<2)>>2]|0){P=-1;break g}t=t+1|0;if(t>>>0>=10){P=1;break}}}else P=y;while(0);Pa=j;return P|0}function fl(a,b,d){a=a|0;b=b|0;d=d|0;if(!(c[a>>2]&32))tl(b,d,a)|0;return}function gl(b){b=b|0;var d=0,e=0,f=0,g=0,h=0;if(!($k(a[c[b>>2]>>0]|0)|0))d=0;else{e=0;while(1){f=c[b>>2]|0;g=(e*10|0)+-48+(a[f>>0]|0)|0;h=f+1|0;c[b>>2]=h;if(!($k(a[h>>0]|0)|0)){d=g;break}else e=g}}return d|0}function hl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0,i=0,j=0.0;a:do if(b>>>0<=20)do switch(b|0){case 9:{e=(c[d>>2]|0)+(4-1)&~(4-1);f=c[e>>2]|0;c[d>>2]=e+4;c[a>>2]=f;break a;break}case 10:{f=(c[d>>2]|0)+(4-1)&~(4-1);e=c[f>>2]|0;c[d>>2]=f+4;f=a;c[f>>2]=e;c[f+4>>2]=((e|0)<0)<<31>>31;break a;break}case 11:{e=(c[d>>2]|0)+(4-1)&~(4-1);f=c[e>>2]|0;c[d>>2]=e+4;e=a;c[e>>2]=f;c[e+4>>2]=0;break a;break}case 12:{e=(c[d>>2]|0)+(8-1)&~(8-1);f=e;h=c[f>>2]|0;i=c[f+4>>2]|0;c[d>>2]=e+8;e=a;c[e>>2]=h;c[e+4>>2]=i;break a;break}case 13:{i=(c[d>>2]|0)+(4-1)&~(4-1);e=c[i>>2]|0;c[d>>2]=i+4;i=(e&65535)<<16>>16;e=a;c[e>>2]=i;c[e+4>>2]=((i|0)<0)<<31>>31;break a;break}case 14:{i=(c[d>>2]|0)+(4-1)&~(4-1);e=c[i>>2]|0;c[d>>2]=i+4;i=a;c[i>>2]=e&65535;c[i+4>>2]=0;break a;break}case 15:{i=(c[d>>2]|0)+(4-1)&~(4-1);e=c[i>>2]|0;c[d>>2]=i+4;i=(e&255)<<24>>24;e=a;c[e>>2]=i;c[e+4>>2]=((i|0)<0)<<31>>31;break a;break}case 16:{i=(c[d>>2]|0)+(4-1)&~(4-1);e=c[i>>2]|0;c[d>>2]=i+4;i=a;c[i>>2]=e&255;c[i+4>>2]=0;break a;break}case 17:{i=(c[d>>2]|0)+(8-1)&~(8-1);j=+g[i>>3];c[d>>2]=i+8;g[a>>3]=j;break a;break}case 18:{i=(c[d>>2]|0)+(8-1)&~(8-1);j=+g[i>>3];c[d>>2]=i+8;g[a>>3]=j;break a;break}default:break a}while(0);while(0);return}function il(b,c,e,f){b=b|0;c=c|0;e=e|0;f=f|0;var g=0,h=0;if((b|0)==0&(c|0)==0)g=e;else{h=e;e=c;c=b;while(1){b=h+-1|0;a[b>>0]=d[3056+(c&15)>>0]|0|f;c=On(c|0,e|0,4)|0;e=L()|0;if((c|0)==0&(e|0)==0){g=b;break}else h=b}}return g|0}function jl(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0;if((b|0)==0&(c|0)==0)e=d;else{f=d;d=c;c=b;while(1){b=f+-1|0;a[b>>0]=c&7|48;c=On(c|0,d|0,3)|0;d=L()|0;if((c|0)==0&(d|0)==0){e=b;break}else f=b}}return e|0}function kl(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;if(c>>>0>0|(c|0)==0&b>>>0>4294967295){e=d;f=b;g=c;do{c=f;f=Mn(f|0,g|0,10,0)|0;h=g;g=L()|0;i=Hn(f|0,g|0,10,0)|0;j=Jn(c|0,h|0,i|0,L()|0)|0;L()|0;e=e+-1|0;a[e>>0]=j&255|48}while(h>>>0>9|(h|0)==9&c>>>0>4294967295);k=f;l=e}else{k=b;l=d}if(!k)m=l;else{d=k;k=l;while(1){l=d;d=(d>>>0)/10|0;b=k+-1|0;a[b>>0]=l-(d*10|0)|48;if(l>>>0<10){m=b;break}else k=b}}return m|0}function ll(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=Pa;Pa=Pa+256|0;g=f;if((c|0)>(d|0)&(e&73728|0)==0){e=c-d|0;Vn(g|0,b<<24>>24|0,(e>>>0<256?e:256)|0)|0;if(e>>>0>255){b=c-d|0;d=e;do{fl(a,g,256);d=d+-256|0}while(d>>>0>255);h=b&255}else h=e;fl(a,g,h)}Pa=f;return}function ml(a,b){a=a|0;b=b|0;var c=0;if(!a)c=0;else c=rl(a,b,0)|0;return c|0}function nl(b,e,f,g,h,i){b=b|0;e=+e;f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0.0,t=0,u=0.0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0.0,E=0,F=0,G=0,I=0.0,J=0,K=0,M=0,N=0,O=0,P=0,Q=0.0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0.0,ia=0.0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0;j=Pa;Pa=Pa+560|0;k=j+32|0;l=j+536|0;m=j;n=m;o=j+540|0;c[l>>2]=0;p=o+12|0;q=ol(e)|0;r=L()|0;if((r|0)<0){s=-e;t=ol(s)|0;u=s;v=1;w=13468;x=L()|0;y=t}else{u=e;v=(h&2049|0)!=0&1;w=(h&2048|0)==0?((h&1|0)==0?13469:13474):13471;x=r;y=q}do if(0==0&(x&2146435072|0)==2146435072){q=(i&32|0)!=0;y=v+3|0;ll(b,32,f,y,h&-65537);fl(b,w,v);fl(b,u!=u|0.0!=0.0?(q?13508:13495):q?13487:13491,3);ll(b,32,f,y,h^8192);z=y}else{e=+pl(u,l)*2.0;y=e!=0.0;if(y)c[l>>2]=(c[l>>2]|0)+-1;q=i|32;if((q|0)==97){r=i&32;t=(r|0)==0?w:w+9|0;A=v|2;B=12-g|0;do if(!(g>>>0>11|(B|0)==0)){s=8.0;C=B;do{C=C+-1|0;s=s*16.0}while((C|0)!=0);if((a[t>>0]|0)==45){D=-(s+(-e-s));break}else{D=e+s-s;break}}else D=e;while(0);B=c[l>>2]|0;C=(B|0)<0?0-B|0:B;E=kl(C,((C|0)<0)<<31>>31,p)|0;if((E|0)==(p|0)){C=o+11|0;a[C>>0]=48;F=C}else F=E;a[F+-1>>0]=(B>>31&2)+43;B=F+-2|0;a[B>>0]=i+15;E=(g|0)<1;C=(h&8|0)==0;G=m;I=D;while(1){J=~~I;K=G+1|0;a[G>>0]=r|d[3056+J>>0];I=(I-+(J|0))*16.0;if((K-n|0)==1?!(C&(E&I==0.0)):0){a[K>>0]=46;M=G+2|0}else M=K;if(!(I!=0.0))break;else G=M}G=M;if((g|0)!=0?(-2-n+G|0)<(g|0):0){E=p;C=B;N=g+2+E-C|0;O=E;P=C}else{C=p;E=B;N=C-n-E+G|0;O=C;P=E}E=N+A|0;ll(b,32,f,E,h);fl(b,t,A);ll(b,48,f,E,h^65536);C=G-n|0;fl(b,m,C);G=O-P|0;ll(b,48,N-(C+G)|0,0,0);fl(b,B,G);ll(b,32,f,E,h^8192);z=E;break}E=(g|0)<0?6:g;if(y){G=(c[l>>2]|0)+-28|0;c[l>>2]=G;Q=e*268435456.0;R=G}else{Q=e;R=c[l>>2]|0}G=(R|0)<0?k:k+288|0;C=G;I=Q;do{r=~~I>>>0;c[C>>2]=r;C=C+4|0;I=(I-+(r>>>0))*1.0e9}while(I!=0.0);y=G;if((R|0)>0){B=G;A=C;t=R;while(1){r=(t|0)<29?t:29;K=A+-4|0;if(K>>>0>=B>>>0){J=K;K=0;do{S=Pn(c[J>>2]|0,0,r|0)|0;T=In(S|0,L()|0,K|0,0)|0;S=L()|0;K=Mn(T|0,S|0,1e9,0)|0;U=Hn(K|0,L()|0,1e9,0)|0;V=Jn(T|0,S|0,U|0,L()|0)|0;L()|0;c[J>>2]=V;J=J+-4|0}while(J>>>0>=B>>>0);if(K){J=B+-4|0;c[J>>2]=K;W=J}else W=B}else W=B;a:do if(A>>>0>W>>>0){J=A;while(1){V=J+-4|0;if(c[V>>2]|0){X=J;break a}if(V>>>0>W>>>0)J=V;else{X=V;break}}}else X=A;while(0);K=(c[l>>2]|0)-r|0;c[l>>2]=K;if((K|0)>0){B=W;A=X;t=K}else{Y=W;Z=X;_=K;break}}}else{Y=G;Z=C;_=R}if((_|0)<0){t=((E+25|0)/9|0)+1|0;A=(q|0)==102;B=Y;K=Z;J=_;while(1){V=0-J|0;U=(V|0)<9?V:9;if(B>>>0<K>>>0){V=(1<<U)+-1|0;S=1e9>>>U;T=0;$=B;do{aa=c[$>>2]|0;c[$>>2]=(aa>>>U)+T;T=H(aa&V,S)|0;$=$+4|0}while($>>>0<K>>>0);$=(c[B>>2]|0)==0?B+4|0:B;if(!T){ba=K;ca=$}else{c[K>>2]=T;ba=K+4|0;ca=$}}else{ba=K;ca=(c[B>>2]|0)==0?B+4|0:B}$=A?G:ca;S=(ba-$>>2|0)>(t|0)?$+(t<<2)|0:ba;J=(c[l>>2]|0)+U|0;c[l>>2]=J;if((J|0)>=0){da=ca;ea=S;break}else{B=ca;K=S}}}else{da=Y;ea=Z}if(da>>>0<ea>>>0){K=(y-da>>2)*9|0;B=c[da>>2]|0;if(B>>>0<10)fa=K;else{J=K;K=10;while(1){K=K*10|0;t=J+1|0;if(B>>>0<K>>>0){fa=t;break}else J=t}}}else fa=0;J=(q|0)==103;K=(E|0)!=0;B=E-((q|0)==102?0:fa)+((K&J)<<31>>31)|0;if((B|0)<(((ea-y>>2)*9|0)+-9|0)){t=B+9216|0;B=(t|0)/9|0;A=G+4+(B+-1024<<2)|0;C=t-(B*9|0)|0;if((C|0)<8){B=C;C=10;while(1){t=C*10|0;if((B|0)<7){B=B+1|0;C=t}else{ga=t;break}}}else ga=10;C=c[A>>2]|0;B=(C>>>0)/(ga>>>0)|0;q=C-(H(B,ga)|0)|0;t=(A+4|0)==(ea|0);if(!(t&(q|0)==0)){s=(B&1|0)==0?9007199254740992.0:9007199254740994.0;B=ga>>>1;I=q>>>0<B>>>0?.5:t&(q|0)==(B|0)?1.0:1.5;if(!v){ha=I;ia=s}else{B=(a[w>>0]|0)==45;ha=B?-I:I;ia=B?-s:s}B=C-q|0;c[A>>2]=B;if(ia+ha!=ia){q=B+ga|0;c[A>>2]=q;if(q>>>0>999999999){q=A;B=da;while(1){C=q+-4|0;c[q>>2]=0;if(C>>>0<B>>>0){t=B+-4|0;c[t>>2]=0;ja=t}else ja=B;t=(c[C>>2]|0)+1|0;c[C>>2]=t;if(t>>>0>999999999){q=C;B=ja}else{ka=C;la=ja;break}}}else{ka=A;la=da}B=(y-la>>2)*9|0;q=c[la>>2]|0;if(q>>>0<10){ma=ka;na=B;oa=la}else{C=B;B=10;while(1){B=B*10|0;t=C+1|0;if(q>>>0<B>>>0){ma=ka;na=t;oa=la;break}else C=t}}}else{ma=A;na=fa;oa=da}}else{ma=A;na=fa;oa=da}C=ma+4|0;pa=na;qa=ea>>>0>C>>>0?C:ea;ra=oa}else{pa=fa;qa=ea;ra=da}C=0-pa|0;b:do if(qa>>>0>ra>>>0){B=qa;while(1){q=B+-4|0;if(c[q>>2]|0){sa=B;ta=1;break b}if(q>>>0>ra>>>0)B=q;else{sa=q;ta=0;break}}}else{sa=qa;ta=0}while(0);do if(J){A=E+((K^1)&1)|0;if((A|0)>(pa|0)&(pa|0)>-5){ua=i+-1|0;va=A+-1-pa|0}else{ua=i+-2|0;va=A+-1|0}if(!(h&8)){if(ta?(A=c[sa+-4>>2]|0,(A|0)!=0):0)if(!((A>>>0)%10|0)){B=0;U=10;while(1){U=U*10|0;T=B+1|0;if((A>>>0)%(U>>>0)|0|0){wa=T;break}else B=T}}else wa=0;else wa=9;B=((sa-y>>2)*9|0)+-9|0;if((ua|32|0)==102){U=B-wa|0;A=(U|0)>0?U:0;xa=ua;ya=(va|0)<(A|0)?va:A;break}else{A=B+pa-wa|0;B=(A|0)>0?A:0;xa=ua;ya=(va|0)<(B|0)?va:B;break}}else{xa=ua;ya=va}}else{xa=i;ya=E}while(0);E=(ya|0)!=0;y=E?1:h>>>3&1;K=(xa|32|0)==102;if(K){za=0;Aa=(pa|0)>0?pa:0}else{J=(pa|0)<0?C:pa;B=kl(J,((J|0)<0)<<31>>31,p)|0;J=p;if((J-B|0)<2){A=B;while(1){U=A+-1|0;a[U>>0]=48;if((J-U|0)<2)A=U;else{Ba=U;break}}}else Ba=B;a[Ba+-1>>0]=(pa>>31&2)+43;A=Ba+-2|0;a[A>>0]=xa;za=A;Aa=J-A|0}A=v+1+ya+y+Aa|0;ll(b,32,f,A,h);fl(b,w,v);ll(b,48,f,A,h^65536);if(K){C=ra>>>0>G>>>0?G:ra;U=m+9|0;T=U;q=m+8|0;t=C;do{S=kl(c[t>>2]|0,0,U)|0;if((t|0)==(C|0))if((S|0)==(U|0)){a[q>>0]=48;Ca=q}else Ca=S;else if(S>>>0>m>>>0){Vn(m|0,48,S-n|0)|0;$=S;while(1){V=$+-1|0;if(V>>>0>m>>>0)$=V;else{Ca=V;break}}}else Ca=S;fl(b,Ca,T-Ca|0);t=t+4|0}while(t>>>0<=G>>>0);if(!((h&8|0)==0&(E^1)))fl(b,13528,1);if(t>>>0<sa>>>0&(ya|0)>0){G=ya;T=t;while(1){q=kl(c[T>>2]|0,0,U)|0;if(q>>>0>m>>>0){Vn(m|0,48,q-n|0)|0;C=q;while(1){K=C+-1|0;if(K>>>0>m>>>0)C=K;else{Da=K;break}}}else Da=q;fl(b,Da,(G|0)<9?G:9);T=T+4|0;C=G+-9|0;if(!(T>>>0<sa>>>0&(G|0)>9)){Ea=C;break}else G=C}}else Ea=ya;ll(b,48,Ea+9|0,9,0)}else{G=ta?sa:ra+4|0;if(ra>>>0<G>>>0&(ya|0)>-1){T=m+9|0;U=(h&8|0)==0;t=T;E=0-n|0;C=m+8|0;S=ya;K=ra;while(1){y=kl(c[K>>2]|0,0,T)|0;if((y|0)==(T|0)){a[C>>0]=48;Fa=C}else Fa=y;do if((K|0)==(ra|0)){y=Fa+1|0;fl(b,Fa,1);if(U&(S|0)<1){Ga=y;break}fl(b,13528,1);Ga=y}else{if(Fa>>>0<=m>>>0){Ga=Fa;break}Vn(m|0,48,Fa+E|0)|0;y=Fa;while(1){J=y+-1|0;if(J>>>0>m>>>0)y=J;else{Ga=J;break}}}while(0);q=t-Ga|0;fl(b,Ga,(S|0)>(q|0)?q:S);y=S-q|0;K=K+4|0;if(!(K>>>0<G>>>0&(y|0)>-1)){Ha=y;break}else S=y}}else Ha=ya;ll(b,48,Ha+18|0,18,0);fl(b,za,p-za|0)}ll(b,32,f,A,h^8192);z=A}while(0);Pa=j;return ((z|0)<(f|0)?f:z)|0}function ol(a){a=+a;var b=0;g[h>>3]=a;b=c[h>>2]|0;K(c[h+4>>2]|0);return b|0}function pl(a,b){a=+a;b=b|0;return +(+ql(a,b))}function ql(a,b){a=+a;b=b|0;var d=0,e=0,f=0,i=0.0,j=0.0,k=0,l=0.0;g[h>>3]=a;d=c[h>>2]|0;e=c[h+4>>2]|0;f=On(d|0,e|0,52)|0;L()|0;switch(f&2047){case 0:{if(a!=0.0){i=+ql(a*18446744073709551616.0,b);j=i;k=(c[b>>2]|0)+-64|0}else{j=a;k=0}c[b>>2]=k;l=j;break}case 2047:{l=a;break}default:{c[b>>2]=(f&2047)+-1022;c[h>>2]=d;c[h+4>>2]=e&-2146435073|1071644672;l=+g[h>>3]}}return +l}function rl(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;do if(b){if(d>>>0<128){a[b>>0]=d;f=1;break}e=(sl()|0)+188|0;if(!(c[c[e>>2]>>2]|0))if((d&-128|0)==57216){a[b>>0]=d;f=1;break}else{e=Qk()|0;c[e>>2]=84;f=-1;break}if(d>>>0<2048){a[b>>0]=d>>>6|192;a[b+1>>0]=d&63|128;f=2;break}if(d>>>0<55296|(d&-8192|0)==57344){a[b>>0]=d>>>12|224;a[b+1>>0]=d>>>6&63|128;a[b+2>>0]=d&63|128;f=3;break}if((d+-65536|0)>>>0<1048576){a[b>>0]=d>>>18|240;a[b+1>>0]=d>>>12&63|128;a[b+2>>0]=d>>>6&63|128;a[b+3>>0]=d&63|128;f=4;break}else{e=Qk()|0;c[e>>2]=84;f=-1;break}}else f=1;while(0);return f|0}function sl(){return _k()|0}function tl(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;f=e+16|0;g=c[f>>2]|0;if(!g)if(!(ul(e)|0)){h=c[f>>2]|0;i=5}else j=0;else{h=g;i=5}a:do if((i|0)==5){g=e+20|0;f=c[g>>2]|0;k=f;if((h-f|0)>>>0<d>>>0){j=Va[c[e+36>>2]&255](e,b,d)|0;break}b:do if((a[e+75>>0]|0)<0|(d|0)==0){l=0;m=b;n=d;o=k}else{f=d;while(1){p=f+-1|0;if((a[b+p>>0]|0)==10)break;if(!p){l=0;m=b;n=d;o=k;break b}else f=p}p=Va[c[e+36>>2]&255](e,b,f)|0;if(p>>>0<f>>>0){j=p;break a}l=f;m=b+f|0;n=d-f|0;o=c[g>>2]|0}while(0);Un(o|0,m|0,n|0)|0;c[g>>2]=(c[g>>2]|0)+n;j=l+n|0}while(0);return j|0}function ul(b){b=b|0;var d=0,e=0,f=0;d=b+74|0;e=a[d>>0]|0;a[d>>0]=e+255|e;e=c[b>>2]|0;if(!(e&8)){c[b+8>>2]=0;c[b+4>>2]=0;d=c[b+44>>2]|0;c[b+28>>2]=d;c[b+20>>2]=d;c[b+16>>2]=d+(c[b+48>>2]|0);f=0}else{c[b>>2]=e|32;f=-1}return f|0}function vl(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=a+20|0;f=c[e>>2]|0;g=(c[a+16>>2]|0)-f|0;a=g>>>0>d>>>0?d:g;Un(f|0,b|0,a|0)|0;c[e>>2]=(c[e>>2]|0)+a;return d|0}function wl(){return _k()|0}function xl(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;f=0;while(1){if((d[3072+f>>0]|0)==(b|0)){g=4;break}h=f+1|0;if((h|0)==87){i=87;g=5;break}else f=h}if((g|0)==4)if(!f)j=3168;else{i=f;g=5}if((g|0)==5){g=3168;f=i;while(1){i=g;do{b=i;i=i+1|0}while((a[b>>0]|0)!=0);f=f+-1|0;if(!f){j=i;break}else g=i}}return yl(j,c[e+20>>2]|0)|0}function yl(a,b){a=a|0;b=b|0;return zl(a,b)|0}function zl(a,b){a=a|0;b=b|0;var d=0;if(!b)d=0;else d=Al(c[b>>2]|0,c[b+4>>2]|0,a)|0;return ((d|0)==0?a:d)|0}function Al(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;f=(c[b>>2]|0)+1794895138|0;g=Bl(c[b+8>>2]|0,f)|0;h=Bl(c[b+12>>2]|0,f)|0;i=Bl(c[b+16>>2]|0,f)|0;a:do if((g>>>0<d>>>2>>>0?(j=d-(g<<2)|0,h>>>0<j>>>0&i>>>0<j>>>0):0)?((i|h)&3|0)==0:0){j=h>>>2;k=i>>>2;l=0;m=g;while(1){n=m>>>1;o=l+n|0;p=o<<1;q=p+j|0;r=Bl(c[b+(q<<2)>>2]|0,f)|0;s=Bl(c[b+(q+1<<2)>>2]|0,f)|0;if(!(s>>>0<d>>>0&r>>>0<(d-s|0)>>>0)){t=0;break a}if(a[b+(s+r)>>0]|0){t=0;break a}r=Cl(e,b+s|0)|0;if(!r)break;s=(r|0)<0;if((m|0)==1){t=0;break a}l=s?l:o;m=s?n:m-n|0}m=p+k|0;l=Bl(c[b+(m<<2)>>2]|0,f)|0;j=Bl(c[b+(m+1<<2)>>2]|0,f)|0;if(j>>>0<d>>>0&l>>>0<(d-j|0)>>>0)t=(a[b+(j+l)>>0]|0)==0?b+j|0:0;else t=0}else t=0;while(0);return t|0}function Bl(a,b){a=a|0;b=b|0;var c=0;c=Qn(a|0)|0;return ((b|0)==0?a:c)|0}function Cl(b,c){b=b|0;c=c|0;var d=0,e=0,f=0,g=0;d=a[b>>0]|0;e=a[c>>0]|0;if(d<<24>>24==0?1:d<<24>>24!=e<<24>>24){f=e;g=d}else{d=c;c=b;do{c=c+1|0;d=d+1|0;b=a[c>>0]|0;e=a[d>>0]|0}while(!(b<<24>>24==0?1:b<<24>>24!=e<<24>>24));f=e;g=b}return (g&255)-(f&255)|0}function Dl(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;f=Pa;Pa=Pa+16|0;g=f;h=e&255;a[g>>0]=h;i=b+16|0;j=c[i>>2]|0;if(!j)if(!(ul(b)|0)){k=c[i>>2]|0;l=4}else m=-1;else{k=j;l=4}do if((l|0)==4){j=b+20|0;i=c[j>>2]|0;if(i>>>0<k>>>0?(n=e&255,(n|0)!=(a[b+75>>0]|0)):0){c[j>>2]=i+1;a[i>>0]=h;m=n;break}if((Va[c[b+36>>2]&255](b,g,1)|0)==1)m=d[g>>0]|0;else m=-1}while(0);Pa=f;return m|0}function El(e,h,i){e=e|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0,Ma=0,Na=0,Oa=0,Qa=0,Ra=0,Sa=0.0,Ta=0,Ua=0,Va=0,Wa=0,Xa=0,Ya=0,Za=0;j=Pa;Pa=Pa+288|0;k=j+264|0;l=j;m=j+260|0;n=j+272|0;if((c[e+76>>2]|0)>-1)o=Uk(e)|0;else o=0;p=a[h>>0]|0;a:do if(p<<24>>24){q=e+4|0;r=e+100|0;s=e+108|0;t=e+8|0;u=l+10|0;v=l+33|0;w=l+46|0;x=l+94|0;y=k+4|0;z=h;A=0;B=0;C=0;D=p;E=0;b:while(1){c:do if(!(Fl(D&255)|0)){F=(a[z>>0]|0)==37;d:do if(F){G=z+1|0;H=a[G>>0]|0;e:do switch(H<<24>>24){case 37:{break d;break}case 42:{I=0;J=z+2|0;break}default:{if($k(H&255)|0?(a[z+2>>0]|0)==36:0){I=Il(i,(d[G>>0]|0)+-48|0)|0;J=z+3|0;break e}K=(c[i>>2]|0)+(4-1)&~(4-1);M=c[K>>2]|0;c[i>>2]=K+4;I=M;J=G}}while(0);if(!($k(d[J>>0]|0)|0)){N=0;O=J}else{G=0;H=J;while(1){M=(G*10|0)+-48+(d[H>>0]|0)|0;K=H+1|0;if(!($k(d[K>>0]|0)|0)){N=M;O=K;break}else{G=M;H=K}}}H=a[O>>0]|0;G=O+1|0;if(H<<24>>24==109){P=(I|0)!=0&1;Q=0;R=G;S=O+2|0;T=a[G>>0]|0;U=0}else{P=0;Q=C;R=O;S=G;T=H;U=E}switch(T<<24>>24){case 104:{H=(a[S>>0]|0)==104;V=H?-2:-1;W=H?R+2|0:S;break}case 108:{H=(a[S>>0]|0)==108;V=H?3:1;W=H?R+2|0:S;break}case 106:{V=3;W=S;break}case 116:case 122:{V=1;W=S;break}case 76:{V=2;W=S;break}case 110:case 112:case 67:case 83:case 91:case 99:case 115:case 88:case 71:case 70:case 69:case 65:case 103:case 102:case 101:case 97:case 120:case 117:case 111:case 105:case 100:{V=0;W=R;break}default:{X=Q;Y=U;Z=143;break b}}H=d[W>>0]|0;G=(H&47|0)==3;K=G?H|32:H;H=G?1:V;G=K&255;switch(G<<24>>24){case 99:{_=(N|0)>1?N:1;$=A;break}case 91:{_=N;$=A;break}case 110:{Jl(I,H,A,((A|0)<0)<<31>>31);aa=W;ba=B;ca=A;da=Q;ea=U;break c;break}default:{Gl(e,0);do{M=c[q>>2]|0;if(M>>>0<(c[r>>2]|0)>>>0){c[q>>2]=M+1;fa=d[M>>0]|0}else fa=Hl(e)|0}while((Fl(fa)|0)!=0);if(!(c[r>>2]|0))ga=c[q>>2]|0;else{M=(c[q>>2]|0)+-1|0;c[q>>2]=M;ga=M}_=N;$=(c[s>>2]|0)+A+ga-(c[t>>2]|0)|0}}Gl(e,_);M=c[q>>2]|0;ha=c[r>>2]|0;if(M>>>0<ha>>>0){c[q>>2]=M+1;ia=ha}else{if((Hl(e)|0)<0){X=Q;Y=U;Z=143;break b}ia=c[r>>2]|0}if(ia|0)c[q>>2]=(c[q>>2]|0)+-1;f:do switch(G<<24>>24){case 91:case 99:case 115:{ha=(K|0)==99;g:do if((K|16|0)==115){Vn(l|0,-1,257)|0;a[l>>0]=0;if((K|0)==115){a[v>>0]=0;b[u>>1]=0;b[u+2>>1]=0;a[u+4>>0]=0;ja=W}else ja=W}else{M=W+1|0;ka=(a[M>>0]|0)==94;la=ka&1;ma=ka?W+2|0:M;Vn(l|0,la|0,257)|0;a[l>>0]=0;switch(a[ma>>0]|0){case 45:{M=(la^1)&255;a[w>>0]=M;na=ma+1|0;oa=M;break}case 93:{M=(la^1)&255;a[x>>0]=M;na=ma+1|0;oa=M;break}default:{na=ma;oa=(la^1)&255}}la=na;while(1){ma=a[la>>0]|0;h:do switch(ma<<24>>24){case 0:{X=Q;Y=U;Z=143;break b;break}case 93:{ja=la;break g;break}case 45:{M=la+1|0;ka=a[M>>0]|0;switch(ka<<24>>24){case 93:case 0:{pa=la;qa=45;break h;break}default:{}}ra=a[la+-1>>0]|0;if((ra&255)<(ka&255)){sa=ra&255;do{sa=sa+1|0;a[l+sa>>0]=oa;ra=a[M>>0]|0}while(sa>>>0<(ra&255)>>>0);pa=M;qa=ra}else{pa=M;qa=ka}break}default:{pa=la;qa=ma}}while(0);a[l+((qa&255)+1)>>0]=oa;la=pa+1|0}}while(0);la=ha?_+1|0:31;ma=(H|0)==1;sa=(P|0)!=0;i:do if(ma){if(sa){ra=Hk(la<<2)|0;if(!ra){X=0;Y=0;Z=143;break b}else ta=ra}else ta=I;c[k>>2]=0;c[y>>2]=0;ra=la;ua=0;va=ta;j:while(1){wa=(va|0)==0;xa=ua;while(1){k:while(1){ya=c[q>>2]|0;if(ya>>>0<(c[r>>2]|0)>>>0){c[q>>2]=ya+1;za=d[ya>>0]|0}else za=Hl(e)|0;if(!(a[l+(za+1)>>0]|0))break j;a[n>>0]=za;switch(Kl(m,n,1,k)|0){case -1:{X=0;Y=va;Z=143;break b;break}case -2:break;default:break k}}if(wa)Aa=xa;else{c[va+(xa<<2)>>2]=c[m>>2];Aa=xa+1|0}if(sa&(Aa|0)==(ra|0))break;else xa=Aa}ra=ra<<1|1;wa=Jk(va,ra<<2)|0;if(!wa){X=0;Y=va;Z=143;break b}else{ua=Aa;va=wa}}if(!(Ll(k)|0)){X=0;Y=va;Z=143;break b}else{Ba=xa;Ca=0;Da=va;Ea=va}}else{if(sa){ua=Hk(la)|0;if(!ua){X=0;Y=0;Z=143;break b}ra=la;wa=0;ka=ua;while(1){ua=wa;do{M=c[q>>2]|0;if(M>>>0<(c[r>>2]|0)>>>0){c[q>>2]=M+1;Fa=d[M>>0]|0}else Fa=Hl(e)|0;if(!(a[l+(Fa+1)>>0]|0)){Ba=ua;Ca=ka;Da=0;Ea=0;break i}M=ua;ua=ua+1|0;a[ka+M>>0]=Fa}while((ua|0)!=(ra|0));ra=ra<<1|1;M=Jk(ka,ra)|0;if(!M){X=ka;Y=0;Z=143;break b}else{wa=ua;ka=M}}}if(!I)while(1){ka=c[q>>2]|0;if(ka>>>0<(c[r>>2]|0)>>>0){c[q>>2]=ka+1;Ga=d[ka>>0]|0}else Ga=Hl(e)|0;if(!(a[l+(Ga+1)>>0]|0)){Ba=0;Ca=0;Da=0;Ea=0;break i}}ka=0;while(1){wa=c[q>>2]|0;if(wa>>>0<(c[r>>2]|0)>>>0){c[q>>2]=wa+1;Ha=d[wa>>0]|0}else Ha=Hl(e)|0;if(!(a[l+(Ha+1)>>0]|0)){Ba=ka;Ca=I;Da=0;Ea=0;break i}a[I+ka>>0]=Ha;ka=ka+1|0}}while(0);if(!(c[r>>2]|0))Ia=c[q>>2]|0;else{la=(c[q>>2]|0)+-1|0;c[q>>2]=la;Ia=la}la=Ia-(c[t>>2]|0)+(c[s>>2]|0)|0;if(!la){Ja=Ca;Ka=P;La=B;Ma=Ea;break b}if(!((la|0)==(_|0)|ha^1)){Ja=Ca;Ka=P;La=B;Ma=Ea;break b}do if(sa)if(ma){c[I>>2]=Da;break}else{c[I>>2]=Ca;break}while(0);if(ha){Na=ja;Oa=Ca;Qa=Ea}else{if(Da|0)c[Da+(Ba<<2)>>2]=0;if(!Ca){Na=ja;Oa=0;Qa=Ea;break f}a[Ca+Ba>>0]=0;Na=ja;Oa=Ca;Qa=Ea}break}case 120:case 88:case 112:{Ra=16;Z=131;break}case 111:{Ra=8;Z=131;break}case 117:case 100:{Ra=10;Z=131;break}case 105:{Ra=0;Z=131;break}case 71:case 103:case 70:case 102:case 69:case 101:case 65:case 97:{Sa=+Nl(e,H,0);if((c[s>>2]|0)==((c[t>>2]|0)-(c[q>>2]|0)|0)){Ja=Q;Ka=P;La=B;Ma=U;break b}if(!I){Na=W;Oa=Q;Qa=U}else switch(H|0){case 0:{f[I>>2]=Sa;Na=W;Oa=Q;Qa=U;break f;break}case 1:{g[I>>3]=Sa;Na=W;Oa=Q;Qa=U;break f;break}case 2:{g[I>>3]=Sa;Na=W;Oa=Q;Qa=U;break f;break}default:{Na=W;Oa=Q;Qa=U;break f}}break}default:{Na=W;Oa=Q;Qa=U}}while(0);do if((Z|0)==131){Z=0;G=Ml(e,Ra,0,-1,-1)|0;ma=L()|0;if((c[s>>2]|0)==((c[t>>2]|0)-(c[q>>2]|0)|0)){Ja=Q;Ka=P;La=B;Ma=U;break b}if((I|0)!=0&(K|0)==112){c[I>>2]=G;Na=W;Oa=Q;Qa=U;break}else{Jl(I,H,G,ma);Na=W;Oa=Q;Qa=U;break}}while(0);aa=Na;ba=B+((I|0)!=0&1)|0;ca=(c[s>>2]|0)+$+(c[q>>2]|0)-(c[t>>2]|0)|0;da=Oa;ea=Qa;break c}while(0);H=z+(F&1)|0;Gl(e,0);K=c[q>>2]|0;if(K>>>0<(c[r>>2]|0)>>>0){c[q>>2]=K+1;Ta=d[K>>0]|0}else Ta=Hl(e)|0;if((Ta|0)!=(d[H>>0]|0)){Z=23;break b}aa=H;ba=B;ca=A+1|0;da=C;ea=E}else{H=z;while(1){K=H+1|0;if(!(Fl(d[K>>0]|0)|0))break;else H=K}Gl(e,0);do{F=c[q>>2]|0;if(F>>>0<(c[r>>2]|0)>>>0){c[q>>2]=F+1;Ua=d[F>>0]|0}else Ua=Hl(e)|0}while((Fl(Ua)|0)!=0);if(!(c[r>>2]|0))Va=c[q>>2]|0;else{F=(c[q>>2]|0)+-1|0;c[q>>2]=F;Va=F}aa=H;ba=B;ca=(c[s>>2]|0)+A+Va-(c[t>>2]|0)|0;da=C;ea=E}while(0);z=aa+1|0;D=a[z>>0]|0;if(!(D<<24>>24)){Wa=ba;break a}else{A=ca;B=ba;C=da;E=ea}}if((Z|0)==23){if(c[r>>2]|0)c[q>>2]=(c[q>>2]|0)+-1;if((B|0)!=0|(Ta|0)>-1){Wa=B;break}else{Xa=0;Ya=C;Za=E;Z=144}}else if((Z|0)==143)if(!B){Xa=P;Ya=X;Za=Y;Z=144}else{Ja=X;Ka=P;La=B;Ma=Y}if((Z|0)==144){Ja=Ya;Ka=Xa;La=-1;Ma=Za}if(!Ka)Wa=La;else{Ik(Ja);Ik(Ma);Wa=La}}else Wa=0;while(0);if(o|0)Yk(e);Pa=j;return Wa|0}function Fl(a){a=a|0;return ((a|0)==32|(a+-9|0)>>>0<5)&1|0}function Gl(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;c[a+104>>2]=b;d=c[a+8>>2]|0;e=c[a+4>>2]|0;f=d-e|0;c[a+108>>2]=f;if((b|0)!=0&(f|0)>(b|0))c[a+100>>2]=e+b;else c[a+100>>2]=d;return}function Hl(b){b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;e=b+104|0;f=c[e>>2]|0;if((f|0)!=0?(c[b+108>>2]|0)>=(f|0):0)g=4;else{f=Vk(b)|0;if((f|0)>=0){h=c[e>>2]|0;e=c[b+8>>2]|0;if(h){i=c[b+4>>2]|0;j=h-(c[b+108>>2]|0)|0;h=e;if((e-i|0)<(j|0)){k=h;g=9}else{c[b+100>>2]=i+(j+-1);l=h}}else{k=e;g=9}if((g|0)==9){c[b+100>>2]=e;l=k}k=b+4|0;if(!l)m=c[k>>2]|0;else{e=c[k>>2]|0;k=b+108|0;c[k>>2]=l+1-e+(c[k>>2]|0);m=e}e=m+-1|0;if((f|0)==(d[e>>0]|0|0))n=f;else{a[e>>0]=f;n=f}}else g=4}if((g|0)==4){c[b+100>>2]=0;n=-1}return n|0}function Il(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=Pa;Pa=Pa+16|0;e=d;c[e>>2]=c[a>>2];a=b;while(1){b=(c[e>>2]|0)+(4-1)&~(4-1);f=c[b>>2]|0;c[e>>2]=b+4;if(a>>>0>1)a=a+-1|0;else break}Pa=d;return f|0}function Jl(d,e,f,g){d=d|0;e=e|0;f=f|0;g=g|0;var h=0;a:do if(d|0)switch(e|0){case -2:{a[d>>0]=f;break a;break}case -1:{b[d>>1]=f;break a;break}case 0:{c[d>>2]=f;break a;break}case 1:{c[d>>2]=f;break a;break}case 3:{h=d;c[h>>2]=f;c[h+4>>2]=g;break a;break}default:break a}while(0);return}function Kl(b,e,f,g){b=b|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;h=Pa;Pa=Pa+16|0;i=h;j=(g|0)==0?16412:g;g=c[j>>2]|0;a:do if(!e)if(!g)k=0;else l=19;else{m=(b|0)==0?i:b;if(!f)k=-2;else{if(!g){n=a[e>>0]|0;if(n<<24>>24>-1){c[m>>2]=n&255;k=n<<24>>24!=0&1;break}n=(Yl()|0)+188|0;o=a[e>>0]|0;if(!(c[c[n>>2]>>2]|0)){c[m>>2]=o<<24>>24&57343;k=1;break}n=(o&255)+-194|0;if(n>>>0>50){l=19;break}o=c[2352+(n<<2)>>2]|0;n=f+-1|0;if(!n)p=o;else{q=e+1|0;r=o;s=n;l=11}}else{q=e;r=g;s=f;l=11}b:do if((l|0)==11){n=d[q>>0]|0;o=n>>>3;if((o+-16|o+(r>>26))>>>0>7){l=19;break a}o=n+-128|r<<6;n=s+-1|0;if((o|0)<0){t=q;u=o;v=n;while(1){t=t+1|0;if(!v){p=u;break b}w=a[t>>0]|0;if((w&-64)<<24>>24!=-128){l=19;break a}x=(w&255)+-128|u<<6;w=v+-1|0;if((x|0)>=0){y=w;z=x;break}else{u=x;v=w}}}else{y=n;z=o}c[j>>2]=0;c[m>>2]=z;k=f-y|0;break a}while(0);c[j>>2]=p;k=-2}}while(0);if((l|0)==19){c[j>>2]=0;j=Qk()|0;c[j>>2]=84;k=-1}Pa=h;return k|0}function Ll(a){a=a|0;var b=0;if(!a)b=1;else b=(c[a>>2]|0)==0&1;return b|0}function Ml(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,I=0,J=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0;a:do if(e>>>0>36){i=Qk()|0;c[i>>2]=22;j=0;k=0}else{i=b+4|0;l=b+100|0;do{m=c[i>>2]|0;if(m>>>0<(c[l>>2]|0)>>>0){c[i>>2]=m+1;n=d[m>>0]|0}else n=Hl(b)|0}while((Fl(n)|0)!=0);b:do switch(n|0){case 43:case 45:{m=((n|0)==45)<<31>>31;o=c[i>>2]|0;if(o>>>0<(c[l>>2]|0)>>>0){c[i>>2]=o+1;p=m;q=d[o>>0]|0;break b}else{p=m;q=Hl(b)|0;break b}break}default:{p=0;q=n}}while(0);m=(e|0)==0;do if((e|16|0)==16&(q|0)==48){o=c[i>>2]|0;if(o>>>0<(c[l>>2]|0)>>>0){c[i>>2]=o+1;r=d[o>>0]|0}else r=Hl(b)|0;if((r|32|0)!=120)if(m){s=r;t=8;u=47;break}else{v=r;w=e;u=32;break}o=c[i>>2]|0;if(o>>>0<(c[l>>2]|0)>>>0){c[i>>2]=o+1;x=d[o>>0]|0}else x=Hl(b)|0;if((d[5009+x>>0]|0)>15){o=(c[l>>2]|0)==0;if(!o)c[i>>2]=(c[i>>2]|0)+-1;if(!f){Gl(b,0);j=0;k=0;break a}if(o){j=0;k=0;break a}c[i>>2]=(c[i>>2]|0)+-1;j=0;k=0;break a}else{s=x;t=16;u=47}}else{o=m?10:e;if(o>>>0>(d[5009+q>>0]|0)>>>0){v=q;w=o;u=32}else{if(c[l>>2]|0)c[i>>2]=(c[i>>2]|0)+-1;Gl(b,0);o=Qk()|0;c[o>>2]=22;j=0;k=0;break a}}while(0);c:do if((u|0)==32)if((w|0)==10){m=v+-48|0;if(m>>>0<10){o=0;y=m;do{o=(o*10|0)+y|0;m=c[i>>2]|0;if(m>>>0<(c[l>>2]|0)>>>0){c[i>>2]=m+1;z=d[m>>0]|0}else z=Hl(b)|0;y=z+-48|0}while(y>>>0<10&o>>>0<429496729);if(y>>>0<10){m=z;A=o;B=0;C=y;while(1){D=Hn(A|0,B|0,10,0)|0;E=L()|0;F=((C|0)<0)<<31>>31;G=~F;if(E>>>0>G>>>0|(E|0)==(G|0)&D>>>0>~C>>>0){I=10;J=m;M=A;N=B;u=76;break c}A=In(D|0,E|0,C|0,F|0)|0;B=L()|0;F=c[i>>2]|0;if(F>>>0<(c[l>>2]|0)>>>0){c[i>>2]=F+1;O=d[F>>0]|0}else O=Hl(b)|0;C=O+-48|0;if(!(C>>>0<10&(B>>>0<429496729|(B|0)==429496729&A>>>0<2576980378)))break;else m=O}if(C>>>0>9){P=p;Q=B;R=A}else{I=10;J=O;M=A;N=B;u=76}}else{P=p;Q=0;R=o}}else{P=p;Q=0;R=0}}else{s=v;t=w;u=47}while(0);d:do if((u|0)==47){if(!(t+-1&t)){m=a[13512+((t*23|0)>>>5&7)>>0]|0;y=a[5009+s>>0]|0;F=y&255;if(t>>>0>F>>>0){E=0;D=F;do{E=D|E<<m;G=c[i>>2]|0;if(G>>>0<(c[l>>2]|0)>>>0){c[i>>2]=G+1;S=d[G>>0]|0}else S=Hl(b)|0;T=a[5009+S>>0]|0;D=T&255}while(E>>>0<134217728&t>>>0>D>>>0);U=S;V=D;W=0;X=E;Y=T}else{U=s;V=F;W=0;X=0;Y=y}o=On(-1,-1,m|0)|0;B=L()|0;if(t>>>0<=V>>>0|(B>>>0<W>>>0|(B|0)==(W|0)&o>>>0<X>>>0)){I=t;J=U;M=X;N=W;u=76;break}A=X;C=W;G=Y;while(1){Z=Pn(A|0,C|0,m|0)|0;_=L()|0;$=Z|G&255;Z=c[i>>2]|0;if(Z>>>0<(c[l>>2]|0)>>>0){c[i>>2]=Z+1;aa=d[Z>>0]|0}else aa=Hl(b)|0;G=a[5009+aa>>0]|0;if(t>>>0<=(G&255)>>>0|(_>>>0>B>>>0|(_|0)==(B|0)&$>>>0>o>>>0)){I=t;J=aa;M=$;N=_;u=76;break d}else{A=$;C=_}}}C=a[5009+s>>0]|0;A=C&255;if(t>>>0>A>>>0){o=0;B=A;do{o=B+(H(o,t)|0)|0;G=c[i>>2]|0;if(G>>>0<(c[l>>2]|0)>>>0){c[i>>2]=G+1;ba=d[G>>0]|0}else ba=Hl(b)|0;ca=a[5009+ba>>0]|0;B=ca&255}while(o>>>0<119304647&t>>>0>B>>>0);da=ba;ea=B;fa=ca;ga=o;ha=0}else{da=s;ea=A;fa=C;ga=0;ha=0}if(t>>>0>ea>>>0){G=Mn(-1,-1,t|0,0)|0;m=L()|0;y=da;F=ha;E=ga;D=fa;while(1){if(F>>>0>m>>>0|(F|0)==(m|0)&E>>>0>G>>>0){I=t;J=y;M=E;N=F;u=76;break d}_=Hn(E|0,F|0,t|0,0)|0;$=L()|0;Z=D&255;if($>>>0>4294967295|($|0)==-1&_>>>0>~Z>>>0){I=t;J=y;M=E;N=F;u=76;break d}ia=In(_|0,$|0,Z|0,0)|0;Z=L()|0;$=c[i>>2]|0;if($>>>0<(c[l>>2]|0)>>>0){c[i>>2]=$+1;ja=d[$>>0]|0}else ja=Hl(b)|0;D=a[5009+ja>>0]|0;if(t>>>0<=(D&255)>>>0){I=t;J=ja;M=ia;N=Z;u=76;break}else{y=ja;F=Z;E=ia}}}else{I=t;J=da;M=ga;N=ha;u=76}}while(0);if((u|0)==76)if(I>>>0>(d[5009+J>>0]|0)>>>0){do{E=c[i>>2]|0;if(E>>>0<(c[l>>2]|0)>>>0){c[i>>2]=E+1;ka=d[E>>0]|0}else ka=Hl(b)|0}while(I>>>0>(d[5009+ka>>0]|0)>>>0);E=Qk()|0;c[E>>2]=34;P=(g&1|0)==0&0==0?p:0;Q=h;R=g}else{P=p;Q=N;R=M}if(c[l>>2]|0)c[i>>2]=(c[i>>2]|0)+-1;if(!(Q>>>0<h>>>0|(Q|0)==(h|0)&R>>>0<g>>>0)){if(!((g&1|0)!=0|0!=0|(P|0)!=0)){E=Qk()|0;c[E>>2]=34;E=In(g|0,h|0,-1,-1)|0;j=L()|0;k=E;break}if(Q>>>0>h>>>0|(Q|0)==(h|0)&R>>>0>g>>>0){E=Qk()|0;c[E>>2]=34;j=h;k=g;break}}E=((P|0)<0)<<31>>31;F=Jn(R^P|0,Q^E|0,P|0,E|0)|0;j=L()|0;k=F}while(0);K(j|0);return k|0}function Nl(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0.0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;switch(e|0){case 0:{g=-149;h=24;i=4;break}case 1:{g=-1074;h=53;i=4;break}case 2:{g=-1074;h=53;i=4;break}default:j=0.0}a:do if((i|0)==4){e=b+4|0;k=b+100|0;do{l=c[e>>2]|0;if(l>>>0<(c[k>>2]|0)>>>0){c[e>>2]=l+1;m=d[l>>0]|0}else m=Hl(b)|0}while((Fl(m)|0)!=0);b:do switch(m|0){case 43:case 45:{l=1-(((m|0)==45&1)<<1)|0;n=c[e>>2]|0;if(n>>>0<(c[k>>2]|0)>>>0){c[e>>2]=n+1;o=d[n>>0]|0;p=l;break b}else{o=Hl(b)|0;p=l;break b}break}default:{o=m;p=1}}while(0);l=0;n=o;while(1){if((n|32|0)!=(a[13499+l>>0]|0)){q=n;t=l;break}do if(l>>>0<7){u=c[e>>2]|0;if(u>>>0<(c[k>>2]|0)>>>0){c[e>>2]=u+1;v=d[u>>0]|0;break}else{v=Hl(b)|0;break}}else v=n;while(0);l=l+1|0;if(l>>>0>=8){q=v;t=8;break}else n=v}c:do switch(t&2147483647|0){case 8:break;case 3:{i=23;break}default:{n=(f|0)!=0;if(n&t>>>0>3)if((t|0)==8)break c;else{i=23;break c}d:do if(!t){l=0;u=q;while(1){if((u|32|0)!=(a[13508+l>>0]|0)){w=l;x=u;break d}do if(l>>>0<2){y=c[e>>2]|0;if(y>>>0<(c[k>>2]|0)>>>0){c[e>>2]=y+1;z=d[y>>0]|0;break}else{z=Hl(b)|0;break}}else z=u;while(0);l=l+1|0;if(l>>>0>=3){w=3;x=z;break}else u=z}}else{w=t;x=q}while(0);switch(w|0){case 3:{u=c[e>>2]|0;if(u>>>0<(c[k>>2]|0)>>>0){c[e>>2]=u+1;A=d[u>>0]|0}else A=Hl(b)|0;if((A|0)!=40){if(!(c[k>>2]|0)){j=r;break a}c[e>>2]=(c[e>>2]|0)+-1;j=r;break a}u=1;while(1){l=c[e>>2]|0;if(l>>>0<(c[k>>2]|0)>>>0){c[e>>2]=l+1;B=d[l>>0]|0}else B=Hl(b)|0;if(!((B+-48|0)>>>0<10|(B+-65|0)>>>0<26)?!((B|0)==95|(B+-97|0)>>>0<26):0)break;u=u+1|0}if((B|0)==41){j=r;break a}l=(c[k>>2]|0)==0;if(!l)c[e>>2]=(c[e>>2]|0)+-1;if(!n){y=Qk()|0;c[y>>2]=22;Gl(b,0);j=0.0;break a}if(!u){j=r;break a}y=u;while(1){y=y+-1|0;if(!l)c[e>>2]=(c[e>>2]|0)+-1;if(!y){j=r;break a}}break}case 0:{if((x|0)==48){y=c[e>>2]|0;if(y>>>0<(c[k>>2]|0)>>>0){c[e>>2]=y+1;C=d[y>>0]|0}else C=Hl(b)|0;if((C|32|0)==120){j=+Ol(b,h,g,p,f);break a}if(!(c[k>>2]|0))D=48;else{c[e>>2]=(c[e>>2]|0)+-1;D=48}}else D=x;j=+Pl(b,D,h,g,p,f);break a;break}default:{if(c[k>>2]|0)c[e>>2]=(c[e>>2]|0)+-1;y=Qk()|0;c[y>>2]=22;Gl(b,0);j=0.0;break a}}}}while(0);if((i|0)==23){y=(c[k>>2]|0)==0;if(!y)c[e>>2]=(c[e>>2]|0)+-1;if((f|0)!=0&t>>>0>3){l=t;do{if(!y)c[e>>2]=(c[e>>2]|0)+-1;l=l+-1|0}while(l>>>0>3)}}j=+(p|0)*s}while(0);return +j}function Ol(a,b,e,f,g){a=a|0;b=b|0;e=e|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0.0,x=0.0,y=0,z=0,A=0,B=0.0,C=0.0,D=0,E=0,F=0,G=0,H=0,I=0,J=0.0,K=0,M=0.0,N=0.0,O=0,P=0,Q=0.0,R=0,S=0,T=0,U=0.0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0.0,aa=0,ba=0.0;h=a+4|0;i=c[h>>2]|0;j=a+100|0;if(i>>>0<(c[j>>2]|0)>>>0){c[h>>2]=i+1;k=d[i>>0]|0}else k=Hl(a)|0;i=k;k=0;a:while(1){switch(i|0){case 46:{l=10;break a;break}case 48:break;default:{m=0;n=i;o=k;p=0;q=0;break a}}r=c[h>>2]|0;if(r>>>0<(c[j>>2]|0)>>>0){c[h>>2]=r+1;s=d[r>>0]|0}else s=Hl(a)|0;i=s;k=1}if((l|0)==10){s=c[h>>2]|0;if(s>>>0<(c[j>>2]|0)>>>0){c[h>>2]=s+1;t=d[s>>0]|0}else t=Hl(a)|0;if((t|0)==48){s=0;i=0;while(1){r=c[h>>2]|0;if(r>>>0<(c[j>>2]|0)>>>0){c[h>>2]=r+1;u=d[r>>0]|0}else u=Hl(a)|0;r=In(s|0,i|0,-1,-1)|0;v=L()|0;if((u|0)==48){s=r;i=v}else{m=1;n=u;o=1;p=r;q=v;break}}}else{m=1;n=t;o=k;p=0;q=0}}k=0;w=1.0;x=0.0;t=0;u=m;m=n;n=o;o=0;i=0;s=p;p=q;while(1){q=m+-48|0;v=m|32;if(q>>>0>=10){r=(m|0)==46;if(!(r|(v+-97|0)>>>0<6)){y=m;break}if(r)if(!u){z=1;A=k;B=w;C=x;D=t;E=n;F=i;G=o;H=i;I=o}else{y=46;break}else l=24}else l=24;if((l|0)==24){l=0;r=(m|0)>57?v+-87|0:q;do if(!((o|0)<0|(o|0)==0&i>>>0<8))if((o|0)<0|(o|0)==0&i>>>0<14){J=w*.0625;K=k;M=J;N=x+J*+(r|0);O=t;break}else{q=(k|0)!=0|(r|0)==0;K=q?k:1;M=w;N=q?x:x+w*.5;O=t;break}else{K=k;M=w;N=x;O=r+(t<<4)|0}while(0);r=In(i|0,o|0,1,0)|0;z=u;A=K;B=M;C=N;D=O;E=1;F=s;G=p;H=r;I=L()|0}r=c[h>>2]|0;if(r>>>0<(c[j>>2]|0)>>>0){c[h>>2]=r+1;P=d[r>>0]|0}else P=Hl(a)|0;k=A;w=B;x=C;t=D;u=z;m=P;n=E;o=I;i=H;s=F;p=G}do if(!n){G=(c[j>>2]|0)==0;if(!G)c[h>>2]=(c[h>>2]|0)+-1;if(g){if(!G?(c[h>>2]=(c[h>>2]|0)+-1,!((u|0)==0|G)):0)c[h>>2]=(c[h>>2]|0)+-1}else Gl(a,0);Q=+(f|0)*0.0}else{G=(u|0)==0;F=G?i:s;H=G?o:p;if((o|0)<0|(o|0)==0&i>>>0<8){G=t;I=i;E=o;while(1){P=G<<4;m=I;I=In(I|0,E|0,1,0)|0;z=E;E=L()|0;if(!((z|0)<0|(z|0)==0&m>>>0<7)){R=P;break}else G=P}}else R=t;if((y|32|0)==112){G=Ql(a,g)|0;E=L()|0;if((G|0)==0&(E|0)==-2147483648){if(!g){Gl(a,0);Q=0.0;break}if(!(c[j>>2]|0)){S=0;T=0}else{c[h>>2]=(c[h>>2]|0)+-1;S=0;T=0}}else{S=G;T=E}}else if(!(c[j>>2]|0)){S=0;T=0}else{c[h>>2]=(c[h>>2]|0)+-1;S=0;T=0}E=Pn(F|0,H|0,2)|0;G=In(E|0,L()|0,-32,-1)|0;E=In(G|0,L()|0,S|0,T|0)|0;G=L()|0;if(!R){Q=+(f|0)*0.0;break}I=0-e|0;P=((I|0)<0)<<31>>31;if((G|0)>(P|0)|(G|0)==(P|0)&E>>>0>I>>>0){I=Qk()|0;c[I>>2]=34;Q=+(f|0)*1797693134862315708145274.0e284*1797693134862315708145274.0e284;break}I=e+-106|0;P=((I|0)<0)<<31>>31;if((G|0)<(P|0)|(G|0)==(P|0)&E>>>0<I>>>0){I=Qk()|0;c[I>>2]=34;Q=+(f|0)*2.2250738585072014e-308*2.2250738585072014e-308;break}if((R|0)>-1){C=x;I=R;P=E;m=G;while(1){z=!(C>=.5);D=I<<1|(z^1)&1;B=C+(z?C:C+-1.0);z=In(P|0,m|0,-1,-1)|0;A=L()|0;if((D|0)>-1){C=B;I=D;P=z;m=A}else{U=B;V=D;W=z;X=A;break}}}else{U=x;V=R;W=E;X=G}m=((b|0)<0)<<31>>31;P=Jn(32,0,e|0,((e|0)<0)<<31>>31|0)|0;I=In(P|0,L()|0,W|0,X|0)|0;P=L()|0;if((P|0)<(m|0)|(P|0)==(m|0)&I>>>0<b>>>0)if((I|0)>0){Y=I;l=65}else{Z=0;_=84;l=67}else{Y=b;l=65}if((l|0)==65)if((Y|0)<53){Z=Y;_=84-Y|0;l=67}else{$=0.0;aa=Y;ba=+(f|0)}if((l|0)==67){C=+(f|0);$=+Sl(+Rl(1.0,_),C);aa=Z;ba=C}I=(V&1|0)==0&(U!=0.0&(aa|0)<32);C=(I?0.0:U)*ba+($+ba*+((V+(I&1)|0)>>>0))-$;if(!(C!=0.0)){I=Qk()|0;c[I>>2]=34}Q=+Ul(C,W)}while(0);return +Q}function Pl(a,b,e,f,g,h){a=a|0;b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,I=0,J=0,K=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0.0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,La=0,Ma=0,Na=0,Oa=0,Qa=0,Ra=0,Sa=0,Ta=0,Ua=0,Va=0,Wa=0,Xa=0,Ya=0,Za=0,_a=0,$a=0,ab=0,bb=0,cb=0,db=0,eb=0.0,fb=0,gb=0.0,hb=0.0,ib=0.0,jb=0.0,kb=0.0,lb=0.0,mb=0.0,nb=0.0,ob=0.0,pb=0.0,qb=0;i=Pa;Pa=Pa+512|0;j=i;k=f+e|0;l=0-k|0;m=a+4|0;n=a+100|0;o=b;b=0;a:while(1){switch(o|0){case 46:{p=7;break a;break}case 48:break;default:{q=0;r=o;s=b;t=0;v=0;break a}}w=c[m>>2]|0;if(w>>>0<(c[n>>2]|0)>>>0){c[m>>2]=w+1;x=d[w>>0]|0}else x=Hl(a)|0;o=x;b=1}if((p|0)==7){x=c[m>>2]|0;if(x>>>0<(c[n>>2]|0)>>>0){c[m>>2]=x+1;y=d[x>>0]|0}else y=Hl(a)|0;if((y|0)==48){x=0;o=0;while(1){w=In(x|0,o|0,-1,-1)|0;z=L()|0;A=c[m>>2]|0;if(A>>>0<(c[n>>2]|0)>>>0){c[m>>2]=A+1;B=d[A>>0]|0}else B=Hl(a)|0;if((B|0)==48){x=w;o=z}else{q=1;r=B;s=1;t=w;v=z;break}}}else{q=1;r=y;s=b;t=0;v=0}}c[j>>2]=0;b=r+-48|0;y=(r|0)==46;b:do if(y|b>>>0<10){B=j+496|0;o=0;x=0;z=0;w=q;A=s;C=r;D=y;E=b;F=t;G=v;I=0;J=0;c:while(1){do if(D)if(!w){K=o;M=x;N=1;O=z;P=A;Q=I;R=J;S=I;T=J}else break c;else{U=In(I|0,J|0,1,0)|0;V=L()|0;W=(C|0)!=48;if((x|0)>=125){if(!W){K=o;M=x;N=w;O=z;P=A;Q=F;R=G;S=U;T=V;break}c[B>>2]=c[B>>2]|1;K=o;M=x;N=w;O=z;P=A;Q=F;R=G;S=U;T=V;break}X=j+(x<<2)|0;if(!o)Y=E;else Y=C+-48+((c[X>>2]|0)*10|0)|0;c[X>>2]=Y;X=o+1|0;Z=(X|0)==9;K=Z?0:X;M=x+(Z&1)|0;N=w;O=W?U:z;P=1;Q=F;R=G;S=U;T=V}while(0);V=c[m>>2]|0;if(V>>>0<(c[n>>2]|0)>>>0){c[m>>2]=V+1;_=d[V>>0]|0}else _=Hl(a)|0;E=_+-48|0;D=(_|0)==46;if(!(D|E>>>0<10)){$=K;aa=M;ba=O;ca=N;da=_;ea=P;fa=Q;ga=S;ha=R;ia=T;p=31;break b}else{o=K;x=M;z=O;w=N;A=P;C=_;F=Q;G=R;I=S;J=T}}ja=o;ka=x;la=z;ma=I;na=J;oa=F;pa=G;qa=(A|0)!=0;p=39}else{$=0;aa=0;ba=0;ca=q;da=r;ea=s;fa=t;ga=0;ha=v;ia=0;p=31}while(0);do if((p|0)==31){v=(ca|0)==0;t=v?ga:fa;s=v?ia:ha;v=(ea|0)!=0;if(!(v&(da|32|0)==101))if((da|0)>-1){ja=$;ka=aa;la=ba;ma=ga;na=ia;oa=t;pa=s;qa=v;p=39;break}else{ra=$;sa=aa;ta=ba;ua=ga;va=ia;wa=v;xa=t;ya=s;p=41;break}v=Ql(a,h)|0;r=L()|0;if((v|0)==0&(r|0)==-2147483648){if(!h){Gl(a,0);za=0.0;break}if(!(c[n>>2]|0)){Aa=0;Ba=0}else{c[m>>2]=(c[m>>2]|0)+-1;Aa=0;Ba=0}}else{Aa=v;Ba=r}r=In(Aa|0,Ba|0,t|0,s|0)|0;Ca=$;Da=aa;Ea=ba;Fa=r;Ga=ga;Ha=L()|0;Ia=ia;p=43}while(0);if((p|0)==39)if(c[n>>2]|0){c[m>>2]=(c[m>>2]|0)+-1;if(qa){Ca=ja;Da=ka;Ea=la;Fa=oa;Ga=ma;Ha=pa;Ia=na;p=43}else p=42}else{ra=ja;sa=ka;ta=la;ua=ma;va=na;wa=qa;xa=oa;ya=pa;p=41}if((p|0)==41)if(wa){Ca=ra;Da=sa;Ea=ta;Fa=xa;Ga=ua;Ha=ya;Ia=va;p=43}else p=42;do if((p|0)==42){va=Qk()|0;c[va>>2]=22;Gl(a,0);za=0.0}else if((p|0)==43){va=c[j>>2]|0;if(!va){za=+(g|0)*0.0;break}if(((Ia|0)<0|(Ia|0)==0&Ga>>>0<10)&((Fa|0)==(Ga|0)&(Ha|0)==(Ia|0))?(e|0)>30|(va>>>e|0)==0:0){za=+(g|0)*+(va>>>0);break}va=(f|0)/-2|0;ya=((va|0)<0)<<31>>31;if((Ha|0)>(ya|0)|(Ha|0)==(ya|0)&Fa>>>0>va>>>0){va=Qk()|0;c[va>>2]=34;za=+(g|0)*1797693134862315708145274.0e284*1797693134862315708145274.0e284;break}va=f+-106|0;ya=((va|0)<0)<<31>>31;if((Ha|0)<(ya|0)|(Ha|0)==(ya|0)&Fa>>>0<va>>>0){va=Qk()|0;c[va>>2]=34;za=+(g|0)*2.2250738585072014e-308*2.2250738585072014e-308;break}if(!Ca)Ja=Da;else{if((Ca|0)<9){va=j+(Da<<2)|0;ya=Ca;ua=c[va>>2]|0;while(1){ua=ua*10|0;if((ya|0)>=8)break;else ya=ya+1|0}c[va>>2]=ua}Ja=Da+1|0}if((Ea|0)<9?(Ea|0)<=(Fa|0)&(Fa|0)<18:0){if((Fa|0)==9){za=+(g|0)*+((c[j>>2]|0)>>>0);break}if((Fa|0)<9){za=+(g|0)*+((c[j>>2]|0)>>>0)/+(c[4976+(8-Fa<<2)>>2]|0);break}ya=e+27+(H(Fa,-3)|0)|0;A=c[j>>2]|0;if((ya|0)>30|(A>>>ya|0)==0){za=+(g|0)*+(A>>>0)*+(c[4976+(Fa+-10<<2)>>2]|0);break}}A=(Fa|0)%9|0;if(!A){Ka=Ja;La=0;Ma=Fa}else{ya=(Fa|0)>-1?A:A+9|0;A=c[4976+(8-ya<<2)>>2]|0;if(Ja){G=1e9/(A|0)|0;F=0;J=0;I=Fa;z=0;do{x=j+(z<<2)|0;o=c[x>>2]|0;xa=(o>>>0)/(A>>>0)|0;ta=o-(H(xa,A)|0)|0;o=xa+F|0;c[x>>2]=o;F=H(G,ta)|0;ta=(z|0)==(J|0)&(o|0)==0;I=ta?I+-9|0:I;J=ta?J+1&127:J;z=z+1|0}while((z|0)!=(Ja|0));if(!F){Na=J;Oa=Ja;Qa=I}else{c[j+(Ja<<2)>>2]=F;Na=J;Oa=Ja+1|0;Qa=I}}else{Na=0;Oa=0;Qa=Fa}Ka=Oa;La=Na;Ma=9-ya+Qa|0}z=0;G=Ka;A=La;ua=Ma;d:while(1){va=(ua|0)<18;ta=(ua|0)==18;o=j+(A<<2)|0;Ra=z;Sa=G;while(1){if(!va){if(!ta){Ta=ua;break d}if((c[o>>2]|0)>>>0>=9007199){Ta=18;break d}}x=0;Ua=Sa;xa=Sa+127|0;while(1){sa=xa&127;ra=j+(sa<<2)|0;wa=Pn(c[ra>>2]|0,0,29)|0;pa=In(wa|0,L()|0,x|0,0)|0;wa=L()|0;if(wa>>>0>0|(wa|0)==0&pa>>>0>1e9){oa=Mn(pa|0,wa|0,1e9,0)|0;qa=Hn(oa|0,L()|0,1e9,0)|0;na=Jn(pa|0,wa|0,qa|0,L()|0)|0;L()|0;Va=oa;Wa=na}else{Va=0;Wa=pa}c[ra>>2]=Wa;ra=(sa|0)==(A|0);Xa=(sa|0)!=(Ua+127&127|0)|ra?Ua:(Wa|0)==0?sa:Ua;if(ra)break;else{x=Va;Ua=Xa;xa=sa+-1|0}}Ya=Ra+-29|0;if(!Va){Ra=Ya;Sa=Ua}else break}o=A+127&127;ta=Xa+127&127;va=j+((Xa+126&127)<<2)|0;if((o|0)==(Xa|0)){c[va>>2]=c[va>>2]|c[j+(ta<<2)>>2];Za=ta}else Za=Ua;c[j+(o<<2)>>2]=Va;z=Ya;G=Za;A=o;ua=ua+9|0}ua=Ra;G=A;z=Ta;ya=Sa;e:while(1){I=ya+1&127;J=j+((ya+127&127)<<2)|0;F=ua;o=G;ta=z;while(1){va=(ta|0)==18;xa=(ta|0)>27?9:1;_a=F;$a=o;while(1){x=0;while(1){sa=x+$a&127;if((sa|0)==(ya|0)){p=92;break}ra=c[j+(sa<<2)>>2]|0;sa=c[6256+(x<<2)>>2]|0;if(ra>>>0<sa>>>0){p=92;break}if(ra>>>0>sa>>>0)break;if((x+1|0)>>>0<2)x=1;else{p=92;break}}if((p|0)==92?(p=0,va):0)break e;ab=xa+_a|0;if(($a|0)==(ya|0)){_a=ab;$a=ya}else break}va=(1<<xa)+-1|0;x=1e9>>>xa;bb=0;cb=$a;db=ta;sa=$a;do{ra=j+(sa<<2)|0;pa=c[ra>>2]|0;na=(pa>>>xa)+bb|0;c[ra>>2]=na;bb=H(pa&va,x)|0;pa=(sa|0)==(cb|0)&(na|0)==0;db=pa?db+-9|0:db;cb=pa?cb+1&127:cb;sa=sa+1&127}while((sa|0)!=(ya|0));if(bb|0){if((I|0)!=(cb|0))break;c[J>>2]=c[J>>2]|1}F=ab;o=cb;ta=db}c[j+(ya<<2)>>2]=bb;ua=ab;G=cb;z=db;ya=I}eb=0.0;z=ya;G=0;while(1){ua=G+$a&127;A=z+1&127;if((ua|0)==(z|0)){c[j+(A+-1<<2)>>2]=0;fb=A}else fb=z;eb=eb*1.0e9+ +((c[j+(ua<<2)>>2]|0)>>>0);G=G+1|0;if((G|0)==2)break;else z=fb}gb=+(g|0);hb=eb*gb;z=_a+53|0;G=z-f|0;ya=(G|0)<(e|0);ua=ya?((G|0)>0?G:0):e;if((ua|0)<53){ib=+Sl(+Rl(1.0,105-ua|0),hb);jb=+Tl(hb,+Rl(1.0,53-ua|0));kb=ib;lb=jb;mb=ib+(hb-jb)}else{kb=0.0;lb=0.0;mb=hb}A=$a+2&127;if((A|0)!=(fb|0)){ta=c[j+(A<<2)>>2]|0;do if(ta>>>0>=5e8){if((ta|0)!=5e8){nb=gb*.75+lb;break}if(($a+3&127|0)==(fb|0)){nb=gb*.5+lb;break}else{nb=gb*.75+lb;break}}else{if((ta|0)==0?($a+3&127|0)==(fb|0):0){nb=lb;break}nb=gb*.25+lb}while(0);if((53-ua|0)>1?!(+Tl(nb,1.0)!=0.0):0)ob=nb+1.0;else ob=nb}else ob=lb;gb=mb+ob-kb;do if((z&2147483647|0)>(-2-k|0)){ta=!(+u(+gb)>=9007199254740992.0);A=_a+((ta^1)&1)|0;eb=ta?gb:gb*.5;if((A+50|0)<=(l|0)?!(ob!=0.0&(ya&((ua|0)!=(G|0)|ta))):0){pb=eb;qb=A;break}ta=Qk()|0;c[ta>>2]=34;pb=eb;qb=A}else{pb=gb;qb=_a}while(0);za=+Ul(pb,qb)}while(0);Pa=i;return +za}function Ql(a,b){a=a|0;b=b|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;e=a+4|0;f=c[e>>2]|0;g=a+100|0;if(f>>>0<(c[g>>2]|0)>>>0){c[e>>2]=f+1;h=d[f>>0]|0}else h=Hl(a)|0;switch(h|0){case 43:case 45:{f=(h|0)==45&1;i=c[e>>2]|0;if(i>>>0<(c[g>>2]|0)>>>0){c[e>>2]=i+1;j=d[i>>0]|0}else j=Hl(a)|0;i=j+-48|0;if((b|0)!=0&i>>>0>9)if(!(c[g>>2]|0)){k=0;l=-2147483648}else{c[e>>2]=(c[e>>2]|0)+-1;m=14}else{n=f;o=j;p=i;m=12}break}default:{n=0;o=h;p=h+-48|0;m=12}}if((m|0)==12)if(p>>>0>9)m=14;else{p=0;h=o;while(1){p=h+-48+(p*10|0)|0;o=c[e>>2]|0;if(o>>>0<(c[g>>2]|0)>>>0){c[e>>2]=o+1;q=d[o>>0]|0}else q=Hl(a)|0;r=q+-48|0;if(!(r>>>0<10&(p|0)<214748364))break;else h=q}h=((p|0)<0)<<31>>31;if(r>>>0<10){r=q;q=p;o=h;while(1){i=Hn(q|0,o|0,10,0)|0;j=L()|0;f=In(r|0,((r|0)<0)<<31>>31|0,-48,-1)|0;q=In(f|0,L()|0,i|0,j|0)|0;o=L()|0;j=c[e>>2]|0;if(j>>>0<(c[g>>2]|0)>>>0){c[e>>2]=j+1;s=d[j>>0]|0}else s=Hl(a)|0;t=s+-48|0;if(!(t>>>0<10&((o|0)<21474836|(o|0)==21474836&q>>>0<2061584302)))break;else r=s}if(t>>>0<10){do{t=c[e>>2]|0;if(t>>>0<(c[g>>2]|0)>>>0){c[e>>2]=t+1;u=d[t>>0]|0}else u=Hl(a)|0}while((u+-48|0)>>>0<10);v=q;w=o}else{v=q;w=o}}else{v=p;w=h}if(c[g>>2]|0)c[e>>2]=(c[e>>2]|0)+-1;h=(n|0)==0;n=Jn(0,0,v|0,w|0)|0;p=L()|0;k=h?v:n;l=h?w:p}if((m|0)==14)if(!(c[g>>2]|0)){k=0;l=-2147483648}else{c[e>>2]=(c[e>>2]|0)+-1;k=0;l=-2147483648}K(l|0);return k|0}function Rl(a,b){a=+a;b=b|0;var d=0.0,e=0,f=0,i=0.0,j=0;if((b|0)<=1023)if((b|0)<-1022){d=a*2.2250738585072014e-308;e=(b|0)<-2044;f=b+2044|0;i=e?d*2.2250738585072014e-308:d;j=e?((f|0)>-1022?f:-1022):b+1022|0}else{i=a;j=b}else{d=a*8988465674311579538646525.0e283;f=(b|0)>2046;e=b+-2046|0;i=f?d*8988465674311579538646525.0e283:d;j=f?((e|0)<1023?e:1023):b+-1023|0}b=Pn(j+1023|0,0,52)|0;j=L()|0;c[h>>2]=b;c[h+4>>2]=j;return +(i*+g[h>>3])}function Sl(a,b){a=+a;b=+b;return +(+Xl(a,b))}function Tl(a,b){a=+a;b=+b;return +(+Vl(a,b))}function Ul(a,b){a=+a;b=b|0;return +(+Rl(a,b))}function Vl(a,b){a=+a;b=+b;var d=0,e=0,f=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0.0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0.0;g[h>>3]=a;d=c[h>>2]|0;e=c[h+4>>2]|0;g[h>>3]=b;f=c[h>>2]|0;i=c[h+4>>2]|0;j=On(d|0,e|0,52)|0;L()|0;k=j&2047;j=On(f|0,i|0,52)|0;L()|0;l=j&2047;j=e&-2147483648;m=Pn(f|0,i|0,1)|0;n=L()|0;a:do if(!((m|0)==0&(n|0)==0)?(o=Wl(b)|0,p=(L()|0)&2147483647,!((k|0)==2047|(p>>>0>2146435072|(p|0)==2146435072&o>>>0>0))):0){o=Pn(d|0,e|0,1)|0;p=L()|0;if(!(p>>>0>n>>>0|(p|0)==(n|0)&o>>>0>m>>>0))return +((o|0)==(m|0)&(p|0)==(n|0)?a*0.0:a);if(!k){p=Pn(d|0,e|0,12)|0;o=L()|0;if((o|0)>-1|(o|0)==-1&p>>>0>4294967295){q=0;r=p;p=o;while(1){o=q+-1|0;r=Pn(r|0,p|0,1)|0;p=L()|0;if(!((p|0)>-1|(p|0)==-1&r>>>0>4294967295)){s=o;break}else q=o}}else s=0;q=Pn(d|0,e|0,1-s|0)|0;t=s;u=q;v=L()|0}else{t=k;u=d;v=e&1048575|1048576}if(!l){q=Pn(f|0,i|0,12)|0;r=L()|0;if((r|0)>-1|(r|0)==-1&q>>>0>4294967295){p=0;o=q;q=r;while(1){r=p+-1|0;o=Pn(o|0,q|0,1)|0;q=L()|0;if(!((q|0)>-1|(q|0)==-1&o>>>0>4294967295)){w=r;break}else p=r}}else w=0;p=Pn(f|0,i|0,1-w|0)|0;x=w;y=p;z=L()|0}else{x=l;y=f;z=i&1048575|1048576}p=Jn(u|0,v|0,y|0,z|0)|0;o=L()|0;q=(o|0)>-1|(o|0)==-1&p>>>0>4294967295;b:do if((t|0)>(x|0)){r=t;A=o;B=q;C=u;D=v;E=p;while(1){if(B)if((E|0)==0&(A|0)==0)break;else{F=E;G=A}else{F=C;G=D}H=Pn(F|0,G|0,1)|0;I=L()|0;J=r+-1|0;K=Jn(H|0,I|0,y|0,z|0)|0;M=L()|0;N=(M|0)>-1|(M|0)==-1&K>>>0>4294967295;if((J|0)>(x|0)){r=J;A=M;B=N;C=H;D=I;E=K}else{O=J;P=N;Q=K;R=M;S=H;T=I;break b}}U=a*0.0;break a}else{O=t;P=q;Q=p;R=o;S=u;T=v}while(0);if(P)if((Q|0)==0&(R|0)==0){U=a*0.0;break}else{V=R;W=Q}else{V=T;W=S}if(V>>>0<1048576|(V|0)==1048576&W>>>0<0){o=O;p=W;q=V;while(1){E=Pn(p|0,q|0,1)|0;D=L()|0;C=o+-1|0;if(D>>>0<1048576|(D|0)==1048576&E>>>0<0){o=C;p=E;q=D}else{X=C;Y=E;Z=D;break}}}else{X=O;Y=W;Z=V}if((X|0)>0){q=In(Y|0,Z|0,0,-1048576)|0;p=L()|0;o=Pn(X|0,0,52)|0;_=p|(L()|0);$=q|o}else{o=On(Y|0,Z|0,1-X|0)|0;_=L()|0;$=o}c[h>>2]=$;c[h+4>>2]=_|j;U=+g[h>>3]}else aa=3;while(0);if((aa|0)==3){ba=a*b;U=ba/ba}return +U}function Wl(a){a=+a;var b=0;g[h>>3]=a;b=c[h>>2]|0;K(c[h+4>>2]|0);return b|0}function Xl(a,b){a=+a;b=+b;var d=0,e=0,f=0;g[h>>3]=a;d=c[h>>2]|0;e=c[h+4>>2]|0;g[h>>3]=b;f=c[h+4>>2]&-2147483648|e&2147483647;c[h>>2]=d;c[h+4>>2]=f;return +(+g[h>>3])}function Yl(){return _k()|0}function Zl(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;if((c[f+76>>2]|0)>-1)g=Uk(f)|0;else g=0;h=e+-1|0;if((e|0)<2){e=f+74|0;i=a[e>>0]|0;a[e>>0]=i+255|i;if(g|0)Yk(f);if(!h){a[b>>0]=0;j=b}else j=0}else{a:do if(h){i=f+4|0;e=f+8|0;k=h;l=b;while(1){m=c[i>>2]|0;n=m;o=(c[e>>2]|0)-n|0;p=Xk(m,10,o)|0;q=(p|0)==0;r=q?o:1-n+p|0;p=r>>>0<k>>>0?r:k;Un(l|0,m|0,p|0)|0;m=(c[i>>2]|0)+p|0;c[i>>2]=m;s=l+p|0;r=k-p|0;if(!(q&(r|0)!=0)){t=s;u=17;break a}if(m>>>0>=(c[e>>2]|0)>>>0){q=Vk(f)|0;if((q|0)<0)break;else v=q}else{c[i>>2]=m+1;v=d[m>>0]|0}m=s+1|0;a[s>>0]=v;k=r+-1|0;if((v&255|0)==10|(k|0)==0){t=m;u=17;break a}else l=m}if((s|0)!=(b|0)?(c[f>>2]&16|0)!=0:0){t=s;u=17}else w=0}else{t=b;u=17}while(0);if((u|0)==17)if(!b)w=0;else{a[t>>0]=0;w=b}if(!g)j=w;else{Yk(f);j=w}}return j|0}function _l(b){b=b|0;var d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;d=b;a:do if(!(d&3)){e=b;f=5}else{g=b;h=d;while(1){if(!(a[g>>0]|0)){i=h;break a}j=g+1|0;h=j;if(!(h&3)){e=j;f=5;break}else g=j}}while(0);if((f|0)==5){f=e;while(1){k=c[f>>2]|0;if(!((k&-2139062144^-2139062144)&k+-16843009))f=f+4|0;else break}if(!((k&255)<<24>>24))l=f;else{k=f;while(1){f=k+1|0;if(!(a[f>>0]|0)){l=f;break}else k=f}}i=l}return i-d|0}function $l(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0;if((c[d+76>>2]|0)>=0?(Uk(d)|0)!=0:0){e=b&255;f=b&255;if((f|0)!=(a[d+75>>0]|0)?(g=d+20|0,h=c[g>>2]|0,h>>>0<(c[d+16>>2]|0)>>>0):0){c[g>>2]=h+1;a[h>>0]=e;i=f}else i=Dl(d,b)|0;Yk(d);j=i}else k=3;do if((k|0)==3){i=b&255;f=b&255;if((f|0)!=(a[d+75>>0]|0)?(e=d+20|0,h=c[e>>2]|0,h>>>0<(c[d+16>>2]|0)>>>0):0){c[e>>2]=h+1;a[h>>0]=i;j=f;break}j=Dl(d,b)|0}while(0);return j|0}function am(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;f=b+75|0;a[f>>0]=-1;switch(e|0){case 2:{c[b+48>>2]=0;break}case 1:{a[f>>0]=10;break}default:{}}c[b>>2]=c[b>>2]|64;return 0}function bm(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0;if((c[a+76>>2]|0)>-1)b=Uk(a)|0;else b=0;cm(a);d=(c[a>>2]&1|0)!=0;if(!d){e=dm()|0;f=c[a+52>>2]|0;g=a+56|0;if(f|0)c[f+56>>2]=c[g>>2];h=c[g>>2]|0;if(h|0)c[h+52>>2]=f;if((c[e>>2]|0)==(a|0))c[e>>2]=h;em()}h=fm(a)|0;e=Ta[c[a+12>>2]&511](a)|0|h;h=c[a+92>>2]|0;if(h|0)Ik(h);if(d){if(b|0)Yk(a)}else Ik(a);return e|0}function cm(a){a=a|0;var b=0,d=0,e=0;if(c[a+68>>2]|0){b=c[a+116>>2]|0;d=a+112|0;if(b|0)c[b+112>>2]=c[d>>2];a=c[d>>2]|0;if(!a)e=(hm()|0)+232|0;else e=a+116|0;c[e>>2]=b}return}function dm(){U(16416);return 16424}function em(){ja(16416);return}function fm(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;do if(a){if((c[a+76>>2]|0)<=-1){b=gm(a)|0;break}d=(Uk(a)|0)==0;e=gm(a)|0;if(d)b=e;else{Yk(a);b=e}}else{if(!(c[1400]|0))f=0;else f=fm(c[1400]|0)|0;e=dm()|0;d=c[e>>2]|0;if(!d)g=f;else{e=d;d=f;while(1){if((c[e+76>>2]|0)>-1)h=Uk(e)|0;else h=0;if((c[e+20>>2]|0)>>>0>(c[e+28>>2]|0)>>>0)i=gm(e)|0|d;else i=d;if(h|0)Yk(e);e=c[e+56>>2]|0;if(!e){g=i;break}else d=i}}em();b=g}while(0);return b|0}function gm(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0;b=a+20|0;d=a+28|0;if((c[b>>2]|0)>>>0>(c[d>>2]|0)>>>0?(Va[c[a+36>>2]&255](a,0,0)|0,(c[b>>2]|0)==0):0)e=-1;else{f=a+4|0;g=c[f>>2]|0;h=a+8|0;i=c[h>>2]|0;if(g>>>0<i>>>0)Va[c[a+40>>2]&255](a,g-i|0,1)|0;c[a+16>>2]=0;c[d>>2]=0;c[b>>2]=0;c[h>>2]=0;c[f>>2]=0;e=0}return e|0}function hm(){return _k()|0}function im(a){a=a|0;var b=0,d=0,e=0;if(!(c[a>>2]&128))b=1;else b=(c[a+20>>2]|0)>>>0>(c[a+28>>2]|0)>>>0?2:1;d=Va[c[a+40>>2]&255](a,0,b)|0;if((d|0)<0)e=d;else e=d-(c[a+8>>2]|0)+(c[a+4>>2]|0)+(c[a+20>>2]|0)-(c[a+28>>2]|0)|0;return e|0}function jm(a){a=a|0;var b=0,d=0,e=0;if((c[a+76>>2]|0)>-1){b=(Uk(a)|0)==0;d=im(a)|0;if(b)e=d;else e=d}else e=im(a)|0;return e|0}function km(a){a=a|0;return jm(a)|0}function lm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;if((d|0)==1)e=b-(c[a+8>>2]|0)+(c[a+4>>2]|0)|0;else e=b;b=a+20|0;f=a+28|0;if((c[b>>2]|0)>>>0>(c[f>>2]|0)>>>0?(Va[c[a+36>>2]&255](a,0,0)|0,(c[b>>2]|0)==0):0)g=-1;else{c[a+16>>2]=0;c[f>>2]=0;c[b>>2]=0;if((Va[c[a+40>>2]&255](a,e,d)|0)<0)g=-1;else{c[a+8>>2]=0;c[a+4>>2]=0;c[a>>2]=c[a>>2]&-17;g=0}}return g|0}function mm(a){a=a|0;var b=0,d=0,e=0;if((c[a+76>>2]|0)>-1){b=(Uk(a)|0)==0;d=(c[a>>2]|0)>>>5&1;if(b)e=d;else e=d}else e=(c[a>>2]|0)>>>5&1;return e|0}function nm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;if((c[a+76>>2]|0)>-1){e=(Uk(a)|0)==0;f=lm(a,b,d)|0;if(e)g=f;else{Yk(a);g=f}}else g=lm(a,b,d)|0;return g|0}function om(a,b,c){a=a|0;b=b|0;c=c|0;return nm(a,b,c)|0}function pm(b){b=b|0;var d=0,e=0,f=0,g=0;d=Pa;Pa=Pa+16|0;e=d;T(0,e|0)|0;f=0;g=(c[e+4>>2]|0)*65537^(e>>>4)+b;while(1){a[b+f>>0]=(g&15)+65|g<<1&32;f=f+1|0;if((f|0)==6)break;else g=g>>>5}Pa=d;return b|0}function qm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=Pa;Pa=Pa+48|0;f=e+32|0;g=e+16|0;h=e;if(rm(13521,a[d>>0]|0)|0){i=sm(d)|0;c[h>>2]=b;c[h+4>>2]=i|32768;c[h+8>>2]=438;b=Pk(ea(5,h|0)|0)|0;if((b|0)>=0){if(i&524288|0){c[g>>2]=b;c[g+4>>2]=2;c[g+8>>2]=1;aa(221,g|0)|0}g=tm(b,d)|0;if(!g){c[f>>2]=b;ga(6,f|0)|0;j=0}else j=g}else j=0}else{g=Qk()|0;c[g>>2]=22;j=0}Pa=e;return j|0}function rm(b,c){b=b|0;c=c|0;var d=0;d=vm(b,c)|0;return ((a[d>>0]|0)==(c&255)<<24>>24?d:0)|0}function sm(b){b=b|0;var c=0,d=0,e=0,f=0;c=(rm(b,43)|0)==0;d=a[b>>0]|0;e=c?d<<24>>24!=114&1:2;c=(rm(b,120)|0)==0;f=c?e:e|128;e=(rm(b,101)|0)==0;b=e?f:f|524288;f=d<<24>>24==114?b:b|64;b=d<<24>>24==119?f|512:f;return (d<<24>>24==97?b|1024:b)|0}function tm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=Pa;Pa=Pa+64|0;f=e+40|0;g=e+24|0;h=e+16|0;i=e;j=e+56|0;if(rm(13521,a[d>>0]|0)|0){k=Hk(1156)|0;if(!k)l=0;else{Vn(k|0,0,124)|0;if(!(rm(d,43)|0))c[k>>2]=(a[d>>0]|0)==114?8:4;if(rm(d,101)|0){c[i>>2]=b;c[i+4>>2]=2;c[i+8>>2]=1;aa(221,i|0)|0}if((a[d>>0]|0)==97){c[h>>2]=b;c[h+4>>2]=3;d=aa(221,h|0)|0;if(!(d&1024)){c[g>>2]=b;c[g+4>>2]=4;c[g+8>>2]=d|1024;aa(221,g|0)|0}g=c[k>>2]|128;c[k>>2]=g;m=g}else m=c[k>>2]|0;c[k+60>>2]=b;c[k+44>>2]=k+132;c[k+48>>2]=1024;g=k+75|0;a[g>>0]=-1;if((m&8|0)==0?(c[f>>2]=b,c[f+4>>2]=21523,c[f+8>>2]=j,(fa(54,f|0)|0)==0):0)a[g>>0]=10;c[k+32>>2]=131;c[k+36>>2]=132;c[k+40>>2]=130;c[k+12>>2]=271;if(!(c[4088]|0))c[k+76>>2]=-1;um(k)|0;l=k}}else{k=Qk()|0;c[k>>2]=22;l=0}Pa=e;return l|0}function um(a){a=a|0;var b=0,d=0;b=dm()|0;c[a+56>>2]=c[b>>2];d=c[b>>2]|0;if(d|0)c[d+52>>2]=a;c[b>>2]=a;em();return a|0}function vm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=d&255;a:do if(!e)f=b+(_l(b)|0)|0;else{if(!(b&3))g=b;else{h=d&255;i=b;while(1){j=a[i>>0]|0;if(j<<24>>24==0?1:j<<24>>24==h<<24>>24){f=i;break a}j=i+1|0;if(!(j&3)){g=j;break}else i=j}}i=H(e,16843009)|0;h=c[g>>2]|0;b:do if(!((h&-2139062144^-2139062144)&h+-16843009)){j=g;k=h;while(1){l=k^i;if((l&-2139062144^-2139062144)&l+-16843009|0){m=j;break b}l=j+4|0;k=c[l>>2]|0;if((k&-2139062144^-2139062144)&k+-16843009|0){m=l;break}else j=l}}else m=g;while(0);i=d&255;h=m;while(1){j=a[h>>0]|0;if(j<<24>>24==0?1:j<<24>>24==i<<24>>24){f=h;break}else h=h+1|0}}while(0);return f|0}function wm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;d=El(a,b,f)|0;Pa=e;return d|0}function xm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;e=Pa;Pa=Pa+32|0;f=e+16|0;g=e;h=sm(b)|0;if((c[d+76>>2]|0)>-1)i=Uk(d)|0;else i=0;fm(d)|0;do if(!a){j=d+60|0;if(h&524288|0){c[g>>2]=c[j>>2];c[g+4>>2]=2;c[g+8>>2]=1;aa(221,g|0)|0}c[f>>2]=c[j>>2];c[f+4>>2]=4;c[f+8>>2]=h&-524481;if((Pk(aa(221,f|0)|0)|0)<0)k=15;else k=12}else{j=qm(a,b)|0;if(!j)k=15;else{l=j+60|0;m=c[l>>2]|0;n=c[d+60>>2]|0;if((m|0)!=(n|0)){if((ym(m,n,h&524288)|0)<0){bm(j)|0;k=15;break}}else c[l>>2]=-1;c[d>>2]=c[d>>2]&1|c[j>>2];c[d+32>>2]=c[j+32>>2];c[d+36>>2]=c[j+36>>2];c[d+40>>2]=c[j+40>>2];c[d+12>>2]=c[j+12>>2];bm(j)|0;k=12}}while(0);if((k|0)==12)if(!i)o=d;else{Yk(d);o=d}else if((k|0)==15){bm(d)|0;o=0}Pa=e;return o|0}function ym(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=Pa;Pa=Pa+48|0;f=e+24|0;g=e+16|0;h=e;a:do if((a|0)!=(b|0)){i=(d&524288|0)!=0;b:do if(i)while(1){c[h>>2]=a;c[h+4>>2]=b;c[h+8>>2]=d;j=ba(330,h|0)|0;switch(j|0){case -38:{break b;break}case -16:break;default:{k=j;break a}}}while(0);do{c[g>>2]=a;c[g+4>>2]=b;l=ha(63,g|0)|0}while((l|0)==-16);if(i){c[f>>2]=b;c[f+4>>2]=2;c[f+8>>2]=1;aa(221,f|0)|0;k=l}else k=l}else k=-22;while(0);l=Pk(k)|0;Pa=e;return l|0}function zm(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;f=H(d,b)|0;g=(b|0)==0?0:d;if((c[e+76>>2]|0)>-1){d=(Uk(e)|0)==0;h=tl(a,f,e)|0;if(d)i=h;else{Yk(e);i=h}}else i=tl(a,f,e)|0;if((i|0)==(f|0))j=g;else j=(i>>>0)/(b>>>0)|0;return j|0}function Am(a){a=a|0;var b=0,e=0,f=0,g=0,h=0;if((c[a+76>>2]|0)>=0?(Uk(a)|0)!=0:0){b=a+4|0;e=c[b>>2]|0;if(e>>>0<(c[a+8>>2]|0)>>>0){c[b>>2]=e+1;f=d[e>>0]|0}else f=Vk(a)|0;g=f}else h=3;do if((h|0)==3){f=a+4|0;e=c[f>>2]|0;if(e>>>0<(c[a+8>>2]|0)>>>0){c[f>>2]=e+1;g=d[e>>0]|0;break}else{g=Vk(a)|0;break}}while(0);return g|0}function Bm(d){d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;e=Pa;Pa=Pa+112|0;f=e+24|0;g=e;h=e+32|0;c[g>>2]=c[1320];c[g+4>>2]=c[1321];c[g+8>>2]=c[1322];c[g+12>>2]=c[1323];b[g+16>>1]=b[2648]|0;a[g+18>>0]=a[5298]|0;i=g+12|0;j=g;k=h;l=0;while(1){pm(i)|0;m=h;n=m+76|0;do{c[m>>2]=0;m=m+4|0}while((m|0)<(n|0));c[f>>2]=j;c[f+4>>2]=k;l=l+1|0;if(($(196,f|0)|0)==-2){o=4;break}if(l>>>0>=100){p=0;break}}if((o|0)==4){o=(d|0)==0?15664:d;Cm(o,g)|0;p=o}Pa=e;return p|0}function Cm(a,b){a=a|0;b=b|0;Dm(a,b)|0;return a|0}function Dm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;e=d;a:do if(!((e^b)&3)){if(!(e&3)){f=d;g=b}else{h=d;i=b;while(1){j=a[h>>0]|0;a[i>>0]=j;if(!(j<<24>>24)){k=i;break a}j=h+1|0;l=i+1|0;if(!(j&3)){f=j;g=l;break}else{h=j;i=l}}}i=c[f>>2]|0;if(!((i&-2139062144^-2139062144)&i+-16843009)){h=g;l=f;j=i;while(1){i=l+4|0;m=h+4|0;c[h>>2]=j;j=c[i>>2]|0;if((j&-2139062144^-2139062144)&j+-16843009|0){n=i;o=m;break}else{h=m;l=i}}}else{n=f;o=g}p=n;q=o;r=10}else{p=d;q=b;r=10}while(0);if((r|0)==10){r=a[p>>0]|0;a[q>>0]=r;if(!(r<<24>>24))k=q;else{r=q;q=p;while(1){q=q+1|0;p=r+1|0;b=a[q>>0]|0;a[p>>0]=b;if(!(b<<24>>24)){k=p;break}else r=p}}}return k|0}function Em(a,b,c){a=a|0;b=b|0;c=c|0;return cl(a,2147483647,b,c)|0}function Fm(){var a=0,b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0;a=Pa;Pa=Pa+64|0;b=a+48|0;d=a+40|0;e=a+24|0;f=a;c[f>>2]=c[1328];c[f+4>>2]=c[1329];c[f+8>>2]=c[1330];c[f+12>>2]=c[1331];c[f+16>>2]=c[1332];g=f+13|0;h=f;f=0;while(1){pm(g)|0;c[e>>2]=h;c[e+4>>2]=32962;c[e+8>>2]=384;i=Pk(ea(5,e|0)|0)|0;f=f+1|0;if((i|0)>-1){j=4;break}if(f>>>0>=100){k=0;break}}if((j|0)==4){c[d>>2]=h;X(10,d|0)|0;d=tm(i,13525)|0;if(!d){c[b>>2]=i;ga(6,b|0)|0;k=0}else k=d}Pa=a;return k|0}function Gm(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=Pa;Pa=Pa+16|0;f=e;c[f>>2]=d;d=Em(a,b,f)|0;Pa=e;return d|0}function Hm(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=Pa;Pa=Pa+16|0;d=b+8|0;e=b;f=a;c[e>>2]=f;a=X(10,e|0)|0;if((a|0)==-21){c[d>>2]=f;g=da(40,d|0)|0}else g=a;a=Pk(g)|0;Pa=b;return a|0}function Im(a){a=a|0;var b=0,d=0,e=0;if((c[a+76>>2]|0)>-1){b=(Uk(a)|0)==0;d=(c[a>>2]|0)>>>4&1;if(b)e=d;else e=d}else e=(c[a>>2]|0)>>>4&1;return e|0}function Jm(a){a=a|0;var b=0;if((c[a+76>>2]|0)>-1){b=(Uk(a)|0)==0;c[a>>2]=c[a>>2]&-49;if(!b)Yk(a)}else c[a>>2]=c[a>>2]&-49;return}function Km(a,b){a=a|0;b=b|0;var d=0,e=0;d=Pa;Pa=Pa+16|0;e=d;c[e>>2]=a;c[e+4>>2]=b;b=Pk(ca(38,e|0)|0)|0;Pa=d;return b|0}\nfunction Lm(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;g=H(e,d)|0;h=(d|0)==0?0:e;if((c[f+76>>2]|0)>-1)i=Uk(f)|0;else i=0;e=f+74|0;j=a[e>>0]|0;a[e>>0]=j+255|j;j=f+4|0;e=c[j>>2]|0;k=(c[f+8>>2]|0)-e|0;if((k|0)>0){l=k>>>0<g>>>0?k:g;Un(b|0,e|0,l|0)|0;c[j>>2]=(c[j>>2]|0)+l;m=g-l|0;n=b+l|0}else{m=g;n=b}a:do if(!m)o=13;else{b=f+32|0;l=n;j=m;while(1){if(Zk(f)|0)break;e=Va[c[b>>2]&255](f,l,j)|0;if((e+1|0)>>>0<2)break;k=j-e|0;if(!k){o=13;break a}else{l=l+e|0;j=k}}if(i|0)Yk(f);p=((g-j|0)>>>0)/(d>>>0)|0}while(0);if((o|0)==13)if(!i)p=h;else{Yk(f);p=h}return p|0}function Mm(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;a:do if(!d)e=0;else{f=b;g=d;h=c;while(1){i=a[f>>0]|0;j=a[h>>0]|0;if(i<<24>>24!=j<<24>>24)break;g=g+-1|0;if(!g){e=0;break a}else{f=f+1|0;h=h+1|0}}e=(i&255)-(j&255)|0}while(0);return e|0}function Nm(a){a=a|0;var b=0;b=(Om(a)|0)==0;return (b?a:a|32)|0}function Om(a){a=a|0;return (a+-65|0)>>>0<26|0}function Pm(b,c){b=b|0;c=c|0;var d=0;d=b+(Qm(b,c)|0)|0;return ((a[d>>0]|0)==0?0:d)|0}function Qm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=Pa;Pa=Pa+32|0;f=e;g=a[d>>0]|0;a:do if(g<<24>>24!=0?(a[d+1>>0]|0)!=0:0){Vn(f|0,0,32)|0;h=a[d>>0]|0;if(h<<24>>24){i=d;j=h;do{h=j&255;k=f+(h>>>5<<2)|0;c[k>>2]=c[k>>2]|1<<(h&31);i=i+1|0;j=a[i>>0]|0}while(j<<24>>24!=0)}j=a[b>>0]|0;if(!(j<<24>>24))l=b;else{i=b;h=j;while(1){j=h&255;if(c[f+(j>>>5<<2)>>2]&1<<(j&31)|0){l=i;break a}j=i+1|0;h=a[j>>0]|0;if(!(h<<24>>24)){l=j;break}else i=j}}}else m=3;while(0);if((m|0)==3)l=vm(b,g<<24>>24)|0;Pa=e;return l-b|0}function Rm(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;e=Pa;Pa=Pa+32|0;f=e;c[f>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[f+12>>2]=0;c[f+16>>2]=0;c[f+20>>2]=0;c[f+24>>2]=0;c[f+28>>2]=0;g=a[d>>0]|0;do if(!(g<<24>>24))h=0;else{if(!(a[d+1>>0]|0)){i=b;while(1)if((a[i>>0]|0)==g<<24>>24)i=i+1|0;else break;h=i-b|0;break}j=d;k=g;do{l=k&255;m=f+(l>>>5<<2)|0;c[m>>2]=c[m>>2]|1<<(l&31);j=j+1|0;k=a[j>>0]|0}while(k<<24>>24!=0);k=a[b>>0]|0;a:do if(!(k<<24>>24))n=b;else{j=b;i=k;while(1){l=i&255;if(!(c[f+(l>>>5<<2)>>2]&1<<(l&31))){n=j;break a}l=j+1|0;i=a[l>>0]|0;if(!(i<<24>>24)){n=l;break}else j=l}}while(0);h=n-b|0}while(0);Pa=e;return h|0}function Sm(a,b){a=a|0;b=b|0;return Tm(a,b,(_l(a)|0)+1|0)|0}function Tm(b,c,d){b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0;a:do if(!d)e=0;else{f=c&255;g=d;while(1){g=g+-1|0;if((a[b+g>>0]|0)==f<<24>>24)break;if(!g){e=0;break a}}e=b+g|0}while(0);return e|0}function Um(b,c){b=b|0;c=c|0;var d=0,e=0,f=0;d=a[c>>0]|0;do if(d<<24>>24){e=rm(b,d<<24>>24)|0;if(e)if(a[c+1>>0]|0)if(a[e+1>>0]|0){if(!(a[c+2>>0]|0)){f=Vm(e,c)|0;break}if(a[e+2>>0]|0){if(!(a[c+3>>0]|0)){f=Wm(e,c)|0;break}if(a[e+3>>0]|0)if(!(a[c+4>>0]|0)){f=Xm(e,c)|0;break}else{f=Ym(e,c)|0;break}else f=0}else f=0}else f=0;else f=e;else f=0}else f=b;while(0);return f|0}function Vm(b,c){b=b|0;c=c|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0;e=(d[c>>0]|0)<<8|(d[c+1>>0]|0);c=b+1|0;f=a[c>>0]|0;a:do if(!(f<<24>>24))g=0;else{h=(d[b>>0]|0)<<8|f&255;i=c;while(1){j=h&65535;if((j|0)==(e|0))break;k=i+1|0;l=a[k>>0]|0;if(!(l<<24>>24)){g=0;break a}else{h=j<<8|l&255;i=k}}g=i+-1|0}while(0);return g|0}function Wm(b,c){b=b|0;c=c|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=(d[c+1>>0]|0)<<16|(d[c>>0]|0)<<24|(d[c+2>>0]|0)<<8;c=b+2|0;f=a[c>>0]|0;g=(d[b+1>>0]|0)<<16|(d[b>>0]|0)<<24|(f&255)<<8;b=f<<24>>24==0;if((g|0)==(e|0)|b){h=c;i=b}else{b=c;c=g;while(1){g=b+1|0;f=a[g>>0]|0;c=(c|f&255)<<8;j=f<<24>>24==0;if((c|0)==(e|0)|j){h=g;i=j;break}else b=g}}return (i?0:h+-2|0)|0}function Xm(b,c){b=b|0;c=c|0;var e=0,f=0,g=0,h=0,i=0,j=0;e=(d[c+1>>0]|0)<<16|(d[c>>0]|0)<<24|(d[c+2>>0]|0)<<8|(d[c+3>>0]|0);c=b+3|0;f=a[c>>0]|0;g=(d[b+1>>0]|0)<<16|(d[b>>0]|0)<<24|(d[b+2>>0]|0)<<8|f&255;b=f<<24>>24==0;if((g|0)==(e|0)|b){h=c;i=b}else{b=c;c=g;while(1){g=b+1|0;f=a[g>>0]|0;c=c<<8|f&255;j=f<<24>>24==0;if((c|0)==(e|0)|j){h=g;i=j;break}else b=g}}return (i?0:h+-3|0)|0}function Ym(b,e){b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0;f=Pa;Pa=Pa+1056|0;g=f+1024|0;h=f;c[g>>2]=0;c[g+4>>2]=0;c[g+8>>2]=0;c[g+12>>2]=0;c[g+16>>2]=0;c[g+20>>2]=0;c[g+24>>2]=0;c[g+28>>2]=0;i=a[e>>0]|0;a:do if(i<<24>>24){j=0;k=i;do{if(!(a[b+j>>0]|0)){l=0;break a}m=k&255;n=g+(m>>>5<<2)|0;c[n>>2]=c[n>>2]|1<<(m&31);j=j+1|0;c[h+(m<<2)>>2]=j;k=a[e+j>>0]|0}while(k<<24>>24!=0);k=j>>>0>1;if(k){m=1;n=1;o=0;p=-1;q=1;while(1){r=a[e+(n+p)>>0]|0;s=a[e+q>>0]|0;do if(r<<24>>24==s<<24>>24)if((n|0)==(m|0)){t=m;u=1;v=m+o|0;w=p;break}else{t=m;u=n+1|0;v=o;w=p;break}else if((r&255)>(s&255)){t=q-p|0;u=1;v=q;w=p;break}else{t=1;u=1;v=o+1|0;w=o;break}while(0);q=u+v|0;if(q>>>0>=j>>>0)break;else{m=t;n=u;o=v;p=w}}if(k){p=1;o=1;n=0;m=-1;q=1;while(1){s=a[e+(o+m)>>0]|0;r=a[e+q>>0]|0;do if(s<<24>>24==r<<24>>24)if((o|0)==(p|0)){x=p;y=1;z=p+n|0;A=m;break}else{x=p;y=o+1|0;z=n;A=m;break}else if((s&255)<(r&255)){x=q-m|0;y=1;z=q;A=m;break}else{x=1;y=1;z=n+1|0;A=n;break}while(0);q=y+z|0;if(q>>>0>=j>>>0){B=t;C=w;D=j;E=x;F=A;G=25;break}else{p=x;o=y;n=z;m=A}}}else{B=t;C=w;D=j;E=1;F=-1;G=25}}else{B=1;C=-1;D=j;E=1;F=-1;G=25}}else{B=1;C=-1;D=0;E=1;F=-1;G=25}while(0);b:do if((G|0)==25){w=(F+1|0)>>>0>(C+1|0)>>>0;t=w?E:B;A=w?F:C;w=A+1|0;if(!(Mm(e,e+t|0,w)|0)){z=D-t|0;H=z;I=t;J=z}else{z=D-A+-1|0;t=(A>>>0>z>>>0?A:z)+1|0;H=0;I=t;J=D-t|0}t=D|63;z=D+-1|0;y=(H|0)!=0;x=b;v=0;u=b;while(1){i=x;do if((u-i|0)>>>0<D>>>0){m=Xk(u,0,t)|0;if(m)if((m-i|0)>>>0<D>>>0){l=0;break b}else{K=m;break}else{K=u+t|0;break}}else K=u;while(0);i=d[x+z>>0]|0;c:do if(!(1<<(i&31)&c[g+(i>>>5<<2)>>2])){L=0;M=D}else{m=D-(c[h+(i<<2)>>2]|0)|0;if(m|0){L=0;M=y&(v|0)!=0&m>>>0<I>>>0?J:m;break}m=w>>>0>v>>>0;n=m?w:v;o=a[e+n>>0]|0;d:do if(o<<24>>24){p=n;q=o;while(1){if(q<<24>>24!=(a[x+p>>0]|0))break;k=p+1|0;q=a[e+k>>0]|0;if(!(q<<24>>24))break d;else p=k}L=0;M=p-A|0;break c}while(0);if(!m){l=x;break b}o=w;while(1){o=o+-1|0;if((a[e+o>>0]|0)!=(a[x+o>>0]|0)){L=H;M=I;break c}if(o>>>0<=v>>>0){l=x;break b}}}while(0);x=x+M|0;v=L;u=K}}while(0);Pa=f;return l|0}function Zm(){return}function _m(a,b){a=a|0;b=b|0;var d=0,e=0;d=Pa;Pa=Pa+16|0;e=d;c[e>>2]=a;c[e+4>>2]=b;b=Pk(ia(91,e|0)|0)|0;Pa=d;return b|0}function $m(a){a=a|0;var b=0;b=(an(a)|0)==0;return (b?a:a&95)|0}function an(a){a=a|0;return (a+-97|0)>>>0<26|0}function bn(a){a=a|0;return (a+-33|0)>>>0<94|0}function cn(a){a=a|0;var b=0;if(!(dn(a)|0))b=($k(a)|0)!=0&1;else b=1;return b|0}function dn(a){a=a|0;return ((a|32)+-97|0)>>>0<26|0}function en(a){a=a|0;return (a>>>0<32|(a|0)==127)&1|0}function fn(a){a=a|0;return (((a|32)+-97|0)>>>0<6|($k(a)|0)!=0)&1|0}function gn(a){a=a|0;var b=0;if(!(bn(a)|0))b=0;else b=(cn(a)|0)==0&1;return b|0}function hn(a){a=+a;var b=0,d=0.0,e=0,f=0.0,i=0.0,j=0.0;g[h>>3]=a;b=c[h+4>>2]|0;d=(b|0)<0?-.5:.5;e=b&2147483647;c[h>>2]=c[h>>2];c[h+4>>2]=e;f=+g[h>>3];do if(e>>>0<1082535490){i=+jn(f);if(e>>>0>=1072693248){j=d*(i+i/(i+1.0));break}if(e>>>0<1045430272)j=a;else j=d*(i*2.0-i*i/(i+1.0))}else j=d*2.0*+kn(f);while(0);return +j}function jn(a){a=+a;var b=0,d=0,e=0,f=0,i=0.0,j=0,k=0.0,l=0.0,m=0,n=0,o=0.0,p=0.0,q=0.0,r=0.0,s=0.0;g[h>>3]=a;b=c[h+4>>2]|0;d=b&2147483647;e=On(c[h>>2]|0,b|0,63)|0;L()|0;do if(d>>>0>1078159481){b=ln(a)|0;f=(L()|0)&2147483647;if(!(f>>>0>2146435072|(f|0)==2146435072&b>>>0>0))if(!e)if(a>709.782712893384)i=a*8988465674311579538646525.0e283;else j=11;else i=-1.0;else i=a}else{if(d>>>0<=1071001154)if(d>>>0<1016070144){i=a;break}else{k=a;l=0.0;m=0;j=14;break}if(d>>>0<1072734898)if(!e){n=1;o=a+-.6931471803691238;p=1.9082149292705877e-10;j=12;break}else{n=-1;o=a+.6931471803691238;p=-1.9082149292705877e-10;j=12;break}else j=11}while(0);if((j|0)==11){d=~~(a*1.4426950408889634+((e|0)==0?.5:-.5));q=+(d|0);n=d;o=a-q*.6931471803691238;p=q*1.9082149292705877e-10;j=12}if((j|0)==12){q=o-p;k=q;l=o-q-p;m=n;j=14}a:do if((j|0)==14){p=k*.5;q=k*p;o=q*(q*(q*(q*(4.008217827329362e-06-q*2.0109921818362437e-07)+-7.93650757867488e-05)+1.5873015872548146e-03)+-.03333333333333313)+1.0;a=3.0-p*o;p=q*((o-a)/(6.0-k*a));if(!m){i=k-(k*p-q);break}a=k*(p-l)-l-q;switch(m|0){case -1:{i=(k-a)*.5+-.5;break a;break}case 1:{if(k<-.25){i=(a-(k+.5))*-2.0;break a}else{i=(k-a)*2.0+1.0;break a}break}default:{n=Pn(m+1023|0,0,52)|0;d=L()|0;c[h>>2]=n;c[h+4>>2]=d;q=+g[h>>3];if(m>>>0>56){p=k-a+1.0;i=((m|0)==1024?p*2.0*8988465674311579538646525.0e283:p*q)+-1.0;break a}d=Pn(1023-m|0,0,52)|0;n=L()|0;if((m|0)<20){c[h>>2]=d;c[h+4>>2]=n;r=1.0-+g[h>>3];s=k-a}else{c[h>>2]=d;c[h+4>>2]=n;r=k-(a+ +g[h>>3]);s=1.0}i=(r+s)*q;break a}}}while(0);return +i}function kn(a){a=+a;return +(+E(+(a+-1416.0996898839683))*2247116418577894884661631.0e283*2247116418577894884661631.0e283)}function ln(a){a=+a;var b=0;g[h>>3]=a;b=c[h>>2]|0;K(c[h+4>>2]|0);return b|0}function mn(a){a=+a;var b=0,d=0.0,e=0.0;g[h>>3]=a;b=c[h+4>>2]&2147483647;c[h>>2]=c[h>>2];c[h+4>>2]=b;a=+g[h>>3];do if(b>>>0<1072049730)if(b>>>0<1045430272)d=1.0;else{e=+jn(a);d=e*e/((e+1.0)*2.0)+1.0}else if(b>>>0<1082535490){e=+E(+a);d=(e+1.0/e)*.5;break}else{d=+kn(a);break}while(0);return +d}function nn(a,b){a=+a;b=b|0;var d=0,e=0,f=0,i=0,j=0,k=0.0,l=0,m=0.0,n=0;g[h>>3]=a;d=c[h>>2]|0;e=c[h+4>>2]|0;f=On(d|0,e|0,52)|0;L()|0;i=f&2047;f=i+-1023|0;if(i>>>0>1074){g[b>>3]=a;c[h>>2]=0;c[h+4>>2]=e&-2147483648;return +((d|0)==0&(e&1048575|0)==0|(f|0)!=1024?+g[h>>3]:a)}do if(i>>>0>=1023){j=On(-1,1048575,f|0)|0;if((j&d|0)==0&((L()|0)&e|0)==0){g[b>>3]=a;c[h>>2]=0;c[h+4>>2]=e&-2147483648;k=+g[h>>3];break}else{j=Nn(0,-1048576,f|0)|0;l=j&d;j=(L()|0)&e;c[h>>2]=l;c[h+4>>2]=j;m=+g[h>>3];n=b;c[n>>2]=l;c[n+4>>2]=j;k=a-m;break}}else{j=b;c[j>>2]=0;c[j+4>>2]=e&-2147483648;k=a}while(0);return +k}function on(a){a=+a;var b=0,d=0,e=0.0,f=0.0;g[h>>3]=a;b=c[h+4>>2]|0;d=b&2147483647;c[h>>2]=c[h>>2];c[h+4>>2]=d;a=+g[h>>3];do if(d>>>0>1071748074)if(d>>>0>1077149696){e=1.0-0.0/a;break}else{e=1.0-2.0/(+jn(a*2.0)+2.0);break}else{if(d>>>0>1070618798){f=+jn(a*2.0);e=f/(f+2.0);break}if(d>>>0>1048575){f=+jn(a*-2.0);e=-f/(f+2.0)}else e=a}while(0);return +((b|0)<0?-e:e)}function pn(a,b){a=+a;b=b|0;return +(+Rl(a,b))}function qn(){return 6264}function rn(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;e=Pa;Pa=Pa+272|0;f=e;g=e+256|0;do if(!(a[d>>0]|0)){h=za(13530)|0;if(h|0?a[h>>0]|0:0){i=h;break}h=za(5344+(b*12|0)|0)|0;if(h|0?a[h>>0]|0:0){i=h;break}h=za(13537)|0;if(h|0?a[h>>0]|0:0){i=h;break}i=13542}else i=d;while(0);d=0;a:while(1){switch(a[i+d>>0]|0){case 47:case 0:{j=d;break a;break}default:{}}d=d+1|0;if(d>>>0>=15){j=15;break}}d=a[i>>0]|0;if(d<<24>>24!=46?(a[i+j>>0]|0)==0:0)if(d<<24>>24==67){k=i;l=15}else{m=i;l=16}else{k=13542;l=15}if((l|0)==15)if(!(a[k+1>>0]|0)){n=k;l=18}else{m=k;l=16}b:do if((l|0)==16)if((Cl(m,13542)|0)!=0?(Cl(m,13550)|0)!=0:0){k=c[4107]|0;if(k|0){i=k;do{if(!(Cl(m,i+8|0)|0)){o=i;break b}i=c[i+24>>2]|0}while((i|0)!=0)}U(16432);i=c[4107]|0;c:do if(i|0){k=i;while(1){if(!(Cl(m,k+8|0)|0))break;d=c[k+24>>2]|0;if(!d)break c;else k=d}ja(16432);o=k;break b}while(0);d:do if(((c[4089]|0)==0?(i=za(13556)|0,(i|0)!=0):0)?(a[i>>0]|0)!=0:0){d=254-j|0;h=j+1|0;p=i;while(1){i=vm(p,58)|0;q=a[i>>0]|0;r=i-p+((q<<24>>24!=0)<<31>>31)|0;if(r>>>0<d>>>0){Un(f|0,p|0,r|0)|0;s=f+r|0;a[s>>0]=47;Un(s+1|0,m|0,j|0)|0;a[f+(h+r)>>0]=0;t=V(f|0,g|0)|0;if(t|0)break;u=a[i>>0]|0}else u=q;p=i+(u<<24>>24!=0&1)|0;if(!(a[p>>0]|0)){l=41;break d}}p=Hk(28)|0;if(!p){_m(t,c[g>>2]|0)|0;l=41;break}else{c[p>>2]=t;c[p+4>>2]=c[g>>2];h=p+8|0;Un(h|0,m|0,j|0)|0;a[h+j>>0]=0;c[p+24>>2]=c[4107];c[4107]=p;v=p;break}}else l=41;while(0);if((l|0)==41){p=Hk(28)|0;if(!p)v=p;else{c[p>>2]=c[1465];c[p+4>>2]=c[1466];h=p+8|0;Un(h|0,m|0,j|0)|0;a[h+j>>0]=0;c[p+24>>2]=c[4107];c[4107]=p;v=p}}ja(16432);o=(b|0)==0&(v|0)==0?5860:v}else{n=m;l=18}while(0);do if((l|0)==18){if((b|0)==0?(a[n+1>>0]|0)==46:0){o=5860;break}o=0}while(0);Pa=e;return o|0}function sn(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;e=Pa;Pa=Pa+16|0;f=e;do if(b>>>0>6)g=0;else{U(16440);if((b|0)!=6){h=tn(b,d)|0;ja(16440);g=h;break}if(d|0){c[f>>2]=c[1356];c[f+4>>2]=c[1357];c[f+8>>2]=c[1358];c[f+12>>2]=c[1359];h=0;i=d;while(1){j=vm(i,59)|0;k=j-i|0;if((k|0)<16){Un(f|0,i|0,k|0)|0;a[f+k>>0]=0;l=(a[j>>0]|0)==0?i:j+1|0}else l=i;tn(h,f)|0;h=h+1|0;if((h|0)==6)break;else i=l}}i=15696;h=0;while(1){j=c[16388+(h<<2)>>2]|0;k=(j|0)==0?13569:j+8|0;m=_l(k)|0;Un(i|0,k|0,m|0)|0;a[i+m>>0]=59;h=h+1|0;if((h|0)==6)break;else i=i+(m+1)|0}a[i+m>>0]=0;ja(16440);g=15696}while(0);Pa=e;return g|0}function tn(a,b){a=a|0;b=b|0;var d=0,e=0;if(!b)d=c[16388+(a<<2)>>2]|0;else{e=rn(a,b)|0;c[16388+(a<<2)>>2]=e;d=e}return ((d|0)==0?13569:d+8|0)|0}function un(a,b,c){a=a|0;b=b|0;c=c|0;return Cl(a,b)|0}function vn(a,b){a=a|0;b=b|0;wn()|0;return un(a,b,0)|0}function wn(){return _k()|0}function xn(a,b){a=a|0;b=b|0;return +(+yn(a,b,1))}function yn(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,i=0.0;e=Pa;Pa=Pa+128|0;f=e;g=f;h=g+124|0;do{c[g>>2]=0;g=g+4|0}while((g|0)<(h|0));g=f+4|0;c[g>>2]=a;h=f+8|0;c[h>>2]=-1;c[f+44>>2]=a;c[f+76>>2]=-1;Gl(f,0);i=+Nl(f,d,1);d=(c[g>>2]|0)-(c[h>>2]|0)+(c[f+108>>2]|0)|0;if(b|0)c[b>>2]=(d|0)==0?a:a+d|0;Pa=e;return +i}function zn(a){a=a|0;var b=0;b=15840;c[b>>2]=a+-1;c[b+4>>2]=0;return}function An(){var a=0,b=0,d=0;a=15840;b=Hn(c[a>>2]|0,c[a+4>>2]|0,1284865837,1481765933)|0;a=In(b|0,L()|0,1,0)|0;b=L()|0;d=15840;c[d>>2]=a;c[d+4>>2]=b;d=On(a|0,b|0,33)|0;L()|0;return d|0}function Bn(){S(16464);return}function Cn(){return 16448}function Dn(){return 16456}function En(){return 16460}function Fn(){return 16464}function Gn(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0;c=a&65535;d=b&65535;e=H(d,c)|0;f=a>>>16;a=(e>>>16)+(H(d,f)|0)|0;d=b>>>16;b=H(d,c)|0;return (K((a>>>16)+(H(d,f)|0)+(((a&65535)+b|0)>>>16)|0),a+b<<16|e&65535|0)|0}function Hn(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=a;a=c;c=Gn(e,a)|0;f=L()|0;return (K((H(b,a)|0)+(H(d,e)|0)+f|f&0|0),c|0|0)|0}function In(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;e=a+c>>>0;return (K(b+d+(e>>>0<a>>>0|0)>>>0|0),e|0)|0}function Jn(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;e=b-d>>>0;e=b-d-(c>>>0>a>>>0|0)>>>0;return (K(e|0),a-c>>>0|0)|0}function Kn(a){a=a|0;return (a?31-(I(a^a-1)|0)|0:32)|0}function Ln(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;g=a;h=b;i=h;j=d;k=e;l=k;if(!i){m=(f|0)!=0;if(!l){if(m){c[f>>2]=(g>>>0)%(j>>>0);c[f+4>>2]=0}n=0;o=(g>>>0)/(j>>>0)>>>0;return (K(n|0),o)|0}else{if(!m){n=0;o=0;return (K(n|0),o)|0}c[f>>2]=a|0;c[f+4>>2]=b&0;n=0;o=0;return (K(n|0),o)|0}}m=(l|0)==0;do if(j){if(!m){p=(I(l|0)|0)-(I(i|0)|0)|0;if(p>>>0<=31){q=p+1|0;r=31-p|0;s=p-31>>31;t=q;u=g>>>(q>>>0)&s|i<<r;v=i>>>(q>>>0)&s;w=0;x=g<<r;break}if(!f){n=0;o=0;return (K(n|0),o)|0}c[f>>2]=a|0;c[f+4>>2]=h|b&0;n=0;o=0;return (K(n|0),o)|0}r=j-1|0;if(r&j|0){s=(I(j|0)|0)+33-(I(i|0)|0)|0;q=64-s|0;p=32-s|0;y=p>>31;z=s-32|0;A=z>>31;t=s;u=p-1>>31&i>>>(z>>>0)|(i<<p|g>>>(s>>>0))&A;v=A&i>>>(s>>>0);w=g<<q&y;x=(i<<q|g>>>(z>>>0))&y|g<<p&s-33>>31;break}if(f|0){c[f>>2]=r&g;c[f+4>>2]=0}if((j|0)==1){n=h|b&0;o=a|0|0;return (K(n|0),o)|0}else{r=Kn(j|0)|0;n=i>>>(r>>>0)|0;o=i<<32-r|g>>>(r>>>0)|0;return (K(n|0),o)|0}}else{if(m){if(f|0){c[f>>2]=(i>>>0)%(j>>>0);c[f+4>>2]=0}n=0;o=(i>>>0)/(j>>>0)>>>0;return (K(n|0),o)|0}if(!g){if(f|0){c[f>>2]=0;c[f+4>>2]=(i>>>0)%(l>>>0)}n=0;o=(i>>>0)/(l>>>0)>>>0;return (K(n|0),o)|0}r=l-1|0;if(!(r&l)){if(f|0){c[f>>2]=a|0;c[f+4>>2]=r&i|b&0}n=0;o=i>>>((Kn(l|0)|0)>>>0);return (K(n|0),o)|0}r=(I(l|0)|0)-(I(i|0)|0)|0;if(r>>>0<=30){s=r+1|0;p=31-r|0;t=s;u=i<<p|g>>>(s>>>0);v=i>>>(s>>>0);w=0;x=g<<p;break}if(!f){n=0;o=0;return (K(n|0),o)|0}c[f>>2]=a|0;c[f+4>>2]=h|b&0;n=0;o=0;return (K(n|0),o)|0}while(0);if(!t){B=x;C=w;D=v;E=u;F=0;G=0}else{b=d|0|0;d=k|e&0;e=In(b|0,d|0,-1,-1)|0;k=L()|0;h=x;x=w;w=v;v=u;u=t;t=0;do{a=h;h=x>>>31|h<<1;x=t|x<<1;g=v<<1|a>>>31|0;a=v>>>31|w<<1|0;Jn(e|0,k|0,g|0,a|0)|0;i=L()|0;l=i>>31|((i|0)<0?-1:0)<<1;t=l&1;v=Jn(g|0,a|0,l&b|0,(((i|0)<0?-1:0)>>31|((i|0)<0?-1:0)<<1)&d|0)|0;w=L()|0;u=u-1|0}while((u|0)!=0);B=h;C=x;D=w;E=v;F=0;G=t}t=C;C=0;if(f|0){c[f>>2]=E;c[f+4>>2]=D}n=(t|0)>>>31|(B|C)<<1|(C<<1|t>>>31)&0|F;o=(t<<1|0>>>31)&-2|G;return (K(n|0),o)|0}function Mn(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Ln(a,b,c,d,0)|0}function Nn(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){K(b>>c|0);return a>>>c|(b&(1<<c)-1)<<32-c}K(((b|0)<0?-1:0)|0);return b>>c-32|0}function On(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){K(b>>>c|0);return a>>>c|(b&(1<<c)-1)<<32-c}K(0);return b>>>c-32|0}function Pn(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){K(b<<c|(a&(1<<c)-1<<32-c)>>>32-c|0);return a<<c}K(a<<c-32|0);return 0}function Qn(a){a=a|0;return (a&255)<<24|(a>>8&255)<<16|(a>>16&255)<<8|a>>>24|0}function Rn(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0;l=l+1|0;c[a>>2]=l;while((f|0)<(e|0)){if(!(c[d+(f<<3)>>2]|0)){c[d+(f<<3)>>2]=l;c[d+((f<<3)+4)>>2]=b;c[d+((f<<3)+8)>>2]=0;K(e|0);return d|0}f=f+1|0}e=e*2|0;d=Jk(d|0,8*(e+1|0)|0)|0;d=Rn(a|0,b|0,d|0,e|0)|0;K(e|0);return d|0}function Sn(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;while((e|0)<(d|0)){f=c[b+(e<<3)>>2]|0;if(!f)break;if((f|0)==(a|0))return c[b+((e<<3)+4)>>2]|0;e=e+1|0}return 0}function Tn(a,b){a=a|0;b=b|0;if(!j){j=a;k=b}}function Un(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;if((e|0)>=8192){ua(b|0,d|0,e|0)|0;return b|0}f=b|0;g=b+e|0;if((b&3)==(d&3)){while(b&3){if(!e)return f|0;a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0}h=g&-4|0;e=h-64|0;while((b|0)<=(e|0)){c[b>>2]=c[d>>2];c[b+4>>2]=c[d+4>>2];c[b+8>>2]=c[d+8>>2];c[b+12>>2]=c[d+12>>2];c[b+16>>2]=c[d+16>>2];c[b+20>>2]=c[d+20>>2];c[b+24>>2]=c[d+24>>2];c[b+28>>2]=c[d+28>>2];c[b+32>>2]=c[d+32>>2];c[b+36>>2]=c[d+36>>2];c[b+40>>2]=c[d+40>>2];c[b+44>>2]=c[d+44>>2];c[b+48>>2]=c[d+48>>2];c[b+52>>2]=c[d+52>>2];c[b+56>>2]=c[d+56>>2];c[b+60>>2]=c[d+60>>2];b=b+64|0;d=d+64|0}while((b|0)<(h|0)){c[b>>2]=c[d>>2];b=b+4|0;d=d+4|0}}else{h=g-4|0;while((b|0)<(h|0)){a[b>>0]=a[d>>0]|0;a[b+1>>0]=a[d+1>>0]|0;a[b+2>>0]=a[d+2>>0]|0;a[b+3>>0]=a[d+3>>0]|0;b=b+4|0;d=d+4|0}}while((b|0)<(g|0)){a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0}return f|0}function Vn(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;f=b+e|0;d=d&255;if((e|0)>=67){while(b&3){a[b>>0]=d;b=b+1|0}g=f&-4|0;h=d|d<<8|d<<16|d<<24;i=g-64|0;while((b|0)<=(i|0)){c[b>>2]=h;c[b+4>>2]=h;c[b+8>>2]=h;c[b+12>>2]=h;c[b+16>>2]=h;c[b+20>>2]=h;c[b+24>>2]=h;c[b+28>>2]=h;c[b+32>>2]=h;c[b+36>>2]=h;c[b+40>>2]=h;c[b+44>>2]=h;c[b+48>>2]=h;c[b+52>>2]=h;c[b+56>>2]=h;c[b+60>>2]=h;b=b+64|0}while((b|0)<(g|0)){c[b>>2]=h;b=b+4|0}}while((b|0)<(f|0)){a[b>>0]=d;b=b+1|0}return f-e|0}function Wn(a){a=a|0;var b=0,d=0;b=c[i>>2]|0;d=b+a|0;if((a|0)>0&(d|0)<(b|0)|(d|0)<0){Ma(d|0)|0;W(12);return -1}if((d|0)>(ra()|0)){if(!(va(d|0)|0)){W(12);return -1}}else c[i>>2]=d;return b|0}function Xn(a,b){a=a|0;b=b|0;return Ta[a&511](b|0)|0}function Yn(a){a=a|0;return N(0,a|0)|0}function Zn(a){a=a|0;return N(1,a|0)|0}function _n(a){a=a|0;return N(2,a|0)|0}function $n(a){a=a|0;return N(3,a|0)|0}function ao(a){a=a|0;return N(4,a|0)|0}function bo(a){a=a|0;return N(5,a|0)|0}function co(a){a=a|0;return N(6,a|0)|0}function eo(a){a=a|0;return N(7,a|0)|0}function fo(a){a=a|0;return N(8,a|0)|0}function go(a){a=a|0;return N(9,a|0)|0}function ho(a){a=a|0;return N(10,a|0)|0}function io(a){a=a|0;return N(11,a|0)|0}function jo(a){a=a|0;return N(12,a|0)|0}function ko(a){a=a|0;return N(13,a|0)|0}function lo(a){a=a|0;return N(14,a|0)|0}function mo(a){a=a|0;return N(15,a|0)|0}function no(a){a=a|0;return N(16,a|0)|0}function oo(a){a=a|0;return N(17,a|0)|0}function po(a){a=a|0;return N(18,a|0)|0}function qo(a){a=a|0;return N(19,a|0)|0}function ro(a){a=a|0;return N(20,a|0)|0}function so(a){a=a|0;return N(21,a|0)|0}function to(a){a=a|0;return N(22,a|0)|0}function uo(a){a=a|0;return N(23,a|0)|0}function vo(a){a=a|0;return N(24,a|0)|0}function wo(a){a=a|0;return N(25,a|0)|0}function xo(a){a=a|0;return N(26,a|0)|0}function yo(a){a=a|0;return N(27,a|0)|0}function zo(a){a=a|0;return N(28,a|0)|0}function Ao(a){a=a|0;return N(29,a|0)|0}function Bo(a){a=a|0;return N(30,a|0)|0}function Co(a){a=a|0;return N(31,a|0)|0}function Do(a){a=a|0;return N(32,a|0)|0}function Eo(a){a=a|0;return N(33,a|0)|0}function Fo(a){a=a|0;return N(34,a|0)|0}function Go(a){a=a|0;return N(35,a|0)|0}function Ho(a){a=a|0;return N(36,a|0)|0}function Io(a){a=a|0;return N(37,a|0)|0}function Jo(a){a=a|0;return N(38,a|0)|0}function Ko(a){a=a|0;return N(39,a|0)|0}function Lo(a){a=a|0;return N(40,a|0)|0}function Mo(a){a=a|0;return N(41,a|0)|0}function No(a){a=a|0;return N(42,a|0)|0}function Oo(a){a=a|0;return N(43,a|0)|0}function Po(a){a=a|0;return N(44,a|0)|0}function Qo(a){a=a|0;return N(45,a|0)|0}function Ro(a){a=a|0;return N(46,a|0)|0}function So(a){a=a|0;return N(47,a|0)|0}function To(a){a=a|0;return N(48,a|0)|0}function Uo(a){a=a|0;return N(49,a|0)|0}function Vo(a){a=a|0;return N(50,a|0)|0}function Wo(a){a=a|0;return N(51,a|0)|0}function Xo(a){a=a|0;return N(52,a|0)|0}function Yo(a){a=a|0;return N(53,a|0)|0}function Zo(a){a=a|0;return N(54,a|0)|0}function _o(a){a=a|0;return N(55,a|0)|0}function $o(a){a=a|0;return N(56,a|0)|0}function ap(a){a=a|0;return N(57,a|0)|0}function bp(a){a=a|0;return N(58,a|0)|0}function cp(a){a=a|0;return N(59,a|0)|0}function dp(a){a=a|0;return N(60,a|0)|0}function ep(a){a=a|0;return N(61,a|0)|0}function fp(a){a=a|0;return N(62,a|0)|0}function gp(a){a=a|0;return N(63,a|0)|0}function hp(a){a=a|0;return N(64,a|0)|0}function ip(a){a=a|0;return N(65,a|0)|0}function jp(a){a=a|0;return N(66,a|0)|0}function kp(a){a=a|0;return N(67,a|0)|0}function lp(a){a=a|0;return N(68,a|0)|0}function mp(a){a=a|0;return N(69,a|0)|0}function np(a){a=a|0;return N(70,a|0)|0}function op(a){a=a|0;return N(71,a|0)|0}function pp(a){a=a|0;return N(72,a|0)|0}function qp(a){a=a|0;return N(73,a|0)|0}function rp(a){a=a|0;return N(74,a|0)|0}function sp(a){a=a|0;return N(75,a|0)|0}function tp(a){a=a|0;return N(76,a|0)|0}function up(a){a=a|0;return N(77,a|0)|0}function vp(a){a=a|0;return N(78,a|0)|0}function wp(a){a=a|0;return N(79,a|0)|0}function xp(a){a=a|0;return N(80,a|0)|0}function yp(a){a=a|0;return N(81,a|0)|0}function zp(a){a=a|0;return N(82,a|0)|0}function Ap(a){a=a|0;return N(83,a|0)|0}function Bp(a){a=a|0;return N(84,a|0)|0}function Cp(a){a=a|0;return N(85,a|0)|0}function Dp(a){a=a|0;return N(86,a|0)|0}function Ep(a){a=a|0;return N(87,a|0)|0}function Fp(a){a=a|0;return N(88,a|0)|0}function Gp(a){a=a|0;return N(89,a|0)|0}function Hp(a){a=a|0;return N(90,a|0)|0}function Ip(a){a=a|0;return N(91,a|0)|0}function Jp(a){a=a|0;return N(92,a|0)|0}function Kp(a){a=a|0;return N(93,a|0)|0}function Lp(a){a=a|0;return N(94,a|0)|0}function Mp(a){a=a|0;return N(95,a|0)|0}function Np(a){a=a|0;return N(96,a|0)|0}function Op(a){a=a|0;return N(97,a|0)|0}function Pp(a){a=a|0;return N(98,a|0)|0}function Qp(a){a=a|0;return N(99,a|0)|0}function Rp(a){a=a|0;return N(100,a|0)|0}function Sp(a){a=a|0;return N(101,a|0)|0}function Tp(a){a=a|0;return N(102,a|0)|0}function Up(a){a=a|0;return N(103,a|0)|0}function Vp(a){a=a|0;return N(104,a|0)|0}function Wp(a){a=a|0;return N(105,a|0)|0}function Xp(a){a=a|0;return N(106,a|0)|0}function Yp(a){a=a|0;return N(107,a|0)|0}function Zp(a){a=a|0;return N(108,a|0)|0}function _p(a){a=a|0;return N(109,a|0)|0}function $p(a){a=a|0;return N(110,a|0)|0}function aq(a){a=a|0;return N(111,a|0)|0}function bq(a){a=a|0;return N(112,a|0)|0}function cq(a){a=a|0;return N(113,a|0)|0}function dq(a){a=a|0;return N(114,a|0)|0}function eq(a){a=a|0;return N(115,a|0)|0}function fq(a){a=a|0;return N(116,a|0)|0}function gq(a){a=a|0;return N(117,a|0)|0}function hq(a){a=a|0;return N(118,a|0)|0}function iq(a){a=a|0;return N(119,a|0)|0}function jq(a){a=a|0;return N(120,a|0)|0}function kq(a){a=a|0;return N(121,a|0)|0}function lq(a){a=a|0;return N(122,a|0)|0}function mq(a){a=a|0;return N(123,a|0)|0}function nq(a){a=a|0;return N(124,a|0)|0}function oq(a){a=a|0;return N(125,a|0)|0}function pq(a){a=a|0;return N(126,a|0)|0}function qq(a){a=a|0;return N(127,a|0)|0}function rq(a,b,c){a=a|0;b=b|0;c=c|0;return Ua[a&255](b|0,c|0)|0}function sq(a,b){a=a|0;b=b|0;return O(0,a|0,b|0)|0}function tq(a,b){a=a|0;b=b|0;return O(1,a|0,b|0)|0}function uq(a,b){a=a|0;b=b|0;return O(2,a|0,b|0)|0}function vq(a,b){a=a|0;b=b|0;return O(3,a|0,b|0)|0}function wq(a,b){a=a|0;b=b|0;return O(4,a|0,b|0)|0}function xq(a,b){a=a|0;b=b|0;return O(5,a|0,b|0)|0}function yq(a,b){a=a|0;b=b|0;return O(6,a|0,b|0)|0}function zq(a,b){a=a|0;b=b|0;return O(7,a|0,b|0)|0}function Aq(a,b){a=a|0;b=b|0;return O(8,a|0,b|0)|0}function Bq(a,b){a=a|0;b=b|0;return O(9,a|0,b|0)|0}function Cq(a,b){a=a|0;b=b|0;return O(10,a|0,b|0)|0}function Dq(a,b){a=a|0;b=b|0;return O(11,a|0,b|0)|0}function Eq(a,b){a=a|0;b=b|0;return O(12,a|0,b|0)|0}function Fq(a,b){a=a|0;b=b|0;return O(13,a|0,b|0)|0}function Gq(a,b){a=a|0;b=b|0;return O(14,a|0,b|0)|0}function Hq(a,b){a=a|0;b=b|0;return O(15,a|0,b|0)|0}function Iq(a,b){a=a|0;b=b|0;return O(16,a|0,b|0)|0}function Jq(a,b){a=a|0;b=b|0;return O(17,a|0,b|0)|0}function Kq(a,b){a=a|0;b=b|0;return O(18,a|0,b|0)|0}function Lq(a,b){a=a|0;b=b|0;return O(19,a|0,b|0)|0}function Mq(a,b){a=a|0;b=b|0;return O(20,a|0,b|0)|0}function Nq(a,b){a=a|0;b=b|0;return O(21,a|0,b|0)|0}function Oq(a,b){a=a|0;b=b|0;return O(22,a|0,b|0)|0}function Pq(a,b){a=a|0;b=b|0;return O(23,a|0,b|0)|0}function Qq(a,b){a=a|0;b=b|0;return O(24,a|0,b|0)|0}function Rq(a,b){a=a|0;b=b|0;return O(25,a|0,b|0)|0}function Sq(a,b){a=a|0;b=b|0;return O(26,a|0,b|0)|0}function Tq(a,b){a=a|0;b=b|0;return O(27,a|0,b|0)|0}function Uq(a,b){a=a|0;b=b|0;return O(28,a|0,b|0)|0}function Vq(a,b){a=a|0;b=b|0;return O(29,a|0,b|0)|0}function Wq(a,b){a=a|0;b=b|0;return O(30,a|0,b|0)|0}function Xq(a,b){a=a|0;b=b|0;return O(31,a|0,b|0)|0}function Yq(a,b){a=a|0;b=b|0;return O(32,a|0,b|0)|0}function Zq(a,b){a=a|0;b=b|0;return O(33,a|0,b|0)|0}function _q(a,b){a=a|0;b=b|0;return O(34,a|0,b|0)|0}function $q(a,b){a=a|0;b=b|0;return O(35,a|0,b|0)|0}function ar(a,b){a=a|0;b=b|0;return O(36,a|0,b|0)|0}function br(a,b){a=a|0;b=b|0;return O(37,a|0,b|0)|0}function cr(a,b){a=a|0;b=b|0;return O(38,a|0,b|0)|0}function dr(a,b){a=a|0;b=b|0;return O(39,a|0,b|0)|0}function er(a,b){a=a|0;b=b|0;return O(40,a|0,b|0)|0}function fr(a,b){a=a|0;b=b|0;return O(41,a|0,b|0)|0}function gr(a,b){a=a|0;b=b|0;return O(42,a|0,b|0)|0}function hr(a,b){a=a|0;b=b|0;return O(43,a|0,b|0)|0}function ir(a,b){a=a|0;b=b|0;return O(44,a|0,b|0)|0}function jr(a,b){a=a|0;b=b|0;return O(45,a|0,b|0)|0}function kr(a,b){a=a|0;b=b|0;return O(46,a|0,b|0)|0}function lr(a,b){a=a|0;b=b|0;return O(47,a|0,b|0)|0}function mr(a,b){a=a|0;b=b|0;return O(48,a|0,b|0)|0}function nr(a,b){a=a|0;b=b|0;return O(49,a|0,b|0)|0}function or(a,b){a=a|0;b=b|0;return O(50,a|0,b|0)|0}function pr(a,b){a=a|0;b=b|0;return O(51,a|0,b|0)|0}function qr(a,b){a=a|0;b=b|0;return O(52,a|0,b|0)|0}function rr(a,b){a=a|0;b=b|0;return O(53,a|0,b|0)|0}function sr(a,b){a=a|0;b=b|0;return O(54,a|0,b|0)|0}function tr(a,b){a=a|0;b=b|0;return O(55,a|0,b|0)|0}function ur(a,b){a=a|0;b=b|0;return O(56,a|0,b|0)|0}function vr(a,b){a=a|0;b=b|0;return O(57,a|0,b|0)|0}function wr(a,b){a=a|0;b=b|0;return O(58,a|0,b|0)|0}function xr(a,b){a=a|0;b=b|0;return O(59,a|0,b|0)|0}function yr(a,b){a=a|0;b=b|0;return O(60,a|0,b|0)|0}function zr(a,b){a=a|0;b=b|0;return O(61,a|0,b|0)|0}function Ar(a,b){a=a|0;b=b|0;return O(62,a|0,b|0)|0}function Br(a,b){a=a|0;b=b|0;return O(63,a|0,b|0)|0}function Cr(a,b){a=a|0;b=b|0;return O(64,a|0,b|0)|0}function Dr(a,b){a=a|0;b=b|0;return O(65,a|0,b|0)|0}function Er(a,b){a=a|0;b=b|0;return O(66,a|0,b|0)|0}function Fr(a,b){a=a|0;b=b|0;return O(67,a|0,b|0)|0}function Gr(a,b){a=a|0;b=b|0;return O(68,a|0,b|0)|0}function Hr(a,b){a=a|0;b=b|0;return O(69,a|0,b|0)|0}function Ir(a,b){a=a|0;b=b|0;return O(70,a|0,b|0)|0}function Jr(a,b){a=a|0;b=b|0;return O(71,a|0,b|0)|0}function Kr(a,b){a=a|0;b=b|0;return O(72,a|0,b|0)|0}function Lr(a,b){a=a|0;b=b|0;return O(73,a|0,b|0)|0}function Mr(a,b){a=a|0;b=b|0;return O(74,a|0,b|0)|0}function Nr(a,b){a=a|0;b=b|0;return O(75,a|0,b|0)|0}function Or(a,b){a=a|0;b=b|0;return O(76,a|0,b|0)|0}function Pr(a,b){a=a|0;b=b|0;return O(77,a|0,b|0)|0}function Qr(a,b){a=a|0;b=b|0;return O(78,a|0,b|0)|0}function Rr(a,b){a=a|0;b=b|0;return O(79,a|0,b|0)|0}function Sr(a,b){a=a|0;b=b|0;return O(80,a|0,b|0)|0}function Tr(a,b){a=a|0;b=b|0;return O(81,a|0,b|0)|0}function Ur(a,b){a=a|0;b=b|0;return O(82,a|0,b|0)|0}function Vr(a,b){a=a|0;b=b|0;return O(83,a|0,b|0)|0}function Wr(a,b){a=a|0;b=b|0;return O(84,a|0,b|0)|0}function Xr(a,b){a=a|0;b=b|0;return O(85,a|0,b|0)|0}function Yr(a,b){a=a|0;b=b|0;return O(86,a|0,b|0)|0}function Zr(a,b){a=a|0;b=b|0;return O(87,a|0,b|0)|0}function _r(a,b){a=a|0;b=b|0;return O(88,a|0,b|0)|0}function $r(a,b){a=a|0;b=b|0;return O(89,a|0,b|0)|0}function as(a,b){a=a|0;b=b|0;return O(90,a|0,b|0)|0}function bs(a,b){a=a|0;b=b|0;return O(91,a|0,b|0)|0}function cs(a,b){a=a|0;b=b|0;return O(92,a|0,b|0)|0}function ds(a,b){a=a|0;b=b|0;return O(93,a|0,b|0)|0}function es(a,b){a=a|0;b=b|0;return O(94,a|0,b|0)|0}function fs(a,b){a=a|0;b=b|0;return O(95,a|0,b|0)|0}function gs(a,b){a=a|0;b=b|0;return O(96,a|0,b|0)|0}function hs(a,b){a=a|0;b=b|0;return O(97,a|0,b|0)|0}function is(a,b){a=a|0;b=b|0;return O(98,a|0,b|0)|0}function js(a,b){a=a|0;b=b|0;return O(99,a|0,b|0)|0}function ks(a,b){a=a|0;b=b|0;return O(100,a|0,b|0)|0}function ls(a,b){a=a|0;b=b|0;return O(101,a|0,b|0)|0}function ms(a,b){a=a|0;b=b|0;return O(102,a|0,b|0)|0}function ns(a,b){a=a|0;b=b|0;return O(103,a|0,b|0)|0}function os(a,b){a=a|0;b=b|0;return O(104,a|0,b|0)|0}function ps(a,b){a=a|0;b=b|0;return O(105,a|0,b|0)|0}function qs(a,b){a=a|0;b=b|0;return O(106,a|0,b|0)|0}function rs(a,b){a=a|0;b=b|0;return O(107,a|0,b|0)|0}function ss(a,b){a=a|0;b=b|0;return O(108,a|0,b|0)|0}function ts(a,b){a=a|0;b=b|0;return O(109,a|0,b|0)|0}function us(a,b){a=a|0;b=b|0;return O(110,a|0,b|0)|0}function vs(a,b){a=a|0;b=b|0;return O(111,a|0,b|0)|0}function ws(a,b){a=a|0;b=b|0;return O(112,a|0,b|0)|0}function xs(a,b){a=a|0;b=b|0;return O(113,a|0,b|0)|0}function ys(a,b){a=a|0;b=b|0;return O(114,a|0,b|0)|0}function zs(a,b){a=a|0;b=b|0;return O(115,a|0,b|0)|0}function As(a,b){a=a|0;b=b|0;return O(116,a|0,b|0)|0}function Bs(a,b){a=a|0;b=b|0;return O(117,a|0,b|0)|0}function Cs(a,b){a=a|0;b=b|0;return O(118,a|0,b|0)|0}function Ds(a,b){a=a|0;b=b|0;return O(119,a|0,b|0)|0}function Es(a,b){a=a|0;b=b|0;return O(120,a|0,b|0)|0}function Fs(a,b){a=a|0;b=b|0;return O(121,a|0,b|0)|0}function Gs(a,b){a=a|0;b=b|0;return O(122,a|0,b|0)|0}function Hs(a,b){a=a|0;b=b|0;return O(123,a|0,b|0)|0}function Is(a,b){a=a|0;b=b|0;return O(124,a|0,b|0)|0}function Js(a,b){a=a|0;b=b|0;return O(125,a|0,b|0)|0}function Ks(a,b){a=a|0;b=b|0;return O(126,a|0,b|0)|0}function Ls(a,b){a=a|0;b=b|0;return O(127,a|0,b|0)|0}function Ms(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Va[a&255](b|0,c|0,d|0)|0}function Ns(a,b,c){a=a|0;b=b|0;c=c|0;return P(0,a|0,b|0,c|0)|0}function Os(a,b,c){a=a|0;b=b|0;c=c|0;return P(1,a|0,b|0,c|0)|0}function Ps(a,b,c){a=a|0;b=b|0;c=c|0;return P(2,a|0,b|0,c|0)|0}function Qs(a,b,c){a=a|0;b=b|0;c=c|0;return P(3,a|0,b|0,c|0)|0}function Rs(a,b,c){a=a|0;b=b|0;c=c|0;return P(4,a|0,b|0,c|0)|0}function Ss(a,b,c){a=a|0;b=b|0;c=c|0;return P(5,a|0,b|0,c|0)|0}function Ts(a,b,c){a=a|0;b=b|0;c=c|0;return P(6,a|0,b|0,c|0)|0}function Us(a,b,c){a=a|0;b=b|0;c=c|0;return P(7,a|0,b|0,c|0)|0}function Vs(a,b,c){a=a|0;b=b|0;c=c|0;return P(8,a|0,b|0,c|0)|0}function Ws(a,b,c){a=a|0;b=b|0;c=c|0;return P(9,a|0,b|0,c|0)|0}function Xs(a,b,c){a=a|0;b=b|0;c=c|0;return P(10,a|0,b|0,c|0)|0}function Ys(a,b,c){a=a|0;b=b|0;c=c|0;return P(11,a|0,b|0,c|0)|0}function Zs(a,b,c){a=a|0;b=b|0;c=c|0;return P(12,a|0,b|0,c|0)|0}function _s(a,b,c){a=a|0;b=b|0;c=c|0;return P(13,a|0,b|0,c|0)|0}function $s(a,b,c){a=a|0;b=b|0;c=c|0;return P(14,a|0,b|0,c|0)|0}function at(a,b,c){a=a|0;b=b|0;c=c|0;return P(15,a|0,b|0,c|0)|0}function bt(a,b,c){a=a|0;b=b|0;c=c|0;return P(16,a|0,b|0,c|0)|0}function ct(a,b,c){a=a|0;b=b|0;c=c|0;return P(17,a|0,b|0,c|0)|0}function dt(a,b,c){a=a|0;b=b|0;c=c|0;return P(18,a|0,b|0,c|0)|0}function et(a,b,c){a=a|0;b=b|0;c=c|0;return P(19,a|0,b|0,c|0)|0}function ft(a,b,c){a=a|0;b=b|0;c=c|0;return P(20,a|0,b|0,c|0)|0}function gt(a,b,c){a=a|0;b=b|0;c=c|0;return P(21,a|0,b|0,c|0)|0}function ht(a,b,c){a=a|0;b=b|0;c=c|0;return P(22,a|0,b|0,c|0)|0}function it(a,b,c){a=a|0;b=b|0;c=c|0;return P(23,a|0,b|0,c|0)|0}function jt(a,b,c){a=a|0;b=b|0;c=c|0;return P(24,a|0,b|0,c|0)|0}function kt(a,b,c){a=a|0;b=b|0;c=c|0;return P(25,a|0,b|0,c|0)|0}function lt(a,b,c){a=a|0;b=b|0;c=c|0;return P(26,a|0,b|0,c|0)|0}function mt(a,b,c){a=a|0;b=b|0;c=c|0;return P(27,a|0,b|0,c|0)|0}function nt(a,b,c){a=a|0;b=b|0;c=c|0;return P(28,a|0,b|0,c|0)|0}function ot(a,b,c){a=a|0;b=b|0;c=c|0;return P(29,a|0,b|0,c|0)|0}function pt(a,b,c){a=a|0;b=b|0;c=c|0;return P(30,a|0,b|0,c|0)|0}function qt(a,b,c){a=a|0;b=b|0;c=c|0;return P(31,a|0,b|0,c|0)|0}function rt(a,b,c){a=a|0;b=b|0;c=c|0;return P(32,a|0,b|0,c|0)|0}function st(a,b,c){a=a|0;b=b|0;c=c|0;return P(33,a|0,b|0,c|0)|0}function tt(a,b,c){a=a|0;b=b|0;c=c|0;return P(34,a|0,b|0,c|0)|0}function ut(a,b,c){a=a|0;b=b|0;c=c|0;return P(35,a|0,b|0,c|0)|0}function vt(a,b,c){a=a|0;b=b|0;c=c|0;return P(36,a|0,b|0,c|0)|0}function wt(a,b,c){a=a|0;b=b|0;c=c|0;return P(37,a|0,b|0,c|0)|0}function xt(a,b,c){a=a|0;b=b|0;c=c|0;return P(38,a|0,b|0,c|0)|0}function yt(a,b,c){a=a|0;b=b|0;c=c|0;return P(39,a|0,b|0,c|0)|0}function zt(a,b,c){a=a|0;b=b|0;c=c|0;return P(40,a|0,b|0,c|0)|0}function At(a,b,c){a=a|0;b=b|0;c=c|0;return P(41,a|0,b|0,c|0)|0}function Bt(a,b,c){a=a|0;b=b|0;c=c|0;return P(42,a|0,b|0,c|0)|0}function Ct(a,b,c){a=a|0;b=b|0;c=c|0;return P(43,a|0,b|0,c|0)|0}function Dt(a,b,c){a=a|0;b=b|0;c=c|0;return P(44,a|0,b|0,c|0)|0}function Et(a,b,c){a=a|0;b=b|0;c=c|0;return P(45,a|0,b|0,c|0)|0}function Ft(a,b,c){a=a|0;b=b|0;c=c|0;return P(46,a|0,b|0,c|0)|0}function Gt(a,b,c){a=a|0;b=b|0;c=c|0;return P(47,a|0,b|0,c|0)|0}function Ht(a,b,c){a=a|0;b=b|0;c=c|0;return P(48,a|0,b|0,c|0)|0}function It(a,b,c){a=a|0;b=b|0;c=c|0;return P(49,a|0,b|0,c|0)|0}function Jt(a,b,c){a=a|0;b=b|0;c=c|0;return P(50,a|0,b|0,c|0)|0}function Kt(a,b,c){a=a|0;b=b|0;c=c|0;return P(51,a|0,b|0,c|0)|0}function Lt(a,b,c){a=a|0;b=b|0;c=c|0;return P(52,a|0,b|0,c|0)|0}function Mt(a,b,c){a=a|0;b=b|0;c=c|0;return P(53,a|0,b|0,c|0)|0}function Nt(a,b,c){a=a|0;b=b|0;c=c|0;return P(54,a|0,b|0,c|0)|0}function Ot(a,b,c){a=a|0;b=b|0;c=c|0;return P(55,a|0,b|0,c|0)|0}function Pt(a,b,c){a=a|0;b=b|0;c=c|0;return P(56,a|0,b|0,c|0)|0}function Qt(a,b,c){a=a|0;b=b|0;c=c|0;return P(57,a|0,b|0,c|0)|0}function Rt(a,b,c){a=a|0;b=b|0;c=c|0;return P(58,a|0,b|0,c|0)|0}function St(a,b,c){a=a|0;b=b|0;c=c|0;return P(59,a|0,b|0,c|0)|0}function Tt(a,b,c){a=a|0;b=b|0;c=c|0;return P(60,a|0,b|0,c|0)|0}function Ut(a,b,c){a=a|0;b=b|0;c=c|0;return P(61,a|0,b|0,c|0)|0}function Vt(a,b,c){a=a|0;b=b|0;c=c|0;return P(62,a|0,b|0,c|0)|0}function Wt(a,b,c){a=a|0;b=b|0;c=c|0;return P(63,a|0,b|0,c|0)|0}function Xt(a,b,c){a=a|0;b=b|0;c=c|0;return P(64,a|0,b|0,c|0)|0}function Yt(a,b,c){a=a|0;b=b|0;c=c|0;return P(65,a|0,b|0,c|0)|0}function Zt(a,b,c){a=a|0;b=b|0;c=c|0;return P(66,a|0,b|0,c|0)|0}function _t(a,b,c){a=a|0;b=b|0;c=c|0;return P(67,a|0,b|0,c|0)|0}function $t(a,b,c){a=a|0;b=b|0;c=c|0;return P(68,a|0,b|0,c|0)|0}function au(a,b,c){a=a|0;b=b|0;c=c|0;return P(69,a|0,b|0,c|0)|0}function bu(a,b,c){a=a|0;b=b|0;c=c|0;return P(70,a|0,b|0,c|0)|0}function cu(a,b,c){a=a|0;b=b|0;c=c|0;return P(71,a|0,b|0,c|0)|0}function du(a,b,c){a=a|0;b=b|0;c=c|0;return P(72,a|0,b|0,c|0)|0}function eu(a,b,c){a=a|0;b=b|0;c=c|0;return P(73,a|0,b|0,c|0)|0}function fu(a,b,c){a=a|0;b=b|0;c=c|0;return P(74,a|0,b|0,c|0)|0}function gu(a,b,c){a=a|0;b=b|0;c=c|0;return P(75,a|0,b|0,c|0)|0}function hu(a,b,c){a=a|0;b=b|0;c=c|0;return P(76,a|0,b|0,c|0)|0}function iu(a,b,c){a=a|0;b=b|0;c=c|0;return P(77,a|0,b|0,c|0)|0}function ju(a,b,c){a=a|0;b=b|0;c=c|0;return P(78,a|0,b|0,c|0)|0}function ku(a,b,c){a=a|0;b=b|0;c=c|0;return P(79,a|0,b|0,c|0)|0}function lu(a,b,c){a=a|0;b=b|0;c=c|0;return P(80,a|0,b|0,c|0)|0}function mu(a,b,c){a=a|0;b=b|0;c=c|0;return P(81,a|0,b|0,c|0)|0}function nu(a,b,c){a=a|0;b=b|0;c=c|0;return P(82,a|0,b|0,c|0)|0}function ou(a,b,c){a=a|0;b=b|0;c=c|0;return P(83,a|0,b|0,c|0)|0}function pu(a,b,c){a=a|0;b=b|0;c=c|0;return P(84,a|0,b|0,c|0)|0}function qu(a,b,c){a=a|0;b=b|0;c=c|0;return P(85,a|0,b|0,c|0)|0}function ru(a,b,c){a=a|0;b=b|0;c=c|0;return P(86,a|0,b|0,c|0)|0}function su(a,b,c){a=a|0;b=b|0;c=c|0;return P(87,a|0,b|0,c|0)|0}function tu(a,b,c){a=a|0;b=b|0;c=c|0;return P(88,a|0,b|0,c|0)|0}function uu(a,b,c){a=a|0;b=b|0;c=c|0;return P(89,a|0,b|0,c|0)|0}function vu(a,b,c){a=a|0;b=b|0;c=c|0;return P(90,a|0,b|0,c|0)|0}function wu(a,b,c){a=a|0;b=b|0;c=c|0;return P(91,a|0,b|0,c|0)|0}function xu(a,b,c){a=a|0;b=b|0;c=c|0;return P(92,a|0,b|0,c|0)|0}function yu(a,b,c){a=a|0;b=b|0;c=c|0;return P(93,a|0,b|0,c|0)|0}function zu(a,b,c){a=a|0;b=b|0;c=c|0;return P(94,a|0,b|0,c|0)|0}function Au(a,b,c){a=a|0;b=b|0;c=c|0;return P(95,a|0,b|0,c|0)|0}function Bu(a,b,c){a=a|0;b=b|0;c=c|0;return P(96,a|0,b|0,c|0)|0}function Cu(a,b,c){a=a|0;b=b|0;c=c|0;return P(97,a|0,b|0,c|0)|0}function Du(a,b,c){a=a|0;b=b|0;c=c|0;return P(98,a|0,b|0,c|0)|0}function Eu(a,b,c){a=a|0;b=b|0;c=c|0;return P(99,a|0,b|0,c|0)|0}function Fu(a,b,c){a=a|0;b=b|0;c=c|0;return P(100,a|0,b|0,c|0)|0}function Gu(a,b,c){a=a|0;b=b|0;c=c|0;return P(101,a|0,b|0,c|0)|0}function Hu(a,b,c){a=a|0;b=b|0;c=c|0;return P(102,a|0,b|0,c|0)|0}function Iu(a,b,c){a=a|0;b=b|0;c=c|0;return P(103,a|0,b|0,c|0)|0}function Ju(a,b,c){a=a|0;b=b|0;c=c|0;return P(104,a|0,b|0,c|0)|0}function Ku(a,b,c){a=a|0;b=b|0;c=c|0;return P(105,a|0,b|0,c|0)|0}function Lu(a,b,c){a=a|0;b=b|0;c=c|0;return P(106,a|0,b|0,c|0)|0}function Mu(a,b,c){a=a|0;b=b|0;c=c|0;return P(107,a|0,b|0,c|0)|0}function Nu(a,b,c){a=a|0;b=b|0;c=c|0;return P(108,a|0,b|0,c|0)|0}function Ou(a,b,c){a=a|0;b=b|0;c=c|0;return P(109,a|0,b|0,c|0)|0}function Pu(a,b,c){a=a|0;b=b|0;c=c|0;return P(110,a|0,b|0,c|0)|0}function Qu(a,b,c){a=a|0;b=b|0;c=c|0;return P(111,a|0,b|0,c|0)|0}function Ru(a,b,c){a=a|0;b=b|0;c=c|0;return P(112,a|0,b|0,c|0)|0}function Su(a,b,c){a=a|0;b=b|0;c=c|0;return P(113,a|0,b|0,c|0)|0}function Tu(a,b,c){a=a|0;b=b|0;c=c|0;return P(114,a|0,b|0,c|0)|0}function Uu(a,b,c){a=a|0;b=b|0;c=c|0;return P(115,a|0,b|0,c|0)|0}function Vu(a,b,c){a=a|0;b=b|0;c=c|0;return P(116,a|0,b|0,c|0)|0}function Wu(a,b,c){a=a|0;b=b|0;c=c|0;return P(117,a|0,b|0,c|0)|0}function Xu(a,b,c){a=a|0;b=b|0;c=c|0;return P(118,a|0,b|0,c|0)|0}function Yu(a,b,c){a=a|0;b=b|0;c=c|0;return P(119,a|0,b|0,c|0)|0}function Zu(a,b,c){a=a|0;b=b|0;c=c|0;return P(120,a|0,b|0,c|0)|0}function _u(a,b,c){a=a|0;b=b|0;c=c|0;return P(121,a|0,b|0,c|0)|0}function $u(a,b,c){a=a|0;b=b|0;c=c|0;return P(122,a|0,b|0,c|0)|0}function av(a,b,c){a=a|0;b=b|0;c=c|0;return P(123,a|0,b|0,c|0)|0}function bv(a,b,c){a=a|0;b=b|0;c=c|0;return P(124,a|0,b|0,c|0)|0}function cv(a,b,c){a=a|0;b=b|0;c=c|0;return P(125,a|0,b|0,c|0)|0}function dv(a,b,c){a=a|0;b=b|0;c=c|0;return P(126,a|0,b|0,c|0)|0}function ev(a,b,c){a=a|0;b=b|0;c=c|0;return P(127,a|0,b|0,c|0)|0}function fv(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;return Wa[a&255](b|0,c|0,d|0,e|0)|0}function gv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(0,a|0,b|0,c|0,d|0)|0}function hv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(1,a|0,b|0,c|0,d|0)|0}function iv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(2,a|0,b|0,c|0,d|0)|0}function jv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(3,a|0,b|0,c|0,d|0)|0}function kv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(4,a|0,b|0,c|0,d|0)|0}function lv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(5,a|0,b|0,c|0,d|0)|0}function mv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(6,a|0,b|0,c|0,d|0)|0}function nv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(7,a|0,b|0,c|0,d|0)|0}function ov(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(8,a|0,b|0,c|0,d|0)|0}function pv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(9,a|0,b|0,c|0,d|0)|0}function qv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(10,a|0,b|0,c|0,d|0)|0}function rv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(11,a|0,b|0,c|0,d|0)|0}function sv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(12,a|0,b|0,c|0,d|0)|0}function tv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(13,a|0,b|0,c|0,d|0)|0}function uv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(14,a|0,b|0,c|0,d|0)|0}function vv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(15,a|0,b|0,c|0,d|0)|0}function wv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(16,a|0,b|0,c|0,d|0)|0}function xv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(17,a|0,b|0,c|0,d|0)|0}function yv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(18,a|0,b|0,c|0,d|0)|0}function zv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(19,a|0,b|0,c|0,d|0)|0}function Av(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(20,a|0,b|0,c|0,d|0)|0}function Bv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(21,a|0,b|0,c|0,d|0)|0}function Cv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(22,a|0,b|0,c|0,d|0)|0}function Dv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(23,a|0,b|0,c|0,d|0)|0}function Ev(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(24,a|0,b|0,c|0,d|0)|0}function Fv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(25,a|0,b|0,c|0,d|0)|0}function Gv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(26,a|0,b|0,c|0,d|0)|0}function Hv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(27,a|0,b|0,c|0,d|0)|0}function Iv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(28,a|0,b|0,c|0,d|0)|0}function Jv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(29,a|0,b|0,c|0,d|0)|0}function Kv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(30,a|0,b|0,c|0,d|0)|0}function Lv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(31,a|0,b|0,c|0,d|0)|0}function Mv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(32,a|0,b|0,c|0,d|0)|0}function Nv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(33,a|0,b|0,c|0,d|0)|0}function Ov(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(34,a|0,b|0,c|0,d|0)|0}function Pv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(35,a|0,b|0,c|0,d|0)|0}function Qv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(36,a|0,b|0,c|0,d|0)|0}function Rv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(37,a|0,b|0,c|0,d|0)|0}function Sv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(38,a|0,b|0,c|0,d|0)|0}function Tv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(39,a|0,b|0,c|0,d|0)|0}function Uv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(40,a|0,b|0,c|0,d|0)|0}function Vv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(41,a|0,b|0,c|0,d|0)|0}function Wv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(42,a|0,b|0,c|0,d|0)|0}function Xv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(43,a|0,b|0,c|0,d|0)|0}function Yv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(44,a|0,b|0,c|0,d|0)|0}function Zv(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(45,a|0,b|0,c|0,d|0)|0}function _v(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(46,a|0,b|0,c|0,d|0)|0}function $v(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(47,a|0,b|0,c|0,d|0)|0}function aw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(48,a|0,b|0,c|0,d|0)|0}function bw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(49,a|0,b|0,c|0,d|0)|0}function cw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(50,a|0,b|0,c|0,d|0)|0}function dw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(51,a|0,b|0,c|0,d|0)|0}function ew(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(52,a|0,b|0,c|0,d|0)|0}function fw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(53,a|0,b|0,c|0,d|0)|0}function gw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(54,a|0,b|0,c|0,d|0)|0}function hw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(55,a|0,b|0,c|0,d|0)|0}function iw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(56,a|0,b|0,c|0,d|0)|0}function jw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(57,a|0,b|0,c|0,d|0)|0}function kw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(58,a|0,b|0,c|0,d|0)|0}function lw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(59,a|0,b|0,c|0,d|0)|0}function mw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(60,a|0,b|0,c|0,d|0)|0}function nw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(61,a|0,b|0,c|0,d|0)|0}function ow(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(62,a|0,b|0,c|0,d|0)|0}function pw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(63,a|0,b|0,c|0,d|0)|0}function qw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(64,a|0,b|0,c|0,d|0)|0}function rw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(65,a|0,b|0,c|0,d|0)|0}function sw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(66,a|0,b|0,c|0,d|0)|0}function tw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(67,a|0,b|0,c|0,d|0)|0}function uw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(68,a|0,b|0,c|0,d|0)|0}function vw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(69,a|0,b|0,c|0,d|0)|0}function ww(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(70,a|0,b|0,c|0,d|0)|0}function xw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(71,a|0,b|0,c|0,d|0)|0}function yw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(72,a|0,b|0,c|0,d|0)|0}function zw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(73,a|0,b|0,c|0,d|0)|0}function Aw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(74,a|0,b|0,c|0,d|0)|0}function Bw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(75,a|0,b|0,c|0,d|0)|0}function Cw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(76,a|0,b|0,c|0,d|0)|0}function Dw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(77,a|0,b|0,c|0,d|0)|0}function Ew(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(78,a|0,b|0,c|0,d|0)|0}function Fw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(79,a|0,b|0,c|0,d|0)|0}function Gw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(80,a|0,b|0,c|0,d|0)|0}function Hw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(81,a|0,b|0,c|0,d|0)|0}function Iw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(82,a|0,b|0,c|0,d|0)|0}function Jw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(83,a|0,b|0,c|0,d|0)|0}function Kw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(84,a|0,b|0,c|0,d|0)|0}function Lw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(85,a|0,b|0,c|0,d|0)|0}function Mw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(86,a|0,b|0,c|0,d|0)|0}function Nw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(87,a|0,b|0,c|0,d|0)|0}function Ow(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(88,a|0,b|0,c|0,d|0)|0}function Pw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(89,a|0,b|0,c|0,d|0)|0}function Qw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(90,a|0,b|0,c|0,d|0)|0}function Rw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(91,a|0,b|0,c|0,d|0)|0}function Sw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(92,a|0,b|0,c|0,d|0)|0}function Tw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(93,a|0,b|0,c|0,d|0)|0}function Uw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(94,a|0,b|0,c|0,d|0)|0}function Vw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(95,a|0,b|0,c|0,d|0)|0}function Ww(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(96,a|0,b|0,c|0,d|0)|0}function Xw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(97,a|0,b|0,c|0,d|0)|0}function Yw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(98,a|0,b|0,c|0,d|0)|0}function Zw(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(99,a|0,b|0,c|0,d|0)|0}function _w(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(100,a|0,b|0,c|0,d|0)|0}function $w(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(101,a|0,b|0,c|0,d|0)|0}function ax(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(102,a|0,b|0,c|0,d|0)|0}function bx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(103,a|0,b|0,c|0,d|0)|0}function cx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(104,a|0,b|0,c|0,d|0)|0}function dx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(105,a|0,b|0,c|0,d|0)|0}function ex(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(106,a|0,b|0,c|0,d|0)|0}function fx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(107,a|0,b|0,c|0,d|0)|0}function gx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(108,a|0,b|0,c|0,d|0)|0}function hx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(109,a|0,b|0,c|0,d|0)|0}function ix(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(110,a|0,b|0,c|0,d|0)|0}function jx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(111,a|0,b|0,c|0,d|0)|0}function kx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(112,a|0,b|0,c|0,d|0)|0}function lx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(113,a|0,b|0,c|0,d|0)|0}function mx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(114,a|0,b|0,c|0,d|0)|0}function nx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(115,a|0,b|0,c|0,d|0)|0}function ox(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(116,a|0,b|0,c|0,d|0)|0}function px(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(117,a|0,b|0,c|0,d|0)|0}function qx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(118,a|0,b|0,c|0,d|0)|0}function rx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(119,a|0,b|0,c|0,d|0)|0}function sx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(120,a|0,b|0,c|0,d|0)|0}function tx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(121,a|0,b|0,c|0,d|0)|0}function ux(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(122,a|0,b|0,c|0,d|0)|0}function vx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(123,a|0,b|0,c|0,d|0)|0}function wx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(124,a|0,b|0,c|0,d|0)|0}function xx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(125,a|0,b|0,c|0,d|0)|0}function yx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(126,a|0,b|0,c|0,d|0)|0}function zx(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return Q(127,a|0,b|0,c|0,d|0)|0}function Ax(a,b,c){a=a|0;b=b|0;c=c|0;Xa[a&255](b|0,c|0)}function Bx(a,b){a=a|0;b=b|0;R(0,a|0,b|0)}function Cx(a,b){a=a|0;b=b|0;R(1,a|0,b|0)}function Dx(a,b){a=a|0;b=b|0;R(2,a|0,b|0)}function Ex(a,b){a=a|0;b=b|0;R(3,a|0,b|0)}function Fx(a,b){a=a|0;b=b|0;R(4,a|0,b|0)}function Gx(a,b){a=a|0;b=b|0;R(5,a|0,b|0)}function Hx(a,b){a=a|0;b=b|0;R(6,a|0,b|0)}function Ix(a,b){a=a|0;b=b|0;R(7,a|0,b|0)}function Jx(a,b){a=a|0;b=b|0;R(8,a|0,b|0)}function Kx(a,b){a=a|0;b=b|0;R(9,a|0,b|0)}function Lx(a,b){a=a|0;b=b|0;R(10,a|0,b|0)}function Mx(a,b){a=a|0;b=b|0;R(11,a|0,b|0)}function Nx(a,b){a=a|0;b=b|0;R(12,a|0,b|0)}function Ox(a,b){a=a|0;b=b|0;R(13,a|0,b|0)}function Px(a,b){a=a|0;b=b|0;R(14,a|0,b|0)}function Qx(a,b){a=a|0;b=b|0;R(15,a|0,b|0)}function Rx(a,b){a=a|0;b=b|0;R(16,a|0,b|0)}function Sx(a,b){a=a|0;b=b|0;R(17,a|0,b|0)}function Tx(a,b){a=a|0;b=b|0;R(18,a|0,b|0)}function Ux(a,b){a=a|0;b=b|0;R(19,a|0,b|0)}function Vx(a,b){a=a|0;b=b|0;R(20,a|0,b|0)}function Wx(a,b){a=a|0;b=b|0;R(21,a|0,b|0)}function Xx(a,b){a=a|0;b=b|0;R(22,a|0,b|0)}function Yx(a,b){a=a|0;b=b|0;R(23,a|0,b|0)}function Zx(a,b){a=a|0;b=b|0;R(24,a|0,b|0)}function _x(a,b){a=a|0;b=b|0;R(25,a|0,b|0)}function $x(a,b){a=a|0;b=b|0;R(26,a|0,b|0)}function ay(a,b){a=a|0;b=b|0;R(27,a|0,b|0)}function by(a,b){a=a|0;b=b|0;R(28,a|0,b|0)}function cy(a,b){a=a|0;b=b|0;R(29,a|0,b|0)}function dy(a,b){a=a|0;b=b|0;R(30,a|0,b|0)}function ey(a,b){a=a|0;b=b|0;R(31,a|0,b|0)}function fy(a,b){a=a|0;b=b|0;R(32,a|0,b|0)}function gy(a,b){a=a|0;b=b|0;R(33,a|0,b|0)}function hy(a,b){a=a|0;b=b|0;R(34,a|0,b|0)}function iy(a,b){a=a|0;b=b|0;R(35,a|0,b|0)}function jy(a,b){a=a|0;b=b|0;R(36,a|0,b|0)}function ky(a,b){a=a|0;b=b|0;R(37,a|0,b|0)}function ly(a,b){a=a|0;b=b|0;R(38,a|0,b|0)}function my(a,b){a=a|0;b=b|0;R(39,a|0,b|0)}function ny(a,b){a=a|0;b=b|0;R(40,a|0,b|0)}function oy(a,b){a=a|0;b=b|0;R(41,a|0,b|0)}function py(a,b){a=a|0;b=b|0;R(42,a|0,b|0)}function qy(a,b){a=a|0;b=b|0;R(43,a|0,b|0)}function ry(a,b){a=a|0;b=b|0;R(44,a|0,b|0)}function sy(a,b){a=a|0;b=b|0;R(45,a|0,b|0)}function ty(a,b){a=a|0;b=b|0;R(46,a|0,b|0)}function uy(a,b){a=a|0;b=b|0;R(47,a|0,b|0)}function vy(a,b){a=a|0;b=b|0;R(48,a|0,b|0)}function wy(a,b){a=a|0;b=b|0;R(49,a|0,b|0)}function xy(a,b){a=a|0;b=b|0;R(50,a|0,b|0)}function yy(a,b){a=a|0;b=b|0;R(51,a|0,b|0)}function zy(a,b){a=a|0;b=b|0;R(52,a|0,b|0)}function Ay(a,b){a=a|0;b=b|0;R(53,a|0,b|0)}function By(a,b){a=a|0;b=b|0;R(54,a|0,b|0)}function Cy(a,b){a=a|0;b=b|0;R(55,a|0,b|0)}function Dy(a,b){a=a|0;b=b|0;R(56,a|0,b|0)}function Ey(a,b){a=a|0;b=b|0;R(57,a|0,b|0)}function Fy(a,b){a=a|0;b=b|0;R(58,a|0,b|0)}function Gy(a,b){a=a|0;b=b|0;R(59,a|0,b|0)}function Hy(a,b){a=a|0;b=b|0;R(60,a|0,b|0)}function Iy(a,b){a=a|0;b=b|0;R(61,a|0,b|0)}function Jy(a,b){a=a|0;b=b|0;R(62,a|0,b|0)}function Ky(a,b){a=a|0;b=b|0;R(63,a|0,b|0)}function Ly(a,b){a=a|0;b=b|0;R(64,a|0,b|0)}function My(a,b){a=a|0;b=b|0;R(65,a|0,b|0)}function Ny(a,b){a=a|0;b=b|0;R(66,a|0,b|0)}function Oy(a,b){a=a|0;b=b|0;R(67,a|0,b|0)}function Py(a,b){a=a|0;b=b|0;R(68,a|0,b|0)}function Qy(a,b){a=a|0;b=b|0;R(69,a|0,b|0)}function Ry(a,b){a=a|0;b=b|0;R(70,a|0,b|0)}function Sy(a,b){a=a|0;b=b|0;R(71,a|0,b|0)}function Ty(a,b){a=a|0;b=b|0;R(72,a|0,b|0)}function Uy(a,b){a=a|0;b=b|0;R(73,a|0,b|0)}function Vy(a,b){a=a|0;b=b|0;R(74,a|0,b|0)}function Wy(a,b){a=a|0;b=b|0;R(75,a|0,b|0)}function Xy(a,b){a=a|0;b=b|0;R(76,a|0,b|0)}function Yy(a,b){a=a|0;b=b|0;R(77,a|0,b|0)}function Zy(a,b){a=a|0;b=b|0;R(78,a|0,b|0)}function _y(a,b){a=a|0;b=b|0;R(79,a|0,b|0)}function $y(a,b){a=a|0;b=b|0;R(80,a|0,b|0)}function az(a,b){a=a|0;b=b|0;R(81,a|0,b|0)}function bz(a,b){a=a|0;b=b|0;R(82,a|0,b|0)}function cz(a,b){a=a|0;b=b|0;R(83,a|0,b|0)}function dz(a,b){a=a|0;b=b|0;R(84,a|0,b|0)}function ez(a,b){a=a|0;b=b|0;R(85,a|0,b|0)}function fz(a,b){a=a|0;b=b|0;R(86,a|0,b|0)}function gz(a,b){a=a|0;b=b|0;R(87,a|0,b|0)}function hz(a,b){a=a|0;b=b|0;R(88,a|0,b|0)}function iz(a,b){a=a|0;b=b|0;R(89,a|0,b|0)}function jz(a,b){a=a|0;b=b|0;R(90,a|0,b|0)}function kz(a,b){a=a|0;b=b|0;R(91,a|0,b|0)}function lz(a,b){a=a|0;b=b|0;R(92,a|0,b|0)}function mz(a,b){a=a|0;b=b|0;R(93,a|0,b|0)}function nz(a,b){a=a|0;b=b|0;R(94,a|0,b|0)}function oz(a,b){a=a|0;b=b|0;R(95,a|0,b|0)}function pz(a,b){a=a|0;b=b|0;R(96,a|0,b|0)}function qz(a,b){a=a|0;b=b|0;R(97,a|0,b|0)}function rz(a,b){a=a|0;b=b|0;R(98,a|0,b|0)}function sz(a,b){a=a|0;b=b|0;R(99,a|0,b|0)}function tz(a,b){a=a|0;b=b|0;R(100,a|0,b|0)}function uz(a,b){a=a|0;b=b|0;R(101,a|0,b|0)}function vz(a,b){a=a|0;b=b|0;R(102,a|0,b|0)}function wz(a,b){a=a|0;b=b|0;R(103,a|0,b|0)}function xz(a,b){a=a|0;b=b|0;R(104,a|0,b|0)}function yz(a,b){a=a|0;b=b|0;R(105,a|0,b|0)}function zz(a,b){a=a|0;b=b|0;R(106,a|0,b|0)}function Az(a,b){a=a|0;b=b|0;R(107,a|0,b|0)}function Bz(a,b){a=a|0;b=b|0;R(108,a|0,b|0)}function Cz(a,b){a=a|0;b=b|0;R(109,a|0,b|0)}function Dz(a,b){a=a|0;b=b|0;R(110,a|0,b|0)}function Ez(a,b){a=a|0;b=b|0;R(111,a|0,b|0)}function Fz(a,b){a=a|0;b=b|0;R(112,a|0,b|0)}function Gz(a,b){a=a|0;b=b|0;R(113,a|0,b|0)}function Hz(a,b){a=a|0;b=b|0;R(114,a|0,b|0)}function Iz(a,b){a=a|0;b=b|0;R(115,a|0,b|0)}function Jz(a,b){a=a|0;b=b|0;R(116,a|0,b|0)}function Kz(a,b){a=a|0;b=b|0;R(117,a|0,b|0)}function Lz(a,b){a=a|0;b=b|0;R(118,a|0,b|0)}function Mz(a,b){a=a|0;b=b|0;R(119,a|0,b|0)}function Nz(a,b){a=a|0;b=b|0;R(120,a|0,b|0)}function Oz(a,b){a=a|0;b=b|0;R(121,a|0,b|0)}function Pz(a,b){a=a|0;b=b|0;R(122,a|0,b|0)}function Qz(a,b){a=a|0;b=b|0;R(123,a|0,b|0)}function Rz(a,b){a=a|0;b=b|0;R(124,a|0,b|0)}function Sz(a,b){a=a|0;b=b|0;R(125,a|0,b|0)}function Tz(a,b){a=a|0;b=b|0;R(126,a|0,b|0)}function Uz(a,b){a=a|0;b=b|0;R(127,a|0,b|0)}function Vz(a){a=a|0;J(0);return 0}function Wz(a,b){a=a|0;b=b|0;J(1);return 0}function Xz(a,b,c){a=a|0;b=b|0;c=c|0;J(2);return 0}function Yz(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;J(3);return 0}function Zz(a,b){a=a|0;b=b|0;J(4)}\n\n// EMSCRIPTEN_END_FUNCS\nvar Ta=[Vz,Yn,Zn,_n,$n,ao,bo,co,eo,fo,go,ho,io,jo,ko,lo,mo,no,oo,po,qo,ro,so,to,uo,vo,wo,xo,yo,zo,Ao,Bo,Co,Do,Eo,Fo,Go,Ho,Io,Jo,Ko,Lo,Mo,No,Oo,Po,Qo,Ro,So,To,Uo,Vo,Wo,Xo,Yo,Zo,_o,$o,ap,bp,cp,dp,ep,fp,gp,hp,ip,jp,kp,lp,mp,np,op,pp,qp,rp,sp,tp,up,vp,wp,xp,yp,zp,Ap,Bp,Cp,Dp,Ep,Fp,Gp,Hp,Ip,Jp,Kp,Lp,Mp,Np,Op,Pp,Qp,Rp,Sp,Tp,Up,Vp,Wp,Xp,Yp,Zp,_p,$p,aq,bq,cq,dq,eq,fq,gq,hq,iq,jq,kq,lq,mq,nq,oq,pq,qq,lg,mg,mh,nh,oh,ph,qh,rh,sh,th,uh,vh,wh,xh,yh,zh,Ah,Bh,Ch,Dh,Eh,Fh,Gh,Hh,Oh,Ph,Qh,Rh,Sh,Th,Uh,Vh,Wh,Xh,Yh,Zh,$h,ai,bi,ci,di,ei,ii,ji,ki,li,mi,ni,oi,pi,qi,ri,si,ti,ui,vi,wi,xi,Bi,Pi,Qi,Ri,Si,Ti,Ui,Vi,Wi,Xi,Yi,Ci,Di,Ei,Fi,Gi,Hi,Ii,Ji,bj,cj,dj,ej,fj,gj,hj,ij,jj,kj,lj,mj,nj,oj,pj,qj,rj,sj,tj,uj,vj,wj,xj,yj,zj,Aj,Bj,Cj,Ej,Fj,Gj,Hj,Ij,Jj,Kj,Lj,Mj,Nj,Oj,Qj,Rj,Sj,Tj,Uj,Vj,Wj,Xj,Yj,Zj,_j,$j,ak,bk,jk,kk,lk,mk,nk,ok,pk,Ek,Fk,Gk,zk,Ak,Mk,ig,lh,sk,_h,ik,zi,Dj,Pj,Nh,aj,hi,kg,Mh,Lh,Ih,fi,Ai,Oi,Zi,_i,gk,tk,uk,vk,wk,xk,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz,Vz];var Ua=[Wz,sq,tq,uq,vq,wq,xq,yq,zq,Aq,Bq,Cq,Dq,Eq,Fq,Gq,Hq,Iq,Jq,Kq,Lq,Mq,Nq,Oq,Pq,Qq,Rq,Sq,Tq,Uq,Vq,Wq,Xq,Yq,Zq,_q,$q,ar,br,cr,dr,er,fr,gr,hr,ir,jr,kr,lr,mr,nr,or,pr,qr,rr,sr,tr,ur,vr,wr,xr,yr,zr,Ar,Br,Cr,Dr,Er,Fr,Gr,Hr,Ir,Jr,Kr,Lr,Mr,Nr,Or,Pr,Qr,Rr,Sr,Tr,Ur,Vr,Wr,Xr,Yr,Zr,_r,$r,as,bs,cs,ds,es,fs,gs,hs,is,js,ks,ls,ms,ns,os,ps,qs,rs,ss,ts,us,vs,ws,xs,ys,zs,As,Bs,Cs,Ds,Es,Fs,Gs,Hs,Is,Js,Ks,Ls,se,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz,Wz];var Va=[Xz,Ns,Os,Ps,Qs,Rs,Ss,Ts,Us,Vs,Ws,Xs,Ys,Zs,_s,$s,at,bt,ct,dt,et,ft,gt,ht,it,jt,kt,lt,mt,nt,ot,pt,qt,rt,st,tt,ut,vt,wt,xt,yt,zt,At,Bt,Ct,Dt,Et,Ft,Gt,Ht,It,Jt,Kt,Lt,Mt,Nt,Ot,Pt,Qt,Rt,St,Tt,Ut,Vt,Wt,Xt,Yt,Zt,_t,$t,au,bu,cu,du,eu,fu,gu,hu,iu,ju,ku,lu,mu,nu,ou,pu,qu,ru,su,tu,uu,vu,wu,xu,yu,zu,Au,Bu,Cu,Du,Eu,Fu,Gu,Hu,Iu,Ju,Ku,Lu,Mu,Nu,Ou,Pu,Qu,Ru,Su,Tu,Uu,Vu,Wu,Xu,Yu,Zu,_u,$u,av,bv,cv,dv,ev,Nk,Ok,Tk,Rk,vl,Uf,Wf,Kh,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz,Xz];var Wa=[Yz,gv,hv,iv,jv,kv,lv,mv,nv,ov,pv,qv,rv,sv,tv,uv,vv,wv,xv,yv,zv,Av,Bv,Cv,Dv,Ev,Fv,Gv,Hv,Iv,Jv,Kv,Lv,Mv,Nv,Ov,Pv,Qv,Rv,Sv,Tv,Uv,Vv,Wv,Xv,Yv,Zv,_v,$v,aw,bw,cw,dw,ew,fw,gw,hw,iw,jw,kw,lw,mw,nw,ow,pw,qw,rw,sw,tw,uw,vw,ww,xw,yw,zw,Aw,Bw,Cw,Dw,Ew,Fw,Gw,Hw,Iw,Jw,Kw,Lw,Mw,Nw,Ow,Pw,Qw,Rw,Sw,Tw,Uw,Vw,Ww,Xw,Yw,Zw,_w,$w,ax,bx,cx,dx,ex,fx,gx,hx,ix,jx,kx,lx,mx,nx,ox,px,qx,rx,sx,tx,ux,vx,wx,xx,yx,zx,hg,hk,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz,Yz];var Xa=[Zz,Bx,Cx,Dx,Ex,Fx,Gx,Hx,Ix,Jx,Kx,Lx,Mx,Nx,Ox,Px,Qx,Rx,Sx,Tx,Ux,Vx,Wx,Xx,Yx,Zx,_x,$x,ay,by,cy,dy,ey,fy,gy,hy,iy,jy,ky,ly,my,ny,oy,py,qy,ry,sy,ty,uy,vy,wy,xy,yy,zy,Ay,By,Cy,Dy,Ey,Fy,Gy,Hy,Iy,Jy,Ky,Ly,My,Ny,Oy,Py,Qy,Ry,Sy,Ty,Uy,Vy,Wy,Xy,Yy,Zy,_y,$y,az,bz,cz,dz,ez,fz,gz,hz,iz,jz,kz,lz,mz,nz,oz,pz,qz,rz,sz,tz,uz,vz,wz,xz,yz,zz,Az,Bz,Cz,Dz,Ez,Fz,Gz,Hz,Iz,Jz,Kz,Lz,Mz,Nz,Oz,Pz,Qz,Rz,Sz,Tz,Uz,bb,fc,Tc,Uc,Zc,Bd,te,yi,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz,Zz];return{___emscripten_environ_constructor:Bn,___muldi3:Hn,___udivdi3:Mn,__get_daylight:Dn,__get_environ:Fn,__get_timezone:En,__get_tzname:Cn,_bitshift64Ashr:Nn,_bitshift64Lshr:On,_bitshift64Shl:Pn,_emscripten_replace_memory:Sa,_free:Ik,_i64Add:In,_i64Subtract:Jn,_llvm_bswap_i32:Qn,_luaL_getmetafield:Xf,_luaL_loadbufferx:Vf,_luaL_newstate:gg,_luaL_openlibs:jg,_lua_close:ve,_lua_createtable:Ub,_lua_getglobal:Pb,_lua_gettop:gb,_lua_iscfunction:pb,_lua_next:lc,_lua_pcallk:ec,_lua_pushboolean:Mb,_lua_pushcclosure:Lb,_lua_pushnil:Db,_lua_pushnumber:Eb,_lua_pushstring:Ib,_lua_pushvalue:mb,_lua_rawget:Sb,_lua_rawlen:zb,_lua_rawset:_b,_lua_setglobal:Xb,_lua_setmetatable:ac,_lua_settop:hb,_lua_toboolean:xb,_lua_tolstring:yb,_lua_tonumberx:ub,_lua_topointer:Cb,_lua_type:nb,_lua_typename:ob,_malloc:Hk,_memcpy:Un,_memset:Vn,_realloc:Jk,_saveSetjmp:Rn,_sbrk:Wn,_setThrew:Tn,_testSetjmp:Sn,dynCall_ii:Xn,dynCall_iii:rq,dynCall_iiii:Ms,dynCall_iiiii:fv,dynCall_vii:Ax,establishStackSpace:$a,stackAlloc:Ya,stackRestore:_a,stackSave:Za}})\n\n\n// EMSCRIPTEN_END_ASM\n(asmGlobalArg, asmLibraryArg, buffer);\n\nvar ___emscripten_environ_constructor = Module[\"___emscripten_environ_constructor\"] = asm[\"___emscripten_environ_constructor\"];\n\nvar ___muldi3 = Module[\"___muldi3\"] = asm[\"___muldi3\"];\n\nvar ___udivdi3 = Module[\"___udivdi3\"] = asm[\"___udivdi3\"];\n\nvar __get_daylight = Module[\"__get_daylight\"] = asm[\"__get_daylight\"];\n\nvar __get_environ = Module[\"__get_environ\"] = asm[\"__get_environ\"];\n\nvar __get_timezone = Module[\"__get_timezone\"] = asm[\"__get_timezone\"];\n\nvar __get_tzname = Module[\"__get_tzname\"] = asm[\"__get_tzname\"];\n\nvar _bitshift64Ashr = Module[\"_bitshift64Ashr\"] = asm[\"_bitshift64Ashr\"];\n\nvar _bitshift64Lshr = Module[\"_bitshift64Lshr\"] = asm[\"_bitshift64Lshr\"];\n\nvar _bitshift64Shl = Module[\"_bitshift64Shl\"] = asm[\"_bitshift64Shl\"];\n\nvar _emscripten_replace_memory = Module[\"_emscripten_replace_memory\"] = asm[\"_emscripten_replace_memory\"];\n\nvar _free = Module[\"_free\"] = asm[\"_free\"];\n\nvar _i64Add = Module[\"_i64Add\"] = asm[\"_i64Add\"];\n\nvar _i64Subtract = Module[\"_i64Subtract\"] = asm[\"_i64Subtract\"];\n\nvar _llvm_bswap_i32 = Module[\"_llvm_bswap_i32\"] = asm[\"_llvm_bswap_i32\"];\n\nvar _luaL_getmetafield = Module[\"_luaL_getmetafield\"] = asm[\"_luaL_getmetafield\"];\n\nvar _luaL_loadbufferx = Module[\"_luaL_loadbufferx\"] = asm[\"_luaL_loadbufferx\"];\n\nvar _luaL_newstate = Module[\"_luaL_newstate\"] = asm[\"_luaL_newstate\"];\n\nvar _luaL_openlibs = Module[\"_luaL_openlibs\"] = asm[\"_luaL_openlibs\"];\n\nvar _lua_close = Module[\"_lua_close\"] = asm[\"_lua_close\"];\n\nvar _lua_createtable = Module[\"_lua_createtable\"] = asm[\"_lua_createtable\"];\n\nvar _lua_getglobal = Module[\"_lua_getglobal\"] = asm[\"_lua_getglobal\"];\n\nvar _lua_gettop = Module[\"_lua_gettop\"] = asm[\"_lua_gettop\"];\n\nvar _lua_iscfunction = Module[\"_lua_iscfunction\"] = asm[\"_lua_iscfunction\"];\n\nvar _lua_next = Module[\"_lua_next\"] = asm[\"_lua_next\"];\n\nvar _lua_pcallk = Module[\"_lua_pcallk\"] = asm[\"_lua_pcallk\"];\n\nvar _lua_pushboolean = Module[\"_lua_pushboolean\"] = asm[\"_lua_pushboolean\"];\n\nvar _lua_pushcclosure = Module[\"_lua_pushcclosure\"] = asm[\"_lua_pushcclosure\"];\n\nvar _lua_pushnil = Module[\"_lua_pushnil\"] = asm[\"_lua_pushnil\"];\n\nvar _lua_pushnumber = Module[\"_lua_pushnumber\"] = asm[\"_lua_pushnumber\"];\n\nvar _lua_pushstring = Module[\"_lua_pushstring\"] = asm[\"_lua_pushstring\"];\n\nvar _lua_pushvalue = Module[\"_lua_pushvalue\"] = asm[\"_lua_pushvalue\"];\n\nvar _lua_rawget = Module[\"_lua_rawget\"] = asm[\"_lua_rawget\"];\n\nvar _lua_rawlen = Module[\"_lua_rawlen\"] = asm[\"_lua_rawlen\"];\n\nvar _lua_rawset = Module[\"_lua_rawset\"] = asm[\"_lua_rawset\"];\n\nvar _lua_setglobal = Module[\"_lua_setglobal\"] = asm[\"_lua_setglobal\"];\n\nvar _lua_setmetatable = Module[\"_lua_setmetatable\"] = asm[\"_lua_setmetatable\"];\n\nvar _lua_settop = Module[\"_lua_settop\"] = asm[\"_lua_settop\"];\n\nvar _lua_toboolean = Module[\"_lua_toboolean\"] = asm[\"_lua_toboolean\"];\n\nvar _lua_tolstring = Module[\"_lua_tolstring\"] = asm[\"_lua_tolstring\"];\n\nvar _lua_tonumberx = Module[\"_lua_tonumberx\"] = asm[\"_lua_tonumberx\"];\n\nvar _lua_topointer = Module[\"_lua_topointer\"] = asm[\"_lua_topointer\"];\n\nvar _lua_type = Module[\"_lua_type\"] = asm[\"_lua_type\"];\n\nvar _lua_typename = Module[\"_lua_typename\"] = asm[\"_lua_typename\"];\n\nvar _malloc = Module[\"_malloc\"] = asm[\"_malloc\"];\n\nvar _memcpy = Module[\"_memcpy\"] = asm[\"_memcpy\"];\n\nvar _memset = Module[\"_memset\"] = asm[\"_memset\"];\n\nvar _realloc = Module[\"_realloc\"] = asm[\"_realloc\"];\n\nvar _saveSetjmp = Module[\"_saveSetjmp\"] = asm[\"_saveSetjmp\"];\n\nvar _sbrk = Module[\"_sbrk\"] = asm[\"_sbrk\"];\n\nvar _setThrew = Module[\"_setThrew\"] = asm[\"_setThrew\"];\n\nvar _testSetjmp = Module[\"_testSetjmp\"] = asm[\"_testSetjmp\"];\n\nvar establishStackSpace = Module[\"establishStackSpace\"] = asm[\"establishStackSpace\"];\n\nvar stackAlloc = Module[\"stackAlloc\"] = asm[\"stackAlloc\"];\n\nvar stackRestore = Module[\"stackRestore\"] = asm[\"stackRestore\"];\n\nvar stackSave = Module[\"stackSave\"] = asm[\"stackSave\"];\n\nvar dynCall_ii = Module[\"dynCall_ii\"] = asm[\"dynCall_ii\"];\n\nvar dynCall_iii = Module[\"dynCall_iii\"] = asm[\"dynCall_iii\"];\n\nvar dynCall_iiii = Module[\"dynCall_iiii\"] = asm[\"dynCall_iiii\"];\n\nvar dynCall_iiiii = Module[\"dynCall_iiiii\"] = asm[\"dynCall_iiiii\"];\n\nvar dynCall_vii = Module[\"dynCall_vii\"] = asm[\"dynCall_vii\"];\n\nModule[\"asm\"] = asm;\n\nif (memoryInitializer) {\n if (!isDataURI(memoryInitializer)) {\n  memoryInitializer = locateFile(memoryInitializer);\n }\n if (ENVIRONMENT_IS_NODE || ENVIRONMENT_IS_SHELL) {\n  var data = Module[\"readBinary\"](memoryInitializer);\n  HEAPU8.set(data, GLOBAL_BASE);\n } else {\n  addRunDependency(\"memory initializer\");\n  var applyMemoryInitializer = function(data) {\n   if (data.byteLength) data = new Uint8Array(data);\n   HEAPU8.set(data, GLOBAL_BASE);\n   if (Module[\"memoryInitializerRequest\"]) delete Module[\"memoryInitializerRequest\"].response;\n   removeRunDependency(\"memory initializer\");\n  };\n  var doBrowserLoad = function() {\n   Module[\"readAsync\"](memoryInitializer, applyMemoryInitializer, function() {\n    throw \"could not load memory initializer \" + memoryInitializer;\n   });\n  };\n  var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);\n  if (memoryInitializerBytes) {\n   applyMemoryInitializer(memoryInitializerBytes.buffer);\n  } else if (Module[\"memoryInitializerRequest\"]) {\n   var useRequest = function() {\n    var request = Module[\"memoryInitializerRequest\"];\n    var response = request.response;\n    if (request.status !== 200 && request.status !== 0) {\n     var data = tryParseAsDataURI(Module[\"memoryInitializerRequestURL\"]);\n     if (data) {\n      response = data.buffer;\n     } else {\n      console.warn(\"a problem seems to have happened with Module.memoryInitializerRequest, status: \" + request.status + \", retrying \" + memoryInitializer);\n      doBrowserLoad();\n      return;\n     }\n    }\n    applyMemoryInitializer(response);\n   };\n   if (Module[\"memoryInitializerRequest\"].response) {\n    setTimeout(useRequest, 0);\n   } else {\n    Module[\"memoryInitializerRequest\"].addEventListener(\"load\", useRequest);\n   }\n  } else {\n   doBrowserLoad();\n  }\n }\n}\n\nfunction ExitStatus(status) {\n this.name = \"ExitStatus\";\n this.message = \"Program terminated with exit(\" + status + \")\";\n this.status = status;\n}\n\nExitStatus.prototype = new Error();\n\nExitStatus.prototype.constructor = ExitStatus;\n\ndependenciesFulfilled = function runCaller() {\n if (!Module[\"calledRun\"]) run();\n if (!Module[\"calledRun\"]) dependenciesFulfilled = runCaller;\n};\n\nfunction run(args) {\n args = args || Module[\"arguments\"];\n if (runDependencies > 0) {\n  return;\n }\n preRun();\n if (runDependencies > 0) return;\n if (Module[\"calledRun\"]) return;\n function doRun() {\n  if (Module[\"calledRun\"]) return;\n  Module[\"calledRun\"] = true;\n  if (ABORT) return;\n  ensureInitRuntime();\n  preMain();\n  if (Module[\"onRuntimeInitialized\"]) Module[\"onRuntimeInitialized\"]();\n  postRun();\n }\n if (Module[\"setStatus\"]) {\n  Module[\"setStatus\"](\"Running...\");\n  setTimeout(function() {\n   setTimeout(function() {\n    Module[\"setStatus\"](\"\");\n   }, 1);\n   doRun();\n  }, 1);\n } else {\n  doRun();\n }\n}\n\nModule[\"run\"] = run;\n\nfunction exit(status, implicit) {\n if (implicit && Module[\"noExitRuntime\"] && status === 0) {\n  return;\n }\n if (Module[\"noExitRuntime\"]) {} else {\n  ABORT = true;\n  EXITSTATUS = status;\n  exitRuntime();\n  if (Module[\"onExit\"]) Module[\"onExit\"](status);\n }\n Module[\"quit\"](status, new ExitStatus(status));\n}\n\nfunction abort(what) {\n if (Module[\"onAbort\"]) {\n  Module[\"onAbort\"](what);\n }\n if (what !== undefined) {\n  out(what);\n  err(what);\n  what = JSON.stringify(what);\n } else {\n  what = \"\";\n }\n ABORT = true;\n EXITSTATUS = 1;\n throw \"abort(\" + what + \"). Build with -s ASSERTIONS=1 for more info.\";\n}\n\nModule[\"abort\"] = abort;\n\nif (Module[\"preInit\"]) {\n if (typeof Module[\"preInit\"] == \"function\") Module[\"preInit\"] = [ Module[\"preInit\"] ];\n while (Module[\"preInit\"].length > 0) {\n  Module[\"preInit\"].pop()();\n }\n}\n\nModule[\"noExitRuntime\"] = true;\n\nrun();\n\nvar FUNCTION_TABLE = [];\n\nvar Lua = {\n isRun: false,\n isInitialized: false,\n state: null,\n tmp_id: 0,\n errorHandlerCallback: null,\n default_source_name: \"stdin\",\n preallocated_strings: {\n  \"__handle\": null,\n  \"__index\": null\n },\n js_string_to_lua: function jsStringToLua(str) {\n  return intArrayFromString(str);\n },\n lua_string_to_js: function luaStringToJs(int8array) {\n  return decodeURIComponent(escape(intArrayToString(int8array)));\n },\n set_js_string_to_lua: function setJsStringToLua(f) {\n  this.js_string_to_lua = f;\n },\n set_lua_string_to_js: function setLuaStringToJs(f) {\n  this.lua_string_to_js = f;\n },\n initialize: function initialize(sourceName, stdout, stderr) {\n  if (this.isInitialized) throw new Error(\"Lua already initialized\");\n  this.default_source_name = sourceName || this.default_source_name;\n  this.stdout = stdout || this.stdout;\n  this.stderr = stderr || this.stderr;\n  if (!this.isRun) {\n   run();\n   this.isRun = true;\n  }\n  this.state = _luaL_newstate();\n  _luaL_openlibs(this.state);\n  for (var key in this.preallocated_strings) {\n   if (this.preallocated_strings.hasOwnProperty(key)) {\n    this.preallocated_strings[key] = this.allocate_string(key);\n   }\n  }\n  this.isInitialized = true;\n },\n destroy: function destroy() {\n  if (!this.isInitialized) throw new Error(\"Lua is not initialized\");\n  _lua_close(this.state);\n  for (var i = 0; i < functionPointers.length; i++) {\n   functionPointers[i] = null;\n  }\n  this.isInitialized = false;\n },\n require_initialization: function requireInitialization() {\n  if (!this.isInitialized) throw new Error(\"Lua not yet initialized\");\n },\n parse: function parse(command, sourceName) {\n  this.require_initialization();\n  var commandArray = this.js_string_to_lua(command);\n  var commandPtr = allocate(commandArray, \"i8\", 0);\n  var namePtr = this.allocate_string(sourceName);\n  var parseFailed = _luaL_loadbufferx(this.state, commandPtr, commandArray.length - 1, namePtr);\n  if (parseFailed) {\n   this.report_error(\"Parsing failure\");\n  }\n  _free(commandPtr);\n  _free(namePtr);\n  return !parseFailed;\n },\n eval: function luaEval(command, sourceName, source) {\n  return this.exec(\"return \" + command, sourceName || this.default_source_name, source || command);\n },\n exec: function luaExec(command, sourceName) {\n  this.require_initialization();\n  var src = sourceName || this.default_source_name;\n  if (this.parse(command, src)) {\n   var callFailed = _lua_pcallk(this.state, 0, -1, 0);\n   if (callFailed) {\n    this.report_error(\"Evaluation failure\");\n   } else {\n    return this.get_stack_args();\n   }\n  } else {\n   this.report_error(\"Parsing failure\");\n  }\n  return null;\n },\n inject: function luaInject(object, injName, finalLocation, metatable) {\n  var name = injName || this.get_tmp_name();\n  this.pushStack(object);\n  if (metatable) {\n   this.pushStack(metatable);\n   _lua_setmetatable(this.state, -2);\n  }\n  var strptr = this.allocate_string(name);\n  _lua_setglobal(this.state, strptr);\n  _free(strptr);\n  if (finalLocation) {\n   this.exec(finalLocation + \" = \" + name + \"\\n\" + name + \" = nil\");\n  }\n  return finalLocation || name;\n },\n cache: function luaCache(evalstring) {\n  if (!(evalstring in this.cache.items)) {\n   this.cache.items[evalstring] = this.eval(evalstring);\n  }\n  return this.cache.items[evalstring];\n },\n call: function luaCall(evalstring, args) {\n  var func = this.cache(evalstring)[0];\n  return func.apply(null, args);\n },\n allocate_string: function allocateString(str) {\n  var arr = this.js_string_to_lua(str);\n  return allocate(arr, \"i8\", 0);\n },\n inspect: function luaInspect(index) {\n  var type = _lua_type(this.state, index);\n  var ptr = _lua_typename(this.state, type);\n  var typename = Pointer_stringify(ptr);\n  var address = _lua_topointer(this.state, index);\n  return {\n   \"type\": type,\n   \"typename\": typename,\n   \"address\": address,\n   \"addrstr\": address.toString(16)\n  };\n },\n peekStack: function peekStack(index, source) {\n  this.require_initialization();\n  var ret;\n  var ptr;\n  var type = _lua_type(this.state, index);\n  switch (type) {\n  case -1:\n  case 0:\n   ret = null;\n   break;\n\n  case 1:\n   var result = _lua_toboolean(this.state, index);\n   ret = result ? true : false;\n   break;\n\n  case 3:\n   ret = _lua_tonumberx(this.state, index);\n   break;\n\n  case 4:\n   ptr = _lua_tolstring(this.state, index, 0);\n   var len = _lua_rawlen(this.state, index);\n   ret = this.lua_string_to_js(HEAPU8.subarray(ptr, ptr + len));\n   break;\n\n  case 5:\n   var isArray = true;\n   var maxKey = 0;\n   _lua_pushstring(this.state, this.preallocated_strings.__handle);\n   _lua_rawget(this.state, index - 1);\n   var handle = this.popStack();\n   if (handle) {\n    ptr = this.preallocated_strings.__index;\n    _luaL_getmetafield(this.state, index, ptr);\n    var __indexfunc = this.popStack();\n    return __indexfunc.source;\n   }\n   ret = {};\n   _lua_pushnil(this.state);\n   _lua_pushnil(this.state);\n   while (_lua_next(this.state, index - 2)) {\n    var value = this.popStack();\n    var key = this.peekStack(-1);\n    ret[key] = value;\n    if (isArray && typeof key === \"number\") {\n     if (key > maxKey) {\n      maxKey = key;\n     }\n    } else {\n     isArray = false;\n    }\n   }\n   this.popStack();\n   if (isArray) {\n    var newret = [];\n    for (var i = 1; i <= maxKey; i++) {\n     if (typeof ret[i] === \"undefined\") {\n      isArray = false;\n      break;\n     }\n     newret.push(ret[i]);\n    }\n    if (isArray) {\n     ret = newret;\n    }\n   }\n   break;\n\n  case 6:\n   var self = this;\n   var address = _lua_topointer(this.state, index);\n   if (_lua_iscfunction(this.state, index)) {\n    var func = FUNCTION_TABLE[address];\n    if (func.unwrapped) {\n     return func.unwrapped;\n    }\n   }\n   var name = this.get_tmp_name();\n   var aname = this.allocate_string(name);\n   _lua_pushvalue(this.state, index);\n   _lua_setglobal(this.state, aname);\n   _free(aname);\n   ret = function retfn() {\n    var origTop = _lua_gettop(self.state);\n    var afname = self.allocate_string(name);\n    _lua_getglobal(self.state, afname);\n    _free(afname);\n    for (var j = 0; j < arguments.length; j++) {\n     self.pushStack(arguments[j]);\n    }\n    var failure = _lua_pcallk(self.state, arguments.length, -1, 0);\n    if (failure) {\n     self.report_error(\"Failure calling Lua function\");\n    }\n    var numArgs = _lua_gettop(self.state) - origTop;\n    return self.get_stack_args(numArgs);\n   };\n   var src = source || \"\";\n   ret.toString = function toString() {\n    return \"Lua function \" + src + \": \" + name + \" at \" + address;\n   };\n   ret.source = src;\n   ret.name = name;\n   ret.address = address;\n   break;\n\n  default:\n   var inspection = this.inspect(index);\n   ret = inspection.typename + \" (typecode \" + type + \"): 0x\" + inspection.addrstr;\n  }\n  return ret;\n },\n popStack: function popStack(source) {\n  var ret = this.peekStack(-1, source);\n  _lua_settop(this.state, -2);\n  return ret;\n },\n pushStack: function pushStack(obj) {\n  var object = obj;\n  if (object === null) {\n   object = undefined;\n  }\n  switch (typeof object) {\n  case \"undefined\":\n   _lua_pushnil(this.state);\n   return 1;\n\n  case \"boolean\":\n   _lua_pushboolean(this.state, object);\n   return 1;\n\n  case \"number\":\n   _lua_pushnumber(this.state, object);\n   return 1;\n\n  case \"string\":\n   var strptr = this.allocate_string(object);\n   _lua_pushstring(this.state, strptr);\n   _free(strptr);\n   return 1;\n\n  case \"function\":\n   var self = this;\n   var wrapper = function wrapperFn() {\n    var result = object.apply(self, self.get_stack_args());\n    if (typeof result === \"undefined\" || result === null) {\n     result = [];\n    }\n    if (!(typeof result === \"object\" && typeof result.length === \"number\")) {\n     throw new Error(\"Expected array return type from JS function\");\n    }\n    for (var i = 0; i < result.length; i++) {\n     self.pushStack(result[i]);\n    }\n    return result.length;\n   };\n   wrapper.unwrapped = object;\n   var pointer = addFunction(wrapper);\n   FUNCTION_TABLE[pointer] = wrapper;\n   _lua_pushcclosure(this.state, pointer, 0);\n   return 1;\n\n  case \"object\":\n   if (typeof object.length === \"undefined\") {\n    _lua_createtable(this.state, 0, 0);\n    if (object.__handle) {\n     var source = object;\n     var metatable = {\n      \"__index\": function __index(table, key) {\n       return [ source[key] ];\n      },\n      \"__newindex\": function __newindex(table, key, value) {\n       source[key] = value;\n       return [];\n      }\n     };\n     metatable.__index.source = source;\n     this.pushStack(metatable);\n     _lua_setmetatable(this.state, -2);\n     object = {\n      \"__handle\": object.toString()\n     };\n    }\n    for (var k in object) {\n     if (object.hasOwnProperty(k)) {\n      this.pushStack(k);\n      this.pushStack(object[k]);\n      _lua_rawset(this.state, -3);\n     }\n    }\n   } else {\n    _lua_createtable(this.state, object.length, 0);\n    for (var kx in object) {\n     if (object.hasOwnProperty(kx)) {\n      kx = 1 * kx;\n      this.pushStack(kx + 1);\n      this.pushStack(object[kx]);\n      _lua_rawset(this.state, -3);\n     }\n    }\n   }\n   return 1;\n\n  default:\n   throw new Error(\"Cannot push object to stack: \" + object);\n  }\n },\n get_stack_args: function getStackArgs(numArgs) {\n  var num = typeof numArgs === \"undefined\" ? _lua_gettop(this.state) : numArgs;\n  var args = [];\n  for (var i = 0; i < num; i++) {\n   args.push(this.popStack());\n  }\n  return args.reverse();\n },\n anon_lua_object: function anonLuaObject(object) {\n  if (typeof object === \"undefined\" || object === null) {\n   return \"nil\";\n  }\n  switch (typeof object) {\n  case \"string\":\n   return '\"' + object.replace('\"', '\\\\\"') + '\"';\n\n  case \"function\":\n  case \"object\":\n   return this.inject(object);\n\n  default:\n   return object.toString();\n  }\n },\n get_tmp_name: function getTmpName() {\n  return \"_weblua_tmp_\" + this.tmp_id++;\n },\n cleanup_tmp: function cleanupTmp(name) {\n  if (name === \"_weblua_tmp_\" + (this.tmp_id - 1)) {\n   this.tmp_id--;\n  }\n  _lua_pushnil(this.state);\n  var strptr = this.allocate_string(name);\n  _lua_setglobal(this.state, strptr);\n  _free(strptr);\n },\n stdout: function luaStdout(str) {\n  console.log(\"stdout: \" + str);\n },\n stderr: function luaStderr(str) {\n  console.log(\"stderr: \" + str);\n  if (this.errorHandlerCallback) {\n   this.errorHandlerCallback(str);\n  }\n },\n report_error: function reportError(defaultMessage) {\n  if (this.isInitialized) {\n   var errorMessage = this.popStack();\n   if (!(errorMessage && errorMessage.length)) errorMessage = defaultMessage;\n   this.stderr(errorMessage);\n  } else {\n   this.stderr(defaultMessage);\n  }\n  _lua_settop(this.state, 0);\n },\n set_error_callback: function setErrorCallback(cb) {\n  this.errorHandlerCallback = cb;\n }\n};\n\nwindow[\"Lua\"] = Lua;\n\nwindow[\"Lua\"][\"initialize\"] = Lua.initialize;\n\nwindow[\"Lua\"][\"destroy\"] = Lua.destroy;\n\nwindow[\"Lua\"][\"stdout\"] = Lua.stdout;\n\nwindow[\"Lua\"][\"stderr\"] = Lua.stderr;\n\nwindow[\"Lua\"][\"eval\"] = Lua.eval;\n\nwindow[\"Lua\"][\"exec\"] = Lua.exec;\n\nwindow[\"Lua\"][\"anon_lua_object\"] = Lua.anon_lua_object;\n\nwindow[\"Lua\"][\"inject\"] = Lua.inject;\n\nwindow[\"Lua\"][\"cache\"] = Lua.cache;\n\nwindow[\"Lua\"][\"set_js_string_to_lua\"] = Lua.set_js_string_to_lua;\n\nwindow[\"Lua\"][\"set_lua_string_to_js\"] = Lua.set_lua_string_to_js;\n\nwindow[\"Lua\"][\"set_error_callback\"] = Lua.set_error_callback;\n\nwindow[\"Lua\"][\"cache\"][\"items\"] = {};\n\nwindow[\"Lua\"][\"cache\"][\"clear\"] = function luaClearCache(evalstring) {\n delete Lua.cache[\"items\"][evalstring];\n};\n\n})();"

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<div id=\"stead-container\">\n    <div id=\"instead--menu\">\n        <div id=\"instead--menu-content\">\n            <div id=\"instead--game-details\"></div>\n            <a href=\"\" id=\"instead--menu-back\" data-action=\"back\"></a>\n            <a href=\"\" id=\"instead--menu-save\" data-action=\"menu-save\"></a>\n            <a href=\"\" id=\"instead--menu-load\" data-action=\"menu-load\"></a>\n            <a href=\"\" id=\"instead--menu-reset\" data-action=\"reset\"></a>\n            <a href=\"\" id=\"instead--menu-mute\" data-action=\"mute\"></a>\n            <a href=\"\" id=\"instead--menu-export\" data-action=\"menu-export\"></a>\n            <a href=\"\" id=\"instead--menu-export-log\" data-action=\"export-log\"></a>\n        </div>\n        <div id=\"instead--menu-saveload\">\n        </div>\n    </div>\n    <div id=\"stead-toolbar\">\n        <div id=\"stead-toolbar-info\"></div>\n        <div id=\"stead-toolbar-buttons\">\n            <button id=\"toolbar-mute\"></button>\n            <button id=\"toolbar-log\">&#128196;</button>\n            <button id=\"toolbar-menu\">&#9776;</button>\n        </div>\n    </div>\n    <div id=\"stead\">\n        <div id=\"win\">\n            <div id=\"title\"></div>\n            <div id=\"picture\"></div>\n            <div id=\"ways-top\"></div>\n            <div id=\"instead--text\"></div>\n            <div id=\"ways-bottom\"></div>\n        </div>\n        <div id=\"inventory\"></div>\n        <div id=\"menu_button\"><img id=\"menu_image\"></img></div>\n    </div>\n    <div id=\"instead--log\"></div>\n</div>\n"

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12)


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(62)


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Stream = (function (){
  try {
    return __webpack_require__(24); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = __webpack_require__(63);
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(34);
exports.Duplex = __webpack_require__(12);
exports.Transform = __webpack_require__(33);
exports.PassThrough = __webpack_require__(62);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(33)


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(34)


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(5)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript !== "undefined")
		execScript(src);
	else
		eval.call(null, src);
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139)(__webpack_require__(131))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(17)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(141);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 144 */
/***/ (function(module, exports) {

function ajaxGet(sQuery, callback, bSynchronous) {
    var bAsync = true;
    if (bSynchronous) {
        bAsync = false;
    }
    var client = new XMLHttpRequest();
    client.onreadystatechange = function callbackHandler() {
        if (this.readyState === this.DONE) {
            if (this.status === 200) {
                callback(this.responseText);
            } else {
                callback(null, this.status);
            }
        }
    };
    client.open('GET', sQuery, bAsync);
    client.send();
}

function ajaxGetSync(url) {
    var data;
    ajaxGet(url, function loadCallback(response) {
        data = response;
    }, true);
    return data;
}

module.exports = ajaxGetSync;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Logger = __webpack_require__(19);
var HTMLAudio = {
    track: null,
    audio: null,
    isMuted: false,
    playMusic: function play(track, loop, onEndCallback) {
        if (!track.match(/(mp3|ogg|wav)$/) && !track.match(/^blob:/)) {
            console.log('Unsupported music format:' + track); // eslint-disable-line no-console
            Logger.log('{warning} Unsupported music format:' + track); // eslint-disable-line no-console
            return;
        }
        if (track !== this.track) {
            // stop previous music
            this.stopMusic();
            // start new track
            this.audio = new Audio(track);
            this.track = track;
            this.audio.autoplay = true;
            this.audio.muted = this.isMuted;
            this.play(this.audio, loop);
            this.audio.addEventListener('ended', function cb() {
                onEndCallback(track);
            });
        }
    },
    stopMusic: function stop() {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
            this.track = null;
        }
    },
    playSound: function playSound(track, loop, cache) {
        var audio = new Audio(track);
        audio.muted = this.isMuted;
        if (cache) {
            audio.muted = true;
        }
        this.play(audio, loop);
    },
    play: function play(audio, loop) {
        if (loop === 0) {
            audio.addEventListener('ended', function restartAudio() {
                this.currentTime = 0;
                this.play();
            }, false);
            audio.play();
        } else if (loop > 0) {
            for (var i = 0; i < loop; i++) {
                audio.play();
            }
        } else {
            audio.play();
        }
    },
    mute: function muteAudio(m) {
        if (this.audio) {
            this.audio.muted = m;
        }
        this.isMuted = m;
    }
};

module.exports = HTMLAudio;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);

var i18n = __webpack_require__(25);
var Game = __webpack_require__(2);
var Instead = __webpack_require__(35);
var UI = __webpack_require__(26);
var Preloader = __webpack_require__(151);

var gamepath = './games/';
var gameList = gamepath + 'games_list.json';
var allGames;

var Manager = {
    init: function init() {
        this.container = $('#manager');
        this.el = $('#manager-gamelist');
        this.el.perfectScrollbar({wheelSpeed: 1});
        this.el.append('<div id="loading">' + i18n.t('loading') + '</div>');

        var self = this;
        this.el.on('click', 'a', function selectGame(e) {
            e.preventDefault();
            var gameid = $(this).attr('data-ref');
            self.startGame(gameid);
        });

        var gameListURL = gameList + '?' + Math.random().toString(36).substring(7); // avoid cached response
        $.get(gameListURL, function listGames(data) {
            allGames = typeof data === 'object' ? data : JSON.parse(data);
            var chosenGame = null;
            var gameIds = Object.keys(allGames);
            if (gameIds.length === 1) {
                // If there is only one game, start it immediately
                chosenGame = gameIds[0];
            } else {
                var gameUrl = window.location.hash.replace('#/', '');
                var gid = gameIds.indexOf(gameUrl);
                if (gid !== -1) {
                    chosenGame = gameIds[gid];
                }
            }

            if (chosenGame) {
                self.startGame(chosenGame);
            } else {
                $('#loading').remove();
                gameIds
                    .sort(function gameListSorter(a, b) {
                        if (allGames[a].name > allGames[b].name) {
                            return 1;
                        }
                        if (allGames[a].name < allGames[b].name) {
                            return -1;
                        }
                        return 0;
                    })
                    .forEach(function listGame(id) {
                        self.el.append('<a href="#/' + id + '" data-ref="' + id + '">' + allGames[id].name + '</a>');
                    });
            }
        });
    },
    startGame: function startGame(gameid) {
        window.location.hash = '#/' + gameid;
        Instead.initGame({
            id: gameid,
            path: allGames[gameid].path || gamepath + gameid + '/',
            name: allGames[gameid].name,
            details: allGames[gameid].details,
            ownTheme: allGames[gameid].theme,
            stead: allGames[gameid].stead
        });
        if (Game.preload) {
            this.preload(gameid);
        } else {
            $('#stead-toolbar-info').html('<b>' + Game.name + '</b>');
        }
        this.hide();
        Instead.startGame(Game.autosaveID);
    },
    /* TODO: return to game selection menu
    show: function show() {
        this.el.show();
        UI.hide();
    },
    */
    preload: function preload(gameid) {
        Preloader.load(
            allGames[gameid].preload,
            function preloadProgress(percent) {
                $('#stead-toolbar-info').html(i18n.t('preload') + ': ' + percent + '%');
            },
            function preloadSuccess() {
                $('#stead-toolbar-info').html('<b>' + Game.name + '</b>');
            }
        );
    },
    hide: function hide() {
        this.container.hide();
        UI.show();
        $('#stead-toolbar').show();
    }
};

module.exports = Manager;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var Game = __webpack_require__(2);
var Logger = __webpack_require__(19);
var vfs = __webpack_require__(36);
var i18n = __webpack_require__(25);

var UTFsymbol = {
    mute: '<div style="position:absolute; color: #CC0000; text-shadow: 0px 0px 2px #000000">&#10006;</div>&#128266;',
    sound: '&#128266;'
};

var Menu = {
    element: {},
    init: function init(ui, steadHandler) {
        this.element = ui;
        var self = this;

        // apply menu translations
        $('#instead--menu-back').text(i18n.t('menu_back'));
        $('#instead--menu-save').text(i18n.t('menu_save'));
        $('#instead--menu-load').text(i18n.t('menu_load'));
        $('#instead--menu-reset').text(i18n.t('menu_reset'));
        $('#instead--menu-export').text(i18n.t('menu_export'));
        $('#instead--menu-export-log').text(i18n.t('menu_export_log'));

        function toggleMute() {
            if (Game.mute) {
                steadHandler.mute(false);
                ui.$menu_mute.text(i18n.t('menu_mute'));
                ui.$toolbar_mute.html(UTFsymbol.sound);
            } else {
                steadHandler.mute(true);
                ui.$menu_mute.text(i18n.t('menu_unmute'));
                ui.$toolbar_mute.html(UTFsymbol.mute);
            }
        }
        Game.mute = !Game.mute; // set correct mute state before switching
        toggleMute();

        ui.$menuButton.on('click', this.toggleMenu.bind(this));
        ui.$menu.on('click', 'a', function handler(e) {
            e.preventDefault();
            var action = $(this).attr('data-action');
            var id = $(this).attr('data-id');
            switch (action) {
            case 'reset':
                self.toggleMenu();
                steadHandler.reset();
                break;
            case 'menu-save':
                self.toggleSaveload('save');
                break;
            case 'menu-load':
                self.toggleSaveload('load');
                break;
            case 'menu-export':
                self.toggleSaveload('export');
                break;
            case 'save':
                self.toggleSaveload();
                self.toggleMenu();
                steadHandler.save(id);
                break;
            case 'load':
                self.toggleSaveload();
                self.toggleMenu();
                steadHandler.load(id);
                break;
            case 'export':
                self.exportSave(id);
                break;
            case 'cancel':
                self.toggleSaveload();
                break;
            case 'mute':
                toggleMute();
                break;
            case 'export-log':
                self.exportLog();
                break;
            default:
                self.toggleMenu();
            }
        });

        if (Game.log) {
            ui.$toolbar_log.on('click', function toggleLog(e) {
                e.preventDefault();
                Logger.show();
                $('#instead--log').toggle().scrollTop(function sh() { return this.scrollHeight; });
            });
        } else {
            ui.$toolbar_log.hide();
        }
        ui.$toolbar_mute.on('click', function toggleLog(e) {
            e.preventDefault();
            toggleMute();
        });
        ui.$toolbar_menu.on('click', this.toggleMenu.bind(this));

        function importLoad(e) {
            Game.importSave(e.target.result);
            self.toggleSaveload();
            self.toggleMenu();
            steadHandler.load(Game.importID);
        }

        ui.$menu.on('change', '#load-import',  function fileCtrl() {
            var reader = new FileReader();
            reader.onload = importLoad;
            reader.readAsText(this.files[0]);
        });
    },
    toggleMenu: function toggleMenu() {
        var ui = this.element;
        ui.$gameDetails.html(
            Game.name + ' - ' + Game.details.version + '<br/>'
            + Game.details.author + '<br/>'
            + '<pre>' + Game.details.info.replace(/\\n/g, '\n') + '</pre>'
            + '<hr>'
        );
        ui.$menu_saveload.hide();
        ui.$menu_content.show();
        ui.$menu.toggle();
        if (ui.$menu.is(':visible')) {
            ui.$stead.css('opacity', 0.5);
        } else {
            ui.$stead.css('opacity', 1);
        }
    },
    toggleSaveload: function toggleSaveload(action) {
        var ui = this.element;
        var html = '';
        var slots = [];
        if (action) {
            ui.$menu_content.hide();

            Game.allSaves().forEach(function f(item) {
                var saveId = item.id.match(/save-(\d+)/);
                var timestamp = new Date(item.timestamp);
                slots[saveId[1]] = timestamp.toLocaleString('en-US', {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false
                });
            });
            var i;
            if (action === 'save') {
                html += '<h3>' + i18n.t('menu_savegame') + '</h3>';
                for (i = 1; i <= Game.saveSlots; i++) {
                    html += '<a href="" data-action="save" data-id="' + i + '" class="slot-selector">';
                    if (slots[i]) {
                        html += i + ' - ' + slots[i];
                    } else {
                        html += i + ' - ' + i18n.t('empty');
                    }
                    html += '</a>';
                }
            } else if (action === 'load') {
                html += '<h3>' + i18n.t('menu_loadgame') + '</h3>';
                html += '<a href="" data-action="load" data-id="' + Game.autosaveID +
                        '" class="slot-selector">0 - ' + i18n.t('menu_autosave') + '</a>';
                for (i = 1; i <= Game.saveSlots; i++) {
                    if (slots[i]) {
                        html += '<a href="" data-action="load" data-id="' + i + '" class="slot-selector">';
                        html += i + ' - ' + slots[i];
                        html += '</a>';
                    } else {
                        html += '<div class="slot-selector">' + i + ' - ' + i18n.t('empty') + '</div>';
                    }
                }
                html += '<h3>' + i18n.t('menu_import') + '</h3>';
                html += '<input type="file" id="load-import" style="font-size: 0.8em"/>';
                html += '<br><br>';
            } else {
                html += '<h3>' + i18n.t('menu_export') + '</h3>';
                html += '<a href="" data-action="export" data-id="' + Game.autosaveID +
                        '" class="slot-selector">0 - ' + i18n.t('menu_autosave') + '</a>';
                for (i = 1; i <= Game.saveSlots; i++) {
                    if (slots[i]) {
                        html += '<a href="" data-action="export" data-id="' + i + '" class="slot-selector">';
                        html += i + ' - ' + slots[i];
                        html += '</a>';
                    } else {
                        html += '<div class="slot-selector">' + i + ' - ' + i18n.t('empty') + '</div>';
                    }
                }
            }

            html += '<a href="" data-action="cancel">' + i18n.t('menu_cancel') + '</a>';
            ui.$menu_saveload.html(html);
            ui.$menu_saveload.show();
        } else {
            ui.$menu_saveload.hide();
            ui.$menu_content.show();
        }
    },
    exportSave: function exportSave(id) {
        var savename = Game.getSaveName(id);
        var content = Game.load(id);
        vfs.exportFile(savename + '.lua', content);
    },
    exportLog: function exportLog() {
        var logContentTxt = Game.id + '\n' + Game.name + '\n\n';
        logContentTxt += Game.gJournal.join('\n');
        vfs.exportFile(Game.id + '-log.txt', logContentTxt);
    }
};

module.exports = Menu;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Game = __webpack_require__(2);
var themeCSS = __webpack_require__(66);
var interpreter = __webpack_require__(37);
var vfs = __webpack_require__(36);

var Theme = {
    themeFile: 'theme.ini',
    theme: {},
    themeUrlGetter: {},
    load: function load(elements, themePath) {
        var defaultTheme = null;
        var customTheme = null;
        var includedThemeName = null;
        var includedTheme = null;

        this.elements = elements;
        // reset styles
        themeCSS.resetStyles();

        // load default theme
        defaultTheme = vfs.readfile(themePath + 'default/' + this.themeFile);
        this.parseTheme(defaultTheme, function themeURL(file) {
            return themePath + 'default/' + file;
        });

        if (Game.ownTheme) {
            // try to load custom theme
            customTheme = vfs.readfile(Game.fileURL(this.themeFile));
            if (customTheme) {
                interpreter.call('js_instead_theme_name(".")');
                includedThemeName = this.parseTheme(customTheme, Game.fileURL);
            }

            // load included theme
            if (includedThemeName) {
                includedTheme = vfs.readfile(themePath + includedThemeName + '/' + this.themeFile);
                this.parseTheme(includedTheme, function fileURL(file) {
                    return themePath + includedThemeName + '/' + file;
                });
                this.parseTheme(customTheme, Game.fileURL);
            }
        }
        // apply theme
        themeCSS.immediate(false); // disable auto-updating stylesheet while theme rules are generated
        this.apply();
        themeCSS.immediate(true);
        themeCSS.update();

        this.setCursor();
    },
    parseTheme: function parseTheme(data, urlGetter) {
        var self = this;
        var isInclude;
        data.split('\n').forEach(function parse(line) {
            var name;
            var value;
            var pair = line.split('=');
            if (pair.length === 2) {
                name = pair[0].trim();
                value = (pair[1].split(';'))[0].trim();
                self.theme[name] = value;
                self.themeUrlGetter[name] = urlGetter;
                if (name === 'include') {
                    isInclude = value;
                }
            }
        });
        return isInclude;
    },
    apply: function applyTheme() {
        var elements = this.elements;
        var theme = this.theme;
        var themeUrlGetter = this.themeUrlGetter;

        if (theme['scr.gfx.mode'] === 'embedded') {
            // ignore gfx size for embedded
            delete theme['scr.gfx.x'];
            delete theme['scr.gfx.y'];
            delete theme['scr.gfx.w'];
            delete theme['scr.gfx.h'];
            delete theme['win.gfx.x'];
            delete theme['win.gfx.y'];
            delete theme['win.gfx.w'];
            delete theme['win.gfx.h'];
        }
        if (!theme['win.fnt.name']) {
            theme['win.fnt.name'] = 'Tahoma';
        }
        if (!theme['inv.fnt.name']) {
            theme['inv.fnt.name'] = 'Tahoma';
        }
        Object.keys(theme).forEach(function parseParam(key) {
            themeCSS.applyParamStyle(key, elements, theme[key], themeUrlGetter[key]);
        });
        if ('snd.click' in theme && theme['snd.click']) {
            Game.clickSound = themeUrlGetter['snd.click'](theme['snd.click']);
        }
    },
    setCursor: function setCursor(isAct) {
        var cursor = this.theme['scr.gfx.cursor.normal'];
        if (isAct) {
            cursor = this.theme['scr.gfx.cursor.use'];
        }
        themeCSS.applyParamStyle('CURSOR', this.elements, cursor, this.themeUrlGetter['scr.gfx.cursor.normal']);
    },
    setStyle: function setStyle(name, value) {
        themeCSS.applyParamStyle(name, this.elements, value, Game.fileURL);
    },
    getStyle: function getStyle(name) {
        return this.theme[name];
    }
};

// configure global handlers for 'theme' module
window.insteadThemeGet = Theme.getStyle.bind(Theme);
window.insteadThemeSet = Theme.setStyle.bind(Theme);

module.exports = Theme;

/*

? scr.gfx.use = путь к картинке-индикатору режима использования (строка)
? scr.gfx.pad = размер отступов к скролл-барам и краям меню (число)
X scr.gfx.icon = пусть к файлу-иконке игры (ОС зависимая опция, может работать некорректно в некоторых случаях)
- scr.gfx.mode = режим расположения (строка fixed, embedded или float). Задает режим изображения.
    embedded - картинка является частью содержимого главного окна,
               параметры scr.gfx.x, scr.gfx.y, scr.gfx.w игнорируются.
    float    - картинка расположена по указанным координатам (scr.gfx.x, scr.gfx.y)
               и масштабируется к размеру scr.gfx.w x scr.gfx.h если превышает его.
    fixed    - картинка является частью сцены как в режиме embedded, но не скроллируется
               вместе с текстом а расположена непосредственно над ним.
    Доступны модификации режима float с модификаторами 'left/right/center/middle/bottom/top',
    указывающими как именно размещать картинку в области scr.gfx. Например: float-top-left;
- win.scroll.mode = [0|1|2|3] режим прокрутки области сцены.
    0 - нет автоматической прокрутки,
    1 - прокрутка на изменение в тексте,
    2 прокрутка на изменение, только если изменение не видно,
    3 - всегда в конец;
- menu.fnt.name = путь к файлу-шрифту меню (строка)
- menu.fnt.size = размер шрифта меню (размер)
- menu.fnt.height = междустрочный интервал как число с плавающей запятой (1.0 по умолчанию)
*/


/***/ }),
/* 149 */
/***/ (function(module, exports) {

var keycodes = {
    8: 'backspace',
    9: 'tab',
    13: 'return',
    16: 'shift',
    17: 'ctrl',
    18: 'alt',
    27: 'escape',
    32: 'space',
    33: 'page up',
    34: 'page down',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    45: 'insert',
    46: 'delete',
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    59: ';',
    61: '=',
    65: 'a',
    66: 'b',
    67: 'c',
    68: 'd',
    69: 'e',
    70: 'f',
    71: 'g',
    72: 'h',
    73: 'i',
    74: 'j',
    75: 'k',
    76: 'l',
    77: 'm',
    78: 'n',
    79: 'o',
    80: 'p',
    81: 'q',
    82: 'r',
    83: 's',
    84: 't',
    85: 'u',
    86: 'v',
    87: 'w',
    88: 'x',
    89: 'y',
    90: 'z',
    96: '[0]',
    97: '[1]',
    98: '[2]',
    99: '[3]',
    100: '[4]',
    101: '[5]',
    102: '[6]',
    103: '[7]',
    104: '[8]',
    105: '[9]',
    106: '[*]',
    107: '[+]',
    109: '[-]',
    110: '[.]',
    111: '[/]',
    112: 'f1',
    113: 'f2',
    114: 'f3',
    115: 'f4',
    116: 'f5',
    117: 'f6',
    118: 'f7',
    119: 'f8',
    120: 'f9',
    121: 'f10',
    122: 'f11',
    123: 'f12',
    144: 'numlock',
    145: 'scroll lock',
    173: '-',
    186: ';',
    187: '=',
    188: ',',
    189: '-',
    190: '.',
    191: '/',
    192: '`',
    219: '[',
    220: '\\\\', // backslash
    221: ']',
    222: "'"
};

var Keyboard = {
    handler: function keyboardHandler(e) {
        e.preventDefault();
        return {
            key: keycodes[e.keyCode],
            down: e.type === 'keydown' ? 'true' : 'false',
            text: e.type === 'keydown' && e.keyCode >= 48 && !(e.keyCode >= 112 && e.keyCode <= 145) ? e.key : null
        };
    }
};

module.exports = Keyboard;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Game = __webpack_require__(2);
var Sprite = __webpack_require__(65);

function parseCompositeImage(image, style) {
    var parsedImg = image.split(';');
    var images = parseCompositePart(parsedImg[0], true);
    for (var i = 1; i < parsedImg.length; i++) {
        images += parseCompositePart(parsedImg[i]);
    }

    return '<div class="compositeImage" style="' + style + '">' + images + '</div>';
}

function parseCompositePart(image, isMain) {
    if (!image) {
        return '';
    }
    var pImg = image;
    var imageParts = [];
    var pStyle = isMain ? '' : 'position:absolute;';
    var pMargins;
    if (image.indexOf('@') !== -1 ) {
        imageParts = image.split('@');
        pImg = imageParts[0];
        pMargins = imageParts[1].match(/(\d+),(\d+)/);
        pStyle += 'left:' + pMargins[1] + 'px;top:' + pMargins[2] + 'px;';
    } else {
        pStyle += 'left: 0; top: 0;';
    }
    // Parse pseudo-images (box, blank)
    if (pImg.indexOf('box') === 0 || pImg.indexOf('blank') === 0) {
        return pImg.replace(/(box|blank):(.+)/, function imgReplacer() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(pStyle);
            return parseEmptyImage.apply(null, args);
        });
    }
    return '<img style="' + pStyle + '" src="' + Game.fileURL(pImg) + '"/>';
}

function parseEmptyImage(style, fullReplaceString, box, params) {
    var d = params.split(',');
    var imgSize = d[0].match(/(\d+)x(\d+)/);
    var eStyle = style + 'width:' + imgSize[1] + 'px;' +
        'height:' + imgSize[2] + 'px;';
    if (d[1]) {
        eStyle += 'background-color:' + d[1] + ';';
    }
    if (d[2]) {
        eStyle += 'opacity:' + (d[2] / 256) + ';';
    }
    eStyle += 'display:inline-block;';
    return '<div style="' + eStyle + '"></div>';
}


function parseImg(fullString, img, style) {
    var image = img;
    var parsedImg = '';
    var imgStyle = style ? style : 'max-width: 100%;';

    if (Sprite.is(img)) {
        return Sprite.asImage(img);
    }

    // parse padded images
    if (image.indexOf('pad') === 0) {
        parsedImg = image.match(/pad:(.+?),(.+)/);
        imgStyle += 'margin:' + parsedImg[1].replace(/(\d+)/g, '$1px') + ';';
        image = parsedImg[2];
    }

    // parse aligned images
    if (image.indexOf('\|') !== -1) {
        parsedImg = image.match(/(.+)\\\|(.+)/);
        image = parsedImg[1];
        imgStyle += 'float:' + parsedImg[2] + ';';
    }

    // composite image
    if (image.indexOf(';') !== -1) {
        return parseCompositeImage(image, imgStyle);
    }

    // Parse pseudo-images (box, blank)
    if (img.indexOf('box') === 0 || img.indexOf('blank') === 0) {
        return img.replace(/(box|blank):(.+)/, function imgReplacer() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(imgStyle);
            return parseEmptyImage.apply(null, args);
        });
    }

    return '<img ' + (imgStyle ? 'style="' + imgStyle + '" ' : '') + 'src="' + Game.fileURL(image) + '">';
}

module.exports = parseImg;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var Game = __webpack_require__(2);

var Preloader = {
    progress: 0,
    load: function load(imgArray, callbackProgress, callbackFinished) {
        var self = this;
        imgArray.forEach(function preloadImg(image) {
            $('<img>').attr('src', Game.fileURL(image)).on('load', function complete() {
                self.progress += 1;
            });
        });
        this.calcPercent = setInterval(function updatePercent() {
            callbackProgress(Math.floor(self.progress / imgArray.length * 100));
            if (self.progress === imgArray.length) {
                clearInterval(self.calcPercent);
                callbackFinished();
            }
        }, 10);
    },
    stop: function stop() {
        this.calcPercent = null;
    }
};

module.exports = Preloader;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/* global Uint8Array, TextDecoder */
var $ = __webpack_require__(4);

var JSZip = __webpack_require__(91);
var JSZipUtils = __webpack_require__(153);

var Game = __webpack_require__(2);
var Instead = __webpack_require__(35);
var UI = __webpack_require__(26);
var i18n = __webpack_require__(25);

var decoder = new TextDecoder('utf-8');

var gamepath = './games/';

function matchRe(regexp, string) {
    var isMatching = string.match(regexp);
    if (isMatching) {
        return isMatching[1].trim();
    }
    return '';
}

var ZipLoader = {
    init: function init() {
        this.el = $('#manager');

        $('#ziploader').html(
            '<input type="file" id="zip-game" style="font-size: 0.8em"/>' +
            '<label for="zip-game">&#128194; ' + i18n.t('zip') + '</label>'
        );

        this.el.on('change', '#zip-game',  function fileCtrl() {
            var reader = new FileReader();
            reader.onload = importGame;
            reader.readAsArrayBuffer(this.files[0]);
        });

        var gameHash = window.location.hash;
        if (gameHash.match(/#zip:/)) {
            var gameUrl = window.location.hash.replace('#zip:', '');
            JSZipUtils.getBinaryContent(gameUrl, function zipHandler(err, data) {
                if (err) {
                    $('#manager-gamelist').html('<div id="loading">' + JSON.stringify(err) + '</div>');
                    return;
                }
                importGame({target: {result: data}});
            });
        }
    },
    startGame: function startGame(gameid, gameinfo) {
        Instead.initGame(gameinfo);
        this.hide();
        $('#stead-toolbar-info').html('<b>' + Game.name + '</b>');
        Instead.startGame(Game.autosaveID);
    },
    hide: function hide() {
        this.el.hide();
        UI.show();
        $('#stead-toolbar').show();
    }
};

function importGame(e) {
    var fileBuffer = [];
    var gameinfo = {};

    var filehandler = function zipFileHandler(zipEntry) {
        return zipEntry.async('arraybuffer')
        .then(function success(zcontent) {
            var pathParts = zipEntry.name.split('/');
            var filename = pathParts[pathParts.length - 1];
            var gameid = pathParts[0];
            gameinfo.id = gameid + '.zip';
            gameinfo.path = gamepath + gameid + '/';
            if (filename === 'theme.ini') {
                gameinfo.ownTheme = true;
            }
            if (filename === 'main.lua') {
                gameinfo.stead = 2;
            }
            if (filename === 'main3.lua') {
                gameinfo.stead = 3;
            }
            if ((filename === 'main.lua' || filename === 'main3.lua') && pathParts.length <= 2) {
                var gf = decoder.decode(new Uint8Array(zcontent));
                gameinfo.name = matchRe(/\$Name\(ru\)\s*:\s*([^\$\n]+)/, gf);
                if (gameinfo.name === '') {
                    gameinfo.name = matchRe(/\$Name\s*:\s*([^\$\n]+)/, gf);
                    if (gameinfo.name === '') {
                        gameinfo.name = gameid;
                    }
                }
                gameinfo.details = {};
                gameinfo.details.author = matchRe(/\$Author\s*:\s*([^\$\n]+)/, gf);
                gameinfo.details.version = matchRe(/\$Version\s*:\s*([^\$\n]+)/, gf);
                gameinfo.details.info = matchRe(/\$Info\s*:\s*([^\$\n]+)/, gf);
            }

            var fullpath = gamepath + zipEntry.name;
            var fileContent = new Blob([zcontent]);
            var dataUrl = URL.createObjectURL(fileContent);
            Game.addFile(fullpath, dataUrl);
        });
    };

    $('#manager-gamelist').html('<div id="loading">' + i18n.t('loading') + '</div>');

    JSZip.loadAsync(e.target.result).then(function handleZip(zip) {
        zip.forEach(function handleZipEntry(relativePath, entry) {
            fileBuffer.push(filehandler(entry));
        });
        $.when.apply($, fileBuffer).then(function startgame() {
            if (gameinfo.name) {
                ZipLoader.startGame('provodnik', gameinfo);
            } else {
                $('#manager-gamelist').html('<div id="loading">' + i18n.t('zip_incorrect') + '</div>');
                Game.reset();
            }
        });
    });
}

module.exports = ZipLoader;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!

JSZipUtils - A collection of cross-browser utilities to go along with JSZip.
<http://stuk.github.io/jszip-utils>

(c) 2014 Stuart Knightley, David Duponchel
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip-utils/master/LICENSE.markdown.

*/
!function(e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):"undefined"!=typeof window?window.JSZipUtils=e():"undefined"!=typeof global?global.JSZipUtils=e():"undefined"!=typeof self&&(self.JSZipUtils=e())}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return require(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var JSZipUtils = {};
// just use the responseText with xhr1, response with xhr2.
// The transformation doesn't throw away high-order byte (with responseText)
// because JSZip handles that case. If not used with JSZip, you may need to
// do it, see https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
JSZipUtils._getBinaryFromXHR = function (xhr) {
    // for xhr.responseText, the 0xFF mask is applied by JSZip
    return xhr.response || xhr.responseText;
};

// taken from jQuery
function createStandardXHR() {
    try {
        return new window.XMLHttpRequest();
    } catch( e ) {}
}

function createActiveXHR() {
    try {
        return new window.ActiveXObject("Microsoft.XMLHTTP");
    } catch( e ) {}
}

// Create the request object
var createXHR = window.ActiveXObject ?
    /* Microsoft failed to properly
     * implement the XMLHttpRequest in IE7 (can't request local files),
     * so we use the ActiveXObject when it is available
     * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
     * we need a fallback.
     */
    function() {
    return createStandardXHR() || createActiveXHR();
} :
    // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;



JSZipUtils.getBinaryContent = function(path, callback) {
    /*
     * Here is the tricky part : getting the data.
     * In firefox/chrome/opera/... setting the mimeType to 'text/plain; charset=x-user-defined'
     * is enough, the result is in the standard xhr.responseText.
     * cf https://developer.mozilla.org/En/XMLHttpRequest/Using_XMLHttpRequest#Receiving_binary_data_in_older_browsers
     * In IE <= 9, we must use (the IE only) attribute responseBody
     * (for binary data, its content is different from responseText).
     * In IE 10, the 'charset=x-user-defined' trick doesn't work, only the
     * responseType will work :
     * http://msdn.microsoft.com/en-us/library/ie/hh673569%28v=vs.85%29.aspx#Binary_Object_upload_and_download
     *
     * I'd like to use jQuery to avoid this XHR madness, but it doesn't support
     * the responseType attribute : http://bugs.jquery.com/ticket/11461
     */
    try {

        var xhr = createXHR();

        xhr.open('GET', path, true);

        // recent browsers
        if ("responseType" in xhr) {
            xhr.responseType = "arraybuffer";
        }

        // older browser
        if(xhr.overrideMimeType) {
            xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }

        xhr.onreadystatechange = function(evt) {
            var file, err;
            // use `xhr` and not `this`... thanks IE
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 0) {
                    file = null;
                    err = null;
                    try {
                        file = JSZipUtils._getBinaryFromXHR(xhr);
                    } catch(e) {
                        err = new Error(e);
                    }
                    callback(err, file);
                } else {
                    callback(new Error("Ajax error for " + path + " : " + this.status + " " + this.statusText), null);
                }
            }
        };

        xhr.send();

    } catch (e) {
        callback(new Error(e), null);
    }
};

// export
module.exports = JSZipUtils;

// enforcing Stuk's coding style
// vim: set shiftwidth=4 softtabstop=4:

},{}]},{},[1])
(1)
});
;

/***/ }),
/* 154 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(67);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// instead.3129b46e1fdb587c2994.js